import { useState, useRef, useMemo, useEffect, useCallback, Fragment } from "react";
import { cloudGet, cloudSet, cloudGetAll, isSupabaseConfigured, uploadFile, readAsDataURL } from "./supabase";

// ─── MOBILE DETECTION HOOK ────────────────────────────────────────
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth < 768
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
}

// ─── THEME ────────────────────────────────────────────────────────
const T = {
  bg: "#0D0D0D",
  surface: "#141414",
  card: "#1A1A1A",
  border: "#252525",
  accent: "#E8C547",
  accentSoft: "rgba(232,197,71,0.10)",
  text: "#EDEBE4",
  textMuted: "#7A7670",
  textDim: "#4A4844",
  success: "#3DB86A",
  warning: "#D4900A",
  danger: "#D94F4F",
  info: "#4880D4",
  restaurant: "#D4724A",
  delivery: "#4A98D4",
  catering: "#9A4AD4",
};

const LOGO_SRC = "data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/2wBDAQUFBQcGBw4ICA4eFBEUHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCAWsB9ADASIAAhEBAxEB/8QAHAABAAEFAQEAAAAAAAAAAAAAAAYCAwQFBwEI/8QATxAAAgEDAgQDBAgEAwUHAwALAAECAwQRBSEGEjFBB1FhEyJxgRQyQpGhscHRFSNSYjNy4RYkQ4KSNFNjorLw8SVEczU2g8IXVCZkdJPi/8QAGwEBAAIDAQEAAAAAAAAAAAAAAAQFAwYHAgH/xABAEQEAAQMBBQQJAwMCBwEAAgMAAQIDBBEFBhIhMRNBUWEiMnGBkaGxwdEU4fAjM0JS8RUkNENTYnIWJTVEkrL/2gAMAwEAAhEDEQA/APssAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGNdX9larNzdUaX+aaRp73jHRrfKhVnXa/oj+pGvZlix/criPe902q6/VhIQQa749f/2un7edSf7GrueLdbruXJcU6MX0UKayvmyqvbyYNvpVNXsj86JNODdq68nTW0lltIx7i9s7dZr3NKmvWSOT3Wpahcv+feXE/T2jwWHKc8c2X8WVlze2n/t2/jLNTs6f8qnUq3EOj0lmV7CX+XLMGrxjpUHiEbio/Snj8znyf/yVpZeNkV9zevLq9WmI/ntZIwLcdZTatxnQ39jZVH/mkkYi4yvZN/7nQgu3vN/sRZevYuRWNu5Cr3h2hX/np7Ihk/SWo7m/nxVq05ZjK3px8lTz+pb/ANotWln/AHrGf7F+xpl06lyOPmRatr51XW7Pxfewtx3Nk9a1WTeb6qvhj9gtW1NZ/wB9rfORgrong9hvs92YZz8qetyr4y+9lR4M+Oraln/ttbL/ALir+J6gt/ptb/qMFNZeCtdFtueZzMiZ/uT8ZfJop8GatS1B/wD3lb/qK1qOoN73db/qZhb5K167D9Zk/wDkn4y88FPgzFqGodFeVl/zF2GqajFf9sm/il+xgrqVI9RtDLp6XKvjLzNunwbKGsailj26fq4Iv0tcvo7TVKb/AMuDUrffJUviZqds51HS7P1+rzNm34NzHXrnnWbelKPf3mmZMddp/atqmP7ZJmhiVxZJt7x7Qo616+2IeJx7c9yQ0tas5vdVYf5oGRT1CzmsqvFfHYjKK0s9dydb3syqfXppn4wxzjUpVCrTmswqRkvRlZFFjGC7SqVqcUqderDD7Tz+ZYWt77c/3Lcx7J1/DHONPdKTA0dLULyM8upGccdJR/VGTT1SW/taHzjLqWljePAu9auH2wxTZrhswYtPULaTw5Sg/wC5YMinUhUWYTjJejLazk2b0a26on2SxzTMdVQAM74AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABbuK9C3pupXrU6UF1lOSSPkzERrIuAiurcd6JZqUbepK8qLb+Wvdz8f2InqfH+r3OY2kKdpD0WZfeyoytu4WPymvWfCOf7JVvCvXOkaOp1atOjBzq1Iwit25PCRoNS4z0KzUlC5+kzX2aSz+PQ5Rd315e1PaXV1VrSe2Zyf5Fp9cp+hr+TvXcq5WaNPbzTrezaY9eU8v/EGtLmjY2UY+Uqjy/uNBf8AEutX7ftbycItYcafur8DSJLZ/f6lxZzlbvPkUd/a+ZkevcnTy5fRLoxrVHSlW5ylLM5SlLu5PLKlu8LGShYy8ZxjfJWsrb3kmVszMzrLLorj9Xoslcd0u/rkpgkmn925Ws9tseR8fFWM7PJWlhpdu7LaTfTr5F6lSq1XijTqTf8AbBtn2ImZ0h5mXi9XncuYy1h9OpsLXRNVr49nYV+XzlHl/Mz7fhPWJT96FKlHzlUT/Il29nZd31bcz7mGq/bjrLSQeF0yytNbkmpcGXOf5l3SXwi2ZdPg2imnO8m33xEmW93toVf4ae2Y/LFVlWvFEINp5f3lffOxNaXCVhD69avP4tF+PDGlLrCq/jMlU7rZtXXSPf8Asxzm20Hi87N7YPd8k+hoGlR/+1T+LZcWjaYnn6HT+ZmjdLJ766fn+Hic2jwQCPy6lyJPHpGmNYdlRa/ylS0vT1/9nR/6T1G6N/8A8kfN5nNp8EERWicfwrTc5+hUf+k8WlacnlWdL7h/+RyP/JHzfP1lPghcfXqVomL0rT//AOVgW5aJp0nn2Ml8Js8VbpZXdXT8/wAH6ujwRSPwwVokstCsX09ov+Ytz0C3bzCvVj6bMwVbrZ1MctJ977+qoaFFyJuJ6Cse5cPPrEtfwW6X/EpS+9EWvYG0KP8At6+yY/L729ue9rljuVx+bMmWmX0c/wAjOOjjJPJZdC4gszt6sP8AlIN3AyrXOu3Me6XqK6Z6S8RWi2mm+q26+hcjuQ55cpfVaK4+pQuhXE+S8yqKHGLeUsS81s/wK/keM9RVNM60y+K6V1c0to1nJf37mVDVZL/Eop+sX+5gPqUy33LXG23m48ejcmY8+f1eJtU1dYbqjqNpUly+1UJeU9jLTTWU8kXkk01Lp5YPYVatGTdKrKDz2e33F9i73T0yLfvj8T+WOrG8JScGjo6tcQwqsI1F3a2ZsKGp2lXCdRU5PtPY2LF21hZXKivSfCeUsFVqunrDMATTWU8gtWMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABbuK9G3pupXqwpwXWUnhEQ17xC0qy9pSsIyva8e692Gfj+xGycyxjU8V2qIZLdmu5OlMapm2kst4Rotb4s0PSYyVe8jUqr/hUvek/2OUa5xhrerzlCpcyo0Zf8Ol7sfv6mjUm9+rzu2axmb0xHo49Pvn8LS1sqetyfgn2s+ImoXDcdNoRtodMz96b/RES1DUb/UJupeXNWs3/AFSz+BgJvr1ztnzLkMNp4eFskjWMnaOTlc7tczHy+Cwt49u16sPYNbJp79Nytdn3/MpSx9/3FyL8tmtlkhasqtPnzt07LuVx2UeucFEHLbEXn0NnpuiarqEk7WyqTi+kmsL72e7dq5cnSinWfJ4qqinrLBjssJorXVpN/AmWm+H97VSnf3VKhlbxgud/oiS6bwbo1piU6Uria71Ht9xcY+7mbe5zTwx5/hDuZ1mnpOrl1GlVrOMKdOc5P7MVnJt7ThvXbuKdPT6kYvo6jUcfedVtrO0tklQtqVPHTlikXy7sbp2453q5n2cvyh17RmfVhAbLgS6lJSu7ylTXlTTk/wATcW3BelU0vayrVn3zLH5EmBb2dhYNnpb19vNGqy7tXe1tvoWk0MezsaOV0cllmfTpU6f+HThH4LBWCyt2bdvlRTEeyGCaqqusgAMryAAACmpOFOLlOcYpd28GBc63p1BPNfna7QWTDeybNiNblUR7ZeqaKqukNiCP1+JoJ4oWspes5YMKrxFfTknTVKnHuuXP4sqLu8ez7fKK9fZEs9OJdnuS0EKraxqE5Z+lzil2iks/gUPUr1pZuq3/AFEKve3EjpTVPw/LJGDX4pwCCSvLmXW5rfHnaELu4i8q5rZ/zsxf/r7H/jn5PX6CrxTsEHhf3cc4uq3/AFMrWpXu+Lur/wBR6je/G76Kvk+foa/FNQQ2nq2oQf8A2ucvRpfsX4a9fxby6cvjEz0b14NXWKo937vM4VxKwRuHEdZNc9rCS78s8MzKXENnKSjUp1qbffGUvuJ9nb2z7vS5Ee3WPqxVYt2nubgGJR1Gyq/UuIZ8m8GUmpLKaa9Czt3rd2NaKon2MM0zHWFNSjRqJqdKEs+cTHqadZzx/K5cdOV4MsHi7jWbvr0RPtgiqY6S109Khn3K016NZLM9PuoLMXTqfB4f4m3BV3t3sC7/AIaeydP2ZIvVx3tFOnVpt+0pzh6tFpyT6NMkRaqW1vU3nRg354KbI3Qif7Nz4/t+GSMjxhoXuyl7ZNtV0yk8ulOUHnO+6MOtp11BvlUKkfNPD+4osnd7Psc+Hijy5/LqzU3qJYUuu/QplnJXVjKDanFxfqih+nQpq6KqJ4ao0ZonVS9ih9OhW9iiXofH2F2hc16ElKnUlHzWcr7jPttalFYuafMv6ofsap4wUyLPE2vl4unZ18vCecPFVqmrrCV215bXKzSqxb7ro18i+QvON1s+zTwZlpq13b4U5e1h5S6/ebThb2Wq9Kcinh845x+fqj14s/4pQDX2mr2ddqLk6U32n+5sE01lbm02Mm1kU8VqqJjyRqqZp5SAAzPIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALV3c29pQlXuq1OjSj1lOWEiDcS+IdGhmjo1JV5d6017q+C7kTLz7GJTxXatPqy2rFd2dKYTi9u7ayoOtdV4Uaa6yk8EG4j8R7WhCVLRqX0ip/3k1iK+Xc5zrGqX+q3Xtr26q1JPs37q+CMH3k3s+vc0/O3nu3NaceOGPHv/ZcWdmUU6Tc5yzda1vVNWre0v7ydXL2in7q+Rr3s/dw8vbcrjtFT6eTRbfKpOLWX6dzWrl2q5VxVzrKzppinlTCtf0NrJXHK3ffuijyws/AybS2r3VaNva0alWb6RhFtnmImqdIJnSOaldUuyWV6lTzJ4jJLo8Ex0Xw81S6anfzhZ0n2b5p/cTbROC9D0ySqewdzWX262+PguhdYm72Zf51Rwx5/hAu59m30nWXLtI0HVdUmnbWVSUM7TaxHHxJdpHhzV5lPUryMI/0Ull/ezo0IxhFRhFRiuiSwj02XF3ZxbXO5rVPwj4K65tG7V6vJqNK4a0bTYJULOEprfnqe9I20UorEUkvJHoL61Zt2aeG3TER5INVdVU61TqAAyvIAAAAAAAADGv7+0safPc14Q22jnd/BES1jiivcc1GxTow/r+0/wBitz9q42DH9Srn4R1Z7WPXd6QlOo6pZWO1equftBbtkevuKLipJwtKcaMf6pbyf6IjMpubblJyb6ts85vLHxNJzd58q/Mxa9Cny6/H8LK1hW6evOWdXuq1eXPWrTqy6ZlLJaU/Ux+dbYew5+35mvV11XJ4q51nzSopiOjJ5/mOfph/EsKbx1Q50urSPGj7oyef0PVJlFO3uKycqVtWmvSLMujo+qVFmNnUS/u2/MkW8S/c9SiZ90vE10x1ljqfbuFPKbM+HD+qvrQjH4zRdjw1qTW7pL/mJNOyM6rpan4PHb2o/wAoavnKnP7za/7M6hjadH/qPJcN6l2dF/8AMep2Ln6f2pfP1Fr/AFNYpnql3bM2WgapHpRjL4TRYqaXqdPPNZ1fksmCvZuXR61qr4S9Rdtz0qhZ5t+p7z4ZarU69F4q0p0/80WihTffbBDqt1UzpMaMkc2TnPcu0bqvRlmjWqQeNuWRhc/fO4U/Jnuiuu3PFRMxPk+TTE8pb+14hu6csVoQrR+5o3NlrVlcpJz9lN/ZmQhT2Y58F3ibyZ2Pyqnijz/KNXh26+nJ0iMlKKlFpp9Gj0gNlqV3aSXsa0orO8Xun8jf6fxJQqYjeR9i/wCpbx/0Nswd5cTJ9Gv0KvPp8UG7h10c45w34KaVSFWCnTnGcX0aeUVGwxMTGsIgAD6PJRjJYlFNeqMOvpltUy4p02+8X+hmgwX8WzkRw3aYn2vsVTHRo7jSq8N6clVX3M11WFSm2pwlB56NYJaeThCceWcVJeTRruXupjXOdmZpn4x+fmkUZNUdeaIPpgpfmb+60ehUy6MpUn5J5RrLrTbui2/Z88fOG/4GrZewc3F1maeKPGOf7pFF6ipgy36FD8sbFctsppp+pQ+nmU/tZ1DRlWWoXVo17OfNBfYl0MV9Cl/+0Z7GRdx6+O1VMT5E0xVGkpPY65bVvdr/AMifq9vvNpGUZRUotST6NEDe+EZFlf3VnL+RU91veEt4v9ja8DeqqNKMmNfOPvCLXixPOlNQanT9ct7h8lfFCp6vZ/M2yaaynlG4Y2XZyqOO1VrCHVRVTOkgAJDyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGk4i4m0zRabVap7Wvj3aNPeT+PkYr163Zomu5OkPVFFVc6UxrLdSlGMXKTSS6tvoQ/iXjuxsHO3sF9LrrKcl9SL+PchXEfFmp6xKUHN29v0VKD6/F9yO5xlveT7eRp+0d55q1oxY085+0flb4+zYjnd+DP1rWtR1eu617cSnFP3YdIr4I1b2yujfUrfMvXyKZSeYprLx1NTuXK7tc11zrK1ppimNKY5LeVjlktl3RRUeHnGV126lcP82/qbDRtD1TV6/JYW0qqe0qnSMfiz7btV3a+GiNZfaqopjWZ0atvCy1lY6GXo+j6lq9d0dPtaleXdraMfi2dO4d8ObG0jGpqtVXlXCzCKxBfqya2lrbWdFUbWhTo049IwjhGz4W7F2v0sieGPCOv4hW3tp008rcay5/w/4a04Yq6xc87f/CpPC+bJ1pWlafpdFUbC0pUIrvFbv4vqzMPJNRTcmkl1bNsxNnY2JH9KnSfHv+Kpu5N2960vQRrX+N9B0hShK5+lXC29lR3efV9EYGnz4s4lxXuJfwHTs5jCmuavVXxf1V8idpPVljBuxb7SuOGnxnlr7I6ymgLNla0rO3jQo83LH+qWW/mXj4hyAFuvXo0IOdarCnFd5PB8mYiNZNNVwEb1HjPSLZuNB1LqX/hrC+9mju+Ob2f/AGe2pUV5yfMypyNu4NjlNes+XNJoxL1fc6AeOSXVpfM5XW4l1i4k072pHPaCSwYFS9u6mXVuass+dRlVd3tsR/btzPwj8pNOza56y67UvbOntO7oR+NRIxLjXtHoNqpf0crtF835HKOfv38z1vLxnlf4EG5vddn1LcR7Zmfwyxs2nvqdFuOMNNhlUYVqr7PlwvxNHf8AF1/cZjQjG3i/JZl95FufbrjzCm+iTKvJ3gzr8acXDHly/dIt4VqnnpqzKtxUqycq1SVSWW25PLPFPKST6GNGT3W+Qpb5z8ikmZqnWeqTpEMh1E91ncrTT2S37Gx0Dh2+1JqpJOhb/wBclu/gibaVoOnafGPJRVSovtz3Zd7P3fysyOOfRp8Z+0Il/Lt2uUc5QvTdF1O9SlTt3GD+3PZG8s+EMYldXWfNQX6ksBtmLuxhWY9OJqnz/EK65nXKunJp7bhvSqKfNRdXP9cjOoadYUI4pWdCK9IIygXNrCx7P9uiI90I1VyurrIkksJJIAEl4AAAAAAAAeSjGSxKKkvJrJhXOkadcPmqWlNS84rlf4GcDHcs27saV0xPth6pqmnpKPXXC1tNf7vXnSfruae84e1O3WYU414/2PdfJk5BTZO7mDf6U8M+X46JFGZdp79XMJ81OXLUi4NPo1g85/U6Td2drdxcbihCpnu1v95HdR4Ti+apY13F4+pPp95rGbutk2fSszxx8JTbedRVyq5Iyp47nqm3I8u7W6sqrp3FGdOS6ZWz+DLCqLOcms3KKrdXDXGkpsTExrDZ6dqVzY1ea3qPl7wfRkr0fX7W+kqNT+TXa6PpL4MgUZeuD1TaeVj9S32dtrJwZ0idafCft4I97Gou+11QEL0LiWrbyVK+k6lF7KXeH7kxoVqVelGpRqRnCSynFnQtn7TsZ9HFbnn3x3wqb1iu1OlSsAFiwgAAAADGu7G2uU/aU0pP7S2ZprzRLiDcreUakcdHtIkQKvN2PiZn9ynn4xyn+e1kou1UdJQerTnSm4VIOMl2ZRLzJrc21C5jy1qcZ+r6o0l/oM4pztJ8y/ol1+TNQzt2MixrVZ9OPn+6ZbyaauvJom9ng8e3QuVqVSjNwqwlCS7NFvdI1maaqatKo0SYnXook9sPcy7DVL2yklTqc9Nf8Obyvl5GK218Ch9DNj5N3Hriu1VMSTTFUaSmemava3qUeZU6v9En1+HmbE5y9njLWOjNvpevXFs1TuM1qXTLe6/c3PZu9FNelGVGk+MdPeh3cSY50JeDHsb22vaSqW9RSWMtdGvijINuorprpiqmdYlDmJidJAAenwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALV3c0LShKvc1Y0qcVlyk8Gl4k4psNHi6akq9z2pRfT4+RzPX9a1DWKynd1dk9qcViMSi2nt2xhehT6Vfh4e1Nx8Ku9znlCS8Vcc1anNbaSnTpvaVZ/Wfw8iCV5zqVHKtOU5Pdye7Emkm3vleZTtjCy/wBTQszPv5lfFdq1+kLyzYos06UwozhN8vXrv1POVpb5fmepuOcpr5ldrb17usqFvSnWqSeFGCy2yLTE1TpEc2WZ05rH1o7bP4mXpOmahqlwqNhazrPo3jZL1fYm3DXh3Kbjca3UcY7P6PTe/wA3+x0Kxs7WxoRoWlCFGnHpGKwbNs/dq7e9PInhp8O/9ldkbRoo5Uc5+SFcN+HdpbKNfWKn0qrhfyo7Qj+5OLahRtqSpW9KFKnHpGKwi4Wrq4oWtGVa5rU6NOPWU5JJG54uDYxKeG1Tp9fiqLl65eq9KdV0t3Fejb0pVa9WFKnHrKTwkQTiXxKsbTNDR6SvK2eX2ksqCf6nN9Z13VdaqyqaleSqJSbjCO0Y/BIn02pnqu8DdvKyfSuehT59fh+XTeIfErSbHNLTqcr+tnHMny018+/yOf6xxPxBxBWVGdxU5aksRoW6aTfl5sj1tbzua9O3t4ylOo+WEUsuT8jtPh5wbR0Ogr69jGpqM116qkvJevmzJMUW/av8ixs/Ydrj4eKuemvX9oYvAXAVDTYU9Q1eEa16940nvGl+8vyJ4A9llmCqqZnWWkZeZdy7k3Ls6z9PYGHqmp2Wm0HVvK8aa7Jvd/BEZ4s42oWKna6Y4Vrjo6j3hD92c7vb65vq8q1zXlUqy3cpM1rae8VrGmbdn0qvlH5Z8fAruelXyhMda47uK/NS0yl7GD2VSe8n8PIi13fXN1VdS6r1Ksn3cs/ga/n7blSlmOW/T4mk5e0MnLnW7VMx4d3wW9vHt2o9GGQqmG09z2M13MdTxhJLK7nsHKpLlgnJvyRC0mWTRkc67NdPM9511Xlgy7HQtYvo89CwrYfeUeX8zdWnAmr1UnXq0KKfZvmx9xOs7My70ehbn4MNd+1R1qRtTfYRm+uM/PqTi08P6cZ81zqM5ryhDBsKPAui05KUncz9HU2/Isbe7OdX1iI9s/hgqz7Md+rm/N0bW5VGTSaex1SlwroNNYVhGXrKTf6mZb6PpdD/AArChH/kTJdG6WRPrXIj4z+GGdpUd0S5hYaVqd7UUbe0qST+21hL1Jpw/wAI29o43F/JV6635PsR/clEYqKxFJJdkel7gbuYuLVx1+lV59PgiXs65cjSOUEUopJJJLokADYEIAAAAAAAAAAAAAAAAAAAAAAABbuKFG4punXpxqRfaSInrfCk4uVfTJZ7ulJ7/JkwBBzdm4+bTw3aff3wy2r9dqdaZckqxqUasoVYOFRdYyWGjxTTWejOmaxo9lqdNqvTSqJe7Uj9Zfuc/wBc0e80mr/OXNRbxGolszn+1Ng3sH049Kjx8PauLGVRd5dJYak8Yz36mTaX9zayzbV6lL/K/wBDXc+F2+89U3tlopqK6rdXFTOkpU0xVHNIqPFOq06cV7WFR+c4ZybC24yqJR+kWUZb7uE8bfBkO59+h6qnmWVrbmfa6XJn28/qwVYlqr/F0a04n0uvtKpOi/8AxF+xtre5t7iPNQrU6i/tlk5GqjWE11LtC6q0JKdGrKnL+14LnH3tvU8r1ET7OSNXs6mfVl1wHP8ATeLNQtni55bqn5PaS+ZKNL4k02+ah7X2NR/ZqbZfozZcPbeHl8qatJ8J5IN3Fu2+scm4ATTWV0BbowAALVzbULmHJWpxmvVGg1DQJ0052cnUX9EuvyJICvzdl42bGl2nn4x1ZKLtVHRAK1OpTk6dSLjJPdNFp9CeXtlb3lPkr00/KS2a+ZGtU0S4ts1KCdan12XvL5GkbR3dyMXWu16VPzj3fhOt5NNfKeUtNJopaediqaabTWH5MpeOpr0xzSntGvVt60atGcoTXdPqSfSuI6NVqje4pTfSf2X8fIim5Q+u6LLZ+1cjBq1tzy8J6MdyzTc6umxalFSi00+jR6QPSdautPagv5tHO8H2+DJjpuoWt/S57eom+8X1R0DZu2LGdGlPKrwn7eKtu2KrfsZYALZhAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA1rVrPSbX213USb2hBfWk/JI8XLlNuma650iH2mmap0hmV61KhSlVrVI06cVlyk8JEA4o42nVU7TScwi/ddfu/h5fE0fE3EN7rNRqcnSt4vMKSe3xfmaSWcbY33NH2rvHVd1t43Knx759nguMbAin0rnOfB5VlKU255m3u23ltlEm5Nd15dyqb2wnt+pbzltb+i9DVOc81pEPG92uV7dymSyk9s9sGZpthealcxtrOhKtUfl9n1bOkcM8E2dhyXOoYurlbpP6kfl3LPZ2ycjOn0I0p8Z6fuj38qizHPr4IfwzwdqOrKNesvotrL7UlvL4I6VoOg6botD2dlQSm/rVJbzl8/wBDaJJJJLCQN+2fsfHwo1pjWrxn+clJfy7l7ryjwDycowi5TkoxSy23hIj3FXGGk6DCVOpVVe67Uaby18fI5PxPxbrGuycatZ0LVp/yKbwn8fMuKaJqWGzthZObpVpw0+M/bxdE4o8Q9N07mt9NSvblbc0X7ifx7/I5fruv6rrdw6moXU5QzmNNPEI/I1WWpczW/RY6ks4U4E1XWYqvcU5WdpLpUqLEpfCP6szRTTRGstysYOBsijtK55+M9fd+yJNvKi2nnZrzfoTHhzw+1jVOWvdr6DQlvma96S81Ht8zpfDfCGi6GlO3tlVuF/x6qTkvh5EgPFV7XopM/eqqr0MWNPOftCP8McIaNoD9rbUXVumsSr1XmXy7L5EgBTUnCnTlUqSUIRWXJvCSMMz3y1O9euX6+O5VMz5vZSjGLlJpRSy2+xzHjnjSV1OenaVNxt1LlqVU/r+i9DH4941lqMp6dpcpwtFtUqLZ1fh6EIlL+l+71+BpO3Nu8euPjzy75+0LXCweH07ke5kxqxa5mkHNb5fqtzGU044xlehsNE0y/wBYvPo1hQlUeN5dIxXq+xqdFuq5VFNEazK0qmKY1nksSnJRXM92/vNxo3D+r6uoys7aSpt71KjxFfuT3hrgXT9PUa1/i7uFvhr3Iv0Xcl8IxhFRhFRitkksJG14G69VWlWTOnlH5Vd/aURytxr5oNo/h7a04xnqlxKvJbunTfLH7+pLNO0fTNPio2dlRpY7qOZfe9zOBtOLs3FxY/pURHn3/FV3Mi5c9aQAE5hAAABq+KtU/g+iV75R5pxXLBf3PoRPw+4q1PVNYlY30lWjODnGSjjlwQL20bNnIox6vWqZ6Meuu3NyOkOgAAnsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFFejSr0pUq1OM4SWHGSyisHyYiY0k6OfcU8MTsXK7soupb/aj3h/oRbnXZ9DtTSaaaTT6pnPuOeHlZc2o2UMUZP+ZBfYb7/A0bbmwItRORjRy748POPJb4mZxehX1RhzTePvPOdNbdcmM5e/zRlleRN+A7TSdV0ypQurSFStRllt9cM17Z+DVm3uxpqiJ07029dizRxTCJRqLdZ+B7z4XXJ0S74N0irHFGM6D/ALZZ/Mj+pcFahQg5WdWncf2/VZPyd3c6xzinijy/HVht5tmvlrp7UbU1HbOMnvO1jfHwKbq3ubSq6dzRqUprqpRwWedfV79SkqpmmdJjml8p5wkOi8R6hpzUfae3od4VN2vgycaLr+n6olClVUK2MunPZ/LzOT+032yVRq1ITjOE3Ca6OLxgu9nbfycPSmqeKnwn7SiXsOi5zjlLtYIHw1xlKEo22qtzi9o1kt18fMnNGrTrUo1aU4zhJZUovKZv2DtGxm0cVqfbHfCnvWK7M6VKpZ5XypN42yau112znqT0y5l9FvVuqVTbnXnF9zamr4j0Ox1yz9hdwxOO9KrHadN+aZOLPZzVpc6eMd35bQHLo8T6/wAHaj/Dddg761/4VXPvyj5p9/gyf6Brmm65afSdOuY1Utpw6Sg/JrseppmOaTlbNvY9MXOtE9Ko6fs81XRra+zOP8mt/XFdfiiKajp9zYyarwxHpGcfqsnxTWp061OVOrCM4SWHGSymUG0tg4+brXT6NfjH3hgtZFVHKecObPaSyUtkl1fhyUU61h7yW/sn1+TI3WTpzcJwcZReGn1RoWds6/g18N2Pf3Ssbd2m5HJbl1z1KqFetb1FVo1HSnHpKJTJ92GQ6a5pqiqnlLLMaxzTHQ+IqVzy0LxxpVnspfZl+xvzlssY2RvNC4iq2nJQum6tDopfaj+5ueyd5ddLWV//ALfn8oN/E/yo+CbAt21elcUY1qFSNSEllNMuG5RMVRrCvAAfQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbSWW8Ih/FnFkbeM7TTJqdXpOqt1H0XqRM3Ns4dubl2fzPsZbVqq7Vw0tlxRxLbaRTdKny1ruS92Gdo+rOZ6pqFfUbmVzd1JTnJ7b7R+CLVWdWrNzqVHKb6uT3bLTx0XVvc5ztPa97Pq58qe6PyvcfFosx5qZYxuvmUNpvZt/BFcs4eV32Z7b0a1etGlRpyqTbxFRWSqpiZnSEnlCx3S6+SJHwvwhd6u43Fw3b2mc8zXvT9Ev1JLwrwXSt+W71WMalbrGl9mPx82TSKUUlFJJdEjcNlbtzVpdyun+n8/hWZO0NPRtfFhaRpdlpVqrezoxpx7vvJ+bZmgiXF/HGnaKpW1vKNzetNKMXmMH6v9DdLduKYiiiNIQLGPey7nBbjWZSTUtQs9NtpXF7cU6FNd5Pr8PM5Zxd4iXV85Wmi81rQls6r2qS/Yh+uavf61cuvqFzOrPOy6RgvJIx7Gyr3txGjZUKtxVnsowjklU2ojq3jZ27tjFjtcmeKY+EflZqzdSpKU5805PLb7vzz3N1w3wvq2vVIqzt3Cin71eptBfu/RE54P8NqFBfSte5a02ly20X7sf8AM+7OiUKNKhSjSo0406cViMYrCQqu6cqWLaW89u1/TxY1nx7vd4ovwvwJo+jclarBXl3Hf2tRbJ+i7ErAMEzM85aVkZN3Jr47tWsgBrtd1mw0a1de8qpbe7Bbyk/JIx3LlNumaq50iGGmmap0hmXVxRtbedxcVY0qUFmUpPCSORce8Y1tZlOysZTpWMXh42lV+PkvQxOLuJL3Xq7jUbpWsX/Lox6fPzNBycssZXxNF2xt+cjW1Y5U98+P7LzEwYt6V19WKsrlSTx5s9ba25Wmo9DIinttj4o3XBvDlXXtTUMuFvTeatRdl5L1Zr1mzXfuRbojWZWNdymimaqukKuCuFrriG45pKVCzg17Sr5+i9Tsmj6XZaTZxtbKjGnBdX3k/Nl6ws7awtIWtrSjSpQWFFIvnSNl7JtYNHjXPWfx5Ncysuq/PhHgAAtkQAAAAAAABAPGS85LCzsYya9rUc5JPsv/AJMTwZs81b+/niWMUoPy7v8AQ0XixezuuKp0YtShbwUFh9H1ZMPBuny8M1ajWHUrt/gjTrNcZW3Jq7qdflGn1XFcdlgxHj903ABuKnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACmtThWpSpVYqcJrEk+jRUD5Ma8pHIeMNGlo2pThGLdvU96lPrt5FzgLUnY8RUVJpU7heynv59PxJ9xtpC1fQq1KC/n017Sk/Vdvn0OOKtOlWUsOM4Sz/laOebSxZ2XnU3bfq66x94/ncvsav8AVWZpq69HfwYukXMbzTLa5jLKqU4yz64Mo6FTVFVMVR3qKY0nSVi9s7W9ouldUIVYv+pdCF8QcENRnX0mee/sZvr8GTsELN2bjZtOl2nn497Lav12p1plxC6p17Sq6FxTlTmusZLDRZU21l5fkdi13Q7DWKPJdUvfX1akdpROW8ScP32h3DVaPtLeT9ytFbP4+TND2psK9ha10+lR4+HtXWNmUXuU8pYHOspL5G84Y4ju9IrKEm6tq371PPT1RG4yeHjoe8yWXnqVOPkXca5Fy1Okwk126bkcNUO5abfWuo2kLm0qqpTkuq6r0fqZJxrhrXLrRbxVqLc6Mn/NpPo15r1OuaZfW+o2VO7tZ89OayvNejOk7I2tb2hb8K46x94UGTi1WZ8mDxXoVrr+mSta6Uai3o1cbwl5nD7mnq3DOtype1nbXdF/Wg2lJdn6pn0ORDxM4a/jel/SrWGb62WYY+3HvH9i8or05T0XGwtqxjV9he526vHu/bxanhHxIpXEqdprkI0JvaNxF+7J/wBy7fE6HSqU6tONSlOM4SWVKLymj5mnCcZyjKPLODxJPZp+RIuGOLtV4fqRVKf0i1ziVvN7fJ9me67X+lc7T3Youf1MTlPh3e7w+jvJrtX0i11CDco8lXG1SK3+fmY/DPEem69bKpaVVGql79Gb9+P7m5Id+xbvUTbu06xLSa6LmPXNNUaTDnmp6fcadV5LiPuP6s19WRg9+p025oUbmjKjXpxqQl1TREdc4dqWua1kpVaPVx6yj+6NE2tu5Xj63cf0qfDvj8p1nKirlV1R5+hS1s+6yVSz5FM8f/Bq6azdI1a502rzUW5U/tU29mTzSdSttSt1VoS3x70H1izmj69souWt1Xs66rW1R06kfxL/AGTty7hTFFfpUeHh7PwjX8am7zjq6mDT8Pa7Q1Omqc8UrlL3oZ2fqjcHQ8fIt5FuLlqdYlVV0TROkgAMzyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAU1Jwp05VKklGMVltvZFNzXpW1CdevNQpwWZSfRHOeKuIq2qTlbUHKnaRfTo5+r/AGKzae1LWBb1r51T0j+dyRj49V6rSOjK4s4qndOdlp8pU6K2nUXWfw9CITz3e3mXPzLdTLeMHNc3OvZl2bl2efd5exe2rVNqOGlQ2s/LB4ts9Cp5S67dmbrhnhy51mfO80bVP3quOvojFjY13JuRbtxrMvddyminiqnk1+kaVe6tdextKXMvtTf1Y/FnTuGuHrPRrdcsVUuGvfqtfgvJGfplha6baRtrWmoQj97fmzKOibJ2HawYiuv0q/Hw9n5UeTmVXeUcoCze3dtZW07m7rQo0oLLlJ4Rq+KuJNP4etPa3U+arJfy6MfrSf6L1ONcVcS6hxFdKpczlTox/wAOjCT5Y+uO79TYaaJqT9lbEvZ88U+jR4/hJOM/EC5v3Oy0Vyt7d7SrYxOa9PJfiQCUk3zNpyzu5PqV2dvXvLqNrb05Vq1R8sIRWW2dV4L8PaFp7O91tRr1lvC3+xH/ADebM8zTbbncu4WxLPDHXw75Q/hPgjUteUa9XNrZy39rJbtf2rude4e0HTdCtI29hQUWliVSW85vzbNnGMYxUYpRS2SS6Hpgqrmpo+0ts5GfOlU6U+EffxAAeFSCTUU22kl1bKK9WnQozrVpqFOCzKT6JHNeLuKa2qc9nYylRtU8SktnU/0K7aO07OBb4q+s9I8WexYqvTpHRvOJuN7WyUqGmpXNfpz/AGI/uc3v7u7vrqVzd3FSvUnu3J/kvI9UXjmX5HnIudJbPqc82htW/nVenPLw7l5YsW7McurG5MPK+qJU1jEWvuMrk91vqux5yLl37+hW6pHEtWtpVubmna0k5VKjUYpLzO1cMaPQ0TSqdpRiufGaku8pdyHeF+kRq3VXVKsU40fcpN/1d38kdFN83Z2fFu1+prjnV09n7qfaORNVXZx0gABtSsAAAAAAAABJpRbfRLIMHiGu7bQr2us5hQk1j4Hi5XFFM1T3PtMazEOFaxV+m6vd3kk17WtKXruzrPhZBQ4RotLGZyf4nJHTbT3zlfedh8Nv/wBU7bPnL8zRd2qprzqqp6zE/WF5tHlYiI8UkABvqiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAONeIWnLTeJK7jHFKv8AzYL49fxOykF8YrKFXR7a+Uf5lCryZ/tkv9Ci3ixYv4VVXfTz/Kds+7wXojunk2XhfdO54UpQeM0Zyp9e3VfmSg5v4LXeVqFlKbbzGpGPZLdP9DpBK2Ne7XCt1eWnw5MWZRwXqoAAWaMFq6t6N1QlQuKcalOSw4yWzLoPkxExpJE6OT8a8KVtIqSu7TmrWUn070n6+aIq5tYw2onf61KnWpSpVYRnCSxKMllNHIuPOGp6FcyubaM5WVaXu/8AhvyZom3dh/p9b9iPR748P2+i8wsztPQr6o6qjxlPHkSXgXiSek3qpV5N2daWJx/of9REnN5y3lLph7Hims7Zw/Xoa7i5FzGuxdtzzhYXLVNyiaZfRUJxnCM4SUoyWU13R6Qfwt4g+m2ktJuJfz7dZptv60P9CcHVMPKoy7NN2jvaxetTarmiUZ4t4M0vXoSrKCtr3Hu1oLq/7l3OQcQ8O6lodz7G/oPlb9yqnmE/g/P0PoUsX9na39rO2vLenXozWJQnHKJ1FyaVzszb1/C0oq9Kjw8PY+cLC6ubS8hcW9epRqQ6Tg8NHVeDPEOhd8tlrcoUa/1Y11tCX+byZpOMvD25sJTvtF57i2SblQ6zgvTzRAFHrlpIzTFNyG4XLODtuzxRPPx74fTUZRlFSi00900+p6cV4I44utDjC0vJVLqxb2TeZU/g/L0Ov6TqVlqtnC7sLiFalLvF9H5PyZHqomlou0tk38CvSuNae6e5q9f4epXfNcWiVOv1cfsz/ZkMr0qlGrKjVhKE4vdM6ka3XNHttTpe8lCvH6lRLf4PzRq21936MnW7Y5V+HdP4lHsZU0ejV0c6bznyKZZyZep2NzYXHsLmGJdYtdJLzRhtvKX4GhXLVdqqaK40mFpTMTGsEJzp1I1KcpRlHdNPDRNeGeJIXfLaXslCvj3ZvZT/ANSEPZ4KFlPbOeuSfs7aV7AucVHSeseP7sd2zTdjSXXwQ/hXiV5hZalU67U6r/J/uTBbrKOk4OdZzbXaWp9sd8Ke7aqt1aVAAJjGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABZvLmhZ287i4qRp04LLbYvbqhZ28q9xNQhFbtnNuJdZr6tcNPMLeL/l0/1fqVG1trW9n2+fOqekfefJJx8aq9V5KuJtfr6tUdKHNTtk/dh/V6s0Le3qi5vnMW/mUdG/M5rk5NzJuzduTrMr6i3TbjhphTL+r7ilrKXd9yrdtcu7fRYJpwfwrzcmoanTaXWnRkvxf7GXA2fezrvZ249s90PN69Tap4qmFwtwlO+5LvUFKnb9VTxiU/2R0KhSp0KMaNGEYU4LEYpbJFaSSwlhI8nKMIuU5KMUstt7I6Zs/ZtnBt8NuOffPfKhv3671WsvSE8dcd2ukKdjpsoXF/0k08xpfH19DSeIHHsqjq6Xoc8RXu1blPr5qP7nNX70t5ZbeeZvv6ltRa15y2nY27naaXsqOXdH5/C/f3txfXNS5vq86tap1lJ5bXZGx4V4c1DiG79jaw5aUMe0rSyowXx7v0N1wHwRc63ON7qMalCxTzFtYlV+Hp6nYdPsrXT7WFrZ0YUaUFtGKPdd2I5Qstq7ftYcTYxudUfCGr4U4Y03h63atoc9xNfzK0l70v2RvACPM6tCvXrl6ua7k6zIAD4xABoeNNTdjproUZNV665U19ld2R8rJoxrVV2vpD3RRNdUUwjPHOuO/ry0+2ni1pv32n9eX7EWcE22njJk8mM7N57jk9DlWbmXMy9N25PX5R4L61RTbp4YY3s1vn5ov6dp9zf3Ube1ouc5eXRerZk6fp1e/uoW9vBynJ9cbL1Z0zQdIttJtVSpJSqP/EqY3k/2LDY+x68+viq5UR1n7QxZOVFqNI6ore8KWul8M3dxXl7a6UE1LpGLyuhCuRylypZb6dzrXGCzw3er+z9Uc94dtXc6zbUVnDqJy+W5N27g27WVasWadImIj4yx4l6qqiquqXRuGrCOnaLb20UlLl5p47ye7NkFssIG+WrdNqiKKekRoqKqpqmZkABkfAAAAAAAAA0nHNV0uF7xr7UVD72bsj/iCubheuv7of8AqRE2hM04tyY/0z9GWz/cp9rkig/rNnWPDl54Xor+mUl+JzFRik9mdI8NJuWh1INv3ar6/BGj7r16Zsx4xK22hzte9KQAdDUgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABg67plDWNLrafctqnVS3XVNPKaM4Hmuim5TNNUaxL7TVNM6wj/AAlwpY8OurUt6lStWqpRlOfZeRIADxYsW7FEW7caRD1XcquVcVU6yAAyvAAABj6jZ0L+yq2lzBTpVI8rRkA+VUxVExPR9iZidYcA4n0qvoOsVrGq8xW9ObWFKPY1vNhZlH7jr/itokdQ0N39OGbi13ylu4d1+pxxpLO22Gcw2vgfosmaI9Wecexs2Jf7e1E9/e2nDuqz0jWbe/g9oS9/HeL6o77bVoXFvTr0pKUKkVKLT6pnzdFSS28t0ztfhbqH07hWjSnPmqWr9lL4dvwLrdbL0rqx5nrzj7oe1LUcMXISoAG7KQIXxrwHZazGpd2MYW1893he5UfqvP1JoD7EzHRIxcu9i3IuWqtJfN2o2N1pd5O1vbWtRqxeMTjjPqvNeqMvhvXdQ0C+dxY1FiTXtab+rNep3HiXQbDXrJ295T95L3KiXvQfocU4q4Z1Dh26dK5i6tF/4VeEfdn6ejJFNcVxpLoGztsY+07fY3oiKp6xPSfY7JwpxNp/EFu3bz9ncQX82jJ+9H90bw+arG+utOuYXlnVnSrQfuyi9/h6nYuBeOLXWlCxvpRt9QxsukavqvX0MddvTnDXdsbv14mt2zzo+cfslWpWNvf20qFxDmi+j7xfmjn+uaTcaXX5aic6Mn7lVLb4PyZ0kt3VCjc0JUa8FOnJYaZR7V2Raz6NelcdJ/KhsZE2p8nJmm3usHnqbziXQqumVHWpc1S1k9pd4+j/AHNG316HN8nFu4tybV2NJhcUVxXTrSoeOVkq4U4l9jGFnqE802+WFR/Z9H6EWzjqkUZ332MuDnXsK72lufd4w+XLVN2nSXY000mnlMEE4U4kdrKFlezcrd7QqN5cPj6E6i1KKlFpprKa7nS9n7QtZ1rtLfvjwUt2zVaq0l6ACexAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABZvLmjZ207i4moU4LLbK69WnQoyq1ZqEIrLb7HO+KNbqanc+zpycLaH1Ir7Xqyq2rtS3gWtZ51T0j+dyRj483qtO5Z4j1qvq1eXWFvF/y4enm/U08m010wVdOmxSuq26s5jkZFzJuTcuTrMr6iiminhjopl7y3zv0wU4bko4y30wVKOZcq35tkiecIcMxtFG+v4KVx1p030p+vxJezdm3c+7wUcojrPg8X79NmnWVvg/hhUOW/wBSgnV60qT+yvN+pLwWNQvLawtKl3d1Y0qNNZlKTOm4WFaw7UWrUcvqoq7ld+vxlXdV6NtQnXuKkadKCzKUnhJHHvEHjavq9SVhpkp0rGLw5J4dV/sYXHXF1xxFcOjR9pQsIfVpt4cn5sjVpbV7u7hb29OVWrOXLGKW7LOi3pzqbxsXYNONEZGT63XTuj2+f0W4RlVqRjCnKTk8KK6tnTuAPD+MeTUtbop9HStn29ZfsbfgDgiho8Y6hqUY1tQktl1jS+Hr6k2PNd3XlCDtreKbmtjFnSO+fH2fl5CMYRUYpRilhJLZHoBhaeAAAAADaSbeyRzXiC6eoapVr82Y55YL0RNuKLp22k1FGTU6vuRa9epA+XtjY0revN5041Ptn7LDCo01rYqhnbHcezbmlFNvskX1TN9wdp6ub13M45pUOme8uxquDiV5d+m1T1lNuXIopmqW74U0iOm2SqVI/wC8VVmf9q8jdAHWMbHoxrUWrccoUldc11cUsLXaTraPd0l1dJ4IVwRRUtfpv+mnKX/v7zoM4qcHF7prDIbwzQ+h8UVaElhqM4pfNYKPa9jXOxrs9NdPvCTYr0tV0pmADY0QAAAAAAAAAAA1PF9L2vDt3HyhzfcbYsajR+k2Feh/3lNx+9GDJt9pZrojviY+T3RPDVEuOKC6Yw35k38M6z5by3b6OM1+REXTaxzJc3mb3gi4VtrlOMnhVouG3n2OabEv9jnW5nx0+PJdZUcdqXRAAdSUQAAAAAAAAAAAAAAAAAAAAA8nKMIuU5KMV1beyPKc4VIqUJRlF908oiniZd1aWm0LWlNx9tPM8d0u33mD4YXVw7m6s5zlKmoKaz2ecFRXtamnPjD4evf56apMY0zZ7XVOwAW6MAAAAAAAAAAAAAAAAAAAAAKLilCvb1KM1mFSDjJejWDgOq2LstRubSe3s6rjv5H0Ccg8SbaNHimu8NKpGM/wNV3qsRVYou98Tp8f9lnsy5pXNPiiLptZeHjs/Mn/AIO3UqWoXdk2lCrT9pFeqf7EKVNte8SDw3qyocV26bXLNSg/mjVtj3ZtZturz0+PJZ5VPHZqh2MAHU2sgAAFi/s7W/tZ2t5RhWozWHGSL4D7TVNM6x1cV474JutFqzvbPNbTm85X1qXo/T1IfSquFT2lOcoOLzFrqn55PpmpCFSDhOKlGSw01lNHKfELgKds6mp6JTcqGearbR3cPNx9PQkW7mvKpvWxd4Yu6WMqefdPj7fNsvD/AI7jc8ml6zUUay92ncPZT9H6+p0VNNZXQ+ZaeFLP1XjK9GdG8OuOp0FS0rWqjlSe1G4k8uPpL09TzXb74R9t7vaa38WPbH3j8OpVacKtOVOpBThJYcWspogXFPD87CbuLWLlavql1h/oT6LUoqUWmmspruJxjOLjKKlFrDT7lRtLZtrPt8FfXunwalZvVWqtYceeeweOxJeLtAlZSleWkG7Zv3orrTf7EZaxlp98HNMvDu4d2bV2Of1XVu5FynihTjO22GSrg7iJ20o6ffVM0elOb+x6P0Iq8Yznt2KG+zeGesHNu4d2Llufb5ly1Tdp4anaE01lPKYIRwZxIoOOnX9RqLfLRqSffybJudNwM61m2ouW/fHhKku2qrVXDIACaxAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHk5RhFyk0opZbfY9IZxjrXt3LT7WbVOLxVkn9b0RA2jtC3g2Zu3PdHjLLZs1XauGGFxZrktRqO2oScbSD6r7b836Efxu+hU+j9CiXXJy7Ly7uZdm7cnnP8AOTYLVum3Tw0vJbLCwviUPyy5ZeCuXTOMk14O4e9lyaje0/fazSpy+z6v1Muztn3c+92dHTvnwh5vXqbNPFUr4O4dVrGF/fwTrtZpwa+p6/ElQMXVdQtdMsKt7eVY06NNZbff0XqdRw8O1iWotWo5fVRV1136/GZNW1C10uwqXt5UVOlTWW+79F6nD+NuKrviO+cczoWMHilSzj5y9SjjPii84h1HnnzU7Sm/5NJPp6v1NVounXmr6hTtbKi6lScsLyXq/JFnboinnLftjbFowKP1GRpxfKn91OnWV3qN9Ss7SjKrWqPljGMenq/RHauA+ELfh+2Ve45a2oTjidTG0F/TH9zJ4L4XteHbR8uKl3US9rV/ReSJCY7lzi5QoNt7eqy5mzZ5UfX9gAGJrQAAAAAAACKcZVZVLylQWeWEcv4s0Xs9u5tdXl7bUq9RPmXNhfBGG4b7nJtrX5v5lyvz0+HJb2Y4aIhjezcmopPL6InmjWkbLTqVBL3sZk/NvqRnRLZV9Toxayk+Z/Bf+0TI2fdLE0pryKu/lH3Rcu5rpSAA3JCCJ3NWNPjONRbLnUW/isEsIVrUXDWK0091Uz+pr28V+bFq3XHdXE/DVJxo1qmPJNQW7Wqq9tTqrpKKZcL+mqKqYqjpKNPIAB6AAAAAAAAAAAc216z+javcU0uWPO5RwuzMaylK3uadddYSUuhKeNrNe0pXkV1XJLb7iMuL+RynalicPNrpjlpOsfWF1Zr47cOmW9SNahCrH6s4porNFwbeOtYSt6j9+i8L1izenTMLJpysei9T3x/uqLlHBVNIACU8AAAAAAAAAAAAAAAAAAbSTbeEuoHP/Eiv7XVKVunlUqeWl5s2Hhra8lvdXTxmclBfLf8AUjuuXDvtVuLhrClPEduy2ROeDKSp6BQwsOWZP7zSNl1xmbYrvd0azH0hZ3/6ePFLcgA3dWAAAAAAAAAAAGv13V7bSLX21fMpSeIQj1kyvWtSt9LspXFeW/SEO8n5HM7+5vNb1JznGU6k5Yp012Xkij2xteMOns7fO5PSPD+d0JeNjdrPFV0dA4a4gt9aVSMKcqVSnu4t5yvM3JpOFNDjpFvKdRqVxUS52uiXkjdlhgTkTj0zkev3sN7g454OgACYxAAAHMvE+H/1+Elh5pLZ/M6ac28RsVeIOXP1aSzsa9vPMRg8/GE3A/uoeo/A2nCEeXiWycY7e1RiOHn2NrwjS5+IrLHVVMmiYOs5NvTxj6ri7V/Tq9jrYAOuNaAAAAAAPfqABzfxD4Dp11V1XRqXLV3lWt49JebivP0OWTThs4tSW273TPpsgPiFwPDUI1NT0iCpXi96pTj0q+q8mZqLmnKW4bD3gm3pj5M8u6fDynyaHw944np8qel6vVlK2e1OrLd0/j6HW4SjOCnCSlGSymns0fM8qdSjNxqQxUg8STW6fkTrw742qaZKjpeqzc7Ob5adTOXR8s/2/kfblvvhJ27sGLkTkY0c++PHzh16cYzi4TipRaw0+5AeLeH3YTleWkG7aT96K/4f+hPoSjOCnCSlGSymnlNCpCNSEoTipRksNPuVG0tnWs+1wV9e6fBplm9VZq1hxv7lhlDezb33JFxdw+9NrfSbeMpWk3/0PyfoR148jmWXiXMS7Nq5HOF5bri5TxQ8zJPDz/qTvgviNXChp1/USr9KU39r0+JA5dNt2eKTpzjUhlSi8p90zPs7aFzAvRco6d8eLzes03adJdrBHeDteWp2/wBGuZKN3TXn9deaJEdOxcm3lWou251iVFXRNFXDIACQ8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaviLVYabae60681inF/mzDfv0Y9ublydIh6oomuqKYYHGGsu1ouztaiVaf15L7K/chD675eS5cTlVqSqVJOU5Sy231LfVNrqcr2ptK5n3+0q6d0eH7r6xZi1TpCiWM55Sh7vZdfMrbXTfJvuEdDd/XV3cwf0WD2T+2/2MOHh3Mu7Fq3HOfkyXLlNuniqZfB3D6qcuo3tPMc5pU5Lr/cyaCKUUkkkl0SKLitSt6M61acadOC5pSk8JI6ls/AtYNmLVv3z4yobt2q9XrK3f3dvY2lS7uqip0aceaUmcO444nuuIdQeJSpWVJv2VL9X5sv+IPFtbXr2VvbudPT6Mvcj09o/6mRzTbW5v7ulZ2lN1a1SWIRXn6+hb27ekay3vYexqcOj9Tket/8A8x+VelWF1qd/TsLOm6lWq/d8l6v0O48F8MWvDtgorlq3lRfzq2Or8l5Ip4I4XteHrFNxjUvakV7ar/8Aur0RIjFcucSi25turMq7K1OlEfP9gAGNrYAAAAAAAAeSeIt+SPS1dtq1qtdVB/kea54aZkhD3Hmbl5vP3hw2xuX6dNqlBbfVR7y/A4xVVrMyt4lsOF6KUq1bvtH9f2N6a3h6CjaTfeU/0NkdT2Fbi3gW4jvjX4q29OtcgALZiCM8T26hexqxS/mrL+KJMYGuW6r2TaWZU3zL9So25i/qcKumOsc4937MtivhriWJwvcN0p2s3vB80PgboiVrUlbV4VobtPf1RK6NSFWlGpB5jJZRC3az4yMbsap9Kj6d34e8ijSrWO9UADZEcAAAAAAAAAAGNqlrG8salCXWS91+T7EDnScZNSWHF4a8mdFIxxNYqncK4hFclT63+Y1PenAm5ajJojnTyn2fsmYlzhnhlq9HuJWV/Csl7vSe/VMnUJKcVKLymspkC5FkkPDN83D6HWnlr/Db8vIr92NpRaqnGuTyq6e3w973lW+KOKG9ABviAAAAAAAAAAAAAAAAAGo4svXaaVOMH/Mq+4t+3c25CuKrtXepulHLp0PdXq+5T7dzf0mHVMT6VXKPez49HHXGqPSh2zsjpei0VQ0m1pLtTX5ECs7V17qlQisuckvlk6PFKMVFbJLCKLdGzzuXfZH8+STnVdIegA3VXgAAAAAAABjanfUNPtJ3FeWFHou8n5Iu3VelbW869aajCCy2znuuahV1O7dSeVTi37OHkv3KfbG1qNn2uXOuekfdIsWZu1eTD1q/r6reOvW5kukIJ7RRK+C9Dja0lqFzD+fUXuRf2V+5reE9I+mXX0mtH+RSf/VLyJytlhFNu/s6u9XOdkc5npr9fwkZV6KY7OgABuKvAAAAAA5XxXUVxr93UTcoqXKn8DpeqXKtNPr3Df1INr49jllRSqTlUm8yk8s07e3IiKLdnvnn9ljgU85qYfs+u3U3/AVv7TiKFTl2pwlJ/kamUd+m3oS/w7tOX6TdvO+IJ/i/0Nf2HZm9nW48J1+CZk18NqUwAB1FRAAAAAAAAAAAgfiNwVDUoVdV0ulGN9FZqU1sq2P/AN78zj84zjNwkuWS6xe2GfThz/xL4Mjf0auraZTxdRXNVpRX+Il3Xr+Zmt3NOUtv2Bt7spjHyJ9Hunw8p8vo0vhrxt9DnT0nVaubaT5aVaX2JeT9PXsdai1JJxaafRo+ZJRmnjaOHh56nTPDLjOMZQ0PVKmF9W3rSf8A5X+h9uW++GfeDYcTrk48e2PvH3dMr0qdejKjWgpwmsST7nNOKdCq6RcOVLM7Wo/cl3XozpxZvrWhe207e4gp05LdFHtXZdGfa0nlVHSf53NRx782avJxtpp7Lfug1jt2NlxBpNfSL2VGrmVOTzTmltJfuat5e7ax5HM7tmuzXNu5Gkwu6aorjihXbXFW1uKdehNwqQeU12OqcM6xR1iwjVjKKrx2qwT6P9jlDafTbG3UydF1SvpF7G6odnice04+Ra7F2rVg3dKvUnr+WDJx4u08usOxgxtMvqGo2VO7tpc0Jr5p90zJOlUV010xVTOsSpJiYnSQAHp8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADyUlGLlJpJLLbAs6hd0rK0ncVniMV0835HOdSva1/dzuK796T2XaK8kbHiXVXqF2oQk/o9PaK/qfmaWXXqc43g2v+rudlbn0KfnPj+FziY/ZxxT1lTP4dymXzKn6b+ZesLOtf3cLahFuUnv/au7Zr1u3VcriiiNZlMmYpjWWTw9pM9Vu+Vpxow/xJry8vidGoUqdCjCjSioQgsRS7IsaVY0dPsoW1COFHq+8n3bMo6hsfZVOz7Ok+vPWfso8nIm9V5EmopttJLdtnHfEri2Wq3ctLsKjVlSliUl/wAWS/Q23ipxc48+h6bV3fu3NSPb+39zmCTlLlSb5pbef3F/ao75bdu7sXhiMq/H/wAx9/wuWtKpdXELejCVSrUfLGC3bZ2vw94SoaBZK4uIRqajVX8yb+wv6UYfhnwfT0i3jql/RTv6sfdUt/ZRfb4k4PNyvXlCFvBtv9RVOPYn0I6z4/t9QAGJqoAAAAAAAAAABau1m1qrzg/yLp5JKUXF9GsHmuOKmYIRqjH+TBvfMUypw+89jJRXKu2x7zehxeqNJmFnrLZaHtRqx/vz96NgajSqvLd8naccfNf+2bc6hu9fi7gUad3L4fsg3o0rkABdMQGk0090wAI3eWrt68qe7j1i/QydIufo83RqP+XJ7Z+yzY6jbfSKSa+vDdevoaZRjNbbpnOc+zc2LnxeterPT7wm01Rdo0lIwaywvfZ8tGs/d6Rm309GbM3nBz7Wbai5bn2x3wiVUzTOkgAJryAAAAAAAAFq8oQubadGfSS2fk/Mug810U10zTVGsSROiGVredKtKlUWJR2Z5BOElODaknlNdiRa1Ze2gq8F78FuvNGk5HjKWxyrauz69n5M093WJ/nfCzt3Irpb/SL5XdHlnhVo/WXn6oziKUnOjWjVg2pReVub/Tr6FzBRk1GrjePn8Dcdhbcpy6Ys3p0rj5/uiXrPDzjozAAbMjgAAAAAAAAAAAB7LLAw9Zu/oljOon77XLD4kJlFt5bbb3bNxrd1K7u2k/5UNorz82a9wOZbwbR/WZPDTPo08o+8rLHo4KfOWbwtbc+p+1a92nFv59iWmp4Zt1TsnWaxKo+vojbG57v4v6fBo161c/j+yJkV8VcgALpgAAAAAANpJtvCQNFxPf8ALTdjSfvSX8zfovIiZ2ZRh2Zu193znwe6KJrq0hqOJdSle3HsaUsW9N7Y+0/M1llZVLu8hb0lvJ7vHReZcdNeqJXwxYK3tfpNSOKtVbekexz7Ds3dtZ01XZ5dZ8o8FlXXFi3pDZWVvTtLaFCksRgsfEvAHSqaYopimmOUKuZ1nWQAHp8AAAAMXU72nY2kq03v0ivNni5cptUTXXOkQ+xEzOkNBxte8yjYU5b/AFp/oiJuGenzMy5nOvXnXq+9Oby2W1TfwOUbTzZzcmq73d3sXNmiLdMUsdU+mOp0bh+0VlpNCjjEuXml8XuRPh2wV3qUIuL9nT9+bJ2bRunhzFNWTVHXlH3RM25rpTAADckAAAAAAAAAAAAAAcz8T+DeZVNb0ujl4zXoxX/nX6nMIJpfy9nF526n020msNZTOR+KHCDsK8tY06DVpUf86EelKXn8GZ7dzulu27229dMW/Psn7T9m+8MeMP4jQhpOpVF9LprFKo/+LHyfqifHzPbVK1vXVSlUlCVOScJRe6Z27w94rpcQ2Lo1moX9BYqx/rXaSPly3pzhE3h2L+nqnIsx6M9Y8P2bzW9MoarYztqyw2vcmusX5nKtSsa9hdztriPLKD+9eaOxmj4u0OGrWTnTSjdUk/Zy/q9Gaxt3ZEZlvtbcenHzjw/CgxMmbc8M9HLZd91uUtJryfl5FypTlSqSpzg4yi3GSfZooaXfr2OdzrTOi69je8Ha7LSLxUqzzaVX76/pf9R1GEozhGcJKUZLKa7o4dLOV3J34ea8pxWk3U0nHahJvqv6Tbt3Nq8E/pbs8p6fj8K7Nx9f6lPvTcAG7qoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIxxjqvKnp9CW7X81rt6G317UI6dYyqJ5qz92lHzZAKs5VJynUk3NvLb7s1TeXavYW/wBPbn0quvlH7p2HY4p46ui2+qWxTJvJVL78FDa6HP1u8UXOSjBNuTwkurZ0DhjSI6bac1RJ3NRZm/L0NVwXpHTUriG//Bi10/uJYb9u3sjsaP1V2PSnp5R4+/6KrNyOKeCnoEP8SOKY6LZfQrSonf11sk96cf6v2NzxZrltoGkzu6zTqP3aNPO85eRwXUr+4v8AUKl5cP2letLMpN/gjcbdHFOq03f2R+rr7a5HoR85/Hixpy55Sm5vmcsyb6t+p0vwr4RUuXXNSo5Wc21Oa/8AP+xpPDThaWt3yvr2l/uNFpvK2qy8vh5naYRjCKhCKjFLCSWyR7uV6coWu8e2OzicWzPPvnw8noAMDRgAAAAAAAAAAAAAAAEcvoexu6lNbLOV8yyp+pn8RUnGdOul7rXLL9DU8z2OT7Yxf02Zco7tdY96ytTxUxLJhVcZxnHZxeUSO2qxr0IVY9JLJFFIz9Jvfo9XkqS/lTf3PzLLdzacYl7srk+jV8pY79vijWOqQALdZQOjIIAABrtTtHl16S9ZpfmbEEPPwbWbZm1c/wBpeqKppnWEbU8r0Mqzv5UMRnmdPPzRd1HT2nKtbrPeUP2NXzPp0OcXLWZsXI1idPPumE2OG7CTUa1OtDnpTUl6FZGKdWdOfPTlKL813M+31ecVi4p8684dfuNswN6Ma9HDf9Gr5MFePVHRuAY1C+tay9ysk/KWz/EyU0+jybHbu27scVFUTHkwTEx1AAZHwADaXUAC1Vuren9etBfMxKuq0YtqnCpUa9ML8SJfz8bH/uXIj3vUUVT0hsDS6naexqe0gv5c308mVz1OvJLlhCHn3LFW6rVdp1XyvrFLCNV21tfZ2ZZm1zme6dOk+/RntW66Z1WPZ47BRaaabTW6a7Mr5j3KNJiZidaZStWfaajhKFynn+tLb5mwp1adRZhOMl6M0GUEknlbP0Nqwt6b9mmKL1PH59JR6rETzhIcrzGV5kefxf3jf+qX3k7/APYUf+L5/s8/p/NIQR5839Uv+pjFTtWqL4TZ7p3vtTPO1PxfP08+KQg0Cq3EelxU+bK4XV3Br+e5fFIkUb2Yc+tTVHw/L52FXi3gNPDULuMnzezkvLGGXIarNNKpavHnCaf5ky3vFs+v/PT2xLzNmttDWa3d8kPo1N+/Je8/JFNbU6kotUqXJ6yeTXTUpzc5PMn1bKrbO8VqbU2sWrWZ6z4QyWrM661MXk9CqnburVjTj9aTwi84I2GiW+a8q7w1Bcq+JqmzcOczJotd3f7O9Krr4adW1o040qMKUPqwSSKwDrcRFMaQrAAH0AAAAEmoptvCXUDF1O6jaWsqm3O9orzZEailUm51G5Tk8t+ZstSuJXdy57qC2gn5eZi8i+ZzLb205zsjgo9SnlHnPj+FjYo4KdZ6q9Hsfpd6oyX8qHvT/YlqSSwuhiaTa/RbOMZJe0l70/j5GWbrsTZ8YWNETHpVc5/HuQ71zjqAAXDEAAAAALdzWp29GVWrJRjFEN1a8q39w6kliC2hHyRs+JZVZ3sactqUYpx9X3NS6e2xz7ePa1y9dnFp5U0zz85/HgsMe1FMcU9WOoZ2xueKm5bJNt9EZHJ3ZtuHbGNW4dxUWY0n7q7NlFgYleZfps0d/wAo72eu5FFOstnw/Y/QrJc0cVanvT/Y2IB1jHsUY9qm1R0hU1VTVOsgAMz4AAAAAAAAAAAAABRXpU69GdGrBTpzTjKLWzRWAROnOHDvEHhStoF97e3zUsK8/wCW/wCh/wBLNDpGp3OkalS1Czk4ypvL8mu6fofQmsada6rp9Wyu6anTqLuuj7NepwLirRLzQdUq2d1mW+aVRLacc7NEm3VxRpLomwtq059qce/zqiPjH86u58L63a6/pVO9tnhvapTfWEvI2pwHgniCvw9q0a6cp203y16a7rzXqjvNncUbu1p3NvUVSlUipRku6MNyjhlqm2tlTgXvR9Sen4RDxA0HmhPVrSPvpfz4pdV/UQNtSWGdvlGMouMkmmsNPucw410OWl33taMW7SrvBr7L7xf6Gjbx7K4J/VWo5d/5/LHhZGv9Or3I803J5WEU0qkqNaNSm3BwknFrqmj3O2/3lMn6moxMxKyda4R1qGsacpSaVzTSVWP6/M3Rxrh7Vauk6pC6hL3cqNSOfrR8jsFncUru2p3FCanTqR5otHSdh7T/AFtnhr9enr5+ajy8fsqtY6SugAu0QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8nKMIOcniMVls9I3xhqLjFWFGW8t6rXl5EPPzaMKxVer7vnLJatzcqimGk13UJahfOos+zjtBehrnv8AsVPp5FLycmyL9eRdm7cnnK+ooimIiFLWG9jYcOaW9TvV7Rf7vTeaj8/QwrelUr3FOhSTlUm8I6JpNjS0+yhb01v1nL+qXdl1u9sr9Ze7S5HoU/OfD8o+Vf7KnSOssqEYwioxSUUsJLsW7u4o2ttUua81ClTi5Tk+yRdOU+LnE0q9V6FZT/lQadxKL+tL+n4I6ZTTrOkImzcCvOvxap6d8+EIzxtr9XiLWJ1m5RtqeY28X0ivN+rMbhLQrnX9VhZ0lywW9WrjKhH9zXWtCreXNO1t6fPUnJRjHzyd44H4docO6PChFKVzUxKvU/ql5fBEiuqKKdIb3tTOt7JxItWvW00iPv8AzvbXTLG306wo2VrBQpUo8sV+pkgEZzaqqapmqesgAD4AAAAAAAAAAAAAAAAtXVGNxbzoz6SWPgRGvGdGtKlUTUovDJmazXdOd1TVWj/jQXT+pGubw7KnMtRdtx6dPzhIx7vBOk9EdU3s0euRYk3FuLTTWzHNt5HOdJ1WDeaPqjpyVC4f8v7Mn9n0fob9NNZTymQTmNlper1LTFOrmpR8u8fgbfsXeHsoixlTy7p8Pai3sfX0qUpBbt61O4oxq0pKUJdGi4bzTVFUaxPJB6AAPoGFf6fSufej7lTzXf4maDBkY1rJom3dp1h9pqmmdYRa5t69tPlqwa8pLoyzzb9SXTjGcXGUVJPszQ65Ywtoq4o7QbxKOenwNF2ru3ONRN6zOtMdYnrH5TbV/inSWA2n1K6dWpTkpQqTj8JPBiqeGeqe3bBrNFyu3OtE6exImmJ6s1X13vi5qR+5lf8AErzCXt38cIps9OurmPMkoQf2pdzNhob/AOJdS/5YJfnk2HFxttX6YqoqqiPOdPrLBVVZjqw/p153uZv7i1OtOo251Zy27yZuIaNar606svjJfsXo6XYpYdHm+MmyX/wHat6NLl341TLx21uOkNApJdNj1TTe2X8CSQtbaCxChTXyLkacI/VhFfBHujdCuedd35fu+Tkx3QjSVRvaEvuZUqdbP+DV/wClklBIp3QtR1uT8Ief1M+CORoXLSxQqf8ASV/RrpL/AAKn3EgBk/8AyON311fL8Pn6mrwaD6Ldf9xP7jz6Ncp70J/cSAH3/wDJYv8Arq+X4P1FXgjrp11nNGp/0spXtG/8KovjFkkB4q3Qsd1yfkfqJ8EbbaTcoyS+BSqsW9mSZpPqkUunTfWEX8jBXufH+N35fu+/qPJHufPQ95jeTtbef1qMH8i1LTbNrCpOP+WTRGubo5EercifjH5eoyKfBqOb0PeZGxnpVFp8lWrH44f6FmWlVVH3a8ZP1jgg3N2s+3zimJ9kx+z1F6iWJlDKLtSxu4LKpqfwkWKkK1N+/RqR/wCUrL2zsqzzrtzHuZIqpnpKrYu0LirRyqU8Re+GsoxFNNbPfO5VzGCxfu49fHbqmmX2adY5tjS1OosKtRUvWEv0Zk0tQtpreTpvOPfWDS8x7zbdEX2PvRm2uVelUecfhiqsUz0SOE4zjzQkpLzTyekbhLkkpQ91ryeDKpajcU8J8tVf3bMv8bevGucr1M0/OPz8mGrHqjo3QMKjqVvLao3Tf93T7zMjKMoqUWmn3TNisZVnIp4rVUT7GGaZp6vTXaxcYj9Gi95LMmuyM25rRoUZVJ9ui8zRzqOpNznu29yg3k2n+msdjRPpVfKP36M1mjWdZWHAy9KtlUulNr3Ke/z7FrK8s+hudPo+wtYxeOd7y+LNa3c2f+pyu0q9Wjn7+5nvXOGnTxZAAOloIAAAAAAADD1W1jc2zeFzwWYsjfJsSjUKyo20sbyksRRoOT/2zn29lNmMimafW05/ZNxpnhnVi8mNsG+4cwrOce6mzVOnsbfQYKNvOS7zI+62v673S9ZE+g2IAOkoAAAAAAAAAAAAAAAAAAABoeN+HqfEOjTt1yxuoJyoTa6S8n6M3wPsTpOrLZvV2LkXKJ0mHzReW9ezuqltXhKlWpTcZxl1TXUnfhXxS7G7WjX1T/dar/lTb2pzfb4P8zeeK/C7vbb+M2FJu5or+dCK3nHz+KOSx5k01hNb5SJMaXKXSbVyxtvC0q69/lL6aMXVrGjqVhVtK692a2f9L7Mi/hhxN/GdM+hXc19Otlh/+JDtImREuW4qiaKo5S51k49zEvTbr5TDi+rafcabfVLS4WKkG8PG0l2aMLKzhLPw7HUeOtEWpWH0mhDNzQWVhbyj3Ry+osNrP3nL9r7PnBvzR/jPSf54LfGvxeo171D2bXdky8ONd+jV/wCFXU/5VR5pSb+rLy+ZDW22sHnvQqKUJcs47rHZkfBzK8O/F2ju6+cMl21F2iaZd4Bo+DNZjrGkxlN4uKPuVV69n8zeHVLF6i/bi5RPKWu10TRVNMgAMryAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxdVvI2NlOu8OXSC82QCtUnWqyq1ZOU5PMn6m24nv1eX3sacs0qWUt9m+7NNLpnoc03j2n+qyOyon0aPnPf+Fzh2eCnWesqHuU/a6leDYcPad/EL9Rkn7Kn71R9mvIpcXHrybtNqjrKTXXFFM1S3fB2lqlS/iFaPv1F/LT7Lz+ZIzyMVGKjFJJLCSLGpXlvp9hWvbqahRowcpM61g4dGHYps0d3znxUVdVV6vXvlHfEfiP+BaRKnbTir6unGnn7C7y+Rw9tynUqzqOcpSy23u2bHifWbjXNZq6hcZjGaxTg/sQ7I2vh1w5PXtXTrQxY27U6rx1faPzLWmIop1l0fZ2Lb2PhTcu9es/hLvCXhaNCjHXr6k1XnF/R4S+xF/a+LOjHkIxhCMIRUYxWEl2R6RqquKdXP8APzbmbfm7X3/KPAAB8QwAAAAAAAAAAAAAAAAAAAABqta0mN2nWoNQrJdO0iK1o1KNR060HCceqZPzC1XTqN/R5ZrlqJe7NLdGs7Y2BRla3bHKv5T+6TZyJo5VdEKU9j1T2KtQta1hcOlXTz2l2aMbnz8Dn9y1XarmiuNJhYxpMaw3vDV86F57CcsUqu2/aXYlZziM+jzjH4Ex4e1SF5QjRqySuIro39ZeZue7G1I4f0tyef8Aj+ELKtf5w2wANzQgAACO8UXalXjaRbxDEpfHsiREF1WrKpqVxUz9ab/Db9DW96MmbWJFFP8AlOnuScWjir18FPN18jcaBp/0mSua6zSi/dX9TND7RpZxnBOtMhGnp9CEFhKmvyNc3awKMnImu5zinnp59yRk1zRTpHeyFt0Ae27MK81WxtcqpXTkvswXM/wOh3b1uzTxXKoiPNXxTM9GaDQ1+JKK2o285esngw6nEF7JNRVOGfTOCovbw4FqdOPX2RqzRj3J7kqD26kKq6nf1FiV3U/5dixKtVa96rVbfnNsrbm9tiPUtzPwj8skYlXfKcutRXWrBfGSLcry0i8O5or/AJ0QhNY6dz3m32IlW99Xda+f7PX6SPFM3qVgnj6ZRz/nR79Psv8A+ao/9aIXzYeM7nrk+x4//X3f/FHxff0keKbxuraSzG4pNf50VKtRfSrB/wDMiDqXr8jx8r+yvuMlO99Xfa+f7Pk4keKeJp9GmCDKrKKxGpNfCTRdpXdzT3p3NZejnlfiSKN7rU+vbmPfr+HmcSe6U0BEVq2oJLluW/jFMyIa7dpbxpy+KJlvenBq9bWPd+HicWuEmBoYcQy5kp2uV3cZGTDXrJySmq0M+cMr8Cfa23gXel2Pfy+rxNm5Hc2oMWjqFlWk407mm5Lqs4MlNNZTTXoWNF2i5GtExPsY5iY6vQAe3xZrWtvV/wASjBvzxv8AeYlTSLd5dKdSnntzcy/E2IId/Z+Nkf3bcT7ufxeorqjpLSVtLuYb0nCa+OGYVWFWjtVpTh/mW33koDSaw0mn2ZR5O6mLc52pmmfjH897NTkVR1RXn9Rz7m9r6ZaVU+WmqbfeG34GBcaRXjl0ZxmvJ7M1zL3azbPOmOKPLr8Gei/RPXkwubbcqp1qlPPs6s4N/wBL/QsVI1KUnGrCUJeUkec3mUkVXcevlM0zHtiWbSKoZM61WpJOpVlNrbdlPOWOYc3l0PNy5Xcq4q51nzIpiGz0ul7a7i39WHvP4m8IxZXdS1q+0glJNYafdG3t9XtKjUZt0ZP+vp95vO7ObiW8bspqiK5nnr3+HyQ79FXFr3NgDyMoyWYtNeaZ6bf1RgAAAA2kst4QAtXVenb0+eb+C7sxLzVKVJuFFe0n5/ZX7mqrVp1ajnUllv8AA1zau8NnFpmizPFX8o9v4Z7dmauc9F+tWlXqe0qP4LyRRlFnm2HN2Od3r1d6ublc6zKXFOnKF7CeEllvZI3lpS9jbwp90t/iYGkW3Ni5qJ7fUTX4m0N+3Z2ZVj2pv3I9Krp7P3RL9es6QAA2lgAAAAAAAAAAAAAAAAAAAAABpNNNZTOK+JXDa0LU/plrBqyupNx8oT6uP6o7UYOvaZb6xpNfT7le5VjhPvF9mvVHuirhlabJ2jVgX4r/AMZ5THl+z5/0TU7nSNWpajbNqdNp4z9Zd0/kfQOhanb6vpdG/tpZhUW67xfdM+ftZ0yvpGo19OuV/NoyxnGOZdn9xJvCziR6TqjsLmp/uVzLDcukJ9n+hmuUxVGsNw2/s6nOx4yLPOqI19sfzo7Qc08QtGdjf/TqNP8A3eu98fZl3OlrdZMXVrGjqWn1rOuvcqRxnun2aKTauz6c7HmjvjnHtaFj3ps169zicly7JYRTKSTwvx3MvVLOpp1/VtK+04S5X6rszEx7zWOr6I5fVRNFU01RpMNhpmJjVs+E9VqaPq1O4TbpzfLVj5x/0Ox0pxq041ISUoySaa7o4M2k1FbM6L4Zaz7e1lpdaeZUlzUcv7Pl8jat2to8Ff6avpPT2+HvV+0LGsdpCbAA3hTgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeTnGEeaclFebYmdB6DDqanaR2jU9o/7FkxamsS39nbr0c59fuK+9tXEs8q7kfX6MlNmurpDbA0j1W5a+rTi/RNlMtTvO0qa+MP9SFO8WFHfPwZP01beg0a1W7UcuNGT/ytfqZFHV00va0cPvyyyZbe3cGvlx6e2Hmce5Hc2gMajfW1VLFRRb2SlsZK3WUWlu9buxxUTEx5MU0zHUABkfA1nEd99DsXGD/m1fdj6ebNm2km28JEF1q9d9fSq/8ADi+WHw8yj2/tH9FjTFM+lVyj7yk4trtK+fSGvxjzRS+hWUPpk5eu1MU5SUVluTwl6k/0Gwjp+nwpYXtJe9UfqR/g/To17l31RNwpPEE11l5/Il5vu62zeztzlVxzq6ezx96rzr2s8EBynxg4iVe5WhWk8xpNSrtPZy7R+ROeOddhoOg1blNfSJrkoR85Pv8ALqcDrzlXlUr1ZZqTk5yl3k+7N1tUazrK93Y2Z2tz9VcjlT09v7K7K1r3d7Stbem6lWrNQgkurZ9A8K6LQ0LR6VjSSc0uarP+qXdkM8HuHnToPXLuDdSaxb8y3S7v9DpB8u16zox7y7T7e7+non0aevnP7AAMTVgAAAAAAAAAAAAAAAAAAAAAAAAAAYup2NG/tnRqrD+zLvFkCvrerZ3c7erHDi9n5rzOjmp4l0r+I2vNSSVxT3j/AHehr23tkRmW+1tx6cfOPD8JWNe4J0nog6k98dPUqp1akJKcZSi08pp4LM1OlOUKicZQeGmt0Uue+zxk516VM+EwtNIlK9N4n5Uqd9TcsL/Eh1+aN7a6pYXKzRuqb803hr7znCmvM9Uk106M2LE3nyrERTciKo8+vxRq8OirnHJ1CM4SWYzi/gz1zgusor5nMI1Zx+rOS+DYdWb6zm15uTLON7qNP7Xz/Zh/Qz4ug6vqVvaWdSXtIyqOLUYp75IJKo2228t7vcsc665Pebz7mvbW2tXtGumZjSI6Qk2bEWoX4yWMm6suIq1vZKh7GNScViM3Lt8CO82JdSpMh4mbexKpqs1aa8nuu1TXHpNld6neXcmqteXK/sxeEYvM98FmDcpKKTbeyS7m3sNAv7nEppUKfnLr9xkotZWfXyia5/nweZ4LceDXc3boiqmpTeIRlP0SJbZ8PWNDDqc1eS7y2X3I2lGhRorFKlCC9FgvcbdO9VGt6uKfZzRqsumPVhDLbS9RrfVtpxT3zLZGZT4evpNc9SjD5tkrBcWt1sOj15mr36fRgnKrnojkeGpv614vlD/UvQ4bor69zUfwSRvQTadgbPp/7fzn8vE5Fye9pv8AZ20/76r96H+z1p/3tb70bkGT/guB/wCKHzt7ni03+z1rj/Gq/gUy4doP6txVXxSN2BOxMCf+1B29zxaCXDn9N21v3gUT4drfZuoP4xaJEDDVu9s6r/t/Ofy+xkXPFF5aDfRe0qUvhLBj1dK1Cns7aUvWLTJgCJc3WwqvVmY9/wCz3GVX3oNOhc0ny1KFSL9YstKWcvyZPi3Ut6FT69GEvjEg3d0Kf+3c+MPcZfjCDNprGfhkrp1alPanVnDv7smiWVtI0+q8ugov+1tGFV4ct3l0rirB/wB2JIgVbs51meK1VE+ydGSMm3PVraOsX1PC9rzpLGJrJm0eIpravaZ9acv0ZjVuHryCzTq0qr/6TCraffUW1O2q480sr8D5F/beH60VaefpR933hs1pNb6zYVutV03nGKiwZ1OpTqLMJxkvR5IDPmi8Si032awe06koNTpzlBrbMXgl2N7LtM8N+3r7OTxViR3Sn4Ihb63f0ZNupGrHymv1Rs7XiOhPa5oypesXzL9y8xt4sG/ymrhnz/PRgqx66fNvAY1tf2dyv5NxTk/LO5klzRcpuRxUzrDDMTHVTVp06seWpCM15NZNZdaLSm+a3m6T/pe6NqCPlYOPlxpeoifr8X2muqnpKJXdrc2rxVpPHaS3X3mOp4+JNWk1hpNGtvtHt6+ZUv5NT06P5Go526lVOtWLVr5T+UujJjpUjqk/Q95kVXtlc2cmqsHy9pLdMxlJGp3bNyzXNFynSfNKiYmNYZVGtUpYdGrOHweEZdPVr2Ecc8J/5o/sarn9T3n23M9jaGVj8rdcx73mq3TV1hu6WuV9ue3pv4Ta/Qreuy3xbLPb3/8AQ0PNst0e85O//RbQjl2nyj8PH6ejwbiprN1L6sKdP4ZZiVbmvWf82rOSfbO33GGp77sc2CJkbUy8jlcuTMfzweqbVMdIZHN2HNh4LClt6lyhCrXmoUabnL0RBpoqrmKaY1mXueS5zeZs9L091kqtZNQ7Ra+sXdO0hQxVu2pT6qC6L9zbG6bG3bmmYvZUeyn8/hDu3+6kSSWEsJAA3VEAAAAAAAAAAAAAAAAAAABZu7iFtR9pPL7JLuzUXOo3NVtRfso+Uev3lbnbVx8Llcnn4R1Zbdmqvo3NatRorNWrCC9XgsfxGy5eZV1Jf2ps0EkpPml7z83uerJr93ei5M/06I080mMSO+W+jqNo3/iNfGLL9CvRrx5qVSM16MjR7TlOnNSpNxlnbHmMfea7NcRcoiYnwKsWnTlLC8VuHY6po89Qtqeby1i3st5w7r5HF6eYzTT5Wt/gfTiWYJSw8rc4n4ncOfwXWPpVCC+h3MnOGF9WXeP6m82a/wDFtG6+0+uJcn/5/CeeFvEL1fRVaXNTmu7VKLb6zh2f6ExPnbhzVq+iazR1G3bxCX82PaUe6PoLTryhf2NG9tp89GtBTg/Rni5RpOqp3h2Z+kv9pRHoVfKe+EW8R9F+lWf8Tt6ea1FYqJLeUP8AQ5vJ7pnd5xjODhJJxksNPucf4v0qWk6zVpOOKM3z0X2x5Gibz7O4KoyqI5Tyn2+KNs+/xR2dXuaaaxHZdS9p17W0++o3dCSjOnLK36+jLDb91Mofljfrk1SiuqiqKqZ5ws5jWNJd00q9pajp9G8oPMKsU/g/Iyjm/hfrXsbp6RXl7lX3qLfaXl8zpB1PZmbGZj03O/v9rXMizNq5NIACewAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABRWrU6MOerNRXqYl9qNOjmnSxOouvkjTVas6tR1ak3KT8+i+BR7R25ZxPQo9Kr5R7Ui1jzXzno2N1qsn7ttFL+6X7Guq1KlWXNWnKo/wC4p265Q226GnZe08nKn06uXh3JtFqmjpAl0S29B8UM75yMrO5A1ZHnyPdsNj7hnvk+QC37j4nm3XJ7lIRMAX7W7r279ybcf6Xuiwmh6GazfuWauK3VMS+VUxVylvrS/o18Rb5Jvs+5lkWe7Ntp+oZxSrvd7Rkbhsvb8Xpi1kcp7p7pQruPw86V3XVcPTaito5k+vnjvgg0sp4e2Do5GOKNMVJ/TKEVGm3/ADIrs/Mj70bMuX6YyaJ14Y5x5eMfdkwr0UzwT3o4/QqtaM7i5hbU1zTnJJHksvuSPgyx+vfVI/2U8/izUtlYNWbk02u7v9nen3rsW6JqSCxtqdpa07emtoLHxfmXZyUYuUmlFLLb7HpDPFbX/wCFaJ9Ct5f71eZj13jDu/0Ot27cUxFFMcoVWLj15d+m1T1qlzvxF1+Wu67N05P6JQzTorOzXeXzMbg3Q3r+t0rRKSop81eXlBdV+hpFHdrDz3O4eGegPRtDjXuI/wC93SVSefsx7RJVVXBTpDoW0smjZODFu1ynpH3n7+1KLejSt6EKFGChTpxUYxXRJFYBGc1mZmdZAAHwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAarW9EtdSg5Y9lX7VEvz8yGalomoWDlKpSc6a+3DdHSA0msNZKXaGw8bNma/Vq8Y+8JFrJrt8usOSc76Zx+hUprlW+50a+0LS7zLqWsYSfWVP3X+Bqa/BtBxfsbupF525opo1a/uvmUT6GlUe3T6p1OZbnryQ6M/eK1PZrJJP9jLjOf4hT/6GVQ4MqLPPfReeuIESN39of8Aj+cfl7nKteKMKeds43PXNZ3kS+nwdbKOJ3dVv0iiPcTWNvpeoQtaFWU8w5p82MptvH5HjK2LlYlrtbsREe19ov266uGlhc22fvPVJ467GPGW/my5bQlWuKdGllupJRXzZVU0TVOkM08uab8H6ZCnaRva0VKpV3hlfVRIii3pRo0KdGPSEVFfIrOt4OJRiWKbVEdPqorlc11TMgAJbwAAAAAAAAAAAAAAAAAAAAAAAAt1aFGr/iUoT+McmBcaFp9VPlpOk285hLBswR72JYvxpcoifbD1TXVT0lG7jhqabdvcpryktzW3Ok6jR60HJY3cNybApr+7OFd9SJpnyn8s9OVXHXm53LnpvEouEl1ysMy7XVr62f8ALuZSj/RNcyf6/iTSvb0K6xWo06i/uimau64dsKu9LnoP+15X3Mqat3c3Fnixbv2n8M0ZNuvlXDHtOJqbwrqg4f3Q3X3G4tb+0ul/Jrwk/LO5Grnhu+p70alOsvLPKzV3dpd2jTr0KlPHSXr8Ue6NrbUwuWVa4o8f3jk+djauepLoQINY65f2ySjW9tD+mpv+PUkGla/b3lWNCpCVKrJ4XdNl1hbexMqYpieGqe6WC5jV0c23q04VYOFSKlF9UyG6xbOyvpUk/cfvQ+BNCL8aNRuLd/acX+ZF3nxaLmJ2sx6VMx8+Wj1i1TFeni0/O8nqkjH59/Q2vDdhG+u5Tqp+ypbtdpPsjQsPFryr1NqjrKwrmKKdZYXM29kyqPM3jll9xO4U6cIqMKcYpdkj3lj5L7jbI3Qjvu/L90P9X5IPTo3FV4p0Kkn6RZl0NJ1Cr0o8iz1m8EuBKtbpY1M63K5n5PE5dXdDSWegwjvdVXP+2Oy+829ChRoQ5KNOMI+iLgL7E2fjYkaWaIjz7/iwV3Kq+sgAJrwAAAAAAAAAAAAAAAAAAAAANTr1Rc1KlnpmTX5Gr+Rl6rU9pfT6Yj7pi9Dmu2L3bZtc+E6fBaWKeGiDORjpuPuBWwyhdsabqX1CKf2uZ/BLJb+Rn6HTUrmdVr6kcJ+rLDZdntsy3T56/DmxXauGiZbk1XFmjw1zQ7ixk1GpKOaU2vqyXQ2oOmdFdauVWq4ronSYfNN9QrWl1Uta8HTrUpOM4v0OjeDvEKjUloFzUzzZnb57PvH9fvPPGPh9xrR1+2jhTxTuEl36KX6fcc7srmtZ3lK7oTcK1KanCWe6JOkV0ulf0ttbP85+VUfz4PpU0HHWkLVdGk6cc3FD36fr5r5mbwzqtPWtFt7+GFKcffj/AEy7o2RAyLFF+1Var6S5xpXj3dJ5TEuCyT5nzLDW2GUYzl7/AA6Em490Z6ZrUq1FfyLlupBLtLvH9SNd22tu5ynLx68a9Var6w2G1ciumKoKVWpRrQr0Z+znCSlFrqmuh2zh7UqeraTQvKfWUcTXlLujh7yl0bwTLwv1h2uoz0yvL+Vc70/Sf+pc7u536fI7KqeVXL3934Rc6xx2+KOsOnAA6GogAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANJrOq8rlbW0t+k5p9PRHuv6p7LNpby99r35L7Pp8SPOS2ecmm7wbem1M42PPPvnw8o80/FxtfTqXs4WEOYs8yyObD6mhT4rHRe5hzstwU5zUYRcpN4SSyb/AE3RlDFW7fNLtDsviWGz9l5GfXw2o5d890MV27RbjWprLW2uLmeKNOTX9T6febS30TvcVs+kV+puIxjCKjFJJdEj03rC3XxLMa3fTnz6fD8q65l11dOTCp6XZQeXRU3/AHPJeVnaJJK2pbf2IvgvKMPHtxpTREe6GCblU9ZYtbTrKqsSt4J+cdn+Bh3Gi05ZdCrKD8pbo2wMN/ZeHfjSu3Hw0n4w+03q6ekoneWtxaP+dBpdpLo/mWFVlvmT+8mU4RnBwnFSi+qZHtZ0v6PF17fLpr60f6TTNr7tV40Tdxp1p7474/KfYyornhr6tdzyW/M/vHtJL7TXzLHMsvDPeZehqnFPim6JHoWoOt/u1Z+/FZi39pG0qwjUpypzSlGSw0+6IVSqypVYVISxKLymTGzrxubWnXh0ks/BnRt29pzl2ZsXZ1qp+cfzkq8qzwVcVPSUMudLrUtWWnw355e7LH2H3+SJrbUYW9CFGmsQgsISo0pV413CLqRTSl3SZcLHZuybWBXcqo/yn4R4MV6/N2Iie5RXqwoUJ1qslGEIuUm+yR8+8YatLXOIbi/cuanLEaXpBdF6d38zpPjBrjstKhpVCX8673qYe8aa/d7fechjGUpqMFlyeEu+S9s097dN1sDgonKr6zyj2d8pT4ZaEtZ4hjVqxzbWmKlTyb7L/wB+R3E0PAeix0Th6hbuKVxUXtK7xjMn2+XQ3xjrq4pa5tvaH63KmY9WnlH594ADwpwAxbzULS1/xq0VLtFbtmO5dotU8VcxEeb7FM1TpDKBH7niCb2t6MYrs5vL+419bUbyrjnuJ/COxQZO9GFZnSjWqfLp80qjDuVdeSXuUV1kl8WW5XFvH61ekvjNEMlNzbc25v1eSlqPVxi/kVVe+PP0bXxn9mWMDxqTWNzby6V6T/50XIyjL6sk/gyCtQ7wj9xXCo6cs05OL/teD7Rvjz9O18J/Z9nA8JTgEVtdXvKOFzqpFdp/ubrTtVt7vEJfyqv9Mn1+DL3A29h5k8NM6VeE/wA0RrmNXb59zYAAukcAAAAAAAAAAAAAAAAAAAAAAAAbSWX0OT6/eSutYuq7kpRlUajjphbL8jpHEl2rLRLqu5crUGov1eyOSurzLZ8z7tmm72ZHK3Zj2z9I+6y2fb61Lqm8J5yb7gS2dzr8KjXu0Yub279F+ZGudRay2T/w1tlHT6144tOrPlWV2RRbDxu3zqInpHP4JeVVwWpnxS0AHT1EAAAAAAAAAAAAAAAAFNWpTpQc6k4wiu7Zbv630ezq18ZcINpepE61erXnz1qjnL1/YpNsbao2dEU8OtU9PD3pFjHm7z7m/r6xQjlUoufk28JmHW1S5njlqQp+aSyajmwz3mRpV/eTOvf5cMeXL90+nEopbCreXFSLTuqi+EsHlC6r0nlXlWW3SUsmvUj3PwIX/FsvXi45+MvfYUeDdW2rzg0q7jUj3ktmjc0pxqU41IPmjJZTIbHM5KCSbk8JExoQVOjCmlhRikbpu1tDJzKa4uzrFOmk96Bl2qaJjRWADaUQAAAAAA91hgAYN1pGnXO9S2gpf1QXK/wMaw4ftLS8VzGdSbi24xl0RtwRKsDGqri5NEcUd+j3FyuI01CH8bT/APqVKP8ATSz+JMCBcY1nLX6sV9iEY/hn9Sp3mr4cGY8Zhnw41uNdzPHX8Sd8M230bSaWU1OoueWfUg+k0Ppmo0LbtOW/w7nSoxUYqMVhJYSKrdPF1qrvz3co+/2Zs2rTSmHoD2WWYdfU7Gi3GVxFyXVR3f4G43b1u1GtyqIjznRAimaukMwGvjrNg5qLqSjnu4vBmUa1GtHmpVIzXozxZy7F/wDt1xPsl6qoqp6wuAAkPAAAAAAAAAAAAAAAAAAAAAABvCb8gY2qVnQ0+tUWOZRws+b2Rju3It0VVz0iNX2mNZ0aCb5qk5vq5N/ieNZLPtXjogqz8lg5HXk011TVPeuYomIXgu+Sz7fD2ih7bzSPPb0avvDK8bnQYONm5vPvzb6diP8Atn0UU23hIllvTVKhCmvsrBtO61EXb1d3/TH1RMuZppiFwAG8q9janZUNR0+vZXMFOlWg4yTPnziLT62k6vcafWi+alUaT84/Zf3H0Yc68ZdBdezp63bwbnR9yul3j2fyf5mW1VpOjZN2tofp8jsap9Gv69zReEOvuw1b+E3VR+wu/qNvaFTt9/7HYj5lozlSnCpB4nGSknno0z6C4N1eGtcP294mvaY5Kq8pLqfb1Ok6pW9Wz+zuRk0Ryq5T7f3ecY6StX0WpRiv51P+ZSf9y/c41PKk48u66/sd+OT+IukLTtalcUo4oXWZrHRS7r9TTN58HipjJp7uU/ZTbNvaTNufcjLxnGfe/I8o1JUK0atGbjOElKLXZpnj3aXVefdnkm2+VPbozSYmYnVbO48OajDVdHt72L3nHE15SXU2BzTwo1Z0byrpVWb9nWXPST7SXVHSzqWy8yMzGpud/Sfa1zJtdlcmnuAAWKOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGBrd+rG0co4dWW0F+pntpJtvCXVkF1q+d5fzqp/y4+7TXoUu3dpfocbWn1quUfn3JONZ7Wvn0hZnUlOTnJtuW7Z5zbllS8g5Z6HLZ5zrPVc6L3N6ldCE61VU6cXKUnhJGMpZeOuSX8N6b9FoKvWivbTW39qLLZWy69oX+COVMdZ8vyw37sWqde9kaRpsLOmpTSlWfWXl6I2AB1PGxreNbi3ajSIUtdc1zrIADO8gAAAAAGk001lPqgAIfrln9Cuny59jUeY+noYHN55Jjrtp9L0+pFJOpBc0PiiD8+/ocv3g2dGFk60R6NXOPvC5xbvaUc+sLylv5Eg4SusuravOMc8W/x/QjXMZug13R1ahLLxKXK/mRtiZM4+dbqjpM6T7J5PeRRx25hOCmtUhSpTq1JKMIRcpN9kiog/i/rLsdB/h1GfLXvNpYe6guv39DrURrOisw8arKv02ae+XM+LNXet67c37yoyfLTflBdP3Nz4VaF/FeIFeVoZt7P3pZ6Sl9lfqQ+MXOSjGLbbSUVvud84B0aOicOULdxxWqfzaz78z/AGWESLno06Q37bmVTs/Biza5TPKPZ3t+ACM5wFi8u7e0pudeoo+S7v5Gu1nW6VpmjQxUr/eo/EitxcVK9V1a1SU5t7tmt7W3itYetu16Vfyj2/hMsYlVznVyhuNQ1yvcNwoP2NL/AMz/AGNU5NvLZZ5t92HLbvk0HLzr+ZVx3qtfp8FnRaptxpTC9zbnvNs0WObPwCnj/Uh6Pei9z9T3m+/1LKm879S9Strqqs07erNekWZKLVdydKYmXyZiOoprqObffJ7VtLuiuarb1IxXdrYsc22c9T5XZrtzpXEx7SJiei85POw58dHhllSPFLB4jlOsPuiT6Dq7m42t1LMntCb7+jN8c758NYeMEy4fv1e2nLJ/zaeFL18mdA3b2zVkf8tenWqOk+MeCsy8fh9Ono2QANuQAAAAAAAAAAAAAAAAAAAAABDPFG/VGztrGLWa0nOS9F0/E5+pbdf9Tc+IGoK74lrRjLMaCVOHy6/iaHney6peZzDbeT2+bXMdI5fBsGLb4LULylnGd2+mDsfDtqrLRbW3xhqmnLPm93+Zyrhe2/iGvWlvy5h7ROXfCW7OyF9upj8q78+yPrP2Qto19KAAG4qwAAAAAAAAAAAAAAABquJ6vJp8Yc2HUml8Ut/0IzzbG24vrv29GgukYuTfxNE6nr1OZbzXu1z6oj/GIj7/AHXGHRpajzX856s8ct8lrm23HN6mvaJWi9zLI5vUsuXrkKWNsnx80bLR4e31OhDspc0vgln88EvI3wjS5rmtcdow5F83n9CSHTN17HZ4MVz1qmZ+32VOZVrc08AAGxogAAAAAAAAAABzTieuqnEF487Kpy/ckjpZyTUp82o3UnLd15vP/MzVN7K9Meijxn6R+6fgRrXMpL4f0va39a4fSlDlW3dkzrVYUaUqtSSjCKy2zRcB0HT0ONZretJy+XRFnii+9pcfQ4fUptOfq/8AQyY1+nZWyablUc556eMz0eblM378xC1qWq1rucoxfs6PaPd/EwFLHctOR45eRoOXl3cq5Ny7VrKyot00RpSv5x3KqNapRqqpSm4SXRox+Yc2UYKK6qKuKmdJh9mInqlujanG8j7KpiNeK6dpLzRsiB0K9SjWjVpS5ZRezJtZXEbq1p14dJLPwZ0nd7a9Wdam3d9en5x4/lVZVjs51jpK8ADY0QAAAAAAAAAAAAAAAAAAA1PFFTlsqdP+uovw3/Y2xHuLK382jR8k5FPt692WBcnxjT4s+NTxXYajmXmObYs8wcm1ucpXWi85eQcuxaU/M85vUdBstGpO41Kise7B88vl/rglho+E6P8ALq3D+0+WL9F1N4dO3axewwYqnrVz/Coy6+K5p4AANgRQtXdCldWtW2rwU6VWDhOL7pl0B9iZidYfOnEmmT0jW7rTZqWKc3yya6x6p/cSnwh1p2GtT06tNK2u17qfaouj+a2+43vjNoft7SjrdCHv0X7Ou1/S+j+T2+ZyylVlb3MKtKXLODUoteaJUTx06OmY9dG2NncNXWY0nymO/wC76YNFxxpS1TQa0IRbrUk6lPC3bXb5mVwtqlPWdCtb+nJNzhiaTziS6o2ZAv2ab1uq3X0nk5xMV493SeU0y4A87Jvr0aRTJ7vbp3JBx1pa0zXq8Yrlo137SnhdM9V95HZZWFnv2OT5FirHu1WqusTo2O3XFymKo71+wualje0LuDxOlNSWDuemXdK/0+heUZJwqwUkcEb3WdvM6P4Tarz21bSasvept1KOX1i+q+TNh3ZzOyvzYqnlV9UHaNnioiuOsJ6ADfFIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA03Ft79G050YyxUr+6vh3IU5ZXkjZcWXf0nWZwi8Ror2aedm+5qefC6nL94Mz9Vm1RE8qeUff5rvEtcFuPGVzm7nrl0WCzz910Pc5aS88FHEdyS3/AApYq7vHXqRzTo4fxfYmZg6HZxstNpUkvea5pvzbM46tsXAjCxaaZ9aec+39lFk3e0rme4ABbMAAAAAAAAAAABzzVqat9TuaKxhVG0vR7nQyEcZxjT1dyWznBN+vY1fey1FWJTX4T9U7Aq0uTDVczSK7er7K4pT/AKakX+JjqTffY8lJtJY3yl+Jz+zM03KZ84WsxydSW6TOP+NFOUeJberzPllbLCzt1Z1+n/hx+COUeNzX8YsUo5fsG3/1Ha7XrQx7tTptCn2T9Gk8L9F/i3E9Kc45t7VKtVz3x9VfN/kdzIj4U6Q9N4ZhcVYpV7x+1l/l+yvu/Mlwrq4pYtv5v6vMq06U8o+/zCNcQ66lKVnZVPezidRdvRHnFGuRhzWNpU9/pUmu3oRRSytuhpW39vTRrj488++ftH3RsTF19Otd58vLy33PeddHuWefPqHLvnY0WVnovKXfJ5z74yi1zdctIu2lGtdV40KFPnnLyPtNFVdUU0xrMvk6RzlVHmnU5YRcm9ljc32l8O1q8Y1buToxe/J9p/HyNvoejUdPhzzxUrvrLy+BtTedl7r0U0xcy+c/6e73qy/mz0t/FiWenWdpFKjQjlfaay/vMsA263aotU8NEREeSBNU1TrI0msMivFmnQt5K9ox5YyeJxXRPzJUYeuUvbaRdQXX2ba+K3IO1sKjLxaqJjnEax7WWxcm3XEoAp7/AA6jm7dS1zLl23bPObCOS6L5eUvXY2PD967XVKbcv5dR8sjUqXQc2Oj77Mz41+qxepu0dYnV5roiumaZdQBi6RcK60y3uM5c6az8e/4mUdit1xcoiuOk82vTGk6SAA9vgAAAAAAAAAAAAAAAAWL+4ja2Ne5m8RpU3J/JF80PiBWlQ4Qv5xW7go/e0jDk3Oys1V+ETL3bp4q4p8XIa9w7mvUrVHmU5uT+bKIyxhro2Y0ZZW6698nvPhddjkdUzVOsto005Jl4b3dhZX1e7vrmNHkp4gpPrlkwuON9ApRyric32UYPc49Gb5d9vTuU8+Pdf2t8l1h7cv4dmLVumEW7g0Xa+KqXVJ+Immb8lpcy+OEYlx4i4lihp2V2cpnOJT6x9dypVMY+r6H2veLPq6Vae6HyMCzHcndXxFvpNqlY0F6uTZjT4+1maxGNtTf+XJDZTfPly9T3OWsPD9SPVtrOq/7svcYdmP8AFK/9uNfcmlWpf/6kUS4119v/ALXBfCmiLczb7LHU951y5wYv+J5k/wDdq+Mvf6az/phJqnGXEE0sXvL/AJYR/Yqjxjr3Kkr3L9YR/YjCkuud2e82OnTvk+TtLM/8tXxk/T2v9MJSuNNfW30mEvPNOP7Fa441/H+NQ7f8JET53l77423PYzyk47PufY2pmx/3avi8/prX+mEypce6vDClSt6mfOOPyMu14+vp1adOdhQbnJR92TIJ7TDSf4m14PpfS+JLSgsf4ik/luS8baufXcpoi5POYjuY68WzFMzNLtEG5QjJrDazg9B5JqMW30SydI6NfQriOv7TWKyTyoYj80a3mys9GU3Fd1rirWznnm5fJstqW2Tjube7fIrueMy2G3Tw0RC9z7nvMsbbFjPTLwxzb+hFe9F/mHN8yy3l5226DPYaPia8I01HSvapNOpNvf7jcGLpNF0NNt6T6xgs/EyjsWBZ7DGt2/CIUF2rirmQAEtjAAAAAAAAAABRXlyUKk/6Yt/gccTdxcPkk26kvzZ13Vaipabc1JPCjSk/wOW8J2/0viG1pYbip88l6Lc1HeWib16xZjvmfnoscGYpprql1LT6MbLTKNHCSpUknj0W5BrmtKtcVKspOTnJvdk8vs/Qq+Ovs5fkc4clt+hF3uqmimzajpz+0PuBGs1VL/NjZt4Cluywp9uw5sZNL106LLRf5+6PebsWFLuhKXr8WfIfNF5Tx13JPwbcOdvXoS+xJSXwaIlzYXckPA8v96uF/YvzL3dy5NvaFER36x8kbLp1tSlYAOoKUAAAAAAAAAAAAAAAAAAAh3E1Vz1apHP1EkvuJic91Sr7TU7qeetWXT02/Q1Xe27w4lNHjP0hNwada5lTzLPYKT+BZ5vPGRzrbJzzRbL3N08j1ScpKMU3JtJJeZY598ZNtwva/StTjUlF8lH338exJwsarKv02Y75eLlUUUzVKWabbq1sqVDq4x3fm+5kAHYbdFNumKKekclBM6zrIAD2+AAAsX9tSvLKtaVoqVOrBwkn5M+ddZsaumapc2FWLhKjUcVnuux9InLvGjRlCrQ1ulHapijW+K+q/wA19xltVaTo2fdfO7HImzV0r+sMfwW1b2GoXGkTqc1O4XtKfkprqvmvyOsnzbpl3W06/o3lvJKdKSqJJ9d+h9FaZeUdQ0+he281OlWgpxa9Rdjnq+704XZZEX6elX1hHPE3S/puhO8pxzVtHz9Psd/3OTtp9OvY+gasI1aU6c0nGcXFp90zhuu6dPS9WubKSeKc/dfdp9PwNE3ow+G5TkR38p9vd/PJA2be1pm3Pc176bpb+ZseFr+Wl69bXnN7kZ8tTfrF7M1vfDS2RSm0+SOyZq9m7VariunrHNZVUxVTNM976GhKM4RnF5jJZT9D0jnh3qn8S4cpRnPmrW/8qbffHR/cSM6xjX6b9qm7T0mNWr3KJt1zTPcAAzPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABZvq8bazrXEulODkXjR8b3HsNBqRXWrJQI+Xe7CxXc8ImXu3Rx1xT4oE6kpTlUf1m25erZ455ec9i0p+Q58PfocdnWqdZbJELrk+6Nrwvaq71ijBrMI+/L5GlU8756MmHh3Qyrq7afaC/N/oWWxsaMjNt0T011n3c2DKq4LUyl4AOsNfAAAAAAAAAAAAAAg/Hkl/F6a/8ACX5snBz/AI6rRnrsowe8KaizXt550wJjxmE3AjW603OupfsF7a+t6aWVOrFfiYbmvn2N5wVbfSdbhP7NGLm9u/Y0HZ9ib2Tbo8ZhbXaooomqXQlsjm/F+k1+JPEG2sFzK2tqcZVprtHOWvn0OkFmja0KVxWuIU0qtZpzl3eFhHX4mY6KjCy6sSublPXSYjy171ynCNOnGnBKMYpJJdkaTivWVYUfo1B5uai/6F5s2Os39PTrCpc1N2l7kf6n2RzO6uqt1dTuK8uac3ua3vDtb9Ja7K1Pp1fKP50fcPH7Sriq6Q9lNuWW8yb3yG8d1uWefDa2wec3c5xPPmudF7nSeRzZyl/8lrmxjc859uUaPujLtqdW5rQo0YuU5bJI6DoOlUtNtksKVaS9+f6I1vBWkfRbb6fXX86qvcTX1I/uySHQt3tjRj0RkXY9OenlH5lT5mRxTwU9AAG0oAAABbu97Wqn/Q/yLhj6lP2enXNT+mlJ/gzxcnSmZl9jq5dCfLTjh5WFjJUpYbXQsw2pxi3lpYz5nvPlpP5HGJ68myxC7z9uh6pZWzwWFNZz1PXLv1Pmho6BwTVU9EUM55Kkl+v6m8Iz4fT59PuFjpV/Qkx1jY1fHgWpnw+nJQZMaXaoAAWbAAAAAAAAAAAAAAAAAGo4ztpXfC+oUYrMnRcorHdb/obc8lFSi4yWU1hox3bcXLdVE98aPVFXDVFXg+cOffZ5x2wVt4TbksvsbrjzQqmi67ViotW1dudFpbP0+RH0kn0ztnHqcov2KrF2bdcc4bXRVTcpiqnpK7zPpjPmyqM5OSUVu3jqWW+aPwWfU85sJNbPOVjojDo9aapbacE8RV6cZwtqfLNJqcqqxg2VHw31ecI+0u7Om++8m1+BrOEuNtQ0VKhcN3dmmk4P60P8rOoaBxHpOtwTsrle0ay6Utpr5G2bMwdlZdMRrPF4TP06aqnJvZVqfLxRG18NJYzdaom//Dp/uZtLw405NOrfXM/gkicAv6NhYFP/AG/qgTm35/yRKn4f6FH630ifxmXlwLw8utvUl8ajJODPGy8OOlqPg8Tk3v8AVKNw4H4cjn/c5PPnUZdXB/DySX0CO39zN+D3Gz8WOluPhDz293/VPxaP/ZLh/CX8Pp7erKJcHcPSWPoKXwkzfg+/oMb/AMcfCDt7n+qUanwPw7KSf0SafpUZlaVwtpGmX0Ly0ozjVgmk3PPU3YPlOz8WmqKotxEx5E37kxpNUhha7WdDR7qopKMlTaTfm9jNI/x3W5NIhTzjnqLPqkNo3uxxblfhEvlmniuRCFqWMYaSHNnHmWU5f0+oUts9zkDYtF7m2we82/Us8zyHLD9A+aLqlv8AqX7Gm7jULe3W/PVint2zv+GTDUtm8N5N3wXSdbXYT+zSjKb+7C/MmbPsdvlW7fjMMd6rgomU+SSWF0QbSTb6IGPqftv4fcfR489X2cuSPm8HXqp4YmWvxzlGaPHul/TKlC6p1aMYTcVUS5k8P03JHYanYX8FOzu6VZNZ92W/3HELzTtSt5zlcWdel73vNwePvLFCvVpT5qVWdOSe7jLD+80i1vLk2auG/RrHwlcVbOt1xrRL6BByLSOONZsXFVpK7orrGr9b5MmeicdaPqGIV3KzqvtU3i/mbBibcxMnlxcM+E/nog3cK7b56awlQKaVWnWpqpSnGcXunF5RUXETqiAAAAADV8WyceG79r/uWRHwttPaXtxfSW1OHJF+rJLx7V9lwrePzil+Jb8PrFWXDdGTT56/8yWfXp+BRZFnttq257qKdfnpCZRVwY1XnLfV4e0ozh/VFr8DmdSMqVWcJ9YScWdPIHxjZytNTddR/lVt0+yfdFfvZizXYovR/jPP2S94FelU0+LUue245sd9iw57PLbPc+e3zNAW2i/zvZt/cOb0yixzeXc95kljLPupovOTzhko4Dpybuq7WI+7BfHq/wA0RGMnmKWXnY6Nw5ZOx0qlSmv5kvfnt3Zsm6+LN3M7Tupj5zyQ86vht8Pi2IAOjqYAAAAAAAAAAAAAAAAAAFNWXJSlP+lNnMnUlUk5yWHJtv4nRNZqey0q6mnjFKX5HNef5PyNG3wr1qtUe2fos9n08qpXVLyeGFJdcllSXVvAcuy2NMjyWWi8312XoTvheylaaZCVSOKtX35Ly8l9xEuGbH6fqUIS3p08Tn8EdCWywjdt1MD1sqqPKPvP2+Ksz7vSiAAG7K0AAAAADWcU6bHV9Bu7CSy6kHyf5luvxNmB0e7dyq3XFdPWOb5nqU50ako1Eo1IScXHyaOq+C2ruvptxpFWS57aXPT8+WXX7n+ZFfFfR3p3E07iCfsbxe1j3xL7S/X5mu8PtXWk8UWtaTxSqS9lU/yvv8mSao46NXSc+inamzOOnrprHtju+sO/HPPFrTMTt9Vpx6r2VRpdH1T/ADOhmu4msI6lod1aNJuUG4Z7SW6KfaeLGVi12+/u9sOdY13srsVOGS8o+9juUbvtlouSjKEmpbSWzRRj3U5bN9TlmmjZUu8KdS+i65KzlL+XdRwv8y6fqdYPnywuJ2t3RvKL5Z0qinH5Pod80+5heWNC7pv3KsFNfNG97sZXHYqsz1p+k/updpWuGuK/FfABs6tAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIf4l1mrezop9ZSk18F/qTA5/4m1X/F7Sl9mNBt/OX+hS7wV8Gz6/PSPmlYVOt6EZ599gmuy/0LUZtJeZ4p/wBWdmcw0X69ztZOlcDQ5eHqMsY55Sl+JzCUs9X12Os8MR5dAskv+6RtO6duJyqqvCPvCv2jP9OI82yAB0BTAAAAAAAAAAAAAAcs4muFV168lHf+ZjPw2OlapdQstOr3VR4VODfz7HH69Wdacqknmc25N+reTT97b8RRbs98zr8Fns2jWqal6M8Sx1OhcC6fK00v6RVjipcPmx5R7ET4S0aeq3yqzi1a0mudvu/I6ZFKMVFLCSwkYd19mzxTlVx5R95+z1tC9GnZx73obSTbeEurBGePdX+hWH0KjLFausSa6xj3NtzMqjFs1Xq+kK61bm5VFMI1xdqz1LUWoSf0ajmMEn182aZySfVv9CzJxi+V5DkliP3nJsrIrybtV2uectit24opimF/Oe7fc85t3LsWU9shtYW++Ohg8nvRec8tvJvuDdKWo6j7aqm7eg1KXlKXZEdowlVqxpU4uU5tJLzZ1nQNPhpumUrdJc+MzfnLuX+72zf1eTx1x6NPP390Iebe7KjSOss9JJYXQAHSlEAAAAABqOMa/sOHLt5w5x5F83g25EvEm5jCxoWrfvTnzfJFftW/2GHcr8p+fJmx6eK7TCEqXx6dRKTW+clrnz13fkeOfd5OStjX3LGHlsc0sZS/EtZ93D+J4prqnhh80dC8O4yWlVpy+1V2+4kxpOB6TpcN27ceV1Mzx8Wbs6zsm32eFapnwj582vZM63ap8wAFiwAAAAAAAAAAAAAAAAAAA1nEmi2mu6ZOzuo4fWnNdYS80cY4h4a1TRa8o3FtOVJPatBNxl+x3o8nGM4uM4qSfVNZKjaWx7Od6U8qo7/ymY2ZXY5dYfNqeG8rLbMzTdI1PUUo2djXq52yoPGfid7WlaYqvtVp9qp+fskZcIQhHlhGMV5JYKe3urGvp3OXlCZVtXl6NLkOkeHGs3HLK9qUrSHdN8z+5Ez4Z4F03RbyF77evcXFN5hJvlS+S6ksBc4uxMPHmKqadZjvn+aIV3OvXI0meQAC2RAAAAAAAAAAACF+ItxL6Ta2yzyqLm/yJoc245uFV4hrRUsqnGMMeW2/5mv7zXezwZp/1TEff7JmBTrd9jUxl1fVnnMlLL/Ms82G3lYPObmecL4HNdF5ovc3qe8z3w3gtczxlYHPts8Nd2fdBd5lnuvgTHw6orF1ctPOVBP8SE8+Xv1Oj8B0XS4fpzksOrOU/lnH6GwbsWe0zoq/0xM/b7oefVw2tPFvgAdJUbycIzWJxUl5NZNRqXDOiahzOvYU1N/bp+7L70bgGO5Zt3Y0rpiY83qmuqmdYlz3VPDWlLmlpuoShnpCtHmS+aI1qnB2u2Cc/orrxj9qj723w6nZwU2Ru7h3vVjhny/CZb2hep683CdO1jV9FuOW3ua9GcetOa91+jTJzoXiNa1uSlq1B283t7WDzF/LqiZahpmn6hTdO8s6NZP+qO/39SH6v4badX5p6ddVbWTz7s/fj+5Co2btHAn/AJa5xU+E/wA+7NORj3/7lOk+KaWN5a31BV7S4p16b+1CWS+chegcXcNXH0mxjOpGL3dB80ZL1j3JFw/4h0KlRWut0XaVls6ii+XPquqLDH2xTrFvKpm3V59PiwXMOdOK1PFCeAt29ejcUY1qFWFWnJZjKLymXC5idecITR8bUKl3pMLOmm3Xrwg/RZ3Nzb0oULenRprEKcVGK9EsFbSfVJ4BipsxF2q53zER8Hua5mmKQxNVsaOoWc7eslv9V/0vzMsHu5bpu0TRXGsS801TTOsOWapY3On3DoXEGn9l9mvMxHPHTHzOr31nbXtB0bmkpxf3r4MjF7wXTll2l5KHkprOPmaFn7r36K5nH9Knw74/K3s59FUaV8pRDn6tocy6LOeyJNR4LunJe1vKaj35U2bzSuGdPspxq1Iu4rLpKfRfIiY+7Wbdq0qp4Y8Z/EMlebapjlOrT8H6HUnWhqN5FxhHenBr6z836EzAN92fgWsGz2Vv3z4yqL16q7VxSAAnMQAAAAAAAAAAAAAAAAAANdxK8aDef/jwc15pPLbOkcVJvh+8wsvk/VHMOZSznY0De3/qqP8A5+8rfZ0ehPtXubK2/wBBlt7fJFjm3x1N/wAE6b9P1D21SObe3abfnLsjXcPFryr1NqjrP81TrlcW6ZqlLeFNO+gabGU44rVven6eSNuAdaxsejHtU2qOkNcrrmuqapAAZ3kAAAAAAABD/FfRp6pw6q1CnKdxaT9pFRjltdGji04VIN06kZ05eUlhr7z6ZMDVtG0vVaLo6hZUa8fWO6+DW5koucPJsmyNvzg2+xrp1p198MLgTU3qvDFpcTnz1Yw9nVfnKO2fmbw0vDPD9LQHXpWlxUna1GnCnPdwfxN0Y5UeXNqb1U2vVmeTjXHunfw/iS4pxjy06382Plh/65I/5rLePM6f4s6eq2mW+oQj71CfLN/2v/X8zl/XthI5jtrG/TZldMdJ5x713iXO0tRKiW2YpYS7M614V6g7rQHaTlmdtPlS/te6OSVN8b5x3RLfCu++i8TfRpT/AJd1Bwx/ct1+Rk2Dk9hm069KuXx6fN8zrXHZny5uugA6U10AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA5x4ntrXqPZfRY/+qR0c5n4qSxxDQW+9rH/ANcjX95v+gn2wm7P/vQjXM455m2xzLL6vuWMvqFNfE5vovtF5Twu6y/uOx8O4/gdnjp7GJxZTWN3k7LwrU9pw7Yz86KNt3S/v3PZ91btOPQj2tmADe1MAAAAAAAAAAAAAIP4j6spuGk2825JqVXl/BGq4c4Wv7+pCtcRlb2uU25bSkvRHQ6WnWNOtOtC0pe0nLmlJxy2/MyjX7uw4ysqb+TVrHdEdNE6nM7O3wW496xY2lCyto29tTUKceiX5l8AvqaYpiKaY0iEKZmZ1lbua1O3t6lerLlp04uUn5JHH9X1KtqWpVruo378vci39WPZEz8TdU+j2VPTqcvfre9Nf2rt8znUZPOcYxuaLvTnTcuxjUzyp5z7Vvs+zpTNye9e5pNPdCMsbZ+BZ9osb/eE3t0Rqeiz0XuZprPd9j3m8nl92WebHRsU05S5YbvOMLv6DQ0THw5013Ooyv60P5dusQz/AFHRDWcL6etN0W3oOPLUceap/mZszqmx8KMPFpo05zzn2y1zKu9rcme4ABaI4AAAAAHLeOdQ+ma/VUJJ0qC9nHfq11/E6BxLqMdM0avdNrnUeWCz1k+hx2dWVSUnJPmby/Vmob15elFOPT1nnPs7lps21rM1yvcz9UjzmzL3mmiy5Yj5JhyxjlSk30NG08FvovqeHhvr2KqSlVqwpRacpPCSMb2mfL4kg4Dsvp3EFKTWYUP5kn8On4kjEx5yL9FqO+WO5VFumap7nT7CirayoW66U6cY/ci8AdfppimIiO5rMzrOoAD6+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADeFlnHNWuHc6pd3Dlnnrza37czx+GDrGs3H0XSrq4xnkpSa+44zz5e3U0ze29yt2485WuzafWqXVJdU8Z36FXMm2395Yk9t3jywU87zu8o0nRashTe/XHRYCqNrfBY5mopv8BzrK95n3Q0X+bot+v3nYdHofRtLtqHeFKKfxxucl0Oi7nWrOi03zVo5Xonl/kdkN13Rs+jcu+yPuqdpVerSAA3NVgAAAAAAABrNY0HStWhi9s6c5dppYkvmjZg8XLdFynhrjWHqmqaZ1iUOocMapolX2nDuor2P2ra43i/n2JXYzuJ2tOV3SjSrNe/CMspP4l4GGxi0WOVvWI8O73eD1Xdquet1AASWMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABruJYynoF7GKy/ZPByfmXJ1ydkvKftbStS/rhKP3o4rKUoycZLEk8Nepo291vS7br8pj4f7rfZs601Qy7SlUubmFtRy6k5KMcdzq+i6fS0zT6drSS23k19qXdkf8P9Gdvb/xG5p4q1F/KTW8V5/MlpZ7ubL/AE1rt7kelV8o/dHzsjjq4I6QAA2ZAAAAAPJSjGLlJpJLLb7Aemp1riDT9LXLVqe0q/8Ad0938/IjHFXF0qk52mmVJQpraVZdZfD09SHupOTk3JuT3be/MaltPeam1M28bnPj3e7xWWPgTVHFc+CX3fG17Uli1t6VKPbm95muqcV63KeVdqK7pU1g0Ep7rdnvPsatc2znXJ1m5Pu5fRYU4tqnpSk1txjq1Nr2jo1lF+9mGMki0fi+wvJxo3S+i1JdHJ+6/n2Ob8zfVtoKeXnHRbYJGLvDm2KtZq4o8J/mrxcwrVcdNHbU00mmmn0aBAeBOIZ07iGmXk805vFKTf1X2XzJ8dA2dtC3nWe1o98eEqa/Zqs1cMsLXLON/pFzaSWfaU2lt37HCKlOVOrOnLClF7rO6wfQhxbj2w+gcT3VNJqnUaqw27P/AFya/vVja0UXo7uU/ZP2Zc51UI+8RlnOOhf024dpqFG6pT9+lUU1jzRZmkk1v6bFLTTypLdfeaZTM0zFUdVxMaw+hbOvG5tKNxBpxqQUlj1RdI54c3FSvwtbxqwnF0swXMuq7MkZ1rGvdtZpueMRLVblHBXNPgAAzvADGu9QsbRZubqlS9JS3+40V/xrpVDMbeNa5l2cY4j97Il/Oxsf+7XEe/7MlFmuv1YSYHPrvji/nj2FCjQXrmTZqbjiTWbhPmvakU+0PdKa9vThUeprV7vylU7Puz15OrSlGKzKSS9WY1TUdPp55762jjrmqjkdS8uZv+ZcVpPvmbeS1zY9GV1ze/8A0WvjP7M9OzfGp1WtxJolKXLLUKbf9qb/ACRblxVoaX/bG/hTl+xy3nw31znbB65euPMi1b2ZU+rRT8/yyRs233zLqEOKtClHP0zHxpy/Yv23EOi3EnGnqNDK7SfL+ZyiMln4eZ431cXj4n2je3Jj1qI+f5fJ2db7pl2ijXoVlmjWp1F5xkmXDi9GvWoTUqFSdJt592WDcabxZqtpLE6v0iO3u1N/xLHG3ssV8rtE0+zmw17Nrj1Z1dQBHdD4t0/UHGlXza139mb91/BkiTTWU8o2bHyrOTRx2qomECu3VbnSqNAAGd4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOY+LEscQ2qa/8AtU0/hJ/udOOd+MNNRq6fXWMtThv36Mo94qOLAr8tPqmYE6X4QRSxnGz8me80V2aLLeW2l8mU8zeO5zVsWjIjJ9M7Ludg4ArOtwraN9Ypx+5nGefMtnjJ1HwlvPb6HXtm96FX8Gv9GbHuvc4MyafGJ/Kv2lTrZ18JTMAHQ1CAAAAAAAAAAAAAAAAHlScadOU5tKMVlvyR6RjxJ1J2HD06UJYq3L9mvh3Zgyb9OPZqu1dIh7tUTcrimO9zriPUqmq6vcXmdpS/lryiuiNe5rCecssp+8uqx5jMvhv3OSXblV2ua6p5y2mmiKYimO5dz7v6jmljOcFnm5njO577RYSwm8dUY3rRec9sLou/ckHAenrUOIKXPFulR/my8tun4kZb5cb59TqPhXYex0ad/JNSuJYjn+lbfnktth4n6nMpiekc5937omZc7O1Mx3piADqDXAAAAAAANPxfrNPRtIqV8p1ppxpRzu35/Ix3r1Fm3NyudIh6oomuqKY6yhniZrKutQjptCT9lb71Gu83+yIfTb5+bPT8S3XrzrVpTqS5pzbb+JSnhZlnPTByjOy6sy/Vdq7/AKdzZrNqLVuKIXnP0yhGW22P3LLmvNJI8U932RD7mXhZHMt+22UdT8OtK+gaMrqrDFe695+ke37nPuDdLlrOs06DT+jw9+o/JI7PCMYQUIrEYrCRuO6+z9apyao6co+6q2le0iLce96ADdlOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACP+IVw7fhi4w95tQ6+pydSxLO2cnQvFqtyaXaUVLedVvHnhHN4ySeO3kc73nucebw+ER+V7s6nSzr4yvObT9M75HMt0viWZTWcLOO4ym1nBriw0XYy391/E95srzwWE1jOcJ9z2MlHDjnC65PpolfhzRdfiaFSWM0oOf6fqdTOf+ElGMne3ON1iCf4nQDpG7dns8GmfGZn7fZr+fVremPAABfIQAAAAbSWXsgAMaWoWEW1K9t011TqIro3VtXeKNxSqPyjNM8RcpmdIl94Z8F4AHt8AAAAAAGq1fiHSdLTVzdw9p/3cXmRFtQ8REpOFjYc3lKrL9F+5X5O1MTGnS5XGvh1n5M9vGu3PVhPgcnvONterv3a1KguuKVP98mIuLdfj11Go9u8V+xVVb04cTpEVT7o/KVGzbsx1h2MHLdM491ehJRuY0buC65XLLHxRPuHdcs9btXVtm4zg8Tpy6xZY4O2MXNnhtz6XhPVHvYlyzGtUcm0ABaIwAAADaSbbwl1ZBOL+NfYudnpLTktp1+y/wAv7kPNzrOFb47s+zxn2M1mxXeq4aUs1XWNO0yGby5hCXaCeZP5EWvvECks/QbCVRdOarPl/BZOfVa1WvUdWrUlOct3KUstlLn05tl5GlZe8+TcnSz6MfGVtb2dbp9bml1TjrWJv3IW1JP+1vBTHjnWk9/o7Sf/AHfX8SJueE4vojzmylldSsnbGdM69rKRGJZ/0p3Z+INdYV1p8JrvKnPD+5kk0rizRtQahG49jUf2Kqx+PQ4+t8NJeZ6pNvpv+ROx95c21PpzxR5/sxXNn2qunJ3xNNJppp90DknDXFd9pVaNOpOVxat705Pp6p9jqGlaja6naRurSopwfXzT8mbjs3a9jPp9HlVHWJ/nNU5GLXZnn0ZYALVGAAAOf2fDVS44wvI1oSVnTquq3jaWXlROgAg5mBazJo7T/GdWa1eqtROne8jFRioxSSSwkj0AnMIAAAAAEG8RNf5JPSbWbTxmvKP/AKSVcQ6hHS9IuLyTWYR9xecuxxivXqVq0qtWfPObcpSlvls1feXaU2LcWLc86uvs/dY7Px+OrjnpCpN9gp529CxGbUtsPyR7z5979Dn+i60X4zymuvr5FMpd8lrLy1k23CumLWNXp2cs+zXv1Wu0UZrFmq9ci3RHOeTzVVFETVKzZ2F9eRzbWtWovOMcoouLa6tZ4uaFSk87c0WjtNtQo21CNGhTjTpxWFGKNfxNpNLV9Kq28or2qWaUu8Zdjbbu6cU2ZmivWv2clZTtLWvSY5OQwnKE1OM+XleU/Xsdm0S7V9pNtd96lNN/HucTqc0ZOEk8p4ydc4F//Vez/wAr/Mxbp11RfuUd2n0etpUxwUy3hz7xfsFKNnqEcJxzTk/xX6nQSxe2lreU1TuqEK0IyUlGaysrubbtDE/WY9VnXTVW2LvZXIrcb0LhXVtYnzUafsqD61aiwl8PM6Dw/wAD6TpvJVuI/TLiO/NUXup+iJTCMYRUYxUYrZJLoYeq6rYaXRdS9uYUvKOfefwRX4mxcPBp47nOY756fhnu5l69PDT8mZCMYRUYRUYroksJFq6ura1p89zXp0o+cpYIFrfHlepmlplFUYNf4tTeT+C7EQub25vJyq3VepVm31k8kTN3nx7Po2I4p+EMlrZ9dXOvk6LqvHFjQlKnZUpXMl9tvEf3ZFNR4q1i9bi7l0YP7NJYX7ke53jy9A5752x1NXy9t5uTOk16R4RyWNvDtW+kasidSVR885yk+uZPLZ4nnKbMd1Nur28irmxu3nL236FROs85SdOS/GXb7jxyTxjqmWebGZdPgIz2x9580NF2MtstroVKSXXf4GPCbabb26CUt8cySGhov86fXbHQJ+rLDnmONv2PVPfCbzjqNDRfdTcc+yzn4osKXZZ9TyUsb5wfYg0ZHPnZfezxze7SzjsixKa5W0238T1Sws7LIiDRdjLbfOSScNcV3Wm1IUblyrWj2w370PVfsRWT6d316lUZ8qXXPoScXKu4lztLU6T/ADq8XbVNyNKodxsbu3vbaFxbVI1KcllNF45JwfxDPSL6KqNu0qvlqR8n/UjrNKpCrSjVpyUoSWYtdGjpOydp0bQtcXSqOsfzuUGTjzYq07lQALVGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACF+LlFS0GhcY3pVlvjomiaGl43tJXvC1/RgszVJzj8VuQtpWe2xLlEd8SzY9XBdpnzcPdV53yn8Op5zLLXTPr1LKm3hvzw3kOWXlbR7ZOUaQ2rRfT6NrsTPwlvo0OIKtq3lXNLC32Tjuv1II5+TabW5l6PfOw1Whd0nLNGant3XdEvAyP02TRd8J+XexX7XaW6qX0OC1ZXFO7tKVzSkpU6sFOLXk0XTrETExrDVJjTkAA+gAAAAAAAAAAAAAHIPE7VXf8RTtqc37K0Xs0v7usv0Oq6vdxsNMubybSVKm5bvvg+frmtUr3M7meZSqScpNvuzVN6crgs02In1uc+yP3Wuy7WtU1z3KnLmWFttv6HnN2b6ooT97m2Sxk8UstNZSf4Giwu4XVNtqT7dvMScZdWvkWefmit3s8Zx1PHJYaaaXYaPrLt4VK9zTo0/rVJKMe+d8HfNKtYWOm29pTSUaVNR288bnHfDSzd7xVbZTcKOar222O1m8bq43DarvT3zp8FHtWv0oo8AAG2qoAAAA8lKMYuUmoxSy2+wFF1XpWttUuK81CnTi5Sb7I4pxbr1XW9Wncc0lQj7lGm+iXn8WbTxF4req1/4fYVf9ypy9+S/4j/Yhjk8rZYW5oO8G1oyauwtT6MdfOfxC+wMTs446+sr7n7uWnlfgxnK3WV8SxzLKcltj7zzmTfMu5rGiy0X+fKWMLyPaWalWFOEOaUpYil3Mfn6LbC/94Oi+F3DXtJR1u+hmC/7PCS6v+om4GDXmXotUe/yhhv3qbNE1VJXwPokdG0eMZx/3mt79V915L5G/AOpWLFFi3Tbo6Q1i5XNdU1T1kABmeAAAAAAAAAAAAAAAAAAAAAAAAAAAAYWq6tp2l0fa311Torsm938F1IdqXiVZ0242FjVrf3VHyr7iFk7QxsXldriJ8O/4M1rHu3fVhPgcoq+JGrzm/ZW1tCPVJxbZRDxI1mE8TpWs11+q0Vs7y4MTprPwSf8Aht/wdaBANJ8SbSpLk1K0nRWcc9P3l80TfT7601C2jcWdxCtSl0lF/n5Fni7Qx8uP6NWv1+CNdx7lr14ZAAJjCAAAAAOX+L10p6xbWq39lSy15OT/ANCFuo+T623bzN34h3cbnjC9az/Kapr5JfqR3m6ZW/mcr2vc7XNuVef05NnxaeGzTHkv80ntnK8hzS5c7ZLDm0stZedsFWWsOTymVyRpouqS7vC64PObOd8vyZZhKWedrHme875nJxwDR1/wtt/Y8MKo1vWqyl8lt+hKzWcK2v0Lh2xtm8uNFN/F7/qbM61gWuxxrdHhENVv18dyqrzAAS2IAIL4hcX/AEHn0zTan+8Y/nVYv/D9F6kXMzLWJam5cnl9WWzZqvVcNLZcWcYWmj81tbKNzdrZxz7sPi/0OcazxFq+qzzc3s1DOVTpvlivu6/M0tSq5y5pOUm98vuylzWElLfPmc7z9s5OZVPPhp8I+/i2DHw7dmOms+LIc+qztndlyjc1qMlOjVnCfZwk4sxOfO3kFLMvLC2bKmJmJ115pUxExzT/AIS45uKVenZ6tP2tGTUY1n9aPx80dKi1KKlFpprKaPneU2llro+x2Dwy1OWo8OQp1JN1LZ+zbfl2N23c2rcvVTj3p1nun7KbaGLTRHaUx7UpABtypDm3iNxLf0tUraTaV3QowilUcdpSbWcZOkSajFybwkss4JxBeSvNavbib5vaVpOL7Yzt+GDW95cuuxj00UTpNU/KFjs2zFy5MzHRZnUlLeUuaWfrN5eTzneNtu7b7llSy9m9+uBzNrpk58vtNF9zbTin8Q5Plw+22Sw5pNLHqeZztnbO+RoaMiU3zbvCx0On+E9tyaPXu5JZq1MJ+iOVtrly98fdg7hwbaKy4ZsaKhySdJTksd3uzZN1rHHlTc/0x9VbtKvS1EeLbgA6CogAj/HWuLRNHlKnJfSa3uUl5eb+RhyL9GPbquV9Ie7dE3Kopp6yjviTxO1z6PYVcPOK84v/AMpz9tp7vKaLU6snKU5y5pS3y+7KVJ45ln4eRy3aGdczb03a/dHhDZrFiLNHDSvuSxy52CmkvMtc6k0mtzxT5MYe7IWjNovOeFvJNJ9BTftJYgnv0wsv5FmMotvq9+x0Hwr0NVubWbqCaTcaMWurXWRNwMKvNvxao9/lDDkXqbNE1S1FPg7W5adK9lRjHEXL2cniTXwI5zvdN/HJ9AtJpp9GcD1uHsdavaS6RrSS8urLbbmyLWDRRVbmefKdUTCyqr8zFSzzNJPbD2N7wfxBV0bU4ybbtaj5asf1+KI2pc7j6eZU5cye/QorF+5j3IuW50mE65bprpmmp9C0qkKtKNWnJShNJxa7oqIf4WalK70N2lWXNUtnhZefdfQmB1bDyacqxTdp74avdtzbrmie4ABJYwAAAAAAAAAAQLxbv3CjaafGWOZurNei2X6nO3Pm3W0e5JPFK4nV4pqUnLalSjFL5Z/UisZ7rdY8zl+2703s65PhOnwbLhURTYp+K/GeXlNN9Dzn3xnbPRFqU3HEuXP6njlsn2fkVWiVpDIbT3RNfCPE9XvW3lwoRSePOX+hA8vLxnJM/CKp/wD1DcRzjmtunniS/ctdhzEZ9vXx+yJmx/QqdTAB1BrbiPFUY0+JL+lTxGKrywl8cnXuG7Z2ehWdvJYlGkub4vdnN9I0yfEXGtzcrP0WFy6k5dmlLZfPB1jaK8kjVt3sbS5eyNOUzMR8Vnn3PRot98dQsX15a2Nu693WhSprvJkZ4o42sNMc7azcbq6XXlfuQ+LOa6xrV/qlw617XlPyj9mPwRJ2lvBYxNaLfpVfKPbLHj4Fd3nVyhMeI/ECpJyoaRT5I9PbTWX8l2IVdXVe5q+1uK8qs5byc3lmJzPPN+AlLLWfgaPmbRyMyriu1a+Xd8F1ax7dqNKYX+ZNN56dGIvPft0LDnFrq0z2k5znyU8ynLZJLLZCimZ6Mui/CSa2y9+45sdfvNxpXCGvX3LKNo6FN781Z8q+7qSfT/DqKlzX1+5JvPLSjj8WWdjY2bkc6aJiPGeX1RrmXZo61IBzJx7rPZlVODqPljCU5bdFnJ1yx4P0G1jH/dPbSX2qjb/0Nxb2Nnbr+RaUKX+WCRcWd079X9yuI9nP8IlW06I9WHF6OkarcLNHT7qXwptGfQ4T4gqxTenTg3/VJLH4nYQWFG6ePHr1zPwj8sE7Tud0Q5XT4G12Ufq0IZ7Op0K48A619qpbZXR87/Y6iCTG7GDHj8WP/iN7yct/2C1tdJW3/X/oY1fgzXqGeW2VVf2TR1sHmrdfCqjlMx7/ANiNpXu/Rw680vUbOT+lWNxSwstuDx96MFSTTaeUd+lGMouMkmn1TXU0er8KaLqKcpWsaFXtOl7r+7oVmTunVEa2K9fKfyk2tpx0rhx+MsLKxjsjzn5pdljdI33E/Cd/osXXS+k2q+3Fbr4rsRpNfWbWTVsjFu41c27tOkrO3XTcjipnVeUsRT67lXN188FmLSim8brddjzmbg02kkYNNXuV7m32l8fU6X4Xaq7mwqadVk3K33p5/oZy3mTlmPbyJF4f3s7Xiq0ipPkrSdKXrlbfjgttiZU42ZRMdJ5T70XMtRXZny5uxgA6g1sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPJxjOEoSWYyWGvQ9AHzzxHp89K1y6sGtqVV8vquqx8jX+/wBEln49jpXjFpTjcW+r0o7TXsqrX4fqc7UMdebfocr2njTi5Vdvu15eyW1Yt7tbUVLKylu8pvYP7L58fAvKCaeU1jo/MezWE8ZedskDVI1dR8INb9vp8tGuKmatD3qWeri+3yJ+fPWkX1fTNRo31q+WpTllrs/NfA7toOqW+saZSvrZ+7Ne9HvGXdM3/d3aMX7PYVz6VPzj9mv7Rx+CvjjpP1Z4ANkVoAAAAAAAAAAAAAhHi/qStNBpWUW+e6qYaX9Md3+ODkKniWXnD26dSYeK19K94onRi5clrD2aXbPVv/35ESisTzthrJzTbuT2+bXp0jl8P3bLg2+zsx581tybliOz9T2bbaS5seRXKGJbPPyPVFKXVvumynlM1UKcoLL/AKdtjyU+ZZalnokV8rzukzynB9cbJdX5jzOTpvgpYctre6lOLTnNUoZ8lu/zOjGh8P7N2XCVjSkkpzg6kvjJ5/LBvjqeyrHYYdujv01+PNq2Xc7S9VUAAsEcALdzXo21CVavUjTpxWZSk8JHyZiI1k6q5NRi5SaSW7bOWeIvGsbp1NJ0qr/Ixy1q0ft+i9Cxx5xrU1PnsdLnKnaJ4nUWzqf6EIdPOMvHc0vbe3oribGPPLvn7QusLB4f6l33Qp5sNJvZ9Gux45LZp7lbg1HLaTXl3LcaeXntg1FcQqVRppySeOh42nu8devmVcqe+MJbvBJ+BuEbjXLiNa5jKnYQfvT7y9EZ8bGuZNyLduNZljuXKLdM1VcoXfD7herrl4rq6TjYUpZk/wDvH/SvTzOy0qcKVKNKnFQhFYjFLZIt2Vrb2VtC2taUaVKCxGMV0Lx0nZezbeBa4Y51T1n+dzWsrJqv1693cAAs0YAAAAAAeTlGEXKTUYpZbfY57xh4gwoOVnobjUqdJV2spf5fP4kTMzrOHRx3Z0+sstmxXenSiE9u7u1tKbqXNxSoxSy3OSRHdQ484ctHiN1K5f8A4Mc/i8HHdQvrzUq/tL25q1pPOeaWcGIk5/a9NzU8jeq7M6WaIiPPmtreyqY9eXV6nihpany09OvJLzbiv1Mqy8SNBrOKrU7q3y8ZlBSS+aZx5waT7roUxhhJRb+ZDp3lzddZmPgzzsyxMctX0XpuqafqVNVLG7pV4/2y3+4zD5zs7q6sa6rWtedKon9aDxg6lwHxutTcNP1blp3beKdRbRqfHyZsGzd4bWVVFu7HDVPwlX5OzqrUcVE6wnQANjVoAAAAAAAAQDjrjtWU56fo0oVLhZVStnaD8l5sv+KPEstMtFplnPlua8czknvCH7s5E+Zvme8n37/E1Pbu26rMzj2J598+HktsHCiuO0udO6GReXlxeXMq11cTrTl1lJ5+4tyltnmTxtgtyg/d97YRjJvdfPBpNUzVPFM811EREclbqe6sb465DeHlr0xgtqPkmlnoVcr5ej3Pj70Vymk3n4to2Oga/e6LeKvZ1pRWffp592a+BqlFrfdNPf1Eo4f1Xnqt+h7tXKrVcV0TpMPlVFNUcNXR3/hfXbTXtOjdW0kprarTzvBm2OB8G65X0PWKd3HPspe7Wgujj5neLatTuLenXpSUqdSKlF+aZ0jY204zrPpevHX8tbzcXsK+XSVwAFwhh5JpRbfRLJ6Yet1/o2j3dwutOjKX4HmuqKaZqnufaY1nRwbX7mdxrV5cYzz15yWPjsYinzPEpYzv8i3LmlKUnlNtvf1PJZk9883fHc5Dcqmuuap72300xEREK+ZrqsrOzR7KWXnb5MtY5Y4cn6rPRFM45aS+88ac3pflU32TfmmZGm05Xeo21vjHtasI/e0jC3Tx1aJD4dWzuOL7KLjmMJucl5YRnxbXa3qKPGYY7tXBRNXhDudKKhTjBdIpJFQB1xqIAWru4pWtrUua8lCnTi5Sb7JHyZiI1kiNWh4+4ghoekyVOa+l1ly0lndecjilapKrN1KzdSpPeTb3bfczuLNXra5rNe8qt8jly04vpCC6I1LfTGXg5ptjaM51/l6sco/PvbNh40WaOfWeq7KTy0nh9kVRfXDST9CyubPXHn3RS3KOIrZ5yVGiX1XVLbKWZJns5ybbx2yyh4UMxe7ymmec0ox65XkDqu+0fr088HRfBOvKUtRov6q5Zfmcz5pcz/A6f4I0pex1GtPrzQjn5F1u9E/r6NPP6Ie0OWPU6QADpLWmt4ouvoXD19c94UZY+LWDgXM28bZztudh8WLr2HCk6SliVepGGPNdTi+X/wA2fI0Pem7xZFNvwj6r3ZdGlqavGV9ySlj78BNqLWUiym/s7Nddh1WXF5zlmrrTSF3mzh9MI9lJ8se/f4llSfRPZ+ghthScl64Po2GkUJX2rWlrHdVa0Ib+r3PoSEVGCiuiWEcV8LbaVzxfQnyJwoxlUb/BfidrN73Vs8OPXc8Z+ii2pXrcinwAAbQqx7LLOJeIGtvVuIKzpNyt6D9lT9cdX951PjfUv4Xw1d3KlibhyQ+L2OCTqPP9ze/qafvTlzEU49Pfzn7LfZdnWZuT7F5yyl8c4QjUymnnBYy4vP34YlL3sQS3NM0XWi+pLky9t+x6pJt7bIsZ2zlya6pBSXJjv3Q0GdptvVvtQt7Sin7SpUUEvizv+nWlGwsaNnQjy06MFGPyOU+D+n/SteqXkofy7aGY7faZ143vdfEi3Ym9Mc6vpH7qLal3iuRRHcHA+Jpr/aK/SeV9Ilt65O+N4TZ88a9U59ZvJxaadeefP6zMe9c/0bcec/R92VHp1Mdz67JD2nKuZNSZZ5nzYTXnsJTjH6y6R6mkaLxOvCS6VLiWVvnCr0HtnutzrZxLwv5v9tLFJ5TjPL/5GdtOg7sVzVhaT3TP2a/tOnS97gAGxK4AAAAAAAAAAHEPEGo3xlqEn2mlu/7UaKNTmX1FsbvxIUafGF/s0ueLfrlIj3tFJP3sYOT7Q1/VXP8A6n6trsc7VPshd58r3fPcOW3uY6diy5qTzF7vZ5PHNYxHZpdUQ9GZkc6222+JIvDS4dHi+099JVFKD9U0RdSSe7XTb1MrR736DqtrdPOKdWMsLyzuScK72ORRX4TDFdo47c0+MPog8klKLi+jWGeUpxq0oVI/VlFNfM0/FPElhoFo515qddr+XRT3k/0R1a7et2qJruTpENVooqrq4aY5snGlcP6dKf8AKtLeGW35/uzm3FvG91qU5WunylbWvRtfXn+yI3xHxBfa1dyuLyq+RPEKMfqpeRqZT5XiPwZoe09vV347HG9Gj5z+IX2NgRR6dznUyZyw1lNvPXuecy6569sliMpNcqW+cEi4d4O1nWMTVH6Nbv8A4tVYXyXcorGNdyKuC1TrKdXXRbjWqdGlUm8NPr3NvoXDur6u4u0tZezf/Fn7sF8zpfDvA+kaVCM60Xe3C356qWE/REohGMIqMYqKXRJG04W61U+lk1aeUflVXtpxHK3HvQTR/Dm1pKM9TupV5bNwprlj9/Vku0zR9M02CjZWdKlj7Sj7339TIu7q2tKTq3NenRgllucsGjteMdHu9apaXaVJ1qlRtc6XurbPU2K1j4ODMU0xETPTxn7q+q5fvxMzrMfJIgAWaMAAAAAAAAAAAAAPJxjODhOKlGSw01s0cw8QuEXZ82p6bHNs3mrTS/w/Veh1AprU4VqU6VSKlCacZJ90QNo7PtZ1qaK+vdPgz4+RVYr4ofOynjpul+B4pYi85Tbyt87G3420h6JrtW1WVRl79J+cX2NFzJvbD27HL71mqzcqt19Yls9uqK6YqjpK8pde3Y2nC888T6Z0z9LpL/zI0znlZw2jccEUp3HFel04R6XEZv0Ud3+R7w6Zqv0RHjH1fL2kW5mfB3kAHXGpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwdf06lq2k3FjVxipFqL8pdmcKvLOtZXtW1uYqNWnJxafZo+gyCeJ3D3t6b1m1g3Ugkq0YrOV/V8jWt49nTfs9vRHpU9fZ+yx2fkcFXBV0lzLkcnt1XU8VPCWVl/iX1DHwye8m2V3Of815qxuSOHhNLuSDgjiCroOoYm5Ss6jSqQzsv7l6mo5MRaxu/MOGYtcqwZrGRcx7kXbc6TDzcppuUzTV0d8tLijdW8Li3qRqU5rMZJl04/wfxJdaHVVOpKVazm/ep5+r6xOraZf2mo2sbm0rRqQfk90/JnSdl7WtZ9HLlVHWPx5NeycWqzPkygAWyKAAAAAAAAFu5qxo29StJ4jCLk38C4aLj28+h8LXc08TqRVOPxk8flkw5F2LNqq5PdEy926eOqKfFxrUqsrnUq91Lmk6tRyy3vuzFillvZNdjIx6dOh649Nkm+2DkVdU1TNU97ao5RosODTyl6YZTy8y33L7Ty0uYr9lmLecL0PMS+66Mdw23+WxesaDub+hR/rqRjt6sqUEk+ZZb6eZu+A7X2/FNlDqoy53leW5nxbU3r1FEd8xDHcucNE1eDsdtTjRt6dGCxGEVFL4IuAHXYjSNIaqAx7+9tLCg695cU6NNd5PBBuIuPZSjKho9NrKx7eS3+SIWbtHHwqdbtXPw72a1j3Ls+jCV8QcQabotLN1WTqte7Si8yZyfinibUNdrfzG6VtF+7Rg9vi/Nmuuala5uJVripOrVnu5TeWy24Py7mibS27ezfQp9Gjw8fau8bDos855yxlCC80lskeuLcvd+e2S/wAu+d8rsOR4z3fYo9U3Vjcje26S6FShhdH6pGVSo1KtWNKnBznN4jFbtnQuEeBY0pxvNYUZvZwoY2X+b9ifg7Pv51fDajl3z3Qw3smmzGtUtFwVwXW1WrG8vozo2SeUukqnw9DrFrQo21CFC3pxp0oLEYxWEkVxioxUYpJLZJdj06Ls7ZlnAt8NHOe+fFr+Rk136taugACxRwAAAAAANDx3q/8ACNCqVKbxXrP2dP4vq/uMV+9TYt1XK+kc3qiia6opjvQ7xJ4rncVqmjafNxoxeK1RfbfkvQgSp5TWEn2Mhwcm6km228y3zk8UVtI5XnZ1zNuzcr93k2ezaps0RTSxnF83NypJ9du49ny5ajltGS6bWe8WexpylLliudvsupE9jLxMdJ7RluvRBwWOZKWM5WS/OjUglzwlFZ2ymsM8lBuaT+GUxpoa96wo9Y8u3xPVzQanGXLKLUlh9DIcOXd4TXmUcuGtlt3Pmvea6uu+HnEX8Y0/6Lcz/wB8oRXNl7zj2ZKjhXDWpVdJ1eje0ve5Xyy36xfVHcrerCvQhWpvMJxUk/RnR9gbRnLscFc+lT847pa9nWItV6x0lWAC+QgAAC1e3FO0tKtzVaUKcXJt+hdIp4oXjtuG5UIyxK4mofLqyNmZEY9iu7PdDJZo7SuKfFyjXLyrqmqXF7cSlKVWbkv7V2XyRhKOZfFmQo4eXhJ9hyNYzg5NXXVXVNVU6zLaqdIjSFhwjnONkuxmWGlahfy5LS0rVcdeVbEl4C4U/jNZ3l6pRs6csY6Oo/L4HWLW2t7WhGhbUYUqcVhRhHCRsGy9368ujtbk8NPd4ygZWfFqeGmNZcWp8EcRvE5WDSe+81lehqtQ0jUdOk6d5Z1aLaz7y2fwPoMsX1pbX1tO3uqMKtKaw4yRcXt1bE0/0q5ifPoiUbUr19KOT55jFYfN0S3weShlJcuMdGSXjbh2Wh6ioRfNa1culJ9V6P1NDyuMlJZ6Gl37FePdm1cjSYXFu5TXTFVPSWM6b6Prj7zq/hJqzuNKnpdaWals+am33g/2ZzHlWN0s9TecB338O4ntpuWIVH7OfwZP2NlzjZlNXdPKfewZlvtbUx3w7WADp7Wg0HiFcStuEb6cfrSioL5vBvyHeLVadPhunRg1mtXUXnySb/Qg7TudniXKvKWfGp4rtMebkOMrGHjp13Z5Jb5eHymRyvm377PfoFDfON/JHKY0bRqsOKkstYT8jyPLhprOPzMhKX1VjHqeqK5d+voDVjul7sWoY+LJv4P2znr9avyrlpUHvju3/wDJD+VPrH4+h0vwdtFTsb672zUqKC+Sz+pcbBt9pn0R4az8kPOr4bFSegA6Y1wOe+Lut+zt4aLQl71TE6+P6eyJ5f3NOzs611VeIUoOTOEa5eVdT1SveV281JZW/RGubyZ/YWOxpnnV9O9Y7OscdzjnpDVcjWy+QxiWMtrqzJcY4S5XhdD1Q396O+djn+q/1Y3Lh7Pbvhnk4488IyVB/wBK32fqTHhTge61JRub9u2tXvGOPfmv2JOLiXcq5wWqdZ/nViu3qLUcVSG2Vlc3deNK2oTrTnskln5ks0nw71e6UZ3UqdpB74n70vuR1HSNK0/SrdULG2p0Yrq0t38X3M03DE3Xs0RE5FXFPhHKPyqL2066uVEaILY+GWjUoL6Vc3Vw+6yor8ESrQ9G07RbeVDTqHsoTeZZk22/mbAF9j7PxsedbVERPj3/ABQbmRduRpVVqAAmMLm/jTccz0+xTecSqv8AJfqc19ksRTxnOH5ky8U7l3PFlSj2t6caa37tc36kTUN8Ne8t8nMNt3e1zrk+E6fDk2bCp4LFMLM6bW/Lsu2T1JpPC+XmZDgm91hM8lBJYbaafYq0mJYzj7zysfDoeuOUluZEYJrHR52YUd8pKPqfNX3VPvBWzxUv7vblio0o/mzphE/Cq1VDhWFblSlXqym3574T/Alh1DYtnssG3HjGvx5tZza+O/VIAC0RXNPGi/bnZ6ZCbwk61Rfgv1Ob+zw+ZN5a6dyQcbXX8R4nvbht4U+SGX9mKx+5p4QTi8b7nLNrZP6jLrud2ukeyOTaMWjs7NNLHVPpHp+xUqblnEUsPt5F5Qy93jbZiUXjZ75K5n1Y8Y4zy53eXkOL+qo9fwRflFJ79cFcKSlNJv0bPpro6x4SWEbXhj6Ty4ndVHN/BbImJh6JaRsdHtLOOMUaMYbeaRmHWcKx2GPRb8Ihqt+vtLlVXis3tRUrOtUbwo05P8D50rr2s5VX9Zybfrk7zxpcK24X1CpzYbouMd8bvY4ZGLceVpt92anvXd/qW6PCJn4rXZUaU1VMWKXRLfOXkqcVltZfoy/OMc5itkeRgmsY+BqXmt9Uk8Kbac+Mbaql7tKnOTafnHH6naTmfg1Zv6Ve3jziEFTWfN7nTDou7dqaMGJnvmZ+32a7tKvivz5ABj3l3TtpUYz61aihFepezMUxrKDEasgAH18AAAAAAAAcY8WKDhxdVny5VSlCS/L9CI8ilvytZ7HSPGW0f0+yuktp0pQfxTz+pz/HLthvfr5HLts25t51yPPX482z4dfFYpWVBRacU9uoUfffL26eRehDl6ZXlnzPI023npgrUlYdOK95Lo/M95E5NJduvkXvZ9U21nrg9cVldOmwNXQ7fjunYcG2dGg1W1JUvZtSW0MbZZzy/urm/uqlze1pVa0223LqeOC6569di5QtalarGhQpzq1J7KMVlsn5e0MjM4aK55RpER/O9gtWLdmZmOssXlllc26W6RtdA4a1PW6vLZUZKnnEqstor5k34V8PM8lzrj26q3i+v+Z/odEtqFG2oxo29KFKnFYUYrCRdbN3buXdK8n0Y8O/9kPJ2lTT6NvnKLcL8CaVpHLXuF9Nu+vPUXuxfov3JakksJYSMLWNVsNJtXc39xCjBdMveT8ku5d028o6hY0by3bdKrHmjlYeDc8fGtY1HBap0hU3Zu3I7SvXTx7l6rNU6U6ks4jFyePQ5pr3iPXk50dLtlRim0qtTeXxS6HTWk001lM4Br1B2+s3lBxx7OtJbfHYo94szIxrdHZVaROuqVs+1buVTxxroo1LUL7Uasql7dTrt7+8/wBOhXw3c/R+ILK4UlBQrR5n6ZwYLW2ExCXs60Z+TTTNGovVRdi5M6zE6ryaImmaYfRqeUmu4MbS6yuNNtq6eVUpRl96Mk63TPFETDU5jSdAAH18AAAAAAAAAAAAAHPvGqxVTTLK/jhSpVXTl6qS/dHLKaw84bz17HY/F5J8Jpd/pEMficgUeuF8TnW8tEU50zHfENh2dVrY0law+bZdM9O5P/BjTpVdSuNSqRzChD2cMrpJ9fwIXp1jcX95StLaHNWqywkvzO7cL6PR0PR6VjSw5L3qkv6pPqzJu5g1X8iL0x6NP17vy+bRvxRb4O+W0AB0Fr4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB5OMZwcJJOMlhp90egDlPHHDb0q7dzQg3Z1Ze7j/hvyZHFDDxlJdjul3b0bu2nb3EFOnNYlFnL+KuGq2kV3Vp81S0k/dlj6vozQdu7FnHqm/Zj0J6x4ft9Fzh5fHHBX1Rp02v1aPFBrfm37tGQo7P8A95PeXvn5GrrDVjygnlJJJmbo2p32k3Lr2VZw/qjn3ZfFFn2fT+ryPHFYeU8voe7Vyu3VFdE6TD5OlUaT0dM4c4xsdR5aF3i1ufV+5L4MlCakk000+6OFqGPXBuNH17U9M2t7hzpp/wCHU3ibbgb01UxFGVGvnH3hWXsCJ52/g64CIaZxzZVI8uoUZ28l9uC5ov5dUSS01PT7uObe8o1PRS3+42nG2hjZMa2q4n6/BX12Llv1oZYCaaynkE1iAAAIN4tXPLa2Vp2lOVR7+Swv/UTk5j4k1o1uIORNS9lSUWvJ9Sk3hvdng1RHfpCXg063o8kSccrONjz2aTw36GRyJb7psKDj1xho5ovuJY5XzPHQ8nFrCbMjkztv8jzkWM4fxY1NVjlwyY+FdqqmtV7l/wDBo4XzZFOVc+GnhoybS8u7SNSFrXnRdTHPyPDaRN2fk0Y2TTerjWI5sd+ibluaY73XtU1nTdNg5Xd1Tg+0E8yfyIbrPH1WfNT0u39msf4lTd/cQyac25yblJvdt5bZ4odFjbHUtszebJvcrXoR8/ii2sG3Rzq5mo3l3qFwq15XncTzs5Pp8PIsOD5ti/7PO8fM8lDLzjddTXq7lVc8VU6ynRpHKFlx2w3+AcHJ7dI+ZfVPzXwM/S9F1DU6qha285LO82sRXzZ9t2q7tUU0RrPk+VVxTzmWoccS6Pqbnh/hnUNYqJwp+zt096s1tj08ybaBwRZ2bhX1Cf0qst+VbQX7kthGMIKEIqMVsklhI2zZ+7FVWleVOkeEdffKuv7RiOVv4tNw5w5p+iwUqUFUuGveqyW/y8jdAG5WbFuxRFFuNIhVV11VzrVIADK8gAAAAAAABy/xRvvpWtwtIPMLWG6X9T6/hg6g3hZOLa/Vndaxd1m026kt/mazvTfmjFi3H+U/RYbOpibk1T3NVyPGywkOTCbb+GxeUXyvz7+Rn6BCw/ilGepTxbwfNLZvOOxodqjtK4o101XNVfDEy33BvBn06lC/1NzjQkswpdHJevkjoFjpmn2MFG0s6NLCxmMFn7yjTtV0y9hFWd3RnttFPDS+BnHTtm4GLjW47LSZ8eurXr9+5cq9Ll5Lde3oV4clejTqR8pRTRB+MOCrb6PUvtJp+yqRzKdKPR/BE8BIzMCzl0TRcj398PFq9XanWmXAJRXfswoLHLlJMlPH2kw0/W5zpQ5aNwvaRSWyf2l95HlBJNJdDluVj1416q1V1iWx27sV0RVHexlBqXKmvmdY8Nb93fD6oTadS2lyP4djl6i+vJl/eSzwwu3Q1upauWIV6f1X/Uv/AGy03fyZs5tMT0q5fj5o2dRx2p8nTAAdKUAAYuq39tptlO7uZ8sIrZd5PyR5rrpopmqqdIh9iJmdIZTaSy3hHNvFS+o3V5a2lGrCpGlFynyvOG+xr+IOJ9Q1apOnGcqFt2pweNvV9zQOL3a8zR9s7wUZNurHsxynv/ELfFwpt1RXVPNZwk8LsU8iW2M93nsX8LP+h7KEcZe233mprPXmmfD3G9pYWdCxqabKnRpxxz05ZfxwTbRtY0/V6PtLK4U8fWg9pR+KOLci+stv2J34XaW41K+pzT5UvZ08933Zt+w9s5d6/TjzETHw0iFXmY1qmia45SnoAN3VDRccaWtU0CtCMU61Fe0p7d11XzRxyMG5JPLfdn0A0mmn0ZxbiKx+ha1dW6TxGo+Vf2vdGlb14sUzRkR38p+y22bd5TRLUcuN+V5KqanCpGcE1JPmX3lxx83/AKHvJlrz7mnxOkrXV3DSbhXemW1zGXN7SlGWfXG5kke8PK3teGKEMY9jKUPxz+pITrmHe7bHoueMRLWLtPDXNIc+8X6jk7C3zsuabX3I6Ccw8T6vteIVSe6pUYpL45ZV7x3ODAqjxmI+aRgRreiUNcY47b9dgoLGUtuzZfS6PGF2Dhjrsl0ZzfXRf6rLi313SPOTbbbzyX+TbO+fM85FnOXl9hBqsOM84xlLdnXvDe1VtwrQa/405VH83j9DlXLhYaw/Q7Vw9bq10OzoL7NKP5ZNp3Ut8WRXX4R9f9ldtKv+nEebPAKa1SFKlOrNqMIRcpN9kjfJnTmpUI8VdUlTtaWlUn/i+/VfouiObqD3fZ9jba/ey1PVLi8n0nL3E+yXQwOT3W0jlW1c2czKqud3SPZDY8a3Fq3FLHUMNpLHdYXUKk3LaO/kv0MmUFthvJO/DzhraOrX1N7/AOBTkv8AzM8bPwbmbei1R758Ie71+LVHFKvgjg6FGFPUNVpKVTaVOi1tHybXn6E7AOm4WFaw7fZ2o/f2teu3qrtXFUAAlsQAAAeyyCxqNVULC4rN4UKcn+B8qqimJmX2I1nRxPiWp9L169uG951pb+i2X4I16i8dM77+ZlVE5VZTw223n1KZJttQSTfZnHrtyblyque+dW00cqYhjcuesX8WeuCz73y3Mhx3aaaPFHMkvwZ4etVnGG8Rxt5dTyUZdY7t7NF9xx7qz+xk6Tau41O2t2/8SrGL+8926ZrqimO98mrSNXZOHbV2WhWVq8Zp0Ip/HG5nnkUoxUV0SwenX7dEUUxTHc1WqeKZkMPW7lWekXVy/wDh0pNfHBmEb8R7h0OGK0ItKVaSh17dzDm3uxx67nhEvdmnjuRS5DUzVnKbe7e+Tzk7OLaZfcXlLGfUcuMrD69Dkcy2jXRjxi+qx5BLPM99tzIcN+Z9uzPORrdp7g1WOWK3Uc9+hsuGbNXOvWVGSynWTafl1MVQSWd2vUkvhta+14mp1HHalTlJ+nYmbPtdtlW6PGYYr9fDbql1dbLAAbSTbeEjrLWEF8Xb7ksLXTovetNzl8F0/P8AA5oqeZbJ+RIuMtS/inEFarHmdKD9nDywvI0vK299tzl22cv9VmV1x06R7mx4lvsrUUyx3Tw8tfH9yrk23y092XlBYz+BuODdJer6zSoyi/YUpc9Xy5V2+ZAx7NV+7Tbo6zOjPXXFFM1T3Oi8Aab/AA3huhGUeWpW/mzyt9+n4EgEUoxUUsJLCQOtY9mmxapt09IjRrFyua6pqnvCO6zWdfi/SrGD2pRnXnv6YRIiF8N3C1Lj3U7p7qjDkpv0Tx+jI2dc0m3bjrVVHwjnP0ZLNPrVeEJoACewAAAAAAAAIl4p2TueHY14puVtUU8ej2ZydU8N7netZtVe6Vc2r29pTcV8cHDa1J05ezkmnGWGjQt6sfgyKbsf5R9F3s25rbmnwY/I2m3Lo9uw5Zd08l7l3xLz29T32bfqzV1lqx1FpOXbO2eh4o7t5fxMicVnrsFT3y1jA1NVqjT56sISnyqbUXLy3Oz8KcNWGh26lRSq3E171aS3fovJHHeV74XR7M7HwPqX8S4dt6kn/NpL2U998rbPzNp3W7Gq/VFUelprE/VW7SmrgjSeXe3hi6vUrUdLuqttj20KUpQz5pbGUUV4e0ozh/VFr8DfFNRMRVEy+cdT1K81O7nd39edxVe2ZvZeiXZHZPCW7VzwXbQzmVCc6T/6sr8Gji2oUZ299Xt5vM6dSUZbeTOo+B1wpaXqNr/RcKa+Dil/+6SLsRw8nQd47FE7OiaI0iJift93RTi3iNQVvxfd7PFVqf3pHaTlXjBRcdcoVFlKpQ3fwZq281vjw+LwmPw0zZtWl7TxhBns93lLz3PEs5Tk9t9yqTUUsJvbGCh7JKS690c/X7ufAF0rvhHT6iazGnyPHnF4N6Q3whuFV4XlRzl0a8l9+/6kyOqbOudpiW6vKGrZFPDdqjzAATWEAAAAAAAAAAAAAQTxiuVHS7Sz71KrqP0UVj9Tnuk6Vfapcq2sqEq8pPDaW0V5tnY9W4asNV1OF7fOpV5IcsaWcRRtLO0trOkqVrQp0YLtCODWMvYVzOzKrt2rSnlpp10j6LK1m02bUUUxrLQcGcKW2g0vbVGq17JYlUxtH0RJQDYcfHt49uLduNIhAuXKrlXFVPMABmeAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKK9GlXoyo1oRnTksOLWUysHyYiY0kc/4l4QqW8p3OmxdSi95U+so/DzRFJQaliSxjqsHazSa7w1Yanmqo+wuMbVId/iu5qO1N2ormbmLynw7vd4LGxnaejc+Ll6it5YPFH3umTfarw3qVhmU6ftqa+3T3XxZp3FpuLW66Gm38e7Yq4LtMxPmsqLlNca0ys8m3vdGHDLx5F6UMY2TPXDL3WPUwvWqwo5ykv9BFb53XqmXVHfp06nvJ9prZjXToTK/batqlulGhfVopdFzZSNnbcXa3T2nXhVx/VBbmkUFnoj1Q2eUTLW0Mq16lyY97HVat1dYSaHHGpKOJWltJ/NFa47vEsy0+g/LFR/sRbl22S9Dz2e6bS9SXTt7aFP/c+n4Y/0tn/SlL47vsv/AOnW6/8A2j/YjOp3VTUL+reVoQhOrLLjHp0KFFZTwHBYyiNlbTysumKL1ese57t2aLc60wsOG6eXkqcdsNdupelD0+4crws5x39SCzarHs8LKinn16HnI+/xL/I+kciMFlZb+ANVlwaPORdc7F+UU/s5CppvCXwSEc3zVjqK643Dg3jHRdTbWOianeJewtJ4l9qSwsEh03gipJqV/cxgsfUpLL+8sMbZWXk/26J08Z5QxXMi3R1lCXT5niPVm30rhrU9QcZQoOnTeMzqe6sHRNN0HSrDDoWkHP8Arn70vvZs1tsjZcPdSI55FevlH5/ZCubQnpRCLaPwVp1ry1LyUrqot8PaK+Xck9KnTpU1TpQjCK6JLCKgbTjYdjFp4bVMQgXLtdydapAASWMAAAAAAAAAAAwNa1a00m29rcyzJ/UgvrSZl3FWFChUrVHiEIuTfojk+sX9bU7+rdVZPd+4u0V2SKXbW1f0FqOHnXV0/KVi4/bVc+kMzWOKdU1DmhGatqP9FN7v4s0HJl+b67l3Dbzjt0PVHv8A+0c6yMq9k1cV2qZlc0UU240phZUcRwl38xy/eXuXD2S+YccSzj7iO96rUYzpvNNyi19pPDR1vheF1DRLf6ZUlUqyjze91SfRHO+GtOeo6zQotZgpc1T/ACrd/sdXSSSSWEjdd1MarSu/M8ukfdWbQuROlAADclYjXiJZK50P26XvW81L5dGc0kpZb6HZ9Vt43Wm3FvLpUptfgceccvlUcdt+poW9diKMii7H+UfT/db7Pr1omnwWXDusmw4ZrfRdetKu7SqJPPrsYvLyrGMlVLMKsJrrGSaZrWPc7O7TX4TCdVHFTMO0AooS56FOXnFP8Cs7DE6xq1oOb+Il5K71hWqk/Z28cYT2cn1OjVZqFOU30im2cdv607u7rXM3vUm5fezV96smbePTaifWn5Qn4FGtc1eDD5Es98hwxHtsXlBpvKDj08zQZW+qw4JL1fUOmsPui+474aXTsHHqsbPqH3VYjSlJqEUst4R2Ph+yjp+j21qlhxgnL4vqc64PsPpmvUIuHNTpv2k9+y6fjg6mbvupi6UV357+UfdVbQuc4oAAbgrQ5p4k20aevxqrC9rSTfyyjpZBfE6kndWdXDy4Sj+KKHeS3x4FU+ExPzS8GrS9CEcrbzt5Bx32Re5FjdZDintjBzZd6p34XVnLTbqg8+5VTWfVEwIR4Ytqd7B+UX+ZNzqGwa+PAtz/ADqosuNL0hyXjWo63E95J4xGSivkjrT2WTj2szdbVbqrlPNaTX3lZvZc0x6KfGfpDPs6PTmWtUcrdrbse8v9KL/LstkgoYSS6Ghawt9WPyvHxDiu0cr1MjkeP0Q5M4XR+Qh81U2VFVLyjTazzTjH72drpRUKcYLpFJHKOFrdVuIbOD6Kqnj4bnWTet07Wlm5X4zp8P8AdVbRq1qiAjfiFqH0TQ5W8G1UuXybPpHv+xJDmnHl59N12VJTfs7dciXr3LTb2X+mw6tOtXKPf+yPiW+O7Gvci7h+IUV0b36/EyGs9Fl9vIpUd3t8DmS+1bngrQ/4rqHtKsX9FovM/wC59kdTjFRioxSSSwkjQ8BVLafD9KFCEYTg2qqTz73mb86bsLDt4+JTVROs1c5n+eCiy7tVdyYnuAAXKKAAAAABpuNa6ocM3kn9qHIvm8G5Iz4j1VHQVSzvUqr8NyDtK52WJcr8pZbEa3KY83MlBx3x6FLhjzb9DISy8Njl3fr3OTNi1Y7jl+bYcMvOPjuZCj0j1DjHDytz6asfk6LOPPY3nA9uqvE1qpRyo5lt0WEatRbWP/aJX4aUU9XrVHH/AA6OM/Fljsm12ubap8/pzYcmvhtVS6EADqrXggvirVi/oNvndOVRr7kv1J0c48SKiq67Gnn/AA6KT+bbKLeO5wYFUeMxHzS8KNb0Ii44ksR29Q4rKeF8kXnDPl1KuV8yykc1XmrHlHPZrA5crKMhxf4HijthRBqscsfVZJt4VW2Lm9ucfVhGHXzef0Ieo+iZn6Nql9pVXntK3Ln60GsxkWGysm3i5VN25HKGLIoquW5ph2Ai3HuuqwsnY20s3NdNPD+pHu/iaS5421WrSdOjQt6Mn9tZf5kYr1KlxVdWtOVWct3OTy2bNtTeS1XZm3i66z39NP3QMfCmKuK53MRww84xg8UGmn+JkSh1xvgqjSnUqRp04uU28KK7s0qOfJacSzRoSq1406cXKUniKSy8nWOD9Fjo2mKM4r6TV96q12fl8jX8F8NLT4K9vop3Ml7sf6F+5Kzft39jzjR296PSnpHhH5VGZldpPBT0AAbQr2v4jvVp+i3NznEowaj/AJnsiPeFtpKGnXN7USzWq8sX6Lr+LZb8TL/FOhpsH9b+bU+HZEh4UtPoXD1nQaxL2fNL4vd/mUdNf6nakxHS3T85/ZL04Mf/AOpbQAF4iAAAAAAAAByPjjTnYcQ3OIv2VZqpD59fxydcIf4m2CrWNC9jHMqUuST/ALX/AKlDvHi9vhzVHWnn+UzBucF3Txc3ccvZdtgoN5/Mv8jccev3DleV0SRzdearCpvK2+9hweNsZfkZHL2ay/M8jCSWFul2GuhqscrfoiY+F197HUq9hJ+7WjzRz15l/oRVQ9V8DK0i5lY6pbXS932VRSeO8c7r7idszKnFyqLvdE8/ZPVhv0dpbml2cHkJRnCM4vMZLKZ6dYa6+fON7Z2vFmoUmsL20pL4PclXghcqOrX1thL2lJNY78r/ANTT+K9GVPji5bylOnCcfXKx+hf8JKqo8ZUof95RnF/Hr+hJmdbbpOV/X2Lr/wCkT8ObtRzrxmoy5NPrx6ZlB/mdFIX4vwzw7QqLGY3K/FMottUceDcjy1+DQMKrS/S5NNuKfXYoScm3n5Hslu87/MJJemexzJsrpXgtW/lalb/3wml8sHRTlXgzU5NbvKLf16Ca38pf6nVTpGwK+LAo8tfq1zPp0vyAAuUMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAe/U1epaDpl83OpbxhVf/ABILDNoDFesW71PDcpiY83qmqqmdYlCr3gytBN2lzGa/pmsM0l1omo2spe2s6vKt+aKyvwOoAoMndjEu87etM+XT5pVGbcp683IXHlnhrDXVMSg8/ojq1zZWdysXFtSqf5opmvrcN6TUk5ewlBv+mTRT3d0r9P8AbrifbrH5SKc+nvhzjl3xg9cX5J4J3V4QsJNclatBLtsyxPg2lh8l7NfGKIVe7WfHSmJ98MkZlqe9ClHHxfkOR93uTF8GvGFfZ+MDxcGvG99/5DF/+e2h/o+cfl6/V2vFDnT6Bw3yumMEi1/QoaXawrO5lVlOfKly4XQ03L1b/IrcrEu4lzs7saSy0XYrjWljezz/AKHvJ6l9w8onigkl6EaHvVY5N3n78Hqh6l9w69fgOWTT90+mqw47rG36nS9E0mwtbSjUhaUlVcE5Tccyz8TntKH82G32kjqlJYpxXkkbhunZorquV1RrMafdAzq5iIiFS26AA3hWAAAAAAAAAAAAAAAAAAA0nG1z9H0GrBNc1ZqCT7ruc59nth9SY+IFVzrW1sntGLm/j0Iqqed8bnN95cjtc2aY/wAYiPuuMOOG3r4sfkb2e3mFBfgZHJ5njh3Ne1S9Vhwy+h6o46fiX1FY2/DseOGG13PvM1S3w7s1GjXvZLeT5Iv07kuNPwc6H8BoxoNNrPOvKXc3B1bY9mmzhW6afDX481FkVTVcmZAAWTCHI9RoqnqNzBL6tWax82dcOXavBvWLxb4Vef5mo720/wBG3V5yn4E6VS1rj59BypppdcdTI5O8o7Y8goZztg0VaauoaNP2mk2s85zSjv8AIyzX8Of/AKCs/wD8SNgdhxquKzRV4xH0a9XGlUw1XFly7XQLqcfrTj7OPo5bZOZOD5dln5E58Qa+LW3tlLec3JrzS/8AkhnLjqaFvRf48yKP9MfXn+Frg08NvXxY8YeeT3kbWzz55L6g/UcmY75NbTdWPytPont5Bw97r/oX+Xbz+J64vZLoNZfNW34Jv6Gn6nL6SsKtFQU+0d+50VbrKOR8n/vBKeGeI3QUbO/l/KW0Kj6x9Gbfu9tmizT+mvco7p+0/lX5ePNU8dKZg8pzhUgpwkpRe6aeUz03mJ1VgRDxKhF0LKbW/NJfgiXkV8RFm1tP88vyRUbe/wD6+57vrCRi/wB6lBZRWfqrIUer2znoX1H7hy99/gcuXmqReHGY6lcRxhOln8SdkH8P0v4nVw/+F+pODpe7c64FPtn6qXM/uyt3U1TtqtR9Iwb/AAOQVknUlJLClJvc6fxNfW9ppdaFSf8AMqwcYQT3baOaqGF0+RR72Xqarlu3E9InX3pWBTpEyscvurO4xzLG2xfcP7dz3lWMrBp6fqx4xTTS2Q5VlP5l/lxuj3kxsfdTVueAKKnrym1lQpuS9Ox0Qhvh1T/3i9qNbxjCOfjl/oiZHSt27fBgUz4zM/PT7KbMq1uyxtUuoWOn17qbSVODa9X2RyWtzVZyq1G3KbzJ56snviBdcljSs4t81WXM/gv9SD8rW3Y17erK7TIpsx0pj5z+2iZgUcNHF4sflxjt5HvLh7NZwX+WXpg8UNv1NWTtW64Ev5WeqfR5yxRuPda7KXZnRTkMYuElOEsNbprzOncP361HS6VfK9oly1F5SRvO62fxUTjVTzjnHs71XnW+fHDYAA29XgAAAAAQvxLrZnZW622lN/giaEC4/n7TW4QT2p0Umvi2UW8dzgwKvOYj5pWHGt2EWkks4S+KDg8bsvOGNsbHvK8JeXqc1hdarCi+6HKnnv8AEvcjUVk9cV+h8g1WORvO6x1Jv4aUeW2vK2PrTjFP4J/uQ/2ax69kjoPAdJ0+H4NrDnUlL8cfobDuxb486KvCJn7fdEzatLWjfAA6Opg5hxnL2nEV1JYaTS+5HTzles/zNUupPDzVlv8AM1Te2vTGop8Z+yfgR6cy1cV8xyJ9PiZDh8F5jlafRehoS11Y7j0+J7y4fl5l9w6dPUcrb6CDVj8q7rDJXpvDMNR4aoXFJ+zusyeX0msvCZHHB4z5nTuGIKnw/ZR6/wApP7zYt3cO1l3blF2NY0+8ImZdqopiaZ73Nr/SdRs5NXFpVik/rJZj95j0LSvWeKNvVqPyjBs7GEkuiLirdK1NWsXJ09iPG0KtOdLmmn8J6rdyUqlKNvBvd1Oq+RMtA4dsdJipqKrXHerNbr4eRuQW2DsTFw54qY1q8ZR7uVcuRpPQABcIweTkoQc5PCSy2emi40v1aaROhF/zbhckfRd2R8rIpxrNV2rpEPduia6ophDa0/45xUm8yjVqqK9II6dCKjFRXRLCIN4fWLqX9S8lvGjHlX+Z/wChOil3ct1TYqyK+tczP8+aTmVRxRRHSAAGxIYAAAAAAAAQzxD1PmUdLoy32nV/REq1S7hY2Fa6qdKccr1fZHK7yrO5uatxUb56km5fM1febaHYWYsUTzq6+z907CtcVXHPcw3Btdg4ZWcJfEvqm2lLleH0eNmeOO6xnY0DpyW2qxyLpjsFFJY3L/LnZLIcMYz0Y1fdVjCfRL12DTUX08jI5O6WMdUecq9D4auk8FXf0rh+gm/epfy3v5dPwN0Q3w3r4ld2uMdKi/ImR1bZGR2+Fbrnrpp8OSgyKeG7MOQeNkOXiW1njadqvm1J/wChofDyShxpps+dp+1w8vzTRK/HSio19KuUstxqU38E4v8AUhXCtWNLibTajeFC5hn5su6OdDoWzv6uxtP/AFqj6vocjHihRVXg65l3pzpyX/Wl+pJzR8e0nW4Q1KEU2/Y8yx6NP9CrzqOPGuU+NM/RzzHnS7TPnDh0ljmTx032KO+Vnp1ZU84wl065PKib3xjz3OUw2qEs8J6nJxbBdHOjNNI7GcS8NaipcXWbafvc0c/FHbTf92KtcOY8Jn7KHacaXvcAA2JXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACmrONKlOpL6sYuT+CMKGsWEknKrKGf6oNGRqOP4fcZ/7uX5ETk+xrO3ts3tnXKItxExMT1S8exTdidUqhf2U1mN1Sa/zF2FxQm8QrU5N9lJEOe+S9pcf/qVDH9aK/G3suXblNuq1HOYjr4stWFERM6peADdlejHHjzC0jvjmkyK8nXJKONpKVxb0+6i3gj3Jnc5hvDVxbQr8tPpC2xeVuFjHpjyHLvjHUvOLxsshQ9EUiRqstZWDzlx8i/yLyeRyZe/Q+mr3T6XtL+hB7p1I9fidKOf6NHGrWi23qxwdAN83Sp0sXKvP7K7NnWqIAAbahAAAAAAAAAAAAAAAAAB5OXLCUn2WRM6Dn3E1b6Trl1JZxCSprPov3ya1xTeWu/n1Mmrz1KtSpLeU5OT+byUuOeyOP5d6b9+u54zMr2j0aYhY5cde4UVjGPxMjl6ZS3PHDyWxGeuJZ5PI8cfNdi+oPphF21tKt3cKhRjF1H0Tfkj1boqrqiimNZl8mqIjWVejajW0y59pTTcH9eDf1kT2wvLe9oKtbzUk+q7p+TOfVrerQqSp1oShNdVJFyxurmzq+1t6nJLv5P4l/snbVzZ1XZXYmaPDvj+eCNfsRd9KOrooNBpvEtCq1TvIOjPH11vF/sbujWpVoc9KpGcfNPJvuLnY+VTxWqon6/BW126qJ9KFw5vrlNLWrxrvVbOkHOtWinrF5LqnWZr+9v/AE1Ht+yVhevLAUH032Ch1y/9S/y5eMbI8cfQ0HmstU/4dz/BLXP9Bnmt0evRoaJbSq1IwjyfaeDXatxJCMHTsI80sf4klsvgjqdOfj4eJbm9Vp6Mcu/p4KabdVyudI72r42qOtrEaa6UqaT+e5ouV91kya0516sq1SbnOTy2+5bUDm+fk/qsiu94z/strVPBTFKyo+mA4b9C/wAu+Glljk3/ADIj3qscvXbJ7yeXXJeccI9jBuUUl1Z9pjWSZbS64auvolK5tX7ZSgpSg3iSbX4mmq0KlOo4VKcoyT3T2Z1CjHkowgvsxSLF5Y2l5HFxQhP1xv8Aeb3l7rWrkRVYq4avCeiuozaon0uaB6Vql7p7fsZ5h1cJPKJLYcU2VWKV1GVCfdpOUS3e8K0ZNytK7g/6Z7r7zU1+HdTot4oxqpdHCXX7yBap2zsz0Yp4qfjH5hkqnHvdeUplb3tnXWaNzSmvSSI9x61KlaJNP3pPPyRopWN7DObavHz91liaqP3Krn7u6UsnnaG3ruRjVWLlrhme/wB/sLWPTRXFUVMdwxj/AN4Cgty6ovH5lXLlbGqQm6trwhd2ljXrVrqrGmnHEc9Xv0M7U+K3vCwo4/vqL8karSNIrajKapThFQxlyJNp3DllbJSrf7xPzktvuNv2V/xO9i02rERTRz9Lv6/z8oV6bMVzVVznwRG4t9Qu7erqNfmcI4zOb65eMIweVp9PiTnjTENGjSglFSqxWEuy3/Qhri12yU+2sOnDvxbiqZnTWZnvlnsXeOnXTRYccdEOXySL/L3Y5d90VDPqsKGfkeqmn2wXOXYq5U/QPmqWcA0ow064qpbzrb/JIkZqeEqap6JTa+1KUvxNncVVRt6lWXSEXJ/I6vsqmLWDbif9MflS3p4rkoLxjcfSdanTWXCilBfHv+ZpeTyMmtN1Ksqk8tzk28+pTyb9NjmObkTk5Fd2e+f9lxbjgpilY5NviFD0wXuXfB7ysjPeqxyZ6rc3vB199Dv1bzlilW2y+0uxqFFeR7FNNPutyVh5VeLfpvUdzxcpiumaZdQBruHr/wCnafCU3/NguWfq/M2J1qxeov26blHSeakqpmmdJAAZXkAAA53xZL2uvXLTWItR+5I6I9llnN9Ul7XUbiqnzKVSTT+Zqu9lzTGoo8Z+kJuDHpzLXum9tg4bvuX+XbZYHL8DQFnqsKD79fUcnki+4YfbYOL+8Gqxyrr+p0jhuPJoVmsY/lp/ec9cc5Txg6ZYwULOjBdFTS/A3DdGj+rcq8Ij5/7IOdPoxC8ADeVa8m8Qb8kcsu8zuak2vrTb/E6Lr12rPTKtVP32uWHxZz1xz1fY0je2/TNVu1rzjWfj0WODExEyx3B+XU9cE35l5wy0HFJ5NN11T9VhQfXG7PeXPoi/hY9Tzlx26n3U1Y7g1BtLfH3nT9Fh7PSbWHlSj+Rzjkz18tzplisWVBL/ALuP5G4boxrXdnyj7oGdPKF4AG8K4AAAAAG0ll9Ec64mvXqOqVJR3pU/ch8PMlXFuo/RbJ29KWKtZYz/AEx7simi2X03U6NDHu5zL4I03ePLnIu0YNrrMxr7e6Pun4lHDE3Kkw4Ts1Z6NSWMTqfzJbeZtjyKUYqKWElhHptmPZpsWqbdPSI0Qq6pqqmZAAZnkAAAAAADyclGLk+iWWBEePb2Up0tPpy2S56nx7IitKjOrUjCKzKTSXxM/VK8ry/rXDf1pbZ8uxm8JWvt9ZpyafLSTm/j2OX5NydqbR0jpVOkez+c1zR/RtexseJtIhb8N2/s4+9bY5mu+ev4kQ5N8YeDq15RjcWtWhJZU4uJzOvRlSqzhL60ZNMn7z4VNi7RXRGkTGnw/Ziw7s1UzEsRQfZBxe2xkOO245WsLP4GrpuqwovC+J5yPqt8mRGGW+55yrv8gattwNUlT16MEvdqU5Rfy3RPznfDT9lrtm8v6/L96aOiHRN1rnFhTT4TP2VWbH9TVzrxwg3p2mVEk+WtOPwzH/Q5lpMnT1aylGS2rwb2/uR1fxqi/wDZu2mkny3KW/rFnIraThXhU2XLNP8AE2636re93J4tm6e2H0vH6q+BhcQx59Bv4+dtU/8ASzKtpc9vSl/VBP8AAtarHn0u7j50Zr/yshXY1omPJzunlXD5765aSXx7FMurWHhblVRJbRTa6b9SnGI42yn9xyLpLbG24LqKnxTpuE8uulk7ycD4SeOJtPaeyuI4+GTvhvG6s/0K48/spNqevTPkAA2lVgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADH1P8A/R9x/wDjf5EUe/kSnV3jTLhr/u2RZ4ZoG+E/17fsn6rLC9WVEujMnSYqWqUMPdSz+BjS6sy9Fw9Uo/F/ka7syNcy1H/tH1Srv9ufYlYAOwqNFOLo51GD7qml+Jp+T0NzxI+fVZRX2YpM1qhnsco21VxZ932razytwscnoecmeqMjl7DlecFYyarHJ0POT0MjlaZ5ynx91XdEpOWs2m31amX/ANLJwRLh2P8A9XpPbbm/JktOibp06YdU/wDtP0hXZc+mAA2dFAAAAAAAAAAAAAAAADD1uo6elXEk8NwwvmZhquKJqOmcrf15pEPaF3ssW5X4RP0e7ca1RCH8jweOGGjIUV6jlwzkMrjVjuCz0HJtuX+Q95fjkGrHcMdEbjhOmparzPrGDZr+XPmbrhOn/vNaflBL8S22HTx59qPP7MN+r+nLfXVrb3UOSvSjUXquhob7hlPMrStjf6k1+pJAdGy9m42ZH9WjWfHv+Kuou10erKC3Gk31B+/bya847oxYyqUnmMp02vJuLOiFFSlSqJqdOEk/NZNfu7p0ROti5NPt5/hIjLn/AChDKOr6jSxi5lJdlL3jBrc1StOrPDlNuUseZN5aVpu7+h0l3eFgh9RJ1pyhtHmfKvTJR7ZwcvEooi/d4onpznu9rPZuUVzPDGjG5G+2EeKBkKPYKGXuma/1SNV200q9ulFU6c+RdHNvCXobzT+HKFJ+0vJqu19lLEfn5m6toqFvTiuiil+B5eS5LStP+mDf4HScPYGLjUxcuRxVRHf+FbXkV1co5OfTSlKUopJSbaS2Q5EXaUGqMMvdRRVy4Xqc4qniqmVlE8mPyvOTxxMnl7HnJ2wedTVYcVnoV26/3il61Ir72i4obFdCKVxRyk/5sP8A1Iy4/O7TE+MPlU8pT0AHZVKAAARTjLDvqMUkuWnnp5v/AEJWRDiOTq6tUTe0Uoo13ee5FODMeMxH3ScWP6mrTcj+J7y5Zf5GOXY5xKy1SHguly2txVfWVTH3L/U35rOGaXs9Jg+85Sl+P+hszrGyLfZ4Vqnyj581TenW5MtBxrvZW8c4ftc/+V/uRblWxJ+MJJytqff3pfkv1NBy7YwaJvJXrtCuPCI+idjcrcMdwWPPB5y7GRybdDzla+yUGqTqscq8hy79DI5cdg44WV2PpqmmhU/ZaTbw/syY/FNb2Wkzjvmo1Az7H/sdH/IvyNFxfVcq1C3XZOb/ACX6nT9o3f0uzJ0/0xEe/kqrccV1GVDthDl33SMhw9Q4PCzF4fRtbM5jGs6rTVj8je45PvL6g+XzDgfOj7qsOOcb/Mcm3xL6pr/32HLuNTVlaBe/QL1Sm/5c/dnj8ycJppNPKfQ57y7kp4YvnWt3a1G3Omvdb7xNy3X2lw1TiXJ684+8IWXb19OG5ABvCAAADF1e4VtptetlJqOI583sjn/K2tyVcX3G1K1T/vkvPyI5yvp95zvejL7XLi1HSiPnKyxKeGjXxWHDv2Q5W10RfUHnA5O2DWdeaVqscu2ExybeZe9n5HvJ5rqDVZhDM4LzeMHR6SxTivJIgFGC9rDP9S/M6BH6q+BvG6ERw3Z9n3Qc2ecPQDG1O6jZ2c6zxlLEV5vsbfduU2qJrrnSI5oURMzpCNcX3Xt7uFvF5jS3fxNE4b9jJkp1ajk25Tk8582xOlOEpRnHlkniS8jkudk15d+rIq6TP+3yXFuIopiljcm7Dj9xf5cscvpsiFq96rHIsZa3HLtgv+za/wDgcncGrHlDbpudC0mbnpltN9XSj+RBeTbPcmXDVb2uk002uam3Fm2bpXYjIrt+MfSUTMjWmJbIAG/K4AAAtXdxTtbederLEIrL9S5OUYQc5tRillt9iIcQak76qqdJv2EHt/c/Mq9q7TowLPFPrT0j+dzLZtTcq0avUrid/eTuZpxcui8l5Ej4MsVStp3co4nU92P+VGhs7Wd1dU7eGc1JYfou7J5QpQo0YUoLEYJJGtbtYtWTkVZl3np9Z/CXlV8NMUQrABvKvAAAAAAAADXcSV3Q0avJfWkuRfPY2JH+M6maNvQT3cnJr4f/ACV21r/YYVyuOun15MtmniriES5NiVcD26jb17n7Upci+CI5yPyJpwxTVLRaCUUubMn82zSt17PaZvFP+MTP2TsurS3p4tkQLiOgqWsXKSwpSU/vRPSKcX0mtRp1NsSh+RsW9FrjwuLwmPwjYlWlaOcnbDPeXbZZwX1HrsOVpY7HOlnqx3Hy2HIjI5fIcj6dD50NVejxxrNl/wDmidDILodLm1i026VM9PJNk6OgbpR/ytc/+32hXZk61whnjHDn4Pb7xuIP80cUe1Oed2tztnjHj/Yuo23tXp9PicUlyqK5M7rHxNzteq3rdbngzH/tP2fSmly5tMtZedGD/wDKi7crmt6kfODX4FnR/wD9EWf/AOCH/pRkVP8ADl8GRZ6OeV8q59r53uotXNSKSxGT6Fpt4y1levcv3z/36tiWMVJbfMxsJvdPC7nIao9KW1xzhsuF3jiDT5Pr9Ijt8zv5898PrGuWOW1/Phs36n0Iuhum6n9q57Y+im2r69IADa1UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMTWG1pdy1/3bIu3hMlOsLOl3K86bItI5/vh/wBRb9n3WWD6sqGuu5maHvqlL5/kYctl6mZomXqdHHZv8ig2X/1tr/6j6pV3+3V7EqAB19RorrUU9Wr+fu/kYnJ1Njq0c6lWfm1+Ricvocj2rV/zt2f/AGn6rS36kLPJsFDbYv8AKzzlZA0e9Vjkx8xyfcX+X4Bx79gar+gxxq1LptGX5EoI5occarT2+xL9CRnSN1o/5H3z9kDJ9cABsaOAAAAAAAAAAAAAAAAGm4q3oUI9nN7fI3JpuJU27ddssqNvVcOz7mnh94ZbH9yGhcO+Byl/lTWw5MHLNVlqscvoOV+Rf5RybYGsmrH5X5G84Wjh1ntnY1fKzbcNrE6y9EXW7s//AMjbj2/SWK/P9OW6AB1BWgAAt3U1Ttqs39mDf4EKjDC33JZrlT2em1NsuWI/eyNuPzNC3uu63rdvwiZ+P+ybixpEyschVQpc9enHDzKSX4l1xRl6PS59RpY6R95muYVrtsmiiO+Y+qRXVpTMpMlhJLsY+pZ/h9xjr7OX5GQWNR3sK6/8OX5HWsjlZq08J+irp6whrjtsOTb0L/IeuBxvXVb6rDgecrz6ovuL8xyA1WOT8SqjB+2ptLLVSL/FF1RQ5XHePVbo92quGumrzfJ6aJkDynLmpxl5pM9OzROsaqgAB9B7LJC7xqtdVam7Uptolt/WVC0qVG+iwvV9iJ8m2DSt7r/9uzHnP2j7pmJHWVjl88hweVhZfRIyOT5l/T6Lq31GGNubL+C3NQxrU3rtNuO+YhLqq0jVJrOn7G1pUsY5YJP7i6AdippimmKY7lRM6o9xZHmuLd+UJfmjTKL6YN7xKs16X+X9TU8n3nMN4J//AJG57vpCysT/AE4WOX0DhjfBfcA4IpYlm1Y/JuJxfK8YZkcocFttseqI9KNSZTCgsUKa/tX5EU1ubranWlnKi+VfBEqUuS3U/KGfwIhUXPOUmvrNvBvO9d/gx7dqO+dfhH7oWLHpTLH5fTobupYY4cjKMW6kc1fXH/wa6lR9rVp0ln35KOxMFGKgoJe6ljHoQN29n05NF6qvpMcPx/kMmRc4ZjRBuTZ9TxR9NzP1G29heTpJYS3j8GY6hk1m/aqs3Zt19YnRIiqJjWFhx8kHHfP5F/k2HIYtX3VYcdi5bVJ29xCrTk1KDyV8o5PLc9W7lVFUVUzpMHKeUpdZ3ELq3jWpvaS3Xk/IvEZ0i8dnW5ZP+TN+96PzJNFqSTTyn0Z1PZG0qc+xFX+UdY/nirLtvgqA3hZYNfrl0qFr7KL/AJlXZY7LuydlZFGNZqu19Ih4ppmqdIR3U630q9qVsvlbxHPkjFUdzIjQlVnGnHOZd12XV/kecnz9Tkd+qu9VN+r/ACmfj1+61jSPRhY5UxyPyL/IsrYKGVujB3vWqxybDlL6h6BQ9A+arMIZlHbbmROofVXwIW4bZxkmFnUVW1pVI9HFG6boXI1u0d/Kfqh5cdJXSLcRXf0q49lB5p0n1Xd9za61qHsqboUJfzJfWa+yv3I84tvPd9RvNtWmY/SWp/8Ar8fl9xrek8cr+hWn0jUIZjmFP35fLoW9XpKnqdeK6c2fv3N/w7a+xtHVa96q859OxhcS0MXdOsksTjhv1X/yRsnZc2djU1zHpaxVPsnl+Hqm7re0aLHoOUv8mOwcFnoapqlasflw+h7y7bF/kQ5F0wINVhR2NxwvcKjczt5PEaiyvijW8pVFSjJSi3GSeU/JkzZ+bVh5FN6nu+ne8XKeOmYTUGq0/V6VSChdP2dRLeT+rL9jNqX1nCPNK5ppf5jqVjaGNftxcorjT2qybdUTpMMgpqThTg5zkoxXVs1tzrVCCaoQnVfnjCNLfXde8lmrLEV0iuiKvP3ixcaJi3PHV5dPfLJbx6quvJd1rVJ3bdGjlUF98jV8uxe5MdDL0qy+l3Sg1/LjvP4eRotVzI2plRxTrVVy8o/ZOjhtUtlwvZeypO6nHEqm0fgbo8ilGKilhJYSPTqGFiUYlimzR0hW11zXVrIACU8AAAAAAAABGOK3GV/Tj3jT/NknIvxDHOqzf9kUa9vPVpgTHjMJGN/cajk7k20qKhptvFdqa/IiHJsTHT/+w0P/AMa/Ipd0NO1ueyPqzZc8oXyP8XRy7d4y9yQEf4okpXFKH9MWy/3jmI2fXr5fWGDH/uQ0HKsDk6Nl5x9A4+nwOY8llqscqzseuGC9yocq8j5rq+6s3helJ6opr6sINv57EsNJwrQ5YVq7TXM1FfI3Z07dyxNrAo179Z+P7KzJq1uSh3jDn/Yyph4/n08/ecUk8PPNzLPyR2vxh/8A1Lqf/mp/mcVy4xSab9DZbOujft1P+in/AOp+kPpDRcfweyx0+j0//SjKn9SXwMXRf/0NZZ//AJen/wClGVP6kvgR5c+uf3J9r541PH024X/iyX4ljLUPJevmX9Qwr2u0nn2kvzZZS5mllLbY5BX60tqjoyNDlnWrF4X+PHHn1PoZdEfPnD8X/HLFNJ4rxz6bn0Guhum6v9q57YU+1fWpAAbWqQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjass6bcL/AMN/kRV7kr1LfT7j/wDHL8iKNmg74f37Xsn6rLB9WVD6sy9EeNSpfExJY8y/pbxqdu84XOa1s2rTLtT/AO0fVKuc6J9iXgA7Go2g1KP+/wBV9d1+Rj8m3Qzb9f75V77/AKFjG5yHac/85dj/ANp+qxon0YWFDqOXYyEkUqKIEw98Szy+gcPQv8uegx6n01VaTFrVKb7ckv0N+aTTljUaTX9Mkbs6Tut/0Pvn7IN/1wAGxsIAAAAAAAAAAAAAAAAafiCLdWh5Ykbg1utrMqPzKbeCNdnXPd9YZbM6Vw07ge8hfcBynLE/iY/IOUv8p7ybH2DiY/KZ+g5jdzj2cTH5TI05uF7T7c2U0WexbnZ59qZ8dPjyeLs60S3YAOsK4AAGq4gm2qVJYw22zVcrM6/qe2u5tfVi+VfLr+JYUPM5Vt3J7fOrqieUcvgsLMcNEQschsuH6P8ANq1muiUYv8X+hhuOE3nY3emUlSs4bYcvefzJu6+N2ub2k9KY19/SHi/XpToySzex57OtDzpyX4F4NZTT6M6NXTxUzT4oUIlTXPThPzSZVyYLtOnyxUWvq+792xVybnF6qeGZie5acSxyDkL/AC+g5X0wfH3VY5MdA4F/l8hyiXzibzTpOdjRb2fKkzIMHR6maEqbe8X+BnHXtnX4v4tu5HfEK2uNKpgAPJNRi5SaSW7ZNnk8tXxBUzCnQT6vma/I1HJuZlzUdxXlVawm9l6Fvl+45RtjM/WZddyOnSPZCxtRwU6MfkNpoFH36ld4wvdXx7mFy7PbJvtPo+wtIQfXq/iyx3XxO2yu1npRHzno8ZFelOnivgA6MgtLxAs3FPb7H6mt5Dba5/2iksfYb/H/AFMDl6bHLd4OW0bvu+kLCzPoQx+Xsj3lL6jv0HKU0MvEx+Xc8lBuDSW7Rk8jPOViJ0NW4u5yWjtp4k6aRoOXc2FSvz6fTt2nzxn+C6MxnHzL3b2bTl3Lc0TyimPjPVhsxwxOq5o1Ln1CDz9ROXQkRq9Chh1p4wk1Ffdn9TaG4bt2OywKZnrVrKNfq1ra3Xrb2lFV4r3qfX4Gj5CWyipRcWsprDI9c0HRrzpvt09UUO9Wz+C5GVRHKeU+3un+eDNj3OXDLE5fMchf5Ry+ZqCTqx+Ucpkcg5d+g0NWOo+hn6fqM7ZKnUi50l5dYljk7HnKScPNvYdztLU6T/OrzXTTXGkt6tQtHT51WXw7/caG9rzuriVaSwukU+yPeT0CiWW0du5G0LcW6o0jy75eLdqmidWXodvl1q8o7KPLH49zWpIk1hQ9haQpvq1mXxZo69FU604LpGTJm2dnziYOPGnONdfbOkvNq5xVyxeXsOV4L/IORI1hn1WFH1yOUv8AIecvofOj7qs8uxXCpVhTdOFacYvqlJpFzk2HJ6GSi5XbnWidPY+TpPVYay89S5a2zubmFFdG/ea7R7lXLjd7G50a29lRdWS9+p0z2RabF2fOdlRFXqxzn8e9ju3OGlnRioxUYrCSwkYurUPb2cklmUfeRlg6dfsU3rVVqrpMaK+mqYnVEOXfpkcvobHUbV0LhuK/lz3i/wA0YvLtg5HlY9eLeqtVxzhZ01xVGsLHL6BxL/KechF1etVhR+QcGZHIFFA1Y/L2PeXJf5MDkPpqsch5y9cl/lQ5HnCWW3hJdxETVMRHU1WaVKdSpGnTjzTk8JEn0+1haW6px3l1lLzZZ0qyVvD2lTDqy6/2ryM46Pu/sf8AR2+1ux6c/KPz4oF+7xzpHQABsjAAAAAAAAAAAAR3XYr+Iyb7xRIjS69T/wB6hPH1oY+5mvbz0cWBM+Ewz486VtRypok+kT59NoPGPcx92xH+X0NtoNZKnK2nJZTzD1XdGt7q5MW8uaKv8o+cfyWfJjWjVtCM6xUVbUKuHlR937je391G2oyaadRr3I+bI9KMpScpPMm935lnvZm08FONTPPXWfsx41PPiWOVZPOX0L/JgOGxoqZqsch6qbk1CEcybwl5sv8AIbHRLXmqu5mvdjtH1fmT9nYVWbkU2qenf7O94rucNOrZ2VCNtbQoxXRb+r7l4A63RRTbpimnpCtmdeaGeMe/Bso+den+ZxSpNwoyezxHOfgdn8Zp8vClOGfr3MV+DOMwpuS5O0ttyXZ9V0XdflgTPnP2fSej/wD6Js+38iH/AKUZFZ4ozflFstadHk0+2h/TSivwR7fy5bG4l5UpP8CLVOkTLnlXOufa+fbmWbyrL+6T377mPUeOX4t4SKqk3zuTTy29+xTKWVn8u5yCr1tW2RGjO4cfNr9jHCz7eHT4n0Euh8/8Jpy4k09Jf/cR6/E+gDdt1Y/pXPbH0Uu1fXpAAbUqgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABZvs/Qq+Ovs5fkRJtYT8yYV1zUKkfOLX4ENp59lBP8ApRou+NPp2qvb9lhg9JJFyx2v6D8qkfzLbznqe0ZKFzTl0xNZ+81LFnhv0T5x9U6rnTMJoAt1kHZ1C0eoS/36svJr8ixzFWpvGpV/+X8jH5jke1Y0zbv/ANSsbcejC9zY7hyLXNt3POfzID3ovc3YZ9S1zd1k85mfNDRmWE8X9BPvJr/ys3pGrWcle0Gn0qLPz2JKdD3Sr1xKqfCr7Qh5EaVQAA2lHAAAAAAAAAAAAAAAADX63lUqUl2nh/NGwMXVoc1hUxnMfe29CBtWz22Hcojwn8vdudKoafm2HNuWuYZ7nIlhovcyPOYtc3qFIdTRd5sFVOajWpzbfuyTLDkFI9265t1xVHWOZNOsJOnlZQMPSa6q2qi3mUNn8OxmHYsXIpyLNN2npMK2qJpnSQs3tX2NtOa+tjEfiXjSapdKtWUYPNOHT1ZB2xtCMLGqr19KeUe39nu1Rx1aLCawe825a5tgpepyiecp+i/TpuvUjQW/O8P0Xc36SSSWyRrNEo7SuH3XLH4dzZnSt2sP9PidpV1r5+7u/KFfq1q0AAbEwtJfJU7upHzfMtvMs8yM7W6bShWXRe6/0NZzZOVbcxZx82unumdY96faniphdyMrBa5vie8xVMmi5lZDaLXN6hSPPU0ZVrXVvcKo37r2l8DeJppNPKfQjXNtgvW95XoLlhUTj/S1lI2nYW3aMKibN7Xh7vJgu2Zq5w35rdTuoyzQpyTS+u1+Rh1b+5qR5XNRXflWDH5upJ2vvLTetTZxonn1mfs+W7ExOtS7nYZRb5jzm/E02I58kjRmWFL21xGP2Ye9L9jdGNp1B0LdKSXPLeRknVNh7P8A0WLFNXrTzn8e5Au1cVQAC4Y2t1mK56NR+sf1/QwMo2mswUrPnef5clLb7v1NPzHNt6LPBncXdVET9vsm2OdK7lYPMotqQ5smuM2i7sNsFrm67jm9T7qaLm3Y92yWuY8lNpPHXsKdZnSHzRu9Jhy2UXnPO3L8dvwMsppR5KUI+UUio7Ji2os2aLcd0RCuqnWdQwtVt/aU1WgszgvvRmg+ZeNRlWarVfSSmqaZ1hHlh9D3CMjU7f2FT2kf8OT6f0sw+Y5NmYdzEvTaudY+nisKZiqNYV4TGPNlHN6nvMRdHrRVheY2KOZ9g5M+CvlXTJk6fQ9tcRk0nCDy/V9jEhzzmoQ3k3sje2dBW9FQW8usn5s2TdzZs5OR2tUehT857oYb1fDGi8ajVaXLd8/aos59V/7RtyxfUPb0HFY51vF+pue2cKczEqt09Y5x7YRrdXDVq0vKhyopbcW4vqnhjmZymY0nTROVYQ5UU8245j5HMVYHKU82xct6dS4qezp7ecsdDLZsV3q4t0RrMkzpGsrtjbfSK3vf4cHmXq/I3RRQpRo0lTgtl+JWdU2Ts6nAsRR1qnnM+aBcr451AAWbwt3NGFek6c+/R+TNLWoToTcKi+El0ZvimrThVg4VIqSKXa+xre0KdY5Vx0n7Sy27k0I/yYHKupm3VhWhvRfPHyb3MKbcHyzXK/J7HO8zZ2TiVTF2nSPHu+KXTXFXSTlQ5RzZPOb1IT095cocp5GfNPljmUumIrLM2hYV6jUqn8uOd092TMXZ+TlzpaomfPu+LzVXFPViRhKUlCMeaT6JG0sLGNH+ZUxKr28o/AyLe3pUE/Zxw31b6sum+bI3ft4Uxcu+lX8o9n5Rbl6auUdAAGxsIAAAAAAAAAAAAAGHq9L2ltzrOYPPyMwNJpprKZGy8anJsVWaulUaPVNXDOqOKAcPMyr23lbSzu6bez8vQx3I5LkY13EuzbuRpMJ9NXFGsKOTfPfpnuORlfMFIj6zVOsvqjkHJsV825l2tlVqtSqe5Dt5sl4eBfzK+C1Tr9I9r5VXFMayx7O1lc1cJNU0/fl+hvacIwgoQSUYrCSPKcI04KEIpRXZFR0vZOyrez7XDHOqes/zuQrlya5AAWrG59431eXRbCi/+JcN5+EWcrsIKd/bRy3mtFNP4o6X45zi6GlUn9bnqyxn0iv1OdaBD2utWMJJtu4h+aJNvlRq6RsD0NlxV/8AU/V9G0ly0oLyikY2tSUdHvZN4St5v/ysy10Rq+Lqns+GNSn/AP28196wQb88NqqfKXOqI1rj2uCyT5cZ22PG/dXVPPkVR6qSfTt3Ram/e88+RyOG2RGrbcGpT4o09Y95XC+Z3w4VwFT9pxdp/Kn9fO3kkd1N63Wp0x658/spNqTrcj2AANnVYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMhb6tY6Nr7iaEQvIezua0PKo/zNN3xo1tWqvCZj4/7J2DPOYWH8DyKxKLe256ymXT1NEonSYlZJvDeEX6HpZspc9nRn5wT/AvHardXFTEqCY0lHtbjy6jKX9UUzCUuxm8Rtq+j/S4Lf5mtU9vM5Xtqjhz7vtWVrnRC7kc2xaz8BzdOhV6Mmi7zZHMy1z7oc3fYGjIoz5K9OWekk/xJWt1khnN8CX20+e3pz84pm77n3OV2j2T9UPKjpK4ADdEQAAAAAAAAAAAAAAAAPJJSi4vo1g9AmNRFaylSr1KT6wk10/8AfYoUjY8RUeSrC4WMT92Xx7Gqzv6HJNqYc4eVXb7teXslZ26uOnVc5up7zMtZ+DHMivZF1S2yeczyW0wnv2EQMq2ualvV56b+Kfc2Udap4xK3qZ/tawaPm8wn6lphbYysKngtVcvCebFXapr5y2N3qda4jyxj7KD7J5bMTmLPMs+g5vIi5Wbey6+O9VrL1TRFMaQu8xcoQlWrRpQ+tJ4z5epjOSSN/oVo6VH29SOJ1OifZEvZGz5zsmKP8Y5z7P3ebtfBTqz6NONKlGnBbRWEVgHVaaYpjSOitAAfRbuaUa9CdKfSS+71IzUUqdSUJ55ovDJUarXLJ1F9JpJuSWJL08zWd5NmTlWYvW49Kn5x+yRYucM6S1PPkcxa5vI8yc6TtF7nHMWshNZ6j2mi7zfEcxa5sIZEmi7zNBSLSkExqLrl37my0a0dSp7eqnyxfup935mHptnK8q9WqUX70vP0RJIQjCChBJRSwkbdu5sabtcZV6PRjpHjPii37ukcMPQAb6hgAApqwVSnKEuklhkZqJ06sqc8pxeCUGs1qxdaP0ijFupFYcV9pfua5vHs2rLsxctxrVT84Z7FyKZ0nvady3HNsW28PDWMdmObG+Tm8xMdU9dUkxzFrIUhp3Gi7zMuWsfaXVKHnNZMbmNno1pVlcQuJwcYR3WdsljsrFryMqiKY1jWNfYx3JimmW8AB1pWgAApqQjUg4TWYvqaG+tZ2tR5y6b+rIkBTVpwqQcJxUovsyo2tsm3tC3pPKqOk/nyZLdyaJRhS67hS2Nhd6RNScrafMv6ZdvmYTs7xYzb1OvZZOfZGxs2xVw1W5nzjnCdTdoqjqo5hFylJKKbfoZNvpl1UfvxVKPdy6/cbaysaNr70cym1vKRNwN3crJmJuRwU+fX3Q8V3qaenNRpll7CPtKuHUf/AJUZoB0PFxbeLai1ajSIQqqpqnWQAEh5YWoWKrv2lLEanfykaWsp0Z8lSLg/VEnPJRjJYlFNeqNe2lu9YzKpuUzw1T18J9zNbvTRyRfn9Q5b+rJI7ag+tGH/AElUaVKLzGnFP0RT07oV6+ldjT2Mv6mPBpbSxr18SknTh5vr8kbm3o06FPkprC7vuy4DZdnbIx8CP6ca1eM9WCu7VX1AAWjGAAAAABTUpwqLE4RkvVZKgfJiJjSRjSsLSX/AgvhsIWFpF5VCDb89zJBg/SWNdeCNfZD1xT4vIQhBYhGMV5JYPQDPERHKHkAB9AAAAAAAAAAAAAAAAAAAeSSkmpJNPszCuNNpT3pTlSfpujOBGycOxlRpepiXqmqaejV/wqef8dY/y/6lUNKjv7SvJ/BYNkCBTsDZ9M6xb+c/l67avxWaFrQotOFNc39T3ZeALS3aotU8NEREeTxMzPUABkfAAAck8cK0nren0NnGNvKTXxl/oRjgej7Xi7S4bf8AaE3t1xk3PjJXjV4vVPDfsaEIvHxb/UwvC6g63GdnKUt6fNLHyJNPK26ViR2Oxdf/AFn56u7Ee8R6jp8GX7XWUYx6+ckiQkR8Wazp8KOmv+LXhH7nn9Cp2jXwYlyf/Wfo55jRrdpjzcflnDWN2jzaUXnZp/Mqwmn1l55KcpJ58vI5XDaEn8Lqbnxhb5f1ISePkdoOR+D9KU+JqtRx92nQe/q2jrh0HdqnTC18ZlQbSnW9p5AANgV4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEV1ePLqVdebT+9EqI3xBFrUW8bOK3NY3st8WFFXhMfdLw50uaNc12KH32K5bFElk5wtYSzRZ+00u3l/Zj7tjMNZwzUU9MUe8Jyj+Of1Nmdh2dc7TEtVeNMfRR3Y0rmGh4q2qUJd2mjSKWUb/iyCdpRqv7NTH3pkc5kaBvLb4NoVT4xE/JOxp1tril0T3HMWuZdxzfEoWfReU8vK6HifqW1Ic3zGnIXebbqSzRantNMoyfZY+4hyk0SXhOq52NSm+tOo8fB7mz7q3eDLmj/VH0Rsqn0NW4AB0NXgAAAAAAAAAAAAAAAABga3efRLN8rxUntD9zDkX6LFuq7X0h9ppmqdIajXbxV7t04PMKW3xff9jXcyzjP4lrOy3ZutN0uF1pPtGuSpKWYS9P2OZRayNsZVddPXr7o7lnrTZpjVqlLAzt1Ka9OpQrSpVYOM49UUZx5lVXRNFU0VRpMMkaTzXeboe82MFnIzujz0fdF7mGdiznc9y0DRc5hzbdS3zbfmbfSNJnWca1yuWl1S7yJeHg3sy5Fu1Gv0j2vFdcURrKvQ7CVaauKy/lLeKf2mSE8jFRioxSSSwkj06fs3Z1vAsxbo698+Mq25cmudZAAWDGAAAAANHq2lyUnXtVldZQXb1Rpm2nhvD9SamFe6Za3TcpQ5Kn9Udm/j5mp7V3apv1TdxuU98d0/hKtZHDyqRfm22eDzmRsq2g3UX/LqQqL7mY1TStQi8K3cl6NGpXNjZtqdKrU/X6JUXaJ72Op7Mc2F6mTDSNQm96PL6uSMm30G4k81qsIL03Z6tbGzrk6Rbn38vqTdtx3tan2Nlpmm1riSqVk6dL8WbWz0q0tpc6hzz/qnvgzjZtnbrRRMV5U6+UdPejXMnXlSppU4Uqap04qMV0SKgDcIiKY0hEAAfQAAAAAYd7p1vc5k4uE39qJq62i3MX/LnCf4EgBVZexcPLq4q6OfjHJlpvV08olHP4RfYxiH/UX6GiVHh1a0Y+aism8BFt7tYFE6zTM+2XqciuWJa6da27zGnzS/qk8mWAXVmxbsU8NumIjyYZmZ5yAAyvgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG8Jt9EBwjxIrKrxnqDW654x+5JfmbTwboylxXUqYTjTt5Zfq2iL8RVXc65qFaMudTrz5X36k88DaLc9TucYSUKa277t/oSauVt0naP8Ay+x5p/8AWI+kOnkD8ZKyWlWdvzY56rl9y/1J4cy8ZakZ3tjQxnlhKT+b/wBDX9u18GBc89Pq0LAjW/S5+08PfGChv3tu76lfWWN8eZRhNbyOatj6OheC9D/fdQuFnCpxgs+beX+SOnEB8F6TjpF/VeHz3CSfoor9yfHS9h0cGDb8+fza3nVa36gAFsiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaLiZYrUZLvFrJvTU8TQ5rWnUx9We/zKfb9vtNn3I8I1+Es+NOl2Efl0wUy2RXLcob26HKVzDe8KSXsq8Ns8ykbsjfDEuW9nHO0oEkOo7t3e02dR5ax81PlxpdlreJaano9Z7+5ie3oyHc3rkn93TVW1q0msqcGsfI53lxbjLKa2fxRQ722dL1u54xp8P92fDnWmYXVL1HM8d8lpy8jzmWNvxNRhM0XuYc2OhacvQZ+8Q+6L2TdcI1lG9qUXs6kMr5f/ACR/myZmjXH0bU6M28R5sP4MsNlX/wBPmW656a/XkxXaOKiYTwAHWVQAAAAAAAAAAAAAAAA8qTjThKc2oxistvsQrVr6V7eyqv8Aw17tNeSNlxXqa/7DRl61GvyI5z9m9jQ95tqdpV+mtzyjr7fD3fVYY1nSOOWTQhKtXp0Y55pyUUTujTjSowpR+rCKSIvwjb+1u53El7tJYXxZKyz3Ww+yx5vVdavpH7sWXXrVw+DGvrKheU+WtDdfVkuqI/faFdUk5W79tHyWzJSC1z9j4udzuU8/GOrDbvVUdECqUq9KXLUo1IvycWi228bpo6CU8kP6I/cUFe6FOvo3eXs/dIjL8YQSlTr1JJQpTk30xFsz7XRr+u050/Yx7ub3+4lySXQEixunj0Trcrmr5PNWXVPSGt0/R7a1xOa9rUXdrZfI2QBsmPjWsajgtU6QjVVTVOsgAM7yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3dXFC1oSr3FWFKnFZlKTwkc64l8TaVKc6Oi2/tUsr6RU+q/8q7/M9RTNXRNw9n5GbVw2adfPu+LpJ4mm8Jo4Df8AFmvX2fbanXjn7NN8i/A11LVNSp3HtYX9zGf9SqyT/MydjLYaN0b80+lciJ9kvpAGh8P7671LhS0vL2fPWnzJy80pNL8jfGGY0atftTZuVW6usTMfAAAYgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADH1SsqGm3NaTwoUpSz8jINB4h3UbXg7UZyeHOl7OPxlsfYjWWbGt9reoo8ZiHBK0uarKbbcstnYPBWjKHC9eu44Va6k4vzSSX5pnH44b95p42Xmd68OrZ2nBmnUpLEnTc3/zNv9TPe5Ro33eq7FGHTR4zHySA5D4q1lV4qlDbFKlGOfXqdeOFcaVvpPFOo1cvkVZxTXTbb9DU957nDiRT4y03ZlOt2Z8mmllNNlMlmHlv08yqTktl8djzrFRT3NChfOzeFturfg+3eMOrOdT8cfoSk1nClv8AReG9Pt8Y5KEcr5GzOsYVvsseijwiPo1W9VxXKqvMABJYgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMHXYOel1sLLiub7nkzi3c01Vt6lJ9JwcfvRgybXbWa7fjEx8nqieGqJQ1+RTL4lTT6PquuCmXV4OMTGk6SvoZWiVHT1Oi8bNuLJcQijN0q8Kix7kkybReYprujf90L3Fj12/Cdfj/src6n0ol6c91qn9H1a5pLP1+bfye50IiHHdF07qhcRW1SLi36r/3+BM3nx+0w+OP8Z1+zHiVaXNPFoOZYxkZ8mslvO/meOSx3WTnS00Xcp9j1y3/QtOXbZnnP5DqaLrfZHvPh5WU10LPN8D3m/wDk+waOjaLcq70yhWzmTjiXxWzMwiHBN+qdedjUltUfND443JedV2TmRl4lFzv6T7YU1+3wVzAACyYgAAAAAAAAAADVcQ6rDT7fkg0689or+n1Zd1vVKOm27lLEq0l7kM9f9CBXlzVubqVetLmnJ5Nc27tmnEom1an05+X7peNj8c8U9FVSrKVRzlJyk92zyPNKSUVmTeyRZ5svJu+EbH6Vf+3nHNKjv8ZdjRMTGry79NqnrM/7ysK6oopmqUq0S0Vlp1Kk177XNN+rM0A61ZtU2bcW6OkRopapmqdZAAZHwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADyTUVmTSXmwPQajUeJdDsHKNzqNCM49Yxll/cjS1vEjhqm2o1bio1/TSe56imZ6QmWtn5V2NaLcz7pTEEKj4l8P8AWUbpf/szP0/jrhu8m4RvvZNf97FxX3jhnwe69l5lEa1Wp+CTAt21xQuaSq29aFWD6ShLKLh5QZiYnSQAB8AAAAAAAAAABAPG24dPQ7SipP8AmV915pI5ElLGHssZydN8ca0ubTaCaUPelL8DmeOVZTzv+BKteq6bu3Rw7Ponxmfq8h091odMYSfm0eYw9sb+pXvOSguj2SSw8syr6eT6B4Ho+w4S02njH8iMvv3/AFNyYmi0/Y6PZ0sY5KMF+CMsgz1cayKuO7VV4zP1AAfGEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgXjXeKjw/bWj/wCPXy/RRX7tE9OR+Nt1z61Z2qllUqLeF1UpP/RHu3GtULrd+z2ufb8ufwQK3p89xSpZwqk0tvXY+ktOoK2sLe3j0p04xXyRwLguzV/xRp9CUJNOupS8sLf9D6EWyPd6eei33uva3LdvwiZ+P+y3d1VQtatd9KcHJ/JZPny5q+1rVK0st1JOTXxeTtnHVw7bhS/nGWJSp8i/5nj9TiE8LsvLqaJvXe1uW7fhEz8f9lPsunSmqpS01jtHPcrs6DrX1GjBc0qlSKXzZb2wknt8Td8B2sbviqxo9lPned9ksms41vtb1NEd8xCzuVcNE1O30IclGEF9mKRWAdbiNGpgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiGowVO9rU0sJTexjSysm04jg4ahzPpOCaNXk4/tSz2OZct+Ez8+a8s1cVESpe6Jfo9b2+mW9TvyJP4rZkRJFwvV57KVJv/AA5bfBl3ulf4Muq3P+UfOP5KPm060a+Dbmq4qs3eaNVjHPtKeKkMea/0ybU8klKLT6NYN/yLNN+1Vbq6TGitoq4aomHKFLAc/gzJ16zlYapWt8NR5uaD80zB5ng5Hes1WblVurrE6L6mYqiJhe5s9TxSa799y1zPtgc3br8DFo+6LvM+/me8zXxLDks7HvMu4jmaMihWnQqwq05OM4vmizo+iajT1GyhWi1zpJVI+TOYKa8zM0fVK2m3arUXzJ7Si+kkXexdqzgXdK/Unr+UfIsdpTy6uogwtI1K21O2Va3lv9qD6xZmnSbdyi7TFdE6xKnmJpnSQAHt8AAAAKK9WlQpOrWqRpwisuUnhI+TMRGsis1Wva3b6ZT5Nqlw1tBdvVmm1viyPLKjpqf/AOV/oiJ1Ks6tSVSpNznJ5bbzlmq7V3jotRNvF51ePdHs8fonWMOaudbKvryteXM69eblKT+S+BY5s7P5Fnmx128j3nNFrrquVTVVOsysop0jSF+iqlarGlBNzk0kvU6To1lGw0+nQWObGZvzZHuCNIxjU663w1Sj/wDvEtN83a2Z2Fv9Rcj0quns/dWZl7ingjpAADaUIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPZZYAxdS1Cy022dxfXNOhTXecsZ9F5kQ408QLPSvaWmmOF1dR2lLrCD/VnK9W1TUNYryr391Urye8c9I+iXYyU25nnLY9mbuX8qIuXfRp+cuh8ReJ0KbnR0W19o0n/Oq7LPoiBavxHrOrOTvdQrVE3vSjLlh8ElsapNvZvGfMyaFheXk1G2ta9ZrfFOm3+RIpoppbpi7LwsKNaaY18Z6/FjyxzRlvJJbBYUW8tJ+XY28OGOIqkHKOjXy8v5LX5mNfaVqdlBq80+6oR6ZqUpKOfjg+6xPJMpyrFU8NNcTPthgRz0Secbs9ccpcuNjxvdtpb42yetx748s56n1nZ+ia1qmkXPtbC7nRfeCfuS+MejOu8D8bWmvRjaXKVvfpbx+zP4fscTaik208d1noXbatUoVqdahOUKtNpxkuqx3MddESqdp7HsZ1EzMaVd0/nxfSwI5wBxB/H9GVStyq7ovkrJd/KXzJGRpjRzG/YrsXJt1xzgAB8YVNWpClTlUqSUIRWZSbwkjmHFfiTW9vO10FRjBbfSJxy38E/1Nx4w6tOy0SnY0ZYndyanvvyLqccglJbZ3XR9DNboiY1luW7uxbV63+pvxrHdHd7Umo8d8TUbiNb+JzqJ7uM4RcX8sbE94H4+t9ZuI2Goxp213L/Dafu1H5ejOObxSjnmaW+ehXQnKnVjVhtUptSi12aMlVuJhsGbsPEybc0xRFM90xyfTINHwNq71rhu3vKjXtUuSpj+pG8I0xo5letVWblVurrE6OSeN9Tm1myo5+rQb+bZz7ulJ/Nk28Y5SlxfCDjlRt4Y+eckLWGnFpdMbkmj1YdR2JTw4FqPL6rcYt+7nDb6oy7Be1vbeMmuX2sYpfMxVJqpjGWtsG04Zoxr8RafQw97iOVn1MkysL9XDbqq8Il9D0Vy0oJdopFQSwkgQXGZAAAAAAAAAAAAAAAAAAAAAAAAAAAAPJSUVmTSXqwPQaq/4k0KxUvpOq2sZR6xVRSkvktzSXXiNw3Sly06tetLyhTf6n2KZlLtbPyr3Oi3M+6UwBA4+KOiyePod3jPlH9zPs/EPhqu4qdxVt3LvUpvC+aPs0VR3M1eyM6iNZtT8EtBj2F/ZX9FVrK7oXNN/apTUl+BkHlX1UzTOkxzAAHwAAAAAAAAAAAAADg3iNdq+4uvJw6Qn7Pr1xsdzv68LWxr3NSSjClTlOTfZJZPm27re3uqleplOrNybfdszWY56tv3Rsa3bl3wjT4/7Jr4MWbr8S1bpL3Lei2/80tl+p2M5/4JWcaei3l9h81atyJtdort82zoB4uTrUq94b/bZ9enSNI+H7oT4uXKhotC15sOrVy15pHKpPmbeU89EiceL16p6zRtcrFGjl795P8A0RB8NS7fkcz2/e7TOr8tIZ8Gjhsx5qZqPLslt12Jn4PWvtuIq9zKP/Z6Gz7Zk8foyGf8zwdU8HbNUtEubxre4q4W3aP+rZ92BZ7XOo8tZ/nvfc65w2J805AB0hrgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANNxPSXsaVfG8Xyt/E0D+BLNape10yvFdVHmXxW5E+u5zjevH7PMi5HSqPnHL8LXCq1t6eCmXobXheryX86T6Tht8jVMvadW9hf0arbilPEseT2KjZOR+nzLdyekT8p5M96nitzCaAA68o0Z49013FjG9pRzVofWx3iQFVHnudjqQjUhKE0nGSw0+5yzifS6mk6nKnyv2E/epS815fFGkb0bPmmqMqiOU8p+0rPBvaxwSwHJcyyt+/oOZ9l9zLXPzLDXxHM1uupqOix0XlLyeDxSzt1fcttvd4PFJJb9T5oaLuVnbAcsJ4aSLcpJ9Oh4pZx3BozLK9ubOsq1tVdOa7rv6Et0rjKm1GnqNGUX3qU1lfNEHUt89gp98vGSwwdp5OF/aq5eE9GG5YouetDrNrq+mXSTo31CWe3Ok/uMxVKbWVUi/mcZjJJuXftgr9vV7VZrb+pmw297atPTt/Cf90Sdnx3VOwVLm3prNSvTil3ckjXXfEej2zxO9hOWOlNOX5HL3UlLOZSZQm8bNHi5vZdnlbtxHtnX8PVOz6e+U31LjT3XGxt8f31f2RGdQ1O8v5811XdReXRL4I1+H5HvNtgosvamVl6xdr5eHSEmjHot+rC5z7vz8xn3dmWlLutxz7/ALFdozaLrlzbLKRu+FdJnql3maatqbzOXn6IwtB0q41a7VKksUlvUqdor9zpun2dCxtYW1vDlhFfN+psewtjzl1xeux6EfOfwh5WRFuOGnqv04RpwjCCUYxWEl2PQDocRopwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACmpOFOnKpUkowistvokB5Wq06NKVWrOMIRWZSk8JI5J4gcdVtSlPTdHnKnadJ1k8SqY6peS/MseI3GVTVrl6fYVXCwg/ecXvWf7EJWycs7Jki3b75b5sPYEWojIyY9Lujw9vn9CDTeJN80s7kl4V4M1XXJqrTgra1X/GqJpNei7m+8N+CPpkYatrFJfRmuahRkt5+r9Dq1OEKcI06cYwhFYSSwkK7unKH3bG8cWKps43Orvnuj2IvonAmhadGMqtF3lZdZ1t18l0JPRo0qMFClThCK2SisFZaubm3tqbqXFanSgurnJJGCZmWlXsm/k1a3KpqldPJxjOLjOKlF9U1lEfu+NeGrWr7OrqlNy/tTl+RsNL13SNTajY39GtJrPKpb/cNJgqxMiinjqomI8dJR7izgHS9VoTqWMI2V3jMZQXuyfk1+xyDUbC6028qWl9QdOvB4cX0Xrk+kSF+KfDVPVdJlqNvTxe2sW011nDuv1RkouTHKWw7D25ctXIsX6taZ6TPd+zi7w0s5W+Nu4xtnKax2GEur69Vg991ZlF8rZJdCS3wo1J6fxVSoSm1Tu17OSb25ux24+a7C6naajbXcYvmo1I1Ovk8n0jQqKrQp1V0nFS+9Ee9HPVoG9mPwX6Lsf5R9FYAMLU3JfHJN6xp0d1mhLft9Y5884Xvb+aXQ7H4waTO90OnfUYpztJNy2+w+v6HHH0wsZ82SrU+i6bu5fpuYFFMf46xPxe4k+q2TyUfWayn0337nq5vl+B7JLkbSaafTJk6L51rwQqSlol7TbbjG4TXplf6HQSKeFmmT03hWm6seWpcSdVprdJ9PwJWQ651qlybbFym5nXaqemriHitcKrxpcx3xThCCxv2z+pFILZ7Nvqsm+8QqyqcaajKK3Vbl+OEkaD7L9579ESqPVh0vZtHBiWqf/WPo9eG84Sj2ZvfD+PteMdOSXSrnPwRH8Y+qtnvkk3htVt7fjC1r3NaFGlCM5OU3hfVYq9V92hMxi3Jj/TP0d3BD9Y8ROH7GMlRnVvKkXjlpR2+97Gg0/i7X+KtfoWGm042VopxlWcVmSgnl5f4bEaKJmNXNrWxsuuiblVPDTHPWeX7ungA8KoAAAAAAAAANJxdxHacPWDrVsVK80/Y0c4c3+x9iNeUMtmzXeri3bjWZbitVpUabqVqkKcF1lJ4SNNccXcOUKnJPVaDl35cy/I4xxDxJqmtXMq15ctU3tGlBtQivgaeHNh4e+DNFnlzluONulE0a36+fhH5fROm67o+oyUbLUbetJ9Iqe/3GyPmejUq0pKdKo6c494vdHWfCriqvqUJaTqU1K5pR5qNRvecfJ+qPNdvSNYQNq7uVYlub1qripjr4p+ADE1gAIzxPxrpGic1Lnd1dLpSpdn6voj7Ea9Gaxj3civgtU6ykzaSy3hEd1/jPQdHThVu1XrrpSo+9LP5I5VxBxrrusycJ1/otu2/5dF4WPV9yNSXNOWcyeN2vMzU2f8AU2/B3T6VZVXuj8ugaz4n6nXUo6ba07WOViU/el+xEdT17V9RkvpmoV6qb+rzYX4GubxFe6txhLHrtlGWKaYbPjbNxMb+3biPr8ZecsVPfKTzlhppbe8+uX5FTyoczxjOM53RTzw5Vvh9Fnuek7Uy021g8TfNjD3fn0PXH3eZt467BJ5XNhpfeOT7yZNhf3unV417OvVt6ifWLxudT4F4/jqNWGn6wo0rhpcldNcs35PyZyTu2stt9AlKG62ecrD6M8VURVCt2hsvHzqNK40q7p74fTYIj4W6/LWdCdCvJu5s2qc5N/Xj2f6fIlxFmNJ0cuysavGvVWq+sAAPiOAAAAAAAAAACK+KuofQeD7mEcc9y1QS9H9b8MnD3iW0ex0jxuv07mx0+OHyRlVl89kQTh+znfazZ2dJYlWrRWH2Wd/wJNr0adXR93rUY2z+1q79Z938h3PgeyWn8LWNuuvs1N/F7/qbo8pxUIRhFYUVhGHr12rHRru6b/w6UmvjjYiXK4opmqe5z65XVfuzVPWqfq41xndfTuJr65TUoe15IpeUdl+RppeWX8S5WnKVWUtpNvLfmWm45wm89ehyS9dm7cquT3zM/Fs1FPDTFI+XGFn9zufBForLhexo8nLJ01OS9XucT0q2le6nb2qf+LVjF93uz6DowVKjCnHpCKivkbVurY9K5dnyhWbUr0imlUADc1MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADyS5ouL7rBC7qm6VapSl1hJompF+IqXs9SbwsVIqS+PR/kapvbj8eNTdj/GflP8hNwqtK5p8Wta2KJ5ccZx6orf4FDe/U55HJaJrp1b29lSq5y3FZfr3Mg0vClfntqtBvenLK+DN0dh2bk/qcW3d8Y+feor1HBXMLNvdULipWp0pqU6M+Sou8WYuvaXR1XT529RJT605P7MiI8b6pccLcV2mqUk52t7D2dxT6J8uN/jh/gTfT7y3v7KleWtRVKNWPNGSJVy1TdomiuNYlJvYtdiii/T6tXSfOOsOQXtvXsbmdtcwcKsHhpr8fgWObf9DqnFGg0NZtsrFO5gv5dT9H6HL9TsrrTrl293RdOon36NeaZzXa2yLmDXMxzonpP2lYY2RTdjzW3JdHu/MKSSxnDZZUk90stdjxTT79N0U8QlaL3Nh9fkVc3NHbv0x2LOcPPXJ5zd/PyD5ovc3vPtg9TfZ4LGVnKawe82EsSzvgEwuZfNnuj3K75ZaUu6efM95oye/ZB9XE9s5PXJZXbyeS0pLpn/AFPG4ppMPmi9n3t2/PqHLlf5FnKa/H4HsOac/ZwjKcpP3YpZYiNRdyvM3HDuh3Wr1cQTp26+vUa/LzZtuHODatbluNVzCn1VJfWfxJ3b0aVvRjRo0406cViMYrCRtOyt3a7ulzJ5U+HfPt8FfkZkU+jRzlY0uwttOtI21rDlhHv3b82ZQBvVFFNFMU0xpEKqZmZ1kAB6fAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADl3ipxXOdeWhafUxTS/3mcXvL+1P8yW+IfEK4f0OVSlh3Vf3KS8vN/I4TObnL2tWUpSbfM29233Zmt0a85bdu1sqLtX6q7HKOnt8fd9VHK8eS889CZ+F/DMdavnfXlPms7eSyn0qS6pEW06zq399Qs7dN1K01GKS26n0NoWnUdJ0q3sKEUo0opNpdX3Z7uV6RpC63i2pOJY7KifSq+UMyMVGKjFJJLCS7HoPKklCnKTeEk2RnN+qFeIHG8NDk7CwhCtfNe85P3aS/V+hybUdS1C/rTq315VuJy680v06FOs3NW91q6u5uVVzrSfM/j+xiPM3s1lbEuiiKYdU2XsqzhWo0j0pjnPe9UXlYxv3Jb4TW0K3GNGSTapU5TeOz6dSJxj0WE0vP8zovgfbt6hqF1y4ioKK+LeRXypl621d7PBuz5afHk6qeTipwcJLKaw0egiOUvnni2w/hnEl9ZwfLGFR8r9HujVd+mV1ZM/GSgqPFqqQS/nW8ZS+KbRC3u0036/EmUc4iXXdm3pv4lu5PWYgan0xutsH0rpycdPt4y6qlFP7kfPnDFl/EOIrGxlGUuevFyWfsp5Z9FJJJJbJdDFe7mq733Ymq1b7+c/HT8AAMDTFNWEKtOVOpFShJYlFrZo5Txh4eXNCvUutFTrW8m5ex25oei80dYB6pqmnon4G0r+BXxWp69Y7pfOz0PWnUVP+FXnOnh/yZYf4Ez4M8PbmpeU73W4eyoQfMqD6zfbPkjqwPc3ZmNFvlb0ZN63NFERTr3x1aPjHW1w3oivYWvtkpxpxgnhLP/wQqXitWa93R49O9X/QlviVZzveEbuFNZnTxUS+D3/A4PPbGXhPbZn23TFUc03d7ZmHmY81XadaonxllaxeVdS1S4v5QVOdebm4p5Sz6mK8rlwnh7YQp4TzlPKzueyS2ljOO7JEcuUN2opiiIpp6QLDfurvjGTzLezeH8AksqTWOu+Cd+Ddja3ut3dW6t6db2FOMqfPFPlk21lHyqYpjVGzcqMSxVemNeFq+FuCtV1qcZulK2tnv7aouq9F3Ov8MaBYaBYRtrSDlNr+ZWl9ao/N/sbZJJYSSXoCLVXNTm20ttZGfOlXKnwj7+IARTxA4shw/aqhbRVW+qpuC7QX9T/Y8xEzOkK/GxrmTdi1ajWZbvWdZ03SKPtb+6hSz0jnMn8EQ3UvFHT6TasrCvcNPaU2opnL72+ur68nc3VxKtWk8ucnnOTGl9Vb43M8Wo729Ym6uNbiO3map+Efl0ql4rVXU9/R6fJ5qs8/kb7SfEbQ7ypGlcKraTfeazH70cl0nTb7Vq/0extZ16mMvkWy+LMWvRqW9eVK4pyhVg3GUWt0/U+zapnoz3d3tnXJmimNKo8J5/CX0nbV6NzRjWt6sKtOazGUHlNFw4TwPxVdcP6hyuUqlhN/zqWdl/dHyZ3K1r0rm2p3FGSlTqRUotd0zDXRNMtM2rsq5s+5EVc6Z6T/ADvLmtTt7epXqy5adOLlJ+SRwDi3Wq+u63XvZyxBPlpQztGC6HW/FK8dpwdd461sUvvZwx7ZlHDyuvkZbNPe2PdPDp4K8iY59I+59VNOPXzNjw3ptfWNboafSag68sSePqxSy2a2Kb5X0bfQlPhZWVHja0U1tNTim+3usyVcoltGdcqtY1yujrETLoFbw40D+Gyt6Ma0bjl2rueXzebXT5HPeDlX0rj61takV7ancSoz/JndTmEtOV34y1fZUlyUHGtUkuz5F1+bMFNUzrq0fZW07ty3ft36pqjhmefw+7p5iarqVlpdpK6vriFGnHvJ7v0S7s1fGPFFlw7aKVTFa6n/AIVFPd+r8kcV4h1zUNev3d3tVuPSFJP3YL0R8ptzPPuRdk7Cu53p1+jR4+Ps/KTcY+IV9qLla6VzWlpnEp/8Sa+PZEH525vmlzPK6nuM4hFc2WunXPkS7hvw/wBY1RRrXGbC2e+ai95/8pnjhohvVMYWyrOnKmPnP3lEFs8YyuyZttI4e1rU3H6FYVZqW/O44j97OucPcCaDpEo1nQd3cr/i198P0XREojFRWIpJeSRjm94NfzN7KYnhx6NfOfw5RpXhdf1Ixeo39K3T3lGnHmfw8iSWPhrw7btSrq5uZp59+phfciaAxzcqlr1/bufe63Jj2cmmocLcO0I4p6RafOnn8zJ/gmj8vL/DLTHl7JGwB51lXVZN6qdZrn4y0d/wlw7ew5a2lW6faUFytfcQTivw1q28J3Wi1ZV6ccy9hP6y+D7nVwfYrmE3D2xl4lUTRXMx4Tzh8z1Y1IVZU6kHGcNpRaxh+pQ8vZpZWPgdU8W+GqcrV6/ZU+WtTaVxGK+sntzHKYyTbbbWOnqSqKoqjk6Rs3Poz7EXaOXjHhKdeDFxOlxNWouTUK1Frl7Np5ydjON+DdFVOKas44xToOT892kdkI931mi7z6fr508IAAY2vAAAAAAAAABrOKdSWk6Bd3+zlTpvkT7yeyX3iI1e7duq5XFFPWeTivHWofxPi29rOSlThUdKGHtyx2Nz4M6e7niWreVFlWlJvOOspbL8MkJc5Tqe0lHu846ZOx+Denu14andzjyzu6rkv8q2RKuejTo6NtquMLZnZU98RTH3+SbkQ8Vr5W3D6tVLE7meMeaW7/Ql5yrxYvnca9C0hJuFtSSa7c0nl/hg17buR2GFX4zy+P7NBwbfHejy5oW+Xmaz6FLXvtJJY6ZK2ot7tfFdimUU231z0OaNiSnwssXd8VQrzw421OVR7d+i/NnYSCeD1i6WmXd7JLNaooReO0f9WTs6Ru/j9jhUzPWrn/Pc17Pucd6fIABdIYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABqOKKPPaQrLGact36M25ZvqPt7OrR/qi0iHtDH/U41drxj593zZLVfBXFSFvo31KW+5VNYyn17lLz1OOzGnJes/hyv7HVYxb92qnB/HsS0gKk4TVSLxKLTXxROrWqq9tTrR6TipHQN0srjsV2J/xnWPZP7qzOo0qirxRfxW0x6jwnVnCDlVtZKtFL02f4NnN+B+LLrhy6VOpzVdPqSzUpp55X3lH19O53C6owubapb1FmFSLjJejR85ava1NN1a6sasWp0qrgl6Jm6W+cTS2Xdvs8vHuYd2NY6/H8PojTL+01Kyp3llXjWoVFmMov8H5P0LWs6TY6tbexvKKnj6sltKL9Gc88E9R5Kt5pc5YjPFWnF+a2f6HUTBdtU1RNFcaw1zaOJVgZVVqJ6dJ8nL9e4P1HT3KtaRd1bx39366Xqv2IvJyj7vLyvO6wd4NZqmgaVqOXc2kOd/bisS+81PN3Xornix6tPKej1Z2hMcrkauNqXMstd9w3ulnq9ie33h7Tbk7K/lDL2jVjlL5o1F1wHrlNP2U7asv7ZuP5o1+9sLOtf8Ab19nNOpy7NX+SMc6fVHspPCeDcVOEeI4PbTpz75VSG/3spjwlxG5Y/hk0vOVSH6Mif8ADsvX+1V8JZO2tf6o+LUOUY7PL9SptLrjJIbfgbXq0V7SNvQ36SqZx9yNlaeHlxJt3moU457Uot/ngkW9i51zpbn38vq8VZVmn/JCnLLwl82XaVGtXqKnQpTqzbwlGOcnTNP4H0e2cZVVVuJL+uWz+SN/Z2VpZwULW3p0or+mOC2x91r9X96qKfZzlGubRoj1I1c70XgnUrlxne8tpT8m8zfy7E30TQNO0lZt6PNVfWpPeX+htQbNhbHxcPnRTrV4z1V93KuXes8gAFojgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG0k23hIEa8SNWelcM13Tmo1q/8qnvh79WvkfYjWdGbHsVX7tNqnrM6OV+IWsy1viGtKM27ai+SiuzS7kdSftHn6voup7HDbUlnHfz9SnLccLfD2JkRpGjr2PYpsWqbVHSI0dB8FtJ9vqVxqlSOYW65Kbf9b/ZfmdbIv4X2CseEbfMcTrt1ZPzz0/DBKCLXOtTmO3MqcnNrq7o5R7g1nFVzG04b1G4lJxUbaeGuzaaRsyKeK9x7Dgu6ipcsq0oU0/8AmX6I8xGsoeDb7XJt0eMx9XDoN8nx3QlzNJrbD+AgorOJJNdPJjlxJJvMV1ZNdhVbprZvboux13wUt3T0C6rOLXtK+E35JHIcvfDWFsdz8LaMqXBVk5LDqc0/jlvH4GK7PJrW9NzgwuHxmPylABRcVYUKE61R4hCLlJ+iIznURrOkOMeMN2q3F7oxWVRoRjn1eX+xDFvJJrp0a32NjxFqEtT1i6vpbKrUcl547fgVcO6VX1vU6On2yac370sbRj3ZMj0aYdbw6Yw8OiK+UUxz+6beDGjurd19ZqxjyUv5VLb7Xdr5fmdUMTRtOt9K02jYWseWlSjher7syyLVVxTq5ntTNnNyarvd3ewAB5V4DScS8UaToNJu7rc9b7NGnvN/sc21zxI1m75o2EIWdN7Ll96Xxyz3TRNXRbYOxcvNjiop0p8Z5Q7JlA+drnXdZuKjlW1W6k843qtYJb4Xa/rlzxFT0+peSr2zi3ONR8zikuz+OD1NqYjVYZW7F7Hs1XZridI173WqtOFWlKnUipQkmpJ90c2v/DGDvq1WjqPs7PDkoOGZR9DpZjarP2emXVT+mlJ/geKapjop8HPyMSqYs1aavm6tFKUkk0otr1ZTLlTwsLG/wEZNtpxznfLC/t3z6bk3o65GunN6pdeZb+vQ6P4Fp/TNUl29nBfiznDymk1vhvc6l4G0v901Kv3dSMfwz+piu+qpd4quHZ9zz0+sOkgAiuXsbVL2jp2nV764ly0qMHOT+B8967qFzquo3N/XnmVWWVntHssfA6d40ak7fR7bToOS+kz5ptP7Me33nIk3nD6eRIs08tW/7q4UUWJyJjnV09kfu8klHGcpdSraMHJZae/qedW4+S2Rl6FaO91a0tWsRrVYwePLJl7m1XK4oomqe52jw00SGkcOUqs6eLq7Sq1W1us9I/JHNfFa19hxlczppxU4xqfFtbs7lTioU4wXSKSRxzxnjH/aek8PLoL8zBbqnj1aDu9lV3tp1XKp51RKCx2a6JPdnZPBvVZXmg1rGpLM7SpiOXvyNZX45OO7Rg8rr2W50TwPm1quoRWMTowb89m/9TJdiJp1bHvHZpu4Fcz/AI6THx/dIfGbfhWCxlO4jn8TjTbaXKvdff4HcPFe3lX4NuJxw3RlGp9zOHptJPovQ+Wp9FH3VqicKY8Jn7KoyxT3+HyMnRrr6FqlpermSoVoyaTw8JmM3mXLjOxTHPryry3MkxrDYq6Irpmme99MW1WNe3p1oPMakVJfBoiXGnEOmcMO4lZUaMtWu0nPC38k5foiOaVx7T07gijbx/m6lTzRhF9EsbSZALirc6hdzr1qk6lerJyk2m22YKbfPm0bZm7tc3qqsjlRTOn/ANafZ5qN3cXt5Vvbms61ao25Tk+vwNrwtwtqnENbmtqXs7dS96tPaK+HmyV8CeH060Kd/r0OSH1qdvn3n/m8vgdQt6NK3oxo0KcadOCxGMVhJH2q5pyhO2nvHbxo7HFiJmOWvdHs8fojvCvBekaFGNWNJXN31daostP0XYkwBhmZnq0i/kXcivju1ayAA+MIAAAAAAADD12lCto15SqJOMqM0/uPnGL2WFzLPu7dfkfSeowqVLC4p0knUnTlGKfm0QzhDw+t9NrRvdVqQurlbxgl7kH+rMtFUUxOrZ9hbUs4Fi7Nyec6aR49WT4V6BPSNFldXMOW5u2pNPrGHZfqTELZYBjmdZ1UGXk15V6q9X1kAB8RwAAAAAAAA55416j7PTLXTYTxKtPnmsdl0/E6GcH8RtV/ivFl5KDfsaD9hB9U0tm/vyZLca1L/dvF7fNiqelPP8I/QoTqVoUaMearOajGC+1JvCPo3R7OGn6XbWUPq0aaj+Bxvwr0xahxXSqVKadOzXtpekl9X8fyO3nq9PPRP3syuO9RYj/GNZ9s/wA+aivUjRozqzeIwi5P4I4PrN3K+1W5u3J5q1G8+nb8DrPiLffQuF7hRlipXxSjjrv1/A43NLlccNGib05HFXRYju5yqdmW9KZr8VHRbx2KZNN+738irCTa/M2vCOnS1TiSytnH3Pac9TG/ux3f7Gr2LU3rlNunrM6LSquKKZqnudf4Rsv4fw5ZW2EpKkpSwu73ZtQkksLoDrVu3FuiKI6RyarVVNUzMgAPbyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIhrVD2GpVo4fLJ88fg/8AXJgyXyJFxVRzRpXCjlxfK/gyO/M5Rt3E/TZ1dMdJ5x711jV8duJUyx0wSfhS49pYyoPrRlj5MjDM/hy5+j6nGMniFVcj32T7f+/UybvZf6bNp16Vcvj0+ZlUcdufJMDkPjRpTt9coapTilC4p8ssL7cf3X5HXiMeJulx1PhS49xyq2/86njrt1/DJ1a3OlTHsTL/AEubRVPSeU+yXH+FdTlpPENnfOXuwqpVZf2PZ/gfQ0WpRUovKaymfMrims7YXmd08M9W/ivC9BzadW3/AJUt8vC6P7jJejvbFvZia00ZFPdyn7JOADA0cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADk3jXqHtNWtNOg21Rhzy9HL/Q6yfP3HlzK94u1GtKbnFV3CL8ox2/Qy2o1qbLutYi5mTXP+Ma/Zpk5YcFLZfiVUYOrXhTx9aXLjyz3KHnDSSyns8GTpjzqVtFdHVjv8yROrodc6UzL6I0mgrbTLagv+HSjH8DKPILEIr0PSE4zXVNVUzIc/wDGy4UdGs7XOHUr8z+CT/c6Acr8b6yne2FvHrGnKT+b/wBD3b9aFvu/b49oW/LWfk5w+VvGPToUtLmTxL1T7FUW1u0nl/h5Hkm5JRikl55JmjqUDUs9N+rPonhOkqPDOm00sYtobfFI+eKcJOcIr3pSax8ex9K2VP2VnRpL7FOMfuRHvT0abvfX6Fqjzn7LpBPFziH+H6WtKtpP6RdL32vsQ/1JDxZxHY8PWLrXEuarLanSXWT/AGOFaxqN1qmp1b26quc6km3nol5L0PNujWdZVu7uyasi7GRcj0KennP7LFjbTu7ula05e/UlyrmeEvXJ3LgLh2y0HTIqlUpV7uol7atB5y/JehwdKWeeGFLGyMuy1G/sqkKtre1qM49HGbRmuUzVGkS2za+zr2fb7Oi5wx4adfa+kQc14H8Q3XnCx11xjJvlhcrZN/3fudKTTSaaafRkWqmaZ0lzjOwL2Fc7O7H4kKasuSlKf9KbKjG1WoqWmXNR9I0pP8D4i0xrVEPnbWbirdanc16rm5yqybbecbmJT6Jpbd0y5OUZVpSfWUnsyhNR+z7vlknRyjR2ainhoimI6EnFZTWX3yTvwVoRqcS166SfsrVrPxkv2IJKUVVaxlN9cHTvA2nFy1Ouk1hQgs/Nni56mqq29XwbPuT4x9Zh04wOI8rh/UGs5+jzxj/KzPNXxZ/+rOo7tZt5rK+BFjq5ljxrdpjzj6vnhtvdNpvrk9TaSipbruux6pRzlPO+N0Ut427vpnqTNXZCct+XL69Trngiv/oN6/8A+5x/5UcjbTzhNpHYvBZP/ZetNvPNcPHySR4u+q17eedMCY84TkAEVzZxnxivVX4ojbrLVvSUevd7kKSapvD27po3XHd0rvi7UKibaVZw69MbfoaVzz02x0ZMp5Uw65syz2WHbo8oF1baa/Uk/hlQjW4ys04pxjzS380iMZ275XXcm3g1BVOKZzTf8uhJvPxQrmeGXna1c0YV2ryl2U4z4w1FPizlWVKFGKOzHAvEG+jf8W3tZSzCFT2ax5R2MFmPSaZupamrMmrwj6o/H63XG+6R0zwOt5K51O5cfdcYQT9ct/sc1eVJPoui9TuPhdp0rDhalOpT5KtzJ1ZL06L8EZLs6U6Nj3myIt4M099Wkfdvdds1qGjXdm0n7WlKKz542/E+dK8KlGpUo1frQnyNeTTwfTB8/wDHatlxfqkLZKNP2z2XTOFzP78nmzVpOin3RvzFdyz3cp+zR9Gt25YxkRltlPPkEpuKcui8ir3XFPKzkz9zeCipTmowy5t4UV9pnZOAOCaGkUoX+oYr3s1zRi17tJeS82cay4zUs4knt5o7z4e61HWuHKNSU83FFeyrJ9cro/mjFe1iOTWN6LmRbx4m3OlM8p+3uSIAEZzwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAarizUo6Tw9d3zeJQptQ2z7z2R885k6jcpPMm5S82dP8a9VxC00ilNJt+1q/kkc3srWpfahb2dus1K81Tj6NvGSRajSNXQ92caMfDm9X/lz90fyXWvBvTZW2gVdQqpqpdVPdysNRjsidGPptpSsNPt7KisU6FNQj8Ei7cVYUKFStUeIQi5N+iMFVXWZaPnZM5WRXd8Z/2cy8WtQ9vq9DT4TXJbQ5pf55f6JfeQjL5t9l5Iz9avJX2o3N7KTbrVG16Lsa9xbSTax5o5TtDJ/VZNd3umeXs7l7j24t24pJPdvG68zoPg/Yc1W61OUX7sVSg2uvd/oc+e8XHGWzt3BOnfwzhy1oSSVSUfaVPi9yz3bxu1y+0npTGvv7kXaFzhtcPi3QAOhKEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYv6CubOrRf2o7fHsQqWYycZe7JbNPzJ4RLiG2VDUpuMcRqrnXx7mnb3YfHaoyKf8eU+yf3+qfg3NKppa15TKeaUWpReJLdMqkyh7mh0zpzjqsk70+urmzpV19uKb+PcvSipRcZJNNYafcj/AAhc+7Vs5YWHzw/X9CQnX9m5cZeLRd75jn7e9R3qOzrmHz3xjpb0biK7seXFOMuam/OD3RIfCDVvoWvysJzxRu1yxTe3Oun39DeeNGkyqW1vrFKOfZfyqvwb2f3nMbW4qUK1O4pPkq0pRqU35NPKLf16HR8WqnauzOGrrMaT7Y7/ALvpUGDoGo09V0e2v6bWK0E2vJ90ZxGc1roqoqmmrrAAA8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8m8Qk/JHzXfOpVvK8py5m6km9vU+k6u9KS9GfNVwuW4qtT+0+/qZrMdW57oR6V2fZ91radTy/yvoZOntK+t5NN4qR37YyYrWFlLr95Wt3Frbfv2JEw3auOKnR9MUnzU4yXdJlRr+G7iN1oVlXjNT5qMctd3g2BBcZuUTRXNM9wcX8ZpyqcWRpuTUI0I9PmdoOE+JlSVbjW//mZ5HGKT7YSMtn1tWxbq0a5s1eET9kZ97aOcrP3nrUW0l7uweN8tKS6YPc5TbxleRJdF1ZuhU3X1uxoRbblWivxO/wCtajQ0jSa19cP3KMM4832RwzgmDnxdpseXpWi/kT3xtupQ0u0s4yXLUqOU45+thbGGuOKqIajtzH/V7QsWJ6T1+/0c317VbzWdUrXlzNylN+6s7Rj2S+Bgb4W69V+h70w3vtg22ncM69f2f0u00ytVo45lPZZ+CbMusQ2ea7ONRETMU0xyjualPt19PITT6NJbntWEqVZ06lOdOcXyyjJYafwZQ2+ZNTWOy8j6zxz5wN7t52i+x1/wm4leoWj0i5m5V7eGacpPeUP9Dj6axsk1nd+ZtuFNSel8QWd/GWFTqJT9YvaS+7J5uU8UKzbGBTm4tVGnOOce3930Oavi2o6XDOo1F1jby/I2cJKcIzi8qSymaLxAqOlwfqLTSbpOP3kSOrmGJTxZFFPnH1cCWG1KS69Q3LflXLvjDPI5WM7ZXdBpr3uZ79ETXYhJt77vudc8EqLjo15Wa+vWS+5HI5S93DfXY7N4NQ5eFJS/quJGK76rXt56tMCY8ZhNjSceT9nwjqMs4/ktG7I74kPHBmoesEvxRHp6tAwY1ybcecfVwXll1aT7rfY9ksv3ZbJB7vEVj5HuMcsljJN1l2DVS9lnmfTGEdq8HqahwfBpY5q03+JxbGZJPGX6HcPChf8A9F2zzluc/wD1GK96rWt6p/5KI/8AaPpKVnk3yxcn0Syelm+k42VeS7U5P8CM53TGs6PnPVajq6rdTll81acm8f3MxamJLrl+hXWeZTalhOW3qslDiottYWNtidEOz240piFWySTw8snvgkn/AB67bjsrfCfl7yIB05Y4TXmzZ6BR1irXrVNH9u61CPPN0HiSj+p5rjWNEPadnt8Wu3NURr3z7XbON9do6FodavKolcTi40Y93Lz+RwKo3UqyqVd3J5fqzL1G41K9uXO/qXFetFY5amcr5G54Z4I1jWXByoStbZvMq1Vcv3J7s80xFuOau2biY+x8eartcaz1n7Qs8D8P19e1qlSjHFrRkp15+UfL4s71SpwpUo04RUYxSSS7I1/Dmi2WhadGysoYit5yfWb82bIwV1cUtM2ztSdoXtY9WOn5Wb6vG1sq9zP6tKnKb+Sycgt9H/jPBmrazCmndQvJVVPly3BJNr8X9xPPFG/+g8JXEYt89w1Sjh779fwMTg+rR0TwyhfXcFGLpTrSi19bmbwvmsH2nlGqRs+qvFxe3o9aquIjz05/Po4x3WE9vUcycnlYa6bdCt8tSrKrDEIvMlFdFnsUuPuyaeHjd5JOvN0mJeRUHlvOGTDwr1l6bxFG2q1MULpckl2UuzIak+VST2byVxqShPnpycZQeVh757CaeKNGDMxqcmzVaq6TD6aBrOFdRWq8PWV8mnKpSXPjtJLf8TZkKY0cguW6rdc0VdY5AADwAAAAAAAAAAAAAAAAAAAAAAAAFNWcaVOVSbUYxTbb7IqIh4raz/C+GpUKUmri7fs44e6j9p/p8z7EazokYmPVk3qbVPWZcn4p1L+L67d38m2p1GoLyitl+BJvBvS5XevVdRqRXsrSHu7bc8un4EGmm8JrLxjY7x4d6N/BuGbelUhy3FdKtW81JpbfJYRIuTEU6Q3/AG9kU4WBFmjlxejHs7/55pERbxM1L6Fw9K3hLFS7fs/+X7X/AL9SUnJPEnUvp2vTpQmnTtl7OO/V9zXtu5f6bDq061co9/7NDwrXaXY16QirabS8uiPJYx1yl1Ktur+t5lE984OatihteD9NlqXEVrQeXTU1OphdIrfc7klhYRz/AMIdOStrnVJxeZv2VNtdl1OgHQ93cXscTjnrVz93coNoXeO7w+AAC/QQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1XE1u6th7WMcypPPy7m1PJxU4ShJZUlhojZmNTk2KrNXfD3brmiqKoQF56lEs7mTf0JW93VoPrCW3w7GPuceuW6rdc0V9YnRfUzExrC7ply7W/o1+iUve+HcncWpRUk8prKOePfqS3ha8dzp3spv+ZQfK/VdU/u2+RuG6Wbw1VY1U9ecfdBzresRXDL1qwpappVzYVsclam45x0fZ/I+d72hVs7yraXMXGpRk6cl1eU9z6UOR+MWj/RNVp6vSgvZXK5aiS+2v3Rv9qeei33WzeyvzYq6VdPbH7Nh4KaynTuNErTSkm6tHfr/AFL9Tph84aHqM9K1e01C3WJ0aik15x7r7sn0TY3NK8s6N1RlzU6sFOL9GLtOk6se8+D2GT21Mcq/r3rwAMTWQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGsprzPm7Wrf6Pq17bOOHTuKkUvhJn0icM8TbB2XGN1hPkuP50X6vr+JlszzbZule4ciujxj6Iw5Rxu3LPQ8eOuGl5dWw3F7Yxh7eh6tk+ZZw/L8yTDfnXfBnVo3Wi1dMnL+bazzH1g/L4Mnp88cK6zW0TW6F7Ry4ReKkfOL6o7/pt7b6hZUry1qKpRqxzGSIt2nSdXON5Nnzj5M3aY9Gvn7+/8sg+feOaqrcYapNZk/btL5bYPoI+cuI5upxBqE1nDuZ9ev1merPVL3Rp1v3KvL7sHZw2WPRhNrHu4Wdl5Hjed221nHoVS5ubD+q1tuSG+JH4a0lW41seZfVbkl5NIlXjlbTlDT7rbkjzQfxI74TLHGVvHlf1Z7+Wx0nxK0p6pwvXVODnWofzYJdXjqjDVOlcS1DaWTFjbNmqrppEfHWHD7GMZ31tTqS9yVWCk15Z3PpOhTp0qEKVKKjCMUopLZI+Z1zRbksqSaa9Gd84E1qnrWgUanOncUoqFZZ6Nd/mfL0d75vdZrqot3I6RrE+/RCPGnSYUr201SjTw66dOthbNrdP44z9xzlLljzPHojtHjHR9pwjzpb07iEs+S3X6nGMqSWcbdD3amZpWW7d+q7g0xV/jMwR65jj0yUyjltRwu69WVZTi1jcJbJZWMdPJGTmvn0HwXdu94W0+u3mToqMvitjW+KsnHgq7S+04x/8yLXhPVX+xdOU6qcYVJ7vbCyRjxR4vt763lo+nSjUpqSdWqu7T6L9yLFM8XJzbFwble1Zptxypq1nyiJc7ynHHLt1PE0k3n0QxlZyn69z3G+M/BslcnSXiW/Z9lg7l4WUlS4NtcL6zlJ/ecMhjon7rZ3nw1io8F6el05X/wCpmK90avvZVpiUx/7faUjIz4nvHBV9vjKivxRJiMeKOf8AYu9xj7P5mCn1oaVs3/q7X/1H1cKTa3beVssdBH3vtJ75xjqeppxaT6d31CePeaw0u3cmauuqpZj2cm+p3Dwqi4cFWieN5Te3+ZnDJZ5Nnut2md18Lnngqy/5v/UzFd9Vq+9f/R0//X2lJzH1LbTrlv8A7qX5MyDUcZXq0/hi/uXhtUXGKfdvb9SPHVoViibl2mmOszD58+ss1OVt7vlR42nF/Huerrns1jGTxtuW2eX8ibDssCUOXotnn4E+8EXjXr2PLnNvnm/5lsQHE8PMcY9Sc+DFSNLiatTk3mpQfLn0aPFz1ZVW241wLseTrrtrd1fauhSdT+pwWfvLoBEcrmZnqAGHreoUdK0q4v68koUoOW/d9kH2iia6opp6y5n4taitR4ks9DoT5vY4U0u05vH4L8zYeLN5/D9A07RKLUXKK5l25YJbP5ke8P7eprvHS1Cum+ScribbzvnZfiW/Fm8+lcX1aTb5LeMaWPlltff+BIiI1ilvljFppzLGJHS3TNU+2f3YGlcM3F/wrqGr0venbTXLBP60V9b7k8/Ij7eE08Nd0dy8M7GlS4Jt4NRnG4U5y2+sm2vyOS8Wac9I4gu7LkSpRn/L/wAr3R6or1mYT9mbUnJyr1ir/GeXs6fv72oe2YqKa/Ub82Nl6Hrbi23jZfcUxTTTbyurMncvXXfBW7c9Gu7KU8+xq80V5KX+pPzk/ghUxq19T59pUU+T4PqdYIlz1nLt4LUW8+5p36T8YAAeFMAAAAAAAAAAAAAAAAAAAAAAAAHDfE7WP4rxLVUJOVvar2VNp5We7+86px7rUNE4cr3HOlWqfyqK85P9ll/I4HzuTcpLOXnOevxM1qnvblupg61VZVUdOUfdv+ANIlrPElrRe9Ki/bVdtnFdvmzvaWFhdCEeEOivTtBlf1o4rXr5o+kO339Sbnm5VrKq3hzf1WXNNPq08o+7X8RahDS9Gub2eMwg+Recn0X3nD6kp1ZurJ5lNuTbfVk78V9V5q9DS6Uk4w9+qvV9EQPC2a27YOd7yZvbZPZUzyo+vebPtcFvinrK2unb0R7CnOvXp0acW5zkoxS82zzbO/X17Eq8MdMd9ryu6izStVzZ85dinw8acm/TajvlLu3It0TXPc6doVjDTdItrKmtqUEn6vu/vM0A6tRRFFMU09IaxMzM6yAA9PgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAI/xZa49ndxT39yX6Ed3J5e28bq1qUJ9JrHwfYgtWEqdWdOf1oSafxOd704PY5MX6elf1hbYVzio4fBbeDO4evFaalFyeIVPcl+jMGT8iiazs8rJruJkV416m9T1iUquiK6ZpnvdHNRxhpEdb4eurDZVJQcqUn9ma3X4l7h69+m6dCUnmpT9yfxXc2J2HHv03rdN2jpPNSU1V2LsVRymmXzPcU5Uqk6NZONSEnGS8sdjq/g1rULjTJ6NVn/Nt25Usv60H1+5kb8XtFen65DUaFOMbe8y5YX2+/39SNcN6lV0fWbfUaEsKnNc67Sj0a+4nT6dLpGTbo2vs3ip6zGseUx3fZ9FAtWlxTurWlc0Zc1OrBTi/NMukZzOYmJ0kAAfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgfi/odS+02lqlvHNS0f8xJZzB9fuJ4JJSTjJJp7NM+xOk6wlYWXXiX6b1HWHzKmk2+uxTFy95dJPsdP4x8Oak69W90Jx97MnbyeMPvyvy9CAXej6taVnTuNOuqckt80n+ZLpriXUMLamNmUa26o18J6sJN9EspokvA3F1zw9VdOX8+xnL36PeL84mqsdE1m+2ttPuamf7GvzJdw74ZX1acauq11bUm8unDeb9PQ+VVU6aSxbRycCLM0ZNUaT3d/5dK0HW9O1u0+kafXVRLacekoPyaPn7U2/wCK3jf/AH88v/mZ9CaPpOn6Ra/R7C2hRj9ppe9J+bfc+e9Sg/4jdxlJOXtZdPizHa01lQ7rdl21/steHlpr172O3FLDS5fM8eJL3cx+B5PDim/dWD17Lfq9sIztzS/wkx/tjSy8/wAuePTY7Y0msNZTOJeEKzxlTbzlUpr8DtpGu+s51vV/13uj7uO+I3BtbTbutqlhSc7Co3KcI9abfX5EY4c1vUNBvld2dRrDxOnL6s15M+iJxjOLjOKlFrDTWUyE8R+HOlajOdexnKxrSeXGO8G/h2+R9puRppUmbN3htVWv0+bGsdNevLz/AC1Gv8baXr3B93bVIytrxwT9lPdN57M5hPLls3jGSWa/wLrWkW1a9rToVbaksuUZdvPDIqve91bYMtEREcmy7JtYlq1V+lq1pmdfY8z7mz+9CDTXTd9n2PGpNOOU4rqIvDjjtv6HtapHo1XiHVLCnoGlqo7aUm6igsJ57yfkSTiThO04c4GqynJVr6tVh7Srjp/bHyRLvC63dDg60lKCU6mZtpdcvYwvGVy/2SUYrrXhn0I8161aQ0avald7aNOPbiKaePnp3zr1lxmK93n6dvkGpNvs+rR4/dyo75XYSXvczeWuuPP1JDeXskksx+0up3rw5WODNO//AB5/FnBYxWXs9t8NnfPDySlwbpzWMey7fEw3ujU97f8ApqPb9m/IT4xXn0fhiNsniVzVUfktybHHfGTU1d8Q0tPg807Sn7+H9qXVfdgxW41qa1sDGm/nUeFPOfd+6Cxm0k3HGT1LlWyfo+x5FqOHhrC2yzxSlnPdPcl85dRVR36RSz13O5+FjT4Jskuzmv8AzM4ZCOcpe8/yO2+Ec+bgq3jlPkqTjt/mMV71Wr71xrh0/wD1H0lLjm3jZqvs7a10qEl77dWqu/KtkdHqTjTpyqTajGKbbfZHDbutPinxCUo+9CrcqEcvKVOL/ZZ+ZitxrOrXN3ceK8ib9fq241/CM/W2cHTa2akt0UvKey27+ZJ/E2wVjxhcRjFRp1VGpDHZYxj8CMS2652e2STTOsauh4l+L9mm7H+URKqK7ttLJv8AgK++g8W2NeouWEpum3nz2I/n3Vl5fX4HsXOklKm8STznO+RMavuRZi9aqtz3xMPpoEb4D4lt9c0ulCdSMb2lBKrTb3f9y+JILivRt6UqterClCKy5TlhIhzGk6ORX8e5YuzarjnC4ch8WOJVqN2tJs5p21vLNSSe05/sjP4+4/jOjU03QqiamuWdyvJ9o/uQPhvTa2s6zQsIRf8AMn7z8l3Zloo09KW3bC2ROPE5mVGmnOIn6z9nUPBzSvouhVNSqxxUupe729xdNvjk5nxdWlX4o1G4klvcSX3PC/BH0DZ29O0tKVrRio06UFCK9EfPHEDmte1GE98XVTH/AFM+251qmWTd7InLzr9+e/6au68FR5eE9MWMf7vF/gc78bbSNLWrS7Sf8+k1L4xf7Mn/AABUlV4N0uUvrKgov5bfoRXxz5P4bpra9/28vu5WeKPXVOyK6re19PGao+rlMlHrJOXkkVLPOsJSjHsG+VrCeG/geYco9OVZ6kp0dP8AwVjniC6njf6P18tzrpzXwRsnGjf3zecyjSX5v80dKIt31nMd4rkV59endpHyAAY1GAAAAAAAAAAAAAAAAAAAAAABpONtajoXD1xerDq45KSfeT6fd1PsRqy2bNV65TbojnM6OYeLWufxLXvoFKX8mzzBeTn3f6Gh4X0qeta1bWFKDxUknN+UV9Zmtq1JV6sqtR5nJuTz3b7nXPBzRPomkz1avTxWufdp5W6gn+r/ACJNX9OnR0jMu0bI2dFNHWI0j2z3/dO6FKFCjCjTiowhFRil2SKL65pWdnVuq0sU6UXKT+BeIP4qaq6VrS0ujJ89T+ZUx2iun4lTn5UYmPVdnu+vc5xZtzeuRSgGp3dXULytd13mdabk15ehiYTWXnZ/gVz5pPfHluUPK28/U5VVXNdU1VTzlstMaRpCjEVhrp5HY/D3SlpfDtLnWK1w/bVM9s9F92Dm3B2ly1fiC3t5Y9lTftKix9lHaopRiopYSWEjb91sP1sir2R91XtK90tw9ABuSoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAi/FdoqVzG5ivdq7P/MSgxtUtY3ljUoPq1mL8muhWbXwf1uLVbjr1j2x/NGaxc7OuJQNrql1PHstyurGUJSi01KLwy3LZZ/E5LMTE6SvNWz4XvFa6iqcpJU63uvL79iaHNXv2Jzw/f/T9PjOT/mw92fx8ze91NocVE4tc845x7O+FdnWtJ44WOMNGp65oNeykl7THPSl/TNdP2+Z8/wBenVt686Nam6c6cuWS8pLqfTBx/wAYOH3Z6tDWLeL9hde7US+zNfv+5vFqrSdF7uttDs7k41c8quce39288G9e9tZT0O5qJ1aOZ0G/tQfVfJnRD5w0jU6+l6pQvrdvnpVE8LZNd0z6G0q+oalp1C+tpqdKtBTi/j2+J8u06Tqjby7P/T3+2pj0a/r3/Hr8WSADE1oAAAwb/WNKsJKN7qFtbybwlUqJM1PiJrdXROHp1rbH0mrL2dPPbPVnCa9arXqSq1ak6k5PeU3lv1yzJRb4ubYtj7BnPom7XVw09Pa+lLS6trukqtrcUq0HupQkmi8fN+k6jf6XXVxY3VSjJf0vrjs13OtcDcd2+rqNlqXLbXvSMukKvw8n6Cu3NPQ2nu7exKZuW54qfnHuTYAGNroAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHzdq6UdUu4Lb+fNL/qZ9Inzzxbbq14n1O3Wdq8sZXnv+pmszzlt+6NURduU+UfX92qlJ8uFv5+Q2jBR5ds5ePMOTWyTi1t8SmPNlRw8p7r0JHVviYeEkn/tpRUnv7KePTY7acL8L6qo8aWr7VOaP4HdCNe9ZzveunTMif/WPrIADE1hGvE6v7Dgu+e2ZpQWfVnCYxzLEuZPHXJ2bxmqqHCKp5WalxBfJZZxlyi0pRe623RJtR6Lom6tHDhTPjVP2erHPmU1n0R5Ti5TUF9p+6/Mp5n7N4bx22JBwBp89T4qsqHLinGXtam3RR3Mk6xGrYb92LFqq5V0iNfg7foFqrHRbO0X/AA6MU/jgjXjFzLg6fK8L28M/eTMifi1HPBdy2l7tSD37e8RKJ9KHLNm3Jqz7ddXfVH1cQwt+nLssoRzu093957LDS6beXc8e0k1nmW5Lh1h5OMo4ynlbY6nevDaXNwZYdFiLWF8WcGqbbvZ5wzs3g7de34XlRcsyo1mseSe6Md7nS1neqiasKKvCY+6X39zC0sq11U+pSg5P5Hz7dQude1K/vI5TXNcVJY35c/8AwdL8X9dja6UtJt5KVe4f81J7xh/r+hoPD3S3V4S16/nB5nRdKl5+6sv8cHij0adVZsWj9Dh1ZdXWqYiPZr/Pg5+nzSeV8Gz1JKGW8eWDyUW54cHss4T6CWVtGJIb08zJcuI4fb4HXvBW7jPRrqybSqUqvNj0a6/eciWW91jbZ9dzO0vUb3Ta061hdTt5SjySlHbY8XKeKNFbtbBnOxptROk9zqvitxJS0/TJaVb1FK6uViai94R9fiR7wX0x1tUuNTqQahQjyU8+b6kBr1q91XlUrVZVKk5b1JbttneeANIWj8NW9CUcVqi9rU9G+3yWEeKoiijRr20bNGyNmfp6Z1qr6z9fwjvjNo0rnTaOr0Ic07Z8tXC6wff5M5OotqXM0ku59KXdCldW1S2rwU6VWLjOL7pnB+N+Hrnh7VZ03Bu0nl0KuMpry+KFqrX0XvdfaMV2/wBLXPOOns/ZoEk1iElju/U95nF4is4e7PMPbDWRLC6vfoZm4LltcV7WuqtCtOnOO6lGTTT+Reu9Qv7vEru9uKz6YqVHL8zFaWEmt0sP1DllrDy/QTEPE26Jq4tOb2WJPZ9/I7H4UcOfwzTXqdzGX0m5S5IyW8Ifu/2I14Z8G1L25hqupUnC1pvNKElvVfn8DrqSSSSwl0RguV90NL3k2vTVH6SzP/1P2/IcD8QLeFrxlqdLpmoprK23SZ3w5f4z6LJ1aOs0YZi4qlWflj6r/Q82p0qVu7GTTZzOGr/KNPf1brwg1GNzw67KTSqW02lFf0vdEd8a7+nV1KzsYNSdGLlPH2W/9CD6VqV7pty61hcVKFRpxbi+vxLVxWq3VeVavVlVqz3nOby2zJFGlWraLGxOy2jOXry66ec9VnZwzusFyjRrXFWnb20ZTq1JJRjjq2WoQcqijCLk5PCS6s6x4ZcHStJR1rVKTjXa/kUZfYXm/U911cMc1jtLaFrAszcrnn3R4yl/Cekw0TQrewj9aMeao/OT3ZtQCJM6uUXblV2ua6us8wAHxjAAAAAAAAADycowg5zkoxistt4SQHpj3l9ZWcea6u6FBf8AiTUfzOfcbeIfsZTsdBcZzW07h7xX+X9zmVzd3F3cyr3dapWqS3cpybb9EZabUzzls+z92L2RT2l6eGPn+z6Ps720vIc9rc0a8fOnNS/Ivnzjomp3ek3cLuyqqnOMstJ9fRn0JpN5DUNMtr6n9WvSjNfNHmujhQ9sbGq2dNMxVrTLKAB4UgAABxXxU12Gqa+7OlVjK2tMwST2c+7/AEOjeImvQ0Lh+pUjNK5r/wAuiu+X1fyOEVJ88/eeXJ5y+uTPZp725bq7O4qpyq45Ryj7z9my4Y0irrWuW1hSTkpzzUfaMFu3+nzR9C2tCnbW9O3oxUadOKjFLskQrwi0J6fo71K4h/vF0vcyt40+339Scni5VrKu3j2h+qyezpn0aOXv75W7qvTtrapcVpKNOnFyk35I4nruoVNU1Kve1ZYdSTwv6YroideKOrOja09LoS9+r71XD6R7L5nOWm8pvBoO82d2l2MemeVPX2/sj7Ps8NPHPetyecp9EeLpjDSx5HuMRWxseGtNqatrdvZRi+Ry5qrx9WK6v9Pma1atVXa4t0dZlY11RREzPR0Hwv0n6Do0r2rDFa6eVlbqC6L9SXFNKnClSjTpxUYRSSS7IqOrYmNTjWabVPdDWbtyblc1T3gAJLGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAinFdl7G5V1DanV2e3SX+po+voT7U7WN5ZVKEurXuvyfYgdaEqU5QmsTi8NeTOb7zbP/TZHa0x6Nf17/yt8O7x0cM9YW39Z+hseHL92V/FT/wqr5J+nkzWyKe+SixMmvFvU3aOsJddEV0zTLphr+I9Lo6zo9xp9bpUj7sv6ZdmWOFtQ+mWPsqks1qPuy9V2Ztzr2LkUZFqm7R0lRenYuaxymJfNWoW1WwvK9nVjy1qM3Ca8mjoHg7xAqNd6HcTSp1czt/SXdfMyvGLh32lOOvWlNc8Vy3CS+su0v0+45na1pW1SlcUJzp1qclKMk8crRY8rlLpNFVrbWz9J6z8qo/nwfS4NNwbrdPXdEpXaaVaPuVo+Ul1+T6m5Is8nNb1quzXNuuNJgAAY3PvG2EnpFjNRbjGu8vy2OS+blL3YvGDvniDpz1PhO9oQi3UjD2kElvmO+EcDjjG2MEm1McLou61+K8OaO+mfrzeZy3lLZ5TRVTc4yUujznPc8a5Xjpv3EHul1+Zl6w2Webqfhxxw6/s9J1mqvabRo12/rf2y9fU6QfMmWp5i+Vro/U614YcYO9pU9F1Sp/vcFijUl/xI9k/X8yPct98NG2/sKLcTk48cu+PvH3dBABhacAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcN8T7edDjO85orlq8tSLXw/0O5HKPG+0lDUbG9hHCqQcHJdcp9DJan0mxbsXeDOin/VEx9/s556ywvM8bzmC7vqj1KWPLdnieHy/N4JTpDbcF1lb8T6fVm0oqvFZb89j6FPmajN0rmFRZTjNP7j6R024hd6fb3VN5hWpRmn6NZI97rEtH3vtTFdu54xMMgAGFprl3jldxlU0+wU2uVSqzin54S/U5pty7ppZxhEh8RtSWqcU3VWMn7Ok/Y0/VR/1I/JOMUmvnkmURw0w6vsbHnHwrdE9dNfjzexiorEU28930OreDOk+zs6+sVFLmrfy6ee0V1/E5toOmV9V1S3sKSlz1pYk19ld2fQmmWdHT9PoWVvHlp0YKMUY7tXLRUb050WrMY9M86uvs/eWSaLj+3+k8H6jTSy1RckvVbm9LN/bxurKtbT6VYOD+aMEdWi49zsrtNfhMS+anhLEfrY6dRmSbx16L1MjULadnf17SrlTpVJQeV5PBYaXMnFfVJursdNUVREx3lRrqsdM46m44a4k1Hh+VZWFSGK0cSU4ZSfZo0qeIc3Ltnuex+qn26Z7iY5c3i9ZovUTRcjWJZV9cXeraj9JrynWr1pYcvM7zwppVPTOGrbT3Bf4f8AMXm31OVeF2hy1fiCN3Vj/u1niU3/AFS7L9TtpHuz/i0jenMp4qMW30p5z9o+D524n0+rpGtXVjJ4dKo+VvvF9Ga3OcrDTfbzOv8AipwtU1SlDVbClz3VGPLUgus4/ujkNSPIpU5SlGaljGMNfEzUVRMNn2RtCjNxqaon0o5T7VMMqWFtt0KtsJPOOv8AoE3zNJ4xuzZcN6Hf67qEbW1otxf+JVa92K8z1M+Kxu3aLVM11zpEN54YaB/GNbjdVqWbO1xKWejn1SO2Gu4d0i10TSqVhaxSjFZlLvOXds2JErq4pct2xtGc/ImuPVjlHs/cMTVdOs9Us52l9QjWpS7Pt6ryMsHhWU1VUTFVM6TDk+v+GN7QqSqaLcxrUW8qlU2nH59GRatwrxFQm4y0i6ynjMYc35H0CDLF2rvbHj705lqnhriKvb1+ThGn8D8SXlRRjp8qC71KrUcE84V8ObHTpxudTqK9rLeMMYpxf6k7B8qu1SwZm8WZk08ETwx5fl5GMYxUYpRS2SXY9AMahC1eW1C8tqltc0o1aVRYlGS2aLoD7EzE6w5jr3hfKVaVXRryEYN5VKtnb0UkYNl4X6tOpy3N5bUafdxbk/kdcBk7Spd0bx59FHBx6+ekaoxw1wPo2iTjXUJXVyv+LV3x8F0RJwDxMzPVVX8m7kV8d2qZnzAAfGAAAAAAAAAAAHkpRjFyk0opZbfY5F4lcZS1KpLStLqf7nF/zZxeHVa7f5TK8T+MVXdTRdLq5pLavVhL6z/pXoc5aTWMepnt2++W87v7DiiIyciOfdH3n7KIP3VLEn5nspcyw3t2Z637rw+VtY3HLt0zt2M+rcdSnyd1LDXVo79wBCUODdMUuvsEzgltQnc3FO3pv368lCPxbPpHT7eNrYULaCSVKnGCS9EYL09Gn73XY7O3b75mZ+H+6+ADA0UPKk404SnOSjGKy2+yPSB+LnEKsdOWkW1XluLmOamOsYeXzPsRrOiVhYleXfps0d/08UA8QNfnr2v1qkJf7pQfs6Cf9K6y+bKOBNClr2u07WSkqEF7Su12jnovj0NGlKo+SMVztpYXdnc/Djh9aHoUHWgleXGJ1n3XkvkSaquCnSHQNq5VGysGLVrlPSPvP870lpwjTpxpwioxikopdkWtQu6NjZVbqvLlp04uTZfOfeJ2s+0qw0i3n7sHzV8Pq+0f1KfaObTh49V2evd7XO7Fqb1cUofq99V1HUq95W3lVm3jyXZGHUxFNPGH+BU3h+9jr2PHFNbpM5ZcrqrqmqrnMtkiIiIiFC2e3K/1OoeGWj/QtMlqFaP865+rntBdPvIJwvpM9Z1mhbRTVKL5qr7KC6/f0O0U4Rp0404RUYxWEl2Rte7GBxVzk1x05R7e9WbRvaRFuFQAN2VAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABF+L7Hkqxvaa2n7s9u/ZkoLV3Qhc206FRe7NY+BX7Uwac7GqtT17vay2bs264qc6f1vUpexkXtvUtLmpQqL3oPGfP1Md9PicluW6rdU0VRzhfUzExrDK0e9lp+oQrp+43ia84s6BTnGpTjUg04yWU0czX3IlHBupOSenVpLmXvUn5rujbN1tpdnXOLXPKent8Peg5tnijjjuSG8t6N3a1bW4gp0qsXGcX3TOAcX6LW0LW61jUjKVLOaNR/ag+nz7H0IRfxH4d/jujSnQj/AL5bpzpY6yXePzOhW6uGUjYG0/0WRw1z6FXKfLwlzLw84iegaxH2rxZVsRrrP1V2l8julOcakIzhJSjJZTXRo+ZpR5ZNSTjJPDXf4HWvCTiVXtp/BLurm4oRzRcvtw8vij3dp/yhebz7M46f1duOcdfZ4ugAAwNGGk00+jPnvjPS5aNxDeWrXJSjNzp4/oe6/Y+hCAeMOiSu9OpatQhmdt7tVLvB9/k/zMlqdKmwbt5sY2XwVdK+Xv7vx73Isp4UN898j7PM9pd+2Tzu5LK8n5HrU28y3wSnSyHLJYw0y5TqToz9pTnKE4tOMot5XwLa5l72fgj2KTeE8vPU+S+TET1dv8O+KqevWStriaV/RinNP7cf6l+pLD5u0rULnTdQo3tpVdOpReU19r0+DO9cJ67b69pULuk1GqklVp53hIj3KOHnDnO39j/o6+2tR6E/Kfx4NuADE1sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIn4q6XLUeFKtSlFuraSVaKXdL634N/cSwpq04VaU6VSKlCcXGSfdM+xOk6pGLfqx71N2nrE6vmWUfext8u57hfa2x08zdcY6NLQ9fr2eJKm3z0pPpKLNLhS3WVh9yZE6xq69ZvU3rdNyieUwpjjkTez9TsfhDrkLzRv4VVn/PtFiGX9aHb7uhx6Ep43xJ9ljojJ02+utMu6d7Y1pU6sOjW33+Z5rjijRB2ts+M/Hm10nrE+b6SI14g8QUtE0SqoTTu60eSlFdVn7TIDU8S9cdqqfsreNTGOdLdvzwRDUr271K7nc31adepL7Un+BiptTrzavs7di7F6K8mY4Y7o56sWbnKUnJ5clltvqyqOWo45nJroeKO+dsdPgdD8MeD53VeGtajScLaLzQpyWHUf8AVjy/Mz1VxDbs7OtYVmblz/efBIPCrhmWl2H8SvINXVxFckZdYQ/dk4AIczrOrleZl3Mu9VeudZAAfEVyvxf4clC6/jtrTlKnUSjcKK+q10l8DnEN5NZcu2Oh9M1adOrSlSqwjOEliUZLKaIDrfhjp9zWnW026naOTzyNc0U/Tvj0M9u5ERpLc9i7xW7VqLGTy06T5ebknNyrfKfTczNI0+71S9p2NrTdSrOW3L0x5vyR0Ky8K17RSvdU513VOnj8yccPcP6ZoVB07Cgoyf1pveUvmeqrtOnJYZu8+LbonsPSq+SnhHQ6GgaNTsqMY8/1qskvrS7s24BHmdebQLt2u7XNdc6zIR/W+DdB1etKvcWnJWl1nSlyt+rXRskAETMdH2zfu2KuK3VMT5Iba+G/DlKfNVhcV3nPvVWvywSrT7Gz0+3VvZW1K3pLpGEcIyAJqmerLfzcjI5Xa5n2yAA+IoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHPvE7i9WlKpo2m1M3E1y16kH/AIa/p+JtfEXiqnoNh9HtpqV/Wj7iW/JH+p/ocSrVJ161SvUk5znLM3Lu/My26Nectt3e2L20xk3o9GOkeM+PsUz595zxvvnJ5Bcqzl7vOzDinJJYfYOedmu/foiTDflUmp5k0+XoeNp4xnD6nk1iWz6/cVrLjjf9z4+dEs8KtJWo8TxryhmjaR9pJtZXN2O2kY8N9DWi8O0/aQSubjFSq+68l8kSci3KuKXLtu50ZeXVNPqxygAB4UzC1zUaGk6XXv7h4hSjnHm+yPn7Wr+vqmq176vJurXnl/2rGyJV4qcSy1PU3plpJStLaXvNP68+7+Hb7yJ6Jp9fVdUoWNpD360sZ7JefyJFunhjWXRN39nRhY85F3lMxr7I/nNLfCfhz+I6q9UuaX+62svczupz/wBOp2MwdB0y30fSaGnWscU6UcZ7yfdv4szjDXVxTq07a20Ks7Im53dI9jX8Q6nS0jSa15UazFYhH+qT6I45d16lzc1K1ZqdSpLmk/iSHj7WP4nqUrelJO3tm4xw/rPuyMPGOrXxOcbwbR/VX+zon0afnPelYVjs6OKesqXjlx0KZPCy303Ks4z13Rv+BNH/AItq8ZVqfNbUPfqZ6N9olRjY9eRdptUdZS7lcW6ZqnpCa+Hejfw3R/pFWGLi59+WVul2RJwtlhA6rjY9ONaptUdIa1cuTcqmqe8ABneAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABoeLbD2turynHM6f19usf9CJPPqdLaTTTWU+qIJxBYfQL5ximqU8yg/0NF3p2Zw1Rl245Tyn7Ss8G9rHBLWPrse0KtShXhXovE4PKfqeN4RTh4Zp9FU01RNPWFjMctJdG0q8hf2NO4js5L3l5PuZRAuGtSdhqCjOX8ir7s03tHyZPU00mnlM6psbaUZ+PFU+tHKfz71Hk2eyr07nIvFjhr6BevWbOni3ry/mxj0jN9/mQnTbq403UaV9bT5atOSksdmu3wPovUrK31GxrWV1TU6NWPLJP8zgPFGjXGg6xWs7hPkWfZy/rj2ZfW69Y0lvO7u04yrM413nVEfGP2dy4X1mhrmj0b6i0pNYqQzvCXdG0OD8AcST4f1ZVKkpO0rtQrQ/KXyO7UakK1KFWlJShNKUZLo0zFXRwy1bbWzKsC/pHqz0/HuVFu5o07i3qUK0VOnUi4yi+6ZcB4VETMTrD594v0apoOu1bGUX7BvmoyfePY0u7eJcyxsjuviJw9DXdGlOlSU723TlR3xzecfmcMrQqQn7KpHlnGTi1+5Kt1cUOobE2lGdjxr60cp/PveT7RS36v8Ac8XMk1yt+p5TbbeY/wCiKpx7Rnu9/RGWeXKV15PMJx2WfNZ3ybjhDXbvQNWjd0G503iNWm5fXj3+ZqWpc3VNemx48YaWz8/M+TpMc2K7aovUTbrjWJfSOlX9tqdhSvbSanSqRyvNej9TKOIeHfFVTQdQjbXM5SsK+I1E/wDhy/qX6nbaVSFWlGpTkpQksxkns0RK6OGXLtrbMr2fe4Z50z0n+d6oAHhVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAI/xvwzbcRadyNKF3STdCp5PyfocN1OwudMvZ2l5RnSqwliUZLC+TPpI1uu6Fpet0PY6haxq4+rLpKPwZkoucPKWw7G27Vg/07ka0fOPY+dote02wtt0w1Ll5ntv0bydL1Pwqk6vNp2pw5M5UK8HlfNfsYn/8LdWk3zX9lFZ2xzP9DP2lPi3GjeDZ9Ua9pp7Ylz6Uu6X3vGxdtrevWrKhbwlVqVGlGEF1Z1LSfC2yo1I1NR1Cpc4+xThyL792TPR9C0nSIcthZUqT/qxmT+Z5quxHRAy96cW3GlmJqn4Qg3A3h37GcdQ16KlN7wtuqX+b9jpUYxjFRikopYSXY9BgqqmqebSc7Pv51zjuz7I7o9gADyhAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAabi/Xrfh/SKl3ValWaxRpZ3nL9jO1fULbS9OrX13PkpUo5fm/Repwbi3XLnX9Vnd3E3Gn0o0u0Y/ue6KeKV5sTZM593ir9SOvn5MHV7+61S+nfXdRzqVHlt/kYqSk2n3Cxndrpj4Hq2jyqWHjOfIl9HTaaYopimmNIh5u17uFtsIuWGuy7oRjFYy3nsvM9bxHdYXfYS9PWuZbt4xsvImHhbw/8AxfVld16claWjUnlbTl2RFtJsbjU9Qo2NtByqVp4jy9l3bPoLhvSLfRNIo6fbraC96XeUu7MVyrSNGubxbT/SWOyon06vlHi2K2WAARnNwhnihxPHRtMdjbT/AN9uY42e9OHeRI+INWtdF0urf3UkowXuxzvOXZI4BrOoV9W1Svf3TxVqvOM5wvJGW1RrOstk3e2V+ru9tcj0KfnPh+WLltt5e738zsPhTw1HTdNWqXNJK6uY5gn1hDt8G+pDfDHhmes6nG9uYYsbaWZeVSXaP7nakkkklhLoj1dr7oWO821P/wDEtz/9fgIzx9rf8N092tvNK6rrC3+rHuze6ne0NOsql3cy5adNZfm32SOP6zfVtT1KreVpYc3sv6V2RrO39p/pLPZ0T6dXyjx/DV8Kx2lXFPSGC5LZvc8lL3lhdD2WOqXwPNuXOMs5yvHtOnOrUhSoxlOc3iK82dh4T0iGjaRTt9nWkuetJd5P9ERLw00X29xLV7iHuU3y0V5vu/kdDN83a2d2Vv8AU1xzq6ez91Pn3+KezjpAADaVcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGBrmnx1CxlSziot4S9fL4MzwYr1mi/bm3XGsTyeqappnWHM6tOdObhOPK4PDXkW3t0b6ko4w0x5+n0IN52qpfmRaXp0OT7SwK8G/Nqr3T4wvbN2LtHFCmTJhwbqrr0foFxLNWmv5cn9qPl8iHvZ9Op7RrVaFeFajJxqQfMnjuZNlbRqwL8XI6TymPGC/Zi7Ro6kRvxA4bp8QaTiGI3lD36M/Pzi/Rm20XUKepWMa8cKa2qR8mZx1azdpuURconWJU9m9cxb0V0TpVD5mr050LiVCtBxqU24yi+sX5HSfCfiiVOS0HUK3NFv/dJy7f2/DyLni1wmqkZa9YUveX/aYRXX+9fqcypzqU5Kam4uO6lndPzXkTeVyl0eJsbcwfP6T/PjD6ZBE/Dviqnr1gra4mlf0ILnX9a/qX6ksI0xMcpc4yca5jXZtXI0mA5V4scLu3qS1zT6S9lUeLiEV9V/1fM6qUXFGnXoTo1oKdOcXGUX0aPtNXDOqRs7Prwb8XaenfHjD5oeeVKCTa7ZKU8SSa67NYJRx5wvX4e1JzpJy0+q26U0vq/2t+ZGU44z1b8yVExVzh1TGybeTbi7bnWJUyysvPfG56+Xo126nieO6TfmeRxnfdY653PXekC2k0n7r3XodL8LOLPo7hoepVP5b/7PUk/qv+n4HNN+++VhHtPKjldEz5XTxRohbQwbebZm1c90+E+L6cBB/DHi1atb/wALvqvNe0I+7N/8SP7k4IdVM0zpLlWZiXMS9Nq5HOP5qAA+IwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFNWpClSlVqTUIRWZSbwkio5T4qcWq5qVNC06r/Ki8XFSL2k19n4LueqaeKU/Z2z7mdei1R0758IabxE4pq67qH0e3m46fRfuL+t/1MiTTylus75fY9fLLLzv3PJbwzl79EuxLiOGNIdUxca3i2otW40iHv1o4ym13PObMsL4L0PYrl95Zw1u2eyy3v080euks6l7N+78JeQinOaSTy3jYSXImspN7I6R4W8I+3qU9b1KjinB5t6b6Sf8AUzxVVwxqh52dbwrM3a/d5ykHhjwutIsf4jeU19NuIrCa3px8vi+5NACJM6zq5Vl5VzKuzduTzkKa1SFGlOrVmoQgnKUm8JJdyo5b4r8WxqSqaDp81KK2uZp9X/Rn8z7TTNU6MuzsC5nX4tUe+fCGg4/4onr+qTpUOX6Dbtqks/X/ALmaPQdHudZ1SjY2kXKc5bvG0I95NmHTpVKklTpwqTqVGlGMY5y2dy8PeG4aDpanWjm9rpOtJ7uP9pIqqi3HJvu0Mu1sbEi3a69Ij7y3eiadb6TplGxtoqMKUcZ/qfdszARfjzXf4fafQraf+81o7tfYj+7K3LyqMW1VduTyhzmmK79zxmUd4+1v6feuxt5/7rQe7T+vP9kRR9Nm2XJyy35lLbSeTlmblXMu9N2vrP8ANF/atxbpimFEsYe+TM4f0ytrGqQs6bai95yX2YrqzD3lJJJtt4SXc6vwToi0jTFKrH/eqyUqjfZdok7Y2zpzr8RPqxzn8e9jyr/Y0ect1Z29K0tadtRio06cVGKRdAOmREUxpDX5nUAB9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAU1IRqU5Qmk4yWGn3Rz/XtOnp19Knyt0pb036eXyOhGHrFhT1CzlRmveW8JeTKbbey4z7Ho+vT0/HvSca/wBlVz6S5w935lDX2d/Uv3NKdCvOlVi4zg8NeRYbSeWu5y2aZpmaZjSYXkc45M7QtSqaZfKqsypP3akfNfudFoVadejCtSkpQmsxa7o5VJ5+JIOENaVpWVjdTfsKj9yT+xL9mbXu5tfsK/012fRnp5T+6DmY/HHHT1hN5wjOEoTipRksNPo0cS8R+FqmhX7uraLlp9eWYNf8N/0v9Dtxiavp9rqun1bG8pqdKosNd16r1Oh0V8M6vGydp17Pv8cerPWP53vnnSNSutLv6d9ZTcKtF5S813T9Gd64U1214g0qF5btKa92rTzvCXkcR4t0C64e1SdpWg5U3vSq9px/fzK+EtfuuHtUjd0czpSwqtLtOP7meujjjWG67W2da2rjxesT6WnKfGPB9BAxdJ1C11SwpXtnUVSlUWV5r0fqZRFc4qpmiZpqjSYYmsada6rp9SyvKanSqLv2fmvU4PxjoF1w/qsrWtBujPelWXScf39D6DNdxDo1lrmnTs7ymmnvCaW8H5o90V8MrnYu16tn3NKudE9Y+8PnXOYvvJbdOh44pSy2nnqbbijQr7h/UJWd0vcb/lVUvdqR/wDfY1DeM8kU/XyJUTr0dMs3aL1EV251iSLfK8756eh6o5eFnzeSr3E98N52SCy2vdzhH3V71XbO4r2VxTuLapOlWpSUoTi8crO58CcS0eItLU24wu6WI14J9/NejOCuX1orGcZTRsuHtYudD1KjeWcuSUX78H0lHvFmOuji9qm2zsqnPtcvXjpP2fRQMDQdVtdZ02lfWs04zXvRzvCXdMzyL0cxroqt1TTVGkwAAPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAR/jjiShw7pbqOUZXVX3aNPPV+b9EfYiZnSGaxYryLkW7cazLTeJ/Fa0u1elWNR/Ta8HzSj/wo/ucdqPMpJ7ze/qXr24rXl3Vr3FSU6tSWZNvLZYbfNjDeOmxLop4YdS2Xs6jAsxRTzmes+M/h7jOebEdt8lLfRcuNuhU1/LXM9n28xTezWH6HrosnizmWWnjY9WV1b5X5niS3bezXREr4C4Rr8Q3KuLmMqenQeJy/ra+yv3PlUxHNgysm1i25u3Z0iGR4dcIS1uury9jJWFOXdY9o/Jeh2enCFKnGnTiowisRilhJFFnbULO1p21tSjSo04qMIxWyRdIldc1S5ftTadzaF7jq5Ux0jw/cANDxrxFb8PaVKvJqdzNNUafdvz+CPkRrOkINizXfuRbtxrMtZ4kcVrRbRWNlNO/rrbG/s4+b9fI4vKcpTc1JttvLznfuXr+6r397Vu7mo6latJylJv/AN7Er8MuFJave/T7yGLChJbNf4sl2+BJiItw6Ri49jYuHNdc8++fGfCPs3vhPwo4Knr+oUmptP6NCXZf1NfkdLPIxUYqMUkksJLsUXNalbW869aahThFyk32RGrr75c/zs25nX5u19/SPCPBh8QapR0nTp3NRpy6U4d5S8jk2oXVa8uqlzcScqlR5kbDijV62sX7q5aoR2pQ8l5/FmoSff4/A5ttzas5t3gon0KennPj+E/Ex+yp1nrKh9Mpv4HnVPZ/Mqk+3Y2PDekVdZ1ONrFONKPvVZ42iv3ZT2bNd+5FuiNZnolVVRTGs9G98PNAVxcLVbmn/Jp/4MWvrS8/kdELdrQpW1vChRio04RUYpeRcOo7OwaMGxFqnr3z4y1+/em7XxSAAnsIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQcW6Srug7yhH+dTXvJfaX7kHk/d3+46uQvjDSPo1X6ZbQxRm/fS+y/2NL3l2Rrrl2o/+o+/5WWFkf9ur3I00UvOOuSufvZWcblMlt6mka6LRNeDtbjdUlYXMsV4L3G39eP7klORwlUpTjUhNxnFpxa7M6JwzrNPU7VQm1G6pxXtI+fqjoW722f1FMY96fSjpPjH5hU5mNwTx09DizQbbiDSp2lbEKiWaVTG8JfscH1XT7zS7ypZX1J060G012a80/I+kCMcfcLUuIbDno8tO/orNKb6SX9L9DbaK+Hks9g7ZnDr7K7PoT8p8fZ4uZeH/ABXX0C/hSre9YVpYqw/o/uR3C1r0bq3hcUKiqUqkeaMl0aPmy6t69rd1La7pyjVpvllGSxhomHhvxhLR7lWF9UlOwqywsvPsZea9DJct684Xm3tjRlU/qcePS79O+Pz9XZwU05wqU41KclKElmLT2aKiO0Brtf0aw1uwlZ39JTi/qyX1oPzTOIcX8NXvDl8qVbM7eb/lVoraa9fJ+h9AGNqVhaalZztL2hCtRmt4yX4nuiuaV1sjbN3Z9enWiesfeHzckp4e0cbZC5VH6z5c9yW8bcE3mhVZ3VpGdxp7eebq6fo1+pEVhrGU31S8iVExVzh0fFyrWVbi5aq1h5Hlk8JuPmj1pPL6nnnzNJs9ntTxj4Jn2UlI+BOJa3D2pqTlKpaV5JVqeei/qXqjudpcUbq3hcW9SNSlUXNGSezR80uLbckt0vuJ54XcWrTKkdI1Co5W1WeKU3/wpPt8GYrtvXnDVd4tj/qKf1NmPSjrHjH5h18BNNZTymCM5+AAAAAABiahqenafj6be0LfPRVJpNh6poqrnSmNZZYMay1Cxvc/RLujXxu1CabRkgqpmmdKo0AAHkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADBvNY0qzk4XWoW1KS6xlUWUHqiiqudKY1ZwLNpdW13SVW1r061N/ahJNF4PkxMTpIAA+AAAAFu6r0rW2qXFeahSpxcpSfZIPsRMzpDD4g1a00XTKt9dzShBe7HvKXZI4NxHq13rOpTvbuplzfux7Qj2SNhxxxNW4j1Ryg3C0pNxowfl3b9WR1LGU4vPr0JNujTnLpGwdjxhW+0uevPyjw/JKLckk2mt+hSovm3e/ZFUubO3TyZ4p5338s9EZWxcxrLT2ynuG1n6sljr6FUYNyxvLPRLrk6JwHwFO4nDUtZpunS2cKLfvT/zeS9D5VXFPVCzc+zhW+0uz7PGWq8P+DrjXKkby9i6enxe7e0qvovT1OzWdtQs7anbW1KNKlTWIxisJIrpU6dKnGnShGEIrEYxWEkVEWuuanNNp7Uu7QucVXKmOkeH7gBh6xqVppVhUvLyqqdOC79ZPyXqeFdRRVXVFNMazLH4m1uy0HTJ3t5LptTpr605dkjhOv6tea1qdS9vamXL6sF0iuyRkcX8RXfEOpSuasnGjB4o0l0iv3LHDGiXmvapGyt1JraU6mNoR9SVRRFMay6NsjZdvZlib9+fS05z4R4M3gfhyvxDqSpJOFtTadaol0Xl8Wd1sLS3sbSnaWtKNOjTjyxil0Mbh/SLPRNMp2NnTUYRXvS7zl3bNgYK6uKWn7Z2rVtC7y5UR0j7j2WWc644176dXdhaz/wB2pv32uk5fsbTjnX3T5tLsqmJy2rTi+i/pRBnh7d+25pG8W2NdcWzP/wBT9vyxYePp/Uq9yhtZylg8ks4y+h7hcyeOhSnmWFnqacs1Vtb1ry4hb29NyqzeIpdDrPDOkUtH06FCOJVWs1Zru/2NVwLoDsLf6ddwX0mqvdi/sR/dkpOgbv7J/TUdvdj05+UflT5mRxzwU9IAAbKggAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFNanCtSlSqRUoSWGn3RUD5MRMaSOdcRaVU0u72TlQlvTn+j9TVPzzudR1KyoX9pK3rxzF7p90+zOc6vYVtPvJ0Kq6bxl2a8zm+39jzhV9rb9SflPh+F1iZHaxw1dYYMnsXLK7uLK7hc0JclSLz6NeTLc15lMk36rzKCiuq3VFVM6THRMmImNJdP0LVKGq2arU/dmtqkM7xZsDlOj6lW0y9VzRlnG049pLyOmaXf2+o2kbm3nmL2a7xfkzpexdsU59vhr5Vx18/OFJlY02p1joi3iPwjHWrWV9YRUL+lHdL/ix8n6nGJRnTm6c4yjUjJxcWsOL7n00QLxI4KWqRnqulwxeRj/MpLZVl5/5jYrdenKWw7A252GmPfn0e6fD9vojvhrxpPTqkdL1Oo5WcpYpTlv7Jvtny/I69CUZwU4SUoyWU09mj5mqQlTnKE1JSTw01jD9Se+HXGn8LnDStUrOVk3inVk8+yfl/l/I9V0a84TtvbCi7rk40c++PHzjz+rroPISjOCnCSlFrKaezR6YGivJwjODhOKlGSw01lM5rxr4dwmqt7oNNRnJuU7dvZv+39jpYPVNU09E3Cz7+Fc47U6eMd0+180V6dSjWqUqtF0qkG1OEo4aZb5ll99un6ne+KuE9L1+DnWpqldJYjXgt/n5o5FxRwnqnD9SLuKSq0G2o1qazH5+RIouRVydB2Zt3HzYimfRr8Pw0Klv16dBH+tLEm9mMJZ81s/QL3Ixl1+WTIvHWvC7i76bShouo1W7iCxQqy/4iXZ+qOgVJwpwlOpKMIRWZSk8JI+aKdetRqQr0Jyp1IS5otPDTXck/EXHGpaxo1GwnGNOKilWlH/iv19DBXa1nWGm7S3aqvZMV2OVNXXy/wB3SLrj7hmhc+w+myqNPEpQptxXzN3o+sabq9F1dOvKVxFPElF7r4rqj5xk9sZxl4y/MytOvrnT7qnc2depQqp7Si+rPs2Y0ZL+6Vmbf9KuYq8+j6SBAODPEK3vXCy1lxt672jW6Qm/XyZPZVKcaTqucVBLmcs7Y8zBMTHVp2Xg38S52d2nSfr7Gm4z16lw/o87uSU60nyUYN/Wk/0RwfVL261C+q3N7UnVq1JOUpN5+SN94icRPXNal7KWbShmNFfnJkZlyzlFt9PuJFujhjV0HYGy4w7EV1x6dXXy8ly3r17avCvQrTo1Ye9GUG04nROE/EmrDktdch7SC2+kQ+t813Ob1HnbDx5lLSUUt/2PdVMVRzWOZs7HzaOG9T7++Pe+ldOvrTULZXFlcU69J/ag849H5MyD5y0XVr/Rrr6Rp91OjUf1kn7sviujOm8N+JNnXcaGs0/o1TOPbQWaefXujBVamOjRto7t5GNrVZ9On5/D8OgAooVqVekqtGpCpCSypReUysxNcmJjlIAA+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGNqWoWWnW0ri+uadCnFdZPr8F3D1TTNU6UxrLJNbruuaZols62oXMKe3uwzmUvgiBcT+JblGVDQ6Tit17eqt/lH9znV/f3V7dOve151qst3KUsmai1M9W0bO3YvXtK8j0Y8O/8AZMeKfEPUtR57fTYuztns5J/zJL49vkQqdSc5N1JuUn3by382UbdYpP4nik01zRk0uu2xmppiOjdsTBsYtHBZp0+rd8I6/d6BqELihNulJpVaedpL9zvOnXlC/saV5bzUqVWKlFnzXKMX7yzy+R0Twh4jVrc/wO6lilWfNQbf1ZPt8zHdo15woN5NlRftfqbcelT184/Z1gFu6uKFrQnXuasKVKCzKcnhJHL+MfEatWU7XQU6dPpK5kvef+VdvmYaaZqnk03A2bfzq+G1HtnuhPtb4k0XR5KF/fU6dR/8Ne9L7l0MbQ+MNA1i4+j2l6lWzhQqRcW/hnqcFuatWtOVxXnKpUnLMpyeWxSk41YVYZi0+aLW267mbsY0bdG6VjstJrni8e74fu+mW0k23hI4/wCJvFv8UuJaVp9V/Q6T/mTi8e0kv0Rh6hx7q9zw6tNl7tRrE7hfWlHy2IhJSTTSzl74Fu3pOsmxN36sa7N7I6x0/P4eLLwksnrfO8PmS7opbaa3277COHKMebqtmzNo27zezxFcq2a75MnTNMvdRuY2djQqVqr6KK/HPYkfCPAuqazKnXuYfRLLrzzXvT+COu8PaFp2h2nsLCgoZ+tN7yk/VmOu7FPRr21N4bOHE0W/Sr+Ue38I5wTwHaaQ4Xuoctze9UnvGm/TzfqTYAjVVTVOsufZWXey7naXZ1kAMXVdQtNLsal7e1VTo01lt9/Rep8YKaaq6oppjWZe6pfW2m2NS8u6ip0qay35+i9ThnGfE1zxJfucuanaw2o0s7L1fqXONuKrriG7xl0rOD/lUv1fqafRtMu9WvadlZUvaVKjSS/pXdsk0UcPOXQtjbGowLf6jI9b5Ux+Xui6XeaxqFOzsqPPWl1x9VLu36Hd+EtBteH9Lja0UpVZb1quN5y/Ys8F8NWvDuneyppTuKmHWq46vyXob4xXK+KeTXNubanOr7O3yoj5+f4CO8Y68tNofRraS+lVF/0Lz+Jl8Ta1S0q2wmpXE17kfL1foczua1S4uKlapNznN5k31Zq23ts/paZs2p9Oevl+6sxMbjnjq6LM8yblJtvq3ndlLe+c4Xl3KniL6b4KJPGU9zn88+crdS8t4zgl3AnD8ritHU7yn/Ji80ov7b8/gYHCWg1NVu1UqR5bOn9eX9T8kdNpQhSpxp04qMIrCS7I2zd7Y/azGTej0Y6R4+fsQMzJ4fQp6qgAbyqQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA12vaXS1OzdN4jVjvTn5P9jYgxXrNF6ibdcaxL1TVNM6w5PeW9a2rzoV4OE4vDRYbeP3Oj8TaNDU7ZzppRuYL3JefoznVzSnQqyo1YuM4/WTXQ5htbZVez7unWmek/b2r3GyIvU+ay8LKM/QtWr6TeKrTzKm9p029pL9zAxldclOWV1i9XYuRctzpMJFVMVxMS67p17b39pC5tpqcJL5p+TMg5ZoGs3Ok3aqU/et5NKrTfdea8mdMsLuhfWsLm2mp05L7vRnTdkbWt7Qt+FcdY+8eSiycabM+SD+I/BUdRjPVdKpKN3FZq0o/8Zenr+ZyKpF05zhKMoyTw4tbrHmfThBvETgmGrQnqOlwhC/S9+HRVl+5fW7mnKWybC2/2OmPkT6PdPh7fL6Iv4e8cT0yVKw1KpKpYyfLGeN6P/8Aydeo1adelGrRnGdOazGUXlNHzTc0atrWnRrQlGpDaUWsOJL+A+NLjRbiFpeN1tPm8NdXSfmvT0PVy3rzhP23sCL8TkY0c++PH2ef1dqBZsrq3vbaFza1Y1aU1mMovZl4jtDmJpnSQorUqdalKlVhGpCSw4yWUysB8idHPuLPDi2u3K50WcLatu3SnvCX7HMNW0q+0q4drfW9SlUXZrZ+qZ9IGh47qabQ4buq+pUKdaCg1CMlu5PokZaLtUcm0bJ3hybVVNm5HHE8o8fj+XAk1FLd7Y6nknNrDw8vt3PJNqXRYzloqjJNSW0fJEl0M6yXbOx4+ucb9MBNPKcXnH4nrxJJ479x0HiXuKXZPsbmhxLq9LR6ulK7nO1qLDi3lxXkn5GnbXKm49Op48N7Rb7JidJ6sVyzbu6cdOunMwlHMk0m/MqlyrdJY74KYOK7br8BFxeOXL+PRBk0VYyljb4sSeybW7eMrsePdLO76Lfqz17rZpNdPifNAWG8vttv1PHjDXM91947Yk8+ueh5hyystdlufeg2+ha/rGjVIysrqcY96ct4tfA6Pw54lafcxjS1em7Sp09rFZpv490chjnbKfTCPVHK6y33aR4qt0z1VedsfFzOdynSfGOU/wA9r6VtLq2u6KrWtenWpy6ShLKLx846Vq2o6XVVWxuZ0Gn9mWz+K6E90PxQqU1ya1aRnFPCq0Nn84vr8sGGq1MNPzd18mzzs+nHzdRBq9H4g0jVoRdlfUpyazyN4kvkbQxTGjXLluu3Vw1xpPmAAPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2kst4Rota4t0LSVJXF7CpUX/AA6T5pH2ImejLasXL1XDbpmZ8m9MTU9TsNMoOvfXdKhBd5y/Q5ZxB4mahdc9DSrdWdNrCqyfNP4+SIVe3t1f1HVurmdabe7nLLMsWZ72zYW6t+5pVkTwx4dZ/Do/EfialKdDRbfmWP8AHqfpH9zneq6nfancyuL+5qVqi7t7L4LsYucYaWOxTGWHy9Vnol3M1NEUtvwtl42HH9Knn495u5YSxtv6nuyXJvHbLygtm2/xPJKW8+nzPSwexS3aaz+LR5l7tPLaw0G20uV5z1bXQqUXF8qTk29sLOfgDop5W9k1ldfgXKNWdCpGrTbjODzGXkzNvdF1Gz0+lqNzQdvQrSSgqjxKe3VR64Nc37mJSW3UROvR4ouUXadaZ1ht9e4k1XWY01fXUpwhFRVOO0W/M1HVvqz1OKj7vfszyompOUdnjofIiI5Plqzbs08FuNIVYylHbbtnc8lzcvVKK7ZPUs52xjB59baWMI+wyEHBrq0s/eee8o5y1HHRFfNHK5d++6MnRK9pQ1W2r3tD29vGonODfbJ8ea6pppmqI18mZw5w3qut11C0t5ypfaqz2hFfE6lwv4faVpTjXvEr25W6c17kX6Ilen/RnZ0p2cYRoSipQ5FhYZfI1VyanN9o7w5WVM0U+hT4R198iSSSSSS6JAAxtfADV8Sa7p+g2Lur6rjO0Ka+tN+SQe7duu7VFFEazK/rWqWekWFS9vaqp04L5yfkvU4fxlxPfcRXblU9y1g/5VJPZer82W+KuIb3iC/da4n/AC4N+zpJ4UF8DB0bSbzWNRp2FnTc6k928bRXm/QkUURTzl0PZGxrWzqO3vzHH8o/niaTpd5qt9Cys6TqVJv5L1b8jt/BXDFrw5YckWqt1Nfza2OvovQucIcNWfD1iqVH+ZcSWataS3k/JeSN4Y7lzi5R0a3tvblWbPZWuVEfMNVxFrNDSbXLxO4ntTp56+r9CriDWLfSbbmm1KvNfy6fm/N+hza9uq97czuLmfPUk+vl5I1rbW2qcOnsrU61z8lTjY3aTxVdFF/c17y5ncXE5TqSe7Zjy7PCRU3jost7lDa5srzOe1V1V1TVVzlbxGkaQpe7w89co2PDukXGrahGlCLjSW9WbWyX7lrR9OuNUvoW1GLy/rS7QXmzqWkadb6ZZxtreOy+tJ9ZPzZe7E2PObX2lyPQj5+SNlZMWo0jqu2FpQsrWFtbwUKcFhIvgHRaaYpiIjoppmZnWQAH18AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAI/xboS1Gj9JtkldQXTH115fEkAI+Vi2sq1Nq7GsS927lVuripcdqRlTk4zi4yi8STWGvMpezfV58if8XcPK/i7yzglcxXvR/wC8X7nP5RcJuElJSTw0+qZzDaezLuz7vDVziek+K/x79N6nWOqiXXHkbPh3WbjR7rmi3KhJ/wAyn2fqvU1mVzb48tjx7fF7EKxfuY9yLludJhlqoiuOGXYNNvrbULSNza1FOEvvT8mZJyXQtXutHvFUoyzTl/iU30kv3OnaPqVrqlori1nlfai+sX5M6VsjbFvPo4Z5Vx1j7wo8nFmzOsdEc494Mt9doyurRRoahFfW6KovJ/ucZvbG5sLudtdUJ0qtN4lGSxg+lSOcacJ2PEdunP8Ak3dNfy6se/pLzRf27nDyld7F2/ViaWb860fT9nKuDOK73h66ju6tlN4qUG+nqvJnatE1Wx1ixjd2NaNSm+qT3i/JrszgWuaXeaPf1LK8pOnUjum/qyj5rzK+Hdbv9Dvo3VhVcW/r039WpHyZkqtxVzhf7V2LZ2jR29iYiqe/un+eL6IBoeEuKdP4ht/5MvZXUVmpQn9Zeq80b4jzEx1c/vWbliubdyNJgIH41QrS4ftZxz7KNyufHbKeGTww9Z0621XTa1hdR5qVWPK/NeqFM6Tqz4GRGNk0Xao5RL5xajjMsySf3+pS+rWMvGxveMeGr3h+8VKrHntpP+VVS2l/qaLG2U21+ZMidecOtWL9u/RFy3OsSc3Km319O5VJyxvjGTyMllvlbfTCGejfVvc+6ashBprbG/oItY3W68gsxTaW/ZoJZW79X8RyJeZbnutks7FSzjeLeXhL18hSUqk1GClKTeI4W+TrnAvCFpolj/GtbjT+lRh7T+Z9WjHrnyz6niquKeav2ltK1gW+KrnM9I75QbTOBuINTpRqwtVbUWubnrPl/DqW9S4S1awi5QjQulFe97CqpuPxXU2HHPG97q1xO1sas7WwhLC5XiVX1fp6EUt7ivbXUa1CrONSEk4yUmmmfY49ObFi/wDELlPaXZpp1/x0+s6rMotSfRtLKR7lNJLfPT0JFqtpW1mnY6vaWy9vdSdCvGmsR9ovtemU8mhuKM6MZOWyUnDmS2yvIRMSnWcim7Hn3x4T0W3hTSy8JbsoW6T3SPVtFY6+Z7GOU5S6t77dT3CR0eyy4rdPL+88fL2j3xv2PcPDais/kVQab238meXzXQpSnTqc1OcoT/qi8NEm0TjriLS+SnK4jd0ltyV1nC+K3Iu88+Jd+vqeJ8ry2+YTTqwX8Wzk08N2mKo83YNI8TdKuOWOoW9W0k3jmXvx/cl+m6tpupQ5rG9oV/SMln7up84Jt/V6fkXKFarRknRqTpyTzzRk02/iYqrMdzXcrdTHuc7NU0z8Y/PzfTAOFaPx1xFp0lB3juaUcYhXSl+PUlemeKVGSitR06cNt5UpZz8mY5t1Q17J3azrPqxFUeX4l0oEa0zjjhy+jH/flbzl0hXXK/2JDRr0a8VKjVp1IvdOMkzxMTHVS3sa9ZnS5TMe2FwAHxhAAAAAAAAAAAAAAAAAAAAAAAAAY95fWdnTdS6uqNGMernNIjupcfcOWbxG6lcP/wAKOV959iJnokWcS/fnS3RM+yEqBy3VPFKtJuGm2EIdffrSy/uRE9V4v4h1OMo19QqRhJ55Ye4l6bfqe4tVSu8bdjMu869KY8/2dq1XiHRtMi3d39GEln3VLMvuRDtY8ULWnGUdLspVpY2qVXyxz8OpymUsy6vL7t9zx5ecpJ+XmZIsxHVsOLuti2ud2Zqn4R/Pe3+s8W69q7aub2VOk9/ZUfdijQvmcnJtSnLO7/MNLZJpvy75Kp8yfKly+WTLGlPRsFmxasRw2qYiPLk8jvJuWPq9EUtJy2ymj1cqS5dl3fkKa2bTXT7z7DMY9/KzKPl5HkMNbPKXbzPHtu5ZTZXss4WEuo00fVPuyjjHvvyPEm112SxnuzecP8LatqzU4Qjb0pParXlyJ/DuyV0tG0Hg/VreOu28r1VYqUK7X8uDX9vc8zXEdFbkbUs2auzo9Kvwjqg9TTbyGl/xCvR9lauSjF1PddR/2rv8SnStTudNquvZTjSm1jmcIzkvhlPB1/jjhq34r0m2utNuIKpRg3QcfqTi+3p0RxvULW4sbupa3VGVGtTfLKLWGj5RVFUI+zNo2tpWppr04u+nwj7pPxTrlXiDhfTbi4k/b21xUo1WkvefLFqX3NEQaeMrO+xtLOCnw7fKUtqdak4rybyn+SNa9tmeqY05QnYVqixTVbojSImfnz+4l3T3W254udRcnLdroG/VKWd0j3qsrK7dT7KY8zmDeGpdGu3xDezxjywg01J913Ku/TaPRDTk+CSUOyeN13KWuWWMM9TT5u2OuPMl/AXB11rV3TvLyMqenwlzSb2dTHRI+TMUxrKPlZVvEtzcuzpEOn8AQr0+ENOjcKSn7JPD647fgb08hGMIKEEoxisJLsj0hS5Ffudrcqr8ZmQAhXHXHVro8allp8oV7/DTfWNP4+b9D7ETPRkxMS9l3It2o1n+dW14x4qseHbRuo1VupL+VRT3b835I4nrmsXut307y+qOc5fVin7sV5L0MW+urm/uZXV1WlXrTfvSk8tm64N4Vv8AiG5SpwdG0g/frSWy9F5sk0000RrLoWDs3F2PZm7dn0u+ftH85sXhvQ77XdQVpZUumHUqSXuwXmzt3C3D1hw/Yqhaw5qslmrWl9ab/b0MnQtIstGsIWdjSUILeUu835t92Z5hrrmpqO2Nt3M+rgp5UR3ePnIazX9YoaVb5lideS/l089fj6FriLXKOlUnCOKlzJe7DPT1Zz+/uqt5XncXE3Kcnl5/TyNZ21tynDibVrnX9P3V2Nizcniq6KdQua97czuLmTlUl1z2+HoYsmvUuNc2d/iUNYz+Jz2ququqaqp1mVvERHKFOMPbOWX9Psri/u421tFylJ/JLzZ7YWle+uoW1vBznJ4fp6nSeHtGt9ItVCCUq0l/MqY3fp8C42PsivPr4quVEdZ+0I+RkxajzV6DpNvpNmqNJJ1HvUnjeTNiAdItWqLNEUURpEKWqqap1kABkfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjnFfDsb+Mru0jGN0luuin/qSMEbLxLWXam1djWJe7dyq3VxUuM1Kc6VRwqQcJxynGSw8lDa88HSeKuHaWp05XFvindpbPtP0Zzq5o1berKjXpuE4PDi+zOZ7U2Vd2fc4audM9J/nevrGRTejWOqx1bxuzJ0nU7zSrxXNrPlf2ovpJepj9VhP1KHly37lfauV2q4ronSYZ5piqNJdb4f1q11i29pRly1Y/4lNveP8AobM4pZ3dzZXcLm1qunOL2af4fA6XwtxLb6vD2NXlo3cVvBvafqv2OhbH29RmRFq7yr+U/v5KbKw5t+lTzj6M3iPQ7DXrCVre0k31p1Eveg/NM4nxZwxqHDly414+1t5f4ddL3Zeno/Q7+WL+ztr+0qWt3RhWo1FiUZLZmzUVzSlbK21ewKuHrR3x+HzhZ3FxY3NO5t606VxB5hODw0dc4J49tdS5LHVqkLe7wlGo9oVP2ZFOOuBLnSOe+0xVLmx6zgt50v3XqQpLlb3b5fPZkiYi5Grdb2Ph7bsRXTPPx748p/D6aW6ygcd4K4/udL9nZarz3NnhJT6zpr9UdbsL21v7WFzZ14VqU1lSi8kaqiaerQ9o7Lv4FelyOXdPdLzULK1v7WdreUYVqU1hxkjlHGXh7dafKpeaTzXNost0sZnD4eaOvgU1zT0fNn7Uv4FetueXfHdL5lx7vTlx1z1PHPM2/QmHivU0ufEbp6fQpwq01i4qQ2UpfuQ5p4w1v1SZKpnWNXUcO/8AqLNN2adNe6Xrw44XftjueY9xYzl9MnvuyTW2F0z5lKayur3PUeSTCd+EWg/TdYqalcQToWrXKu0p/wChs/F/iLM1oNtUxFYlcY7+Uf1JFwlCjw74eU7yaxig7mb7ty3S/FI4zf3da/vK15XeataTlLPmzDTHHVrLUsOj/iW0q8mv1bfKPb/OfwY+2ebLwuuQ372U8rr0GUs5l7z2wHLMXFJt9c+ZmbYmVpqU9C8OpUU5RudVrTlTT6wppKLa+OPxK/CWylqOoXdld0VX090s1qdVc0VPs15P4ESvb+veez9vPKoUo0qaSwoxXY7FwTZUeGeDJahdx9nUq0/b1s9VttEw1+jE+MtY2rph4lcaf1LtXz7tPZHzQnj/AId4d0q5nRstSlQueRzVCUHOKWNlzds+pDMtvle+FvkyNVvq+pX9e9uH/NrTc5b9PRfAsUa3sK0Kvs41OSSajNZT77mSmNIXeFYu2bEU3Kpqq07/AB/ni8Tz3bR5FvnS3SWzRMeKdN4Zp21vcQu6lhe16Ea07eFN1ILK2X9uSOPR9QhZwvlbSrW8ulal78V6Sx0fxEVRJYzbV6jin0deXPlz8u6fcwG8Sw2sp53PX1fNhSKVh5i87FbaxFOKyl8z0mKU317ds7HqUk08tY6ZXUOLWPdePieOO0nv08x7X15mUm8L4sqbwlKOGsbfoeKL5cZ7bfATjzNpR679dj77RVHLk+ZYfdepesry6tnm1uK1Gf8AZUcfyLUZNw7LPTC6FLTkuXbGfmeZ06PFVMVRpVHJJLDjfia02jfyqwjjEaqUvxe5vbPxR1OM0rmxt6kF9Zxk4s582toxxn7Qa2xGKS9WfJopnuQLuyMK969qPp9HWrbxS05tK60+4p+sJKX7G1s/ELhm4eJXVSg//Epv9MnEIx5sZaz5jC2eEt90jxNmlW3N18Gr1dY9k/l9CW/E/D1w0qWsWkm+i9pj8zYUr2zqpOnd0J56ctRM+bPd2bin33PIvE04uXu+XQ+djHdKFXujan1Lkx7Y1/D6ZjOEuk4v4MqPmqje3lLaleVoYXRVGjKhrerxWI6reR8l7aWPzPPYz4o1W6Fzuux8H0WD55/2i1+EFGOsXjS3z7RlynxRxEsL+L3X/UOxnxYp3RyO65HzfQQPnqXFGv1Jcr1e7i10xPqW58Qa90nq17JelViLMz3vsbo3++5HzfROV5lE6tKCzKrCPxkkfOtXWdWmvf1K7ez2dV7mPWuLiqv5terNuOPem3sOx82WndCv/K7Hw/d9F1tR0+is1b23gvOVRI11xxbw3QbVTWLXK7Rln8j5/WXFc26XdvzPNk1Hr6I9dhHik0bo2Y9e5M+yIj8u13fiRw1ReKdW4uPJ06Tw/mzU3fipZxnKNtptWaXSUppHLE3hrbHkmeJJtZeG8fE+xapTrW7GBR60TPtn8aJ3deJ2s1FJUba2ors8OTNFfcW8RXv+Lq1eOfs03yL8DQz5ce69j1LPXKwtmz1wUx0hY2tlYdnnRbj4a/VXXr1riq6latOpPH1ptuRaaTTjv5ts9TjnOG8njeVjq0tz2sIjTlA2o9MxXng9lHEVnv28zx83s98NPpgqk23tv5AeSbeMJI86Sz0eMJMq92Tins/I87pLGz3PkDyL6NrGfzPZKUkpPbCeFkPOemN8pmRZW91eVvZ2ltVr1enLTg5P7kfZ5PlVUUxxTyYqytnnfqI7Zk1t3+BItS4UuNI0j6drNeFpWq7ULdLmlJ/3Y6Eem1nKfN22QidWOzkW78TVbnWPHub3TeGNSvbOWoVYqz0+EeaVevmKx6LrIkvhjp3DV9qVahXs53FxRip0518cs158nZ/HJhUNUqaj4aXOmyqtVbCcJtZ3lTz+hHOGtUlpOs29/BvFKackn1j3/Axc5iVLdt5WZZvUVVaTEzERHLzj26tr4k2V1p/FNxGtUqVKVT37bmbaUH9leWHthegttQnrnD9XR7ur7S7tU61lUnLeWPrU/VtdCd+Kumw1fhelq1ovaTt0qsXHG9Nrf7upx6UkpR5cpx7rqKPSp83zZVdOfh0a8q6OXsmPzHX3pJwZxdf8PXCptutZSeZ0ZdvWPkzpWp6boPHejxu7ecfbKOIVorE4P+mS8vQ4g++Yvdr5mz4f1u/0K9+lafVw3hTg/qzXkz7VRrzjq97R2P21f6jGngux390+3+e1n32kalo8NT02/ozhy01VpzS92ajJbp9+pHlnO+8XujuejajpvHHDVVSpKFSUXSrQay6cmuqfddGcX1Wyr6bqlxYXCanRqOG6xt2fz6iirWZiepsjaFeRXctXqeG5T1j5asPDi1iSTb7ntTChytJb527njSzJPr6FSXK1l/Bd0ZF6pcd0nlrsi7bUaletCjRpTqVpbRjFZb9S2otPHZvL/Y6b4Ly0qc7qm6H/ANRp+9GpNdYPtHywea6uGEHaWZOHj1Xop4tFzgnw79k4X2vKEp9Y20ei/wA37HSKcIU6cadOEYQisKKWEkVAi1VTVOsuYZuffzbnHdn3d0ewKK9alb0ZVq1SNOnBZlKTwkjW8Sa/p2g2Uri+rJSx7lKO85vySON8V8W6jxFPlq/yLRPMaEZfn5s+00TUl7L2Lfz54o5UeP48Uh458Qp3UKlhokqlKi01K4xiUvh5L1OexknmW/M1vzeZ7QpVa9aNGjF1KlR4hGKy2zqPAnh6qHs9R16KnW+tC16qH+bzfoZ54aIbvXXhbEx9I6/Of58Gh4F4GudYlC+1GM7exUsqLWJVfh5L1OwWVrb2dtC2taUaVKCxGMVhIvJJJJJJLokG0llvCRHqqmrq0LaO1L2fXxV8o7o7oDQcScQ0rDmtrZqpc43fan8fX0MTiTiRQUrXTppy6Tq9l6L9yIScpS5pSbbe/dmo7Z3gi1rZxp1q758PZ5vGPi6+lW8uKlSvXlWrSlOpN5lKTLbT5U89CqWc4xldylvHV79jRpqmqdZ6rOOSn4PJe06xr6jeRoW0eacur7Jeb9C5pmn3OpXKoW1N57y7L1Z0bQ9Kt9LtVSpLmm/rzfWTLrY+xq86viq5UR3+PlCNkZEWo0jqo0DRrbSbflpxUq0kvaVMby9PgbMA6PZs0WaIt240iFRVVNU6yAAyPIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGl4l0C31ag5pKncxXuTXf0ZugYcjHt5FubdyNYl6orqoq4qXGtQta9lcyt7mlKnUi+/f1MaS7N4/U65r2jWmr2zhWglViv5dRLeL/AGOY63pd3pd17C6g8dYzX1ZL0OcbX2LcwKuKnnR4+HtXuNlU3o0nq10s55tk/wAzyDlTmp06jhUi+aMs4aKpLHn0wW+3V5KWmZjnCYn/AAnxjCvyWeqyUKnSFbtL4+vqTVNNJppp9GjhMsyW3mSbhXi+40xxtb5uvadE/tU/h5o3LZG8emlrKn2Vfn8qvJwNfSt/B1BpNYayiA8b+H1vqHtL7R4woXT3nS6QqfDyZN7C8tr+2jc2laNWnJZTRfN1ouaxFVMoeJmX8K5x2p0n+dXzVeWlxZ3Era7pVKVWD5ZQmsNHbvDPSf4XwvR501VuP5s1npnovuM7iXhnSuIKKjfUcVIvMK1Pacfn3XozbW9KFChTo01iFOKjFeiMtdzijRc7W27+vxqbcRpOvPw8tFZHuPdfjoOh1KsJR+lVU4UIvz8/kSE4V4k6tW1Liu5hLehbS9lTi+2Or+bPNunilE2Fs+M3KiKvVp5z+EanOpOcpOTlKUm5Sby35lEsppKXTqvIqTcZJtLOOnqUrGd2l3bwS+rqURoq2ecZy9sruULKi0uvRehcX1sdVjO3mUJNPL6n3Uh1ni+99r4U2FSg/dq06MJ47YW6+9HJ02tpvdb+pKtA1ald8OVuFtQrKnGUlO0uJ/VhPOcS9H5+ppbnSdRtKzpVrOvlLLcIuSa801tgxURw6xKk2XajD7SzX14pmPOJ6fu1++3RJvfBVVp1qNT36bg3FSXMuzJTw5wxONB65rVP6PplvHnlCa3rPtFLtvgj+q3tS/1Grd1cfzJbRXSK7L5LB6irXWIWNrKpvXZot84jrPn4fls+BdG/jPEVtbyg50Yv2lbPRJfvsTfxl1lW9nQ0WhJc1TE6qXaK6IyvCXTI6Xw5X1i6xGVy3NN/ZpRW36s5pxPqdTWdfur+csQqTxBdcRXRGKPSr59ygo//AJHas1z6lr6/z6NXFNtPbPmZ+h2sLvUacaknGlSzVrPH1YR3f7fM17wprdxz0NzOUbLhz2fKvb38k5Y7Uovb4ZkZqpnTRsORVMUxTT1q5fz2QwNTuneXte5nn+ZLb0XZfDB1Twbs5W3DVzfXCxTr1W4p9HGKxn78nJ7O2qXdzTtaX+LVmoxXXqzsvGdxHhvw/VpQbVR0o28OXZ5a3f5mO5OsRTCh3gq4rdrCt9a5j4Q5xxdrlrqmoV42umWdvT52oVYxam0n37bkc6pczx7x6mp5k+mOr8yl9O+34GWmIjkv8fHosURRR0hdVKrOMpxpTlTi/faWVH4lE98xik89CT+GFS5nxVb2dJylb1eZ16b3jKCT6rv2JT4j2PCWl1aSnpVT6XcJv/dqnJypd2s4/A8TXpVor7+1Owy4xpomZmNY0++ujl7SUVnCQyuTme2PTqbfR9ElrdzVt7CtSp14t+ypVXhzXo+mSzrGj6po1aFHULV0ZSWY5afN8D1xR0T4yrU3Oy4vS8O9rorKaeE1v8D1fVwsLH3nijLlxLfPTPU8hKX1nskt/dPvNneySc32b7jbPK2vh5sqzh8ucrHTyKUm8PK39NxqKeWXKunXy7HsXtHCw+2SqXNzbxy309Cnm25VHL8sdQ+9XrU8JPGPQ9eHHKUk28Hk+VP3m8Z8xlqKj0XVPux1fHr3w10XXJ59aDeFFdjzq0uy6+rKnnl3+q99xIKUscuFHz+JS8uMfe37YDbccSwm2VP6yylv59wdHnu/B+XmeJNSbzvnff07lUeRN4jhpFCUstN4ESKovMeZ4fYZaykk3k9ccTUcLZdDxTbWcvr2R88x5N7rfCyj1uM23F4SeG+46J47vy7nvTKimm9/Q+ilzjFLCznseU1KeXBNbZzgqltHlS2we5eU30xukfNAhmO6jn4jmzzNt5fmeLdpJjaWW9kz73jx5ctnyvGz8iqUsvGeq+seZW2XstjMttMvrm2q1qFnVlRpLM6mMJL4nyZh5rrpo9adGHHrl9OrR5DkSyk1l9HuXIQpzuYqrUlCDa5pKPNheeO5NaGicKW/C91rdO4ur+pSioxpz/lpVJfVylvg+TVEI+TmUY+nFEzrpHKPHz6IM3h7pLHTJnz0m/holLVnRzZVKjpqaeWpLb5GA8N5lu128zrvhnTsdW4FnpFy6bcpVOamnuk3tL7z5XVwxEo21c+rBtU3YjWNYifY5GmlnPXHfzN1wtxFqGi3VB0KzVvCfNVp42km98mPxNpFxoerVbC4i24b05tfXj2ZrEk2s7vPRHrSKoS6qbOXZ5+lTU7J4p2K1bhSlqlo1L6Pismt805Lf80/kcdk8RfZdW+52PwuvaWqcJ1NKr++6CdKUX3jL/2zk+u2M9L1a6sZw5fY1XBZf2e34GO11mmVFsCubNV3Cr60Ty9k/wA+Zpd9Owq1KkIqcKtKVOdNv6ya/R4fyMTZxwtkt1sURe2XnZlUemyzv1Zk072x8ERVNUdZde8JNUhqWgVtGuvelbpxUZfapvt8uhzbijSXo2vXWnz5uSE80m19aD+qZPA+sfwTiK3upycaM5ezq/5X/wC8k48ZdI+kWFvrVvDnlR9ypjfMX0f3/mYo9GvylrFH/wDHbVmnpRd+v+/1cok4uDTi00VJS5V39UeJrO63/U8xJxayl+pm7tG0pV4ba09H4gpqpNK2ucU6iz08mSrxf4eqXPsdasaMqlSK5Kygs5XaWDl1vGHtqcK1X2UHLllPGeVeZOeIPEC8qWdOw0WUrenThGm68knUnhYzjosmKqmeKJpa9n4d+M+3kYsc/wDLXpp5oNdUqlGfs61OdOaxmMo4aKd+ZJPOe5Xc1atWtKrWnKpUk8ylKXNKXxZRKLw845k1v0wZIbBTM8McXUw2/dz1z6GboGqXGk6nQv6D9+lLMkn9Zd0zDil7LGHjr8ymLwsNLL6YE83yuim5TNFUaxL6R0fULfVNOo31rNTp1Y5WOz7oyzlXgtqtWN9c6ROeaMoe1pJ9mup1UiV08M6OT7Uwv0WTVa7u72OaeNWjuVK31uk37n8mqs7Y6xf5kB0LQtS1y7jQsKEpb+/Ue0Yr1Z3vXtLttZ0urp13zeyqYy4vDWHnb7i5penWemWkLWxoQo0orZRXX1fme6bsxTot8LeKrEwosxGtca6eEQ0nB3B2m8PU1UjH295Je/WkunpFdkSUGFqupW2nUeetLMmvdgusiPevU26ZruTpEd7X7167lXJruTxVSyq9alQpSq1pxhCKy22QriLiCreSdtaN07fu+8/2Rh6xqtzqNbmqtwpL6tNPZfuzWyfX44ND2vvDVka2sflT498/iE3HxYo9Krq8eMY7Itrv1LiXX9SnfpnBq6bqoa9X8TO0bSbjVLnkpQxBP36j6JfuZPD+hV9Ukqkm6dsnvP8Aq+BP7K1oWdvGhb01CEeyNk2PsGvLmLt7lR85/ZEyMqLfo09VrStPt9OtlQt44/qk+sn5sywDoFu3TbpiiiNIhVTMzOsgAPb4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYuqafa6laStrumpwl084vzT7GUDzXRTXTNNUaxL7EzE6w5VxPw7c6NN1IuVW2e0amOno/I0DSW/U7lVpwq05U6sIzhJYlFrKaIBxZwfUoqd3pUXOkt5UerXw8zRdr7u1WtbuNGtPfHfHs8Vxi50Vejc6+KFvfOS39ZcvZ9ytvDw0853KJprZSNU0WTYaHrd7o1z7S0qe63idOW8ZL4HT+G+I7DWqajSmqdwvrUpPf4rzOOzSzu9+57RqVKFaFWlNwqRw4zi8NP0LrZe2r2DPD61Hh+EbIxKL/AD6S72CAcKcdJqNrrMt+ka6//eRPKNWnWpRq0pxnCSzGUXlM6BhZ9jNo4rU+7vhR3rFdmdKoVnFfFbQ6+na9V1CEG7S7lzppbRl3T/M7UY+pWNrqNnUtLyjGrRqLDi/z+JPoq4Z1Tdk7RnZ+RFzTWJ5THk+bG3hpd+r5ehTJYlhYw1u+pOeLvD7UtNc7rS1K9tUm3Ff4kF8O/wAiEbRk4yzt5ruSqaomOTpuJm2Mujjs1ax/OpUawnHtuzyTwlnOer22K4YcXzdOuCjD3w8JbnqEqNFUuibSTe6eTIpahf0KHs6GoXdKHVQp15RX4MxkubHm1se74UUktts9j57XmqimrlVGrZ1tYuamhQ0ydWtOLqutVlUqOXM+iS9Opqny8ja2z+AT27LsI8yaWy37iI0ebdqm3ExTGmvN2Xja7jpnhxSpW6cVWpQpR5fJrc4y/dTw+Vp9OmDomnajbcVcKQ4fu7iFtqNs07eVSWI1cdN/PsRafCnEUbqVCppVfm5mlLlzB/8AN0wY7elMTqotjdnhU3LV6YirimefLWO6Y8YYOmWc9RvKVtBxSm8zm1tGC3lL5I91y6jeX9SVNKNGOKdKK3xCKwkbO/dDRdNq6dQr0695XSV1UpyzGEf6Iv8AMj/pl8z6eh7jxXFme1r7Tu7vvP8APumXhJpSv+JVdTWadlHnaf8AU8qJleM2q/Stco6ZBtQtIZk+znLt8lj7yVeGtnDQ+DJ6hc4jKsnXm3t7qW34I5Hqt1O/1S5vaksyq1HNtvbd9DxTPFXqocT/AJ3aty/Pq240j2/zVi8y2S2+QUV5rLXyPcR5VJvby8jzZ7YwvUytndJ8EdOTuL3VJRliEVRg30ed3j7kRrxI1D+I8WXcozThSfsob7YX+uTpPC8Y6D4dq6mvZy9g68s+bW36HFK9R1qkqkn78pOUvVsxW/SqmWs7K/5raN/KnpHox/Pd8294Cuo2Gv0tRqKUqFus1PniP6k+8Z7L6ToNrqFN/wCBU95+cZLBzWknb8M16kuZSubiMKe3WMVlv4ZaXyOvUccS+GyinGpVq2fK32VSK/dHmufS4kfbEzZzLWZ3RVwz7P5q4hD13ae2WS6ztOF77hqrqV3RuNPrUKiptUJuftG1thMhzU8+9HGN8M2t/wA1DQLKhFpqtOdy8Pp9lfkzLVEtiy7c3OCKapide6ffLAuFBVajtpTdFyxFz+tj1PIRlOahTj702lFd230KI7NbJZX3kt8LNMhqPEtO4r7Urb30pfan2S/MTOkaveVfjFsVXav8YRrUbG7069naXsHSuIYbi92s9DHxyuT2TXf0Jp4yUvY8WqqlhVaEZZ9VlfsQrKTWEnjdLofaZmqNXzByJycei7P+UE+VLr7vTJ5JZwk/xOqeGdDTeJNLuHqWkWFSpQnFKpGgouW3f9yL8XXejWev3Fla6Dayo29Tkm3UlFya69GeYr1nh0RLW1ZuZNWNFueKnrzjT7Iqm1J82XlYW4i/eeZbJ9+5OocJ6fxBoMtW4elOjXp5VS1qSUsNdk+2eqyargTRNJ1q+npt9WuLa4fvU+XGJY6p57jjp01ZI2pYm3XXz9D1o05x7ka2eZLdx7PsG37u/Nj06k84x4W0HhqlSnXr39epXbUFHlSTXn95Botuooyzy5XNjrg+xVxRyZsTNt5dvtLeunmpTXM8LZ9DxS52sN/uTaz4c4du+H62s/xG9oU7d4qU5Qi5c3kvPOUQpybcknLGektthTOpjZdGRNUUROtPKdYeVFLZPD3yxLqlh79EbHQ62mU71R1a1q1aMpKLlCpyci8+m50finhzh3QOHKmrW2nq5qQ5FT9rUbi+ZpZa79T5NenKUfL2pRi3aLVVEzNXTppPzconFJL3sYeMCWN2s58yUaNr+nSuoUNW0PTZ29RqMpUqPLOCffKNp4hcF22l2C1XSXKVpt7SE5N8ifRrzR8ivnpJVtKm1fps3qZpmrpPdKAtx2fR/mbDR9FvNWnVdDkpUKK5q9arLEKcfNsw6UJVakKaiuebSj5/A6NxxbLhngOx0e3z7S5kncTT3m0svPpn8j1VVpOkdXrOzKrVduzb9eudI8o75RS3tuHI3at7m8u5Rbw7inBKP3PcztZ4GvbfT1qWlXENSs3Fy54L31H4dyJbpbtJdsk+8JNeqWeprR7qeba52pZeVGa7fNZPNUVUxrEsGfGTi2u3s18XDzmJ747/AGNLwPrGnaRqMY6npltXpVJYlWqUk50/VN9jonidpNbVeGqVfTHzQt37X2dN4U448l1wQvxU4fWk6vC8toqNpdtyxj6s+6/X7zceE3FHK46BqE24v/s05fjF/oeJjX04VGdT21FG1MXnMc5j6/Dv+LmnVpc7fnubWjVrLhWuoSxTldwUl54i2SHxR4WelX71Kyg/oVxLMoRW1OXl8GRq4zT4ftYreNSvKfo8JJfqZNYq00XtrKt5lm3ct9JmPdpza/ClJSzuuzJBompV9AlpOp0c9aqqLP14uXQj7bj3TM+6behafltzVStFN+XMhVz0hnyrdN2KaK41iZ0+Uus8aaRbcX8N0dQ09wncQh7ShNfaXeL/APfU4tVg4VJqp7sovDTWMYOj+EupX1mqljd06lOwnLNOrNcsFN9ot9c+ncs+LfDStqz1qzhilWeLhRW0ZdpfP8zHRVw1cLX9l5M7PypwLlWtM+rP2/nf7Wp8LtW/hnFNOFabhQu17F5e3M37r/8Afmbnxp0lUb+21aEF7OuvZVcL7S3T+5P7jniqShOM4ucZJqUWusWvI7ZcKHF3h2pOOa06Kkl3VSP+q/E+1+jVFTJtSP0WdazI6T6NX8/nRxHDw9tjOsNPd3ZXlaE0qltTjUUMZco5w/uyjClHlm4yTU08Y648yWeFNtK+4hrW0oOdvUtpxrZ7J7YMlU6Rqvc6/NjHquxPTn/PaiS5mmmk/NHavD6+hxFwXKyu8ynTg7epnusbP7jkOs6dc6ZqdzY3C/mUajjld12fzRvLDiv+A6dKx0Oi4zqpOvcVN5OfT3V0SPNynijkrtsYk7Qx6Is86tYmJ8FjWuEtT0qrXdyqUKFJvkq1KiXtF25fN+hHmovdpvHkZGo3l3e3Htry4ncVZdZzln5Isbp4Wem/oeo105rTGpvU0R21UTPlyPdbT3+Z6sprO2XjZlKjmO8t33yez3jzZW3ZnrRnJKOy5d36dD1bdXzZfTIhLD3j0XVlCwnlLoPIey7S36+Z7Hm584WEspIuW1vVuKsaNvSnWqywoxgstv0R0fg3w6qynTvNfjGMY4cbaL3f+Z/oeaq4iOaDnbSx8Kjiuzz8O+VzwY0WrD22t1oOEJx9nQTzus7v4bHTCmlCFKnGnThGEIrEYpYSXkVESqeKdXMNoZtWbkVXquWv0AWb27t7Og61xUUIr738CI6zr9e8zSoZo0Hs8P3pfErNobVx8Gn+pOtXdEdWC1ZquTybfXOIaVpmjaYq1u8vsx/ch91cVrms6lapKc5dWyh7LyD37ZOebS2rfzqv6k6U90dyztWabcclDW2X0XmUyeUsrJV3w+nqe0qNavONOlTlObeFFLJXUxNU6R1Z+nValv0W6JFw/wAMyuVG4vk4UdmqfeXx9DZ8P8OU7XlubxKdbqodYx/ckRuuyN3OHS7lR7Kfz+Fffy/8aPippwhTpxp04qEIrCSWEkVAG4xGivAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEY4q4SttUUrm05aF31z9mfxOa6lZXOn15W93SnSnF9GuvqvM7iYOs6TY6tbOjeUVL+mS+tH4M13au79rL1uWvRr+U/wA8U/Gzqrfo1c4cSUtsY3X3solnPTrt1JHxNwtf6ROVWGa9pnKqRW6+KI39pYfNl9maFkY13Gudndp0ld27lNyOKkjiOdsG10DiXU9FqJUantaGcypSeU/h5Gqlum/Utx2z7u79TzYv3LFcV250l6qoprjSqHaOHOJtN1qklSqKlcY96jN7r4eZuz57hUqQq+1pzcJLo4vDTJtw1x9cWvJb6unXo9FWX118u5uuzd5qLmlvJ5T493v8FRkbOmnnb5+TpxGOKOCdH1znrOn9Gu2se2prr8V3N7puoWeo28biyrwrU2uz3XxXYyja6K4qiKqZ5INm/exrnFbmaZhwLiXhLWNBqP21u61t1jcU94/PuvmaDDbUt1hfcfTdSEKkHCcVKL2aaymQjibw40vUPaXGmP6Dcy3aW9OXy7fIk03v9Tctnb1U1aUZUaT4x94/Djko4akm085R7JNNY7vv1NtxBw5q2h1FG+tZ8i6VIe9F/M1HKpOW7e+2epmirWNW22r1u9TFdFWsEvrpRwn1xjYNyWG02sbjmzJ5658j2OcvZZzj5DVk6HMlPlbeNmsdmX5ajqKoO2d5c+x/pdSWP/gx+aXdqSTytj33l/cnvjyDzNFNXWNRLl3Ty8bb9zc8N8O6nrV1R+j28vo8qiUqzxyxXfbJpFmMXJpZMmzvLy0nGpa3FWhNd6c2sHyYmY5MeRTdqomLUxE+brvipdx0vg2NhQag67jRil/Suv4HG5cri85S/BEiqcVV9StIWev0VqFKnLMJ55KlN9G011+DPdL0Th/VL2MKGvO0i+tK6pe964knymOmOCOam2ZZ/wCF480X4nXWZmYjWJ+HP4w1GmafGtp97fVpSp29tBbpZ5pvaMT3QbJ6nrNpp8VzRr1Yxazvjv8AgSrxHpWWj2Fhw/pss0VF16s08uo3sm/xKvBfTFca7V1CdP3baniLf9UtvyPs1TwzUy17Rn9Dcy+kTrw/SPjPNI/F6+jY8MW2lW75XcTUMeVOKy/ySORzjFRi++NsdcEw8WtS+mcUTtqcm6dpBU2v7nuyKadRnc31C2ilzVJqCfzFuNKdTYVj9Ng01T1n0p9/7Njr2Kdlplko49lbe0lnqpTfM0/uR0DwWv3X0e706ct6FXnjH0l1/E5rxDWVzrNxUivdVRxi15Lb9CTeEF79F4q+juUcXFJwefNbo+V060MW1sabuzKvGPS9/Wfu0nGdi9P4nvbSNPEXWcqeOnK90UcS8sdQjaRlyq2pRpyXbKW+PmTbxJ02n/tnpN04tQr59rJf+Hu8/I5zd3E7u6q3Eks1JOTXxZ9pni0SNmZH6q1ar8Keft6faVqPNJpJe8/dxjqyZ8MVlYcX6Pp9GUVGlLFd9pVJLfHwWF8jR8N29WdW41B2861Ozh7RxjHPv9Ir838i1pdavQ4gs7mtGpGUriEszTW7ks7s+1RqzZlMX6a7fhE/GY+0fVN/HG2irjT7t+Uo/qc2nlZ96Oeh13xqoqfDtvcYy6dVfc0chaaxJNOPfY+Wp9FE3buceBR5ax83WvBKONEvquGuastvhE5txHVdxrl9NveVxOSwvU6l4Qrk4NnUbzzVp7nKby3uqmoVuS3uHJ1pJctNvLbZ8p9eZRNmTE7Sya57tI/nwdH8DVU+g6nn6ntY4XrhkL4huP4Tx/e3li+R0Lznil0zs5L4N5J1wxUocEcFyr6rOMb25k6ioJ+9nGIr7ksnKr6vO6vK11X96rVqSqTa828nyjnVMvuzbX6jPyL/APhPo+U/zT5uy+INlQ4i4LjqFqvaOnBXFJrq4tbr7vyOLZXb7snXPB/VI3uh19IrNOVvlxT/AKJf65Oe61obs+Lq2lcvLT9o3B5+x1z9wtzw6xLzsS5+kuXsO5Pqc49n80Uahc1LPh610uLw7mX0ur8Pqwj+Df3Gokui9PkZWqXUbm9q1o5UHtBNdIrZfgYkXFv3l07mSnlDYsejgo105zzn2z/NHvu4ScU/kdo4ycb3wtnWjlr6NSqpr+1xf6HF3neOMvOzO0afBXnhEqSTn/8ATpwxFZbcYtY/A8Xe6VBvD6FWPd8K/wCfRxeLaXvbrrhHb6lSFbwvdSr70XYb82/Y5FpOgapqU4QtLSq4tpObi1GPq2+hMOOuJbK14docMaVce3cIRhXrRfupL7KffLPlccUxEPW2Lf6y/ZtWucxVrOndHmifB9ONbinTITS5ZV4p4+8nXjllW2nLblc5L8CBcK11bcSafXnhRhXi2n8TpHjVbOtoNtcY2pVkn6KS/wBD7VOlcPO0KuDa2PM9NJ+/7OSPZt5W/V9i5Z3FS1vKFypvmpzUovywyhJr7Xcp6e7hZwZdO5skxFUTEu2eINCOr8BO6hBznGELiGPPH7NnFFOVOpFwlKM4vKknhxfodt0KrKt4XwnV96X0KSfyTOI5llJZT67oxWu+Gtbta0UXrE9Kap/nydm4J1u24v4eqadqcYyuIw5Ksf612kvX9TnfHWlVdDvbXSZy9tTpwc6dR7ZTlkxODb+pp3E2n3Km4QdZQmuzi3h5+8nnjZZRqWNlqUVl05unLD7PdHyI4a9O5hos/wDDtqU26Z/p3NZiPCecfz2uXbyll8qx5m9tL+6seGaM7WnRUndVEqk6SlKGy+q30NA05R93d46G8dOc+CKddU5Yp38oNvok6af5mSuOjYcumieCKuca/aWtvNQvb2rGpeXNStJPMXJ9Gu51/gPWqHE3D09P1KMalzTh7OtF/bj2l/77nFnGOHndPqiTeHt3DT9aWo172FvQoxxWT6zT6JJdTzcp1p5IG2tn27+LPDGlVPONPpy8WLxnodbQdZqW0k3Rl79Gf9UfL4roTbwUvajsr+0qpqhTcakZPos5yvwMHjLjjRdVoStY6NK6Syqdas+XD81jf8iEfxPUFYRs43Uqdsm80oPCb9cdT5pNVOko/wCnydo4EWb9PDVy5z5d+nj7dEn4u0vhqjrVxc09aVSnKbk7W2hzTUvLm+qjW0OKbjT7SdtodCnp9OT9+pnnqT9XJ/oR5SbeEs77hqKz27ZPUUd0rO1s+mLcUXqpr08enw/Oqu5rXF1cTuLirKpVk8ynJ5b+ZbSafN/8M9k8veWM7pFKS2S377HuE+I0jSHsmn9bHktjzOZZ91dnnqG5OTbx12WCqDTjyy379D6+9HkouWFtsuh7U5GliXcpksxUtks7Ek4d4N1vXFzUqKtrd/8AGrJpY9F1Z5mYjqw38m1j08d2qIhHY5lJtRcsvZeZLuFOAdV1flr3MfoNo3zc1SPvy/yx/VnRuF+CNH0SEKjpq7uoretVXf0XREnW3QwVXfBpu0d6pnWjEjTzn7Q0/D3DelaHSSs7eLq496tNZm/mbgGJqGo2tlF+1nmfaEd2yNdvUWqZruTpHm1Guu5fr4qpmZllvZZZpdX16ha5pW3LWq93n3Y/uaXVdYu7xuCfsqXaEX1+LNXt12waZtPejXW3if8A+0/aEm1id9au+ua91X9rcTc5PpnovgY8ipt7JspfTHQ0+u5VXVNVU6zKdEREclO3zKfXoVYb7ZeTf6Lw5Ur4rXqdOk+kPtS/Yk4eDezK+C1Tr590Pldym3GtTU6Vpl1qNVRoxxH7dR9ETbR9JttNoqNOPNUa96o1uzNt6NKhSVKjTjCC6JIrOh7L2JZwY4p9Kvx/CsvZFVzl3AALpHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB5OMZxcZRUovZprqQnirgejcud3pOKNXGXR6Rl8PIm4ImXhWcyjgu06/WGW1ertVa0y4NfWteyrzoXVGVKcc5jNY+aMZN75eV2O5a3o9hrFs6N5RUn9ma2lF+jOZ8TcG6jpblXtk7q1W7lGOZRXqjRNp7v38XWu36VPzj2wusfOou8quUovLD3zjtktbprdvHYuSz06FEMpY3eV3KCOSwZGnale6bXVezuatKaefdez+K6M6Hw14h29xy2+r0/YVOirR+rL4rscwWX23x3PHsnF7ossHamRhT/Tnl4T0YL+NbvetHN9E21ejc0Y1qFWFWnJZUovKZcOCaJr2qaLVUrGu4J7ypveEvijovD3iFp15y0dSirSr/XnMG/0N0wN4cbJ0puejV59Pipr+z7lvnTzhM61KlWpunWpxqQezjJZTITxD4b6VeylX0uTsKzy+RLNOT+Hb5E2o1aVelGrRqRqU5LMZReU0VmwU1ac4YsbMv4lXFaqmJ/nc+fuIOFtY0Wp/vdtOVLP+NBc0X8+3zNIvOT2fTHY+m5RjKLjKKkn1TREuIuANF1RSqW8HYXD+1SS5W/WPQzU3vFt2DvXTOlOTTp5x+HEsYeH7ufLq0Ut9W4p4zvkluvcBa/puZ0qKvaajvUo7tfLqRacHTcqc4tTi+WSa3XxM0TE9G1Y2XYyaeK1VE+xRj3s7fB9CqO6y106lMtord56LPURy58rykvI+9ySq6bd/yKcvOZJSz39T15T50lju2F7zTzy7bYQfFz28/aQqSftHHDSnuvhgm3DniFV0xfR6uk2iouWZSoL2b+OOjZBm8PmUk0+i7nm7Si3nD79keZoieqJlYNjLo4btOsNzxdcWOoarPULC5qSVy3OdOpH3qb8vU2XBXDupV6s9TdpKNvRozqUpPrKSi+XC77/kRSUm1l5z2wX7G9v9PqOdndVrept71ObWfifJpnh0h4u4tyMbsbNWndz58vdoszf8x86anl82fPuZWj3y07WLW/6yoVYz22WE9/wLeoXte/uZXV1JVKrwpzcUstfAs8rfTo31PWndKVNPHb4a46xpLtXifWt6HClW9lCM6sl7Oi3259m/uOK9cS28sIlnFPEdHVeEtGsKdZyr0Fi4T80sJs88O+F7nV7+nfVYRjZW8stNrM5LdRXzwY6PQp1lQbLojZeDVXfnTnP4iPf92s1GtcaRRt9Ns69WjUivb15U5YbnJLCfwSXzyW6fEWrxcJVLtXHI8xVaKms/NZMXXIXVPV7r6ZCcLiVSTkprD6mHBPne/X0PfDEwuLWPartxNURMzz19rtfiHH6b4eTrtJy9lTq7dFusnFM4k4uKx6dDtumR/ivhZTp1cydTT5Qb82otfocTXKltt5niz0mFLu1PBResz/jVP8+TsnADdt4au4j7r9nVqJrzWd/wOc6LxPrVnqFKvUv61SnzJ1KdSXMnFvfqdK02MLTwmw37qsJvPxT/AHOLPPIvXzPlERVqw7HsW8m5kzXETrVMfVP/ABN4Xp2tGlrljVrTo1ZZrQqTc+Vy6NN9iAZ934569TtHE9P+IeFqlGX/ANrTqZXphnGOWWXl+6+59tTy0Tt3smu7jTRcnWaJmPc3nAmrrReJbe7lL+TOXsq2N/dltn5PBPPFmyp2to9apPFzWgrR56cjy2/jtjPqcrsN7yjFQSftI/dk674zLPCtD/8AyYZ/6ZHyuPThF2pRFG08euOtXKfOI0cecYPMV1ePkE0moYz6lK92W8Fs98lc028rGHtlGbm2dTDCWejO0eG9Wpc+Hrpwk4VIKrCLXZ74/M4w2kspdH8zr/gzVU+GLijy45K8uvqkYr3Rrm9FOuHFXhVDmllrmrWGpQuVf3M5Up5mpVHyzS6prphnQeOOHtN1XhaHEGm20aFeNJVZKnFJTi+qa80cz1Wn7PVLuk2ko1pLf4s694X146lwS7OpP2jpOdGXon0/BnmvlpVDHtr/AJai1mWeUxMa6d8T4uNU5OM+eO0oPKk35HbrlU+LPD1yppSq1rfKXlUj/qjjGrW0rLU7q2nhSpVZQe2zaeCU+GvFcdCuZWN/N/Qa0sub6U5efwPVynWNYSNtYteTZoyLHOqidY84QyUXHMZR5XHZp7NBZe+ceXmie+IvCtSF1U13SI/SLS4ftKns/e5W+rXoQ7RdKutWvqdtaQlNN4nUXSmv6m+2Nz3TXExqs8bPs5FjtonSO/y8Yl1WwuY2HhFCtU2zauKTfVyyv1OQNyjHCaksdfQmPiJrtCvaWvD2nVG7OzS56iX+JJLG3otyHJYispN4237Hm3GnOUHYuNVbt13a40muqZ08u4xypyct0tt8YO2X1rV4k8O6UZxjC5r2sKsYzfKlUSyk38Ti1Go6F1TrqMJTptSjGSzFteafUydQ1TVNSftL28rV0vsym+WPwj0/AVUTVPJ62ns+5mV26qKop4J11/b91q/tK1hcO3uPZ+1xlqnNSSXxRJ9L4n0rTOFI6PDSFfSqSdSu7h+45ei67bEQSxLmaTS6FK5Yy3T88Z6HqadYjVOvYlORRTTenXTny5c16+rKtdTrRtqVvGbzyUY8sF8EWptbY29T2S7vL/Q892KcsJ9N/I9R4JNNMUxEQSXu4y5Ltt2PEk5LH3dypt7xTTGXCKXzTXUPWr2KjlYXLjqebS5uuOz9DxppPu28Pcbyj1y1tgPhJPbLw8bB5jHmky5bUatzWhb0KU6tWT2p04OTf3Ez0Dw31i/aq6lKNjS8n702vh2PM1RHVFys7HxI1vVRH1+CFNufKksPsiS6BwRrmrSpzhQ+jWzW9Wtt9y6s6pw7wdoeiqM6NrGvcJf49Zc0vl5fIkK26GKq9r0alnb1zPo4tOnnP4RThrgTRtIjGpWh9OuV/wASqtl8I9ESqKUUlFJJdEj0tXNxRtqbqV6kYRXdsj11xEcVU8mp38i9k18V2qZldLN1c0LWnz16kYLtnqzSX+vzeYWcMf3zX6GirValapKpWqSqSfeTyaztDeaxY9Gx6U+Pd+/85vdvFqq51cm31PX6tVOnZp0Yv7b+s/h5GjnKUm5TblJ9W+p7LLzsUySx+xpWZtDIzK+K7Vr5d0e5Oot00RpCh9dkyl9SuXr5HijKdRQinKb2il1ZCiJmeTIty6564L9hYXF9W5KFNvzk1sjdaVw5UqYqXzdOPVQT3fxJPQo0qFNU6UIwiuiSNp2Zu1dv6V5Ho0+HfP4RbuVFPKnnLWaPodtYr2k8Vqz+01tH4G2AN5x8a1j0RbtRpCvqrmqdZAAZ3kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD3WGABF+JOC9N1RTrW8VaXL+1Be7J+qOZ69oGqaNV5L2h/KfSrBZi/n2O6Fu4o0bijKjXpwqU5LDjJZTKLaGwMfL1qpjhq8Y+8J2PnXLXKecPnlpcrUn88ltvDUlu11bOp8SeH1vcc9xpFRUKr39lP6j+Hkc41bSr7S7n2N9bVKMsbJrKl8H0waTnbLycKf6lPLxjousfKt3vVn3MGe697DfXZlupJvC5cfEuNPDT6IpcUopLdt43K5JbHRuINU0WXPp1zUjBtZpy3g/kdD4e8SbG45aWr0XaT/wC9j70H+qOUNuW2cJdEUrCfup4LTC2vlYfKirWPCecI97EtXvWjn4vpGzu7a8oqtaXFKvTfSVOSaLx88aZqN9plwp2F3UoSe/uPb7ic6D4lV6fLT1i09pHp7SjhS+LXQ2zD3lxr2kXo4Z+SovbNuU86OcOnGp1vhzRtZi1f2VOc2se0SxJfNFzSNd0nVaalZXtKo39lvEl8mbI2K3cprjionWPJCpru2K9aZmmY9zmGueF8szqaReReW2qdZY+SaIJq2g6xo9Vxv9Pr0orf2nLzQ/6lsfRR5UhCpFwnGMovqmspmem7VHVf4e8+XZ5XfTjz6/F8y5Um36dH2CbUW/Xc7vrPBHD+pxlzWat5yeXOh7ryQ3VfCy6pRlPS7+FfC2hW915+K2MkXaZbLi7zYV7lXM0z5/lzmOOVdUeveWHheRs9T4d1zTZNXum14pL6yjzR+9ZNbumljdLGcbmSJ16L23et3Y4rdUTHlKmP4L7RVumpSxzfiU8zeE2njol5iMXLO/Tz/I+z4ssvYN7uTwmzxLM20ts9xj3Vh77o9S95trp1z3ED1uPMmmv3K4VatP8Awas6b6pwnjfz2LeMJZ2ePkNnJPCxnZ5GjzNMT1ZN/fXt97L6Zc1Lh0o4hzyy4/PuWracKVzGpVpwqwi8unNtKX3FtcvM19Y8UdmnFbrYeT52dMU8MRpHwdF0rxIjaW1Kyno1GFtTgo8tKeMLySZEn/BLvXK0vb3NrYTblBuKnOLfbC7GoSa2T6eYjvs/cx5dzxFEdYQbOzLGPNVVnWmauvP589ebrNbinhG44YloML+rRpuh7CM5282ltjL2OWX9GjQu50aNzTuow6VaaaUvvLPMoqO6ll7ia5e2N+p9poimeT5gbNowpq7OqZirnz06/DV2fhS4t9c8PVplGvTVxG2dCUHLeLSwn8Hsco1vSa2lV42tevSdfHvwpz5vZrtlrbJgUq1Wm+ejVnTa2zFtPB5vz5lLLk8vfLZ8po4Z5MeDs2rDu11U1+jVOumnf7f2bThrSbrVtSpqio+zp1YOpOpNRUY5Wevpk6r4lW0NZ4cVGxuKFWvRqKooKrHLSTTxv6nFXKXeW+ei7FUXKMsp7pdUxVRNU66vObs25k5FF+K9ODpGn15jUoy96LjKLalzdcnieXjD5l6BxTjtJvDz8WVY3wnh9me1t3KYvd5aTfn+p1Dw/wBQ0fhfS6tPVdZslWuJqap0qnO0sd8HL8L2bbk8pdGhlPEm8rGM4weaqeKNJQdoYMZ1vsqqtKe/RIeMqek3eo3N7purRrqrP2nsXSlBx892sMyPDzin/Z29qU7iE52dbHPGPWLX2iLZjjlUcpvqet5k32xv6Dh5aS9VYNFeN+muTNVPn1+SXcb6tw3eXVe80u0rTurrCqVaixBbYyk++EiHy2wsIq32Sy9u/Y8k2pbpYz1FMacmTExqca3FumZnTxnWWx0zXNU0rmjZahXop9UpZj9z2Kr/AIg1e9pOFzfVZwk94xajn7uprE0ujymt8hqOFyrqj7wx4Pf6azNXHNEa+Ojx+9s1h79e57FL4Y2Z7mON3zZffseJJPZPK7+h9ZtRY9oksJroePPMm+bpkbKWduZefc9l9Xqk0+/Q+D17yTysd9zySaSa8yn3dpNJfqVYWG8tp5PvR96PFyyg8uUt8ejPGpZTbwVxhKcsQhJ5xjC6m90fhHiHU2nS06pCMutSt7kfx3/A+TVEdWG9k2rFPFcqiI85aBJ8v2Ws9ejEU2+XG+Dp+jeFkUlLVr5PfLp0Ft/1P9iZ6RwtoelqLtrCk6iWPaVFzSfzZjm7EdFBlb0Ylrlb1rn4Q41ofCfEOqtO206cKW382suSPyzu18Cc6D4X2tHkqatdyryx71KkuWOfj1OjJJLCWEDHVdqlrWXvLmX+VE8EeXX4sLStJ07S6XsrCzpUI93GO7+L6szQYV3qdpbppz9pNfZhuyLeyLdmnju1REeahma7tWs85ZpYu7u3tYc1erGPkurfwRorvV7qttSaox9N395rJ80m5Sk5SfVvds1jN3qs0a048cU+M8o/P0Z6MWZ9Zt7vXqk042tLkX9U+v3GmrTqVZupVnKpN95PIexQzUMvaeTmz/Vq1jw7vgmUW6aOkPPyKGVvyKWQHtQ+hTnZ9jNs9Pur2SVGniPectookWm6HbW2J1f51Trl9F8EXOz9h5OZOsRpT4z9vFjuX6KPaj+m6Pd3uJqLo0s/Xmuq9ESjTdMtbFZpQzUxvN9TNWywgb1s7YuNgxrTGtXjP28EC5fquewABbsIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYvrO1vqEqF3Qp1qclhqSyXwfKqYqjSX2JmJ1hzriPw4hLmr6JX5H19hVfuv4M57qml3+m1XRv7arQkntzL3X8H0Z9Dlm8tLa8oujd0KdanJYcZxyjXc7dvHv+la9Cfl8FhY2lct8q+cPnDEcrOcZKVLLax3ymdX4i8NrW4c62kV/o03v7Ge8Pk+qOe6zw/q2jVXG9tJqnn/ESzD7zUczZOViazXTrHjHOP57VxZy7V6OU8/Brt29ksehVFJ7vd4KeXZ5ST8vIrjFpqPTvnzKxIXIVKlKcXSnKm0spp4ZKNC411rTnGFWt9LpLrGtu8ejIqorZPqV03hYa288kixl3sedbVUwxXLdFyNKo1dc0nj/SLpKN3GpaVO+fej96/YlNpd2t3TVS1r060H3hLJ8+JtrZdH95l2t1cW1SM7WvUoyTynCWDYsXem9Ryv08XnHKfwrrmzKJ50To78DlOk8daxauMLhU7uktnz7S+9Ep03j3SrhJXUKtrPvlc0fvRsONt7Cv/wCXDPny/ZX3MK9R3a+xLJJSWGk0+zNRqnDGhakn9K06i5P7cVyyXzRn2OoWV7BTtLqlWTWfdkm/uMkuKK4qjWmWGi5cs1a0TMT8HPtU8LtNqxk9Nvq1pLlwlOPtI5+9Mi+peHHENo+a3jQvF0zSlyv7mdpBli7VC3x94s+zymrijz/PV856louqWMsXOnXFJLq+R4MBNRaTluvvPpqUYyWJRUl5NGtveH9EvHm50u1qPzdNJnuL3jC5s73d1238J/P5fO8uXlznPmIRaSlnZeR2jUfDbh27nKpSVzayfanUzH7mmaS88K2k3Z6tzNfVVWn+qf6HqLtMrW1vNg3I5zNPtj8auaTwlmK23bKZJ7b4XbYmN94ccQ27U6VOhdeahUx+ZqbrhLiS33qaZcbv7K5sfce4qp8Vla2nh3PVux8Wkx17fqGt1FLPfdmRcWF9Qea1lcUorb3qUl+hj49Meedsn3WEymumrnTOr1Nbe7nHVCW63eW/I8x5JbdPUpWcrOGu6z0Pr1o9/pUn8cfke7tvos9NjxZzs0k+qaPYc/24+73+IFO2cSTeUexfNFrHNgqwov3W8LzW55JOMouO+w1fddXjluljt1aGcJ9c/E9SaTafvdmePLecZTAQabw3y43800evEW4uSwu5S44812eHuVR5c8uF65AJNyfeKXbzDy8JR3fUJd0seQTb3WXvhoPjyL7vL5fvGMpZf2vvKuSX2Pe9EssyrXSNUuop0dNuprPVUpbfgNYearlFHOqYhiOWe+N9zx5a/u6fAkFrwdxLcLnp6VWhHp/MxH5m4tPDTXa0IutUt6C8nPL/AAR546UK5tXDtetcj4oN9nLxnywevOG3h53TOnWnhSnh3msS65apUUvxbZv9O8OuG7SSlUpV7qSX/GqbfcsI8zepjorr28+Db9WZq9kfnRxWKcpqLe/bG5s9O4f1rUJcltplxLb60o4T+bO72Oi6TYrFpp1tR/y00Z6SSwkkY5u+EKi9vdP/AGrfxn8flxvTPDPXbnkd3UtbODa5k5OcsfBbZ+ZLNL8NNEt/evKte8lnO75Y/cicA8TcqlTZG8Gff5cekeXL92v07RNJ0+KjZ6fb0sd1BZNgCzWu7eltOrFPphbsw3LtFuOKudI81RVXXcnWqZmV4Grr6ukmqNFyfnJ4RgXF7dVtp1XFf00/d/1KTK3kwrHKmriny/PR7psVy3te5oUP8SrFPyzv9xra+trpb0W/7p7fgat4Tz3ZQ+uDWsverJucrMRTHxn+e5IpxqY6rtzdXNd5q1ptf0p4Rjy27FUtyls129kXL1XFcqmZ80iIiOUKX0KHjp3KmUyaSz2MT0pfQoeye+DOs9Ou7p5jTcIf1T2X+purHRLag+es3Xn6rEV8i5wdhZeXpMU8NPjLFXfooR60srm7a9hSbWccz2S+ZvtP0KhRxO5ftqi7dIr9zbRiorEUkl2R6blgbu4uL6VXpVefT3Qh3MiqrpyeRjGMVGKSS6JHoBf9GAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACmpThUg4VIRnF9VJZTKgBEtf4B0bUnKrbxlZV3vmn9Vv1iQbWuBdc0/NSjTV5Sj0dLrj4HZgU+XsLEyefDwz4xy/ZMtZ163y11jzfOk4TpVHGspRqReHGSxj4o9isRb+znc7zq2h6VqkWr2ypVJP7eMSXzW5D9Y8Oaclz6VdcjXSFbdfeavl7s5Nrnanij4SsrW0rdfKrk5wu0c4TRVHbHn5m21ThvW9LbdzY1HD/ALyn78Pw/U1Ue6x3+Zr92xds1cNymYnzTqblNca0zquYb88dCrGYYk1nPQpW77t52K456cqz5mEldoTqUp80Jyg/OLwzeadxXrlm4xhdutBbctVcy+/qaFpppY+JXHss4fl5mezk3rE62qpj2Sx10UVx6Uap3p/H9X3Y3thFrvOnL9DeWXGWiXCXtK87eT7VINfitjle/wBXp36laScslzY3lzbXrTFUecfhDrwbNXTk7Va31ldJO2u6FbKz7k0zIOIUZSpz5qblB+aeDZ2et6vbOMaWo1+Tyk+ZfiW9ne23PK7bmPZzRq9nTHq1OuA53bcZarBr2kaNWPrHDNjQ45i5Yr2EkvOE8lna3iwLnWvT2xKNOHdjuTMEdt+MdIqNKft6T/up5S+aybC313SK7xTv6OfKT5fzLC1tDFu+pciffDFVZuU9aZbGUITWJRjJeqyY9bT7CtFxq2VtOL7SpRf6FyF1bT+pcUpfCaZdTT6NEuKonpLxFVVPTk0lbhLhus8z0Wzz6U8fkYtxwLwvWab01Qx/RUkv1JKD1xSkU5uTT6tyr4yhtbw24ZqNv2d3Bt9q7/UtT8MtAksKvfL/APaL9ibg+8dXiz07Xzqel2fi5/Lwr0d55dRv4xf2cxa/It//AMKdNUsrVLz5qP7HRAfe0q8WSNt58f8Adlz2HhZpi66pe48ko/sXI+Fmirrf37+EorH4E+B846vF8/43n/8AllCY+GfD6WJVb2S//Il+hdpeG3DEJ87pXU35SrvBMQOOrxeJ2tmz1u1fFHKPA/C1KPL/AAqnP1nOUv1Mu04X4etHm30ezg/P2af5m4B81lHrzciv1rkz75WYWlpBJQtqMcdMU0i8klskkG0urSLU7i3gnzV6ax5yR4qrpp6ywTNVS6DClqtgs4uFPH9EXL8kWZ61bptQp1Z/LH5kO7tPDtevdj4vsW657mzBppaxVafJRjF+ryWZ6heT/wCKoLP2Yldd3lwLfSqZ9kfnR7jHrlvyzWu7ak8VK9OL8ubf7jRyqVKkszqzl6N7fceRSXRY+BVX976Y/s2/jP4/L3GP4y209Sop4hGc9uuMIxauo3Mv8ONOC83uzGPGU1/eXOu8oq4Y8oZIs0wVqtartVqzmvLovuLWEtopJeiKmePPyKa7fu3p4rlUz7ebLERHRQ85ZT3wVPvgpecmF7UsoZXu+ibL9DTruuk40+SONnPb8OpIsYl/JnhtUzUTVFPWWI+nQ8UZVJcsISnLyiss3lDRaSw69SU3/THZGxoUKNCHLRpxgvRGy4m6l+5pN+rhjwjnP4YKsmI6NDa6Nc1WpVWqUcd92bWz0u0tmpKDqT/qnu/2M0G1YexcPE50U6z4zzlGrvV19ZAAWrEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA91hmn1XhrRdSzK4saaqP7cFyy/A3AMdy1RdjhriJjzeqa6qZ1pnRANT8OoNc2m3zg10hWWV96I1qPC2u6fl1LOVSEft0Xzr9/wOyApMndzDvc6Y4Z8vwmW9oXaevNwaUJ0ZctROEk91JbnsVv069/JHbrzT7G8i43NrRq5/qismiv+CNHuE3Q9rayxhezllL5MosjdS/TztVxPt5JdG0qJ9aNHMHlr4dypNZ2zlsl95wBfU97W8o115TjyP9TTXnD2s2icqthVcY/agub8ilv7JzLHr25+v0SaMi1X0qa1LdpNfeVxi8tbNJnjhKlJwqU5U5Z+0sFUM53bwV8xMTpLJqq36t9Xgr7rBSkk0VJN9PwPL4rT67/Eqj0/DJTHdvoVrbp/8jq+K47NvOPJmTSubmnlQua0V2xNmNHLS2K47dOzPVNyqmfRnR4mNWfS1XU6b2vq/wA5ZMn+O6tHCV7L5pGqisL0K0vUk07Qyqelyr4yxzbonuhuaXEeqxSzXjP4wRehxNqXf2T+MTR9dsYKl9ZmWnbGdH/dn4vM2Lc9zeriXUm00qGPLk/1KlxLqPlQz/lf7miT+JcXY9/8az//ACy8dhb8G6/2j1HHSgv+V/uVR4h1B9fZfKJpkVxWevbufJ21n/8All87G34Nv/Hr9v68F/yFuer6lPpc8nwijXLqsdiuOx4na+dV1uz8TsqPBnPUr+XW6qfLCLcri5k8yuaz/wCdliPQriYK87Jr63Kp98nBTHcuOc5Y5pyl8ZNlUEl0SRRHqVx6Eaa6qus6itIrSKFjBVE8itfiVx7FCK4nx5lWiuJQtvgVKWVsm/8AKsnqmmap0pjV5lWePoX6drcVOlKUfWWxepaZVkk6taMfSCz+L/Ys8fYmdf04bcx7eX1Y5uUx3te/uKV7zxFOT8kss3dLTraGcxlUy8++8mTCEILEIqK9EXmPuldnneriPZzY5yIjpDRU7C7q9IRgvOb/AEM2jpFNb1qkpvyWyNkC+xd3cGxzmninz/HRiqv1ytULahQ/wqUYvzxuXQC7oopojhpjSGKZmeoAD0+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtV7a3rrFahTqf5opmtueGdEr82bGEJS6um3F/gbcGG5j2rvr0xPth6prqp6SidxwNYSji3u7mk/wC7El+Rr7jgm8hvQuqVT0acSeArbuwMC5/29PZrDPTl3o73Nq/CusUVtQjUX9kkzFq6RqdBfzLGv8o5Opgr7m6mLV6tUx8GWM+53w5K6FeGfaUasV03i0eRwn5nWpRjJYlFNeqLMrO0l9a1ov400Q690f8ATd+Mfu9xn+NLly9c+RXDtk6NW0XSqrfPY0Xnyjgsy4e0h/8A2iXwnL9yLXulk/410z8fw9xnUeEoElh7P7ypfeTafDOlS+xVj8KjPFwxpi6e3X/7Qwzurmx30/H9j9ZbQ1YT7FcV3yTFcNaav++/6/8AQ9/2b07GP53/AF/6Hid187y+J+rtogvuZXHpvjBLVw7p6/75/wDP/oP9ntP/APFX/N/oP/y+dPh8Xz9VbRWPn0Ko798Eo/2d0/v7d/8A7QrjoOnrrGq/jUZ7jdXNnvp+M/h5nKoReJXHrglX8G03GHbJr1k3+pdpafY0vqWtJf8ALkzUbo5E+tciPj+zzOXT3QicZRzjKz5F2MKj2VOo2/KDZLo0aMXlUqa+EUV4XkSre58f53fhH7vE5fhCK07S6nnltqvzWDJpaZeSWXTjD/NIkIJlvdPDp9aZn3sc5NTTU9HquK568YvviOTIp6TQWOerVnj1ST+42ILG1sLAtdLcT7ef1eJvVz3rFOztoS5o0Y5xjL3L0YxisRikvRHoLO3Zt240opiPZDHMzPUABkfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/9k=";
const fmt = (n) => {
  const v = Math.round(n || 0);
  return v.toLocaleString("en-US") + " XAF";
};
// Format payment terms — bold+color phone numbers and account names
const fmtPaymentTerms = (terms) => {
  if (!terms) return "";
  return terms.split("\n").map(line => {
    if (/\d{3}/.test(line)) {
      // Underline just the number sequences within the line
      const formatted = line.replace(/[\d\s]{6,}/g, num =>
        `<span style="text-decoration:underline;font-weight:700">${num}</span>`
      );
      return `<div style="font-size:12px;font-weight:600;color:#b45309;margin:2px 0">${formatted}</div>`;
    }
    return `<div style="font-size:11px;color:#222;margin:2px 0">${line}</div>`;
  }).join("");
};


const fmtShort = (n) => {
  const v = Math.round(n || 0);
  if (v >= 1000000)
    return (v / 1000000).toFixed(1).replace(/\.0$/, "") + "M XAF";
  if (v >= 1000)
    return (
      (v / 1000).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "k XAF"
    );
  return v.toLocaleString("en-US") + " XAF";
};

const APP_TODAY = (() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; })();

// Return ISO date string in LOCAL timezone (not UTC) — critical for Cameroon UTC+1
const toLocalISO = (d) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// Compare dates as strings to avoid UTC/local timezone mismatches
const inRange = (dateStr, from, to) => {
  if (!dateStr) return false;
  const s = dateStr.slice(0, 10); // "YYYY-MM-DD"
  const f = toLocalISO(from);
  const t = toLocalISO(to);
  return s >= f && s <= t;
};
function getPeriodRange(period, customFrom, customTo) {
  // Compute today fresh on every call — APP_TODAY is set once at load time and goes stale
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = today;
  const y = d.getFullYear(),
    m = d.getMonth();
  const dow = d.getDay();
  const mondayOffset = dow === 0 ? -6 : 1 - dow;
  switch (period) {
    case "today":
      return [new Date(d), new Date(d)];
    case "this_week": {
      const mon = new Date(d);
      mon.setDate(d.getDate() + mondayOffset);
      const sun = new Date(mon);
      sun.setDate(mon.getDate() + 6);
      return [mon, sun];
    }
    case "last_week": {
      const mon = new Date(d);
      mon.setDate(d.getDate() + mondayOffset - 7);
      const sun = new Date(mon);
      sun.setDate(mon.getDate() + 6);
      return [mon, sun];
    }
    case "this_month":
      return [new Date(y, m, 1), new Date(y, m + 1, 0)];
    case "last_month":
      return [new Date(y, m - 1, 1), new Date(y, m, 0)];
    case "last_7": {
      const s = new Date(d);
      s.setDate(d.getDate() - 6);
      return [s, new Date(d)];
    }
    case "last_30": {
      const s = new Date(d);
      s.setDate(d.getDate() - 29);
      return [s, new Date(d)];
    }
    case "last_90": {
      const s = new Date(d);
      s.setDate(d.getDate() - 89);
      return [s, new Date(d)];
    }
    case "ytd":
      return [new Date(y, 0, 1), new Date(d)];
    case "custom":
      return [
        customFrom ? new Date(customFrom) : new Date(y, 0, 1),
        customTo ? new Date(customTo) : new Date(d),
      ];
    default:
      return [new Date(y, 0, 1), new Date(d)];
  }
}
const fmtDate = (d) =>
  d.toLocaleDateString("fr-CM", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
const PERIOD_LABELS = {
  today: "Today",
  this_week: "This Week",
  last_week: "Last Week",
  this_month: "This Month",
  last_month: "Last Month",
  last_7: "Last 7 Days",
  last_30: "Last 30 Days",
  last_90: "Last 90 Days",
  ytd: "Year to Date",
  custom: "Custom Range",
};

// ─── INITIAL DATA ─────────────────────────────────────────────────
const INIT_BIZ = {
  name: "Cookies Bites",
  tagline: "Catering & Restaurant Services",
  address: "Rue Njo Njo, Akwa",
  city: "Douala, Cameroun",
  phone: "+237 6XX XXX XXX",
  phone2: "",
  email: "cookiesbites@email.cm",
  website: "",
  rccm: "",
  taxId: "",
  paymentTerms:
    "Payment accepted by Cash, Mobile Money (MoMo), Orange Money, and Bank Transfer.",
  bankName: "",
  bankAccount: "",
  footer:
    "Thank you for choosing Cookies Bites — we look forward to serving you!",
  staffTabs: ["restaurant", "customers"],
};

const CAT_CATS = [];

const CAT_ITEMS = [];

// ─── MEALS (Restaurant menu items with inventory linking) ─────────
const INIT_MEALS = [];

const INIT_INVENTORY = [];

const INIT_EVENTS = [
  {
    "id": 6101,
    "name": "Wedding – Kana Family",
    "clientName": "Hortense Kana",
    "clientPhone": "+237 691 554 772",
    "eventDate": "2026-02-22",
    "location": "Salle des Fêtes Akwa, Douala",
    "eventType": "Wedding",
    "serviceStyle": "Buffet",
    "guests": 120,
    "pricePerHead": 9000,
    "addOns": 50000,
    "discount": 50000,
    "phase": "Event Completed",
    "notes": "Buffet wedding. Ndolé, Eru, Soya. Ran smoothly. Client very satisfied.",
    "revenue": 1080000,
    "media": [],
    "costLines": [],
    "costs": {
      "inventory": 180000,
      "labor": 80000,
      "transport": 30000,
      "overhead": 20000
    }
  },
  {
    "id": 6102,
    "name": "Bridal Shower – Aminatou Bello",
    "clientName": "Aminatou Bello",
    "clientPhone": "+237 655 321 987",
    "eventDate": "2026-02-15",
    "location": "Akwa Palace Hotel, Douala",
    "eventType": "Bridal Shower",
    "serviceStyle": "Cocktail",
    "guests": 40,
    "pricePerHead": 11800,
    "addOns": 0,
    "discount": 0,
    "phase": "Event Completed",
    "notes": "Small chops & dessert-focused event. Elegant setup. Full payment received.",
    "revenue": 472000,
    "media": [],
    "costLines": [],
    "costs": {
      "inventory": 65000,
      "labor": 40000,
      "transport": 15000,
      "overhead": 10000
    }
  },
  {
    "id": 6103,
    "name": "Corporate Lunch – MTN Cameroon",
    "clientName": "Serge Nguimfack",
    "clientPhone": "+237 699 731 560",
    "eventDate": "2026-02-10",
    "location": "MTN HQ, Bonanjo",
    "eventType": "Corporate",
    "serviceStyle": "Plated",
    "guests": 45,
    "pricePerHead": 8000,
    "addOns": 20000,
    "discount": 0,
    "phase": "Event Completed",
    "notes": "Plated corporate lunch. Ndolé & Poulet DG. Team of 45 executives.",
    "revenue": 380000,
    "media": [],
    "costLines": [],
    "costs": {
      "inventory": 95000,
      "labor": 55000,
      "transport": 20000,
      "overhead": 15000
    }
  },
  {
    "id": 6104,
    "name": "Birthday – Jean-Paul Tchamda",
    "clientName": "Jean-Paul Tchamda",
    "clientPhone": "+237 699 456 789",
    "eventDate": "2026-03-08",
    "location": "Résidence Tchamda, Makepe",
    "eventType": "Birthday",
    "serviceStyle": "Buffet",
    "guests": 80,
    "pricePerHead": 7500,
    "addOns": 30000,
    "discount": 20000,
    "phase": "Confirmed",
    "notes": "Deposit paid. Menu confirmed: Kati Kati, Soya, Small Chops, Dessert table.",
    "revenue": 610000,
    "media": [],
    "costLines": [],
    "costs": {
      "inventory": 0,
      "labor": 0,
      "transport": 0,
      "overhead": 0
    }
  },
  {
    "id": 6105,
    "name": "Wedding Enquiry – Fon Family",
    "clientName": "Emmanuel Fon",
    "clientPhone": "+237 670 889 001",
    "eventDate": "2026-04-12",
    "location": "TBD, Douala",
    "eventType": "Wedding",
    "serviceStyle": "Buffet",
    "guests": 200,
    "pricePerHead": 10000,
    "addOns": 0,
    "discount": 0,
    "phase": "Lead / Inquiry",
    "notes": "Initial enquiry. Site visit scheduled for March 5.",
    "revenue": 0,
    "media": [],
    "costLines": [],
    "costs": {
      "inventory": 0,
      "labor": 0,
      "transport": 0,
      "overhead": 0
    }
  }
];

const INIT_SALES = [
  {
    "id": 7001,
    "saleIndex": 1,
    "date": "2026-02-03",
    "meal": "Ndolé",
    "mealId": 1061,
    "plates": 4,
    "pricePerPlate": 3500,
    "method": "Mobile Money",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Marie Ngo Mbock",
    "clientPhone": "+237 677 112 233",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7002,
    "saleIndex": 2,
    "date": "2026-02-03",
    "meal": "Cow Soya",
    "mealId": 1020,
    "plates": 6,
    "pricePerPlate": 2500,
    "method": "Cash",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Emmanuel Fon",
    "clientPhone": "+237 670 889 001",
    "notes": "Extra spicy",
    "partialPaid": ""
  },
  {
    "id": 7003,
    "saleIndex": 3,
    "date": "2026-02-05",
    "meal": "Poulet DG",
    "mealId": 1072,
    "plates": 3,
    "pricePerPlate": 4500,
    "method": "Mobile Money",
    "type": "Takeaway",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Jean-Paul Tchamda",
    "clientPhone": "+237 699 456 789",
    "notes": "Office order",
    "partialPaid": ""
  },
  {
    "id": 7004,
    "saleIndex": 4,
    "date": "2026-02-05",
    "meal": "Eru",
    "mealId": 1062,
    "plates": 5,
    "pricePerPlate": 3500,
    "method": "Cash",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Pauline Essomba",
    "clientPhone": "+237 677 445 882",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7005,
    "saleIndex": 5,
    "date": "2026-02-06",
    "meal": "Mbongo Tchobi",
    "mealId": 1064,
    "plates": 2,
    "pricePerPlate": 4000,
    "method": "Cash",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "",
    "clientPhone": "",
    "notes": "Walk-in",
    "partialPaid": ""
  },
  {
    "id": 7006,
    "saleIndex": 6,
    "date": "2026-02-07",
    "meal": "Achu & Yellow Soup",
    "mealId": 1063,
    "plates": 4,
    "pricePerPlate": 3500,
    "method": "Mobile Money",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Hortense Kana",
    "clientPhone": "+237 691 554 772",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7007,
    "saleIndex": 7,
    "date": "2026-02-08",
    "meal": "Poulet DG",
    "mealId": 1072,
    "plates": 2,
    "pricePerPlate": 4500,
    "method": "Cash",
    "type": "Delivery",
    "deliveryFee": 1000,
    "deliveryAddress": "Akwa, Rue de la Paix",
    "clientName": "Sylvain Mbarga",
    "clientPhone": "+237 676 220 114",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7008,
    "saleIndex": 8,
    "date": "2026-02-10",
    "meal": "Ndolé",
    "mealId": 1061,
    "plates": 8,
    "pricePerPlate": 3500,
    "method": "Bank Transfer",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Serge Nguimfack",
    "clientPhone": "+237 699 731 560",
    "notes": "Team lunch Camtel",
    "partialPaid": ""
  },
  {
    "id": 7009,
    "saleIndex": 9,
    "date": "2026-02-10",
    "meal": "Chicken Soya",
    "mealId": 1021,
    "plates": 5,
    "pricePerPlate": 2500,
    "method": "Cash",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Emmanuel Fon",
    "clientPhone": "+237 670 889 001",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7010,
    "saleIndex": 10,
    "date": "2026-02-12",
    "meal": "Kati Kati",
    "mealId": 1073,
    "plates": 3,
    "pricePerPlate": 4000,
    "method": "Mobile Money",
    "type": "Takeaway",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Marie Ngo Mbock",
    "clientPhone": "+237 677 112 233",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7011,
    "saleIndex": 11,
    "date": "2026-02-13",
    "meal": "Eru",
    "mealId": 1062,
    "plates": 4,
    "pricePerPlate": 3500,
    "method": "Cash",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Pauline Essomba",
    "clientPhone": "+237 677 445 882",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7012,
    "saleIndex": 12,
    "date": "2026-02-14",
    "meal": "Steak",
    "mealId": 1025,
    "plates": 2,
    "pricePerPlate": 8500,
    "method": "Bank Transfer",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Hortense Kana",
    "clientPhone": "+237 691 554 772",
    "notes": "Valentine dinner",
    "partialPaid": ""
  },
  {
    "id": 7013,
    "saleIndex": 13,
    "date": "2026-02-14",
    "meal": "Ndolé",
    "mealId": 1061,
    "plates": 6,
    "pricePerPlate": 3500,
    "method": "Mobile Money",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "",
    "clientPhone": "",
    "notes": "Valentine special",
    "partialPaid": ""
  },
  {
    "id": 7014,
    "saleIndex": 14,
    "date": "2026-02-15",
    "meal": "Poulet DG",
    "mealId": 1072,
    "plates": 4,
    "pricePerPlate": 4500,
    "method": "Cash",
    "type": "Delivery",
    "deliveryFee": 1000,
    "deliveryAddress": "Bonanjo, Douala",
    "clientName": "Sylvain Mbarga",
    "clientPhone": "+237 676 220 114",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7015,
    "saleIndex": 15,
    "date": "2026-02-17",
    "meal": "Pepper Soup",
    "mealId": 1074,
    "plates": 3,
    "pricePerPlate": 3000,
    "method": "Cash",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Didier Mouaha",
    "clientPhone": "+237 655 193 067",
    "notes": "Referred client",
    "partialPaid": ""
  },
  {
    "id": 7016,
    "saleIndex": 16,
    "date": "2026-02-17",
    "meal": "Cow Soya",
    "mealId": 1020,
    "plates": 6,
    "pricePerPlate": 2500,
    "method": "Mobile Money",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Emmanuel Fon",
    "clientPhone": "+237 670 889 001",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7017,
    "saleIndex": 17,
    "date": "2026-02-19",
    "meal": "Kwacoco & Banga",
    "mealId": 1066,
    "plates": 3,
    "pricePerPlate": 3500,
    "method": "Cash",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "",
    "clientPhone": "",
    "notes": "Walk-in",
    "partialPaid": ""
  },
  {
    "id": 7018,
    "saleIndex": 18,
    "date": "2026-02-20",
    "meal": "Ndolé",
    "mealId": 1061,
    "plates": 5,
    "pricePerPlate": 3500,
    "method": "Bank Transfer",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Jean-Paul Tchamda",
    "clientPhone": "+237 699 456 789",
    "notes": "Friday office lunch",
    "partialPaid": ""
  },
  {
    "id": 7019,
    "saleIndex": 19,
    "date": "2026-02-21",
    "meal": "Goat Soya",
    "mealId": 1022,
    "plates": 4,
    "pricePerPlate": 3000,
    "method": "Cash",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Didier Mouaha",
    "clientPhone": "+237 655 193 067",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7020,
    "saleIndex": 20,
    "date": "2026-02-21",
    "meal": "Grilled Chicken / Poulet Braisé",
    "mealId": 1077,
    "plates": 2,
    "pricePerPlate": 5000,
    "method": "Mobile Money",
    "type": "Takeaway",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Christelle Abanda",
    "clientPhone": "+237 652 008 435",
    "notes": "Weekend special",
    "partialPaid": ""
  },
  {
    "id": 7021,
    "saleIndex": 21,
    "date": "2026-02-22",
    "meal": "Eru",
    "mealId": 1062,
    "plates": 5,
    "pricePerPlate": 3500,
    "method": "Cash",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Pauline Essomba",
    "clientPhone": "+237 677 445 882",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7022,
    "saleIndex": 22,
    "date": "2026-02-24",
    "meal": "Kati Kati",
    "mealId": 1073,
    "plates": 3,
    "pricePerPlate": 4000,
    "method": "Mobile Money",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Marie Ngo Mbock",
    "clientPhone": "+237 677 112 233",
    "notes": "",
    "partialPaid": ""
  },
  {
    "id": 7023,
    "saleIndex": 23,
    "date": "2026-02-25",
    "meal": "Poulet DG",
    "mealId": 1072,
    "plates": 6,
    "pricePerPlate": 4500,
    "method": "Bank Transfer",
    "type": "Delivery",
    "deliveryFee": 1500,
    "deliveryAddress": "Bali, Douala",
    "clientName": "Serge Nguimfack",
    "clientPhone": "+237 699 731 560",
    "notes": "Team lunch delivery",
    "partialPaid": ""
  },
  {
    "id": 7024,
    "saleIndex": 24,
    "date": "2026-02-26",
    "meal": "Ekwang",
    "mealId": 1067,
    "plates": 3,
    "pricePerPlate": 3500,
    "method": "Cash",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "",
    "clientPhone": "",
    "notes": "Walk-in",
    "partialPaid": ""
  },
  {
    "id": 7025,
    "saleIndex": 25,
    "date": "2026-02-27",
    "meal": "Ndolé",
    "mealId": 1061,
    "plates": 5,
    "pricePerPlate": 3500,
    "method": "Mobile Money",
    "type": "Takeaway",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Hortense Kana",
    "clientPhone": "+237 691 554 772",
    "notes": "End of month order",
    "partialPaid": ""
  },
  {
    "id": 7026,
    "saleIndex": 26,
    "date": "2026-02-28",
    "meal": "Mbongo Tchobi",
    "mealId": 1064,
    "plates": 4,
    "pricePerPlate": 4000,
    "method": "Cash",
    "type": "Dine-in",
    "deliveryFee": 0,
    "deliveryAddress": "",
    "clientName": "Emmanuel Fon",
    "clientPhone": "+237 670 889 001",
    "notes": "",
    "partialPaid": ""
  }
];

const INIT_INVOICES = [
  {
    "id": 6101,
    "num": "INV-2026-6101",
    "client": "Hortense Kana",
    "clientPhone": "+237 691 554 772",
    "issued": "2026-02-22",
    "due": "2026-02-22",
    "total": 1080000,
    "paid": 1080000,
    "status": "Paid",
    "eventId": 6101,
    "notes": "Full payment received via bank transfer. Wedding complete."
  },
  {
    "id": 6102,
    "num": "INV-2026-6102",
    "client": "Aminatou Bello",
    "clientPhone": "+237 655 321 987",
    "issued": "2026-02-15",
    "due": "2026-02-15",
    "total": 472000,
    "paid": 472000,
    "status": "Paid",
    "eventId": 6102,
    "notes": "Full payment received. Bridal shower completed."
  },
  {
    "id": 6103,
    "num": "INV-2026-6103",
    "client": "Serge Nguimfack",
    "clientPhone": "+237 699 731 560",
    "issued": "2026-02-10",
    "due": "2026-02-17",
    "total": 380000,
    "paid": 200000,
    "status": "Partial",
    "eventId": 6103,
    "notes": "Balance of 80,000 FCFA outstanding. Follow-up sent."
  }
];

const INIT_PROPOSALS = [
  {
    "id": 6001,
    "num": "PROP-2026-0001",
    "status": "Approved",
    "client": "Hortense Kana",
    "clientPhone": "+237 691 554 772",
    "eventType": "Wedding",
    "plannedDate": "2026-02-22",
    "guests": "120",
    "location": "Salle des Fêtes Akwa, Douala",
    "discount": 50000,
    "paymentTerms": "50% deposit on signing, balance 48h before event",
    "notes": "Client prefers Ndolé & Eru as main dishes. Buffet style.",
    "inventoryLinks": [],
    "eventId": 6101,
    "lines": [
      {
        "itemId": 501,
        "name": "Ndolé",
        "qty": 120,
        "price": 3500,
        "unitType": "Per head",
        "photo": null,
        "description": "Bitterleaf stew with groundnut and assorted meat"
      },
      {
        "itemId": 502,
        "name": "Eru",
        "qty": 120,
        "price": 3000,
        "unitType": "Per head",
        "photo": null,
        "description": "Eru leaves with cow skin and fish"
      },
      {
        "itemId": 201,
        "name": "Cow Soya",
        "qty": 120,
        "price": 2500,
        "unitType": "Per head",
        "photo": null,
        "description": "Grilled beef skewers"
      },
      {
        "itemId": 401,
        "name": "Normal & Exotic Fruit Platters",
        "qty": 10,
        "price": 15000,
        "unitType": "Per platter",
        "photo": null,
        "description": "Seasonal fruit arrangement"
      }
    ]
  },
  {
    "id": 6002,
    "num": "PROP-2026-0002",
    "status": "Sent",
    "client": "Serge Nguimfack",
    "clientPhone": "+237 699 731 560",
    "eventType": "Corporate",
    "plannedDate": "2026-03-05",
    "guests": "60",
    "location": "Camtel Conference Centre, Douala",
    "discount": 0,
    "paymentTerms": "100% prepayment by bank transfer",
    "notes": "Corporate lunch. Mix of Cameroonian and continental options.",
    "inventoryLinks": [],
    "eventId": null,
    "lines": [
      {
        "itemId": 512,
        "name": "Poulet DG",
        "qty": 60,
        "price": 4500,
        "unitType": "Per head",
        "photo": null,
        "description": ""
      },
      {
        "itemId": 502,
        "name": "Eru",
        "qty": 60,
        "price": 3000,
        "unitType": "Per head",
        "photo": null,
        "description": ""
      },
      {
        "itemId": 109,
        "name": "Sandwich",
        "qty": 60,
        "price": 2000,
        "unitType": "Per item",
        "photo": null,
        "description": "Assorted finger sandwiches"
      },
      {
        "itemId": 403,
        "name": "Cocktails",
        "qty": 60,
        "price": 1500,
        "unitType": "Per item",
        "photo": null,
        "description": "Fresh mocktails"
      }
    ]
  },
  {
    "id": 6003,
    "num": "PROP-2026-0003",
    "status": "Draft",
    "client": "Christelle Abanda",
    "clientPhone": "+237 652 008 435",
    "eventType": "Birthday",
    "plannedDate": "2026-03-15",
    "guests": "80",
    "location": "Résidence Privée, Bonapriso",
    "discount": 20000,
    "paymentTerms": "50% deposit, 50% on event day",
    "notes": "Sweet 30 celebration. Dessert table required.",
    "inventoryLinks": [],
    "eventId": null,
    "lines": [
      {
        "itemId": 513,
        "name": "Kati Kati",
        "qty": 80,
        "price": 4000,
        "unitType": "Per head",
        "photo": null,
        "description": ""
      },
      {
        "itemId": 101,
        "name": "Hamburger",
        "qty": 80,
        "price": 2000,
        "unitType": "Per item",
        "photo": null,
        "description": ""
      },
      {
        "itemId": 312,
        "name": "Red Velvet",
        "qty": 5,
        "price": 25000,
        "unitType": "Per item",
        "photo": null,
        "description": "Red velvet cake, serves 16 portions"
      },
      {
        "itemId": 406,
        "name": "Fruits & Exotic Parfaits",
        "qty": 80,
        "price": 1500,
        "unitType": "Per item",
        "photo": null,
        "description": ""
      }
    ]
  },
  {
    "id": 6004,
    "num": "PROP-2026-0004",
    "status": "Approved",
    "client": "Aminatou Bello",
    "clientPhone": "+237 655 321 987",
    "eventType": "Bridal Shower",
    "plannedDate": "2026-02-15",
    "guests": "40",
    "location": "Akwa Palace Hotel, Douala",
    "discount": 0,
    "paymentTerms": "50% deposit, balance day before",
    "notes": "Elegant bridal shower. Small chops & dessert focus.",
    "inventoryLinks": [],
    "eventId": 6102,
    "lines": [
      {
        "itemId": 102,
        "name": "Spring Roll",
        "qty": 40,
        "price": 1500,
        "unitType": "Per item",
        "photo": null,
        "description": ""
      },
      {
        "itemId": 104,
        "name": "Meat Pie & Meat Balls",
        "qty": 40,
        "price": 1500,
        "unitType": "Per item",
        "photo": null,
        "description": ""
      },
      {
        "itemId": 115,
        "name": "Sausage Rolls",
        "qty": 40,
        "price": 1200,
        "unitType": "Per item",
        "photo": null,
        "description": ""
      },
      {
        "itemId": 302,
        "name": "Fruit Tart",
        "qty": 40,
        "price": 2000,
        "unitType": "Per item",
        "photo": null,
        "description": ""
      },
      {
        "itemId": 309,
        "name": "Lemon Curd",
        "qty": 40,
        "price": 1500,
        "unitType": "Per item",
        "photo": null,
        "description": ""
      },
      {
        "itemId": 407,
        "name": "Greek & Swiss Yogurts",
        "qty": 40,
        "price": 1500,
        "unitType": "Per item",
        "photo": null,
        "description": ""
      }
    ]
  },
  {
    "id": 6005,
    "num": "PROP-2026-0005",
    "status": "Declined",
    "client": "Didier Mouaha",
    "clientPhone": "+237 655 193 067",
    "eventType": "Birthday",
    "plannedDate": "2026-02-28",
    "guests": "200",
    "location": "Palais des Congrès, Yaoundé",
    "discount": 0,
    "paymentTerms": "50% deposit upfront",
    "notes": "Budget too low for requested scope. Awaiting revised brief.",
    "inventoryLinks": [],
    "eventId": null,
    "lines": [
      {
        "itemId": 501,
        "name": "Ndolé",
        "qty": 200,
        "price": 3500,
        "unitType": "Per head",
        "photo": null,
        "description": ""
      },
      {
        "itemId": 502,
        "name": "Eru",
        "qty": 200,
        "price": 3000,
        "unitType": "Per head",
        "photo": null,
        "description": ""
      },
      {
        "itemId": 201,
        "name": "Cow Soya",
        "qty": 200,
        "price": 2500,
        "unitType": "Per head",
        "photo": null,
        "description": ""
      }
    ]
  }
];





// ─── OVERHEADD / EXPENSE ENTRY TYPES ──────────────────────────────
// entryType: "opex"   = direct operating expense (hits P&L)
//            "capex"  = asset purchase (hits Balance Sheet as Fixed Asset, depreciated)
//            "liability_payment" = payment against an existing liability (AP / loan)
// paymentStatus: "paid" | "unpaid" (unpaid = Accounts Payable)

const OVERHEAD_CATS = [
  "Rent & Premises",
  "Utilities",
  "Personnel",
  "Transportation",
  "Marketing",
  "Equipment",
  "Insurance",
  "Professional Fees",
  "Subscriptions",
  "Maintenance",
  "Other",
];
const OVERHEAD_FREQ = ["Monthly", "Quarterly", "Annually", "One-time"];
const OVERHEAD_ASSET_CATS = [
  "Equipment",
  "Furniture & Fixtures",
  "Vehicles",
  "Technology / IT",
  "Leasehold Improvements",
  "Other Asset",
];

const ENTRY_TYPES = [
  {
    value: "opex",
    label: "Operating Expense",
    icon: "📋",
    desc: "Regular expense — rent, salaries, utilities, marketing…",
  },
  {
    value: "capex",
    label: "Asset Purchase",
    icon: "🏗️",
    desc: "Purchase of a fixed asset — equipment, vehicle, furniture…",
  },
  {
    value: "liability_payment",
    label: "Liability / AP Payment",
    icon: "💳",
    desc: "Payment against a supplier debt, loan, or payable balance",
  },
];

const INIT_OVERHEADS = [
  {
    "id": 5001,
    "date": "2026-02-01",
    "category": "Rent & Premises",
    "description": "Monthly kitchen & dining space rent — Rue Njo Njo",
    "amount": 150000,
    "frequency": "Monthly",
    "vendor": "Propriétaire Akwa",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5002,
    "date": "2026-02-01",
    "category": "Personnel",
    "description": "Chef salary — February 2026",
    "amount": 120000,
    "frequency": "Monthly",
    "vendor": "Chef Bertrand Fouda",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5003,
    "date": "2026-02-01",
    "category": "Personnel",
    "description": "Serving staff wages — February 2026",
    "amount": 80000,
    "frequency": "Monthly",
    "vendor": "Staff Pool",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5004,
    "date": "2026-02-02",
    "category": "Utilities",
    "description": "Electricity bill — January usage",
    "amount": 45000,
    "frequency": "Monthly",
    "vendor": "AES-SONEL / ENEO",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5005,
    "date": "2026-02-02",
    "category": "Utilities",
    "description": "Water & gas — February",
    "amount": 22000,
    "frequency": "Monthly",
    "vendor": "CDE / Gas Supplier",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5006,
    "date": "2026-02-04",
    "category": "Marketing",
    "description": "Facebook & Instagram ads — February campaign",
    "amount": 35000,
    "frequency": "Monthly",
    "vendor": "Meta Ads",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5007,
    "date": "2026-02-05",
    "category": "Transportation",
    "description": "Fuel & delivery costs — Week 1",
    "amount": 18000,
    "frequency": "One-time",
    "vendor": "Fuel Station",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5008,
    "date": "2026-02-08",
    "category": "Equipment",
    "description": "New 10L heavy-duty cooking pot",
    "amount": 45000,
    "frequency": "One-time",
    "vendor": "Marché Central Douala",
    "entryType": "capex",
    "paymentStatus": "paid",
    "assetName": "10L Cooking Pot"
  },
  {
    "id": 5009,
    "date": "2026-02-10",
    "category": "Subscriptions",
    "description": "cookiesbites.app platform — monthly",
    "amount": 5000,
    "frequency": "Monthly",
    "vendor": "Platform",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5010,
    "date": "2026-02-12",
    "category": "Transportation",
    "description": "Fuel & delivery costs — Week 2",
    "amount": 20000,
    "frequency": "One-time",
    "vendor": "Fuel Station",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5011,
    "date": "2026-02-14",
    "category": "Marketing",
    "description": "Valentine's Day flyers printing — 500 copies",
    "amount": 15000,
    "frequency": "One-time",
    "vendor": "Print Shop Akwa",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5012,
    "date": "2026-02-15",
    "category": "Equipment",
    "description": "Catering serving trays x 20",
    "amount": 60000,
    "frequency": "One-time",
    "vendor": "Marché Central Douala",
    "entryType": "capex",
    "paymentStatus": "paid",
    "assetName": "Serving Trays x20"
  },
  {
    "id": 5013,
    "date": "2026-02-17",
    "category": "Maintenance",
    "description": "Kitchen deep-clean & equipment maintenance",
    "amount": 25000,
    "frequency": "One-time",
    "vendor": "Nettoyage Pro Douala",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5014,
    "date": "2026-02-18",
    "category": "Transportation",
    "description": "Fuel & delivery costs — Week 3",
    "amount": 17000,
    "frequency": "One-time",
    "vendor": "Fuel Station",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5015,
    "date": "2026-02-20",
    "category": "Professional Fees",
    "description": "Accountant / bookkeeping fee — Q1 2026",
    "amount": 30000,
    "frequency": "Quarterly",
    "vendor": "Cabinet Comptable Fokou",
    "entryType": "opex",
    "paymentStatus": "unpaid",
    "assetName": ""
  },
  {
    "id": 5016,
    "date": "2026-02-22",
    "category": "Transportation",
    "description": "Wedding event — van hire & logistics",
    "amount": 35000,
    "frequency": "One-time",
    "vendor": "Location Véhicules Douala",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5017,
    "date": "2026-02-24",
    "category": "Transportation",
    "description": "Fuel & delivery costs — Week 4",
    "amount": 19000,
    "frequency": "One-time",
    "vendor": "Fuel Station",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5018,
    "date": "2026-02-25",
    "category": "Marketing",
    "description": "March event flyers design",
    "amount": 12000,
    "frequency": "One-time",
    "vendor": "Graphiste Douala",
    "entryType": "opex",
    "paymentStatus": "unpaid",
    "assetName": ""
  },
  {
    "id": 5019,
    "date": "2026-02-28",
    "category": "Insurance",
    "description": "Business liability insurance — Q1 2026",
    "amount": 55000,
    "frequency": "Quarterly",
    "vendor": "Assurances du Cameroun",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  },
  {
    "id": 5020,
    "date": "2026-02-28",
    "category": "Other",
    "description": "Disposable packaging — boxes, bags, foil",
    "amount": 28000,
    "frequency": "Monthly",
    "vendor": "Emballages Douala",
    "entryType": "opex",
    "paymentStatus": "paid",
    "assetName": ""
  }
];

const INIT_CUSTOMERS = [
  {
    "id": 9001,
    "name": "Marie Ngo Mbock",
    "phone": "+237 677 112 233",
    "email": "marie.ngo@gmail.com",
    "classification": "VIP",
    "notes": "Prefers Ndolé, always pays on time. Birthday in April.",
    "createdAt": "2026-02-03"
  },
  {
    "id": 9002,
    "name": "Jean-Paul Tchamda",
    "phone": "+237 699 456 789",
    "email": "jptchamda@yahoo.fr",
    "classification": "Regular",
    "notes": "Orders for office lunches every Friday.",
    "createdAt": "2026-02-05"
  },
  {
    "id": 9003,
    "name": "Aminatou Bello",
    "phone": "+237 655 321 987",
    "email": "aminatou.bello@hotmail.com",
    "classification": "Regular",
    "notes": "Catering client — organised bridal shower.",
    "createdAt": "2026-02-07"
  },
  {
    "id": 9004,
    "name": "Emmanuel Fon",
    "phone": "+237 670 889 001",
    "email": "",
    "classification": "Regular",
    "notes": "Walk-in customer, orders Poulet DG frequently.",
    "createdAt": "2026-02-10"
  },
  {
    "id": 9005,
    "name": "Hortense Kana",
    "phone": "+237 691 554 772",
    "email": "h.kana@orange.cm",
    "classification": "VIP",
    "notes": "Organised two catering events. Very satisfied client.",
    "createdAt": "2026-02-01"
  },
  {
    "id": 9006,
    "name": "Sylvain Mbarga",
    "phone": "+237 676 220 114",
    "email": "sylvain.mbarga@gmail.com",
    "classification": "Regular",
    "notes": "Delivery customer in Bonanjo area.",
    "createdAt": "2026-02-12"
  },
  {
    "id": 9007,
    "name": "Christelle Abanda",
    "phone": "+237 652 008 435",
    "email": "",
    "classification": "New",
    "notes": "First-time client, birthday event enquiry.",
    "createdAt": "2026-02-18"
  },
  {
    "id": 9008,
    "name": "Serge Nguimfack",
    "phone": "+237 699 731 560",
    "email": "s.nguimfack@camtel.cm",
    "classification": "Regular",
    "notes": "Corporate client from Camtel.",
    "createdAt": "2026-02-08"
  },
  {
    "id": 9009,
    "name": "Pauline Essomba",
    "phone": "+237 677 445 882",
    "email": "pauline.e@gmail.com",
    "classification": "Regular",
    "notes": "Dine-in regular, comes on weekends.",
    "createdAt": "2026-02-14"
  },
  {
    "id": 9010,
    "name": "Didier Mouaha",
    "phone": "+237 655 193 067",
    "email": "",
    "classification": "New",
    "notes": "Referred by Marie Ngo Mbock.",
    "createdAt": "2026-02-22"
  }
];

const INIT_BATCHES = [
  {
    "id": 8001,
    "date": "2026-02-03",
    "mealId": 1061,
    "mealName": "Ndolé",
    "portions": 30,
    "totalCost": 45000,
    "notes": "Regular Monday batch — standard recipe",
    "deductInventory": false
  },
  {
    "id": 8002,
    "date": "2026-02-03",
    "mealId": 1020,
    "mealName": "Cow Soya",
    "portions": 40,
    "totalCost": 35000,
    "notes": "Charcoal grills prepped for week start",
    "deductInventory": false
  },
  {
    "id": 8003,
    "date": "2026-02-05",
    "mealId": 1062,
    "mealName": "Eru",
    "portions": 25,
    "totalCost": 38000,
    "notes": "Wednesday Eru — extra waterleaf added",
    "deductInventory": false
  },
  {
    "id": 8004,
    "date": "2026-02-06",
    "mealId": 1064,
    "mealName": "Mbongo Tchobi",
    "portions": 20,
    "totalCost": 32000,
    "notes": "Fish Mbongo — catfish used",
    "deductInventory": false
  },
  {
    "id": 8005,
    "date": "2026-02-07",
    "mealId": 1063,
    "mealName": "Achu & Yellow Soup",
    "portions": 20,
    "totalCost": 28000,
    "notes": "Weekend special batch",
    "deductInventory": false
  },
  {
    "id": 8006,
    "date": "2026-02-10",
    "mealId": 1072,
    "mealName": "Poulet DG",
    "portions": 25,
    "totalCost": 42000,
    "notes": "Chicken cooked with ripe plantains, rich sauce",
    "deductInventory": false
  },
  {
    "id": 8007,
    "date": "2026-02-10",
    "mealId": 1021,
    "mealName": "Chicken Soya",
    "portions": 35,
    "totalCost": 28000,
    "notes": "Full week batch — suya blend seasoning",
    "deductInventory": false
  },
  {
    "id": 8008,
    "date": "2026-02-12",
    "mealId": 1073,
    "mealName": "Kati Kati",
    "portions": 18,
    "totalCost": 31000,
    "notes": "Fire-grilled, traditional sauce",
    "deductInventory": false
  },
  {
    "id": 8009,
    "date": "2026-02-14",
    "mealId": 1061,
    "mealName": "Ndolé",
    "portions": 35,
    "totalCost": 52000,
    "notes": "Valentine's Friday special — larger batch",
    "deductInventory": false
  },
  {
    "id": 8010,
    "date": "2026-02-14",
    "mealId": 1025,
    "mealName": "Steak",
    "portions": 15,
    "totalCost": 45000,
    "notes": "Valentine's Day special — premium beef",
    "deductInventory": false
  },
  {
    "id": 8011,
    "date": "2026-02-17",
    "mealId": 1062,
    "mealName": "Eru",
    "portions": 30,
    "totalCost": 44000,
    "notes": "Monday batch — cow skin + tripe mix",
    "deductInventory": false
  },
  {
    "id": 8012,
    "date": "2026-02-17",
    "mealId": 1074,
    "mealName": "Pepper Soup",
    "portions": 22,
    "totalCost": 25000,
    "notes": "Goat meat pepper soup",
    "deductInventory": false
  },
  {
    "id": 8013,
    "date": "2026-02-19",
    "mealId": 1066,
    "mealName": "Kwacoco & Banga",
    "portions": 16,
    "totalCost": 22000,
    "notes": "Midweek special",
    "deductInventory": false
  },
  {
    "id": 8014,
    "date": "2026-02-21",
    "mealId": 1072,
    "mealName": "Poulet DG",
    "portions": 28,
    "totalCost": 46000,
    "notes": "Weekend batch — extra sauce prepared",
    "deductInventory": false
  },
  {
    "id": 8015,
    "date": "2026-02-21",
    "mealId": 1022,
    "mealName": "Goat Soya",
    "portions": 30,
    "totalCost": 38000,
    "notes": "Weekend grill — slow charcoal",
    "deductInventory": false
  },
  {
    "id": 8016,
    "date": "2026-02-24",
    "mealId": 1061,
    "mealName": "Ndolé",
    "portions": 30,
    "totalCost": 45000,
    "notes": "Standard Monday Ndolé",
    "deductInventory": false
  },
  {
    "id": 8017,
    "date": "2026-02-24",
    "mealId": 1077,
    "mealName": "Grilled Chicken / Poulet Braisé",
    "portions": 20,
    "totalCost": 35000,
    "notes": "Whole chickens marinated overnight",
    "deductInventory": false
  },
  {
    "id": 8018,
    "date": "2026-02-26",
    "mealId": 1067,
    "mealName": "Ekwang",
    "portions": 16,
    "totalCost": 24000,
    "notes": "Wednesday special — wrapped in banana leaves",
    "deductInventory": false
  },
  {
    "id": 8019,
    "date": "2026-02-27",
    "mealId": 1073,
    "mealName": "Kati Kati",
    "portions": 20,
    "totalCost": 34000,
    "notes": "Month-end batch",
    "deductInventory": false
  },
  {
    "id": 8020,
    "date": "2026-02-28",
    "mealId": 1064,
    "mealName": "Mbongo Tchobi",
    "portions": 18,
    "totalCost": 29000,
    "notes": "End-of-month fish Mbongo",
    "deductInventory": false
  }
];

// ─── HELPERS ──────────────────────────────────────────────────────
const eCOGS = (c, costLines) => {
  if (Array.isArray(costLines) && costLines.length > 0)
    return costLines.reduce((s, l) => s + (Number(l.total) || 0), 0);
  if (c && typeof c === "object")
    return (c?.inventory || 0) + (c?.labor || 0) + (c?.transport || 0) + (c?.overhead || 0);
  return 0;
};
const evtCOGS = (evt) => eCOGS(evt?.costs, evt?.costLines);
const propTotal = (lines, disc = 0) =>
  lines.reduce((s, l) => s + l.qty * l.price, 0) - disc;
const orderTotal = (s) => {
  const itemsTotal = Array.isArray(s.items) && s.items.length > 0
    ? s.items.reduce((sum, it) => sum + (Number(it.plates) || 0) * (Number(it.pricePerPlate) || 0), 0)
    : (Number(s.plates) || 0) * (Number(s.pricePerPlate) || 0);
  return itemsTotal + (Number(s.deliveryFee) || 0);
};

const totalPlates = (s) =>
  Array.isArray(s.items) && s.items.length > 0
    ? s.items.reduce((sum, it) => sum + (Number(it.plates) || 0), 0)
    : (Number(s.plates) || 0);

// Compute COGS for a restaurant sale using meal ingredient-level costing when available,
// falling back to catalog cost-rate estimate
const orderCOGS = (s, catalogItems, meals) => {
  // Get all items — multi-item orders use s.items, legacy uses single fields
  const items = Array.isArray(s.items) && s.items.length > 0
    ? s.items
    : [{ meal: s.meal, plates: s.plates, pricePerPlate: s.pricePerPlate }];

  let total = 0;
  items.forEach(it => {
    const mealName = (it.meal || "").toLowerCase();
    const plates = Number(it.plates) || 0;
    const pricePerPlate = Number(it.pricePerPlate) || 0;

    if (meals && meals.length) {
      const meal = meals.find(m =>
        m.name.toLowerCase() === mealName ||
        m.name.toLowerCase().includes(mealName.split(" ")[0])
      );
      if (meal) {
        const hasCost = meal.laborCost > 0 ||
          (meal.otherCosts && meal.otherCosts.length > 0) ||
          (meal.ingredientLinks && meal.ingredientLinks.length > 0);
        if (hasCost) {
          const cat = catalogItems.find(i => i.name.toLowerCase().includes(mealName.split(" ")[0]));
          const ingCost = Number(cat?.costPerUnit) || 0;
          const otherCost = (meal.otherCosts || []).reduce((a, c) => a + Number(c.amount || 0), 0);
          total += plates * (ingCost + Number(meal.laborCost || 0) + otherCost);
          return;
        }
      }
    }
    // Fallback: 35% cost rate
    const item = catalogItems.find(i => i.name.toLowerCase().includes(mealName.split(" ")[0]));
    const costPerUnit = Number(item?.costPerUnit) || 0;
    const price = Number(item?.price) || 0;
    const costRate = (price > 0 && costPerUnit > 0) ? Math.min(costPerUnit / price, 0.75) : 0.35;
    total += plates * pricePerPlate * costRate;
  });

  return total + (Number(s.deliveryFee) || 0) * 0.4;
};

// Compute total inventory stock value
const inventoryValue = (inventory) =>
  inventory.reduce((s, i) => s + (i.stock || 0) * (i.costPerUnit || 0), 0);

// Separate overheads by entry type for financial reports
const splitOverheads = (overheads) => {
  const opex = overheads.filter((o) => (o.entryType || "opex") === "opex");
  const capex = overheads.filter((o) => (o.entryType || "opex") === "capex");
  const liabPay = overheads.filter(
    (o) => (o.entryType || "opex") === "liability_payment"
  );
  // Unpaid opex = Accounts Payable
  const ap = opex
    .filter((o) => o.paymentStatus === "unpaid")
    .reduce((s, o) => s + Number(o.amount), 0);
  // Unpaid capex = still owed on assets
  const capexAP = capex
    .filter((o) => o.paymentStatus === "unpaid")
    .reduce((s, o) => s + Number(o.amount), 0);
  // Total fixed assets (all capex entries regardless of payment status)
  const fixedAssets = capex.reduce((s, o) => s + Number(o.amount), 0);
  // Total opex paid (hits P&L)
  const totalOpex = opex.reduce((s, o) => s + Number(o.amount), 0);
  const paidOpex = opex
    .filter((o) => o.paymentStatus !== "unpaid")
    .reduce((s, o) => s + Number(o.amount), 0);
  // Total liability payments made (reduces AP / loan balance)
  const totalLiabPaid = liabPay.reduce((s, o) => s + Number(o.amount), 0);
  return {
    opex,
    capex,
    liabPay,
    ap,
    capexAP,
    fixedAssets,
    totalOpex,
    paidOpex,
    totalLiabPaid,
  };
};
// ── Prepaid expense recognition helper ──────────────────────────────
// Returns the total XAF amount of a prepaid schedule recognized within [fromDate, toDate].
// Each calendar month that overlaps the amortization window counts as one slice.
const calcPrepaidRecognized = (prepaidItems, fromDate, toDate) => {
  if (!Array.isArray(prepaidItems) || !fromDate || !toDate) return 0;
  // Normalise to midnight so day-level comparisons are clean
  const pFrom = new Date(fromDate); pFrom.setHours(0, 0, 0, 0);
  const pTo   = new Date(toDate);   pTo.setHours(23, 59, 59, 999);
  const periodDays = (pTo - pFrom) / 86400000 + 1; // total days in the report window
  let total = 0;
  prepaidItems.forEach(item => {
    if (!item.startDate || !item.months || !item.totalPaid) return;
    const monthlyAmt = Number(item.totalPaid) / Number(item.months);
    const start = new Date(item.startDate + "-01");
    for (let m = 0; m < Number(item.months); m++) {
      const sliceStart = new Date(start.getFullYear(), start.getMonth() + m, 1);
      const sliceEnd   = new Date(start.getFullYear(), start.getMonth() + m + 1, 0); // last day of month
      sliceEnd.setHours(23, 59, 59, 999);
      // Does this month overlap the report period at all?
      if (sliceStart > pTo || sliceEnd < pFrom) continue;
      const daysInMonth = sliceEnd.getDate(); // total days in this calendar month
      // Overlap window: clamp to the narrower of report period and month slice
      const overlapStart = sliceStart < pFrom ? pFrom : sliceStart;
      const overlapEnd   = sliceEnd   > pTo   ? pTo   : sliceEnd;
      const overlapDays  = Math.round((overlapEnd - overlapStart) / 86400000) + 1;
      // Prorate: only charge the fraction of the month that falls in the report period
      total += monthlyAmt * (overlapDays / daysInMonth);
    }
  });
  return total;
};

const daysOD = (due) => {
  const now = new Date(); now.setHours(0, 0, 0, 0);
  const d = Math.floor((now - new Date(due)) / 86400000);
  return d > 0 ? d : 0;
};
const ageBucket = (days) => {
  if (days === 0) return "Current";
  if (days <= 7) return "1–7 days";
  if (days <= 30) return "8–30 days";
  if (days <= 60) return "31–60 days";
  return "61+ days";
};
const getTodayISO  = () => { const d = new Date(); return toLocalISO(d); };
const TODAY_ISO    = getTodayISO(); // used as default form value — acceptable to set once
const TODAY_LABEL  = new Date().toLocaleDateString("fr-CM", { day: "2-digit", month: "short", year: "numeric" });
const THIS_YEAR    = new Date().getFullYear();

const PIPELINE_PHASES = [
  "Lead / Inquiry",
  "Quotation Sent",
  "Confirmed",
  "Planning",
  "Procurement / Prep",
  "Cooking / Packing",
  "Delivery / Setup",
  "Event Completed",
  "Invoice Issued",
  "Paid",
  "Closed / Archived",
  "Cancelled",
];

// ─── STYLES ───────────────────────────────────────────────────────
const S = {
  app: {
    fontFamily: "'DM Sans','Helvetica Neue',Arial,sans-serif",
    background: T.bg,
    color: T.text,
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    fontSize: 13,
  },
  topbar: {
    background: T.surface,
    borderBottom: `1px solid ${T.border}`,
    padding: "0 16px",
    display: "flex",
    alignItems: "center",
    gap: 10,
    height: 50,
    flexShrink: 0,
  },
  nav: { display: "flex", gap: 3, overflowX: "auto", flex: 1 },
  navBtn: (a) => ({
    background: a ? T.accentSoft : "transparent",
    color: a ? T.accent : T.textMuted,
    border: `1px solid ${a ? T.accent : "transparent"}`,
    borderRadius: 5,
    padding: "5px 10px",
    cursor: "pointer",
    fontSize: 11,
    fontWeight: 600,
    whiteSpace: "nowrap",
    transition: "all 0.12s",
  }),
  main: {
    flex: 1,
    padding: "16px 20px",
    maxWidth: 1400,
    width: "100%",
    margin: "0 auto",
    boxSizing: "border-box",
  },
  mainMobile: {
    flex: 1,
    padding: "12px 12px 80px",
    width: "100%",
    boxSizing: "border-box",
  },
  pageTitle: {
    fontSize: 17,
    fontWeight: 700,
    marginBottom: 3,
    letterSpacing: -0.3,
  },
  subtitle: { color: T.textMuted, fontSize: 11, marginBottom: 16 },
  grid: (n) => ({
    display: "grid",
    gridTemplateColumns: `repeat(${n},1fr)`,
    gap: 10,
  }),
  gridMobile: { display: "grid", gridTemplateColumns: "1fr", gap: 10 },
  grid2Mobile: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 },
  card: {
    background: T.card,
    border: `1px solid ${T.border}`,
    borderRadius: 10,
    padding: 14,
  },
  cardMobile: {
    background: T.card,
    border: `1px solid ${T.border}`,
    borderRadius: 10,
    padding: 12,
  },
  cardTitle: {
    fontSize: 10,
    fontWeight: 700,
    color: T.textMuted,
    letterSpacing: 0.7,
    textTransform: "uppercase",
    marginBottom: 10,
  },
  kpi: { fontSize: 20, fontWeight: 800, letterSpacing: -0.3, color: T.accent },
  kpiSub: { fontSize: 10, color: T.textMuted, marginTop: 1 },
  badge: (c) => ({
    display: "inline-block",
    padding: "2px 6px",
    borderRadius: 20,
    fontSize: 10,
    fontWeight: 700,
    background: `${c}20`,
    color: c,
  }),
  table: { width: "100%", borderCollapse: "collapse" },
  th: {
    padding: "6px 9px",
    textAlign: "left",
    fontSize: 10,
    fontWeight: 700,
    color: T.textMuted,
    letterSpacing: 0.3,
    borderBottom: `1px solid ${T.border}`,
    whiteSpace: "nowrap",
  },
  td: {
    padding: "7px 9px",
    fontSize: 12,
    borderBottom: `1px solid ${T.border}18`,
    verticalAlign: "middle",
  },
  btn: (v) => ({
    background:
      v === "primary"
        ? T.accent
        : v === "success"
        ? T.success
        : v === "danger"
        ? T.danger
        : "transparent",
    color:
      v === "primary"
        ? T.bg
        : v === "success" || v === "danger"
        ? "#fff"
        : T.text,
    border: v === "ghost" ? `1px solid ${T.border}` : "none",
    borderRadius: 6,
    padding: "6px 12px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 12,
    transition: "all 0.12s",
    whiteSpace: "nowrap",
  }),
  input: {
    background: T.surface,
    border: `1px solid ${T.border}`,
    borderRadius: 6,
    padding: "6px 9px",
    color: T.text,
    fontSize: 12,
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  },
  select: {
    background: T.surface,
    border: `1px solid ${T.border}`,
    borderRadius: 6,
    padding: "6px 9px",
    color: T.text,
    fontSize: 12,
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    color: T.textMuted,
    display: "block",
    marginBottom: 3,
  },
  row: { display: "flex", gap: 8, alignItems: "center" },
  divider: {
    border: "none",
    borderTop: `1px solid ${T.border}`,
    margin: "10px 0",
  },
  pb: (col) => ({
    height: 3,
    borderRadius: 3,
    background: `${col}25`,
    position: "relative",
    overflow: "hidden",
  }),
  pbf: (pct, col) => ({
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: `${Math.min(100, pct)}%`,
    background: col,
    borderRadius: 3,
  }),
  sectionTitle: { fontSize: 13, fontWeight: 700, marginBottom: 10 },
  tag: {
    display: "inline-block",
    background: T.surface,
    border: `1px solid ${T.border}`,
    borderRadius: 3,
    padding: "1px 4px",
    fontSize: 10,
    marginRight: 3,
    color: T.textMuted,
  },
};

// Responsive grid: on mobile, cols > 2 collapse to 1 (or 2 for small items)
const rGrid = (n, isMobile, forceCols) => {
  if (!isMobile) return S.grid(n);
  if (forceCols) return S.grid(forceCols);
  return n <= 2 ? S.grid(n) : S.gridMobile;
};
const Badge = ({ color = T.accent, children }) => (
  <span style={S.badge(color)}>{children}</span>
);
const Divider = () => <hr style={S.divider} />;
const PBar = ({ pct, color = T.accent }) => (
  <div style={S.pb(color)}>
    <div style={S.pbf(pct, color)} />
  </div>
);

// Wraps tables for horizontal scroll on mobile
const TableScroll = ({ children }) => (
  <div
    style={{
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      marginLeft: -12,
      marginRight: -12,
      paddingLeft: 12,
      paddingRight: 12,
    }}
  >
    {children}
  </div>
);

// Mobile stat row (replaces multi-column grid on mobile)
function MobileStatRow({ items }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${Math.min(items.length, 2)}, 1fr)`,
        gap: 8,
        marginBottom: 12,
      }}
    >
      {items.map((item, i) => (
        <div key={i} style={{ ...S.cardMobile, padding: "10px 12px" }}>
          <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 2 }}>
            {item.icon} {item.label}
          </div>
          <div
            style={{
              fontSize: 15,
              fontWeight: 800,
              color: item.color || T.accent,
            }}
          >
            {item.value}
          </div>
          {item.sub && (
            <div style={{ fontSize: 10, color: T.textDim, marginTop: 1 }}>
              {item.sub}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

// Mobile bottom nav
function MobileNav({ tab, setTab, tabs }) {
  const visible = tabs.slice(0, 5); // show first 5 in bottom bar
  const overflow = tabs.slice(5);
  const [showMore, setShowMore] = useState(false);
  return (
    <>
      {showMore && (
        <div
          style={{
            position: "fixed",
            bottom: 60,
            left: 0,
            right: 0,
            zIndex: 900,
            background: T.surface,
            borderTop: `1px solid ${T.border}`,
            padding: 8,
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 6,
          }}
        >
          {overflow.map((t) => (
            <button
              key={t.id}
              style={{
                ...S.navBtn(tab === t.id),
                textAlign: "left",
                padding: "10px 12px",
                fontSize: 13,
              }}
              onClick={() => {
                setTab(t.id);
                setShowMore(false);
              }}
            >
              {t.label}
            </button>
          ))}
        </div>
      )}
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          background: T.surface,
          borderTop: `1px solid ${T.border}`,
          display: "flex",
          height: 58,
          alignItems: "stretch",
        }}
      >
        {visible.map((t) => {
          const active = tab === t.id;
          const icon = t.label.split(" ")[0];
          const name = t.label
            .split(" ")
            .slice(1)
            .join(" ")
            .replace(" & ", "/")
            .replace(" Delivery", "");
          return (
            <button
              key={t.id}
              onClick={() => {
                setTab(t.id);
                setShowMore(false);
              }}
              style={{
                flex: 1,
                background: "transparent",
                border: "none",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                borderTop: active
                  ? `2px solid ${T.accent}`
                  : "2px solid transparent",
                transition: "all 0.12s",
              }}
            >
              <span style={{ fontSize: 18, lineHeight: 1 }}>{icon}</span>
              <span
                style={{
                  fontSize: 9,
                  fontWeight: active ? 700 : 500,
                  color: active ? T.accent : T.textMuted,
                  lineHeight: 1,
                }}
              >
                {name.slice(0, 8)}
              </span>
            </button>
          );
        })}
        <button
          onClick={() => setShowMore(!showMore)}
          style={{
            flex: 1,
            background: "transparent",
            border: "none",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            borderTop: overflow.some((t) => t.id === tab)
              ? `2px solid ${T.accent}`
              : "2px solid transparent",
          }}
        >
          <span style={{ fontSize: 18 }}>☰</span>
          <span
            style={{
              fontSize: 9,
              fontWeight: 500,
              color: overflow.some((t) => t.id === tab)
                ? T.accent
                : T.textMuted,
            }}
          >
            More
          </span>
        </button>
      </div>
    </>
  );
}

function KpiCard({ label, value, sub, color = T.accent, icon = "", onClick }) {
  return (
    <div style={{ ...S.card, cursor: onClick ? "pointer" : "default", transition: "opacity 0.15s" }}
      onClick={onClick}
      title={onClick ? "Click to see details" : undefined}
    >
      <div style={S.cardTitle}>
        {icon} {label}{onClick && <span style={{ float: "right", fontSize: 10, color: T.textDim }}>▼</span>}
      </div>
      <div style={{ ...S.kpi, color }}>{value}</div>
      {sub && <div style={S.kpiSub}>{sub}</div>}
    </div>
  );
}

function PhaseBadge({ phase }) {
  const c = {
    "Lead / Inquiry": T.info,
    "Quotation Sent": T.warning,
    Confirmed: T.success,
    Planning: T.catering,
    "Procurement / Prep": T.warning,
    "Cooking / Packing": T.restaurant,
    "Delivery / Setup": T.delivery,
    "Event Completed": T.success,
    "Invoice Issued": T.accent,
    Paid: "#3DE890",
    "Closed / Archived": T.textDim,
    Cancelled: T.danger,
  };
  return <Badge color={c[phase] || T.textMuted}>{phase}</Badge>;
}

// ─── MEDIA UPLOADER ───────────────────────────────────────────────
// Media category definitions with icons and accepted file types
const MEDIA_CATEGORIES = [
  { id: "screenshot",  label: "Screenshot",       icon: "📸", accept: "image/*" },
  { id: "photo",       label: "Event Photo",       icon: "🖼️",  accept: "image/*" },
  { id: "video",       label: "Video",             icon: "🎥", accept: "video/*" },
  { id: "invoice",     label: "Invoice",           icon: "🧾", accept: "image/*,application/pdf" },
  { id: "receipt",     label: "Receipt",           icon: "💳", accept: "image/*,application/pdf" },
  { id: "contract",    label: "Contract / Quote",  icon: "📝", accept: "image/*,application/pdf" },
  { id: "floor_plan",  label: "Floor Plan / Map",  icon: "🗺️",  accept: "image/*,application/pdf" },
  { id: "other",       label: "Other",             icon: "📎", accept: "image/*,video/*,application/pdf,.doc,.docx" },
];

// Phase-to-suggested-categories map (what makes sense at each stage)
const PHASE_MEDIA_HINTS = {
  "Lead / Inquiry":      ["screenshot", "other"],
  "Quotation Sent":      ["contract", "screenshot", "other"],
  "Confirmed":           ["contract", "receipt", "screenshot"],
  "Planning":            ["floor_plan", "screenshot", "contract", "other"],
  "Procurement / Prep":  ["receipt", "invoice", "photo", "other"],
  "Cooking / Packing":   ["photo", "video", "other"],
  "Delivery / Setup":    ["photo", "video", "other"],
  "Event Completed":     ["photo", "video", "other"],
  "Invoice Issued":      ["invoice", "screenshot", "other"],
  "Paid":                ["receipt", "screenshot", "other"],
  "Closed / Archived":   ["photo", "video", "receipt", "other"],
  "Cancelled":           ["other"],
};

function PhasedMediaGallery({ media, onAdd, onDelete, onUpdate, currentPhase }) {
  const fileRef = useRef();
  const [uploadPhase, setUploadPhase] = useState(currentPhase || "Lead / Inquiry");
  const [uploadCat, setUploadCat] = useState("photo");
  const [uploadCaption, setUploadCaption] = useState("");
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [lightbox, setLightbox] = useState(null); // media item
  const [editingCaption, setEditingCaption] = useState(null); // media id
  const [filterPhase, setFilterPhase] = useState("All");
  const [filterCat, setFilterCat] = useState("All");
  const [isDragging, setIsDragging] = useState(false);

  // Keep uploadPhase in sync when currentPhase changes
  useEffect(() => { if (currentPhase) setUploadPhase(currentPhase); }, [currentPhase]);

  const catInfo = (id) => MEDIA_CATEGORIES.find((c) => c.id === id) || MEDIA_CATEGORIES[7];
  const suggestedCats = PHASE_MEDIA_HINTS[uploadPhase] || ["photo", "other"];

  const processFiles = async (files) => {
    const caption = uploadCaption;
    setUploadCaption("");
    for (const f of Array.from(files)) {
      const isPdf   = f.type === "application/pdf";
      const isVideo = f.type.startsWith("video/");
      const folder  = isVideo ? "events/videos" : isPdf ? "events/docs" : "events/photos";
      // Upload to Supabase Storage (falls back to base64 if offline)
      const src = await uploadFile(f, folder);
      onAdd({
        id: Date.now() + Math.random(),
        src,
        type: isPdf ? "pdf" : isVideo ? "video" : "image",
        name: f.name,
        size: f.size,
        phase: uploadPhase,
        category: uploadCat,
        caption,
        uploadedAt: new Date().toLocaleDateString("fr-CM", { day: "2-digit", month: "short", year: "numeric" }),
      });
    }
  };

  const handleFileInput = (e) => { processFiles(e.target.files); e.target.value = ""; };
  const handleDrop = (e) => {
    e.preventDefault(); setIsDragging(false);
    processFiles(e.dataTransfer.files);
  };

  const filteredMedia = media.filter((m) => {
    if (filterPhase !== "All" && m.phase !== filterPhase) return false;
    if (filterCat !== "All" && m.category !== filterCat) return false;
    return true;
  });

  // Group for display
  const grouped = PIPELINE_PHASES.reduce((acc, p) => {
    const items = filteredMedia.filter((m) => m.phase === p);
    if (items.length) acc[p] = items;
    return acc;
  }, {});
  // Also catch unphased legacy items
  const unphased = filteredMedia.filter((m) => !m.phase);
  if (unphased.length) grouped["Untagged"] = unphased;

  const usedPhases = [...new Set(media.map((m) => m.phase || "Untagged"))];
  const usedCats = [...new Set(media.map((m) => m.category || "other"))];

  return (
    <div>
      {/* Lightbox */}
      {lightbox && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.96)", zIndex: 3000, display: "flex", flexDirection: "column" }}
          onClick={(e) => { if (e.target === e.currentTarget) setLightbox(null); }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 18px", background: T.surface, borderBottom: `1px solid ${T.border}` }}>
            <div style={{ fontSize: 12 }}>
              <span style={{ fontWeight: 700 }}>{catInfo(lightbox.category).icon} {catInfo(lightbox.category).label}</span>
              <span style={{ color: T.textMuted, marginLeft: 10, fontSize: 11 }}>{lightbox.phase} · {lightbox.uploadedAt}</span>
            </div>
            <button style={{ ...S.btn("ghost"), fontSize: 11 }} onClick={() => setLightbox(null)}>✕ Close</button>
          </div>
          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, overflow: "auto" }}>
            {lightbox.type === "video" ? (
              <video src={lightbox.src} controls style={{ maxWidth: "100%", maxHeight: "70vh", borderRadius: 8 }} />
            ) : lightbox.type === "pdf" ? (
              <div style={{ color: T.textMuted, textAlign: "center" }}>
                <div style={{ fontSize: 48, marginBottom: 8 }}>📄</div>
                <div style={{ fontSize: 13 }}>{lightbox.name}</div>
                <a href={lightbox.src} download={lightbox.name} style={{ ...S.btn("primary"), display: "inline-block", marginTop: 14, fontSize: 12, textDecoration: "none" }}>⬇ Download PDF</a>
              </div>
            ) : (
              <img src={lightbox.src} alt={lightbox.name} style={{ maxWidth: "100%", maxHeight: "70vh", borderRadius: 8, objectFit: "contain" }} />
            )}
          </div>
          <div style={{ padding: "10px 18px", background: T.surface, borderTop: `1px solid ${T.border}`, display: "flex", alignItems: "center", gap: 10 }}>
            {editingCaption === lightbox.id ? (
              <>
                <input
                  autoFocus
                  style={{ ...S.input, flex: 1, marginBottom: 0, fontSize: 12 }}
                  defaultValue={lightbox.caption}
                  onBlur={(e) => { onUpdate(lightbox.id, { caption: e.target.value }); setEditingCaption(null); setLightbox((l) => ({ ...l, caption: e.target.value })); }}
                  onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
                />
              </>
            ) : (
              <span
                style={{ flex: 1, fontSize: 12, color: lightbox.caption ? T.text : T.textDim, cursor: "pointer" }}
                onClick={() => setEditingCaption(lightbox.id)}
              >
                {lightbox.caption || "Click to add a caption…"}
              </span>
            )}
            <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px", color: T.danger, borderColor: T.danger + "40" }}
              onClick={() => { onDelete(lightbox.id); setLightbox(null); }}>
              🗑 Delete
            </button>
          </div>
        </div>
      )}

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.7 }}>
          📁 Event Media ({media.length})
        </div>
        <button
          style={{ ...S.btn("primary"), fontSize: 11, padding: "5px 12px" }}
          onClick={() => setShowUploadForm((v) => !v)}
        >
          {showUploadForm ? "✕ Cancel" : "+ Upload Files"}
        </button>
      </div>

      {/* Upload form */}
      {showUploadForm && (
        <div style={{ background: T.surface, border: `1px solid ${T.accent}40`, borderRadius: 10, padding: 14, marginBottom: 14 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: T.accent, marginBottom: 10 }}>📤 Upload to Pipeline Stage</div>

          {/* Phase selector */}
          <div style={{ marginBottom: 10 }}>
            <label style={S.label}>Pipeline Stage</label>
            <select style={S.select} value={uploadPhase} onChange={(e) => { setUploadPhase(e.target.value); setUploadCat(PHASE_MEDIA_HINTS[e.target.value]?.[0] || "other"); }}>
              {PIPELINE_PHASES.map((p) => <option key={p}>{p}</option>)}
            </select>
          </div>

          {/* Category selector with suggested highlights */}
          <div style={{ marginBottom: 10 }}>
            <label style={S.label}>File Type / Category</label>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {MEDIA_CATEGORIES.map((c) => {
                const isSuggested = suggestedCats.includes(c.id);
                const isActive = uploadCat === c.id;
                return (
                  <button
                    key={c.id}
                    onClick={() => setUploadCat(c.id)}
                    style={{
                      ...S.btn(isActive ? "primary" : "ghost"),
                      fontSize: 11,
                      padding: "4px 10px",
                      opacity: isSuggested || isActive ? 1 : 0.45,
                      border: isSuggested && !isActive ? `1px solid ${T.accent}60` : undefined,
                    }}
                  >
                    {c.icon} {c.label}
                  </button>
                );
              })}
            </div>
            {suggestedCats.length > 0 && (
              <div style={{ fontSize: 10, color: T.textDim, marginTop: 4 }}>
                Highlighted types are common for the <em>{uploadPhase}</em> stage
              </div>
            )}
          </div>

          {/* Caption */}
          <div style={{ marginBottom: 12 }}>
            <label style={S.label}>Caption / Note (optional)</label>
            <input style={S.input} placeholder={`e.g. Client WhatsApp confirmation, deposit receipt…`} value={uploadCaption} onChange={(e) => setUploadCaption(e.target.value)} />
          </div>

          {/* Drop zone */}
          <div
            style={{
              border: `2px dashed ${isDragging ? T.accent : T.border}`,
              borderRadius: 8, padding: "20px 16px", textAlign: "center",
              background: isDragging ? T.accentSoft : T.card,
              cursor: "pointer", transition: "all 0.15s",
            }}
            onClick={() => fileRef.current.click()}
            onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={handleDrop}
          >
            <div style={{ fontSize: 28, marginBottom: 6 }}>{catInfo(uploadCat).icon}</div>
            <div style={{ fontSize: 12, fontWeight: 700, color: isDragging ? T.accent : T.text }}>
              Drop files here or click to browse
            </div>
            <div style={{ fontSize: 10, color: T.textMuted, marginTop: 4 }}>
              Images · Videos · PDFs · Documents · Multiple files supported
            </div>
          </div>
          <input ref={fileRef} type="file" accept={catInfo(uploadCat).accept} multiple style={{ display: "none" }} onChange={handleFileInput} />
        </div>
      )}

      {/* Filters */}
      {media.length > 3 && (
        <div style={{ display: "flex", gap: 6, marginBottom: 12, flexWrap: "wrap" }}>
          <select style={{ ...S.select, fontSize: 11, padding: "4px 8px", width: "auto" }} value={filterPhase} onChange={(e) => setFilterPhase(e.target.value)}>
            <option value="All">All stages</option>
            {usedPhases.map((p) => <option key={p}>{p}</option>)}
          </select>
          <select style={{ ...S.select, fontSize: 11, padding: "4px 8px", width: "auto" }} value={filterCat} onChange={(e) => setFilterCat(e.target.value)}>
            <option value="All">All types</option>
            {usedCats.map((c) => <option key={c}>{catInfo(c).icon} {catInfo(c).label}</option>)}
          </select>
        </div>
      )}

      {/* Empty state */}
      {media.length === 0 && !showUploadForm && (
        <div
          style={{ border: `1px dashed ${T.border}`, borderRadius: 8, padding: "28px 16px", textAlign: "center", cursor: "pointer", color: T.textDim }}
          onClick={() => setShowUploadForm(true)}
        >
          <div style={{ fontSize: 28, marginBottom: 6 }}>📁</div>
          <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}>No files uploaded yet</div>
          <div style={{ fontSize: 11 }}>Screenshots · Invoices · Receipts · Photos · Videos · Contracts</div>
        </div>
      )}

      {/* Grouped display */}
      {Object.entries(grouped).map(([phase, items]) => (
        <div key={phase} style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: T.accent, textTransform: "uppercase", letterSpacing: 0.7, marginBottom: 7, display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ background: T.accentSoft, borderRadius: 4, padding: "1px 7px" }}>{phase}</span>
            <span style={{ color: T.textDim, fontWeight: 400 }}>{items.length} file{items.length > 1 ? "s" : ""}</span>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(96px, 1fr))", gap: 6 }}>
            {items.map((m) => (
              <div
                key={m.id}
                style={{ position: "relative", borderRadius: 7, overflow: "hidden", border: `1px solid ${T.border}`, background: T.surface, cursor: "pointer" }}
                onClick={() => setLightbox(m)}
              >
                {/* Thumbnail */}
                <div style={{ aspectRatio: "1", overflow: "hidden", position: "relative" }}>
                  {m.type === "video" ? (
                    <video src={m.src} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  ) : m.type === "pdf" ? (
                    <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: T.card, fontSize: 28 }}>📄</div>
                  ) : (
                    <img src={m.src} alt={m.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  )}
                  {/* Category badge overlay */}
                  <div style={{ position: "absolute", top: 3, left: 3, background: "rgba(0,0,0,0.65)", borderRadius: 3, padding: "1px 4px", fontSize: 9, color: "#fff" }}>
                    {catInfo(m.category).icon}
                  </div>
                  {m.type === "video" && (
                    <div style={{ position: "absolute", bottom: 3, left: 3, background: "rgba(0,0,0,0.6)", color: "#fff", fontSize: 8, padding: "1px 4px", borderRadius: 3 }}>▶</div>
                  )}
                  {/* Delete */}
                  <button
                    style={{ position: "absolute", top: 3, right: 3, background: T.danger, border: "none", color: "#fff", borderRadius: "50%", width: 16, height: 16, fontSize: 9, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", opacity: 0, transition: "opacity 0.15s" }}
                    onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = "0")}
                    onClick={(e) => { e.stopPropagation(); onDelete(m.id); }}
                  >✕</button>
                </div>
                {/* Caption / name */}
                <div style={{ padding: "3px 5px 4px", fontSize: 9, color: T.textMuted, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {m.caption || m.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

// ─── LOGO + BRAND ─────────────────────────────────────────────────
function LogoArea({ logo, setLogo, biz, onSettings }) {
  const ref = useRef();
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {logo?.src ? (
        <img
          src={logo.src}
          alt="logo"
          style={{
            height: 30,
            maxWidth: 110,
            objectFit: "contain",
            borderRadius: 3,
          }}
        />
      ) : (
        <div
          style={{
            fontSize: 14,
            fontWeight: 800,
            color: T.accent,
            letterSpacing: -0.3,
            whiteSpace: "nowrap",
          }}
        >
          {biz.name}
        </div>
      )}
      <button
        style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px" }}
        onClick={() => ref.current.click()}
      >
        ↑ Logo
      </button>
      {logo?.src && (
        <button
          style={{
            background: "none",
            border: "none",
            color: T.textDim,
            cursor: "pointer",
            fontSize: 10,
          }}
          onClick={() => setLogo(null)}
        >
          ✕
        </button>
      )}
      <input
        ref={ref}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={async (e) => {
          const f = e.target.files[0];
          if (!f) return;
          const src = await uploadFile(f, "logo");
          setLogo({ src });
        }}
      />
      {onSettings && (
        <button
          style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px" }}
          onClick={onSettings}
        >
          ⚙️ Settings
        </button>
      )}
    </div>
  );
}

// ─── BAR CHART ────────────────────────────────────────────────────
function BarChart({ data, height = 140 }) {
  if (!data || !data.length)
    return <div style={{ color: T.textMuted, fontSize: 11, textAlign: "center", padding: 20 }}>No data</div>;

  const maxVal = Math.max(...data.map((d) => d.sales || 0), 1);
  const barW = Math.max(18, Math.min(48, Math.floor(560 / data.length) - 6));

  const fmtY = (val) => {
    if (val >= 1000000) return `${(val / 1000000).toFixed(1)}M`;
    if (val >= 1000)    return `${Math.round(val / 1000)}K`;
    return String(Math.round(val));
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <div style={{ display: "flex" }}>
        {/* Y-axis */}
        <div style={{ position: "relative", width: 40, flexShrink: 0, height: height + 28 }}>
          {[100, 75, 50, 25, 0].map((pct) => (
            <div key={pct} style={{
              position: "absolute",
              right: 4,
              bottom: 24 + (pct / 100) * height - 6,
              fontSize: 8,
              color: T.textDim,
              whiteSpace: "nowrap",
              textAlign: "right",
              lineHeight: 1,
            }}>{fmtY((pct / 100) * maxVal)}</div>
          ))}
        </div>
        {/* Bars */}
        <div style={{ flex: 1, overflowX: "auto" }}>
          <div style={{
            display: "flex",
            alignItems: "flex-end",
            gap: 4,
            height: height + 28,
            paddingBottom: 24,
            minWidth: data.length * (barW + 4),
            position: "relative",
          }}>
            {[0, 25, 50, 75, 100].map((pct) => (
              <div key={pct} style={{
                position: "absolute", left: 0, right: 0,
                bottom: 24 + (pct / 100) * height,
                borderTop: `1px solid ${T.border}40`,
                pointerEvents: "none",
              }} />
            ))}
            {data.map((d, i) => (
              <div key={i} style={{
                display: "flex", flexDirection: "column", alignItems: "center",
                flex: 1, minWidth: barW, position: "relative",
              }}>
                <div style={{ width: "100%", display: "flex", gap: 1, alignItems: "flex-end", height }}>
                  <div style={{
                    flex: 1, background: T.restaurant, borderRadius: "3px 3px 0 0",
                    height: d.sales ? (d.sales / maxVal) * height : 1,
                    minHeight: 1, transition: "height 0.3s",
                  }} />
                  <div style={{
                    flex: 1, background: T.success, borderRadius: "3px 3px 0 0",
                    height: d.profit && d.profit > 0 ? (d.profit / maxVal) * height : 1,
                    minHeight: 1, opacity: 0.85, transition: "height 0.3s",
                  }} />
                </div>
                <div style={{
                  fontSize: 9, color: T.textMuted, marginTop: 3,
                  whiteSpace: "nowrap", textAlign: "center",
                  overflow: "hidden", maxWidth: barW + 4,
                }}>{d.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={{ display: "flex", gap: 14, fontSize: 10, color: T.textMuted, marginTop: 2, paddingLeft: 44 }}>
        <span><span style={{ display: "inline-block", width: 8, height: 8, background: T.restaurant, borderRadius: 2, marginRight: 3 }} />Sales (XAF)</span>
        <span><span style={{ display: "inline-block", width: 8, height: 8, background: T.success, borderRadius: 2, marginRight: 3 }} />Gross Profit (XAF)</span>
      </div>
    </div>
  );
}


// ─── PERIOD SELECTOR ──────────────────────────────────────────────
function PeriodSelector({
  period,
  setPeriod,
  customFrom,
  setCustomFrom,
  customTo,
  setCustomTo,
  range,
}) {
  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <div style={{ marginBottom: 12 }}>
        <select
          style={{ ...S.select, marginBottom: 6 }}
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
        >
          {Object.entries(PERIOD_LABELS).map(([k, v]) => (
            <option key={k} value={k}>
              {v}
            </option>
          ))}
        </select>
        {period === "custom" && (
          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
            <input
              type="date"
              style={{ ...S.input, flex: 1, padding: "6px 7px" }}
              value={customFrom}
              onChange={(e) => setCustomFrom(e.target.value)}
            />
            <span style={{ color: T.textMuted, fontSize: 11, flexShrink: 0 }}>
              →
            </span>
            <input
              type="date"
              style={{ ...S.input, flex: 1, padding: "6px 7px" }}
              value={customTo}
              onChange={(e) => setCustomTo(e.target.value)}
            />
          </div>
        )}
        <div style={{ fontSize: 10, color: T.textDim, marginTop: 4 }}>
          {fmtDate(range[0])} – {fmtDate(range[1])}
        </div>
      </div>
    );
  }
  return (
    <div
      style={{
        display: "flex",
        gap: 6,
        alignItems: "center",
        flexWrap: "wrap",
        marginBottom: 14,
      }}
    >
      <div style={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        {Object.entries(PERIOD_LABELS).map(
          ([k, v]) =>
            k !== "custom" && (
              <button
                key={k}
                style={S.navBtn(period === k)}
                onClick={() => setPeriod(k)}
              >
                {v}
              </button>
            )
        )}
        <button
          style={S.navBtn(period === "custom")}
          onClick={() => setPeriod("custom")}
        >
          Custom
        </button>
      </div>
      {period === "custom" && (
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <input
            type="date"
            style={{ ...S.input, width: 130, padding: "4px 7px" }}
            value={customFrom}
            onChange={(e) => setCustomFrom(e.target.value)}
          />
          <span style={{ color: T.textMuted, fontSize: 11 }}>to</span>
          <input
            type="date"
            style={{ ...S.input, width: 130, padding: "4px 7px" }}
            value={customTo}
            onChange={(e) => setCustomTo(e.target.value)}
          />
        </div>
      )}
      <div
        style={{
          fontSize: 10,
          color: T.textDim,
          marginLeft: 4,
          whiteSpace: "nowrap",
        }}
      >
        {fmtDate(range[0])} – {fmtDate(range[1])}
      </div>
    </div>
  );
}

// ─── PRINT/DOC ENGINE ─────────────────────────────────────────────
const PRINT_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Inter',Arial,sans-serif;color:#1a1a1a;background:#fff;padding:24px 40px 40px;font-size:13px;line-height:1.5}
.doc-header{display:grid;grid-template-columns:1fr auto 1fr;align-items:center;margin-bottom:28px;padding-bottom:16px;border-bottom:3px solid #1a1a1a;gap:16px;padding-top:0}
.brand-block{display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start}
.brand-block img{height:150px;max-width:160px;object-fit:contain;display:block;margin:0 auto}
.brand-name{font-size:26px;font-weight:900;letter-spacing:-1px;color:#1a1a1a;line-height:1}
.biz-info{display:flex;flex-direction:column;justify-content:flex-start;align-self:flex-start}
.biz-info .biz-name{font-size:16px;font-weight:900;color:#1a1a1a;line-height:1.2;margin-bottom:3px;letter-spacing:-0.3px}
.biz-info .biz-detail{font-size:10px;color:#555;line-height:1.75}
.brand-sub{font-size:11px;color:#666;margin-top:2px;line-height:1.7}
.doc-ref-block{text-align:right;align-self:flex-start}
.doc-type{font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#999;margin-bottom:4px}
.doc-number{font-size:28px;font-weight:900;color:#1a1a1a;letter-spacing:-0.5px}
.doc-meta{font-size:11px;color:#666;margin-top:4px;line-height:1.8}
.parties{display:grid;grid-template-columns:1fr 1fr;gap:24px;margin-bottom:28px}
.party-box{background:#f8f8f8;border-radius:8px;padding:14px 16px}
.party-label{font-size:9px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#aaa;margin-bottom:8px}
.party-name{font-size:15px;font-weight:700;color:#1a1a1a;margin-bottom:2px}
.party-detail{font-size:11px;color:#555;line-height:1.7}
.status-banner{border-radius:8px;padding:12px 16px;margin-bottom:24px;display:flex;align-items:center;gap:12}
.status-banner.paid{background:#f0fdf4;border:1.5px solid #86efac}
.status-banner.partial{background:#fffbeb;border:1.5px solid #fde68a}
.status-banner.unpaid{background:#fff5f5;border:1.5px solid #fca5a5}
.status-icon{font-size:22px}
.status-text strong{font-size:14px;display:block;margin-bottom:1px}
.status-text span{font-size:11px;color:#555}
.items-section{margin-bottom:28px}
.section-heading{font-size:9px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#aaa;margin-bottom:10px}
table{width:100%;border-collapse:collapse}
thead tr{background:#1a1a1a;color:#fff}
thead th{padding:10px 12px;text-align:left;font-size:11px;font-weight:600;letter-spacing:0.3px;color:#fff}
thead th.tr{text-align:right}thead th.tc{text-align:center}
tbody tr:nth-child(even){background:#fafafa}
tbody td{padding:10px 12px;font-size:12px;color:#333;border-bottom:1px solid #ebebeb}
tbody td.tr{text-align:right;font-weight:600}tbody td.tc{text-align:center}tbody td.bold{font-weight:700;color:#1a1a1a}
.totals-block{display:flex;justify-content:flex-end;margin-bottom:28px}
.totals-inner{width:320px;border-radius:8px;overflow:hidden;border:1px solid #e5e5e5}
.total-row{display:flex;justify-content:space-between;padding:9px 14px;font-size:12px;border-bottom:1px solid #ebebeb}
.total-row:last-child{border-bottom:none}
.total-row.grand{background:#1a1a1a;color:#fff!important;padding:12px 14px}
.total-row.grand .label{font-size:13px;font-weight:700;color:#fff!important}
.total-row.grand .value{font-size:16px;font-weight:900;color:#fff!important}
.total-row .label{color:#555}.total-row .value{font-weight:700;color:#1a1a1a}
.total-row.highlight .value{color:#16a34a;font-size:14px}
.total-row.danger .value{color:#dc2626}
.total-row.discount .value{color:#dc2626}
.payment-box{background:#f8f8f8;border-radius:8px;padding:14px 16px;margin-bottom:28px}
.payment-box h4{font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#aaa;margin-bottom:10px}
.payment-row{display:flex;justify-content:space-between;font-size:12px;padding:3px 0;color:#333}
.payment-row strong{color:#1a1a1a}
.receipt-hero{background:#1a1a1a;color:#fff;border-radius:10px;padding:28px;text-align:center;margin-bottom:28px}
.receipt-hero.partial{background:#7c4a00}
.receipt-hero .rh-label{font-size:11px;font-weight:600;letter-spacing:2px;text-transform:uppercase;color:#aaa;margin-bottom:6px}
.receipt-hero .rh-amount{font-size:42px;font-weight:900;letter-spacing:-2px;line-height:1}
.receipt-hero .rh-sub{font-size:12px;color:#aaa;margin-top:8px}
.receipt-hero .rh-balance{font-size:13px;color:#fde68a;font-weight:700;margin-top:10px;padding-top:8px;border-top:1px solid rgba(255,255,255,0.2)}
.notes-box{background:#f8f8f8;border-radius:8px;padding:12px 16px;margin-bottom:20px;font-size:12px;color:#555;line-height:1.6}
.notes-box strong{color:#1a1a1a;font-size:10px;letter-spacing:1px;text-transform:uppercase;display:block;margin-bottom:5px}
.terms-box{border:1.5px solid #222;border-radius:6px;padding:12px 16px;margin:20px 0;background:#f9f9f9}
.terms-box p{font-size:11px;color:#222;line-height:1.7;margin-bottom:4px;font-weight:500}
.doc-footer{border-top:2px solid #1a1a1a;padding-top:14px;display:flex;justify-content:space-between;align-items:center}
.doc-footer-left{font-size:11px;color:#666}.doc-footer-right{font-size:12px;font-weight:700;color:#1a1a1a}
.catalog-intro{background:#1a1a1a;color:#fff;padding:20px 24px;border-radius:10px;margin-bottom:28px}
.catalog-intro h2{font-size:20px;font-weight:900;margin-bottom:4px}
.catalog-intro p{font-size:11px;color:#aaa;line-height:1.6}
.cat-section{margin-bottom:32px;break-inside:avoid}
.cat-heading{font-size:14px;font-weight:800;color:#1a1a1a;padding:8px 0;border-bottom:2px solid #1a1a1a;margin-bottom:14px}
.cat-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px}
.cat-item{border:1px solid #e5e5e5;border-radius:8px;overflow:hidden;break-inside:avoid}
.cat-item-photo{width:100%;height:120px;object-fit:cover;display:block}
.cat-item-photo-placeholder{width:100%;height:80px;background:#f0f0f0;display:flex;align-items:center;justify-content:center;color:#ccc;font-size:22px}
.cat-item-body{padding:10px 12px}
.cat-item-name{font-size:12px;font-weight:700;color:#1a1a1a;margin-bottom:2px}
.cat-item-desc{font-size:10px;color:#666;margin-bottom:6px;line-height:1.5}
.cat-item-footer{display:flex;justify-content:space-between;align-items:center}
.cat-item-price{font-size:13px;font-weight:800;color:#1a1a1a}
.cat-item-unit{font-size:10px;color:#999;background:#f0f0f0;padding:2px 6px;border-radius:10px}
.cat-tag{display:inline-block;font-size:9px;background:#1a1a1a;color:#fff;padding:1px 6px;border-radius:10px;margin-right:3px;margin-top:3px}
@media print{body{padding:20px}.no-print{display:none!important}.cat-section{page-break-inside:avoid}}
`;

function getBizHTML(biz, logo) {
  const logoSrc = logo?.src || LOGO_SRC;
  const img = `<img src="${logoSrc}" alt="logo"/>`;
  const sub = [
    biz.name,
    biz.tagline,
    biz.address,
    biz.city,
    biz.phone,
    biz.phone2,
    biz.email,
    biz.website,
  ]
    .filter(Boolean)
    .join("<br/>");
  const detail = [
    biz.tagline,
    biz.address,
    biz.city,
    biz.phone,
    biz.phone2,
    biz.email,
    biz.website,
    biz.rccm ? `RCCM: ${biz.rccm}` : "",
    biz.taxId ? `NIU: ${biz.taxId}` : "",
  ]
    .filter(Boolean)
    .join("<br/>");
  return { img, sub, detail };
}
function headerHTML(biz, logo, docType, docNum, dateIssued, dateDue) {
  const { img, detail } = getBizHTML(biz, logo);
  return `<div class="doc-header">
    <div class="biz-info">
      <div class="biz-name">${biz.name}</div>
      <div class="biz-detail">${detail}</div>
    </div>
    <div class="brand-block">${img}</div>
    <div class="doc-ref-block">
      <div class="doc-type">${docType}</div>
      <div class="doc-number">${docNum}</div>
      <div class="doc-meta">Issued: ${dateIssued}${dateDue ? `<br>Due: ${dateDue}` : ""}</div>
    </div>
  </div>`;
}
function partiesHTML(fl, fh, tl, th) {
  return `<div class="parties"><div class="party-box"><div class="party-label">${fl}</div>${fh}</div><div class="party-box"><div class="party-label">${tl}</div>${th}</div></div>`;
}
function footerHTML(biz) {
  return `<div class="doc-footer"><div class="doc-footer-left">${
    biz.footer || "Thank you for your business!"
  }</div><div class="doc-footer-right">${biz.name} — ${biz.city}</div></div>`;
}
function buildInvoiceHTML(inv, evt, biz, logo) {
  const bal = inv.total - inv.paid;
  const stClass =
    inv.paid >= inv.total ? "paid" : inv.paid > 0 ? "partial" : "unpaid";
  const stIcon = inv.paid >= inv.total ? "✅" : inv.paid > 0 ? "⏳" : "❌";
  const stText =
    inv.paid >= inv.total
      ? "Fully Paid"
      : inv.paid > 0
      ? "Partially Paid — balance outstanding"
      : "Unpaid — payment required";
  const lines = evt
    ? [
        {
          desc: `${evt.serviceStyle} Catering – ${evt.guests} guests × ${fmt(
            evt.pricePerHead
          )}/head`,
          total: evt.guests * evt.pricePerHead,
        },
        ...(evt.addOns > 0
          ? [{ desc: "Add-ons & extras", total: evt.addOns }]
          : []),
        ...(evt.discount > 0
          ? [
              {
                desc: "Discount applied",
                total: -evt.discount,
                cls: "discount",
              },
            ]
          : []),
      ]
    : [{ desc: "Services rendered", total: inv.total }];
  const rows = lines
    .map(
      (l, i) =>
        `<tr><td class="bold">${l.desc}</td><td class="tc">${
          i === 0 && evt ? evt.guests : 1
        }</td><td class="tr">${fmt(l.total)}</td><td class="tr ${
          l.cls || ""
        }">${fmt(l.total)}</td></tr>`
    )
    .join("");
  return `${headerHTML(
    biz,
    logo,
    "INVOICE",
    inv.num,
    inv.issued,
    inv.due
  )}${partiesHTML(
    "From",
    `<div class="party-name">${biz.name}</div><div class="party-detail">${[
      biz.address,
      biz.city,
      biz.phone,
      biz.email,
    ]
      .filter(Boolean)
      .join("<br/>")}</div>`,
    "Bill To",
    `<div class="party-name">${inv.client}</div><div class="party-detail">${
      inv.clientPhone || ""
    }${
      evt ? `<br>${evt.name}<br>${evt.eventDate} · ${evt.location}` : ""
    }</div>`
  )}<div class="status-banner ${stClass}"><div class="status-icon">${stIcon}</div><div class="status-text"><strong>${
    inv.status
  }</strong><span>${stText}</span></div></div><div class="items-section"><div class="section-heading">Line Items</div><table><thead><tr><th>Description</th><th class="tc">Qty</th><th class="tr">Unit Amount</th><th class="tr">Total (XAF)</th></tr></thead><tbody>${rows}</tbody></table></div><div class="totals-block"><div class="totals-inner"><div class="total-row"><span class="label">Invoice Total</span><span class="value">${fmt(
    inv.total
  )}</span></div><div class="total-row highlight"><span class="label">Amount Paid</span><span class="value">${fmt(
    inv.paid
  )}</span></div><div class="total-row grand" style="background:${bal>0?'#dc2626':'#16a34a'}"><span class="label" style="color:#fff!important;font-size:13px;font-weight:700">Balance Due</span><span class="value" style="color:#fff!important;font-size:16px;font-weight:900">${fmt(bal)}</span></div></div></div><div class="payment-box"><h4>Payment Information</h4><div class="payment-row"><span>Accepted methods:</span><strong>${
    biz.paymentTerms || "Cash · Mobile Money (MoMo) · Orange Money · Bank Transfer"
  }</strong></div><div class="payment-row"><span>Payment due:</span><strong>${
    inv.due
  }</strong></div>${
    biz.bankName
      ? `<div class="payment-row"><span>Bank:</span><strong>${biz.bankName} ${
          biz.bankAccount ? `· Acc: ${biz.bankAccount}` : ""
        }</strong></div>`
      : ""
  }${
    inv.notes
      ? `<div class="payment-row"><span>Notes:</span><strong>${inv.notes}</strong></div>`
      : ""
  }</div><div class="terms-box"><p><strong>Terms:</strong> Payment is due by the date indicated. All services are provided as per the event agreement.</p>${biz.paymentTerms ? `<div style="margin-top:6px"><strong style="font-size:11px;color:#222">Payment accepted via:</strong>${fmtPaymentTerms(biz.paymentTerms)}</div>` : ""}</div>${footerHTML(
    biz
  )}`;
}
function buildReceiptHTML(inv, biz, logo) {
  const rcn = inv.num.replace("INV", "RCT");
  const bal = inv.total - inv.paid;
  return `${headerHTML(
    biz,
    logo,
    "RECEIPT",
    rcn,
    TODAY_LABEL,
    null
  )}${partiesHTML(
    "From",
    `<div class="party-name">${biz.name}</div><div class="party-detail">${[
      biz.address,
      biz.city,
      biz.phone,
    ]
      .filter(Boolean)
      .join("<br/>")}</div>`,
    "Received From",
    `<div class="party-name">${inv.client}</div><div class="party-detail">${
      inv.clientPhone || ""
    }</div>`
  )}<div class="receipt-hero"><div class="rh-label">Payment Received</div><div class="rh-amount">${fmt(
    inv.paid
  )}</div><div class="rh-sub">Against invoice ${
    inv.num
  } · ${TODAY_LABEL}</div></div><div class="items-section"><div class="section-heading">Payment Breakdown</div><table><thead><tr><th>Description</th><th class="tr">Amount (XAF)</th></tr></thead><tbody><tr><td class="bold">Payment against ${
    inv.num
  }</td><td class="tr" style="color:#16a34a;font-size:14px;font-weight:800">${fmt(
    inv.paid
  )}</td></tr><tr><td>Invoice Total</td><td class="tr">${fmt(
    inv.total
  )}</td></tr><tr><td>Remaining Balance</td><td class="tr" style="color:${
    bal > 0 ? "#dc2626" : "#16a34a"
  };font-weight:700">${fmt(
    bal
  )}</td></tr></tbody></table></div><div class="payment-box"><h4>Payment Details</h4><div class="payment-row"><span>Status:</span><strong style="color:${
    inv.status === "Paid" ? "#16a34a" : "#b45309"
  }">${
    inv.status
  }</strong></div><div class="payment-row"><span>Reference Invoice:</span><strong>${
    inv.num
  }</strong></div>${
    inv.notes
      ? `<div class="payment-row"><span>Notes:</span><strong>${inv.notes}</strong></div>`
      : ""
  }</div><div class="notes-box"><strong>Important</strong>This receipt confirms payment received by ${
    biz.name
  }. Please retain for your records.</div>${footerHTML(biz)}`;
}
function buildProposalHTML(prop, biz, logo) {
  const sub = prop.lines.reduce((s, l) => s + l.qty * l.price, 0);
  const total = sub - (prop.discount || 0);
  const deposit = total * 0.5;
  // Check if any line has a photo
  const hasPhotos = prop.lines.some(l => l.photo);
  const rows = prop.lines
    .map(
      (l) =>
        `<tr>${hasPhotos ? `<td class="tc" style="width:54px;padding:4px">${l.photo ? `<img src="${l.photo}" alt="${l.name}" style="width:48px;height:42px;object-fit:cover;border-radius:5px;display:block"/>` : `<div style="width:48px;height:42px;background:#f5f5f5;border-radius:5px;display:flex;align-items:center;justify-content:center;font-size:18px">🍽️</div>`}</td>` : ""}<td class="bold" style="vertical-align:middle">${l.name}${l.description ? `<div style="font-size:10px;color:#777;font-weight:400;margin-top:2px">${l.description}</div>` : ""}</td><td class="tc" style="vertical-align:middle">${
          l.unitType
        }</td><td class="tc" style="vertical-align:middle">${l.qty}</td><td class="tr" style="vertical-align:middle">${fmt(
          l.price
        )}</td><td class="tr" style="vertical-align:middle">${fmt(l.qty * l.price)}</td></tr>`
    )
    .join("");
  const photoHeader = hasPhotos ? `<th class="tc" style="width:54px"></th>` : "";
  const effectivePaymentTerms = (prop.paymentTerms && prop.paymentTerms.trim())
    ? prop.paymentTerms.trim()
    : (biz.paymentTerms || "Cash · Mobile Money (MoMo) · Orange Money · Bank Transfer");
  return `${headerHTML(
    biz,
    logo,
    "PROPOSAL",
    prop.num,
    TODAY_LABEL,
    null
  )}${partiesHTML(
    "From",
    `<div class="party-name">${biz.name}</div><div class="party-detail">${[
      biz.address,
      biz.city,
      biz.phone,
      biz.email,
    ]
      .filter(Boolean)
      .join("<br/>")}</div>`,
    "Prepared For",
    `<div class="party-name">${prop.client}</div><div class="party-detail">${
      prop.clientPhone || ""
    }<br>${prop.eventType} · ${prop.plannedDate || "Date TBD"}<br>${
      prop.guests
    } guests · ${prop.location}</div>`
  )}<div class="items-section"><div class="section-heading">Proposed Services</div><table><thead><tr>${photoHeader}<th>Service / Item</th><th class="tc">Unit</th><th class="tc">Qty</th><th class="tr">Unit Price</th><th class="tr">Total (XAF)</th></tr></thead><tbody>${rows}</tbody></table></div><div class="totals-block"><div class="totals-inner"><div class="total-row"><span class="label">Subtotal</span><span class="value">${fmt(
    sub
  )}</span></div>${
    prop.discount > 0
      ? `<div class="total-row discount"><span class="label">Discount</span><span class="value">– ${fmt(
          prop.discount
        )}</span></div>`
      : ""
  }<div class="total-row grand"><span class="label">TOTAL</span><span class="value">${fmt(
    total
  )}</span></div></div></div><div class="payment-box"><h4>Payment Schedule</h4><div class="payment-row"><span>Deposit Required (50%):</span><strong>${fmt(
    deposit
  )}</strong></div><div class="payment-row"><span>Balance Due (before event):</span><strong>${fmt(
    total - deposit
  )}</strong></div><div class="payment-row"><span>Payment methods:</span><strong>${effectivePaymentTerms}</strong></div></div>${
    prop.notes
      ? `<div class="notes-box"><strong>Notes</strong>${prop.notes}</div>`
      : ""
  }<div class="terms-box">${(() => {
    const DEFAULT_CLAUSES = [
      { label: "Validity", text: "This proposal is valid for 14 days from the issue date." },
      { label: "Confirmation", text: "A signed acceptance and deposit confirms your booking." },
      { label: "Cancellation", text: "Deposits are non-refundable within 7 days of the event date." },
    ];
    const clauses = (prop.terms && prop.terms.length > 0) ? prop.terms : DEFAULT_CLAUSES;
    return clauses.map(c => `<p><strong>${c.label}:</strong> ${c.text}</p>`).join("");
  })()}</div>${footerHTML(
    biz
  )}`;
}
// ─── CATERING CONTRACT ────────────────────────────────────────────
function buildContractHTML(prop, biz, logo, lang = "en", terms = {}) {
  const EN = lang === "en";
  const sub     = prop.lines.reduce((s, l) => s + l.qty * l.price, 0);
  const total   = sub - (prop.discount || 0);
  const deposit = Math.round(total * 0.5);
  const balance = total - deposit;
  const today = new Date().toLocaleDateString(EN ? "en-GB" : "fr-FR", { day:"2-digit", month:"long", year:"numeric" });
  const eventDate = prop.plannedDate
    ? new Date(prop.plannedDate).toLocaleDateString(EN ? "en-GB" : "fr-FR", { day:"2-digit", month:"long", year:"numeric" })
    : (EN ? "Date TBD" : "Date à confirmer");

  const { img } = getBizHTML(biz, logo);

  const L = {
    title:      EN ? "CATERING SERVICES CONTRACT"         : "CONTRAT DE SERVICES TRAITEUR",
    contract:   EN ? "Contract"                            : "Contrat",
    ref:        EN ? "Ref. Proposal"                       : "Réf. Proposition",
    date:       EN ? "Date"                                : "Date",
    caterer:    EN ? "CATERER"                             : "PRESTATAIRE",
    client:     EN ? "CLIENT"                              : "CLIENT",
    services:   EN ? "SERVICES & SCOPE OF WORK"           : "PRESTATIONS & PÉRIMÈTRE",
    item:       EN ? "Description"                         : "Description",
    unit:       EN ? "Unit"                                : "Unité",
    qty:        EN ? "Qty"                                 : "Qté",
    price:      EN ? "Unit Price"                          : "Prix Unitaire",
    ttl:        EN ? "Total"                               : "Total",
    subtotal:   EN ? "Subtotal"                            : "Sous-total",
    discount:   EN ? "Discount"                            : "Remise",
    grandTotal: EN ? "CONTRACT TOTAL"                      : "TOTAL CONTRAT",
    payment:    EN ? "PAYMENT SCHEDULE"                    : "ÉCHÉANCIER DE PAIEMENT",
    deposit50:  EN ? "Deposit (50%) — due on signing"      : "Acompte (50 %) — dû à la signature",
    balance50:  EN ? "Balance — due before event"          : "Solde — dû avant l'événement",
    method:     EN ? "Accepted payment methods"            : "Modes de paiement acceptés",
    catObl:     EN ? "CATERER OBLIGATIONS"                 : "OBLIGATIONS DU PRESTATAIRE",
    cliObl:     EN ? "CLIENT OBLIGATIONS"                  : "OBLIGATIONS DU CLIENT",
    quality:    EN ? "QUALITY, COMPLAINTS & DISPUTE RESOLUTION" : "QUALITÉ, RÉCLAMATIONS & RÉSOLUTION DES LITIGES",
    media:      EN ? "MEDIA, PHOTOGRAPHY & REPUTATION"    : "MÉDIAS, PHOTOGRAPHIE & RÉPUTATION",
    canc:       EN ? "CANCELLATION & FORCE MAJEURE"        : "ANNULATION & FORCE MAJEURE",
    liab:       EN ? "LIABILITY & INDEMNIFICATION"         : "RESPONSABILITÉ & INDEMNISATION",
    conf:       EN ? "CONFIDENTIALITY"                     : "CONFIDENTIALITÉ",
    sign:       EN ? "SIGNATURES & ACCEPTANCE"             : "SIGNATURES & ACCEPTATION",
    signCat:    EN ? "For the Caterer"                     : "Pour le Prestataire",
    signCli:    EN ? "For the Client"                      : "Pour le Client",
    nameDate:   EN ? "Name & Date"                         : "Nom & Date",
    sigLine:    EN ? "Signature"                           : "Signature",
    agree:      EN ? "By signing below, both parties confirm they have read, understood, and agreed to all terms of this contract. This contract is legally binding upon signature."
                   : "En signant ci-dessous, les deux parties confirment avoir lu, compris et accepté l'ensemble des termes du présent contrat. Ce contrat est juridiquement contraignant à la signature.",
    footer:     EN ? `This contract is governed by the laws of Cameroon. Any unresolved dispute shall be referred to the competent courts of ${biz.city || "Douala"}, Cameroon. Each party acknowledges receipt of a signed copy.`
                   : `Le présent contrat est régi par le droit camerounais. Tout litige non résolu à l'amiable sera porté devant les juridictions compétentes de ${biz.city || "Douala"}, Cameroun. Chaque partie reconnaît avoir reçu un exemplaire signé.`,
  };

  const defCatObl = EN ? [
    `1. Deliver all catering services described in Proposal ${prop.num} with professionalism, punctuality, and in full accordance with the agreed scope.`,
    `2. Supply all food, beverages, equipment, serving materials, and qualified staff necessary to execute the event.`,
    `3. Prepare and handle all food in strict compliance with Cameroonian food safety and hygiene standards. All staff handling food will have valid health certificates where required by law.`,
    `4. Arrive at the agreed venue no later than 1 (one) hour before the scheduled service start time to complete setup.`,
    `5. Ensure that all dishes are prepared and presented in accordance with the agreed menu and the quantities specified in this contract.`,
    `6. Notify the client immediately of any supply shortfall, ingredient substitution, or operational difficulty that may materially affect the agreed menu, and propose an equivalent alternative at no additional cost.`,
    `7. Maintain a clean and orderly working area throughout the event and remove all equipment, waste, and catering materials at the conclusion of service, leaving the venue in the condition in which it was received.`,
    `8. Assign a designated catering manager or point of contact who will be present on-site for the duration of the event and reachable by the client at all times.`,
  ].join("\n") : [
    `1. Exécuter l'ensemble des prestations décrites dans la Proposition ${prop.num} avec professionnalisme, ponctualité et dans le strict respect du périmètre convenu.`,
    `2. Fournir toute la nourriture, les boissons, le matériel de service et le personnel qualifié nécessaires à la réalisation de l'événement.`,
    `3. Préparer et manipuler les aliments dans le strict respect des normes camerounaises d'hygiène alimentaire. Le personnel manipulant les aliments disposera des certificats de santé requis par la loi.`,
    `4. Arriver sur le lieu convenu au plus tard 1 (une) heure avant l'heure de début du service pour l'installation.`,
    `5. Veiller à ce que tous les plats soient préparés et présentés conformément au menu convenu et aux quantités spécifiées dans le présent contrat.`,
    `6. Informer immédiatement le client de toute rupture d'approvisionnement, substitution d'ingrédient ou difficulté opérationnelle susceptible d'affecter le menu convenu, et proposer une alternative équivalente sans surcoût.`,
    `7. Maintenir un espace de travail propre et ordonné tout au long de l'événement et retirer le matériel, les déchets et les fournitures à la fin du service.`,
    `8. Désigner un responsable traiteur ou un interlocuteur unique présent sur place pendant toute la durée de l'événement et joignable par le client à tout moment.`,
  ].join("\n");

  const defCliObl = EN ? [
    `1. Pay the deposit of ${fmt(deposit)} XAF within 48 (forty-eight) hours of signing this contract to secure the booking. Failure to pay within this period may result in cancellation of this contract at the caterer's discretion.`,
    `2. Pay the remaining balance of ${fmt(balance)} XAF no later than 48 (forty-eight) hours before the scheduled event date.`,
    `3. Confirm the final guest count and any dietary requirements or food allergies to the caterer no later than 5 (five) business days before the event. The caterer cannot be held liable for allergy incidents that were not disclosed in advance.`,
    `4. Ensure that the caterer has unrestricted access to the venue, including adequate working space, running water, reliable electricity supply, and a designated food preparation area, from the time of arrival.`,
    `5. Notify the caterer immediately of any changes to the event date, guest count, venue, or service scope. Changes made fewer than 5 days before the event are subject to additional charges and must be agreed in writing.`,
    `6. Ensure that the environment at the venue is safe, orderly, and conducive to professional service. The client is responsible for the conduct of their guests and any damage caused by guests to the caterer's equipment or property.`,
    `7. Refrain from engaging, hiring, or permitting any other food vendor, caterer, or kitchen operation at the venue during the agreed service period without the prior written consent of the caterer.`,
    `8. Settle any outstanding balance or additional charges agreed during the event before the caterer's team departs the venue.`,
  ].join("\n") : [
    `1. Verser l'acompte de ${fmt(deposit)} FCFA dans les 48 (quarante-huit) heures suivant la signature du présent contrat pour confirmer la réservation. Le non-paiement dans ce délai pourra entraîner l'annulation du contrat à la discrétion du prestataire.`,
    `2. Régler le solde de ${fmt(balance)} FCFA au plus tard 48 (quarante-huit) heures avant la date de l'événement.`,
    `3. Confirmer l'effectif final des convives et tout régime alimentaire ou allergie au prestataire au plus tard 5 (cinq) jours ouvrés avant l'événement. Le prestataire ne peut être tenu responsable d'incidents liés à des allergies non déclarées à l'avance.`,
    `4. Garantir l'accès sans restriction au lieu, incluant un espace de travail adéquat, l'eau courante, l'électricité et une zone de préparation des aliments, dès l'arrivée du prestataire.`,
    `5. Informer immédiatement le prestataire de tout changement de date, d'effectif, de lieu ou de périmètre. Les modifications effectuées moins de 5 jours avant l'événement sont susceptibles d'entraîner des frais supplémentaires et doivent être acceptées par écrit.`,
    `6. S'assurer que l'environnement sur le lieu est sûr, calme et propice à un service professionnel. Le client est responsable du comportement de ses invités et de tout dommage causé par ceux-ci au matériel ou aux biens du prestataire.`,
    `7. S'abstenir de faire appel à tout autre fournisseur de restauration ou opération culinaire sur le lieu pendant la période de service convenue, sans l'accord écrit préalable du prestataire.`,
    `8. Régler tout solde ou frais supplémentaires convenus pendant l'événement avant le départ de l'équipe du prestataire.`,
  ].join("\n");

  const defQuality = EN
    ? `Feedback & Complaints: Any complaint regarding the quality, quantity, or delivery of catering services must be raised verbally with the on-site catering manager during the event, and confirmed in writing (by SMS, WhatsApp, or email) within 24 (twenty-four) hours of the event's conclusion. Complaints raised after this window will not be considered valid grounds for a refund or dispute claim.\n\nDispute Resolution: The parties agree to first attempt resolution through good-faith negotiation within 7 (seven) days of a written complaint. If no agreement is reached, the matter shall be referred to a mutually agreed mediator, or failing that, to the competent courts of ${biz.city || "Douala"}.\n\nRefund Policy: Partial or full refunds are only considered where the caterer fails to deliver services as described in this contract and where the complaint was submitted within the 24-hour window above. No refund shall be issued for subjective dissatisfaction with taste, presentation preferences, or events where services were substantially delivered.`
    : `Retours & Réclamations : Toute réclamation relative à la qualité, la quantité ou l'exécution des prestations doit être soulevée verbalement auprès du responsable traiteur présent sur place pendant l'événement, puis confirmée par écrit (SMS, WhatsApp ou e-mail) dans les 24 (vingt-quatre) heures suivant la fin de l'événement. Les réclamations formulées après ce délai ne seront pas considérées comme motifs valables de remboursement ou de litige.\n\nRésolution des litiges : Les parties conviennent de tenter en premier lieu un règlement amiable de bonne foi dans les 7 (sept) jours suivant une réclamation écrite. À défaut d'accord, l'affaire sera soumise à un médiateur désigné d'un commun accord ou, à défaut, aux juridictions compétentes de ${biz.city || "Douala"}.\n\nPolitique de remboursement : Un remboursement partiel ou total n'est envisageable que si le prestataire n'a pas fourni les prestations décrites dans le présent contrat et si la réclamation a été déposée dans le délai de 24 heures susmentionné. Aucun remboursement ne sera accordé pour une insatisfaction subjective relative au goût, aux préférences de présentation, ou lorsque les prestations ont été substantiellement fournies.`;

  const defMedia = EN
    ? `Photography & Videography: The client acknowledges that ${biz.name} may photograph or video-record its food, presentation, and services for internal documentation, portfolio, and marketing purposes. The caterer will not publish images identifying the client or their guests without prior written consent.\n\nClient Photography: The client and their guests are welcome to photograph and share images of the food and services provided. However, any public posting must be accurate and fair. The client agrees not to use selectively edited, misleadingly cropped, or deliberately unflattering images to misrepresent the quality or nature of the services provided.\n\nOnline Reviews & Social Media: The client is free to share honest, factual, and balanced feedback in any public forum. However, the client expressly agrees not to post false, misleading, defamatory, or malicious statements about ${biz.name}, its staff, food, or services on any platform including but not limited to Facebook, Instagram, TikTok, Google, WhatsApp groups, or any other digital medium. Any public statement must be based on personal, first-hand experience and not exaggerated, fabricated, or intended to harm the business's reputation.\n\nDefamation & Reputation Damages: The client acknowledges that ${biz.name}'s reputation is a core business asset. Any false, defamatory, or malicious online statement found to be in breach of this clause may be subject to legal action for damages in accordance with Cameroonian law and applicable cyber regulations. The caterer reserves the right to respond publicly to any inaccurate review in a professional manner.`
    : `Photographie & Vidéographie : Le client reconnaît que ${biz.name} peut photographier ou filmer ses plats, présentations et prestations à des fins de documentation interne, de portfolio et de marketing. Le prestataire ne publiera pas d'images identifiant le client ou ses invités sans consentement écrit préalable.\n\nPhotographie par le client : Le client et ses invités sont libres de photographier et de partager des images des plats et prestations fournis. Toutefois, toute publication publique doit être exacte et équitable. Le client s'engage à ne pas utiliser d'images sélectivement modifiées, recadrées de manière trompeuse ou délibérément dévalorisantes pour dénaturer la qualité ou la nature des prestations fournies.\n\nAvis en ligne & Réseaux sociaux : Le client est libre de partager des commentaires honnêtes, factuels et équilibrés sur tout forum public. Cependant, le client s'engage expressément à ne pas publier de déclarations fausses, trompeuses, diffamatoires ou malveillantes concernant ${biz.name}, son personnel, ses plats ou ses prestations sur toute plateforme incluant, sans s'y limiter, Facebook, Instagram, TikTok, Google, les groupes WhatsApp ou tout autre média numérique. Toute déclaration publique doit être fondée sur une expérience personnelle et directe, sans exagération, fabrication ni intention de nuire à la réputation de l'entreprise.\n\nDiffamation & Dommages réputationnels : Le client reconnaît que la réputation de ${biz.name} constitue un actif commercial essentiel. Toute déclaration en ligne fausse, diffamatoire ou malveillante jugée contraire à la présente clause pourra faire l'objet de poursuites judiciaires en dommages et intérêts conformément au droit camerounais et aux réglementations numériques applicables. Le prestataire se réserve le droit de répondre publiquement à tout avis inexact de manière professionnelle.`;

  const defCanc = EN
    ? `Cancellation by the Client:\n— More than 14 days before the event: deposit refunded in full.\n— Between 7 and 14 days before: 50% of the deposit is retained to cover preparation costs already incurred.\n— Less than 7 days before the event: the full deposit is forfeited. If supplies, staffing, or preparation for the event has already commenced, the client may also be liable for additional costs up to the full contract value.\n\nCancellation by the Caterer: If the caterer cancels due to circumstances within their control, the full deposit will be refunded within 5 business days. The caterer's liability is limited to this refund and does not extend to consequential losses.\n\nEvent Postponement: The client may request a one-time postponement (subject to the caterer's availability) with at least 7 days' notice at no additional charge. The deposit will be transferred to the new date. A second postponement or a change of date with less than 7 days' notice will be treated as a cancellation.\n\nForce Majeure: Neither party shall be in breach of this contract for any failure or delay caused by circumstances beyond their reasonable control, including but not limited to natural disasters, government-imposed restrictions, national mourning, civil unrest, or power grid failure. In such cases, the deposit shall be applied to a mutually agreed rescheduled date within 12 months.`
    : `Annulation par le client :\n— Plus de 14 jours avant l'événement : acompte intégralement remboursé.\n— Entre 7 et 14 jours avant : 50 % de l'acompte est retenu pour couvrir les coûts de préparation déjà engagés.\n— Moins de 7 jours avant l'événement : l'acompte est intégralement acquis au prestataire. Si les approvisionnements, le personnel ou la préparation ont déjà commencé, le client peut également être redevable de frais supplémentaires pouvant atteindre le montant total du contrat.\n\nAnnulation par le prestataire : Si le prestataire annule pour des raisons relevant de sa responsabilité, l'acompte intégral sera remboursé dans les 5 jours ouvrés. La responsabilité du prestataire se limite à ce remboursement et ne s'étend pas aux pertes consécutives.\n\nReport d'événement : Le client peut demander un report unique (sous réserve de la disponibilité du prestataire) avec un préavis d'au moins 7 jours, sans frais supplémentaires. L'acompte sera reporté à la nouvelle date. Un deuxième report ou un changement de date avec moins de 7 jours de préavis sera traité comme une annulation.\n\nForce majeure : Aucune des parties ne sera en violation du présent contrat pour tout manquement ou retard causé par des circonstances indépendantes de leur volonté raisonnable, incluant notamment les catastrophes naturelles, les restrictions gouvernementales, le deuil national, les troubles civils ou les pannes du réseau électrique. Dans ces cas, l'acompte sera appliqué à une nouvelle date convenue d'un commun accord dans les 12 mois.`;

  const defLiab = EN
    ? `Scope of Liability: The caterer's total liability under this contract is limited to the total value of this contract (${fmt(total)} XAF). Under no circumstances shall the caterer be liable for indirect, incidental, consequential, or punitive damages including but not limited to lost profits, reputational harm to the client, or costs arising from third-party claims.\n\nFood Allergies & Dietary Requirements: The caterer will exercise all reasonable professional care in the preparation of food. However, the caterer cannot guarantee the complete absence of allergens in any dish unless a specific allergen-free menu is agreed in writing and expressly included in this contract. The client assumes full responsibility for communicating known allergies of all guests and for the consumption choices made by guests at the event.\n\nEquipment & Property: The caterer is responsible for its own equipment brought to the venue. The client is responsible for any loss or damage to the caterer's equipment caused by the client's guests or by conditions at the venue that were not disclosed in advance.\n\nIndemnification: The client agrees to indemnify and hold harmless ${biz.name}, its owners, staff, and agents from any claim, demand, lawsuit, or liability arising from: (a) the client's breach of any obligation in this contract; (b) undisclosed food allergies or dietary conditions of guests; (c) actions or conduct of the client's guests; or (d) any false, defamatory, or misleading statement made by the client or their associates about ${biz.name} in any public or private forum.`
    : `Étendue de la responsabilité : La responsabilité totale du prestataire dans le cadre du présent contrat est limitée à la valeur totale du contrat (${fmt(total)} FCFA). En aucun cas le prestataire ne sera responsable des dommages indirects, accessoires, consécutifs ou punitifs, incluant notamment la perte de bénéfices, le préjudice réputationnel du client, ou les coûts découlant de réclamations de tiers.\n\nAllergies alimentaires & régimes spéciaux : Le prestataire apportera tout le soin professionnel raisonnable à la préparation des aliments. Toutefois, le prestataire ne peut garantir l'absence totale d'allergènes dans un plat à moins qu'un menu sans allergènes spécifique ne soit convenu par écrit et expressément inclus dans le présent contrat. Le client assume l'entière responsabilité de la communication des allergies connues de tous les convives et des choix de consommation effectués par ceux-ci lors de l'événement.\n\nMatériel & Propriété : Le prestataire est responsable de son propre matériel apporté sur le lieu. Le client est responsable de toute perte ou détérioration du matériel du prestataire causée par les invités du client ou par des conditions sur le lieu qui n'auraient pas été divulguées à l'avance.\n\nIndemnisation : Le client s'engage à indemniser et à dégager de toute responsabilité ${biz.name}, ses propriétaires, employés et mandataires contre toute réclamation, demande, poursuite ou responsabilité découlant de : (a) la violation par le client d'une obligation du présent contrat ; (b) les allergies alimentaires ou régimes non divulgués des convives ; (c) les actes ou comportements des invités du client ; ou (d) toute déclaration fausse, diffamatoire ou trompeuse faite par le client ou ses associés concernant ${biz.name} dans tout forum public ou privé.`;

  const defConf = EN
    ? `Both parties agree to keep confidential all pricing, menu details, business terms, and any proprietary information disclosed during the course of this engagement. The client agrees not to share the pricing or commercial terms of this contract with any third party who could use such information to damage the caterer's commercial interests. This confidentiality obligation survives the termination or completion of this contract.`
    : `Les deux parties s'engagent à garder confidentiels tous les tarifs, détails du menu, conditions commerciales et toute information exclusive divulguée au cours de cette mission. Le client s'engage à ne pas communiquer les tarifs ou conditions commerciales du présent contrat à un tiers susceptible d'utiliser ces informations pour nuire aux intérêts commerciaux du prestataire. Cette obligation de confidentialité survit à la résiliation ou à l'achèvement du présent contrat.`;

  const catObl  = terms.catObl   || defCatObl;
  const cliObl  = terms.cliObl   || defCliObl;
  const qualTxt = terms.quality  || defQuality;
  const mediaTxt= terms.media    || defMedia;
  const cancTxt = terms.canc     || defCanc;
  const liabTxt = terms.liab     || defLiab;
  const confTxt = terms.conf     || defConf;

  const effectivePmt = (prop.paymentTerms && prop.paymentTerms.trim())
    ? prop.paymentTerms.trim()
    : (biz.paymentTerms || (EN ? "Cash · Mobile Money (MoMo) · Orange Money · Bank Transfer" : "Espèces · Mobile Money · Orange Money · Virement bancaire"));

  const rows = prop.lines.map(l =>
    `<tr><td>${l.name}${l.description ? `<div style="font-size:10px;color:#777">${l.description}</div>` : ""}</td><td style="text-align:center">${l.unitType}</td><td style="text-align:center">${l.qty}</td><td style="text-align:right">${fmt(l.price)}</td><td style="text-align:right;font-weight:600">${fmt(l.qty*l.price)}</td></tr>`
  ).join("");

  const oblText  = (txt) => txt.split("\n").map(line => line.trim() ? `<p style="margin:0 0 6px;line-height:1.6">${line}</p>` : `<p style="margin:0 0 4px">&nbsp;</p>`).join("");
  const paraText = (txt) => txt.split("\n").map(line => line.trim() ? `<p style="margin:0 0 8px;line-height:1.65">${line}</p>` : `<p style="margin:0 0 4px">&nbsp;</p>`).join("");

  return `<!DOCTYPE html><html><head><meta charset="utf-8"/>
<style>
${PRINT_CSS}
body{padding:28px 38px;font-size:12px}
.section{margin-bottom:16px}
.section-title{font-size:9px;font-weight:800;letter-spacing:2px;text-transform:uppercase;color:#777;border-bottom:1.5px solid #e5e5e5;padding-bottom:4px;margin-bottom:9px}
table.scope{width:100%;border-collapse:collapse;font-size:11.5px}
table.scope th{background:#f3f3f3;padding:5px 7px;text-align:left;font-size:9px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#555}
table.scope td{padding:5px 7px;border-bottom:1px solid #f0f0f0;vertical-align:top}
.total-band{background:#1a1a1a;color:#fff;padding:7px 11px;border-radius:6px;display:flex;justify-content:space-between;align-items:center;margin-top:7px}
.total-band span{font-size:9px;letter-spacing:1px;text-transform:uppercase;color:#fff}
.total-band strong{font-size:15px;font-weight:900;color:#fff}
.pmt-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:7px;margin-top:7px}
.pmt-cell{background:#f8f8f8;border-radius:5px;padding:8px 10px}
.pmt-cell .lbl{font-size:9px;color:#888;text-transform:uppercase;letter-spacing:1px;margin-bottom:3px}
.pmt-cell .val{font-size:12px;font-weight:700;color:#1a1a1a}
.obl-box{background:#f9f9f9;border-left:3px solid #e8c547;border-radius:0 5px 5px 0;padding:9px 12px;font-size:11.5px;line-height:1.6;color:#333}
.clause-box{font-size:11.5px;line-height:1.65;color:#444;background:#fafafa;border-radius:5px;padding:9px 12px}
.alert-box{background:#fff8e1;border-left:3px solid #f59e0b;border-radius:0 5px 5px 0;padding:9px 12px;font-size:11.5px;line-height:1.65;color:#444}
.sign-grid{display:grid;grid-template-columns:1fr 1fr;gap:28px;margin-top:6px}
.sign-box{border-top:1.5px solid #1a1a1a;padding-top:7px}
.sign-label{font-size:9px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#888;margin-bottom:2px}
.sign-name{font-size:12px;font-weight:600;color:#1a1a1a;margin-bottom:14px}
.sign-line{border-bottom:1px dashed #bbb;height:26px;margin-bottom:4px}
.sign-meta{font-size:9px;color:#aaa}
.agree-txt{font-size:11px;color:#555;font-style:italic;margin-bottom:12px}
.page-note{font-size:9px;color:#aaa;text-align:center;margin-top:6px}
@media print{body{padding:20px 28px}.no-print{display:none!important}@page{margin:8mm 10mm;size:A4}}
</style></head><body>

<div class="doc-header">
  <div class="biz-info">
    <div class="biz-name">${biz.name}</div>
    <div class="biz-detail">${[biz.tagline,biz.address,biz.city,biz.phone,biz.email,biz.rccm?`RCCM: ${biz.rccm}`:"",biz.taxId?`Tax ID: ${biz.taxId}`:""].filter(Boolean).join("<br/>")}</div>
  </div>
  <div class="brand-block">${img}</div>
  <div class="doc-ref-block">
    <div class="doc-type">${L.title}</div>
    <div class="doc-number" style="font-size:19px">${L.contract} #${prop.num.replace("PROP","CTR")}</div>
    <div class="doc-meta">${L.ref}: ${prop.num}<br>${L.date}: ${today}</div>
  </div>
</div>

<div class="parties">
  <div class="party-box">
    <div class="party-label">${L.caterer}</div>
    <div class="party-name">${biz.name}</div>
    <div class="party-detail">${[biz.address, biz.city, biz.phone, biz.email, biz.rccm ? `RCCM: ${biz.rccm}` : "", biz.taxId ? `Tax ID: ${biz.taxId}` : ""].filter(Boolean).join("<br/>")}</div>
  </div>
  <div class="party-box">
    <div class="party-label">${L.client}</div>
    <div class="party-name">${prop.client}</div>
    <div class="party-detail">${[prop.clientPhone, prop.eventType ? `${prop.eventType} · ${eventDate}` : eventDate, prop.guests ? `${prop.guests} ${EN?"guests":"convives"}` : "", prop.location].filter(Boolean).join("<br/>")}</div>
  </div>
</div>

<div class="section">
  <div class="section-title">${L.services}</div>
  <table class="scope">
    <thead><tr><th>${L.item}</th><th style="text-align:center;width:75px">${L.unit}</th><th style="text-align:center;width:38px">${L.qty}</th><th style="text-align:right;width:85px">${L.price} (XAF)</th><th style="text-align:right;width:85px">${L.ttl} (XAF)</th></tr></thead>
    <tbody>${rows}</tbody>
  </table>
  <div style="display:flex;justify-content:flex-end;margin-top:4px;gap:36px;font-size:11px;color:#555">
    <span>${L.subtotal}: <strong style="color:#1a1a1a">${fmt(sub)} XAF</strong></span>
    ${prop.discount > 0 ? `<span>${L.discount}: <strong style="color:#c53030">– ${fmt(prop.discount)} XAF</strong></span>` : ""}
  </div>
  <div class="total-band"><span>${L.grandTotal}</span><strong>${fmt(total)} XAF</strong></div>
</div>

<div class="section">
  <div class="section-title">${L.payment}</div>
  <div class="pmt-grid">
    <div class="pmt-cell"><div class="lbl">${L.deposit50}</div><div class="val">${fmt(deposit)} XAF</div></div>
    <div class="pmt-cell"><div class="lbl">${L.balance50}</div><div class="val">${fmt(balance)} XAF</div></div>
    <div class="pmt-cell"><div class="lbl">${L.method}</div><div class="val" style="font-size:10px;line-height:1.4">${effectivePmt}</div></div>
  </div>
</div>

<div class="section">
  <div class="section-title">${L.catObl}</div>
  <div class="obl-box">${oblText(catObl)}</div>
</div>

<div class="section">
  <div class="section-title">${L.cliObl}</div>
  <div class="obl-box" style="border-color:#4a90d9">${oblText(cliObl)}</div>
</div>

<div class="section">
  <div class="section-title">${L.quality}</div>
  <div class="clause-box">${paraText(qualTxt)}</div>
</div>

<div class="section">
  <div class="section-title">${L.media}</div>
  <div class="alert-box">${paraText(mediaTxt)}</div>
</div>

<div class="section">
  <div class="section-title">${L.canc}</div>
  <div class="clause-box">${paraText(cancTxt)}</div>
</div>

<div class="section">
  <div class="section-title">${L.liab}</div>
  <div class="clause-box">${paraText(liabTxt)}</div>
</div>

<div class="section">
  <div class="section-title">${L.conf}</div>
  <div class="clause-box" style="font-size:11px;color:#555">${paraText(confTxt)}</div>
</div>

<div class="section" style="margin-bottom:18px">
  <div class="clause-box" style="font-size:10.5px;color:#666;background:#f4f4f4">${L.footer}</div>
</div>

<div class="section">
  <div class="section-title">${L.sign}</div>
  <p class="agree-txt">${L.agree}</p>
  <div class="sign-grid">
    <div class="sign-box">
      <div class="sign-label">${L.signCat}</div>
      <div class="sign-name">${biz.name}</div>
      <div class="sign-line"></div>
      <div class="sign-meta">${L.sigLine} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ${L.nameDate}</div>
    </div>
    <div class="sign-box">
      <div class="sign-label">${L.signCli}</div>
      <div class="sign-name">${prop.client}</div>
      <div class="sign-line"></div>
      <div class="sign-meta">${L.sigLine} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ${L.nameDate}</div>
    </div>
  </div>
</div>

${footerHTML(biz)}
</body></html>`;
}

function buildOrderReceiptHTML(sale, biz, logo) {
  const total = orderTotal(sale);
  const paid = sale.partialPaid !== "" && sale.partialPaid != null ? Number(sale.partialPaid) : total;
  const balance = total - paid;
  const isPartial = balance > 0;
  const rcn = `RCT-${new Date(sale.date).getFullYear()}-${String(sale.saleIndex ?? sale.id).padStart(4, "0")}`;
  const clientName = sale.clientName || (sale.type === "Delivery" ? "Delivery Customer" : "Walk-in Customer");
  const clientDetail = [
    sale.clientPhone,
    sale.type === "Delivery" && sale.deliveryAddress ? `📍 ${sale.deliveryAddress}` : null,
    sale.type,
  ].filter(Boolean).join("<br/>");
  const statusLabel = isPartial ? "Partial Payment" : "Payment Received";
  const amountLabel = isPartial ? "Amount Paid" : "Payment Received";
  return `${headerHTML(
    biz, logo, "RECEIPT", rcn, sale.date, null
  )}${partiesHTML(
    "From",
    `<div class="party-name">${biz.name}</div><div class="party-detail">${[biz.address, biz.city, biz.phone, biz.email, biz.rccm ? `RCCM: ${biz.rccm}` : "", biz.taxId ? `NIU: ${biz.taxId}` : ""].filter(Boolean).join("<br/>")}</div>`,
    "Customer",
    `<div class="party-name">${clientName}</div><div class="party-detail">${clientDetail}</div>`
  )}<div class="receipt-hero ${isPartial ? "partial" : ""}"><div class="rh-label">${statusLabel}</div><div class="rh-amount">${fmt(paid)}</div><div class="rh-sub">${sale.method} · ${sale.date}</div>${isPartial ? `<div class="rh-balance">Balance Outstanding: ${fmt(balance)}</div>` : ""}</div><div class="items-section"><div class="section-heading">Order Details</div><table><thead><tr><th>Item</th><th class="tc">Qty</th><th class="tr">Unit Price</th><th class="tr">Amount (XAF)</th></tr></thead><tbody>${
    (sale.items && sale.items.length > 0 ? sale.items : [{ meal: sale.meal, plates: sale.plates, pricePerPlate: sale.pricePerPlate }])
      .map(it => `<tr><td class="bold">${it.meal}</td><td class="tc">${it.plates} plate${it.plates > 1 ? "s" : ""}</td><td class="tr">${fmt(it.pricePerPlate)}</td><td class="tr">${fmt(Number(it.plates) * Number(it.pricePerPlate))}</td></tr>`)
      .join("")
  }${
    sale.deliveryFee > 0
      ? `<tr><td>Delivery Fee</td><td class="tc">—</td><td class="tr">${fmt(sale.deliveryFee)}</td><td class="tr">${fmt(sale.deliveryFee)}</td></tr>`
      : ""
  }</tbody></table></div><div class="totals-block"><div class="totals-inner"><div class="total-row"><span class="label">Order Total</span><span class="value">${fmt(total)}</span></div><div class="total-row highlight"><span class="label">${amountLabel}</span><span class="value">${fmt(paid)}</span></div>${isPartial ? `<div class="total-row"><span class="label" style="color:#dc2626">Balance Due</span><span class="value" style="color:#dc2626;font-weight:800">${fmt(balance)}</span></div>` : `<div class="total-row grand"><span class="label">TOTAL PAID</span><span class="value">${fmt(paid)}</span></div>`}</div></div>${sale.notes ? `<div class="notes-box"><strong>Order Notes:</strong> ${sale.notes}</div>` : ""}<div class="notes-box"><strong>${isPartial ? "Partial payment received. Please settle the remaining balance." : "Thank you!"}</strong>${isPartial ? "" : " We appreciate your order. Come back soon!"}</div>${biz.paymentTerms ? `<div class="terms-box"><p><strong>Payment accepted via:</strong> ${biz.paymentTerms.replace(/\n/g, "<br>")}</p></div>` : ""}${footerHTML(biz)}`;
}

function buildOrderInvoiceHTML(sale, biz, logo) {
  const total = orderTotal(sale);
  const paid = sale.partialPaid !== "" && sale.partialPaid != null ? Number(sale.partialPaid) : total;
  const balance = total - paid;
  const isPartial = balance > 0;
  const isUnpaid = paid === 0;
  const invNum = `INV-${new Date(sale.date).getFullYear()}-${String(sale.saleIndex ?? sale.id).padStart(4, "0")}`;
  const clientName = sale.clientName || (sale.type === "Delivery" ? "Delivery Customer" : "Walk-in Customer");
  const clientDetail = [
    sale.clientPhone,
    sale.type === "Delivery" && sale.deliveryAddress ? `📍 ${sale.deliveryAddress}` : null,
    sale.type + " Order",
  ].filter(Boolean).join("<br/>");
  const rows = [
    ...(sale.items && sale.items.length > 0 ? sale.items : [{ meal: sale.meal, plates: sale.plates, pricePerPlate: sale.pricePerPlate }])
      .map(it => `<tr><td class="bold">${it.meal}</td><td class="tc">${it.plates} plate${Number(it.plates) > 1 ? "s" : ""}</td><td class="tr">${fmt(it.pricePerPlate)}</td><td class="tr">${fmt(Number(it.plates) * Number(it.pricePerPlate))}</td></tr>`),
    sale.deliveryFee > 0
      ? `<tr><td>Delivery Fee</td><td class="tc">—</td><td class="tr">${fmt(sale.deliveryFee)}</td><td class="tr">${fmt(sale.deliveryFee)}</td></tr>`
      : "",
  ].join("");

  let statusBanner;
  if (isUnpaid) {
    statusBanner = `<div class="status-banner unpaid"><div class="status-icon">❌</div><div class="status-text"><strong>Unpaid</strong><span>No payment recorded yet</span></div></div>`;
  } else if (isPartial) {
    statusBanner = `<div class="status-banner partial"><div class="status-icon">⏳</div><div class="status-text"><strong>Partially Paid</strong><span>Payment of ${fmt(paid)} received via ${sale.method} on ${sale.date} — Balance: ${fmt(balance)}</span></div></div>`;
  } else {
    statusBanner = `<div class="status-banner paid"><div class="status-icon">✅</div><div class="status-text"><strong>Paid</strong><span>Payment received via ${sale.method} on ${sale.date}</span></div></div>`;
  }

  return `${headerHTML(biz, logo, "INVOICE", invNum, sale.date, sale.date)}${partiesHTML(
    "From",
    `<div class="party-name">${biz.name}</div><div class="party-detail">${[biz.address, biz.city, biz.phone, biz.email].filter(Boolean).join("<br/>")}</div>`,
    "Bill To",
    `<div class="party-name">${clientName}</div><div class="party-detail">${clientDetail}</div>`
  )}${statusBanner}<div class="items-section"><div class="section-heading">Order Line Items</div><table><thead><tr><th>Description</th><th class="tc">Qty</th><th class="tr">Unit Price</th><th class="tr">Total (XAF)</th></tr></thead><tbody>${rows}</tbody></table></div><div class="totals-block"><div class="totals-inner"><div class="total-row"><span class="label">Subtotal</span><span class="value">${fmt(sale.plates * sale.pricePerPlate)}</span></div>${sale.deliveryFee > 0 ? `<div class="total-row"><span class="label">Delivery Fee</span><span class="value">${fmt(sale.deliveryFee)}</span></div>` : ""}<div class="total-row grand"><span class="label">ORDER TOTAL</span><span class="value">${fmt(total)}</span></div><div class="total-row highlight"><span class="label">Amount Paid</span><span class="value">${fmt(paid)}</span></div><div class="total-row"><span class="label" style="${balance>0?'color:#dc2626':'color:#16a34a'}">Balance Due</span><span class="value" style="${balance>0?'color:#dc2626;font-weight:800':'color:#16a34a;font-weight:800'}">${fmt(balance)}</span></div></div></div><div class="payment-box"><h4>Payment Information</h4><div class="payment-row"><span>Method:</span><strong>${sale.method}</strong></div><div class="payment-row"><span>Date:</span><strong>${sale.date}</strong></div><div class="payment-row"><span>Order type:</span><strong>${sale.type}</strong></div>${sale.notes ? `<div class="payment-row"><span>Notes:</span><strong>${sale.notes}</strong></div>` : ""}</div><div class="terms-box">${balance > 0 ? `<p>A balance of <strong>${fmt(balance)}</strong> remains outstanding. Please arrange payment at your earliest convenience.</p>` : ""}${biz.paymentTerms ? `<div style="margin-top:6px"><strong style="font-size:11px;color:#222">Payment accepted via:</strong>${fmtPaymentTerms(biz.paymentTerms)}</div>` : ""}</div>${footerHTML(biz)}`;
}
function buildCatalogHTML(items, categories, biz, logo) {
  const catMap = {};
  categories.forEach(c => { catMap[c.id] = c.name; });
  const byCat = {};
  items.forEach(i => { if (!byCat[i.catId]) byCat[i.catId] = []; byCat[i.catId].push(i); });
  const brandLogoSrc = logo?.src || LOGO_SRC;
  const brandImg = `<img src="${brandLogoSrc}" alt="logo" style="height:150px;max-width:160px;object-fit:contain;display:block;margin:0 auto"/>`;
  const sections = Object.entries(byCat).map(([catId, its]) => {
    const cards = its.map(i => `
      <div class="cat-item">
        ${i.photo ? `<img src="${i.photo}" alt="${i.name}" class="cat-item-photo"/>` : `<div class="cat-item-photo-placeholder">🍽️</div>`}
        <div class="cat-item-body">
          <div class="cat-item-name">${i.name}</div>
          ${i.description ? `<div class="cat-item-desc">${i.description}</div>` : ""}
          ${i.notes ? `<div class="cat-item-notes">📝 ${i.notes}</div>` : ""}
          <div class="cat-item-footer">
            <div class="cat-item-unit" style="font-size:11px;color:#555">${i.unitType}</div>
          </div>
          ${i.tags && i.tags.length ? `<div class="cat-tags">${i.tags.map(t => `<span class="cat-tag">${t}</span>`).join("")}</div>` : ""}
        </div>
      </div>`).join("");
    return `<div class="cat-section"><div class="cat-heading">${catMap[catId] || "Other"}</div><div class="cat-grid">${cards}</div></div>`;
  }).join("");
  const extraCSS = `<style>
    .cat-item-notes{font-size:10px;color:#a05000;font-style:italic;margin:3px 0 5px;line-height:1.4}
    .cat-tags{margin-top:5px;display:flex;flex-wrap:wrap;gap:3px}
    .cat-item-photo{width:100%;height:160px;object-fit:cover;border-radius:0;display:block}
    .cat-item-photo-placeholder{height:80px;display:flex;align-items:center;justify-content:center;font-size:28px;background:#f5f5f5}
    .cat-item{background:#fff;border:1px solid #e8e8e8;border-radius:8px;overflow:hidden;break-inside:avoid}
    .cat-item-body{padding:9px 10px 10px}
    .cat-item-name{font-size:13px;font-weight:700;color:#1a1a1a;margin-bottom:3px}
    .cat-item-desc{font-size:10px;color:#666;margin-bottom:4px;line-height:1.5}
    .cat-item-footer{display:flex;align-items:baseline;gap:5px;margin-top:6px}
    
    .cat-item-unit{font-size:9px;color:#999}
    .cat-tag{font-size:9px;background:#f0f0f0;color:#555;padding:1px 5px;border-radius:10px}
    .cat-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-top:12px}
    .cat-section{margin-bottom:32px}
    .cat-heading{font-size:16px;font-weight:800;color:#1a1a1a;padding:8px 0 6px;border-bottom:2px solid #1a1a1a;margin-bottom:4px}
    .catalog-intro{margin-bottom:28px;padding-bottom:20px;border-bottom:3px solid #1a1a1a;background:#fff;display:grid;grid-template-columns:1fr auto 1fr;align-items:center;gap:16px}
    .catalog-intro-left{display:flex;flex-direction:column;justify-content:flex-start}
    .catalog-intro-left h2{font-size:22px;font-weight:800;margin:0 0 4px;color:#1a1a1a}
    .catalog-intro-left p{font-size:11px;color:#666;margin:0;line-height:1.7}
    .catalog-intro-right{text-align:right;font-size:10px;color:#999}
  </style>`;
  return `${extraCSS}<div class="catalog-intro"><div class="catalog-intro-left"><h2>Services Catalog</h2><p>${[biz.tagline,biz.city,biz.phone,biz.email].filter(Boolean).join(" · ")}<br>${items.length} items · Valid as of ${TODAY_LABEL}</p></div>${brandImg}<div class="catalog-intro-right">Prices subject to confirmation<br>based on event specifics</div></div><p style="font-size:11px;color:#777;margin-bottom:24px;line-height:1.7">Prices subject to confirmation based on guest count, location and event specifics. Contact us for custom packages.</p>${sections}${footerHTML(biz)}`;
}
function printDoc(title, html) {
  const w = window.open("", "_blank", "width=860,height=940");
  w.document.write(
    `<!DOCTYPE html><html><head><title>${title}</title><style>${PRINT_CSS}</style></head><body>${html}<div class="no-print" style="position:fixed;bottom:20px;right:20px;display:flex;gap:8px"><button onclick="window.print()" style="background:#1a1a1a;color:#fff;border:none;padding:10px 20px;border-radius:8px;font-family:inherit;font-size:13px;font-weight:700;cursor:pointer">🖨️ Print / Save PDF</button><button onclick="window.close()" style="background:#f0f0f0;color:#1a1a1a;border:none;padding:10px 20px;border-radius:8px;font-family:inherit;font-size:13px;cursor:pointer">✕</button></div></body></html>`
  );
  w.document.close();
  w.focus();
}
function DocModal({ doc, onClose }) {
  if (!doc) return null;
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.82)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        style={{
          background: T.card,
          border: `1px solid ${T.border}`,
          borderRadius: 10,
          width: "100%",
          maxWidth: 760,
          maxHeight: "92vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            padding: "10px 14px",
            borderBottom: `1px solid ${T.border}`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: T.surface,
            gap: 8,
            flexShrink: 0,
          }}
        >
          <div style={{ fontWeight: 700, fontSize: 12, flex: 1 }}>
            {doc.title}
          </div>
          <button
            style={{ ...S.btn("primary"), fontSize: 11, padding: "4px 10px" }}
            onClick={doc.onPrint}
          >
            🖨️ Open Print Preview
          </button>
          <button
            style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 10px" }}
            onClick={onClose}
          >
            ✕ Close
          </button>
        </div>
        <div
          style={{
            flex: 1,
            overflow: "auto",
            background: "#fff",
            fontFamily: "'Inter',Arial,sans-serif",
            fontSize: 13,
            padding: 0,
          }}
          dangerouslySetInnerHTML={{
            __html: `<style>${PRINT_CSS}</style><div style="padding:28px">${doc.html}</div>`,
          }}
        />
      </div>
    </div>
  );
}

// ─── SETTINGS ─────────────────────────────────────────────────────
function BizField({ label, k, placeholder, area, draft, setDraft }) {
  return (
    <div>
      <label style={S.label}>{label}</label>
      {area ? (
        <textarea
          style={{ ...S.input, height: 64, resize: "vertical" }}
          value={draft[k] || ""}
          onChange={(e) => setDraft((d) => ({ ...d, [k]: e.target.value }))}
          placeholder={placeholder || ""}
        />
      ) : (
        <input
          style={S.input}
          value={draft[k] || ""}
          onChange={(e) => setDraft((d) => ({ ...d, [k]: e.target.value }))}
          placeholder={placeholder || ""}
        />
      )}
    </div>
  );
}

function SettingsModal({ biz, setBiz, logo, socialLinks, setSocialLinks, onClose,
  setEvents, setSales, setInvoices, setProposals, setBatches, setOverheads, setCustomers,
  cloudSet }) {
  const [draft, setDraft] = useState({ ...biz });
  const [draftSocial, setDraftSocial] = useState({ ...socialLinks });
  const [pwSection, setPwSection] = useState(false);
  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [pwMsg, setPwMsg] = useState(null);

  // Staff account management
  const [staffSection, setStaffSection] = useState(false);
  const existingStaff = loadAuth()?.staff || null;
  const [staffEmail, setStaffEmail] = useState(existingStaff?.email || "");
  const [staffPw, setStaffPw] = useState("");
  const [staffPw2, setStaffPw2] = useState("");
  const [staffMsg, setStaffMsg] = useState(null);
  const [confirmRemoveStaff, setConfirmRemoveStaff] = useState(false);

  const save = () => {
    setBiz(draft);
    setSocialLinks(draftSocial);
    // Force immediate cloud write — don't rely on debounced syncKey
    if (isSupabaseConfigured()) {
      cloudSet("cb_biz", draft);
      cloudSet("cb_social", draftSocial);
    }
    onClose();
  };

  const handleChangePw = () => {
    setPwMsg(null);
    const auth = loadAuth();
    if (!auth) { setPwMsg({ type: "error", text: "No credentials found. Please reload." }); return; }
    if (!currentPw) { setPwMsg({ type: "error", text: "Enter your current password." }); return; }
    if (hashPassword(currentPw) !== auth.owner.hash) { setPwMsg({ type: "error", text: "Current password is incorrect." }); return; }
    if (newPw.length < 6) { setPwMsg({ type: "error", text: "New password must be at least 6 characters." }); return; }
    if (newPw !== confirmPw) { setPwMsg({ type: "error", text: "Passwords do not match." }); return; }
    saveOwnerAuth(auth.owner.email, newPw);
    setCurrentPw(""); setNewPw(""); setConfirmPw("");
    setPwMsg({ type: "success", text: "Password updated successfully." });
  };

  const handleSaveStaff = () => {
    setStaffMsg(null);
    if (!staffEmail.trim()) { setStaffMsg({ type: "error", text: "Staff email is required." }); return; }
    if (!existingStaff && staffPw.length < 6) { setStaffMsg({ type: "error", text: "Password must be at least 6 characters." }); return; }
    if (!existingStaff && staffPw !== staffPw2) { setStaffMsg({ type: "error", text: "Passwords do not match." }); return; }
    if (staffPw && staffPw.length < 6) { setStaffMsg({ type: "error", text: "Password must be at least 6 characters." }); return; }
    if (staffPw && staffPw !== staffPw2) { setStaffMsg({ type: "error", text: "Passwords do not match." }); return; }
    // If password left blank on edit, keep existing hash
    const auth = loadAuth();
    if (existingStaff && !staffPw) {
      saveStaffAuth(staffEmail, null); // save email update only — keep hash
      // Actually just update email while preserving hash manually
      const existing = loadAuth() || {};
      localStorage.setItem("cb_auth_v2", JSON.stringify({
        ...existing,
        staff: { email: staffEmail.trim().toLowerCase(), hash: existingStaff.hash }
      }));
    } else {
      saveStaffAuth(staffEmail, staffPw);
    }
    setStaffPw(""); setStaffPw2("");
    setStaffMsg({ type: "success", text: existingStaff ? "Staff account updated." : "Staff account created successfully." });
  };

  const handleRemoveStaff = () => {
    const existing = loadAuth() || {};
    localStorage.setItem("cb_auth_v2", JSON.stringify({ ...existing, staff: null }));
    setStaffEmail(""); setStaffPw(""); setStaffPw2("");
    setStaffMsg({ type: "success", text: "Staff account removed." });
    setConfirmRemoveStaff(false);
  };
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.85)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          background: T.card,
          border: `1px solid ${T.border}`,
          borderRadius: 12,
          width: "100%",
          maxWidth: 620,
          maxHeight: "90vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            padding: "12px 18px",
            borderBottom: `1px solid ${T.border}`,
            background: T.surface,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ fontWeight: 700, fontSize: 14 }}>
            ⚙️ Business Settings
          </div>
          <button
            style={{
              background: "none",
              border: "none",
              color: T.textMuted,
              cursor: "pointer",
              fontSize: 16,
            }}
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div style={{ padding: 20, overflow: "auto", flex: 1 }}>
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: T.textMuted,
              letterSpacing: 0.8,
              textTransform: "uppercase",
              marginBottom: 10,
            }}
          >
            Company Identity
          </div>
          <div style={S.grid(2)}>
            <BizField draft={draft} setDraft={setDraft} label="Company Name" k="name" />
            <BizField draft={draft} setDraft={setDraft} label="Tagline" k="tagline" />
          </div>
          <div
            style={{
              marginTop: 10,
              fontSize: 10,
              fontWeight: 700,
              color: T.textMuted,
              letterSpacing: 0.8,
              textTransform: "uppercase",
              marginBottom: 10,
            }}
          >
            Contact & Location
          </div>
          <div style={S.grid(2)}>
            <BizField draft={draft} setDraft={setDraft} label="Street Address" k="address" />
            <BizField draft={draft} setDraft={setDraft} label="City / Country" k="city" />
            <BizField draft={draft} setDraft={setDraft} label="Primary Phone" k="phone" />
            <BizField draft={draft} setDraft={setDraft} label="Secondary Phone" k="phone2" />
            <BizField draft={draft} setDraft={setDraft} label="Email" k="email" />
            <BizField draft={draft} setDraft={setDraft} label="Website" k="website" />
          </div>
          <div
            style={{
              marginTop: 10,
              fontSize: 10,
              fontWeight: 700,
              color: T.textMuted,
              letterSpacing: 0.8,
              textTransform: "uppercase",
              marginBottom: 10,
            }}
          >
            Legal & Banking
          </div>
          <div style={S.grid(2)}>
            <BizField draft={draft} setDraft={setDraft} label="RCCM / Business Reg. No." k="rccm" />
            <BizField draft={draft} setDraft={setDraft} label="Tax ID / NIU" k="taxId" />
            <BizField draft={draft} setDraft={setDraft} label="Bank Name" k="bankName" />
            <BizField draft={draft} setDraft={setDraft} label="Bank Account Number" k="bankAccount" />
          </div>
          <div
            style={{
              marginTop: 10,
              fontSize: 10,
              fontWeight: 700,
              color: T.textMuted,
              letterSpacing: 0.8,
              textTransform: "uppercase",
              marginBottom: 10,
            }}
          >
            Document Defaults
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <BizField draft={draft} setDraft={setDraft} label="Payment Terms" k="paymentTerms" area />
            <BizField draft={draft} setDraft={setDraft} label="Document Footer Message" k="footer" area />
          </div>

          {/* ── CHANGE PASSWORD ── */}
          <div style={{ marginTop: 18 }}>
            <button
              style={{
                background: "none", border: "none", padding: 0, cursor: "pointer",
                fontSize: 10, fontWeight: 700, color: T.textMuted,
                letterSpacing: 0.8, textTransform: "uppercase",
                display: "flex", alignItems: "center", gap: 5,
              }}
              onClick={() => { setPwSection(!pwSection); setPwMsg(null); }}
            >
              {pwSection ? "▾" : "▸"} 🔒 Change Password
            </button>
            {pwSection && (
              <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 10 }}>
                <div>
                  <label style={S.label}>Current Password</label>
                  <input type="password" style={S.input} value={currentPw}
                    onChange={e => { setCurrentPw(e.target.value); setPwMsg(null); }}
                    placeholder="Your current password" autoComplete="current-password" />
                </div>
                <div style={S.grid(2)}>
                  <div>
                    <label style={S.label}>New Password</label>
                    <input type="password" style={S.input} value={newPw}
                      onChange={e => { setNewPw(e.target.value); setPwMsg(null); }}
                      placeholder="Min. 6 characters" autoComplete="new-password" />
                  </div>
                  <div>
                    <label style={S.label}>Confirm New Password</label>
                    <input type="password" style={S.input} value={confirmPw}
                      onChange={e => { setConfirmPw(e.target.value); setPwMsg(null); }}
                      placeholder="Re-enter new password" autoComplete="new-password" />
                  </div>
                </div>
                {pwMsg && (
                  <div style={{
                    background: pwMsg.type === "success" ? `${T.success}15` : `${T.danger}15`,
                    border: `1px solid ${pwMsg.type === "success" ? T.success : T.danger}40`,
                    borderRadius: 6, padding: "7px 12px", fontSize: 12,
                    color: pwMsg.type === "success" ? T.success : T.danger,
                  }}>
                    {pwMsg.type === "success" ? "✓" : "⚠️"} {pwMsg.text}
                  </div>
                )}
                <div>
                  <button style={{ ...S.btn("ghost"), borderColor: T.accent, color: T.accent }} onClick={handleChangePw}>
                    Update Password
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* ── STAFF ACCOUNT ── */}
          <div style={{ marginTop: 14 }}>
            <button
              style={{
                background: "none", border: "none", padding: 0, cursor: "pointer",
                fontSize: 10, fontWeight: 700, color: T.textMuted,
                letterSpacing: 0.8, textTransform: "uppercase",
                display: "flex", alignItems: "center", gap: 5,
              }}
              onClick={() => { setStaffSection(!staffSection); setStaffMsg(null); setConfirmRemoveStaff(false); }}
            >
              {staffSection ? "▾" : "▸"} 👤 Staff Account
              {existingStaff && <span style={{ ...S.badge(T.info), marginLeft: 4 }}>Active</span>}
            </button>
            {staffSection && (
              <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 10 }}>
                {/* Info banner */}
                <div style={{
                  background: `${T.info}10`, border: `1px solid ${T.info}30`,
                  borderRadius: 7, padding: "8px 12px", fontSize: 11, color: T.textMuted,
                }}>
                  👤 Staff can only access <strong style={{ color: T.text }}>Restaurant &amp; Delivery</strong> and <strong style={{ color: T.text }}>Invoices &amp; AR</strong>. They cannot access financial reports, settings, or any other section.
                </div>

                <div style={S.grid(2)}>
                  <div style={{ gridColumn: "1 / -1" }}>
                    <label style={S.label}>Staff Email</label>
                    <input style={S.input} type="email" value={staffEmail}
                      onChange={e => { setStaffEmail(e.target.value); setStaffMsg(null); }}
                      placeholder="staff@example.com" autoComplete="off" />
                  </div>
                  <div>
                    <label style={S.label}>{existingStaff ? "New Password (leave blank to keep)" : "Password"}</label>
                    <input style={S.input} type="password" value={staffPw}
                      onChange={e => { setStaffPw(e.target.value); setStaffMsg(null); }}
                      placeholder={existingStaff ? "Leave blank to keep current" : "Min. 6 characters"} autoComplete="new-password" />
                  </div>
                  <div>
                    <label style={S.label}>Confirm Password</label>
                    <input style={S.input} type="password" value={staffPw2}
                      onChange={e => { setStaffPw2(e.target.value); setStaffMsg(null); }}
                      placeholder="Re-enter password" autoComplete="new-password" />
                  </div>
                </div>

                {staffMsg && (
                  <div style={{
                    background: staffMsg.type === "success" ? `${T.success}15` : `${T.danger}15`,
                    border: `1px solid ${staffMsg.type === "success" ? T.success : T.danger}40`,
                    borderRadius: 6, padding: "7px 12px", fontSize: 12,
                    color: staffMsg.type === "success" ? T.success : T.danger,
                  }}>
                    {staffMsg.type === "success" ? "✓" : "⚠️"} {staffMsg.text}
                  </div>
                )}

                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <button style={{ ...S.btn("primary") }} onClick={handleSaveStaff}>
                    {existingStaff ? "Update Staff Account" : "Create Staff Account"}
                  </button>
                  {existingStaff && !confirmRemoveStaff && (
                    <button style={{ ...S.btn("ghost"), color: T.danger, borderColor: `${T.danger}50` }}
                      onClick={() => setConfirmRemoveStaff(true)}>
                      Remove Staff Account
                    </button>
                  )}
                  {existingStaff && confirmRemoveStaff && (
                    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      <span style={{ fontSize: 11, color: T.danger }}>Are you sure?</span>
                      <button style={{ ...S.btn("danger") }} onClick={handleRemoveStaff}>Yes, Remove</button>
                      <button style={S.btn("ghost")} onClick={() => setConfirmRemoveStaff(false)}>Cancel</button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ── STAFF PERMISSIONS ── */}
        <div style={{ padding: "14px 18px", borderTop: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: T.textMuted, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 10 }}>
            🔐 Staff Permissions — Tabs Staff Can Access
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {[
              { id: "dashboard", label: "📊 Dashboard" },
              { id: "catering", label: "🎉 Catering" },
              { id: "restaurant", label: "🍽️ Restaurant & Delivery" },
              { id: "customers", label: "👥 Customers" },
              { id: "vendors", label: "🧾 Expenses" },
              { id: "reports", label: "📑 Reports" },
            ].map(tab => {
              const enabled = (draft.staffTabs || ["restaurant", "customers"]).includes(tab.id);
              return (
                <button key={tab.id}
                  style={{ ...S.btn(enabled ? "primary" : "ghost"), fontSize: 11, padding: "5px 12px" }}
                  onClick={() => {
                    const current = draft.staffTabs || ["restaurant", "customers"];
                    const next = enabled
                      ? current.filter(t => t !== tab.id)
                      : [...current, tab.id];
                    setDraft({ ...draft, staffTabs: next });
                  }}
                >
                  {enabled ? "✓ " : ""}{tab.label}
                </button>
              );
            })}
          </div>
          <div style={{ fontSize: 10, color: T.textDim, marginTop: 8 }}>
            AI Studio is always Owner-only. Changes take effect immediately after Save.
          </div>
        </div>

        {/* ── SOCIAL LINKS ── */}
          <div style={{ marginTop: 18 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: T.textMuted, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 10 }}>
              📱 Social Media & Links
            </div>
            <div style={S.grid(2)}>
              {[
                { key: "instagram", icon: "📷", label: "Instagram URL", ph: "https://instagram.com/cookiesbites" },
                { key: "facebook", icon: "👤", label: "Facebook Page URL", ph: "https://facebook.com/cookiesbites" },
                { key: "tiktok", icon: "🎵", label: "TikTok URL", ph: "https://tiktok.com/@cookiesbites" },
                { key: "whatsapp", icon: "💬", label: "WhatsApp Number", ph: "+237 6XX XXX XXX" },
                { key: "google", icon: "🔍", label: "Google Business Review Link", ph: "https://g.page/r/YOUR_PLACE_ID/review" },
              ].map(s => (
                <div key={s.key}>
                  <label style={S.label}>{s.icon} {s.label}</label>
                  <input style={S.input} value={draftSocial[s.key] || ""} onChange={e => setDraftSocial(p => ({ ...p, [s.key]: e.target.value }))} placeholder={s.ph} />
                </div>
              ))}
            </div>
          </div>

          {/* ── BUSINESS CARD ── */}
          <div style={{ marginTop: 18 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: T.textMuted, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 10 }}>
              🪪 Business Card
            </div>
            <div style={{ fontSize: 11, color: T.textDim, marginBottom: 10 }}>
              Download a print-ready business card with your logo, contact details and social links. Save and re-open settings to reflect latest edits before downloading.
            </div>
            <button
              style={{ ...S.btn("primary"), fontSize: 12 }}
              onClick={() => {
                const b = draft;
                const sl = draftSocial;
                const logoSrc = logo?.src || "";

                const socials = [
                  sl.instagram && { icon: `<svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>`, handle: sl.instagram.replace(/.*instagram\.com\//,"@").replace(/\/$/, "") || "Instagram" },
                  sl.facebook && { icon: `<svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>`, handle: sl.facebook.replace(/.*facebook\.com\//,"").replace(/\/$/, "") || "Facebook" },
                  sl.tiktok && { icon: `<svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.23 8.23 0 004.84 1.56V6.79a4.85 4.85 0 01-1.07-.1z"/></svg>`, handle: sl.tiktok.replace(/.*tiktok\.com\/@?/,"@").replace(/\/$/, "") || "TikTok" },
                  sl.whatsapp && { icon: `<svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>`, handle: sl.whatsapp || "WhatsApp" },
                ].filter(Boolean);

                const socialsHTML = socials.length ? `
                  <div style="display:flex;flex-direction:column;gap:4px;margin-top:8px">
                    ${socials.map(s => `
                      <div style="display:flex;align-items:center;gap:5px;font-size:10px;color:#555">
                        <span style="color:#b85c1a;flex-shrink:0">${s.icon}</span>
                        <span>${s.handle}</span>
                      </div>`).join("")}
                  </div>` : "";

                const cardHTML = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8"/>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=Source+Sans+3:wght@400;500;600&display=swap');
  * { margin:0; padding:0; box-sizing:border-box; }
  body { background:#f0ebe3; display:flex; flex-direction:column; align-items:center; justify-content:center; min-height:100vh; font-family:'Source Sans 3', sans-serif; padding:40px 20px; }
  h2 { font-family:'Source Sans 3',sans-serif; font-size:13px; font-weight:600; color:#888; letter-spacing:2px; text-transform:uppercase; margin-bottom:24px; }
  .card-wrap { display:flex; gap:0; box-shadow:0 20px 60px rgba(0,0,0,0.18); border-radius:14px; overflow:hidden; width:720px; height:240px; }
  .front { background:linear-gradient(135deg,#1a0a00 0%,#3d1a00 60%,#6b2d00 100%); width:360px; height:240px; display:flex; flex-direction:column; align-items:center; justify-content:center; padding:30px; position:relative; overflow:hidden; flex-shrink:0; }
  .front::before { content:''; position:absolute; top:-60px; right:-60px; width:200px; height:200px; background:radial-gradient(circle,rgba(184,92,26,0.3) 0%,transparent 70%); border-radius:50%; }
  .front::after { content:''; position:absolute; bottom:-40px; left:-40px; width:150px; height:150px; background:radial-gradient(circle,rgba(255,160,60,0.15) 0%,transparent 70%); border-radius:50%; }
  .logo-wrap { width:80px; height:80px; border-radius:50%; overflow:hidden; border:3px solid rgba(184,92,26,0.6); margin-bottom:14px; background:#fff; display:flex; align-items:center; justify-content:center; flex-shrink:0; z-index:1; }
  .logo-wrap img { width:100%; height:100%; object-fit:cover; }
  .logo-placeholder { font-size:32px; }
  .biz-name { font-family:'Playfair Display',serif; font-size:20px; font-weight:700; color:#fff; text-align:center; letter-spacing:0.5px; z-index:1; margin-bottom:4px; }
  .biz-tagline { font-size:10px; color:rgba(255,200,140,0.8); text-align:center; letter-spacing:1.5px; text-transform:uppercase; z-index:1; }
  .divider-line { width:40px; height:2px; background:linear-gradient(90deg,transparent,#b85c1a,transparent); margin:10px auto 0; z-index:1; }
  .back { background:#fffdf9; width:360px; height:240px; padding:28px 28px 24px; display:flex; flex-direction:column; justify-content:space-between; flex-shrink:0; }
  .contact-block { display:flex; flex-direction:column; gap:6px; }
  .contact-row { display:flex; align-items:center; gap:8px; font-size:11px; color:#444; }
  .contact-icon { width:20px; height:20px; background:#b85c1a; border-radius:50%; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
  .contact-icon svg { width:11px; height:11px; fill:#fff; }
  .socials-row { display:flex; flex-wrap:wrap; gap:8px; padding-top:8px; border-top:1px solid #f0ebe3; }
  .social-chip { display:flex; align-items:center; gap:4px; font-size:10px; color:#666; }
  .social-chip svg { color:#b85c1a; }
  .bottom-accent { width:100%; height:3px; background:linear-gradient(90deg,#b85c1a,#f5a623,#b85c1a); border-radius:0 0 0 0; position:absolute; bottom:0; left:0; }
  .download-btn { margin-top:28px; background:linear-gradient(135deg,#b85c1a,#d4711f); color:#fff; border:none; padding:12px 32px; border-radius:8px; font-size:14px; font-weight:600; cursor:pointer; font-family:'Source Sans 3',sans-serif; letter-spacing:0.5px; box-shadow:0 4px 14px rgba(184,92,26,0.4); transition:all 0.2s; }
  .download-btn:hover { transform:translateY(-1px); box-shadow:0 6px 18px rgba(184,92,26,0.5); }
  @media print { body { background:#fff; padding:0; } h2 { display:none; } .download-btn { display:none; } .card-wrap { box-shadow:none; } }
</style>
</head>
<body>
<h2>🪪 Business Card Preview</h2>
<div class="card-wrap">
  <!-- FRONT -->
  <div class="front">
    <div class="logo-wrap">
      ${logoSrc ? `<img src="${logoSrc}" alt="logo"/>` : `<span class="logo-placeholder">🍽️</span>`}
    </div>
    <div class="biz-name">${b.name || "Business Name"}</div>
    ${b.tagline ? `<div class="biz-tagline">${b.tagline}</div>` : ""}
    <div class="divider-line"></div>
  </div>
  <!-- BACK -->
  <div class="back" style="position:relative">
    <div class="contact-block">
      ${b.phone ? `<div class="contact-row"><div class="contact-icon"><svg viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg></div><span>${b.phone}${b.phone2 ? " · " + b.phone2 : ""}</span></div>` : ""}
      ${b.email ? `<div class="contact-row"><div class="contact-icon"><svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg></div><span>${b.email}</span></div>` : ""}
      ${b.website ? `<div class="contact-row"><div class="contact-icon"><svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg></div><span>${b.website}</span></div>` : ""}
      ${b.address || b.city ? `<div class="contact-row"><div class="contact-icon"><svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg></div><span>${[b.address, b.city].filter(Boolean).join(", ")}</span></div>` : ""}
    </div>
    ${socials.length ? `<div class="socials-row">${socials.map(s => `<div class="social-chip">${s.icon}<span>${s.handle}</span></div>`).join("")}</div>` : ""}
    <div class="bottom-accent"></div>
  </div>
</div>
<button class="download-btn" onclick="window.print()">🖨️ Print / Save as PDF</button>
<p style="margin-top:14px;font-size:11px;color:#999;font-family:'Source Sans 3',sans-serif">Tip: In print dialog, set paper to <strong>Custom 3.5×2 in</strong> or save as PDF and crop</p>
</body>
</html>`;

                const win = window.open("", "_blank");
                if (win) {
                  win.document.write(cardHTML);
                  win.document.close();
                }
              }}
            >
              🪪 Preview & Download Business Card
            </button>
          </div>

        <div
          style={{
            padding: "12px 18px",
            borderTop: `1px solid ${T.border}`,
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >
          <button style={S.btn("ghost")} onClick={onClose}>
            Cancel
          </button>
          <button style={S.btn("primary")} onClick={save}>
            Save Settings
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── DASHBOARD ────────────────────────────────────────────────────
function Dashboard({
  events,
  sales,
  invoices,
  catalogItems,
  overheads,
  inventory,
  meals,
  invPurchases,
  prepaidItems,
}) {
  const [period, setPeriod] = useState("ytd");
  const [customFrom, setCustomFrom] = useState(`${THIS_YEAR}-01-01`);
  const [customTo, setCustomTo] = useState(TODAY_ISO);
  const [drilldown, setDrilldown] = useState(null); // "cash" | "ar"
  const range = useMemo(
    () => getPeriodRange(period, customFrom, customTo),
    [period, customFrom, customTo]
  );
  const pSales = useMemo(
    () => sales.filter((s) => inRange(s.date, range[0], range[1])),
    [sales, range]
  );
  const pEvents = useMemo(
    () => events.filter((e) => inRange(e.eventDate, range[0], range[1])),
    [events, range]
  );
  const rdRev = pSales.reduce((s, r) => s + orderTotal(r), 0);
  const rdCOGS = pSales.reduce(
    (s, r) => s + orderCOGS(r, catalogItems, meals),
    0
  );
  const catRev = pEvents.reduce((s, e) => s + e.revenue, 0);
  const catCOGS = pEvents.reduce((s, e) => s + evtCOGS(e), 0);
  // Ingredient purchases in period count as COGS (direct food production cost)
  const pIngPurchases = (invPurchases || []).filter(p => inRange(p.date, range[0], range[1]));
  // Only ingredient-type purchases flow through as immediate COGS; resale items are inventory assets
  const ingPurchasesCOGS = pIngPurchases.reduce((s, p) => {
    const invItem = (inventory || []).find(i => i.id === p.itemId);
    const isResale = invItem ? invItem.itemType === "resale" : false;
    return isResale ? s : s + Number(p.totalCost || 0);
  }, 0);
  // Resale COGS: cost of resale items actually sold this period
  const resaleSalesCOGS = pSales.reduce((s, sale) => {
    const resaleItems = (sale.items || []).filter(it => it._itemType === "resale");
    return s + resaleItems.reduce((a, it) => a + (Number(it.qty) || 0) * (Number(it._costPerUnit) || 0), 0);
  }, 0);
  const totalRev = catRev + rdRev;
  const totalCOGS = catCOGS + rdCOGS + ingPurchasesCOGS + resaleSalesCOGS;
  const gp = totalRev - totalCOGS;
  const gm = totalRev ? ((gp / totalRev) * 100).toFixed(1) : 0;
  // Period overheads (opex only — capex & liability payments don't hit P&L)
  const pOverheads = useMemo(
    () =>
      (overheads || []).filter(
        (o) =>
          inRange(o.date, range[0], range[1]) &&
          (o.entryType || "opex") === "opex"
      ),
    [overheads, range]
  );
  const ohFromEntries = pOverheads.reduce((s, o) => s + Number(o.amount), 0);
  const prepaidRecognized = calcPrepaidRecognized(prepaidItems, range[0], range[1]);
  const totalOverheads = ohFromEntries + prepaidRecognized;
  const netProfit = gp - totalOverheads;

  // Cash Received = catering invoices paid + restaurant sales cash received in period
  const invoiceCashRcvd = invoices
    .filter(i => inRange(i.issued || i.lastPaymentDate, range[0], range[1]))
    .reduce((s, i) => s + (i.paid || 0), 0);
  const salesCashRcvd = pSales.reduce((s, sale) => {
    const total = orderTotal(sale);
    const paid = sale.partialPaid !== "" && sale.partialPaid != null
      ? Number(sale.partialPaid)
      : total;
    return s + paid;
  }, 0);
  const cashRcvd = invoiceCashRcvd + salesCashRcvd;

  // AR Outstanding = unpaid catering invoice balance + restaurant sales with outstanding balance
  const invoiceAR = invoices.reduce((s, i) => s + Math.max(0, (i.total || 0) - (i.paid || 0)), 0);
  const salesAR = pSales.reduce((s, sale) => {
    if (sale.method === "Credit" || (sale.partialPaid !== "" && sale.partialPaid != null)) {
      const total = orderTotal(sale);
      const paid = sale.partialPaid !== "" && sale.partialPaid != null ? Number(sale.partialPaid) : total;
      return s + Math.max(0, total - paid);
    }
    return s;
  }, 0);
  const arOut = invoiceAR + salesAR;
  const delFees = pSales
    .filter((s) => s.type === "Delivery")
    .reduce((s, r) => s + (r.deliveryFee || 0), 0);
  const chartData = useMemo(() => {
    const days = Math.ceil((range[1] - range[0]) / 86400000) + 1;
    const groups = {};
    if (days <= 14) {
      for (let i = 0; i < days; i++) {
        const d = new Date(range[0]);
        d.setDate(d.getDate() + i);
        const key = d.toISOString().slice(0, 10);
        const label = d.toLocaleDateString("fr-CM", {
          day: "2-digit",
          month: "2-digit",
        });
        groups[key] = { label, sales: 0, cogs: 0 };
      }
      pSales.forEach((s) => {
        if (groups[s.date]) {
          groups[s.date].sales += orderTotal(s);
          groups[s.date].cogs += orderCOGS(s, catalogItems, meals);
        }
      });
    } else if (days <= 90) {
      pSales.forEach((s) => {
        const d = new Date(s.date);
        const wk = new Date(d);
        const dow = d.getDay();
        const off = dow === 0 ? -6 : 1 - dow;
        wk.setDate(d.getDate() + off);
        const key = wk.toISOString().slice(0, 10);
        const label = `W${Math.ceil(wk.getDate() / 7)} ${wk.toLocaleDateString(
          "fr-CM",
          { month: "short" }
        )}`;
        if (!groups[key]) groups[key] = { label, sales: 0, cogs: 0 };
        groups[key].sales += orderTotal(s);
        groups[key].cogs += orderCOGS(s, catalogItems, meals);
      });
      pEvents.forEach((e) => {
        const d = new Date(e.eventDate);
        const wk = new Date(d);
        const dow = d.getDay();
        const off = dow === 0 ? -6 : 1 - dow;
        wk.setDate(d.getDate() + off);
        const key = wk.toISOString().slice(0, 10);
        const label = `W${Math.ceil(wk.getDate() / 7)} ${wk.toLocaleDateString(
          "fr-CM",
          { month: "short" }
        )}`;
        if (!groups[key]) groups[key] = { label, sales: 0, cogs: 0 };
        groups[key].sales += e.revenue;
        groups[key].cogs += evtCOGS(e);
      });
    } else {
      pSales.forEach((s) => {
        const key = s.date.slice(0, 7);
        const d = new Date(s.date);
        const label = d.toLocaleDateString("fr-CM", {
          month: "short",
          year: "2-digit",
        });
        if (!groups[key]) groups[key] = { label, sales: 0, cogs: 0 };
        groups[key].sales += orderTotal(s);
        groups[key].cogs += orderCOGS(s, catalogItems, meals);
      });
      pEvents.forEach((e) => {
        const key = e.eventDate.slice(0, 7);
        const d = new Date(e.eventDate);
        const label = d.toLocaleDateString("fr-CM", {
          month: "short",
          year: "2-digit",
        });
        if (!groups[key]) groups[key] = { label, sales: 0, cogs: 0 };
        groups[key].sales += e.revenue;
        groups[key].cogs += evtCOGS(e);
      });
    }
    return Object.keys(groups)
      .sort()
      .map((k) => ({ ...groups[k], profit: groups[k].sales - groups[k].cogs }));
  }, [pSales, pEvents, range, catalogItems]);
  const arBuckets = {};
  // Catering invoices — bucketed by due date age
  invoices.forEach((inv) => {
    const bal = inv.total - inv.paid;
    if (bal <= 0) return;
    const b = ageBucket(daysOD(inv.due));
    arBuckets[b] = (arBuckets[b] || 0) + bal;
  });
  // Restaurant sales with outstanding balance — always "Current" (point-of-sale debt, no credit terms)
  sales.forEach((s) => {
    const tot = orderTotal(s);
    const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
    const bal = tot - paid;
    if (bal <= 0) return;
    arBuckets["Current"] = (arBuckets["Current"] || 0) + bal;
  });
  const mealMap = {};
  pSales.forEach((s) => {
    const items = Array.isArray(s.items) && s.items.length > 0
      ? s.items
      : [{ meal: s.meal, plates: s.plates, pricePerPlate: s.pricePerPlate }];
    items.forEach(it => {
      if (it.meal) mealMap[it.meal] = (mealMap[it.meal] || 0) + (Number(it.plates) || 0) * (Number(it.pricePerPlate) || 0);
    });
  });
  const topMeals = Object.entries(mealMap)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5);
  const isMobile = useIsMobile();
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 4,
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <div>
          <div style={S.pageTitle}>📊 Dashboard</div>
          <div style={S.subtitle}>Cookies Bites · {PERIOD_LABELS[period]}</div>
        </div>
      </div>
      <PeriodSelector
        period={period}
        setPeriod={setPeriod}
        customFrom={customFrom}
        setCustomFrom={setCustomFrom}
        customTo={customTo}
        setCustomTo={setCustomTo}
        range={range}
      />
      {isMobile ? (
        <>
          <MobileStatRow
            items={[
              { label: "Revenue", value: fmtShort(totalRev), icon: "💰" },
              {
                label: "Gross Profit",
                value: fmtShort(gp),
                icon: "📈",
                color: T.success,
              },
              {
                label: "Net Profit",
                value: fmtShort(netProfit),
                icon: "🏦",
                color: netProfit >= 0 ? T.success : T.danger,
              },
              {
                label: "AR Outstanding",
                value: fmtShort(arOut),
                icon: "⚠️",
                color: T.danger,
              },
            ]}
          />
          <div style={{ ...S.cardMobile, marginBottom: 10 }}>
            <div style={S.cardTitle}>Revenue by Line</div>
            {[
              { label: "🍽️ Restaurant", val: rdRev, color: T.restaurant },
              { label: "🎉 Catering", val: catRev, color: T.catering },
            ].map((item) => (
              <div key={item.label} style={{ marginBottom: 12 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 3,
                  }}
                >
                  <span style={{ fontSize: 12, fontWeight: 600 }}>
                    {item.label}
                  </span>
                  <span
                    style={{ fontSize: 13, fontWeight: 800, color: item.color }}
                  >
                    {fmt(item.val)}
                  </span>
                </div>
                <PBar
                  pct={totalRev ? (item.val / totalRev) * 100 : 0}
                  color={item.color}
                />
              </div>
            ))}
            <div
              style={{
                borderTop: `1px solid ${T.border}`,
                paddingTop: 8,
                marginTop: 4,
              }}
            >
              {[
                ["COGS", totalCOGS, T.danger],
                ["Gross Profit", gp, T.success],
              ].map(([k, v, c]) => (
                <div
                  key={k}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "3px 0",
                    fontSize: 11,
                  }}
                >
                  <span style={{ color: T.textMuted }}>{k}</span>
                  <span style={{ fontWeight: 700, color: c }}>{fmt(v)}</span>
                </div>
              ))}
            </div>
          </div>
          <div style={{ ...S.cardMobile, marginBottom: 10 }}>
            <div style={S.cardTitle}>Top Meals</div>
            {topMeals.map(([meal, rev], i) => (
              <div
                key={meal}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    width: 18,
                    height: 18,
                    background: T.accent,
                    borderRadius: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 9,
                    fontWeight: 800,
                    color: T.bg,
                    flexShrink: 0,
                  }}
                >
                  {i + 1}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {meal}
                  </div>
                  <PBar
                    pct={topMeals[0] ? (rev / topMeals[0][1]) * 100 : 0}
                    color={T.restaurant}
                  />
                </div>
                <div
                  style={{ fontSize: 11, fontWeight: 700, color: T.restaurant }}
                >
                  {fmtShort(rev)}
                </div>
              </div>
            ))}
          </div>
          <div style={{ ...S.cardMobile, marginBottom: 10 }}>
            <div style={S.cardTitle}>Open Invoices & Unpaid Orders</div>
            {/* Catering invoices with balance */}
            {invoices
              .filter((i) => i.total - i.paid > 0)
              .map((inv, i) => {
                const bal = inv.total - inv.paid;
                const days = daysOD(inv.due);
                return (
                  <div
                    key={i}
                    style={{
                      padding: "8px 0",
                      borderBottom: `1px solid ${T.border}15`,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontSize: 12, fontWeight: 700 }}>
                        {inv.client}
                      </div>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 800,
                          color: T.danger,
                        }}
                      >
                        {fmt(bal)}
                      </div>
                    </div>
                    <div style={{ fontSize: 10, color: T.textMuted }}>
                      {inv.num} ·{" "}
                      {days > 0 ? (
                        <span style={{ color: T.danger }}>{days}d overdue</span>
                      ) : (
                        `Due ${inv.due}`
                      )}
                    </div>
                  </div>
                );
              })}
            {/* Unpaid / partial restaurant sales */}
            {pSales
              .filter(s => {
                const tot = orderTotal(s);
                const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
                return tot - paid > 0;
              })
              .map((s, i) => {
                const tot = orderTotal(s);
                const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
                const bal = tot - paid;
                return (
                  <div key={`rs-${i}`} style={{ padding: "8px 0", borderBottom: `1px solid ${T.border}15` }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div style={{ fontSize: 12, fontWeight: 700 }}>
                        {s.clientName || "Walk-in"} <span style={{ fontSize: 10, color: T.warning, fontWeight: 400 }}>· Order</span>
                      </div>
                      <div style={{ fontSize: 12, fontWeight: 700, color: T.danger }}>{fmt(bal)}</div>
                    </div>
                    <div style={{ fontSize: 10, color: T.textMuted }}>
                      {s.date} · {s.items && s.items.length > 1 ? `${s.items.length} items` : s.meal} · {s.method}
                    </div>
                  </div>
                );
              })}
            {invoices.filter(i => i.total - i.paid > 0).length === 0 &&
             pSales.filter(s => { const t = orderTotal(s); const p = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : t; return t - p > 0; }).length === 0 && (
              <div style={{ color: T.success, fontSize: 12, padding: "10px 0" }}>✅ All invoices & orders paid</div>
            )}
          </div>
        </>
      ) : (
        <>
          <div style={S.grid(5)}>
            <KpiCard
              label="Total Revenue"
              value={fmtShort(totalRev)}
              sub={fmt(totalRev)}
              icon="💰"
            />
            <KpiCard
              label="Gross Profit"
              value={fmtShort(gp)}
              sub={`${gm}% margin`}
              color={T.success}
              icon="📈"
            />
            <KpiCard
              label="Net Profit"
              value={fmtShort(netProfit)}
              sub={`after ${fmtShort(totalOverheads)} overhead`}
              color={netProfit >= 0 ? T.success : T.danger}
              icon="🏦"
            />
            <KpiCard
              label="Cash Received"
              value={fmtShort(cashRcvd)}
              sub={fmt(cashRcvd)}
              color={T.delivery}
              icon="💵"
              onClick={() => setDrilldown(drilldown === "cash" ? null : "cash")}
            />
            <KpiCard
              label="AR Outstanding"
              value={fmtShort(arOut)}
              sub={fmt(arOut)}
              color={T.danger}
              icon="⚠️"
              onClick={() => setDrilldown(drilldown === "ar" ? null : "ar")}
            />
          </div>

          {/* Drilldown panel for Cash Received / AR Outstanding */}
          {drilldown && (
            <div style={{ ...S.card, marginBottom: 10, borderColor: drilldown === "ar" ? T.danger : T.delivery }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: drilldown === "ar" ? T.danger : T.delivery }}>
                  {drilldown === "ar" ? "⚠️ AR Outstanding — Breakdown" : "💵 Cash Received — Breakdown"}
                </div>
                <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "2px 8px" }} onClick={() => setDrilldown(null)}>✕ Close</button>
              </div>

              {/* Catering invoices */}
              {invoices.filter(i => drilldown === "ar" ? (i.total - i.paid) > 0 : i.paid > 0).length > 0 && (
                <div style={{ marginBottom: 10 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Catering Invoices</div>
                  {invoices.filter(i => drilldown === "ar" ? (i.total - i.paid) > 0 : i.paid > 0).map((inv, i) => {
                    const amt = drilldown === "ar" ? (inv.total - inv.paid) : inv.paid;
                    return (
                      <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: `1px solid ${T.border}20` }}>
                        <div>
                          <div style={{ fontSize: 12, fontWeight: 600 }}>{inv.client}</div>
                          <div style={{ fontSize: 10, color: T.textMuted }}>{inv.num} · {inv.issued}</div>
                        </div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: drilldown === "ar" ? T.danger : T.success }}>{fmt(amt)} XAF</div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Restaurant sales */}
              {(() => {
                const rdItems = pSales.filter(s => {
                  const tot = orderTotal(s);
                  const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
                  return drilldown === "ar" ? (tot - paid) > 0 : paid > 0;
                });
                if (!rdItems.length) return null;
                return (
                  <div>
                    <div style={{ fontSize: 10, fontWeight: 700, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Restaurant Orders</div>
                    {rdItems.map((s, i) => {
                      const tot = orderTotal(s);
                      const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
                      const amt = drilldown === "ar" ? (tot - paid) : paid;
                      return (
                        <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: `1px solid ${T.border}20` }}>
                          <div>
                            <div style={{ fontSize: 12, fontWeight: 600 }}>{s.clientName || "Walk-in"}</div>
                            <div style={{ fontSize: 10, color: T.textMuted }}>{s.date} · {s.items && s.items.length > 1 ? `${s.items.length} items` : s.meal} · {s.method}</div>
                          </div>
                          <div style={{ fontSize: 13, fontWeight: 700, color: drilldown === "ar" ? T.danger : T.success }}>{fmt(amt)} XAF</div>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}

              <div style={{ marginTop: 10, paddingTop: 8, borderTop: `1px solid ${T.border}`, display: "flex", justifyContent: "flex-end" }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: drilldown === "ar" ? T.danger : T.delivery }}>
                  Total: {fmt(drilldown === "ar" ? arOut : cashRcvd)} XAF
                </div>
              </div>
            </div>
          )}

          <div style={{ ...S.grid(2), marginTop: 10 }}>
            <div style={S.card}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <div style={S.cardTitle}>Sales & Profit Chart</div>
                <div style={{ fontSize: 10, color: T.textDim }}>
                  {chartData.length} pts
                </div>
              </div>
              <BarChart data={chartData} height={140} />
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>
                Revenue by Line ({PERIOD_LABELS[period]})
              </div>
              {[
                {
                  label: "🍽️ Rest. & Delivery",
                  val: rdRev,
                  color: T.restaurant,
                  sub: `incl. ${fmt(delFees)} delivery fees`,
                },
                {
                  label: "🎉 Catering Events",
                  val: catRev,
                  color: T.catering,
                  sub: `${pEvents.length} events`,
                },
              ].map((item) => (
                <div key={item.label} style={{ marginBottom: 14 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 3,
                      alignItems: "flex-start",
                    }}
                  >
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 600 }}>
                        {item.label}
                      </div>
                      <div style={{ fontSize: 10, color: T.textDim }}>
                        {item.sub}
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 800,
                          color: item.color,
                        }}
                      >
                        {fmt(item.val)}
                      </div>
                      <div style={{ fontSize: 10, color: T.textMuted }}>
                        {totalRev
                          ? ((item.val / totalRev) * 100).toFixed(0)
                          : 0}
                        %
                      </div>
                    </div>
                  </div>
                  <PBar
                    pct={totalRev ? (item.val / totalRev) * 100 : 0}
                    color={item.color}
                  />
                </div>
              ))}
              <div
                style={{
                  marginTop: 14,
                  paddingTop: 10,
                  borderTop: `1px solid ${T.border}`,
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: 700,
                    color: T.textMuted,
                    marginBottom: 8,
                    letterSpacing: 0.5,
                    textTransform: "uppercase",
                  }}
                >
                  Cost Breakdown
                </div>
                {[
                  ["Revenue", totalRev, T.text],
                  ["COGS", totalCOGS, T.danger],
                  ["Gross Profit", gp, T.success],
                ].map(([k, v, c]) => (
                  <div
                    key={k}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "4px 0",
                      fontSize: 11,
                      borderBottom: `1px solid ${T.border}12`,
                    }}
                  >
                    <span style={{ color: T.textMuted }}>{k}</span>
                    <span style={{ fontWeight: 700, color: c }}>{fmt(v)}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div style={{ ...S.grid(3), marginTop: 10 }}>
            <div style={S.card}>
              <div style={S.cardTitle}>AR Aging (All Open)</div>
              {[
                "Current",
                "1–7 days",
                "8–30 days",
                "31–60 days",
                "61+ days",
              ].map((b) => {
                const v = arBuckets[b] || 0;
                const c =
                  b === "Current"
                    ? T.success
                    : b.includes("61")
                    ? T.danger
                    : T.warning;
                return (
                  <div
                    key={b}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "5px 0",
                      borderBottom: `1px solid ${T.border}15`,
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: 11, color: T.textMuted }}>
                      {b}
                    </span>
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: v > 0 ? c : T.textDim,
                      }}
                    >
                      {fmt(v)}
                    </span>
                  </div>
                );
              })}
              <div
                style={{
                  marginTop: 8,
                  paddingTop: 8,
                  borderTop: `1px solid ${T.border}`,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ fontSize: 12, fontWeight: 700 }}>Total AR</span>
                <span style={{ fontSize: 12, fontWeight: 800, color: T.danger }}>
                  {fmt(Object.values(arBuckets).reduce((s, v) => s + v, 0))}
                </span>
              </div>
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>
                Top Meals by Revenue ({PERIOD_LABELS[period]})
              </div>
              {topMeals.length === 0 && (
                <div style={{ color: T.textDim, fontSize: 11 }}>
                  No sales in this period
                </div>
              )}
              {topMeals.map(([meal, rev], i) => (
                <div
                  key={meal}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginBottom: 8,
                  }}
                >
                  <div
                    style={{
                      width: 16,
                      height: 16,
                      background: T.accent,
                      borderRadius: 3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 9,
                      fontWeight: 800,
                      color: T.bg,
                      flexShrink: 0,
                    }}
                  >
                    {i + 1}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 600,
                        marginBottom: 2,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {meal}
                    </div>
                    <PBar
                      pct={topMeals[0] ? (rev / topMeals[0][1]) * 100 : 0}
                      color={T.restaurant}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: T.restaurant,
                      flexShrink: 0,
                    }}
                  >
                    {fmt(rev)}
                  </div>
                </div>
              ))}
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>Open Invoices</div>
              {invoices
                .filter((i) => i.total - i.paid > 0)
                .sort((a, b) => b.total - b.paid - (a.total - a.paid))
                .map((inv, i) => {
                  const bal = inv.total - inv.paid;
                  const days = daysOD(inv.due);
                  return (
                    <div
                      key={i}
                      style={{
                        marginBottom: 8,
                        paddingBottom: 8,
                        borderBottom: `1px solid ${T.border}15`,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <div style={{ fontSize: 12, fontWeight: 700 }}>
                            {inv.client}
                          </div>
                          <div style={{ fontSize: 10, color: T.textMuted }}>
                            {inv.num} · Due {inv.due}
                          </div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div
                            style={{
                              fontSize: 12,
                              fontWeight: 800,
                              color: T.danger,
                            }}
                          >
                            {fmt(bal)}
                          </div>
                          {days > 0 && (
                            <div style={{ fontSize: 10, color: T.danger }}>
                              {days}d overdue
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <div style={{ ...S.card, marginTop: 10 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <div style={S.cardTitle}>
                Detailed Summary · {PERIOD_LABELS[period]}
              </div>
              <div style={{ fontSize: 10, color: T.textMuted }}>
                {fmtDate(range[0])} – {fmtDate(range[1])}
              </div>
            </div>
            <TableScroll>
              <table style={S.table}>
                <thead>
                  <tr>
                    {[
                      "Period",
                      "R&D Sales",
                      "R&D COGS",
                      "Cat. Revenue",
                      "Cat. COGS",
                      "Total Revenue",
                      "Gross Profit",
                      "GM%",
                      "Overheads",
                      "Net Profit",
                    ].map((h) => (
                      <th key={h} style={S.th}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ ...S.td, fontWeight: 700 }}>
                      {PERIOD_LABELS[period]}
                    </td>
                    <td style={{ ...S.td, color: T.restaurant }}>
                      {fmt(rdRev)}
                    </td>
                    <td style={{ ...S.td, color: T.textMuted }}>
                      {fmt(rdCOGS)}
                    </td>
                    <td style={{ ...S.td, color: T.catering }}>
                      {fmt(catRev)}
                    </td>
                    <td style={{ ...S.td, color: T.textMuted }}>
                      {fmt(catCOGS)}
                    </td>
                    <td style={{ ...S.td, fontWeight: 700 }}>
                      {fmt(totalRev)}
                    </td>
                    <td style={{ ...S.td, color: T.success, fontWeight: 700 }}>
                      {fmt(gp)}
                    </td>
                    <td style={{ ...S.td, color: T.accent, fontWeight: 700 }}>
                      {gm}%
                    </td>
                    <td style={{ ...S.td, color: T.warning }}>
                      {fmt(totalOverheads)}
                    </td>
                    <td
                      style={{
                        ...S.td,
                        color: netProfit >= 0 ? T.success : T.danger,
                        fontWeight: 800,
                      }}
                    >
                      {fmt(netProfit)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </TableScroll>
          </div>
        </>
      )}
    </div>
  );
}

// ─── CATERING (with add event, status dropdown, media) ─────────────
// ─── EVENT COST LEDGER ────────────────────────────────────────────────────────
const COST_CATEGORIES = [
  { id: "ingredient_inv",  label: "Ingredient (from Inventory)", icon: "📦", group: "Ingredients" },
  { id: "ingredient_buy",  label: "Ingredient (Market Purchase)", icon: "🛒", group: "Ingredients" },
  { id: "labour",          label: "Labour / Staff",               icon: "👷", group: "Labour" },
  { id: "transport",       label: "Transport / Delivery",         icon: "🚐", group: "Transport" },
  { id: "equipment",       label: "Equipment Hire",               icon: "🔧", group: "Equipment" },
  { id: "packaging",       label: "Packaging & Disposables",      icon: "📦", group: "Other" },
  { id: "gas_fuel",        label: "Gas / Fuel / Charbon",         icon: "🔥", group: "Other" },
  { id: "other",           label: "Other",                        icon: "📋", group: "Other" },
];

function EventCostLedger({ evt, inventory, onUpdate }) {
  const lines = evt.costLines || [];
  const totalCOGS = lines.reduce((s, l) => s + (Number(l.total) || 0), 0);
  const gp = (evt.revenue || 0) - totalCOGS;
  const margin = evt.revenue ? ((gp / evt.revenue) * 100).toFixed(1) : 0;

  const EMPTY_LINE = { cat: "ingredient_inv", desc: "", qty: 1, unitCost: "", total: 0, invId: null };
  const [adding, setAdding] = useState(false);
  const [editId, setEditId] = useState(null);
  const [nl, setNl] = useState(EMPTY_LINE);

  // Recompute total when qty or unitCost change
  const syncTotal = (patch) => {
    const merged = { ...nl, ...patch };
    const t = Number(merged.qty || 0) * Number(merged.unitCost || 0);
    return { ...merged, total: t };
  };

  const saveLine = () => {
    if (!nl.desc && !nl.invId) return;
    const line = {
      ...nl,
      id: editId || Date.now(),
      qty: Number(nl.qty) || 1,
      unitCost: Number(nl.unitCost) || 0,
      total: Number(nl.qty || 1) * Number(nl.unitCost || 0),
    };
    const updated = editId
      ? lines.map((l) => (l.id === editId ? line : l))
      : [...lines, line];
    onUpdate(updated);
    setAdding(false);
    setEditId(null);
    setNl(EMPTY_LINE);
  };

  const deleteLine = (id) => onUpdate(lines.filter((l) => l.id !== id));

  const startEdit = (line) => {
    setNl({ ...line });
    setEditId(line.id);
    setAdding(true);
  };

  // Group lines by category group for display
  const grouped = {};
  lines.forEach((l) => {
    const cat = COST_CATEGORIES.find((c) => c.id === l.cat) || COST_CATEGORIES[COST_CATEGORIES.length - 1];
    const g = cat.group;
    if (!grouped[g]) grouped[g] = { lines: [], subtotal: 0 };
    grouped[g].lines.push({ ...l, cat });
    grouped[g].subtotal += Number(l.total) || 0;
  });

  // Inventory items for quick-pick
  const invOptions = (inventory || []).filter((i) => Number(i.stock) > 0);

  return (
    <div style={{ marginBottom: 4 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 9, marginBottom: 6 }}>
        <span style={{ fontSize: 10, fontWeight: 700, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.5 }}>
          COSTS (COGS)
        </span>
        {!adding && (
          <button
            style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 8px", color: T.accent, borderColor: T.accent + "50" }}
            onClick={() => { setAdding(true); setEditId(null); setNl(EMPTY_LINE); }}
          >
            + Add Cost
          </button>
        )}
      </div>

      {/* Add / Edit form */}
      {adding && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, padding: 10, marginBottom: 8 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: T.accent, marginBottom: 8 }}>
            {editId ? "Edit Cost Line" : "New Cost Line"}
          </div>

          {/* Category */}
          <div style={{ marginBottom: 7 }}>
            <label style={S.label}>Category</label>
            <select
              style={S.select}
              value={nl.cat}
              onChange={(e) => {
                const patch = syncTotal({ cat: e.target.value, invId: null, desc: "", unitCost: "" });
                setNl(patch);
              }}
            >
              {COST_CATEGORIES.map((c) => (
                <option key={c.id} value={c.id}>{c.icon} {c.label}</option>
              ))}
            </select>
          </div>

          {/* Inventory quick-pick */}
          {nl.cat === "ingredient_inv" && (
            <div style={{ marginBottom: 7 }}>
              <label style={S.label}>Select Inventory Item</label>
              <select
                style={S.select}
                value={nl.invId || ""}
                onChange={(e) => {
                  const item = inventory.find((i) => String(i.id) === e.target.value);
                  if (item) {
                    const patch = syncTotal({
                      invId: item.id,
                      desc: item.name,
                      unitCost: item.costPerUnit,
                    });
                    setNl(patch);
                  } else {
                    setNl(syncTotal({ invId: null }));
                  }
                }}
              >
                <option value="">— pick item —</option>
                {invOptions.map((i) => (
                  <option key={i.id} value={i.id}>
                    {i.name} ({i.stock} {i.unit} @ {fmt(i.costPerUnit)}/{i.unit})
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Description */}
          <div style={{ marginBottom: 7 }}>
            <label style={S.label}>
              {nl.cat === "ingredient_inv" ? "Description / Notes" : "Description"}
            </label>
            <input
              style={S.input}
              placeholder={
                nl.cat === "labour" ? "e.g. Chef Marie — 1 day" :
                nl.cat === "transport" ? "e.g. Van hire Bonapriso" :
                nl.cat === "ingredient_buy" ? "e.g. Poulet frais — market" :
                "Description"
              }
              value={nl.desc}
              onChange={(e) => setNl({ ...nl, desc: e.target.value })}
            />
          </div>

          {/* Qty + Unit Cost */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 7, marginBottom: 7 }}>
            <div>
              <label style={S.label}>
                {nl.cat === "labour" ? "Days / Sessions" :
                 nl.cat === "ingredient_inv" || nl.cat === "ingredient_buy" ? "Qty / kg / L" :
                 "Quantity"}
              </label>
              <input
                type="number"
                style={S.input}
                min="0"
                step="0.1"
                value={nl.qty}
                onChange={(e) => setNl(syncTotal({ qty: e.target.value }))}
              />
            </div>
            <div>
              <label style={S.label}>
                {nl.cat === "labour" ? "Rate / day (XAF)" :
                 nl.cat === "ingredient_inv" || nl.cat === "ingredient_buy" ? "Cost / unit (XAF)" :
                 "Unit Cost (XAF)"}
              </label>
              <input
                type="number"
                style={S.input}
                min="0"
                value={nl.unitCost}
                onChange={(e) => setNl(syncTotal({ unitCost: e.target.value }))}
              />
            </div>
            <div>
              <label style={S.label}>Total (XAF)</label>
              <div style={{ ...S.input, display: "flex", alignItems: "center", fontWeight: 700, color: T.accent, fontSize: 13 }}>
                {fmt(Number(nl.qty || 0) * Number(nl.unitCost || 0))}
              </div>
            </div>
          </div>

          <div style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
            <button style={S.btn("ghost")} onClick={() => { setAdding(false); setEditId(null); setNl(EMPTY_LINE); }}>
              Cancel
            </button>
            <button
              style={S.btn("primary")}
              onClick={saveLine}
              disabled={!nl.desc && !nl.invId}
            >
              {editId ? "Update Line" : "Add Line"}
            </button>
          </div>
        </div>
      )}

      {/* Cost lines grouped */}
      {lines.length === 0 && !adding && (
        <div style={{ fontSize: 11, color: T.textDim, padding: "6px 0", textAlign: "center" }}>
          No cost lines yet — click + Add Cost to start tracking
        </div>
      )}

      {Object.entries(grouped).map(([group, { lines: gLines, subtotal }]) => (
        <div key={group} style={{ marginBottom: 6 }}>
          <div style={{ fontSize: 9, fontWeight: 700, color: T.textDim, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 3 }}>
            {group}
          </div>
          {gLines.map((l) => (
            <div
              key={l.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 5,
                padding: "4px 0",
                borderBottom: `1px solid ${T.border}12`,
                fontSize: 11,
              }}
            >
              <span style={{ color: T.textDim, fontSize: 12, flexShrink: 0 }}>{l.cat.icon}</span>
              <span style={{ flex: 1, color: T.textMuted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={l.desc}>
                {l.desc || l.cat.label}
              </span>
              <span style={{ color: T.textDim, fontSize: 10, flexShrink: 0 }}>
                {l.qty} × {fmt(l.unitCost)}
              </span>
              <span style={{ fontWeight: 700, flexShrink: 0, minWidth: 70, textAlign: "right" }}>
                {fmt(l.total)}
              </span>
              <button
                style={{ background: "none", border: "none", cursor: "pointer", color: T.textDim, padding: "0 2px", fontSize: 11, flexShrink: 0 }}
                onClick={() => startEdit(l)}
                title="Edit"
              >✏️</button>
              <button
                style={{ background: "none", border: "none", cursor: "pointer", color: T.danger, padding: "0 2px", fontSize: 11, flexShrink: 0 }}
                onClick={() => deleteLine(l.id)}
                title="Delete"
              >×</button>
            </div>
          ))}
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: T.textMuted, padding: "2px 0 4px" }}>
            <span>{group} subtotal</span>
            <span style={{ fontWeight: 600 }}>{fmt(subtotal)}</span>
          </div>
        </div>
      ))}

      {/* Summary bar */}
      <div style={{ background: T.surface, borderRadius: 7, padding: "8px 10px", marginTop: 6 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
          <span style={{ fontSize: 11, color: T.textMuted }}>Total COGS</span>
          <span style={{ fontSize: 12, fontWeight: 800, color: T.danger }}>{fmt(totalCOGS)}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
          <span style={{ fontSize: 11, fontWeight: 700 }}>Gross Profit</span>
          <span style={{ fontSize: 13, fontWeight: 800, color: gp >= 0 ? T.success : T.danger }}>{fmt(gp)}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span style={{ fontSize: 10, color: T.textMuted }}>Margin</span>
          <span style={{ fontSize: 11, fontWeight: 700, color: Number(margin) >= 50 ? T.success : Number(margin) >= 25 ? T.warning : T.danger }}>
            {margin}%
          </span>
        </div>
      </div>
    </div>
  );
}

function CateringPage({ events, setEvents, proposals, setProposals, inventory, logo, biz, customers, setCustomers, invoices, setInvoices, catalogItems, setCatalogItems, catalogCategories, setCatalogCategories, catalogMeta, setCatalogMeta, meals, setMeals, proposalPrefillLines, clearProposalPrefill }) {
  const [cateringSubTab, setCateringSubTab] = useState("events");
  const [sel, setSel] = useState(null);
  const [filter, setFilter] = useState("All");
  const [doc, setDoc] = useState(null);
  const [evtPmtPanel, setEvtPmtPanel] = useState(null); // { evtId, amount, method }
  const [addingEvent, setAddingEvent] = useState(false);
  const [mediaEventId, setMediaEventId] = useState(null);
  const [newEvt, setNewEvt] = useState({
    name: "",
    clientName: "",
    clientPhone: "",
    eventDate: "",
    location: "",
    eventType: "Wedding",
    serviceStyle: "Buffet",
    guests: "",
    pricePerHead: "",
    addOns: 0,
    discount: 0,
    phase: "Lead / Inquiry",
    notes: "",
    costs: { inventory: 0, labor: 0, transport: 0, overhead: 0 },
    costLines: [],
  });
  const isMobile = useIsMobile();

  const filtered =
    filter === "All" ? events : events.filter((e) => e.phase === filter);
  const evt = sel != null ? events.find((e) => e.id === sel) : null;
  const mediaEvt =
    mediaEventId != null ? events.find((e) => e.id === mediaEventId) : null;
  const openDoc = (title, html) =>
    setDoc({ title, html, onPrint: () => printDoc(title, html) });

  const saveEvent = () => {
    const revenue =
      newEvt.guests * newEvt.pricePerHead +
      Number(newEvt.addOns) -
      Number(newEvt.discount);
    const e = {
      ...newEvt,
      id: Date.now(),
      revenue,
      guests: Number(newEvt.guests),
      pricePerHead: Number(newEvt.pricePerHead),
      addOns: Number(newEvt.addOns),
      discount: Number(newEvt.discount),
      media: [],
      costs: { inventory: 0, labor: 0, transport: 0, overhead: 0 },
      costLines: [],
    };
    setEvents((prev) => [...prev, e]);
    setAddingEvent(false);
    setNewEvt({
      name: "",
      clientName: "",
      clientPhone: "",
      eventDate: "",
      location: "",
      eventType: "Wedding",
      serviceStyle: "Buffet",
      guests: "",
      pricePerHead: "",
      addOns: 0,
      discount: 0,
      phase: "Lead / Inquiry",
      notes: "",
      costs: { inventory: 0, labor: 0, transport: 0, overhead: 0 },
    });

    // Auto-upsert customer from catering event
    if (newEvt.clientName && newEvt.clientName.trim()) {
      const name = newEvt.clientName.trim();
      const phone = (newEvt.clientPhone || "").trim();
      setCustomers(prev => {
        const idx = prev.findIndex(c => c.name.toLowerCase() === name.toLowerCase());
        if (idx >= 0) {
          const updated = [...prev];
          updated[idx] = { ...updated[idx], phone: updated[idx].phone || phone };
          return updated;
        }
        return [...prev, { id: Date.now() + 1, name, phone, email: "", classification: "Regular", notes: "", createdAt: TODAY_ISO }];
      });
    }
  };

  const updatePhase = (id, phase) => {
    setEvents((prev) => prev.map((e) => (e.id === id ? { ...e, phase } : e)));
    if (evt && evt.id === id) {
      /* already reactive */
    }
  };

  const deleteEvent = (id) => {
    if (!window.confirm("Delete this event and all its cost lines? This cannot be undone.")) return;
    setEvents((prev) => prev.filter((e) => e.id !== id));
    setSel(null);
  };

  const addMedia = (id, mediaItem) =>
    setEvents((prev) =>
      prev.map((e) =>
        e.id === id ? { ...e, media: [...(e.media || []), mediaItem] } : e
      )
    );
  const deleteMedia = (id, mediaId) =>
    setEvents((prev) =>
      prev.map((e) =>
        e.id === id
          ? { ...e, media: (e.media || []).filter((m) => m.id !== mediaId) }
          : e
      )
    );
  const updateMedia = (id, mediaId, patch) =>
    setEvents((prev) =>
      prev.map((e) =>
        e.id === id
          ? { ...e, media: (e.media || []).map((m) => m.id === mediaId ? { ...m, ...patch } : m) }
          : e
      )
    );

  const updateCostLines = (id, lines) =>
    setEvents((prev) =>
      prev.map((e) => e.id === id ? { ...e, costLines: lines } : e)
    );

  return (
    <div>
      <DocModal doc={doc} onClose={() => setDoc(null)} />

      {/* ── Event Payment Panel ─────────────────────────────────── */}
      {evtPmtPanel !== null && (() => {
        const evt = events.find(e => e.id === evtPmtPanel.evtId);
        if (!evt) return null;
        const linkedInv = invoices.find(i => i.eventId === evt.id)
          || invoices.find(i => i.client?.toLowerCase() === evt.clientName?.toLowerCase() && i.total === evt.revenue);
        const invTotal = linkedInv ? linkedInv.total : evt.revenue;
        const invPaid  = linkedInv ? linkedInv.paid  : 0;
        const bal = invTotal - invPaid;
        const deposit = Math.round(invTotal * 0.5);

        const recordEvtPmt = () => {
          const amt = Number(evtPmtPanel.amount);
          if (!amt || isNaN(amt) || amt <= 0) return;
          const today = new Date().toISOString().slice(0, 10);
          if (linkedInv) {
            setInvoices(prev => prev.map(i => {
              if (i.id !== linkedInv.id) return i;
              const newPaid = Math.min(i.paid + amt, i.total);
              return { ...i, paid: newPaid, status: newPaid >= i.total ? "Paid" : newPaid > 0 ? "Partially Paid" : "Unpaid", lastPaymentMethod: evtPmtPanel.method, lastPaymentDate: today };
            }));
          } else {
            const invNum = `INV-${THIS_YEAR}-${String(evt.id).slice(-4).padStart(4, "0")}`;
            const newPaid = Math.min(amt, invTotal);
            setInvoices(prev => {
              if (prev.some(i => i.num === invNum)) return prev;
              return [...prev, { id: evt.id, num: invNum, client: evt.clientName, clientPhone: evt.clientPhone || "", issued: today, due: evt.eventDate || today, total: invTotal, paid: newPaid, status: newPaid >= invTotal ? "Paid" : newPaid > 0 ? "Partially Paid" : "Unpaid", eventId: evt.id, lastPaymentMethod: evtPmtPanel.method, lastPaymentDate: today, notes: `Payment recorded from event: ${evt.name}` }];
            });
          }
          setEvtPmtPanel(null);
        };

        return (
          <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.72)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
            onClick={() => setEvtPmtPanel(null)}>
            <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, width:"100%", maxWidth:440, padding:24 }}
              onClick={e => e.stopPropagation()}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
                <div>
                  <div style={{ fontSize:14, fontWeight:700 }}>💳 Record Payment</div>
                  <div style={{ fontSize:11, color:T.textMuted, marginTop:2 }}>{evt.name}</div>
                  <div style={{ fontSize:10, color:T.textDim }}>{evt.clientName} · {evt.eventDate}</div>
                </div>
                <button style={{ background:"none", border:"none", color:T.textDim, cursor:"pointer", fontSize:18 }} onClick={() => setEvtPmtPanel(null)}>✕</button>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:16 }}>
                {[["Event Total", fmt(invTotal), T.text], ["Paid to Date", fmt(invPaid), T.success], ["Balance Due", fmt(bal), bal > 0 ? T.danger : T.success]].map(([l,v,c]) => (
                  <div key={l} style={{ background:T.surface, borderRadius:8, padding:"8px 10px" }}>
                    <div style={{ fontSize:9, color:T.textMuted, textTransform:"uppercase", letterSpacing:0.5, marginBottom:2 }}>{l}</div>
                    <div style={{ fontSize:13, fontWeight:800, color:c }}>{v}</div>
                  </div>
                ))}
              </div>
              {bal <= 0 ? (
                <div style={{ textAlign:"center", padding:"16px 0", color:T.success, fontWeight:700, fontSize:14 }}>✅ This event is fully paid</div>
              ) : (
                <>
                  <div style={{ marginBottom:10 }}>
                    <div style={{ fontSize:10, color:T.textMuted, marginBottom:5, textTransform:"uppercase", letterSpacing:0.5 }}>Quick amounts</div>
                    <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                      {[["50% Deposit", deposit], ["Balance Due", bal], ["Full Total", invTotal]].map(([label, amt]) => (
                        <button key={label} style={{ ...S.btn(Number(evtPmtPanel.amount) === amt ? "primary" : "ghost"), fontSize:10, padding:"3px 10px" }}
                          onClick={() => setEvtPmtPanel(p => ({ ...p, amount: String(amt) }))}>
                          {label} ({fmt(amt)})
                        </button>
                      ))}
                    </div>
                  </div>
                  <div style={{ marginBottom:12 }}>
                    <label style={S.label}>Amount Received (XAF)</label>
                    <input type="number" style={{ ...S.input, fontSize:16, fontWeight:700 }} value={evtPmtPanel.amount}
                      onChange={e => setEvtPmtPanel(p => ({ ...p, amount: e.target.value }))} autoFocus />
                  </div>
                  <div style={{ marginBottom:16 }}>
                    <label style={S.label}>Payment Method</label>
                    <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                      {["Mobile Money", "Cash", "Bank Transfer", "Cheque"].map(m => (
                        <button key={m} style={{ ...S.btn(evtPmtPanel.method === m ? "primary" : "ghost"), fontSize:11, padding:"4px 12px" }}
                          onClick={() => setEvtPmtPanel(p => ({ ...p, method: m }))}>{m}</button>
                      ))}
                    </div>
                  </div>
                  {!linkedInv && (
                    <div style={{ fontSize:10, color:T.textMuted, background:T.surface, borderRadius:6, padding:"6px 10px", marginBottom:12 }}>
                      ℹ️ No invoice found — one will be created automatically with this payment.
                    </div>
                  )}
                  <div style={{ display:"flex", gap:8 }}>
                    <button style={{ ...S.btn("primary"), flex:1 }} onClick={recordEvtPmt}>
                      ✅ Record {evtPmtPanel.amount ? fmt(Number(evtPmtPanel.amount)) : ""} via {evtPmtPanel.method}
                    </button>
                    <button style={{ ...S.btn("ghost"), padding:"6px 14px" }} onClick={() => setEvtPmtPanel(null)}>Cancel</button>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })()}

      {/* Media lightbox modal */}
      {mediaEvt && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.92)",
            zIndex: 1500,
            display: "flex",
            flexDirection: "column",
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) setMediaEventId(null);
          }}
        >
          <div
            style={{
              padding: "14px 20px",
              borderBottom: `1px solid ${T.border}`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: T.surface,
            }}
          >
            <div style={{ fontWeight: 700 }}>
              📷 Media — {mediaEvt.name} ({(mediaEvt.media || []).length} files)
            </div>
            <button
              style={{ ...S.btn("ghost"), fontSize: 11 }}
              onClick={() => setMediaEventId(null)}
            >
              ✕ Close
            </button>
          </div>
          <div style={{ flex: 1, overflow: "auto", padding: 20 }}>
            <PhasedMediaGallery
              media={mediaEvt.media || []}
              onAdd={(m) => addMedia(mediaEvt.id, m)}
              onDelete={(mid) => deleteMedia(mediaEvt.id, mid)}
              onUpdate={(mid, patch) => updateMedia(mediaEvt.id, mid, patch)}
              currentPhase={mediaEvt.phase}
            />
          </div>
        </div>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 4,
        }}
      >
        <div>
          <div style={S.pageTitle}>🎉 Catering Pipeline</div>
          <div style={S.subtitle}>
            {events.length} events ·{" "}
            {fmt(events.reduce((s, e) => s + e.revenue, 0))} total pipeline
          </div>
        </div>
        <button
          style={S.btn("primary")}
          onClick={() => setAddingEvent(!addingEvent)}
        >
          + New Event
        </button>
      </div>

      {/* Sub-tab nav */}
      <div style={{ ...S.row, gap: 6, marginBottom: 14, flexWrap: "wrap" }}>
        <button style={{ ...S.btn(cateringSubTab === "events" ? "primary" : "ghost"), fontSize: 13 }} onClick={() => setCateringSubTab("events")}>🎉 Events</button>
        <button style={{ ...S.btn(cateringSubTab === "proposals" ? "primary" : "ghost"), fontSize: 13 }} onClick={() => setCateringSubTab("proposals")}>📋 Proposals</button>
        <button style={{ ...S.btn(cateringSubTab === "catalog" ? "primary" : "ghost"), fontSize: 13 }} onClick={() => setCateringSubTab("catalog")}>📦 Catalog</button>
      </div>

      {cateringSubTab === "proposals" && (
        <ProposalsPage
          proposals={proposals}
          setProposals={setProposals}
          events={events}
          setEvents={setEvents}
          invoices={invoices}
          setInvoices={setInvoices}
          customers={customers}
          setCustomers={setCustomers}
          catalogItems={catalogItems}
          setCatalogItems={setCatalogItems}
          catalogCategories={catalogCategories}
          setCatalogCategories={setCatalogCategories}
          meals={meals}
          inventory={inventory}
          logo={logo}
          biz={biz}
          proposalPrefillLines={proposalPrefillLines}
          clearProposalPrefill={clearProposalPrefill}
        />
      )}

      {cateringSubTab === "catalog" && (
        <CatalogPage
          categories={catalogCategories}
          setCategories={setCatalogCategories}
          items={catalogItems}
          setItems={setCatalogItems}
          meals={meals}
          setMeals={setMeals}
          logo={logo}
          biz={biz}
          catalogMeta={catalogMeta}
          setCatalogMeta={setCatalogMeta}
          onCreateProposalFromCatalog={(lines) => {
            if (clearProposalPrefill) clearProposalPrefill();
            setCateringSubTab("proposals");
          }}
        />
      )}

      {cateringSubTab === "events" && (<>

      {/* Add Event Form */}
      {addingEvent && (
        <div style={{ ...S.card, marginBottom: 14, borderColor: T.accent }}>
          <div style={S.sectionTitle}>Add New Catering Event</div>
          <div style={S.grid(3)}>
            <div>
              <label style={S.label}>Event Name</label>
              <input
                style={S.input}
                value={newEvt.name}
                onChange={(e) => setNewEvt({ ...newEvt, name: e.target.value })}
                placeholder="e.g. Kamga Wedding · MTN Staff Party"
              />
            </div>
            <div>
              <label style={S.label}>Client Name</label>
              <input
                style={S.input}
                list="cat-customer-list"
                value={newEvt.clientName}
                onChange={(e) => {
                  const val = e.target.value;
                  const match = customers.find(c => c.name === val);
                  setNewEvt({ ...newEvt, clientName: val, clientPhone: match ? match.phone : newEvt.clientPhone });
                }}
              />
              <datalist id="cat-customer-list">
                {customers.map(c => <option key={c.id} value={c.name}>{c.name}{c.phone ? ` · ${c.phone}` : ""}</option>)}
              </datalist>
            </div>
            <div>
              <label style={S.label}>Client Phone</label>
              <input
                style={S.input}
                value={newEvt.clientPhone}
                onChange={(e) =>
                  setNewEvt({ ...newEvt, clientPhone: e.target.value })
                }
              />
            </div>
            <div>
              <label style={S.label}>Event Date</label>
              <input
                type="date"
                style={S.input}
                value={newEvt.eventDate}
                onChange={(e) =>
                  setNewEvt({ ...newEvt, eventDate: e.target.value })
                }
              />
            </div>
            <div>
              <label style={S.label}>Location</label>
              <input
                style={S.input}
                value={newEvt.location}
                onChange={(e) =>
                  setNewEvt({ ...newEvt, location: e.target.value })
                }
              />
            </div>
            <div>
              <label style={S.label}>Event Type</label>
              <select
                style={S.select}
                value={newEvt.eventType}
                onChange={(e) =>
                  setNewEvt({ ...newEvt, eventType: e.target.value })
                }
              >
                {[
                  "Wedding",
                  "Corporate",
                  "Birthday",
                  "Private",
                  "Funeral",
                  "Other",
                ].map((t) => (
                  <option key={t}>{t}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={S.label}>Service Style</label>
              <select
                style={S.select}
                value={newEvt.serviceStyle}
                onChange={(e) =>
                  setNewEvt({ ...newEvt, serviceStyle: e.target.value })
                }
              >
                {[
                  "Buffet",
                  "Plated",
                  "Cocktail",
                  "Family Style",
                  "Box Lunch",
                ].map((s) => (
                  <option key={s}>{s}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={S.label}>Guest Count</label>
              <input
                type="number"
                style={S.input}
                value={newEvt.guests}
                onChange={(e) =>
                  setNewEvt({ ...newEvt, guests: e.target.value })
                }
              />
            </div>
            <div>
              <label style={S.label}>Price per Head (XAF)</label>
              <input
                type="number"
                style={S.input}
                value={newEvt.pricePerHead}
                onChange={(e) =>
                  setNewEvt({ ...newEvt, pricePerHead: e.target.value })
                }
              />
            </div>
            <div>
              <label style={S.label}>Add-ons (XAF)</label>
              <input
                type="number"
                style={S.input}
                value={newEvt.addOns}
                onChange={(e) =>
                  setNewEvt({ ...newEvt, addOns: e.target.value })
                }
              />
            </div>
            <div>
              <label style={S.label}>Discount (XAF)</label>
              <input
                type="number"
                style={S.input}
                value={newEvt.discount}
                onChange={(e) =>
                  setNewEvt({ ...newEvt, discount: e.target.value })
                }
              />
            </div>
            <div>
              <label style={S.label}>Pipeline Stage</label>
              <select
                style={S.select}
                value={newEvt.phase}
                onChange={(e) =>
                  setNewEvt({ ...newEvt, phase: e.target.value })
                }
              >
                {PIPELINE_PHASES.map((p) => (
                  <option key={p}>{p}</option>
                ))}
              </select>
            </div>
          </div>
          <div style={{ marginTop: 8, background: T.surface, borderRadius: 7, padding: "8px 12px", fontSize: 11, color: T.textMuted }}>
            💡 Save the event first, then add detailed cost lines (ingredients, labour, transport, etc.) directly in the event panel.
          </div>
          <div style={{ marginTop: 8 }}>
            <label style={S.label}>Notes</label>
            <textarea
              style={{ ...S.input, height: 56 }}
              value={newEvt.notes}
              onChange={(e) => setNewEvt({ ...newEvt, notes: e.target.value })}
            />
          </div>
          <div
            style={{
              marginTop: 10,
              padding: 10,
              background: T.surface,
              borderRadius: 7,
              fontSize: 12,
              display: "flex",
              gap: 20,
            }}
          >
            <span>
              Est. Revenue:{" "}
              <strong style={{ color: T.accent }}>
                {fmt(
                  Number(newEvt.guests) * Number(newEvt.pricePerHead) +
                    Number(newEvt.addOns) -
                    Number(newEvt.discount)
                )}
              </strong>
            </span>
            <span>
              Est. COGS:{" "}
              <strong style={{ color: T.textMuted }}>add lines after saving</strong>
            </span>
          </div>
          <div style={{ ...S.row, marginTop: 10, justifyContent: "flex-end" }}>
            <button
              style={S.btn("ghost")}
              onClick={() => setAddingEvent(false)}
            >
              Cancel
            </button>
            <button
              style={S.btn("primary")}
              onClick={saveEvent}
              disabled={!newEvt.name || !newEvt.clientName}
            >
              Save Event
            </button>
          </div>
        </div>
      )}

      <div
        style={{ display: "flex", gap: 3, marginBottom: 14, flexWrap: "wrap" }}
      >
        {isMobile ? (
          <select
            style={{ ...S.select, maxWidth: 200 }}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            {["All", ...PIPELINE_PHASES].map((p) => (
              <option key={p}>{p}</option>
            ))}
          </select>
        ) : (
          ["All", ...PIPELINE_PHASES.slice(0, 7)].map((p) => (
            <button
              key={p}
              style={S.navBtn(filter === p)}
              onClick={() => setFilter(p)}
            >
              {p}
            </button>
          ))
        )}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: !isMobile && evt ? "1fr 360px" : "1fr",
          gap: 10,
        }}
      >
        <div>
          {filtered.map((e) => {
            const cogs = evtCOGS(e);
            const profit = e.revenue - cogs;
            const margin = e.revenue
              ? ((profit / e.revenue) * 100).toFixed(0)
              : 0;
            const mediaCount = (e.media || []).length;
            return (
              <div
                key={e.id}
                style={{
                  ...S.card,
                  marginBottom: 8,
                  cursor: "pointer",
                  borderColor: sel === e.id ? T.accent : T.border,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                  onClick={() => setSel(e.id === sel ? null : e.id)}
                >
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{ fontSize: 13, fontWeight: 700, marginBottom: 2 }}
                    >
                      {e.name}
                    </div>
                    <div
                      style={{
                        fontSize: 11,
                        color: T.textMuted,
                        marginBottom: 5,
                      }}
                    >
                      {e.clientName} · {e.eventDate} · {e.location}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: 4,
                        flexWrap: "wrap",
                        alignItems: "center",
                      }}
                    >
                      <PhaseBadge phase={e.phase} />
                      <Badge color={T.textMuted}>{e.serviceStyle}</Badge>
                      <Badge color={T.delivery}>{e.guests} guests</Badge>
                      {mediaCount > 0 && (
                        <Badge color={T.info}>📷 {mediaCount}</Badge>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      marginLeft: 10,
                      flexShrink: 0,
                    }}
                  >
                    <div
                      style={{ fontSize: 13, fontWeight: 800, color: T.accent }}
                    >
                      {fmt(e.revenue)}
                    </div>
                    <div
                      style={{
                        fontSize: 10,
                        color: profit >= 0 ? T.success : T.danger,
                      }}
                    >
                      Profit: {fmt(profit)} ({margin}%)
                    </div>
                  </div>
                </div>
                {/* Inline status + media row */}
                <div
                  style={{
                    display: "flex",
                    gap: 6,
                    marginTop: 8,
                    alignItems: "center",
                  }}
                  onClick={(ev) => ev.stopPropagation()}
                >
                  <div style={{ flex: 1 }}>
                    <select
                      style={{ ...S.select, fontSize: 11, padding: "4px 8px" }}
                      value={e.phase}
                      onChange={(ev) => updatePhase(e.id, ev.target.value)}
                    >
                      {PIPELINE_PHASES.map((p) => (
                        <option key={p}>{p}</option>
                      ))}
                    </select>
                  </div>
                  <button
                    style={{
                      ...S.btn("ghost"),
                      fontSize: 10,
                      padding: "4px 8px",
                      borderColor: T.info,
                      color: T.info,
                    }}
                    onClick={() => setMediaEventId(e.id)}
                  >
                    📷 Media {mediaCount > 0 ? `(${mediaCount})` : ""}
                  </button>
                </div>
              </div>
            );
          })}
          {filtered.length === 0 && (
            <div
              style={{
                color: T.textMuted,
                padding: 20,
                textAlign: "center",
                fontSize: 12,
              }}
            >
              No events in this phase
            </div>
          )}
        </div>

        {evt && (
          <div
            style={{
              ...S.card,
              position: "sticky",
              top: 14,
              alignSelf: "start",
              maxHeight: "85vh",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 8,
              }}
            >
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 700,
                  flex: 1,
                  minWidth: 0,
                  marginRight: 6,
                }}
              >
                {evt.name}
              </div>
              <button
                onClick={() => setSel(null)}
                style={{
                  background: "none",
                  border: "none",
                  color: T.textMuted,
                  cursor: "pointer",
                  fontSize: 15,
                  flexShrink: 0,
                }}
              >
                ×
              </button>
            </div>
            <div style={{ marginBottom: 8 }}>
              <label style={S.label}>Pipeline Stage</label>
              <select
                style={S.select}
                value={evt.phase}
                onChange={(e) => updatePhase(evt.id, e.target.value)}
              >
                {PIPELINE_PHASES.map((p) => (
                  <option key={p}>{p}</option>
                ))}
              </select>
            </div>
            <Divider />
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 7,
                fontSize: 11,
                marginBottom: 8,
              }}
            >
              {[
                ["Client", evt.clientName],
                ["Phone", evt.clientPhone],
                ["Date", evt.eventDate],
                ["Location", evt.location],
                ["Type", evt.eventType],
                ["Style", evt.serviceStyle],
                ["Guests", evt.guests],
                ["Price/Head", fmt(evt.pricePerHead)],
              ].map(([k, v]) => (
                <div key={k}>
                  <span style={{ color: T.textMuted, fontSize: 10 }}>{k}:</span>
                  <br />
                  <strong style={{ fontSize: 11 }}>{v}</strong>
                </div>
              ))}
            </div>
            <Divider />
            {[
              ["Guests × Price/Head", evt.guests * evt.pricePerHead],
              ["Add-ons", evt.addOns],
              ["Discount", -evt.discount],
              ["TOTAL", evt.revenue],
            ].map(([k, v]) => (
              <div
                key={k}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 11,
                  padding: "3px 0",
                  borderBottom:
                    k === "TOTAL"
                      ? `1px solid ${T.accent}`
                      : `1px solid ${T.border}12`,
                  fontWeight: k === "TOTAL" ? 700 : 400,
                }}
              >
                <span style={{ color: k === "TOTAL" ? T.text : T.textMuted }}>
                  {k}
                </span>
                <span
                  style={{
                    color:
                      k === "TOTAL" ? T.accent : v < 0 ? T.danger : "inherit",
                  }}
                >
                  {v < 0 ? `-${fmt(-v)}` : fmt(v)}
                </span>
              </div>
            ))}
            <EventCostLedger
              evt={evt}
              inventory={inventory || []}
              onUpdate={(lines) => updateCostLines(evt.id, lines)}
            />
            <Divider />
            {/* Media section in side panel */}
            <PhasedMediaGallery
              media={evt.media || []}
              onAdd={(m) => addMedia(evt.id, m)}
              onDelete={(mid) => deleteMedia(evt.id, mid)}
              onUpdate={(mid, patch) => updateMedia(evt.id, mid, patch)}
              currentPhase={evt.phase}
            />
            <Divider />
            {/* Linked Proposals section */}
            {(() => {
              const linked = (proposals || []).filter((p) => p.eventId === evt.id);
              return (
                <div style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: linked.length ? 7 : 4 }}>
                    📋 Linked Proposals ({linked.length})
                  </div>
                  {linked.length === 0 ? (
                    <div style={{ fontSize: 11, color: T.textDim }}>No proposals linked. Go to Proposals to link or convert one.</div>
                  ) : (
                    linked.map((p) => (
                      <div key={p.id} style={{ background: T.surface, borderRadius: 7, padding: "7px 10px", marginBottom: 5, border: `1px solid ${T.border}` }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <div>
                            <div style={{ fontSize: 11, fontWeight: 700 }}>{p.num}</div>
                            <div style={{ fontSize: 10, color: T.textMuted }}>{p.lines?.length || 0} items · {fmt(propTotal(p.lines, p.discount))}</div>
                          </div>
                          <Badge color={{ Draft: T.textMuted, Sent: T.info, Approved: T.success, "Converted to Event": T.catering, Declined: T.danger }[p.status] || T.textMuted}>
                            {p.status}
                          </Badge>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              );
            })()}
            <Divider />
            <div style={{ display: "flex", gap: 5, flexWrap: "wrap", alignItems: "center" }}>
              {/* Payment status badge */}
              {(() => {
                const linkedInv = invoices.find(i => i.eventId === evt.id);
                if (!linkedInv && evt.revenue > 0) return (
                  <span style={{ fontSize:10, color:T.danger, background:T.danger+"12", border:`1px solid ${T.danger}30`, padding:"3px 8px", borderRadius:10, fontWeight:700 }}>❌ Unpaid</span>
                );
                if (!linkedInv) return null;
                const bal = linkedInv.total - linkedInv.paid;
                if (bal <= 0) return <span style={{ fontSize:10, color:T.success, background:T.success+"12", border:`1px solid ${T.success}30`, padding:"3px 8px", borderRadius:10, fontWeight:700 }}>✅ Paid</span>;
                if (linkedInv.paid > 0) return <span style={{ fontSize:10, color:T.warning, background:T.warning+"12", border:`1px solid ${T.warning}30`, padding:"3px 8px", borderRadius:10, fontWeight:700 }}>⏳ {fmt(bal)} outstanding</span>;
                return <span style={{ fontSize:10, color:T.danger, background:T.danger+"12", border:`1px solid ${T.danger}30`, padding:"3px 8px", borderRadius:10, fontWeight:700 }}>❌ {fmt(linkedInv.total)} unpaid</span>;
              })()}

              {/* Record Payment button — shown when there's an outstanding balance */}
              {evt.revenue > 0 && (() => {
                const linkedInv = invoices.find(i => i.eventId === evt.id);
                const paid = linkedInv ? linkedInv.paid : 0;
                const total = linkedInv ? linkedInv.total : evt.revenue;
                const bal = total - paid;
                if (bal <= 0) return null;
                return (
                  <button
                    style={{ ...S.btn("primary"), fontSize: 10, padding: "4px 9px", background: T.success, borderColor: T.success }}
                    onClick={(e) => { e.stopPropagation(); setEvtPmtPanel({ evtId: evt.id, amount: String(Math.round(total * 0.5)), method: "Mobile Money" }); }}
                  >
                    💳 Record Payment
                  </button>
                );
              })()}
              <button
                style={{
                  ...S.btn("primary"),
                  fontSize: 10,
                  padding: "4px 9px",
                }}
                onClick={() => {
                  const invNum = `INV-${THIS_YEAR}-${String(evt.id).padStart(4, "0")}`;
                  const inv = {
                    id: evt.id,
                    num: invNum,
                    client: evt.clientName,
                    clientPhone: evt.clientPhone,
                    issued: evt.eventDate,
                    due: evt.eventDate,
                    total: evt.revenue,
                    paid: 0,
                    status: "Unpaid",
                    eventId: evt.id,
                    notes: "",
                  };
                  openDoc(
                    `Invoice – ${evt.name}`,
                    buildInvoiceHTML(inv, evt, biz, logo)
                  );
                  // Save to AR (invoices) if not already there
                  if (setInvoices) {
                    setInvoices(prev => {
                      const exists = prev.some(i => i.num === invNum);
                      if (exists) return prev;
                      return [...prev, inv];
                    });
                  }
                  // Auto-upsert customer
                  if (evt.clientName && evt.clientName.trim() && setCustomers) {
                    const name = evt.clientName.trim();
                    const phone = (evt.clientPhone || "").trim();
                    setCustomers(prev => {
                      const idx = prev.findIndex(c => c.name.toLowerCase() === name.toLowerCase());
                      if (idx >= 0) {
                        const updated = [...prev];
                        updated[idx] = { ...updated[idx], phone: updated[idx].phone || phone };
                        return updated;
                      }
                      return [...prev, { id: Date.now() + 2, name, phone, email: "", classification: "Regular", notes: "", createdAt: evt.eventDate || TODAY_ISO }];
                    });
                  }
                }}
              >
                📄 Invoice
              </button>
              <button
                style={{ ...S.btn("ghost"), fontSize: 10, padding: "4px 9px" }}
                onClick={() => {
                  const inv = {
                    num: `INV-${THIS_YEAR}-${String(evt.id).padStart(4, "0")}`,
                    client: evt.clientName,
                    clientPhone: evt.clientPhone,
                    issued: evt.eventDate,
                    due: evt.eventDate,
                    total: evt.revenue,
                    paid: evt.revenue,
                    status: "Paid",
                    notes: "",
                  };
                  openDoc(
                    `Receipt – ${evt.name}`,
                    buildReceiptHTML(inv, biz, logo)
                  );
                }}
              >
                🧾 Receipt
              </button>
              <button
                style={{ ...S.btn("ghost"), fontSize: 10, padding: "4px 9px", color: T.danger, borderColor: T.danger + "40", marginLeft: "auto" }}
                onClick={() => deleteEvent(evt.id)}
              >
                🗑 Delete Event
              </button>
            </div>
            {evt.notes && (
              <div
                style={{
                  fontSize: 10,
                  color: T.textMuted,
                  background: T.surface,
                  padding: 7,
                  borderRadius: 5,
                  marginTop: 7,
                }}
              >
                {evt.notes}
              </div>
            )}
          </div>
        )}
      </div>
    </>)}
    </div>
  );
}
function CatalogPage({ categories, setCategories, items, setItems, meals, setMeals, logo, biz, onCreateProposalFromCatalog, catalogMeta, setCatalogMeta }) {
  const [selCat, setSelCat] = useState(null); // null = tile overview, number = category id
  const [adding, setAdding] = useState(false);
  const [editId, setEditId] = useState(null);
  const [addingCat, setAddingCat] = useState(false);
  const [newCatName, setNewCatName] = useState("");
  const [editingCatId, setEditingCatId] = useState(null);
  const [editingCatName, setEditingCatName] = useState("");
  const [search, setSearch] = useState("");
  const EMPTY_NI = { catId: categories[0]?.id || 1, name: "", unitType: "Per head", price: "", costPerUnit: "", tags: "", description: "", notes: "", photo: null };
  const [ni, setNi] = useState(EMPTY_NI);
  const [doc, setDoc] = useState(null);
  const photoRef = useRef();

  const filtered = selCat
    ? items.filter(i => i.catId === selCat && (!search || i.name.toLowerCase().includes(search.toLowerCase())))
    : items.filter(i => !search || i.name.toLowerCase().includes(search.toLowerCase()));

  const copyToMeals = (item) => {
    if (!setMeals) return;
    const alreadyExists = meals.some(m => m.name.toLowerCase() === item.name.toLowerCase());
    if (alreadyExists) {
      alert(`"${item.name}" already exists in Meals.`);
      return;
    }
    setMeals(prev => [...prev, {
      id: Date.now(),
      name: item.name,
      description: item.description || "",
      price: 0,
      category: item.catId ? (categories.find(c => c.id === item.catId)?.name || categories[0]?.name || "Main") : (categories[0]?.name || "Main"),
      photo: item.photo || null,
      active: true,
      ingredientLinks: [],
      laborCost: "",
      otherCosts: [],
      availablePortions: "",
    }]);
    alert(`✅ "${item.name}" copied to Meals. Open the Meals tab to set the price and details.`);
  };

  const handlePhoto = async (e, forItem = null) => {
    const f = e.target.files[0]; if (!f) return;
    const src = await uploadFile(f, "catalog");
    if (!src) { alert("❌ Photo upload failed. Please check your internet connection and try again."); return; }
    if (forItem != null) {
      const updatedItem = items.find(it => it.id === forItem);
      setItems(prev => prev.map(it => it.id === forItem ? { ...it, photo: src } : it));
      // Sync to matching meal by name
      if (updatedItem && setMeals) {
        setMeals(prev => prev.map(m =>
          m.name.toLowerCase() === updatedItem.name.toLowerCase() ? { ...m, photo: src } : m
        ));
      }
    } else {
      setNi(n => ({ ...n, photo: src }));
    }
  };

  const pullFromMeal = (mealId) => {
    if (!mealId) return;
    const m = meals.find(ml => String(ml.id) === String(mealId));
    if (!m) return;
    setNi(prev => ({
      ...prev,
      name: m.name || prev.name,
      price: m.price ? String(m.price) : prev.price,
      description: m.description || prev.description,
      photo: m.photo || prev.photo,
      unitType: "Per head",
    }));
  };

  const save = () => {
    if (!ni.name) return;
    const tags = typeof ni.tags === "string" ? ni.tags.split(",").map(t => t.trim()).filter(Boolean) : ni.tags;
    const item = { ...ni, price: 0, costPerUnit: 0, tags };
    if (editId != null) {
      setItems(prev => prev.map(it => it.id === editId ? { ...item, id: editId } : it));
      setEditId(null);
      if (item.catId !== selCat) setSelCat(item.catId);
      // Persist unitType / tags / notes so they survive catalog rebuilds
      if (setCatalogMeta) {
        const key = ni.name.toLowerCase();
        setCatalogMeta(prev => ({ ...prev, [key]: { unitType: item.unitType, tags, notes: item.notes || "" } }));
      }
    } else {
      setItems(prev => [...prev, { ...item, id: Date.now() }]);
    }
    // Sync photo to matching meal by name
    if (item.photo && setMeals) {
      setMeals(prev => prev.map(m =>
        m.name.toLowerCase() === item.name.toLowerCase() ? { ...m, photo: item.photo } : m
      ));
    }
    setAdding(false);
    setNi({ ...EMPTY_NI, catId: selCat || (categories[0]?.id || 1) });
  };

  const startEdit = (item) => {
    // Auto-fill photo from matching meal if catalog item has none
    const mealMatch = meals.find(m => m.name.toLowerCase() === item.name.toLowerCase());
    const photo = item.photo || mealMatch?.photo || null;
    setNi({ ...item, photo, price: String(item.price), costPerUnit: String(item.costPerUnit || ""), tags: Array.isArray(item.tags) ? item.tags.join(", ") : item.tags });
    setEditId(item.id); setAdding(true);
  };

  const addCategory = () => {
    const name = newCatName.trim(); if (!name) return;
    const newId = Math.max(0, ...categories.map(c => c.id)) + 1;
    setCategories(prev => [...prev, { id: newId, name }]);
    // Also add to meals so new category is immediately usable in Meal form
    if (setMeals) {
      // No need to add a meal — just adding the category is enough
      // The sync effect preserves categories that have meals under them
    }
    setNewCatName(""); setAddingCat(false);
  };

  const renameCategory = (id, newName) => {
    const trimmed = newName.trim(); if (!trimmed) return;
    const old = categories.find(c => c.id === id);
    if (!old || old.name === trimmed) return;
    setCategories(prev => prev.map(c => c.id === id ? { ...c, name: trimmed } : c));
    // Sync meals that used the old category name
    if (setMeals) setMeals(prev => prev.map(m => m.category === old.name ? { ...m, category: trimmed } : m));
  };

  const deleteCategory = (id) => {
    if (items.some(i => i.catId === id)) { alert("Remove all items in this category first."); return; }
    const deleted = categories.find(c => c.id === id);
    const fallback = categories.find(c => c.id !== id)?.name || "";
    setCategories(prev => prev.filter(c => c.id !== id));
    if (selCat === id) setSelCat(null);
    // Clear category on meals that used the deleted category
    if (setMeals && deleted) setMeals(prev => prev.map(m => m.category === deleted.name ? { ...m, category: fallback } : m));
  };

  const openDoc = (title, html) => setDoc({ title, html, onPrint: () => printDoc(title, html) });
  const selCatObj = categories.find(c => c.id === selCat);

  return (
    <div>
      <DocModal doc={doc} onClose={() => setDoc(null)} />
      <div style={{ ...S.row, marginBottom: 4 }}>
        <div>
          <div style={S.pageTitle}>📦 Catering Catalog</div>
          <div style={S.subtitle}>{items.length} items across {categories.length} categories · <span style={{ color: T.accent }}>Driven by Meals — add or edit meals to update</span></div>
        </div>
        <button style={S.btn("primary")} onClick={() => openDoc("Services Catalog", buildCatalogHTML(items, categories, biz, logo))}>
          🖨️ Print Catalog
        </button>
      </div>

      {/* ── CATEGORY TILES VIEW ── */}
      {!selCat && (
        <div>
          <div style={{ ...S.row, marginBottom: 14, gap: 8, flexWrap: "wrap" }}>
            <input style={{ ...S.input, flex: 1, minWidth: 160 }} placeholder="Search all items…" value={search} onChange={e => setSearch(e.target.value)} />

          </div>

          {search ? (
            // Search results across all categories
            <div>
              <div style={{ fontSize: 12, color: T.textMuted, marginBottom: 10 }}>{filtered.length} results for "{search}"</div>
              <div style={S.grid(3)}>
                {filtered.map(item => <CatalogItemCard key={item.id} item={item} categories={categories} setItems={setItems} startEdit={startEdit} handlePhoto={handlePhoto} meals={meals} onCopyToMeals={copyToMeals} />)}
              </div>
            </div>
          ) : (
            // Category tiles
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 10 }}>
              {categories.map(cat => {
                const catItems = items.filter(i => i.catId === cat.id);
                const thumb = catItems.find(i => i.photo)?.photo;
                return (
                  <div key={cat.id} style={{ ...S.card, padding: 0, overflow: "hidden", cursor: "pointer", border: `1px solid ${T.border}`, transition: "box-shadow 0.15s" }}
                    onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.18)"}
                    onMouseLeave={e => e.currentTarget.style.boxShadow = ""}
                    onClick={() => { setSelCat(cat.id); setAdding(false); }}>
                    {/* Tile image */}
                    <div style={{ height: 90, background: T.surface, overflow: "hidden", position: "relative" }}>
                      {thumb
                        ? <img src={thumb} alt={cat.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        : <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 32, opacity: 0.5 }}>{cat.name.match(/\p{Emoji}/u)?.[0] || "🍽️"}</div>
                      }
                      {catItems.length > 0 && (
                        <div style={{ position: "absolute", top: 5, right: 5, background: T.accent, color: "#fff", fontSize: 10, fontWeight: 700, padding: "2px 7px", borderRadius: 10 }}>
                          {catItems.length}
                        </div>
                      )}
                    </div>
                    {/* Tile label */}
                    <div style={{ padding: "8px 10px 6px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      {editingCatId === cat.id
                        ? <input
                            autoFocus
                            style={{ ...S.input, fontSize: 11, padding: "2px 6px", marginBottom: 0, flex: 1, marginRight: 4 }}
                            value={editingCatName}
                            onChange={e => setEditingCatName(e.target.value)}
                            onKeyDown={e => {
                              if (e.key === "Enter") { renameCategory(cat.id, editingCatName); setEditingCatId(null); }
                              if (e.key === "Escape") setEditingCatId(null);
                            }}
                            onBlur={() => { renameCategory(cat.id, editingCatName); setEditingCatId(null); }}
                            onClick={e => e.stopPropagation()}
                          />
                        : <div style={{ fontSize: 11, fontWeight: 700, color: T.text, lineHeight: 1.3, flex: 1 }}>{cat.name}</div>
                      }
                      <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                        {editingCatId !== cat.id && (
                          <button
                            title="Rename category"
                            style={{ background: "none", border: "none", color: T.textDim, cursor: "pointer", fontSize: 11, padding: 2, lineHeight: 1 }}
                            onClick={e => { e.stopPropagation(); setEditingCatId(cat.id); setEditingCatName(cat.name); }}>✏️</button>
                        )}
                        <button style={{ background: "none", border: "none", color: T.textDim, cursor: "pointer", fontSize: 13, padding: 2, lineHeight: 1 }}
                          onClick={e => { e.stopPropagation(); deleteCategory(cat.id); }}>🗑</button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* ── CATEGORY DETAIL VIEW ── */}
      {selCat && (
        <div>
          {/* Breadcrumb */}
          <div style={{ ...S.row, marginBottom: 12, gap: 8, flexWrap: "wrap" }}>
            <button style={{ ...S.btn("ghost"), fontSize: 12 }} onClick={() => { setSelCat(null); setAdding(false); setEditId(null); }}>
              ← All Categories
            </button>
            <div style={{ fontSize: 14, fontWeight: 700, color: T.text }}>{selCatObj?.name}</div>
            <div style={{ fontSize: 12, color: T.textMuted }}>({items.filter(i => i.catId === selCat).length} items)</div>
            <div style={{ flex: 1 }} />
            {onCreateProposalFromCatalog && items.filter(i => i.catId === selCat).length > 0 && (
              <button
                style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 10px", borderColor: T.catering, color: T.catering }}
                title="Open Proposals and pre-fill with all items from this category"
                onClick={() => {
                  const catItems = items.filter(i => i.catId === selCat);
                  const lines = catItems.map(item => ({
                    itemId: item.id,
                    name: item.name,
                    qty: 1,
                    price: item.price,
                    unitType: item.unitType,
                  }));
                  onCreateProposalFromCatalog(lines);
                }}
              >
                🎉 Create Proposal from this Category
              </button>
            )}

          </div>

          {/* Edit form — only for existing items synced from Meals */}
          {adding && editId != null && (
            <div style={{ ...S.card, marginBottom: 14, borderColor: T.accent }}>
              <div style={S.sectionTitle}>✏️ Edit Catalog Item</div>



              <div style={S.grid(3)}>
                <div>
                  <label style={S.label}>Item Name *</label>
                  <input style={S.input} value={ni.name} onChange={e => setNi({ ...ni, name: e.target.value })} placeholder="e.g. Jollof Rice" />
                </div>
                <div>
                  <label style={S.label}>Category</label>
                  <select style={{ ...S.select, ...(editId != null && ni.catId !== selCat ? { borderColor: T.accent, fontWeight: 700 } : {}) }}
                    value={ni.catId} onChange={e => setNi({ ...ni, catId: Number(e.target.value) })}>
                    {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                  {editId != null && ni.catId !== selCat && (
                    <div style={{ fontSize: 9, color: T.accent, marginTop: 2 }}>↪ Item will move to this category on save</div>
                  )}
                </div>
                <div>
                  <label style={S.label}>Unit Type</label>
                  <select style={S.select} value={ni.unitType} onChange={e => setNi({ ...ni, unitType: e.target.value })}>
                    {["Per head","Per tray","Per platter","Per item","Per hour","Per day","Flat fee"].map(u => <option key={u}>{u}</option>)}
                  </select>
                </div>

                <div>
                  <label style={S.label}>Photo</label>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    {ni.photo && <img src={ni.photo} alt="p" style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 4, border: `1px solid ${T.border}` }} />}
                    <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 8px" }} onClick={() => photoRef.current.click()}>{ni.photo ? "Change" : "Upload"}</button>
                    {ni.photo && <button style={{ background: "none", border: "none", color: T.danger, cursor: "pointer", fontSize: 11 }} onClick={() => setNi({ ...ni, photo: null })}>✕</button>}
                    <input ref={photoRef} type="file" accept="image/*" style={{ display: "none" }} onChange={e => handlePhoto(e)} />
                  </div>
                </div>
                <div style={{ gridColumn: "span 3" }}>
                  <label style={S.label}>Description</label>
                  <input style={S.input} value={ni.description} onChange={e => setNi({ ...ni, description: e.target.value })} placeholder="Short description for catalog" />
                </div>
                <div style={{ gridColumn: "span 3" }}>
                  <label style={S.label}>Notes (printed on catalog)</label>
                  <input style={S.input} value={ni.notes || ""} onChange={e => setNi({ ...ni, notes: e.target.value })} placeholder="e.g. Contains nuts · Halal · Minimum 20 portions" />
                </div>
                <div style={{ gridColumn: "span 3" }}>
                  <label style={S.label}>Tags (comma-separated)</label>
                  <input style={S.input} value={ni.tags} onChange={e => setNi({ ...ni, tags: e.target.value })} placeholder="e.g. Buffet, Birthday, Halal" />
                </div>
              </div>
              <div style={{ ...S.row, marginTop: 10, justifyContent: "flex-end" }}>
                <button style={S.btn("ghost")} onClick={() => { setAdding(false); setEditId(null); }}>Cancel</button>
                <button style={S.btn("primary")} onClick={save}>Update Item</button>
              </div>
            </div>
          )}

          {/* Items grid */}
          <div style={S.grid(3)}>
            {filtered.map(item => <CatalogItemCard key={item.id} item={item} categories={categories} setItems={setItems} startEdit={startEdit} handlePhoto={handlePhoto} onDelete={() => setItems(prev => prev.filter(i => i.id !== item.id))} meals={meals} onCopyToMeals={copyToMeals} />)}
          </div>
          {filtered.length === 0 && (
            <div style={{ color: T.textMuted, padding: 40, textAlign: "center", fontSize: 13 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🍽️</div>
              No items in this category yet.<br />
              <span style={{ color: T.textDim, fontSize: 11 }}>Add meals in the Meals tab — they appear here automatically.</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ─── CATALOG ITEM CARD ────────────────────────────────────────────
function CatalogItemCard({ item, categories, setItems, startEdit, handlePhoto, onDelete, meals, onCopyToMeals }) {
  const cat = categories.find(c => c.id === item.catId);
  const linkedToMeal = meals.some(m => m.name.toLowerCase() === item.name.toLowerCase());
  return (
    <div style={{ ...S.card, padding: 0, overflow: "hidden" }}>
      <div style={{ height: 120, background: T.surface, position: "relative", cursor: "pointer" }}
        onClick={() => { const inp = document.createElement("input"); inp.type = "file"; inp.accept = "image/*"; inp.onchange = e => handlePhoto(e, item.id); inp.click(); }}>
        {item.photo
          ? <img src={item.photo} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          : <div style={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: T.textDim, gap: 3 }}>
              <div style={{ fontSize: 24 }}>📷</div>
              <div style={{ fontSize: 9 }}>Click to add photo</div>
            </div>
        }
        <div style={{ position: "absolute", bottom: 4, right: 4, background: "rgba(0,0,0,0.5)", color: "#fff", fontSize: 8, padding: "2px 5px", borderRadius: 3 }}>📷</div>
      </div>
      <div style={{ padding: 9 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 1 }}>
          <div style={{ fontSize: 11, fontWeight: 700 }}>{item.name}</div>
          {linkedToMeal && (
            <span title="Linked to a meal — photos sync automatically" style={{ fontSize: 8, color: T.success, background: T.success + "18", padding: "1px 5px", borderRadius: 8, fontWeight: 700, whiteSpace: "nowrap" }}>🔗 Meal</span>
          )}
        </div>
        <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 3 }}>{cat?.name}</div>
        {item.description && <div style={{ fontSize: 9, color: T.textDim, marginBottom: 4, lineHeight: 1.4 }}>{item.description}</div>}
        {item.notes && <div style={{ fontSize: 9, color: T.accent, marginBottom: 4, fontStyle: "italic" }}>📝 {item.notes}</div>}
        <div style={{ fontSize: 10, color: T.textDim, marginBottom: 3 }}>
          {item.unitType}
        </div>
        <div style={{ display: "flex", gap: 3, alignItems: "center", flexWrap: "wrap", marginTop: 4 }}>
          {(Array.isArray(item.tags) ? item.tags : []).map(t => <span key={t} style={S.tag}>{t}</span>)}
          <div style={{ marginLeft: "auto", display: "flex", gap: 4 }}>
            <button style={{ ...S.btn("ghost"), fontSize: 9, padding: "1px 6px" }} onClick={() => startEdit(item)}>✏️ Edit</button>
            {!linkedToMeal && onCopyToMeals && (
              <button
                title="Copy this item to Meals"
                style={{ ...S.btn("ghost"), fontSize: 9, padding: "1px 6px", color: T.accent, borderColor: T.accent + "40" }}
                onClick={() => onCopyToMeals(item)}
              >→ Meals</button>
            )}
            {onDelete && <button style={{ ...S.btn("ghost"), fontSize: 9, padding: "1px 6px", color: T.danger, borderColor: T.danger + "40" }} onClick={onDelete}>✕</button>}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── PROPOSALS (with inventory linking) ───────────────────────────
// ─── CONTRACT MODAL ──────────────────────────────────────────────
function ContractModal({ prop, biz, logo, onClose, onPrint }) {
  const [lang, setLang] = useState("en");
  const [terms, setTerms] = useState({ catObl: "", cliObl: "", quality: "", media: "", canc: "", liab: "", conf: "" });
  const [expanded, setExpanded] = useState(null);

  const EN = lang === "en";
  const sub     = prop.lines.reduce((s, l) => s + l.qty * l.price, 0);
  const total   = sub - (prop.discount || 0);
  const deposit = Math.round(total * 0.5);
  const balance = total - deposit;

  // Defaults live in buildContractHTML — modal just shows section labels for optional override
  const sections = [
    { key: "catObl",   label: EN ? "Caterer Obligations"              : "Obligations du Prestataire",    color: "#e8c547", hint: EN ? "Delivery, staff, hygiene, punctuality…"                : "Livraison, personnel, hygiène, ponctualité…" },
    { key: "cliObl",   label: EN ? "Client Obligations"               : "Obligations du Client",         color: "#4a90d9", hint: EN ? "Payments, guest count, venue access, guest conduct…"   : "Paiements, effectif, accès au lieu, conduite des invités…" },
    { key: "quality",  label: EN ? "Quality & Complaints"             : "Qualité & Réclamations",        color: "#22c55e", hint: EN ? "Complaint window, refund policy, dispute resolution…"  : "Délai de réclamation, remboursements, résolution des litiges…" },
    { key: "media",    label: EN ? "Media & Reputation (Online Reviews)" : "Médias & Réputation (Avis en ligne)", color: "#f59e0b", hint: EN ? "Photography, social media, defamation protection…" : "Photographie, réseaux sociaux, protection contre la diffamation…" },
    { key: "canc",     label: EN ? "Cancellation & Force Majeure"     : "Annulation & Force Majeure",    color: "#e57373", hint: EN ? "14-day / 7-day / force majeure rules…"                 : "Règles 14 jours / 7 jours / force majeure…" },
    { key: "liab",     label: EN ? "Liability & Indemnification"      : "Responsabilité & Indemnisation", color: "#8b5cf6", hint: EN ? "Liability cap, allergens, equipment, indemnification…" : "Plafond de responsabilité, allergènes, matériel, indemnisation…" },
    { key: "conf",     label: EN ? "Confidentiality"                  : "Confidentialité",               color: "#aaa",    hint: EN ? "Pricing and commercial terms confidentiality…"         : "Confidentialité des tarifs et conditions commerciales…" },
  ];

  const handlePrint = () => {
    const html  = buildContractHTML(prop, biz, logo, lang, terms);
    const title = EN ? `Contract – ${prop.num.replace("PROP","CTR")}` : `Contrat – ${prop.num.replace("PROP","CTR")}`;
    onPrint(html, title);
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.72)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
      onClick={onClose}>
      <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, width:"100%", maxWidth:600, maxHeight:"90vh", overflowY:"auto", padding:24 }}
        onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
          <div>
            <div style={{ fontSize:14, fontWeight:700, color:"#6366f1" }}>📄 {EN ? "Generate Contract" : "Générer le Contrat"}</div>
            <div style={{ fontSize:11, color:T.textMuted, marginTop:2 }}>{prop.num} · {prop.client} · {fmt(total)} XAF</div>
          </div>
          <button style={{ background:"none", border:"none", color:T.textDim, cursor:"pointer", fontSize:18 }} onClick={onClose}>✕</button>
        </div>

        {/* Language toggle */}
        <div style={{ marginBottom:14 }}>
          <div style={{ fontSize:10, fontWeight:700, color:T.textMuted, textTransform:"uppercase", letterSpacing:1, marginBottom:6 }}>Language / Langue</div>
          <div style={{ display:"flex", gap:6 }}>
            {[["en","🇬🇧 English"],["fr","🇫🇷 Français"]].map(([v,lbl]) => (
              <button key={v}
                style={{ ...S.btn(lang===v ? "primary" : "ghost"), fontSize:12, padding:"5px 14px" }}
                onClick={() => { setLang(v); setTerms({ catObl:"", cliObl:"", quality:"", media:"", canc:"", liab:"", conf:"" }); }}
              >{lbl}</button>
            ))}
          </div>
        </div>

        {/* Editable clauses */}
        <div style={{ fontSize:10, fontWeight:700, color:T.textMuted, textTransform:"uppercase", letterSpacing:1, marginBottom:8 }}>
          {EN ? "Edit clauses (optional — defaults pre-filled)" : "Modifier les clauses (optionnel — valeurs par défaut préremplies)"}
        </div>
        {sections.map(sec => (
          <div key={sec.key} style={{ marginBottom:8, border:`1px solid ${T.border}`, borderRadius:8, overflow:"hidden" }}>
            <div
              style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 12px", background:T.surface, cursor:"pointer" }}
              onClick={() => setExpanded(expanded === sec.key ? null : sec.key)}
            >
              <div style={{ display:"flex", flexDirection:"column" }}>
                <div style={{ fontSize:11, fontWeight:700, color:T.text, display:"flex", alignItems:"center", gap:6 }}>
                  <span style={{ width:3, height:14, background:sec.color, borderRadius:2, display:"inline-block" }} />
                  {sec.label}
                </div>
                <div style={{ fontSize:10, color:T.textDim, marginTop:2, paddingLeft:9 }}>{sec.hint}</div>
              </div>
              <span style={{ fontSize:10, color:T.textDim, flexShrink:0 }}>{expanded === sec.key ? "▲" : "▼"}</span>
            </div>
            {expanded === sec.key && (
              <div style={{ padding:10 }}>
                <textarea
                  style={{ ...S.input, minHeight:110, resize:"vertical", fontSize:11, lineHeight:1.6, fontFamily:"inherit" }}
                  placeholder={"Leave blank to use the comprehensive default clause — or type here to override…"}
                  value={terms[sec.key]}
                  onChange={e => setTerms(prev => ({ ...prev, [sec.key]: e.target.value }))}
                />
                <div style={{ fontSize:10, color:T.textDim, marginTop:3 }}>
                  {EN ? "Leave blank to use the default text shown above." : "Laisser vide pour utiliser le texte par défaut ci-dessus."}
                </div>
              </div>
            )}
          </div>
        ))}

        {/* Summary */}
        <div style={{ background:T.surface, borderRadius:8, padding:"10px 12px", marginTop:10, marginBottom:16, fontSize:11, color:T.textMuted, lineHeight:1.7 }}>
          <strong style={{ color:T.text }}>{EN ? "Contract includes:" : "Le contrat inclut :"}</strong><br/>
          {EN
            ? `• Services from Proposal ${prop.num}  •  Total: ${fmt(total)} XAF  •  Deposit: ${fmt(deposit)} XAF  •  Balance: ${fmt(balance)} XAF`
            : `• Prestations de la Proposition ${prop.num}  •  Total : ${fmt(total)} XAF  •  Acompte : ${fmt(deposit)} XAF  •  Solde : ${fmt(balance)} XAF`}
          <br/>
          {EN ? "• Caterer & client obligations  •  Quality & complaints  •  Media & reputation protection  •  Cancellation  •  Liability  •  Confidentiality  •  Signatures"
               : "• Obligations des parties  •  Qualité & réclamations  •  Protection médias & réputation  •  Annulation  •  Responsabilité  •  Confidentialité  •  Signatures"}
        </div>

        {/* Actions */}
        <div style={{ display:"flex", gap:8 }}>
          <button style={{ ...S.btn("primary"), flex:1, fontSize:12 }} onClick={handlePrint}>
            🖨️ {EN ? "Print / Save as PDF" : "Imprimer / Enregistrer PDF"}
          </button>
          <button style={{ ...S.btn("ghost"), fontSize:12, padding:"6px 14px" }} onClick={onClose}>
            {EN ? "Cancel" : "Annuler"}
          </button>
        </div>
      </div>
    </div>
  );
}

function ProposalsPage({
  proposals,
  setProposals,
  events,
  setEvents,
  invoices,
  setInvoices,
  customers,
  setCustomers,
  catalogItems,
  setCatalogItems,
  catalogCategories,
  setCatalogCategories,
  meals,
  inventory,
  logo,
  biz,
  proposalPrefillLines,
  clearProposalPrefill,
}) {
  const [sel, setSel] = useState(null);
  const [building, setBuilding] = useState(false);
  const [editingPropIdx, setEditingPropIdx] = useState(null); // index of proposal being edited
  const [draft, setDraft] = useState({
    client: "",
    clientPhone: "",
    eventType: "",
    plannedDate: "",
    guests: "",
    location: "",
    discount: 0,
    notes: "",
    lines: [],
    inventoryLinks: [],
    eventId: null,
    paymentTerms: "",
  });
  const [pickCat, setPickCat] = useState(null);
  const [doc, setDoc] = useState(null);
  const [showInvLink, setShowInvLink] = useState(null);
  const [showTemplates, setShowTemplates] = useState(false);

  // ── Contract modal state ──────────────────────────────────────────
  const [contractModal, setContractModal] = useState(null); // { propIdx } | null

  // ── Inline catalog item creation ──────────────────────────────────
  const [showAddItem, setShowAddItem] = useState(false);
  const [addingNewCat, setAddingNewCat] = useState(false);
  const [newCatName, setNewCatName] = useState("");
  const EMPTY_NI = {
    catId: catalogCategories[0]?.id || 1,
    name: "", unitType: "Per head", price: "", costPerUnit: "",
    description: "", photo: null,
  };
  const [ni, setNi] = useState(EMPTY_NI);
  const photoRef = useRef();

  const handleCatalogPhoto = async (e) => {
    const f = e.target.files[0]; if (!f) return;
    const src = await uploadFile(f, "catalog");
    if (!src) { alert("❌ Photo upload failed. Please check your internet connection and try again."); return; }
    setNi(prev => ({ ...prev, photo: src }));
  };

  const pullFromMealInline = (mealId) => {
    if (!mealId) return;
    const m = meals.find(ml => String(ml.id) === String(mealId));
    if (!m) return;
    setNi(prev => ({
      ...prev,
      name: m.name || prev.name,
      price: m.price ? String(m.price) : prev.price,
      description: m.description || prev.description,
      photo: m.photo || prev.photo,
      unitType: "Per head",
    }));
  };

  const saveCatalogItem = () => {
    if (!ni.name.trim()) return;
    const item = {
      ...ni,
      id: Date.now(),
      price: Number(ni.price),
      costPerUnit: Number(ni.costPerUnit) || 0,
    };
    setCatalogItems(prev => [...prev, item]);
    // Also immediately add to proposal lines
    addLine(item);
    setNi({ ...EMPTY_NI, catId: ni.catId });
    setShowAddItem(false);
  };

  const addNewCategory = () => {
    const name = newCatName.trim(); if (!name) return;
    const newId = Math.max(0, ...catalogCategories.map(c => c.id)) + 1;
    setCatalogCategories(prev => [...prev, { id: newId, name }]);
    setNi(prev => ({ ...prev, catId: newId }));
    setNewCatName(""); setAddingNewCat(false);
  };
  const openDoc = (title, html) =>
    setDoc({ title, html, onPrint: () => printDoc(title, html) });

  // Auto-open builder pre-seeded when arriving from Catalog → "Create Proposal from Category"
  useEffect(() => {
    if (proposalPrefillLines && proposalPrefillLines.length > 0) {
      setDraft(d => ({ ...d, lines: proposalPrefillLines }));
      setBuilding(true);
      setShowTemplates(false);
      if (clearProposalPrefill) clearProposalPrefill();
    }
  }, [proposalPrefillLines]);

  const BLANK_DRAFT = {
    client: "", clientPhone: "", eventType: "", plannedDate: "",
    guests: "", location: "", discount: 0, notes: "", lines: [],
    inventoryLinks: [], eventId: null, paymentTerms: "",
  };

  const duplicateProposal = (i) => {
    const src = proposals[i];
    const newNum = proposals.length + 1;
    const copy = {
      ...src,
      id: Date.now(),
      num: `PROP-${THIS_YEAR}-${String(newNum).padStart(4, "0")}`,
      status: "Draft",
      // Clear client-specific fields — keep line items, discount, notes
      client: "",
      clientPhone: "",
      plannedDate: "",
      eventId: null,
      duplicatedFrom: src.num,
    };
    setProposals(prev => [copy, ...prev]);
  };

  const loadTemplate = (propId) => {
    const src = proposals.find(p => p.id === Number(propId));
    if (!src) return;
    setDraft(d => ({
      ...d,
      lines: src.lines.map(l => ({ ...l })),
      discount: src.discount,
      notes: src.notes,
      inventoryLinks: src.inventoryLinks || [],
      eventType: d.eventType || src.eventType,
    }));
    setShowTemplates(false);
  };

  const toggleTemplate = (i) => {
    const u = [...proposals];
    u[i] = { ...u[i], isTemplate: !u[i].isTemplate };
    setProposals(u);
  };

  const templates = proposals.filter(p => p.isTemplate);

  const addLine = (item) =>
    setDraft((d) => ({
      ...d,
      lines: [
        ...d.lines,
        {
          itemId: item.id,
          name: item.name,
          qty: item.unitType === "Per head" ? d.guests : 1,
          price: item.price,
          unitType: item.unitType,
          photo: item.photo || null,
          description: item.description || "",
        },
      ],
    }));
  const saveDraft = () => {
    if (editingPropIdx !== null) {
      // ── Edit mode: update existing proposal in-place ──────────────
      const existing = proposals[editingPropIdx];
      const updated = { ...existing, ...draft };
      const u = [...proposals];
      u[editingPropIdx] = updated;
      setProposals(u);
      setBuilding(false);
      setEditingPropIdx(null);
      setDraft({ ...BLANK_DRAFT });
    } else {
      // ── Create mode: add new proposal ────────────────────────────
      const newNum = proposals.length + 1;
      const p = {
        ...draft,
        id: Date.now(),
        num: `PROP-${THIS_YEAR}-${String(newNum).padStart(4, "0")}`,
        status: "Draft",
      };
      setProposals((prev) => [...prev, p]);
      setBuilding(false);
      setDraft({ ...BLANK_DRAFT });
    }
  };

  const startEditProposal = (idx) => {
    const p = proposals[idx];
    setDraft({
      client: p.client || "",
      clientPhone: p.clientPhone || "",
      eventType: p.eventType || "",
      plannedDate: p.plannedDate || "",
      guests: p.guests || "",
      location: p.location || "",
      discount: p.discount || 0,
      notes: p.notes || "",
      lines: p.lines ? p.lines.map(l => ({ ...l })) : [],
      inventoryLinks: p.inventoryLinks || [],
      eventId: p.eventId || null,
      paymentTerms: p.paymentTerms || "",
      terms: p.terms ? p.terms.map(t => ({ ...t })) : [],
    });
    setEditingPropIdx(idx);
    setBuilding(true);
    setSel(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const cancelBuilding = () => {
    setBuilding(false);
    setEditingPropIdx(null);
    setDraft({ ...BLANK_DRAFT });
    setShowTemplates(false);
  };
  const updateLine = (pi, li, field, value) => {
    const u = [...proposals];
    u[pi] = {
      ...u[pi],
      lines: u[pi].lines.map((l, i) =>
        i === li ? { ...l, [field]: Number(value) } : l
      ),
    };
    setProposals(u);
  };
  const stColor = {
    Draft: T.textMuted,
    Sent: T.info,
    Negotiation: T.warning,
    Approved: T.success,
    Declined: T.danger,
    "Converted to Event": T.catering,
  };

  const toggleInventoryLink = (propIdx, invId) => {
    const u = [...proposals];
    const links = u[propIdx].inventoryLinks || [];
    const has = links.includes(invId);
    u[propIdx] = {
      ...u[propIdx],
      inventoryLinks: has
        ? links.filter((id) => id !== invId)
        : [...links, invId],
    };
    setProposals(u);
  };
  const toggleDraftInvLink = (invId) => {
    const has = (draft.inventoryLinks || []).includes(invId);
    setDraft({
      ...draft,
      inventoryLinks: has
        ? draft.inventoryLinks.filter((id) => id !== invId)
        : [...(draft.inventoryLinks || []), invId],
    });
  };

  // Link/unlink a proposal to an existing event
  const linkProposalToEvent = (propIdx, eventId) => {
    const u = [...proposals];
    u[propIdx] = { ...u[propIdx], eventId: eventId || null };
    setProposals(u);
  };

  // Convert an approved proposal into a new catering event (or link to existing)
  const convertToEvent = (propIdx) => {
    const p = proposals[propIdx];
    const total = propTotal(p.lines, p.discount);
    const guests = Number(p.guests) || 0;
    const pricePerHead = guests > 0 ? Math.round(total / guests) : 0;
    const newEvent = {
      id: Date.now(),
      name: `${p.eventType || "Event"} – ${p.client}`,
      clientName: p.client,
      clientPhone: p.clientPhone || "",
      eventDate: p.plannedDate || "",
      location: p.location || "",
      eventType: p.eventType || "Other",
      serviceStyle: "Buffet",
      guests,
      pricePerHead,
      addOns: 0,
      discount: Number(p.discount) || 0,
      phase: "Confirmed",
      notes: p.notes || `Converted from proposal ${p.num}`,
      revenue: total,
      media: [],
      costs: { inventory: 0, labor: 0, transport: 0, overhead: 0 },
    };
    setEvents((prev) => [...prev, newEvent]);
    const u = [...proposals];
    u[propIdx] = { ...p, status: "Converted to Event", eventId: newEvent.id };
    setProposals(u);
  };

  // ── Approve: auto-create Event + Invoice + upsert Customer ────────
  const approveProposal = (propIdx) => {
    const p = proposals[propIdx];
    if (p.eventId) {
      // Already linked — just mark approved
      const u = [...proposals];
      u[propIdx] = { ...p, status: "Approved" };
      setProposals(u);
      return;
    }
    const total = propTotal(p.lines, p.discount);
    const deposit = Math.round(total * 0.5);
    const guests = Number(p.guests) || 0;
    const pricePerHead = guests > 0 ? Math.round(total / guests) : 0;
    const eventId = Date.now();
    const invId = eventId + 1;
    const invNum = `INV-${THIS_YEAR}-${String(invId).slice(-4).padStart(4, "0")}`;

    // 1. Create Event
    const newEvent = {
      id: eventId,
      name: `${p.eventType || "Event"} – ${p.client}`,
      clientName: p.client,
      clientPhone: p.clientPhone || "",
      eventDate: p.plannedDate || "",
      location: p.location || "",
      eventType: p.eventType || "Other",
      serviceStyle: "Buffet",
      guests,
      pricePerHead,
      addOns: 0,
      discount: Number(p.discount) || 0,
      phase: "Confirmed",
      notes: `Auto-created on proposal approval · ${p.num}${p.notes ? "\n" + p.notes : ""}`,
      revenue: total,
      media: [],
      costLines: [],
      costs: { inventory: 0, labor: 0, transport: 0, overhead: 0 },
    };
    setEvents(prev => [...prev, newEvent]);

    // 2. Create Invoice (Unpaid, 50% deposit due)
    const newInvoice = {
      id: invId,
      num: invNum,
      client: p.client,
      clientPhone: p.clientPhone || "",
      issued: new Date().toISOString().slice(0, 10),
      due: p.plannedDate || new Date().toISOString().slice(0, 10),
      total,
      paid: 0,
      status: "Unpaid",
      eventId,
      notes: `Auto-generated on approval of ${p.num}. Deposit due: ${fmt(deposit)} XAF.`,
    };
    if (setInvoices) setInvoices(prev => [...prev, newInvoice]);

    // 3. Upsert Customer
    if (p.client && p.client.trim() && setCustomers) {
      const name = p.client.trim();
      const phone = (p.clientPhone || "").trim();
      setCustomers(prev => {
        const idx = prev.findIndex(c => c.name.toLowerCase() === name.toLowerCase());
        if (idx >= 0) {
          const updated = [...prev];
          updated[idx] = { ...updated[idx], phone: updated[idx].phone || phone };
          return updated;
        }
        return [...prev, { id: invId + 1, name, phone, email: "", classification: "Regular", notes: "", createdAt: new Date().toISOString().slice(0, 10) }];
      });
    }

    // 4. Update proposal — Approved + linked IDs
    const u = [...proposals];
    u[propIdx] = { ...p, status: "Approved", eventId, invoiceId: invId };
    setProposals(u);
  };

  return (
    <div>
      <DocModal doc={doc} onClose={() => setDoc(null)} />
      {contractModal !== null && (
        <ContractModal
          prop={proposals[contractModal.propIdx]}
          biz={biz}
          logo={logo}
          onClose={() => setContractModal(null)}
          onPrint={(html, title) => { openDoc(title, html); setContractModal(null); }}
        />
      )}

      <div style={{ ...S.row, marginBottom: 14 }}>
        <div>
          <div style={S.pageTitle}>📋 Proposals</div>
          <div style={S.subtitle}>
            Build and send proposals to clients
            {templates.length > 0 && <span style={{ ...S.badge(T.accent), marginLeft: 6 }}>⭐ {templates.length} template{templates.length > 1 ? "s" : ""}</span>}
          </div>
        </div>
        <button style={S.btn("primary")} onClick={() => { if (building) { cancelBuilding(); } else { setBuilding(true); setShowTemplates(false); } }}>
          {building ? "✕ Cancel" : "+ New Proposal"}
        </button>
      </div>

      {building && (
        <div style={{ ...S.card, marginBottom: 14, borderColor: T.accent }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <div>
              <div style={S.sectionTitle}>
                {editingPropIdx !== null
                  ? `✏️ Editing ${proposals[editingPropIdx]?.num}`
                  : "Build Proposal"}
              </div>
              {editingPropIdx !== null && (
                <div style={{ fontSize: 10, color: T.textMuted, marginTop: 2 }}>
                  Changes will update the existing proposal · status stays as {proposals[editingPropIdx]?.status}
                </div>
              )}
            </div>
            {proposals.length > 0 && (
              <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 10px" }} onClick={() => setShowTemplates(!showTemplates)}>
                {showTemplates ? "✕ Close" : "📋 Load from existing…"}
              </button>
            )}
          </div>

          {/* Template / existing proposal picker */}
          {showTemplates && (
            <div style={{ background: T.accentSoft, borderRadius: 8, padding: "10px 12px", marginBottom: 14 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: T.accent, marginBottom: 8 }}>
                ⚡ Load line items from an existing proposal — client details stay blank for you to fill in
              </div>
              {/* Starred templates first */}
              {templates.length > 0 && (
                <>
                  <div style={{ fontSize: 10, color: T.textMuted, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 5 }}>⭐ Saved Templates</div>
                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
                    {templates.map(t => (
                      <button key={t.id} style={{ ...S.btn("primary"), fontSize: 11, padding: "5px 12px" }} onClick={() => loadTemplate(t.id)}>
                        {t.num} · {t.eventType || "Template"} · {t.lines.length} items · {fmt(propTotal(t.lines, t.discount))}
                      </button>
                    ))}
                  </div>
                </>
              )}
              <div style={{ fontSize: 10, color: T.textMuted, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 5 }}>All Proposals</div>
              <select style={{ ...S.select, width: "100%" }} defaultValue="" onChange={e => { if (e.target.value) loadTemplate(e.target.value); }}>
                <option value="">— Pick a proposal to copy its line items —</option>
                {proposals.map(pr => (
                  <option key={pr.id} value={pr.id}>
                    {pr.isTemplate ? "⭐ " : ""}{pr.num} · {pr.client || "No client"} · {pr.eventType || "—"} · {pr.lines.length} items · {fmt(propTotal(pr.lines, pr.discount))} · {pr.status}
                  </option>
                ))}
              </select>
              {draft.lines.length > 0 && (
                <div style={{ marginTop: 8, fontSize: 11, color: T.accent, fontWeight: 600 }}>
                  ✓ {draft.lines.length} line items loaded — fill in client details below
                </div>
              )}
            </div>
          )}
          <div style={S.grid(3)}>
            <div>
              <label style={S.label}>Client Name</label>
              <input
                style={S.input}
                value={draft.client}
                onChange={(e) => setDraft({ ...draft, client: e.target.value })}
              />
            </div>
            <div>
              <label style={S.label}>Client Phone</label>
              <input
                style={S.input}
                value={draft.clientPhone}
                onChange={(e) =>
                  setDraft({ ...draft, clientPhone: e.target.value })
                }
              />
            </div>
            <div>
              <label style={S.label}>Event Type</label>
              <input
                style={S.input}
                value={draft.eventType}
                onChange={(e) =>
                  setDraft({ ...draft, eventType: e.target.value })
                }
              />
            </div>
            <div>
              <label style={S.label}>Planned Date</label>
              <input
                type="date"
                style={S.input}
                value={draft.plannedDate}
                onChange={(e) =>
                  setDraft({ ...draft, plannedDate: e.target.value })
                }
              />
            </div>
            <div>
              <label style={S.label}>Guest Count</label>
              <input
                type="number"
                style={S.input}
                value={draft.guests}
                onChange={(e) =>
                  setDraft({ ...draft, guests: Number(e.target.value) })
                }
              />
            </div>
            <div>
              <label style={S.label}>Location</label>
              <input
                style={S.input}
                value={draft.location}
                onChange={(e) =>
                  setDraft({ ...draft, location: e.target.value })
                }
              />
            </div>
            <div>
              <label style={S.label}>Discount (XAF)</label>
              <input
                type="number"
                style={S.input}
                value={draft.discount}
                onChange={(e) =>
                  setDraft({ ...draft, discount: Number(e.target.value) })
                }
              />
            </div>
            <div style={{ gridColumn: "span 2" }}>
              <label style={S.label}>Notes</label>
              <input
                style={S.input}
                value={draft.notes}
                onChange={(e) => setDraft({ ...draft, notes: e.target.value })}
              />
            </div>
            <div style={{ gridColumn: "span 3" }}>
              <label style={S.label}>💳 Payment Terms <span style={{ color: T.textDim, fontWeight: 400 }}>(shown on proposal PDF)</span></label>
              <textarea
                style={{ ...S.input, minHeight: 54, resize: "vertical", fontFamily: "inherit", fontSize: 12 }}
                value={draft.paymentTerms}
                placeholder={biz.paymentTerms || "Cash · Mobile Money (MoMo) · Orange Money · Bank Transfer"}
                onChange={(e) => setDraft({ ...draft, paymentTerms: e.target.value })}
              />
            </div>
            <div style={{ gridColumn: "span 2" }}>
              <label style={S.label}>🎉 Link to Catering Event <span style={{ color: T.textDim, fontWeight: 400 }}>(optional)</span></label>
              <select
                style={S.select}
                value={draft.eventId || ""}
                onChange={(e) => setDraft({ ...draft, eventId: e.target.value ? Number(e.target.value) : null })}
              >
                <option value="">— No event linked (create later) —</option>
                {events.map((ev) => (
                  <option key={ev.id} value={ev.id}>
                    {ev.name} · {ev.eventDate || "Date TBD"} · {ev.phase}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <Divider />
          <div style={{ fontSize: 11, fontWeight: 600, marginBottom: 7 }}>
            Select items from catalog:
          </div>
          <div
            style={{
              display: "flex",
              gap: 3,
              flexWrap: "wrap",
              marginBottom: 9,
            }}
          >
            {catalogCategories.map((c) => (
              <button
                key={c.id}
                style={S.navBtn(pickCat === c.id)}
                onClick={() => setPickCat(pickCat === c.id ? null : c.id)}
              >
                {c.name}
              </button>
            ))}
          </div>
          <div style={S.grid(4)}>
            {catalogItems
              .filter((i) => !pickCat || i.catId === pickCat)
              .map((item) => (
                <div
                  key={item.id}
                  style={{
                    ...S.card,
                    padding: 0,
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                  onClick={() => addLine(item)}
                >
                  {item.photo ? (
                    <img
                      src={item.photo}
                      alt=""
                      style={{ width: "100%", height: 60, objectFit: "cover" }}
                    />
                  ) : (
                    <div
                      style={{
                        height: 40,
                        background: T.surface,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: T.textDim,
                        fontSize: 16,
                      }}
                    >
                      📷
                    </div>
                  )}
                  <div style={{ padding: 7 }}>
                    <div
                      style={{ fontSize: 11, fontWeight: 700, marginBottom: 1 }}
                    >
                      {item.name}
                    </div>
                    <div style={{ fontSize: 10, color: T.textMuted }}>
                      {item.unitType}
                    </div>
                  </div>
                </div>
              ))}
          </div>

          {/* ── Inline: Add new catalog item ── */}
          {!showAddItem ? (
            <button
              style={{ ...S.btn("ghost"), fontSize: 11, marginTop: 8, borderStyle: "dashed", color: T.accent, borderColor: T.accent + "60" }}
              onClick={() => {
                setNi({ ...EMPTY_NI, catId: catalogCategories[0]?.id || 1 });
                setShowAddItem(true);
                setAddingNewCat(false);
              }}
            >
              ＋ Add new item to catalog
            </button>
          ) : (
            <div style={{ background: `${T.accent}08`, border: `1px solid ${T.accent}30`, borderRadius: 10, padding: "14px 16px", marginTop: 10 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: T.accent }}>➕ New Catalog Item</div>
                <button style={{ background: "none", border: "none", color: T.textDim, cursor: "pointer", fontSize: 16, lineHeight: 1 }} onClick={() => { setShowAddItem(false); setAddingNewCat(false); }}>✕</button>
              </div>

              {/* Pull from meal shortcut */}
              {meals && meals.length > 0 && (
                <div style={{ background: T.accentSoft, borderRadius: 7, padding: "8px 11px", marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 11, color: T.accent, fontWeight: 700, whiteSpace: "nowrap" }}>⚡ Pull from Meal:</span>
                  <select style={{ ...S.select, flex: 1, marginBottom: 0 }} onChange={e => pullFromMealInline(e.target.value)} defaultValue="">
                    <option value="">— pick a meal to pre-fill —</option>
                    {meals.map(m => <option key={m.id} value={m.id}>{m.name}{m.price ? ` · ${fmt(m.price)} XAF` : ""}</option>)}
                  </select>
                </div>
              )}

              <div style={S.grid(3)}>
                {/* Name */}
                <div>
                  <label style={S.label}>Item Name *</label>
                  <input style={S.input} value={ni.name} onChange={e => setNi({ ...ni, name: e.target.value })} placeholder="e.g. Jollof Rice" />
                </div>

                {/* Category */}
                <div>
                  <label style={S.label}>Category</label>
                  {!addingNewCat ? (
                    <div style={{ display: "flex", gap: 5 }}>
                      <select style={{ ...S.select, flex: 1 }} value={ni.catId} onChange={e => setNi({ ...ni, catId: Number(e.target.value) })}>
                        {catalogCategories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                      </select>
                      <button
                        style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 8px", whiteSpace: "nowrap" }}
                        onClick={() => setAddingNewCat(true)}
                        title="Add new category"
                      >＋ New</button>
                    </div>
                  ) : (
                    <div style={{ display: "flex", gap: 5 }}>
                      <input
                        style={{ ...S.input, flex: 1 }}
                        value={newCatName}
                        onChange={e => setNewCatName(e.target.value)}
                        placeholder="e.g. 🥗 Salads"
                        onKeyDown={e => e.key === "Enter" && addNewCategory()}
                        autoFocus
                      />
                      <button style={{ ...S.btn("primary"), fontSize: 11, padding: "4px 9px" }} onClick={addNewCategory}>Save</button>
                      <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 8px" }} onClick={() => { setAddingNewCat(false); setNewCatName(""); }}>✕</button>
                    </div>
                  )}
                </div>

                {/* Unit type */}
                <div>
                  <label style={S.label}>Unit Type</label>
                  <select style={S.select} value={ni.unitType} onChange={e => setNi({ ...ni, unitType: e.target.value })}>
                    {["Per head", "Per tray", "Per platter", "Per item", "Per hour", "Per day", "Flat fee"].map(u => <option key={u}>{u}</option>)}
                  </select>
                </div>

                {/* Photo */}
                <div>
                  <label style={S.label}>Photo</label>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    {ni.photo && (
                      <img src={ni.photo} alt="" style={{ width: 40, height: 36, objectFit: "cover", borderRadius: 5, border: `1px solid ${T.border}` }} />
                    )}
                    <button
                      style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 8px" }}
                      onClick={() => photoRef.current.click()}
                    >
                      {ni.photo ? "Change" : "📷 Upload"}
                    </button>
                    {ni.photo && (
                      <button style={{ background: "none", border: "none", color: T.danger, cursor: "pointer", fontSize: 13 }} onClick={() => setNi({ ...ni, photo: null })}>✕</button>
                    )}
                    <input ref={photoRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleCatalogPhoto} />
                  </div>
                </div>

                {/* Description */}
                <div style={{ gridColumn: "span 3" }}>
                  <label style={S.label}>Description <span style={{ color: T.textDim, fontWeight: 400 }}>(optional — shown on proposal PDF)</span></label>
                  <input style={S.input} value={ni.description} onChange={e => setNi({ ...ni, description: e.target.value })} placeholder="Short description…" />
                </div>
              </div>

              <div style={{ display: "flex", gap: 8, marginTop: 12, alignItems: "center", flexWrap: "wrap" }}>
                <button
                  style={{ ...S.btn("primary"), fontSize: 12 }}
                  disabled={!ni.name.trim()}
                  onClick={saveCatalogItem}
                >
                  ✓ Save & Add to Proposal
                </button>
                <button style={{ ...S.btn("ghost"), fontSize: 12 }} onClick={() => { setShowAddItem(false); setAddingNewCat(false); }}>Cancel</button>
                <span style={{ fontSize: 10, color: T.textDim }}>Saved to catalog and added to this proposal.</span>
              </div>
            </div>
          )}

          {draft.lines.length > 0 && (
            <>
              <Divider />
              <div className="tbl-wrap">
                <table style={S.table}>
                  <thead>
                    <tr>
                      <th style={{ ...S.th, width: 20 }}></th>
                      {draft.lines.some(l => l.photo) && <th style={S.th}></th>}
                      {[
                        "Item",
                        "Unit",
                        "Qty",
                        "Unit Price (XAF)",
                        "Total",
                        "",
                      ].map((h) => (
                        <th key={h} style={S.th}>
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {draft.lines.map((l, i) => (
                      <tr
                        key={i}
                        draggable
                        onDragStart={e => { e.dataTransfer.effectAllowed = "move"; e.dataTransfer.setData("text/plain", String(i)); }}
                        onDragOver={e => { e.preventDefault(); e.dataTransfer.dropEffect = "move"; e.currentTarget.style.boxShadow = `0 -2px 0 ${T.accent}`; }}
                        onDragLeave={e => { e.currentTarget.style.boxShadow = "none"; }}
                        onDrop={e => {
                          e.preventDefault();
                          e.currentTarget.style.boxShadow = "none";
                          const from = Number(e.dataTransfer.getData("text/plain"));
                          if (from === i) return;
                          const ls = [...draft.lines];
                          const [moved] = ls.splice(from, 1);
                          ls.splice(i, 0, moved);
                          setDraft({ ...draft, lines: ls });
                        }}
                        onDragEnd={e => { e.currentTarget.style.boxShadow = "none"; }}
                        style={{ cursor: "grab" }}
                      >
                        <td style={{ ...S.td, width: 20, padding: "4px 2px", color: T.textDim, fontSize: 14, userSelect: "none" }} title="Drag to reorder">⠿</td>
                        {draft.lines.some(l => l.photo) && (
                          <td style={{ ...S.td, width: 44, padding: "4px 6px" }}>
                            {l.photo
                              ? <img src={l.photo} alt="" style={{ width: 36, height: 32, objectFit: "cover", borderRadius: 4, display: "block" }} />
                              : <div style={{ width: 36, height: 32, background: T.surface, borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>🍽️</div>
                            }
                          </td>
                        )}
                        <td style={S.td}>{l.name}</td>
                        <td style={S.td}>{l.unitType}</td>
                        <td style={S.td}>
                          <input
                            type="number"
                            style={{
                              ...S.input,
                              width: 58,
                              padding: "3px 5px",
                            }}
                            value={l.qty}
                            onChange={(e) => {
                              const ls = [...draft.lines];
                              ls[i] = { ...ls[i], qty: Number(e.target.value) };
                              setDraft({ ...draft, lines: ls });
                            }}
                          />
                        </td>
                        <td style={S.td}>
                          <input
                            type="number"
                            style={{
                              ...S.input,
                              width: 100,
                              padding: "3px 5px",
                              color: T.accent,
                              fontWeight: 700,
                            }}
                            value={l.price}
                            onChange={(e) => {
                              const ls = [...draft.lines];
                              ls[i] = {
                                ...ls[i],
                                price: Number(e.target.value),
                              };
                              setDraft({ ...draft, lines: ls });
                            }}
                          />
                        </td>
                        <td
                          style={{ ...S.td, fontWeight: 700, color: T.accent }}
                        >
                          {fmt(l.qty * l.price)}
                        </td>
                        <td style={S.td}>
                          <button
                            style={{
                              background: "none",
                              border: "none",
                              color: T.danger,
                              cursor: "pointer",
                              fontSize: 13,
                            }}
                            onClick={() =>
                              setDraft({
                                ...draft,
                                lines: draft.lines.filter((_, j) => j !== i),
                              })
                            }
                          >
                            ✕
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={{ textAlign: "right", marginTop: 7 }}>
                {draft.discount > 0 && (
                  <div style={{ fontSize: 11, color: T.textMuted }}>
                    Discount: -{fmt(draft.discount)}
                  </div>
                )}
                <div style={{ fontSize: 13, fontWeight: 800, color: T.accent }}>
                  TOTAL: {fmt(propTotal(draft.lines, draft.discount))}
                </div>
              </div>
            </>
          )}
          {/* Inventory linking in draft */}
          <Divider />
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              color: T.textMuted,
              marginBottom: 7,
              textTransform: "uppercase",
              letterSpacing: 0.5,
            }}
          >
            Link Inventory Items (for costing reference)
          </div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {inventory.map((inv) => {
              const linked = (draft.inventoryLinks || []).includes(inv.id);
              return (
                <div
                  key={inv.id}
                  onClick={() => toggleDraftInvLink(inv.id)}
                  style={{
                    padding: "4px 10px",
                    borderRadius: 20,
                    fontSize: 11,
                    cursor: "pointer",
                    background: linked ? `${T.accent}20` : T.surface,
                    border: `1px solid ${linked ? T.accent : T.border}`,
                    color: linked ? T.accent : T.textMuted,
                    fontWeight: linked ? 700 : 400,
                  }}
                >
                  {linked ? "✓ " : ""}
                  {inv.name} ({inv.unit}) — {fmt(inv.costPerUnit)}
                </div>
              );
            })}
          </div>
          {(draft.inventoryLinks || []).length > 0 && (
            <div
              style={{
                marginTop: 8,
                padding: 8,
                background: T.surface,
                borderRadius: 6,
                fontSize: 11,
              }}
            >
              Est. Ingredient Cost:{" "}
              <strong style={{ color: T.danger }}>
                {fmt(
                  inventory
                    .filter((i) => draft.inventoryLinks.includes(i.id))
                    .reduce(
                      (s, i) =>
                        s + i.costPerUnit * i.usedPerPlate * draft.guests,
                      0
                    )
                )}
              </strong>
              <span style={{ color: T.textDim, marginLeft: 6 }}>
                based on {draft.guests} guests
              </span>
            </div>
          )}
          <div style={{ ...S.row, marginTop: 10, justifyContent: "flex-end" }}>
            <button style={S.btn("ghost")} onClick={cancelBuilding}>
              Cancel
            </button>
            <button style={S.btn("primary")} onClick={saveDraft}>
              {editingPropIdx !== null ? "💾 Save Changes" : "Save Proposal"}
            </button>
          </div>
        </div>
      )}

      {proposals.map((p, i) => {
        const total = propTotal(p.lines, p.discount);
        return (
          <div key={p.id} style={{ ...S.card, marginBottom: 8 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                cursor: "pointer",
              }}
              onClick={() => setSel(sel === i ? null : i)}
            >
              <div>
                <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 2 }}>
                  {p.isTemplate && <span style={{ color: T.accent, marginRight: 4 }}>⭐</span>}
                  {p.num} — {p.client || <span style={{ color: T.textMuted, fontStyle: "italic" }}>No client yet</span>}
                </div>
                <div
                  style={{ fontSize: 11, color: T.textMuted, marginBottom: 4 }}
                >
                  {p.eventType} · {p.plannedDate || "Date TBD"} · {p.guests}{" "}
                  guests · {p.location}
                </div>
                <Badge color={stColor[p.status] || T.textMuted}>
                  {p.status}
                </Badge>
                {p.isTemplate && (
                  <span style={{ ...S.badge(T.accent), marginLeft: 4 }}>⭐ Template</span>
                )}
                {p.duplicatedFrom && (
                  <span style={{ ...S.badge(T.textMuted), marginLeft: 4, fontSize: 9 }}>📋 Copy of {p.duplicatedFrom}</span>
                )}
                {(p.inventoryLinks || []).length > 0 && (
                  <span style={{ ...S.badge(T.info), marginLeft: 4 }}>
                    📦 {p.inventoryLinks.length} linked
                  </span>
                )}
                {p.eventId && (() => {
                  const linkedEvt = events.find((e) => e.id === p.eventId);
                  return linkedEvt ? (
                    <span style={{ ...S.badge(T.catering), marginLeft: 4 }}>
                      🎉 {linkedEvt.name}
                    </span>
                  ) : null;
                })()}
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: 14, fontWeight: 800, color: T.accent }}>
                  {fmt(total)}
                </div>
                <div style={{ fontSize: 10, color: T.textMuted }}>
                  {p.lines.length} items
                </div>
              </div>
            </div>

            {sel === i && (
              <div style={{ marginTop: 10 }}>
                <Divider />
                <div
                  style={{ fontSize: 10, color: T.textMuted, marginBottom: 7 }}
                >
                  ✏️ Qty and unit price are editable below
                </div>
                <table style={{ ...S.table, marginBottom: 8 }}>
                  <thead>
                    <tr>
                      {p.lines.some(l => l.photo) && <th style={S.th}></th>}
                      {[
                        "Service / Item",
                        "Unit",
                        "Qty",
                        "Unit Price (XAF)",
                        "Total",
                      ].map((h) => (
                        <th key={h} style={S.th}>
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {p.lines.map((l, j) => (
                      <tr key={j}>
                        {p.lines.some(l => l.photo) && (
                          <td style={{ ...S.td, width: 44, padding: "4px 6px" }}>
                            {l.photo
                              ? <img src={l.photo} alt="" style={{ width: 36, height: 32, objectFit: "cover", borderRadius: 4, display: "block" }} />
                              : <div style={{ width: 36, height: 32, background: T.surface, borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>🍽️</div>
                            }
                          </td>
                        )}
                        <td style={{ ...S.td, fontWeight: 600 }}>{l.name}</td>
                        <td style={S.td}>{l.unitType}</td>
                        <td style={S.td}>
                          <input
                            type="number"
                            style={{
                              ...S.input,
                              width: 60,
                              padding: "3px 5px",
                            }}
                            value={l.qty}
                            onChange={(e) =>
                              updateLine(i, j, "qty", e.target.value)
                            }
                          />
                        </td>
                        <td style={S.td}>
                          <input
                            type="number"
                            style={{
                              ...S.input,
                              width: 100,
                              padding: "3px 5px",
                              color: T.accent,
                              fontWeight: 700,
                            }}
                            value={l.price}
                            onChange={(e) =>
                              updateLine(i, j, "price", e.target.value)
                            }
                          />
                        </td>
                        <td
                          style={{ ...S.td, fontWeight: 700, color: T.accent }}
                        >
                          {fmt(l.qty * l.price)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{ textAlign: "right", marginBottom: 10 }}>
                  {p.discount > 0 && (
                    <div style={{ fontSize: 11, color: T.textMuted }}>
                      Discount: -{fmt(p.discount)}
                    </div>
                  )}
                  <div
                    style={{ fontSize: 13, fontWeight: 800, color: T.accent }}
                  >
                    TOTAL: {fmt(total)}
                  </div>
                  <div style={{ fontSize: 10, color: T.textMuted }}>
                    Deposit (50%): {fmt(total * 0.5)}
                  </div>
                </div>

                {/* Inventory Links section */}
                <div style={{ marginBottom: 10 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 6,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: T.textMuted,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      📦 Linked Inventory / Ingredients
                    </div>
                    <button
                      style={{
                        ...S.btn("ghost"),
                        fontSize: 10,
                        padding: "2px 7px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowInvLink(showInvLink === i ? null : i);
                      }}
                    >
                      {showInvLink === i ? "Done" : "Edit Links"}
                    </button>
                  </div>
                  {showInvLink === i && (
                    <div
                      style={{
                        display: "flex",
                        gap: 5,
                        flexWrap: "wrap",
                        marginBottom: 8,
                      }}
                    >
                      {inventory.map((inv) => {
                        const linked = (p.inventoryLinks || []).includes(
                          inv.id
                        );
                        return (
                          <div
                            key={inv.id}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleInventoryLink(i, inv.id);
                            }}
                            style={{
                              padding: "3px 9px",
                              borderRadius: 20,
                              fontSize: 11,
                              cursor: "pointer",
                              background: linked ? `${T.accent}20` : T.surface,
                              border: `1px solid ${
                                linked ? T.accent : T.border
                              }`,
                              color: linked ? T.accent : T.textMuted,
                            }}
                          >
                            {linked ? "✓ " : ""}
                            {inv.name}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {(p.inventoryLinks || []).length > 0 ? (
                    <div
                      style={{
                        background: T.surface,
                        borderRadius: 7,
                        padding: 10,
                      }}
                    >
                      <div className="tbl-wrap">
                        <table style={S.table}>
                          <thead>
                            <tr>
                              <th style={S.th}>Ingredient</th>
                              <th style={S.th}>Unit</th>
                              <th style={S.th}>Cost/Unit</th>
                              <th style={S.th}>Used/Plate</th>
                              <th style={S.th}>Est. Total Cost</th>
                            </tr>
                          </thead>
                          <tbody>
                            {inventory
                              .filter((inv) =>
                                (p.inventoryLinks || []).includes(inv.id)
                              )
                              .map((inv) => (
                                <tr key={inv.id}>
                                  <td style={{ ...S.td, fontWeight: 600 }}>
                                    {inv.name}
                                  </td>
                                  <td style={S.td}>{inv.unit}</td>
                                  <td style={S.td}>{fmt(inv.costPerUnit)}</td>
                                  <td style={S.td}>{inv.usedPerPlate}</td>
                                  <td
                                    style={{
                                      ...S.td,
                                      color: T.danger,
                                      fontWeight: 700,
                                    }}
                                  >
                                    {fmt(
                                      inv.usedPerPlate *
                                        inv.costPerUnit *
                                        p.guests
                                    )}
                                  </td>
                                </tr>
                              ))}
                            <tr>
                              <td
                                colSpan={4}
                                style={{
                                  ...S.td,
                                  fontWeight: 700,
                                  textAlign: "right",
                                }}
                              >
                                Total Ingredient Cost ({p.guests} guests):
                              </td>
                              <td
                                style={{
                                  ...S.td,
                                  color: T.danger,
                                  fontWeight: 800,
                                  fontSize: 13,
                                }}
                              >
                                {fmt(
                                  inventory
                                    .filter((inv) =>
                                      (p.inventoryLinks || []).includes(inv.id)
                                    )
                                    .reduce(
                                      (s, inv) =>
                                        s +
                                        inv.usedPerPlate *
                                          inv.costPerUnit *
                                          p.guests,
                                      0
                                    )
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div style={{ fontSize: 11, color: T.textDim }}>
                      No inventory items linked. Click "Edit Links" to connect
                      ingredients for costing.
                    </div>
                  )}
                </div>

                {/* ── Event Link Section ── */}
                <div style={{ marginBottom: 10, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 13px" }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>
                    🎉 Linked Catering Event
                  </div>
                  {p.eventId ? (() => {
                    const linkedEvt = events.find((e) => e.id === p.eventId);
                    return linkedEvt ? (
                      <div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
                          <div>
                            <div style={{ fontSize: 12, fontWeight: 700, color: T.catering, marginBottom: 2 }}>{linkedEvt.name}</div>
                            <div style={{ fontSize: 11, color: T.textMuted, lineHeight: 1.7 }}>
                              {linkedEvt.eventDate || "Date TBD"} · {linkedEvt.location || "Location TBD"}<br/>
                              {linkedEvt.guests} guests · <span style={{ color: T.accent }}>{fmt(linkedEvt.revenue)}</span><br/>
                              Stage: <span style={{ fontWeight: 700 }}>{linkedEvt.phase}</span>
                            </div>
                          </div>
                          <button
                            style={{ ...S.btn("ghost"), fontSize: 10, padding: "3px 8px", color: T.danger, borderColor: T.danger + "40", flexShrink: 0 }}
                            onClick={(e) => { e.stopPropagation(); linkProposalToEvent(i, null); }}
                          >
                            ✕ Unlink
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div style={{ fontSize: 11, color: T.danger }}>⚠️ Linked event not found (may have been deleted).</div>
                    );
                  })() : (
                    <div>
                      <div style={{ fontSize: 11, color: T.textDim, marginBottom: 8 }}>
                        No catering event linked. Link to an existing event or convert this proposal into a new one.
                      </div>
                      {events.length > 0 && (
                        <div style={{ marginBottom: 8 }}>
                          <label style={S.label}>Link to existing event</label>
                          <div style={{ display: "flex", gap: 6 }}>
                            <select
                              style={{ ...S.select, flex: 1 }}
                              defaultValue=""
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) => {
                                e.stopPropagation();
                                if (e.target.value) linkProposalToEvent(i, Number(e.target.value));
                              }}
                            >
                              <option value="">— Select an event —</option>
                              {events.map((ev) => (
                                <option key={ev.id} value={ev.id}>
                                  {ev.name} · {ev.eventDate || "TBD"} · {ev.phase}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Payment Terms inline edit */}
                <div style={{ marginBottom: 10, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 13px" }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>
                    💳 Payment Terms
                  </div>
                  <textarea
                    style={{ ...S.input, minHeight: 52, resize: "vertical", fontFamily: "inherit", fontSize: 12, width: "100%" }}
                    value={p.paymentTerms !== undefined ? p.paymentTerms : (biz.paymentTerms || "")}
                    placeholder={biz.paymentTerms || "Cash · Mobile Money (MoMo) · Orange Money · Bank Transfer"}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => {
                      e.stopPropagation();
                      const u = [...proposals];
                      u[i] = { ...p, paymentTerms: e.target.value };
                      setProposals(u);
                    }}
                  />
                  <div style={{ fontSize: 10, color: T.textDim, marginTop: 3 }}>
                    Edits here are saved automatically and reflected on the printed proposal.
                  </div>
                </div>

                {/* Proposal Clauses editor */}
                {(() => {
                  const DEFAULT_CLAUSES = [
                    { label: "Validity", text: "This proposal is valid for 14 days from the issue date." },
                    { label: "Confirmation", text: "A signed acceptance and deposit confirms your booking." },
                    { label: "Cancellation", text: "Deposits are non-refundable within 7 days of the event date." },
                  ];
                  const clauses = p.terms && p.terms.length > 0 ? p.terms : DEFAULT_CLAUSES;
                  const setClauses = (newClauses) => {
                    const u = [...proposals];
                    u[i] = { ...p, terms: newClauses };
                    setProposals(u);
                  };
                  return (
                    <div style={{ marginBottom: 10, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 13px" }} onClick={e => e.stopPropagation()}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.5 }}>
                          📋 Proposal Clauses
                        </div>
                        <button
                          style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 8px" }}
                          onClick={() => setClauses([...clauses, { label: "New Clause", text: "" }])}
                        >
                          + Add Clause
                        </button>
                      </div>
                      {clauses.map((clause, ci) => (
                        <div key={ci} style={{ marginBottom: 8, border: `1px solid ${T.border}`, borderRadius: 6, overflow: "hidden" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "5px 8px", background: T.card, borderBottom: `1px solid ${T.border}` }}>
                            <input
                              style={{ ...S.input, flex: 1, padding: "3px 6px", fontSize: 11, fontWeight: 700 }}
                              value={clause.label}
                              placeholder="Clause label (e.g. Validity)"
                              onChange={e => {
                                const u = clauses.map((c, j) => j === ci ? { ...c, label: e.target.value } : c);
                                setClauses(u);
                              }}
                            />
                            <div style={{ display: "flex", gap: 3 }}>
                              {ci > 0 && (
                                <button
                                  style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px" }}
                                  title="Move up"
                                  onClick={() => {
                                    const u = [...clauses];
                                    [u[ci - 1], u[ci]] = [u[ci], u[ci - 1]];
                                    setClauses(u);
                                  }}
                                >↑</button>
                              )}
                              {ci < clauses.length - 1 && (
                                <button
                                  style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px" }}
                                  title="Move down"
                                  onClick={() => {
                                    const u = [...clauses];
                                    [u[ci], u[ci + 1]] = [u[ci + 1], u[ci]];
                                    setClauses(u);
                                  }}
                                >↓</button>
                              )}
                              <button
                                style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px", color: T.danger, borderColor: T.danger + "40" }}
                                title="Delete clause"
                                onClick={() => setClauses(clauses.filter((_, j) => j !== ci))}
                              >✕</button>
                            </div>
                          </div>
                          <textarea
                            style={{ ...S.input, width: "100%", minHeight: 44, resize: "vertical", fontFamily: "inherit", fontSize: 11, borderRadius: 0, border: "none", borderTop: `1px solid ${T.border}` }}
                            value={clause.text}
                            placeholder="Clause text…"
                            onChange={e => {
                              const u = clauses.map((c, j) => j === ci ? { ...c, text: e.target.value } : c);
                              setClauses(u);
                            }}
                          />
                        </div>
                      ))}
                      {clauses.length === 0 && (
                        <div style={{ fontSize: 11, color: T.textDim, padding: "4px 0" }}>No clauses — printed proposal will show none.</div>
                      )}
                      <div style={{ fontSize: 10, color: T.textDim, marginTop: 3 }}>
                        Clauses appear at the bottom of the printed proposal. Edits are saved automatically.
                      </div>
                    </div>
                  );
                })()}

                <div style={{ display: "flex", gap: 5, flexWrap: "wrap" }}>
                  <button
                    style={{ ...S.btn("primary"), fontSize: 11, padding: "4px 9px" }}
                    onClick={(e) => { e.stopPropagation(); openDoc(`Proposal – ${p.num}`, buildProposalHTML(p, biz, logo)); }}
                  >
                    🖨️ Print Proposal
                  </button>
                  {(p.status === "Draft" || p.status === "Sent") && (
                    <button
                      style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px", borderColor: T.accent, color: T.accent }}
                      onClick={(e) => { e.stopPropagation(); startEditProposal(i); }}
                    >
                      ✏️ Edit
                    </button>
                  )}
                  <button
                    style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px", borderColor: "#6366f1", color: "#6366f1" }}
                    onClick={(e) => { e.stopPropagation(); setContractModal({ propIdx: i }); }}
                  >
                    📄 Contract
                  </button>
                  <button
                    style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px" }}
                    onClick={(e) => { e.stopPropagation(); const u = [...proposals]; u[i] = { ...p, status: "Sent" }; setProposals(u); }}
                  >
                    ✉️ Mark Sent
                  </button>
                  <button
                    style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px", borderColor: "#25D366", color: "#25D366" }}
                    title="Send via WhatsApp"
                    onClick={(e) => {
                      e.stopPropagation();
                      const total = propTotal(p.lines, p.discount);
                      const deposit = Math.round(total * 0.5);
                      const itemList = p.lines.map(l => `  • ${l.name} × ${l.qty} @ ${fmt(l.price)} XAF`).join("\n");
                      const msg = `Hello ${p.client || "there"} 👋,\n\nThank you for your interest in *${biz.name}*!\n\nPlease find below your catering proposal:\n\n*${p.num} — ${p.eventType || "Event"}*\n📅 Date: ${p.plannedDate || "TBD"}\n📍 Venue: ${p.location || "TBD"}\n👥 Guests: ${p.guests || "TBD"}\n\n*Services Proposed:*\n${itemList}\n\n*Total: ${fmt(total)} XAF*\n💰 Deposit required (50%): ${fmt(deposit)} XAF\n\n${p.notes ? `Notes: ${p.notes}\n\n` : ""}To confirm your booking, please approve this proposal and pay the deposit.\n\nWe look forward to serving you! 🍽️\n\n— ${biz.name}${biz.phone ? `\n📞 ${biz.phone}` : ""}`;
                      const phone = (p.clientPhone || "").replace(/\D/g, "");
                      const url = `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
                      window.open(url, "_blank");
                      const u = [...proposals]; u[i] = { ...p, status: p.status === "Draft" ? "Sent" : p.status }; setProposals(u);
                    }}
                  >
                    💬 WhatsApp
                  </button>
                  <button
                    style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px", borderColor: T.info, color: T.info }}
                    title="Copy SMS message to clipboard"
                    onClick={(e) => {
                      e.stopPropagation();
                      const total = propTotal(p.lines, p.discount);
                      const deposit = Math.round(total * 0.5);
                      const msg = `Hi ${p.client || "there"}, this is ${biz.name}. Your catering proposal ${p.num} for ${p.eventType || "your event"} on ${p.plannedDate || "TBD"} is ready. Total: ${fmt(total)} XAF, deposit: ${fmt(deposit)} XAF. Please confirm to book. Call us: ${biz.phone || ""}`;
                      navigator.clipboard.writeText(msg).then(() => alert("SMS message copied to clipboard! Paste it in your messaging app.")).catch(() => prompt("Copy this SMS:", msg));
                    }}
                  >
                    📱 Copy SMS
                  </button>
                  <button
                    style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px", borderColor: T.success, color: T.success }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (p.status === "Approved") return;
                      if (!window.confirm(
                        `Approve ${p.num}?\n\nThis will automatically:\n✅ Mark proposal as Approved\n🎉 Create a Confirmed event\n🧾 Generate an unpaid invoice (${p.lines.length > 0 ? fmt(propTotal(p.lines, p.discount)) : "—"} XAF)\n👤 Add/update client in Customers\n\nProceed?`
                      )) return;
                      approveProposal(i);
                    }}
                  >
                    ✓ Approve
                  </button>
                  {p.status === "Approved" && p.eventId && (
                    <span style={{ fontSize: 10, color: T.success, padding: "4px 6px", background: T.success + "15", borderRadius: 6, display: "flex", alignItems: "center", gap: 3 }}>
                      🎉 Event &amp; invoice created
                    </span>
                  )}
                  {!p.eventId && p.status !== "Approved" && (
                    <button
                      style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px", borderColor: T.catering, color: T.catering }}
                      onClick={(e) => { e.stopPropagation(); convertToEvent(i); }}
                    >
                      🎉 Convert to Event
                    </button>
                  )}
                  <button
                    style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px" }}
                    onClick={(e) => { e.stopPropagation(); duplicateProposal(i); }}
                    title="Create a copy of this proposal as a new Draft"
                  >
                    📋 Duplicate
                  </button>
                  <button
                    style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px",
                      borderColor: p.isTemplate ? T.accent : T.border,
                      color: p.isTemplate ? T.accent : T.textMuted,
                      background: p.isTemplate ? T.accentSoft : "transparent",
                    }}
                    onClick={(e) => { e.stopPropagation(); toggleTemplate(i); }}
                    title={p.isTemplate ? "Remove from templates" : "Save as reusable template"}
                  >
                    {p.isTemplate ? "⭐ Template" : "☆ Save as Template"}
                  </button>
                  <button
                    style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px", color: T.danger, borderColor: T.danger + "40", marginLeft: "auto" }}
                    onClick={(e) => { e.stopPropagation(); if (window.confirm(`Delete ${p.num}?`)) setProposals(prev => prev.filter((_, j) => j !== i)); }}
                  >
                    🗑 Delete
                  </button>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ─── BATCHES TAB ──────────────────────────────────────────────────
function BatchesTab({ batches, setBatches, meals, setMeals, inventory, setInventory, getMealTotalCost, sales }) {
  const isMobile = useIsMobile();
  const TODAY = new Date().toISOString().slice(0, 10);

  const EMPTY_BATCH = {
    date: TODAY,
    mealId: "",
    mealName: "",
    portions: "",
    totalCost: "",
    notes: "",
    deductInventory: true,
  };
  const [adding, setAdding] = useState(false);
  const [editBatchId, setEditBatchId] = useState(null);
  const [nb, setNb] = useState(EMPTY_BATCH);
  const [filterDate, setFilterDate] = useState("");
  const [confirm, setConfirm] = useState(null); // batch id to delete

  const selectedMeal = meals.find((m) => m.id === Number(nb.mealId));
  const suggestedCost = selectedMeal ? getMealTotalCost(selectedMeal) * Number(nb.portions || 0) : 0;

  const saveBatch = () => {
    if (!nb.mealName || !nb.portions) return;
    const portions = Number(nb.portions);
    const totalCost = nb.totalCost !== "" ? Number(nb.totalCost) : suggestedCost;
    const costPerPortion = portions > 0 ? totalCost / portions : 0;

    const batch = {
      id: editBatchId || Date.now(),
      date: nb.date,
      mealId: nb.mealId ? Number(nb.mealId) : null,
      mealName: nb.mealName,
      portions,
      totalCost,
      costPerPortion,
      notes: nb.notes,
      deductInventory: nb.deductInventory,
    };

    if (editBatchId) {
      // Editing: adjust meal availablePortions by the difference
      const oldBatch = batches.find((b) => b.id === editBatchId);
      const portionDiff = portions - (oldBatch?.portions || 0);
      if (selectedMeal && portionDiff !== 0) {
        setMeals((prev) =>
          prev.map((m) =>
            m.id === selectedMeal.id
              ? { ...m, availablePortions: Math.max(0, (Number(m.availablePortions) || 0) + portionDiff) }
              : m
          )
        );
      }
      setBatches((prev) => prev.map((b) => b.id === editBatchId ? batch : b));
    } else {
      // New batch: deduct inventory and add portions
      if (nb.deductInventory && selectedMeal?.ingredientLinks?.length) {
        setInventory((prev) =>
          prev.map((item) => {
            const link = selectedMeal.ingredientLinks.find((l) => l.inventoryId === item.id);
            if (!link) return item;
            return { ...item, stock: Math.max(0, item.stock - link.qty * portions) };
          })
        );
      }
      if (selectedMeal) {
        setMeals((prev) =>
          prev.map((m) =>
            m.id === selectedMeal.id
              ? { ...m, availablePortions: (Number(m.availablePortions) || 0) + portions }
              : m
          )
        );
      }
      setBatches((prev) => [batch, ...prev]);
    }

    setAdding(false);
    setEditBatchId(null);
    setNb(EMPTY_BATCH);
  };

  const deleteBatch = (id) => {
    // Restore portions to the linked meal when deleting a batch
    const b = batches.find((bt) => bt.id === id);
    if (b?.mealId) {
      setMeals((prev) =>
        prev.map((m) =>
          m.id === b.mealId
            ? { ...m, availablePortions: Math.max(0, (Number(m.availablePortions) || 0) - b.portions) }
            : m
        )
      );
    }
    setBatches((prev) => prev.filter((bt) => bt.id !== id));
    setConfirm(null);
  };

  const startEditBatch = (b) => {
    setNb({
      date: b.date,
      mealId: b.mealId ? String(b.mealId) : "",
      mealName: b.mealName,
      portions: String(b.portions),
      totalCost: String(b.totalCost),
      notes: b.notes || "",
      deductInventory: false, // don't re-deduct on edit
    });
    setEditBatchId(b.id);
    setAdding(true);
  };

  // Compute remaining portions for a batch: batch.portions minus all sales of that meal on/after batch date
  const batchRemaining = (b) => {
    if (!b.mealId) return null;
    const sold = (sales || []).reduce((sum, s) => {
      // Multi-item orders: check items array
      if (Array.isArray(s.items) && s.items.length > 0) {
        return sum + s.items
          .filter(it => Number(it.mealId) === Number(b.mealId) && s.date >= b.date)
          .reduce((a, it) => a + Number(it.plates || 0), 0);
      }
      // Legacy single-item orders
      return sum + (Number(s.mealId) === Number(b.mealId) && s.date >= b.date ? Number(s.plates || 0) : 0);
    }, 0);
    return Math.max(0, b.portions - sold);
  };

  const filtered = filterDate
    ? batches.filter((b) => b.date === filterDate)
    : batches;

  const totalPortions = filtered.reduce((s, b) => s + b.portions, 0);
  const totalCost = filtered.reduce((s, b) => s + b.totalCost, 0);
  const avgCostPerPortion = totalPortions > 0 ? totalCost / totalPortions : 0;
  const todayBatches = batches.filter((b) => b.date === TODAY);
  const todayPortions = todayBatches.reduce((s, b) => s + b.portions, 0);

  return (
    <div>
      {/* KPI row */}
      <div style={S.grid(4)}>
        <KpiCard label="Today's Portions" value={todayPortions} icon="🍽️" color={T.accent} />
        <KpiCard label="Today's Batches" value={todayBatches.length} icon="🍳" color={T.restaurant} />
        <KpiCard label="Total Cost (filtered)" value={fmt(totalCost)} icon="💰" color={T.warning} />
        <KpiCard label="Avg Cost / Portion" value={fmt(avgCostPerPortion)} icon="📊" />
      </div>

      {/* Header row */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "16px 0 10px" }}>
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <div style={{ fontSize: 13, fontWeight: 700 }}>🍳 Production Batches</div>
          <input
            type="date"
            value={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
            style={{ ...S.input, width: 140, marginBottom: 0, fontSize: 11 }}
          />
          {filterDate && (
            <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "3px 8px" }} onClick={() => setFilterDate("")}>
              Clear filter
            </button>
          )}
        </div>
        <button style={{ ...S.btn("primary"), fontSize: 12, padding: "6px 14px" }} onClick={() => { setAdding(true); setNb(EMPTY_BATCH); }}>
          + Log Batch
        </button>
      </div>

      {/* Add batch form */}
      {adding && (
        <div style={{ background: T.card, border: `1px solid ${T.accent}40`, borderRadius: 10, padding: 16, marginBottom: 14 }}>
          <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 12, color: T.accent }}>{editBatchId ? "✏️ Edit Batch" : "🍳 Log Production Batch"}</div>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 10 }}>
            <div>
              <label style={S.label}>Date</label>
              <input type="date" style={S.input} value={nb.date} onChange={(e) => setNb((n) => ({ ...n, date: e.target.value }))} />
            </div>
            <div>
              <label style={S.label}>Meal / Dish</label>
              <select
                style={S.select}
                value={nb.mealId}
                onChange={(e) => {
                  const meal = meals.find((m) => m.id === Number(e.target.value));
                  const newCost = meal ? getMealTotalCost(meal) * Number(nb.portions || 0) : 0;
                  setNb((n) => ({
                    ...n,
                    mealId: e.target.value,
                    mealName: meal ? meal.name : "",
                    totalCost: !editBatchId && newCost > 0 ? String(Math.round(newCost)) : n.totalCost,
                  }));
                }}
              >
                <option value="">— Select a meal —</option>
                {[...new Set(meals.filter(m => m.active !== false).map(m => m.category || "Other"))].sort().map(cat => (
                  <optgroup key={cat} label={cat}>
                    {meals.filter(m => m.active !== false && (m.category || "Other") === cat).map(m => (
                      <option key={m.id} value={m.id}>{m.name}</option>
                    ))}
                  </optgroup>
                ))}
              </select>
              {!nb.mealId && (
                <input
                  style={{ ...S.input, marginTop: 6 }}
                  placeholder="Or type meal name manually"
                  value={nb.mealName}
                  onChange={(e) => setNb((n) => ({ ...n, mealName: e.target.value }))}
                />
              )}
            </div>
            <div>
              <label style={S.label}>Portions Produced</label>
              <input
                type="number"
                style={S.input}
                placeholder="e.g. 25"
                value={nb.portions}
                onChange={(e) => {
                  const portions = e.target.value;
                  const newCost = selectedMeal ? getMealTotalCost(selectedMeal) * Number(portions || 0) : 0;
                  setNb((n) => ({
                    ...n,
                    portions,
                    totalCost: !editBatchId && newCost > 0 ? String(Math.round(newCost)) : n.totalCost,
                  }));
                }}
              />
            </div>
            <div>
              <label style={S.label}>
                Total Production Cost (XAF)
                {suggestedCost > 0 && (
                  <span
                    style={{ color: T.accent, marginLeft: 8, cursor: "pointer", fontWeight: 400, fontSize: 10 }}
                    onClick={() => setNb((n) => ({ ...n, totalCost: String(Math.round(suggestedCost)) }))}
                  >↺ Recalculate ({fmt(suggestedCost)})</span>
                )}
              </label>
              <input
                type="number"
                style={S.input}
                placeholder={suggestedCost > 0 ? `Suggested: ${Math.round(suggestedCost)}` : "e.g. 47500"}
                value={nb.totalCost}
                onChange={(e) => setNb((n) => ({ ...n, totalCost: e.target.value }))}
              />
              {nb.portions && nb.totalCost && (
                <div style={{ fontSize: 10, color: T.accent, marginTop: 3 }}>
                  → {fmt(Number(nb.totalCost) / Number(nb.portions))} per portion
                </div>
              )}
              {nb.portions && !nb.totalCost && suggestedCost > 0 && (
                <div style={{ fontSize: 10, color: T.textMuted, marginTop: 3 }}>
                  → Suggested {fmt(suggestedCost / Number(nb.portions))} per portion
                </div>
              )}
            </div>
            <div style={{ gridColumn: isMobile ? "1" : "1 / -1" }}>
              <label style={S.label}>Notes (optional)</label>
              <input style={S.input} placeholder="e.g. Used long-grain rice, extra spices" value={nb.notes} onChange={(e) => setNb((n) => ({ ...n, notes: e.target.value }))} />
            </div>
          </div>

          {/* Inventory deduction toggle — hidden in edit mode */}
          {!editBatchId && selectedMeal?.ingredientLinks?.length > 0 && (
            <div style={{ marginTop: 10, padding: "8px 12px", background: T.surface, borderRadius: 8, display: "flex", alignItems: "center", gap: 10 }}>
              <input
                type="checkbox"
                id="deductInv"
                checked={nb.deductInventory}
                onChange={(e) => setNb((n) => ({ ...n, deductInventory: e.target.checked }))}
                style={{ accentColor: T.accent }}
              />
              <label htmlFor="deductInv" style={{ fontSize: 11, color: T.textMuted, cursor: "pointer" }}>
                Auto-deduct ingredients from inventory ({selectedMeal.ingredientLinks.length} linked ingredient{selectedMeal.ingredientLinks.length > 1 ? "s" : ""})
              </label>
            </div>
          )}

          {editBatchId && (
            <div style={{ marginTop: 10, padding: "7px 11px", background: T.surface, borderRadius: 7, fontSize: 11, color: T.textMuted }}>
              ℹ️ Editing a batch updates the portion count. Inventory will not be re-deducted. To fix inventory, edit it directly in the Inventory tab.
            </div>
          )}
          <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
            <button
              style={{ ...S.btn("primary"), fontSize: 12, opacity: (!nb.mealName || !nb.portions) ? 0.5 : 1 }}
              disabled={!nb.mealName || !nb.portions}
              onClick={saveBatch}
            >
              {editBatchId ? "✓ Update Batch" : "✓ Save Batch"}
            </button>
            <button style={{ ...S.btn("ghost"), fontSize: 12 }} onClick={() => { setAdding(false); setEditBatchId(null); setNb(EMPTY_BATCH); }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Batches table */}
      {filtered.length === 0 ? (
        <div style={{ color: T.textMuted, padding: 36, textAlign: "center", background: T.card, borderRadius: 10, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>🍳</div>
          <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>No batches recorded yet</div>
          <div style={{ fontSize: 11, lineHeight: 1.7 }}>
            Click <strong>+ Log Batch</strong> to record a production run.<br />
            e.g. Jollof Rice · 25 portions · Cost: 47,500 XAF · 1,900 XAF/portion
          </div>
        </div>
      ) : (
        <div className="tbl-wrap">
          <table style={S.table}>
            <thead>
              <tr>
                {["Date", "Meal / Dish", "Portions", "Remaining", "Total Cost", "Cost/Portion", "Inv. Deducted", "Notes", ""].map((h) => (
                  <th key={h} style={S.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((b) => (
                <tr key={b.id}>
                  <td style={{ ...S.td, whiteSpace: "nowrap", color: T.textMuted }}>{b.date}</td>
                  <td style={{ ...S.td, fontWeight: 700 }}>{b.mealName}</td>
                  <td style={{ ...S.td, color: T.accent, fontWeight: 700 }}>{b.portions}</td>
                  <td style={S.td}>
                    {(() => {
                      const rem = batchRemaining(b);
                      if (rem === null) return <span style={{ color: T.textDim }}>—</span>;
                      if (rem === 0) return <span style={{ color: T.danger, fontWeight: 700 }}>0 sold out</span>;
                      if (rem <= 5) return <span style={{ color: T.warning, fontWeight: 700 }}>{rem} low</span>;
                      return <span style={{ color: T.success, fontWeight: 700 }}>{rem}</span>;
                    })()}
                  </td>
                  <td style={{ ...S.td }}>{fmt(b.totalCost)}</td>
                  <td style={{ ...S.td, color: T.success }}>{fmt(b.costPerPortion)}</td>
                  <td style={{ ...S.td, textAlign: "center" }}>
                    {b.deductInventory ? (
                      <span style={{ color: T.success, fontSize: 12 }}>✓</span>
                    ) : (
                      <span style={{ color: T.textDim, fontSize: 12 }}>—</span>
                    )}
                  </td>
                  <td style={{ ...S.td, color: T.textMuted, fontSize: 11 }}>{b.notes || "—"}</td>
                  <td style={S.td}>
                    <div style={{ display: "flex", gap: 4 }}>
                      {confirm === b.id ? (
                        <>
                          <button style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 7px", color: T.danger, borderColor: T.danger + "50" }} onClick={() => deleteBatch(b.id)}>Delete</button>
                          <button style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 7px" }} onClick={() => setConfirm(null)}>Cancel</button>
                        </>
                      ) : (
                        <>
                          <button style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 7px" }} title="Edit batch" onClick={() => startEditBatch(b)}>✏️</button>
                          <button style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 7px", color: T.danger }} title="Delete batch" onClick={() => setConfirm(b.id)}>🗑</button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Summary by meal */}
      {batches.length > 2 && (
        <div style={{ marginTop: 20 }}>
          <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, color: T.textMuted }}>📊 Production Summary by Meal</div>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: 8 }}>
            {Object.entries(
              batches.reduce((acc, b) => {
                if (!acc[b.mealName]) acc[b.mealName] = { portions: 0, cost: 0, runs: 0 };
                acc[b.mealName].portions += b.portions;
                acc[b.mealName].cost += b.totalCost;
                acc[b.mealName].runs += 1;
                return acc;
              }, {})
            )
              .sort((a, b) => b[1].portions - a[1].portions)
              .map(([name, stats]) => (
                <div key={name} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 13px" }}>
                  <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 4 }}>{name}</div>
                  <div style={{ fontSize: 11, color: T.textMuted, lineHeight: 1.8 }}>
                    <div>{stats.portions} portions across {stats.runs} run{stats.runs > 1 ? "s" : ""}</div>
                    <div>Total cost: <span style={{ color: T.warning }}>{fmt(stats.cost)}</span></div>
                    <div>Avg/portion: <span style={{ color: T.success }}>{fmt(stats.cost / stats.portions)}</span></div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── RESTAURANT & DELIVERY (with Meals tab) ─────────────────────
function RestaurantPage({
  sales,
  setSales,
  inventory,
  setInventory,
  catalogItems,
  setCatalogItems,
  catalogCategories,
  setCatalogCategories,
  meals,
  setMeals,
  batches,
  setBatches,
  logo,
  biz,
  customers,
  setCustomers,
  invPurchases,
  setInvPurchases,
}) {
  const [tab, setTab] = useState("orders");
  const [filterType, setFilterType] = useState("All");
  const [filterPayment, setFilterPayment] = useState("All"); // All | Unpaid | Paid
  const [filterOrderDate, setFilterOrderDate] = useState(""); // "" = all, or YYYY-MM-DD
  const [filterItemKind, setFilterItemKind] = useState("All"); // All | Food | Beverage
  const [orderPmtPanel, setOrderPmtPanel] = useState(null); // sale id
  const [addSale, setAddSale] = useState(false);
  const [editSaleId, setEditSaleId] = useState(null);
  const [doc, setDoc] = useState(null);
  // Restock modal state
  const [restockItem, setRestockItem] = useState(null); // inventory item being restocked
  const EMPTY_RESTOCK = { date: TODAY_ISO, qty: "", costPerUnit: "", supplier: "", note: "", receiptUrl: "", receiptUploading: false };
  const [restockForm, setRestockForm] = useState(EMPTY_RESTOCK);
  // Purchase log filter
  const [purchaseFilter, setPurchaseFilter] = useState("week"); // "day" | "week" | "month" | "all"
  const [purchaseFrom, setPurchaseFrom] = useState(TODAY_ISO);
  const [purchaseTo, setPurchaseTo] = useState(TODAY_ISO);
  const [viewReceiptUrl, setViewReceiptUrl] = useState(null); // lightbox
  const [viewPurchase, setViewPurchase] = useState(null); // purchase detail modal
  const restockFileRef = useRef(null);
  const EMPTY = {
    date: TODAY_ISO,
    items: [],           // [{ meal, mealId, _catalogItemId, plates, pricePerPlate }]
    method: "Cash",
    type: "Dine-in",
    deliveryFee: 0,
    deliveryAddress: "",
    clientName: "",
    clientPhone: "",
    clientEmail: "",
    clientCategory: "Regular",
    notes: "",
    partialPaid: "",
    _pickerMode: "batch",
    // legacy single-item fields (kept for edit compat)
    meal: "",
    mealId: null,
    plates: "",
    pricePerPlate: "",
    _catalogItemId: null,
  };
  const EMPTY_ITEM = { meal: "", mealId: null, _catalogItemId: null, plates: "", pricePerPlate: "" };
  const [ns, setNs] = useState(EMPTY);
  const [currentItem, setCurrentItem] = useState(EMPTY_ITEM); // item being composed before adding to order
  const [showNewCustomer, setShowNewCustomer] = useState(false);
  const [newCust, setNewCust] = useState({ name: "", phone: "", email: "", notes: "" });

  const [addingInv, setAddingInv] = useState(false);
  const [editInvId, setEditInvId] = useState(null);
  const [invSearch, setInvSearch] = useState("");
  const [invCatFilter, setInvCatFilter] = useState("All");
  const [ni, setNi] = useState({
    name: "",
    category: "Ingredient",
    itemType: "ingredient", // "ingredient" | "resale"
    unit: "kg",
    stock: "",
    reorderAt: "",
    costPerUnit: "",
    sellingPrice: "", // only relevant for resale items
    linkedMeals: "",
  });
  const [invCategories, setInvCategories] = useState([
    "Ingredient", "Packaging", "Fuel", "Beverage", "Cleaning", "Other",
  ]);
  const [showNewCatInput, setShowNewCatInput] = useState(false);
  const [newCatValue, setNewCatValue] = useState("");
  // Meals state
  const [addingMeal, setAddingMeal] = useState(false);
  const [editMealId, setEditMealId] = useState(null);
  const [mealSearch, setMealSearch] = useState("");
  const [mealCatFilter, setMealCatFilter] = useState("All");
  const [ingSearch, setIngSearch] = useState(""); // search inside ingredient list when costing
  const EMPTY_MEAL = {
    name: "",
    description: "",
    price: "",
    category: catalogCategories?.[0]?.name || "Main",
    photo: null,
    active: true,
    ingredientLinks: [],
    laborCost: "",
    otherCosts: [],
    availablePortions: "",
  };
  const [nm, setNm] = useState(EMPTY_MEAL);
  const [editIngLinks, setEditIngLinks] = useState(null); // meal id
  const [expandedMeal, setExpandedMeal] = useState(null); // meal id for costing panel
  const mealPhotoRef = useRef();
  const isMobile = useIsMobile();

  // On mount: sweep all existing sales and extract named clients into Customers
  useEffect(() => {
    const named = sales.filter(s => s.clientName && s.clientName.trim());
    if (!named.length) return;
    setCustomers(prev => {
      let updated = [...prev];
      named.forEach(s => {
        const name = s.clientName.trim();
        const phone = (s.clientPhone || "").trim();
        const email = (s.clientEmail || "").trim();
        const classification = s.clientCategory || "Regular";
        const idx = updated.findIndex(c => c.name.toLowerCase() === name.toLowerCase());
        if (idx >= 0) {
          updated[idx] = { ...updated[idx], phone: phone || updated[idx].phone, email: email || updated[idx].email };
        } else {
          updated.push({ id: Date.now() + Math.random(), name, phone, email, classification, notes: "", createdAt: TODAY_ISO });
        }
      });
      return updated;
    });
  }, []); // intentional: runs once on mount to backfill

  const openDoc = (title, html) =>
    setDoc({ title, html, onPrint: () => printDoc(title, html) });
  const filtered = sales
    .filter(s => filterType === "All" || s.type === filterType)
    .filter(s => !filterOrderDate || s.date === filterOrderDate)
    .filter(s => {
      if (filterPayment === "All") return true;
      const tot = orderTotal(s);
      const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
      const bal = tot - paid;
      if (filterPayment === "Unpaid") return bal > 0;
      if (filterPayment === "Paid") return bal <= 0;
      return true;
    })
    .filter(s => {
      if (filterItemKind === "All") return true;
      const items = Array.isArray(s.items) && s.items.length > 0 ? s.items : [];
      if (filterItemKind === "Beverage") {
        // Order contains at least one resale/beverage item
        return items.some(it => it._itemType === "resale") || s._itemType === "resale";
      }
      if (filterItemKind === "Food") {
        // Order contains only food items (no resale items), or is a legacy single-item food order
        const hasResale = items.some(it => it._itemType === "resale");
        return !hasResale && s._itemType !== "resale";
      }
      return true;
    });
  // All KPIs derive from `filtered` so they're always in sync with active filters
  const filteredRev    = filtered.reduce((s, r) => s + orderTotal(r), 0);
  const filteredPlates = filtered.reduce((sum, s) => sum + totalPlates(s), 0);
  const filteredDel    = filtered.filter(s => s.type === "Delivery");
  const filteredDelRev  = filteredDel.reduce((s, r) => s + orderTotal(r), 0);
  const filteredDelFees = filteredDel.reduce((s, r) => s + (r.deliveryFee || 0), 0);
  const filteredDineRev = filtered.filter(s => s.type === "Dine-in").reduce((s, r) => s + orderTotal(r), 0);
  const filteredTkRev   = filtered.filter(s => s.type === "Takeaway").reduce((s, r) => s + orderTotal(r), 0);

  // Best seller from filtered orders
  const filteredByMeal = {};
  filtered.forEach(s => {
    const items = Array.isArray(s.items) && s.items.length > 0
      ? s.items : [{ meal: s.meal, plates: s.plates, pricePerPlate: s.pricePerPlate }];
    items.forEach(it => {
      if (it.meal) filteredByMeal[it.meal] = (filteredByMeal[it.meal] || 0) + (Number(it.plates) || 0) * (Number(it.pricePerPlate) || 0);
    });
  });

  // Legacy names kept for Revenue by Fulfillment card (now all from filtered)
  const todayRev = filteredRev;
  const weekRev  = filteredRev;
  const delRev   = filteredDelRev;
  const delFees  = filteredDelFees;
  const dineRev  = filteredDineRev;
  const tkRev    = filteredTkRev;
  const byMeal   = filteredByMeal;

  const lowStock = inventory.filter((i) => i.stock <= i.reorderAt);
  const typeColor = {
    "Dine-in": T.restaurant,
    Takeaway: T.warning,
    Delivery: T.delivery,
  };
  const totalStockValue = inventory.reduce(
    (s, i) => s + i.stock * i.costPerUnit,
    0
  );

  const saveSale = () => {
    // Ensure any in-progress currentItem gets added automatically if it has data
    const allItems = ns.items && ns.items.length > 0 ? ns.items : [];
    if (allItems.length === 0 && !currentItem.meal) return; // nothing to save

    // If currentItem has a meal selected but wasn't added yet, add it now
    const items = allItems.length > 0 ? allItems :
      (currentItem.meal ? [{ ...currentItem, plates: Number(currentItem.plates) || 1, pricePerPlate: Number(currentItem.pricePerPlate) || 0 }] : []);

    if (items.length === 0) return;

    // For backward compat, also save top-level meal/plates/pricePerPlate from first item
    const first = items[0];
    const sale = {
      ...ns,
      id: editSaleId || Date.now(),
      items,
      meal: first.meal,
      mealId: first.mealId || null,
      plates: Number(first.plates) || 1,
      pricePerPlate: Number(first.pricePerPlate) || 0,
      deliveryFee: Number(ns.deliveryFee || 0),
    };

    if (editSaleId) {
      const old = sales.find((s) => s.id === editSaleId);
      // Restore portions for old sale items
      if (old) {
        const oldItems = old.items || [{ mealId: old.mealId, plates: old.plates }];
        oldItems.forEach(oi => {
          if (oi.mealId) setMeals(prev => prev.map(m =>
            m.id === Number(oi.mealId)
              ? { ...m, availablePortions: (Number(m.availablePortions) || 0) + Number(oi.plates) }
              : m
          ));
        });
      }
      setSales((prev) => prev.map((s) => s.id === editSaleId ? sale : s));
    } else {
      setSales((prev) => [...prev, sale]);
    }

    // Deduct portions and inventory for each item — must be done in single state updates
    // to avoid React batching overwriting earlier deductions with stale prev state

    // Build deduction maps: mealId → total plates, itemName → total qty
    const mealDeductions = {};
    const inventoryDeductions = {};

    const resaleDeductions = {}; // resaleItemId → qty sold

    items.forEach(item => {
      if (item.mealId) {
        const key = Number(item.mealId);
        mealDeductions[key] = (mealDeductions[key] || 0) + Number(item.plates);
      }
      if (!editSaleId && item._catalogItemId) {
        const key = item.meal.toLowerCase();
        inventoryDeductions[key] = (inventoryDeductions[key] || 0) + Number(item.plates);
      }
      if (!editSaleId && item._itemType === "resale" && item._resaleItemId) {
        resaleDeductions[item._resaleItemId] = (resaleDeductions[item._resaleItemId] || 0) + Number(item.plates);
      }
    });

    // Batch portions are computed live from batches minus sales (see batchRemaining / mealPortions)
    // No need to deduct availablePortions from meal state — that field is not used by the picker

    if (Object.keys(inventoryDeductions).length > 0) {
      setInventory(prev => prev.map(inv => {
        const key = inv.name.toLowerCase();
        return inventoryDeductions[key]
          ? { ...inv, stock: Math.max(0, Number(inv.stock) - inventoryDeductions[key]) }
          : inv;
      }));
    }

    // Deduct resale items by id (more precise than name matching)
    if (Object.keys(resaleDeductions).length > 0) {
      setInventory(prev => prev.map(inv =>
        resaleDeductions[inv.id] !== undefined
          ? { ...inv, stock: Math.max(0, Number(inv.stock) - resaleDeductions[inv.id]) }
          : inv
      ));
    }
    setEditSaleId(null);
    setNs(EMPTY);
    setShowNewCustomer(false);
    setNewCust({ name: "", phone: "", email: "", notes: "" });

    // Auto-upsert customer from order — merge in any new info
    if (ns.clientName && ns.clientName.trim()) {
      const name = ns.clientName.trim();
      const phone = (ns.clientPhone || "").trim();
      const email = (ns.clientEmail || "").trim();
      const classification = ns.clientCategory || "Regular";
      setCustomers(prev => {
        const idx = prev.findIndex(c => c.name.toLowerCase() === name.toLowerCase());
        if (idx >= 0) {
          const updated = [...prev];
          updated[idx] = {
            ...updated[idx],
            phone: phone || updated[idx].phone,
            email: email || updated[idx].email,
            classification: classification !== "Regular" ? classification : updated[idx].classification,
          };
          return updated;
        }
        return [...prev, { id: Date.now(), name, phone, email, classification, notes: "", createdAt: TODAY_ISO }];
      });
    }

    setAddSale(false);
    setEditSaleId(null);
    setNs(EMPTY);
    setCurrentItem(EMPTY_ITEM);
    setShowNewCustomer(false);
    setNewCust({ name: "", phone: "", email: "", notes: "" });

    // Invoice and Receipt are available on the sale card — no auto-popup
  };

  const deleteSale = (id) => {
    const s = sales.find((sale) => sale.id === id);
    if (!window.confirm("Delete this order? " + (s?.plates || "") + " plate(s) of " + (s?.meal || ""))) return;
    // Restore portions to the linked meal
    if (s?.mealId) {
      setMeals((prev) =>
        prev.map((m) =>
          m.id === Number(s.mealId)
            ? { ...m, availablePortions: (Number(m.availablePortions) || 0) + Number(s.plates) }
            : m
        )
      );
    }
    setSales((prev) => prev.filter((sale) => sale.id !== id));
  };

  const startEditSale = (s) => {
    // Normalize old single-item orders into items array
    const items = s.items && s.items.length > 0
      ? s.items
      : [{ meal: s.meal || "", mealId: s.mealId || null, _catalogItemId: s._catalogItemId || null, plates: s.plates || 1, pricePerPlate: s.pricePerPlate || 0 }];
    setNs({ ...s, items });
    setCurrentItem(EMPTY_ITEM);
    setEditSaleId(s.id);
    setAddSale(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const saveInv = () => {
    const item = {
      ...ni,
      itemType: ni.itemType || "ingredient",
      stock: Number(ni.stock),
      reorderAt: Number(ni.reorderAt),
      costPerUnit: Number(ni.costPerUnit),
      sellingPrice: ni.itemType === "resale" ? Number(ni.sellingPrice) : 0,
      linkedMeals: ni.linkedMeals
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean),
    };
    if (editInvId != null) {
      setInventory((prev) =>
        prev.map((it) =>
          it.id === editInvId ? { ...item, id: editInvId } : it
        )
      );
      setEditInvId(null);
    } else {
      setInventory((prev) => [...prev, { ...item, id: Date.now() }]);
    }
    setAddingInv(false);
    setNi({
      name: "",
      category: "Ingredient",
      itemType: "ingredient",
      unit: "kg",
      stock: "",
      reorderAt: "",
      costPerUnit: "",
      sellingPrice: "",
      linkedMeals: "",
    });
  };
  const startEditInv = (item) => {
    setNi({
      ...item,
      linkedMeals: Array.isArray(item.linkedMeals)
        ? item.linkedMeals.join(", ")
        : "",
    });
    setEditInvId(item.id);
    setAddingInv(true);
  };
  const deleteInv = (id) =>
    setInventory((prev) => prev.filter((it) => it.id !== id));

  // Meals
  const saveMeal = () => {
    if (!nm.name) return;
    const meal = {
      ...nm,
      price: Number(nm.price),
      laborCost: Number(nm.laborCost || 0),
      availablePortions: Number(nm.availablePortions || 0),
      otherCosts: nm.otherCosts || [],
    };
    if (editMealId != null) {
      setMeals((prev) =>
        prev.map((m) => (m.id === editMealId ? { ...meal, id: editMealId } : m))
      );
      setEditMealId(null);
      setExpandedMeal(null); // collapse costing panel on the card
    } else {
      setMeals((prev) => [...prev, { ...meal, id: Date.now() }]);
    }
    // Sync photo to matching catalog item
    if (meal.photo) syncPhotoToCatalog(meal.name, meal.photo);
    setAddingMeal(false);
    setNm(EMPTY_MEAL);
  };
  const startEditMeal = (meal) => {
    // Auto-fill photo from matching catalog item if meal has none
    const catMatch = catalogItems.find(c => c.name.toLowerCase() === meal.name.toLowerCase());
    const photo = meal.photo || catMatch?.photo || null;
    setNm({
      ...meal,
      photo,
      price: String(meal.price),
      laborCost: String(meal.laborCost || ""),
      availablePortions: String(meal.availablePortions || ""),
      otherCosts: meal.otherCosts || [],
    });
    setEditMealId(meal.id);
    setExpandedMeal(null); // collapse costing panel while editing
    setAddingMeal(true);
  };

  // Sync a photo to the matching catalog item by name
  const syncPhotoToCatalog = (mealName, photoSrc) => {
    if (!setCatalogItems || !photoSrc) return;
    setCatalogItems(prev => prev.map(c =>
      c.name.toLowerCase() === mealName.toLowerCase() ? { ...c, photo: photoSrc } : c
    ));
  };

  const copyToCatalog = (meal) => {
    if (!setCatalogItems) return;
    const alreadyExists = catalogItems.some(c => c.name.toLowerCase() === meal.name.toLowerCase());
    if (alreadyExists) { alert(`"${meal.name}" already exists in Catalog.`); return; }
    const defaultCat = (catalogCategories || [])[0];
    // Try to match meal category name to a catalog category
    const matchedCat = (catalogCategories || []).find(c => c.name.toLowerCase() === (meal.category || "").toLowerCase()) || defaultCat;
    setCatalogItems(prev => [...prev, {
      id: Date.now(),
      catId: matchedCat?.id || 1,
      name: meal.name,
      description: meal.description || "",
      unitType: "Per head",
      price: 0,
      costPerUnit: 0,
      photo: meal.photo || null,
      tags: [],
      notes: "",
    }]);
    alert(`✅ "${meal.name}" added to Catalog. Open the Catalog tab to set the unit type and details.`);
  };

  // Sync a photo to the matching meal by name
  const syncPhotoToMeal = (catName, photoSrc) => {
    if (!photoSrc) return;
    setMeals(prev => prev.map(m =>
      m.name.toLowerCase() === catName.toLowerCase() ? { ...m, photo: photoSrc } : m
    ));
  };
  const importMealFromCatalog = (catItem) => {
    const exists = meals.find((m) => m.name === catItem.name);
    if (exists) return;
    const meal = {
      id: Date.now(),
      name: catItem.name,
      description: catItem.description || "",
      price: catItem.price,
      category: "Imported",
      photo: catItem.photo,
      active: true,
      ingredientLinks: [],
      laborCost: 0,
      otherCosts: [],
      availablePortions: 0,
    };
    setMeals((prev) => [...prev, meal]);
  };
  const toggleIngredientLink = (mealId, invId) => {
    setMeals((prev) =>
      prev.map((m) => {
        if (m.id !== mealId) return m;
        const links = m.ingredientLinks || [];
        const has = links.some((l) => l.inventoryId === invId);
        return {
          ...m,
          ingredientLinks: has
            ? links.filter((l) => l.inventoryId !== invId)
            : [
                ...links,
                {
                  inventoryId: invId,
                  qty:
                    inventory.find((i) => i.id === invId)?.usedPerPlate || 0.1,
                },
              ],
        };
      })
    );
  };
  const updateIngQty = (mealId, invId, qty) => {
    setMeals((prev) =>
      prev.map((m) => {
        if (m.id !== mealId) return m;
        return {
          ...m,
          ingredientLinks: m.ingredientLinks.map((l) =>
            l.inventoryId === invId ? { ...l, qty: Number(qty) } : l
          ),
        };
      })
    );
  };
  const getMealIngCost = (meal) =>
    (meal.ingredientLinks || []).reduce((s, l) => {
      const inv = inventory.find((i) => i.id === l.inventoryId);
      return s + (inv ? inv.costPerUnit * l.qty : 0);
    }, 0);
  const getMealTotalCost = (meal) =>
    getMealIngCost(meal) +
    Number(meal.laborCost || 0) +
    (meal.otherCosts || []).reduce((s, c) => s + Number(c.amount || 0), 0);

  return (
    <div>
      <DocModal doc={doc} onClose={() => setDoc(null)} />
      <div style={S.pageTitle}>🍽️ Restaurant & Delivery</div>
      <div style={S.subtitle}>Orders · Meals · Inventory · Production</div>
      <div style={{ display: "flex", gap: 3, marginBottom: 14 }}>
        {[
          ["inventory", "📦 Inventory"],
          ["purchases", "🛒 Purchases"],
          ["meals", "🍲 Meals"],
          ["batches", "🍳 Batches"],
          ["orders", "📋 Orders"],
        ].map(([t, label]) => (
          <button key={t} style={S.navBtn(tab === t)} onClick={() => setTab(t)}>
            {label}
          </button>
        ))}
      </div>

      {/* ── ORDERS TAB ── */}
      {tab === "orders" && (
        <>
          {/* Dynamic KPIs — all driven by filtered orders */}
          {(() => {
            const periodLabel = filterOrderDate
              ? filterOrderDate === TODAY_ISO ? "Today" : filterOrderDate
              : filterType !== "All" ? filterType
              : filterPayment !== "All" ? filterPayment
              : "All Time";

            return (
              <>
                <div style={S.grid(3)}>
                  <KpiCard
                    label={`Revenue · ${periodLabel}`}
                    value={fmt(filteredRev)}
                    icon="💰"
                    color={T.accent}
                    sub={`${filtered.length} order${filtered.length !== 1 ? "s" : ""}`}
                  />
                  <KpiCard
                    label={`Plates Sold · ${periodLabel}`}
                    value={String(filteredPlates)}
                    icon="🍽️"
                    color={T.restaurant}
                    sub={`avg ${filtered.length ? (filteredPlates / filtered.length).toFixed(1) : 0} per order`}
                  />
                  <KpiCard
                    label={`Best Seller · ${periodLabel}`}
                    value={Object.entries(filteredByMeal).sort((a, b) => b[1] - a[1])[0]?.[0] || "—"}
                    icon="⭐"
                    color={T.warning}
                  />
                </div>

                {/* Revenue by fulfillment — dynamic */}
                <div style={{ ...S.card, marginTop: 10, marginBottom: 10 }}>
                  <div style={S.cardTitle}>Revenue by Fulfillment · {periodLabel}</div>
                  <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginTop: 8 }}>
                    {[
                      { label: "🪑 Dine-in",   val: filteredDineRev, color: T.restaurant },
                      { label: "🥡 Takeaway",  val: filteredTkRev,   color: T.warning },
                      { label: "🛵 Delivery",  val: filteredDelRev,  color: T.delivery, sub: `incl. ${fmt(filteredDelFees)} fees` },
                    ].map(item => (
                      <div key={item.label} style={{ minWidth: 130 }}>
                        <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 2 }}>{item.label}</div>
                        <div style={{ fontSize: 16, fontWeight: 800, color: item.color }}>{fmt(item.val)}</div>
                        {item.sub && <div style={{ fontSize: 10, color: T.textDim }}>{item.sub}</div>}
                        <div style={{ marginTop: 4, height: 3, borderRadius: 2, background: T.border }}>
                          <div style={{ width: `${filteredRev ? (item.val / filteredRev * 100) : 0}%`, height: "100%", background: item.color, borderRadius: 2 }} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            );
          })()}
          {/* Per-meal revenue + cash by method breakdown */}
          {Object.keys(filteredByMeal).length > 0 && (() => {
            // Build per-meal plates
            const mealPlates = {};
            filtered.forEach(s => {
              const items = Array.isArray(s.items) && s.items.length > 0
                ? s.items : [{ meal: s.meal, plates: s.plates, pricePerPlate: s.pricePerPlate }];
              items.forEach(it => {
                if (!it.meal) return;
                mealPlates[it.meal] = (mealPlates[it.meal] || 0) + (Number(it.plates) || 0);
              });
            });

            // Build cash received by payment method
            const byMethod = {};
            filtered.forEach(s => {
              const tot = orderTotal(s);
              const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
              const method = s.method || "Unknown";
              byMethod[method] = (byMethod[method] || 0) + paid;
            });
            const methodEntries = Object.entries(byMethod).sort((a, b) => b[1] - a[1]);
            const totalCash = methodEntries.reduce((s, [, v]) => s + v, 0);

            const periodLabel = filterOrderDate
              ? filterOrderDate === TODAY_ISO ? "Today" : filterOrderDate
              : filterType !== "All" ? filterType
              : filterPayment !== "All" ? filterPayment : "All Time";

            return (
              <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 10, marginBottom: 10 }}>
                {/* Meal breakdown */}
                <div style={S.card}>
                  <div style={S.cardTitle}>Revenue & Plates by Meal · {periodLabel}</div>
                  <div style={{ overflowX: "auto", marginTop: 8 }}>
                    <table style={{ ...S.table, minWidth: 380 }}>
                      <thead>
                        <tr>
                          {["Meal", "Plates", "Revenue", "%"].map(h => (
                            <th key={h} style={{ ...S.th, textAlign: h === "Meal" ? "left" : "right" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(filteredByMeal).sort((a, b) => b[1] - a[1]).map(([meal, rev]) => (
                          <tr key={meal}>
                            <td style={{ ...S.td, fontWeight: 600 }}>{meal}</td>
                            <td style={{ ...S.td, textAlign: "right" }}>{mealPlates[meal] || 0}</td>
                            <td style={{ ...S.td, textAlign: "right", color: T.accent, fontWeight: 700 }}>{fmt(rev)}</td>
                            <td style={{ ...S.td, textAlign: "right", color: T.textMuted, fontSize: 10 }}>
                              {filteredRev ? (rev / filteredRev * 100).toFixed(1) : 0}%
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Cash by method */}
                <div style={{ ...S.card, minWidth: 200 }}>
                  <div style={S.cardTitle}>Cash Received · {periodLabel}</div>
                  <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 10 }}>
                    {methodEntries.map(([method, amt]) => (
                      <div key={method}>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                          <span style={{ fontSize: 11, fontWeight: 600, color: T.text }}>{method}</span>
                          <span style={{ fontSize: 12, fontWeight: 700, color: T.success }}>{fmt(amt)}</span>
                        </div>
                        <div style={{ height: 4, background: T.border, borderRadius: 2 }}>
                          <div style={{ width: `${totalCash ? (amt / totalCash * 100) : 0}%`, height: "100%", background: T.success, borderRadius: 2, opacity: 0.8 }} />
                        </div>
                        <div style={{ fontSize: 9, color: T.textDim, marginTop: 1 }}>
                          {totalCash ? (amt / totalCash * 100).toFixed(1) : 0}%
                        </div>
                      </div>
                    ))}
                    <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span style={{ fontSize: 11, color: T.textMuted }}>Total Revenue</span>
                        <span style={{ fontSize: 12, fontWeight: 700, color: T.accent }}>{fmt(filteredRev)}</span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span style={{ fontSize: 11, color: T.textMuted }}>Cash Collected</span>
                        <span style={{ fontSize: 12, fontWeight: 700, color: T.success }}>{fmt(totalCash)}</span>
                      </div>
                      {filteredRev - totalCash > 0 && (
                        <div style={{ display: "flex", justifyContent: "space-between", background: `${T.danger}12`, borderRadius: 6, padding: "5px 8px", margin: "0 -8px" }}>
                          <span style={{ fontSize: 11, fontWeight: 700, color: T.danger }}>⚠️ Amount Owed</span>
                          <span style={{ fontSize: 13, fontWeight: 800, color: T.danger }}>{fmt(filteredRev - totalCash)}</span>
                        </div>
                      )}
                      {filteredRev - totalCash <= 0 && filteredRev > 0 && (
                        <div style={{ fontSize: 11, color: T.success, fontWeight: 700 }}>✅ Fully Collected</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })()}

          <div style={{ ...S.row, marginBottom: 9, flexWrap: "wrap", gap: 5 }}>
            <div style={{ display: "flex", gap: 3 }}>
              {["All", "Dine-in", "Takeaway", "Delivery"].map((t) => (
                <button key={t} style={S.navBtn(filterType === t)} onClick={() => setFilterType(t)}>{t}</button>
              ))}
            </div>
            <div style={{ display: "flex", gap: 3 }}>
              {[["All","🍽️ All Items"], ["Food","🍲 Food"], ["Beverage","🥤 Beverages"]].map(([val, label]) => (
                <button key={val}
                  style={{ ...S.navBtn(filterItemKind === val), ...(val === "Beverage" && filterItemKind === val ? { background: T.info, color: "#fff", borderColor: T.info } : {}), ...(val === "Beverage" ? { color: filterItemKind === val ? "#fff" : T.info, borderColor: (T.info || "#3b82f6") + "60" } : {}) }}
                  onClick={() => setFilterItemKind(val)}
                >{label}</button>
              ))}
            </div>
            <div style={{ display: "flex", gap: 3 }}>
              {[["All","All Orders"], ["Unpaid","⚠️ Unpaid / Partial"], ["Paid","✅ Paid"]].map(([val, label]) => (
                <button key={val}
                  style={{ ...S.navBtn(filterPayment === val), ...(val === "Unpaid" && filterPayment === val ? { background: T.danger, color: "#fff", borderColor: T.danger } : {}), ...(val === "Unpaid" ? { color: filterPayment === val ? "#fff" : T.danger, borderColor: T.danger + "60" } : {}) }}
                  onClick={() => setFilterPayment(val)}
                >{label}</button>
              ))}
            </div>
            <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
              <button
                style={{ ...S.btn(filterOrderDate === TODAY_ISO ? "primary" : "ghost"), fontSize: 11, padding: "4px 10px" }}
                onClick={() => setFilterOrderDate(filterOrderDate === TODAY_ISO ? "" : TODAY_ISO)}
              >📅 Today</button>
              <input
                type="date"
                style={{ ...S.input, marginBottom: 0, fontSize: 11, padding: "3px 7px", width: 140 }}
                value={filterOrderDate}
                onChange={e => setFilterOrderDate(e.target.value)}
              />
              {filterOrderDate && (
                <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "3px 7px" }} onClick={() => setFilterOrderDate("")}>✕</button>
              )}
            </div>
            <button style={S.btn("primary")} onClick={() => setAddSale(!addSale)}>+ Record Order</button>
          </div>
          {addSale && (
            <div style={{ ...S.card, marginBottom: 10, borderColor: T.accent }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 8,
                }}
              >
                <div style={S.sectionTitle}>{editSaleId ? "Edit Order" : "New Order"}</div>

              </div>
              <div style={S.grid(3)}>
                <div>
                  <label style={S.label}>Date</label>
                  <input
                    type="date"
                    style={S.input}
                    value={ns.date}
                    onChange={(e) => setNs({ ...ns, date: e.target.value })}
                  />
                </div>
                <div style={{ gridColumn: "span 2" }}>
                  {/* Picker mode toggle */}
                  <div style={{ display: "flex", gap: 6, marginBottom: 8, flexWrap: "wrap" }}>
                    {[["batch", "🍳 From Batch"], ["catalog", "🛒 From Catalog"], ["resale", "🍶 Resale Item"]].map(([mode, label]) => (
                      <button key={mode}
                        style={{ ...S.btn((!ns._pickerMode && mode === "batch") || ns._pickerMode === mode ? "primary" : "ghost"), fontSize: 11, padding: "4px 12px" }}
                        onClick={() => { setNs({ ...ns, _pickerMode: mode }); setCurrentItem(EMPTY_ITEM); }}
                      >{label}</button>
                    ))}
                  </div>

                  {/* BATCH PICKER */}
                  {(!ns._pickerMode || ns._pickerMode === "batch") && (() => {
                    const mealPortions = {};
                    batches.forEach((b) => {
                      if (!b.mealId) return;
                      const sold = sales.reduce((sum, s) => {
                        // Multi-item orders: check items array
                        if (Array.isArray(s.items) && s.items.length > 0) {
                          return sum + s.items
                            .filter(it => Number(it.mealId) === Number(b.mealId) && s.date >= b.date)
                            .reduce((a, it) => a + Number(it.plates || 0), 0);
                        }
                        // Legacy single-item orders
                        return sum + (Number(s.mealId) === Number(b.mealId) && s.date >= b.date ? Number(s.plates || 0) : 0);
                      }, 0);
                      const rem = Math.max(0, b.portions - sold);
                      mealPortions[b.mealId] = (mealPortions[b.mealId] || 0) + rem;
                    });
                    const available = meals
                      .filter((m) => (mealPortions[m.id] || 0) > 0)
                      .map((m) => ({ meal: m, portions: mealPortions[m.id] }));

                    if (available.length === 0) {
                      return (
                        <div style={{ background: `${T.warning}15`, border: `1px solid ${T.warning}40`, borderRadius: 8, padding: "10px 13px", fontSize: 11, color: T.warning }}>
                          ⚠️ No batches with available portions. Log a production batch in the{" "}
                          <button style={{ background: "none", border: "none", color: T.accent, cursor: "pointer", fontSize: 11, fontWeight: 700, padding: 0 }} onClick={() => setTab("batches")}>
                            🍳 Batches tab
                          </button>{" "}first, or use <strong>From Catalog</strong> for beverages & direct items.
                        </div>
                      );
                    }
                    return (
                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: 6 }}>
                          {available.map(({ meal: m, portions }) => {
                            const isSelected = currentItem.mealId === m.id;
                            const platesNum = Number(currentItem.plates) || 0;
                            const wouldOversell = isSelected && platesNum > portions;
                            return (
                              <button key={m.id}
                                onClick={() => setCurrentItem({ ...EMPTY_ITEM, meal: m.name, mealId: m.id, pricePerPlate: m.price || currentItem.pricePerPlate || "" })}
                                style={{ background: isSelected ? T.accentSoft : T.surface, border: `1.5px solid ${isSelected ? T.accent : wouldOversell ? T.danger : T.border}`, borderRadius: 8, padding: "8px 11px", cursor: "pointer", textAlign: "left", transition: "all 0.12s" }}
                              >
                                <div style={{ fontSize: 12, fontWeight: 700, color: isSelected ? T.accent : T.text, marginBottom: 2 }}>{m.name}</div>
                                <div style={{ fontSize: 10, color: portions <= 5 ? T.danger : T.success, fontWeight: 600 }}>{portions} portion{portions !== 1 ? "s" : ""} available</div>
                                <div style={{ fontSize: 10, color: T.textDim, marginTop: 1 }}>{fmt(m.price)} / plate</div>
                              </button>
                            );
                          })}
                        </div>
                        {currentItem.mealId && (() => {
                          const sel = meals.find((m) => m.id === currentItem.mealId);
                          const avail = sel ? Number(sel.availablePortions) : 0;
                          const platesNum = Number(currentItem.plates) || 0;
                          if (platesNum > avail) return <div style={{ fontSize: 11, color: T.danger, background: `${T.danger}12`, borderRadius: 6, padding: "5px 10px" }}>⚠️ {platesNum} plates requested but only {avail} available.</div>;
                          if (platesNum > 0) return <div style={{ fontSize: 11, color: T.success, background: `${T.success}12`, borderRadius: 6, padding: "5px 10px" }}>✓ {avail - platesNum} portions will remain after this order.</div>;
                          return null;
                        })()}
                      </div>
                    );
                  })()}

                  {/* CATALOG PICKER — beverages, sodas, direct items */}
                  {ns._pickerMode === "catalog" && (() => {
                    const cats = [...new Set(catalogItems.map(i => i.catId))];
                    return (
                      <div>
                        <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 8 }}>
                          Select any catalog item to sell directly. Inventory stock will be deducted by the quantity sold.
                        </div>
                        {cats.map(catId => {
                          const cat = (catalogCategories || []).find(c => c.id === catId);
                          const items = catalogItems.filter(i => i.catId === catId);
                          if (!items.length) return null;
                          return (
                            <div key={catId} style={{ marginBottom: 10 }}>
                              <div style={{ fontSize: 9, fontWeight: 700, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 5 }}>{cat?.name || "Other"}</div>
                              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 5 }}>
                                {items.map(item => {
                                  const isSelected = currentItem._catalogItemId === item.id;
                                  const invItem = inventory.find(inv => inv.name.toLowerCase() === item.name.toLowerCase());
                                  const stock = invItem ? Number(invItem.stock) : null;
                                  return (
                                    <button key={item.id}
                                      onClick={() => setCurrentItem({ ...EMPTY_ITEM, meal: item.name, _catalogItemId: item.id, pricePerPlate: currentItem.pricePerPlate || "" })}
                                      style={{ background: isSelected ? T.accentSoft : T.surface, border: `1.5px solid ${isSelected ? T.accent : T.border}`, borderRadius: 8, padding: "8px 10px", cursor: "pointer", textAlign: "left" }}
                                    >
                                      {item.photo && <img src={item.photo} alt={item.name} style={{ width: "100%", height: 44, objectFit: "cover", borderRadius: 5, marginBottom: 4 }} />}
                                      <div style={{ fontSize: 11, fontWeight: 700, color: isSelected ? T.accent : T.text, marginBottom: 2 }}>{item.name}</div>
                                      {stock !== null && <div style={{ fontSize: 10, color: stock < 3 ? T.danger : T.success, fontWeight: 600 }}>Stock: {stock} {invItem?.unit || ""}</div>}
                                      {!invItem && <div style={{ fontSize: 9, color: T.textDim }}>Not in inventory</div>}
                                    </button>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                        {currentItem._catalogItemId && (
                          <button style={{ fontSize: 10, color: T.textMuted, background: "none", border: "none", cursor: "pointer", marginTop: 4, padding: 0 }}
                            onClick={() => setCurrentItem(EMPTY_ITEM)}>
                            ✕ Clear selection
                          </button>
                        )}
                      </div>
                    );
                  })()}

                  {/* RESALE ITEM PICKER — drinks, wine, mineral water from inventory */}
                  {ns._pickerMode === "resale" && (() => {
                    const resaleItems = inventory.filter(i => i.itemType === "resale");
                    return (
                      <div>
                        <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 8 }}>
                          Select a resale item (drinks, wine, water). Revenue and COGS are recognized at the time of sale.
                        </div>
                        {resaleItems.length === 0 && (
                          <div style={{ fontSize: 11, color: T.textMuted, padding: "10px 0" }}>
                            No resale items in inventory yet. Go to Inventory → Add Item and set type to "Resale Item".
                          </div>
                        )}
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 5, marginBottom: 8 }}>
                          {resaleItems.map(item => {
                            const isSelected = currentItem._resaleItemId === item.id;
                            return (
                              <button key={item.id}
                                onClick={() => setCurrentItem({
                                  ...EMPTY_ITEM,
                                  meal: item.name,
                                  _resaleItemId: item.id,
                                  _itemType: "resale",
                                  _costPerUnit: item.costPerUnit,
                                  pricePerPlate: item.sellingPrice || "",
                                  plates: "",
                                })}
                                style={{ background: isSelected ? T.accentSoft : T.surface, border: `1.5px solid ${isSelected ? T.accent : T.border}`, borderRadius: 8, padding: "8px 10px", cursor: "pointer", textAlign: "left" }}
                              >
                                <div style={{ fontSize: 11, fontWeight: 700, color: isSelected ? T.accent : T.text, marginBottom: 2 }}>{item.name}</div>
                                <div style={{ fontSize: 10, color: item.stock < (item.reorderAt || 1) ? T.danger : T.success, fontWeight: 600 }}>Stock: {item.stock} {item.unit}</div>
                                {item.sellingPrice > 0 && <div style={{ fontSize: 10, color: T.textMuted }}>Sell: {fmt(item.sellingPrice)}</div>}
                              </button>
                            );
                          })}
                        </div>
                        {currentItem._resaleItemId && (
                          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 4 }}>
                            <div>
                              <label style={S.label}>Qty *</label>
                              <input type="number" style={S.input} placeholder="e.g. 3"
                                value={currentItem.plates}
                                onChange={e => setCurrentItem({ ...currentItem, plates: e.target.value })} />
                            </div>
                            <div>
                              <label style={S.label}>Price / Unit (XAF)</label>
                              <input type="number" style={S.input}
                                value={currentItem.pricePerPlate}
                                onChange={e => setCurrentItem({ ...currentItem, pricePerPlate: e.target.value })} />
                            </div>
                          </div>
                        )}
                        {currentItem._resaleItemId && (
                          <button style={{ fontSize: 10, color: T.textMuted, background: "none", border: "none", cursor: "pointer", marginTop: 4, padding: 0 }}
                            onClick={() => setCurrentItem(EMPTY_ITEM)}>
                            ✕ Clear selection
                          </button>
                        )}
                      </div>
                    );
                  })()}

                  {/* Manual fallback */}
                  <div style={{ marginTop: 8 }}>
                    <label style={{ ...S.label, color: T.textDim }}>Or type item name manually</label>
                    <input
                      style={{ ...S.input, fontSize: 11 }}
                      placeholder="Type any item or meal name"
                      value={(currentItem.mealId || currentItem._catalogItemId) ? "" : currentItem.meal}
                      disabled={!!currentItem.mealId || !!currentItem._catalogItemId}
                      onChange={(e) => setCurrentItem({ ...currentItem, meal: e.target.value, mealId: null, _catalogItemId: null })}
                    />
                    {(currentItem.mealId || currentItem._catalogItemId) && (
                      <button style={{ fontSize: 10, color: T.textMuted, background: "none", border: "none", cursor: "pointer", marginTop: 3, padding: 0 }}
                        onClick={() => setCurrentItem(EMPTY_ITEM)}>
                        ✕ Clear selection to type manually
                      </button>
                    )}
                  </div>
                </div>
                <div>
                  <label style={S.label}>Fulfillment</label>
                  <select
                    style={S.select}
                    value={ns.type}
                    onChange={(e) =>
                      setNs({
                        ...ns,
                        type: e.target.value,
                        deliveryFee: e.target.value === "Delivery" ? 2000 : 0,
                      })
                    }
                  >
                    <option>Dine-in</option>
                    <option>Takeaway</option>
                    <option>Delivery</option>
                    <option>Catering</option>
                  </select>
                </div>
                <div>
                  <label style={S.label}>Qty / Plates</label>
                  <input
                    type="number"
                    style={S.input}
                    placeholder="e.g. 2"
                    value={currentItem.plates}
                    onChange={(e) => setCurrentItem({ ...currentItem, plates: e.target.value })}
                  />
                </div>
                <div>
                  <label style={S.label}>Price / Plate (XAF)</label>
                  <input
                    type="number"
                    style={S.input}
                    placeholder="e.g. 2500"
                    value={currentItem.pricePerPlate}
                    onChange={(e) => setCurrentItem({ ...currentItem, pricePerPlate: e.target.value })}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "flex-end" }}>
                  <button
                    style={{ ...S.btn("primary"), width: "100%", fontSize: 12 }}
                    disabled={!currentItem.meal || !currentItem.plates}
                    onClick={() => {
                      if (!currentItem.meal || !currentItem.plates) return;
                      setNs(prev => ({ ...prev, items: [...(prev.items || []), { ...currentItem, plates: Number(currentItem.plates), pricePerPlate: Number(currentItem.pricePerPlate) || 0 }] }));
                      setCurrentItem(EMPTY_ITEM);
                    }}
                  >＋ Add Item</button>
                </div>

                {/* Order items list */}
                {ns.items && ns.items.length > 0 && (
                  <div style={{ gridColumn: "1 / -1", background: T.surface, borderRadius: 8, border: `1px solid ${T.border}`, overflow: "hidden", marginBottom: 4 }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.5, padding: "6px 12px", borderBottom: `1px solid ${T.border}` }}>
                      Order Items
                    </div>
                    {ns.items.map((item, i) => (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 12px", borderBottom: i < ns.items.length - 1 ? `1px solid ${T.border}` : "none" }}>
                        <div style={{ flex: 1, fontSize: 12, fontWeight: 600, color: T.text }}>{item.meal}</div>
                        <div style={{ fontSize: 11, color: T.textMuted }}>{item.plates} × {fmt(item.pricePerPlate)}</div>
                        <div style={{ fontSize: 12, fontWeight: 700, color: T.accent, minWidth: 80, textAlign: "right" }}>{fmt(Number(item.plates) * Number(item.pricePerPlate))} XAF</div>
                        <button
                          style={{ background: "none", border: "none", color: T.danger, cursor: "pointer", fontSize: 13, padding: "0 2px" }}
                          onClick={() => setNs(prev => ({ ...prev, items: prev.items.filter((_, j) => j !== i) }))}
                        >✕</button>
                      </div>
                    ))}
                    <div style={{ display: "flex", justifyContent: "flex-end", padding: "6px 12px", borderTop: `1px solid ${T.border}`, fontSize: 12, fontWeight: 700, color: T.accent }}>
                      Subtotal: {fmt(ns.items.reduce((s, it) => s + Number(it.plates) * Number(it.pricePerPlate), 0))} XAF
                    </div>
                  </div>
                )}

                <div>
                  <label style={S.label}>Payment Method</label>
                  <select
                    style={S.select}
                    value={ns.method}
                    onChange={(e) => setNs({ ...ns, method: e.target.value })}
                  >
                    {["Cash", "Mobile Money", "Orange Money", "Bank Transfer", "Card", "Credit"].map(
                      (m) => (
                        <option key={m}>{m}</option>
                      )
                    )}
                  </select>
                </div>
                <div>
                  <label style={S.label}>Client Name <span style={{ color: T.textDim, fontWeight: 400 }}>(optional — for invoice/receipt)</span></label>
                  <input
                    style={S.input}
                    list="rest-customer-list"
                    placeholder="e.g. Jean Dupont or Table 4"
                    value={ns.clientName}
                    onChange={(e) => {
                      const val = e.target.value;
                      const match = customers.find(c => c.name === val);
                      if (match) {
                        setNs({ ...ns, clientName: val, clientPhone: match.phone || ns.clientPhone, clientEmail: match.email || ns.clientEmail, clientCategory: match.classification || ns.clientCategory });
                      } else {
                        setNs({ ...ns, clientName: val });
                        if (val.trim() && !match) {
                          setNewCust(prev => ({ ...prev, name: val.trim() }));
                        } else {
                          setShowNewCustomer(false);
                        }
                      }
                    }}
                  />
                  <datalist id="rest-customer-list">
                    {customers.map(c => <option key={c.id} value={c.name}>{c.name}{c.phone ? ` · ${c.phone}` : ""}</option>)}
                  </datalist>
                  {/* Quick-add customer prompt */}
                  {ns.clientName.trim() && !customers.find(c => c.name.toLowerCase() === ns.clientName.trim().toLowerCase()) && (
                    <div style={{ marginTop: 6 }}>
                      {!showNewCustomer ? (
                        <button
                          type="button"
                          style={{ ...S.btn("ghost"), fontSize: 11, padding: "3px 10px", borderColor: T.accent, color: T.accent }}
                          onClick={() => {
                            setNewCust({ name: ns.clientName.trim(), phone: ns.clientPhone || "", email: "", notes: "" });
                            setShowNewCustomer(true);
                          }}
                        >
                          ➕ Save "{ns.clientName.trim()}" as new customer
                        </button>
                      ) : (
                        <div style={{ background: `${T.accent}10`, border: `1px solid ${T.accent}40`, borderRadius: 8, padding: "10px 12px", marginTop: 4 }}>
                          <div style={{ fontSize: 11, fontWeight: 700, color: T.accent, marginBottom: 8 }}>➕ New Customer</div>
                          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 7, marginBottom: 7 }}>
                            <div>
                              <label style={S.label}>Name *</label>
                              <input
                                style={S.input}
                                value={newCust.name}
                                onChange={(e) => setNewCust({ ...newCust, name: e.target.value })}
                                placeholder="Full name"
                              />
                            </div>
                            <div>
                              <label style={S.label}>Phone</label>
                              <input
                                style={S.input}
                                value={newCust.phone}
                                onChange={(e) => setNewCust({ ...newCust, phone: e.target.value })}
                                placeholder="+237 6XX XXX XXX"
                              />
                            </div>
                            <div>
                              <label style={S.label}>Email</label>
                              <input
                                style={S.input}
                                value={newCust.email}
                                onChange={(e) => setNewCust({ ...newCust, email: e.target.value })}
                                placeholder="email@example.com"
                              />
                            </div>
                            <div>
                              <label style={S.label}>Notes</label>
                              <input
                                style={S.input}
                                value={newCust.notes}
                                onChange={(e) => setNewCust({ ...newCust, notes: e.target.value })}
                                placeholder="e.g. VIP, allergies…"
                              />
                            </div>
                          </div>
                          <div style={{ display: "flex", gap: 6 }}>
                            <button
                              type="button"
                              style={{ ...S.btn("primary"), fontSize: 11, padding: "4px 12px" }}
                              disabled={!newCust.name.trim()}
                              onClick={() => {
                                const nc = {
                                  id: Date.now(),
                                  name: newCust.name.trim(),
                                  phone: newCust.phone.trim(),
                                  email: newCust.email.trim(),
                                  notes: newCust.notes.trim(),
                                  classification: "Regular",
                                  createdAt: TODAY_ISO,
                                };
                                setCustomers(prev => [...prev, nc]);
                                setNs(prev => ({ ...prev, clientName: nc.name, clientPhone: nc.phone }));
                                setShowNewCustomer(false);
                                setNewCust({ name: "", phone: "", email: "", notes: "" });
                              }}
                            >
                              ✓ Save Customer
                            </button>
                            <button
                              type="button"
                              style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 10px" }}
                              onClick={() => { setShowNewCustomer(false); setNewCust({ name: "", phone: "", email: "", notes: "" }); }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div>
                  <label style={S.label}>Client Phone <span style={{ color: T.textDim, fontWeight: 400 }}>(optional)</span></label>
                  <input
                    style={S.input}
                    placeholder="+237 6XX XXX XXX"
                    value={ns.clientPhone}
                    onChange={(e) => setNs({ ...ns, clientPhone: e.target.value })}
                  />
                </div>
                <div>
                  <label style={S.label}>Client Email <span style={{ color: T.textDim, fontWeight: 400 }}>(optional)</span></label>
                  <input
                    style={S.input}
                    type="email"
                    placeholder="client@email.com"
                    value={ns.clientEmail || ""}
                    onChange={(e) => setNs({ ...ns, clientEmail: e.target.value })}
                  />
                </div>
                <div>
                  <label style={S.label}>Client Category</label>
                  <select
                    style={S.select}
                    value={ns.clientCategory || "Regular"}
                    onChange={(e) => setNs({ ...ns, clientCategory: e.target.value })}
                  >
                    {["Regular", "VIP", "Wholesale", "Corporate", "Walk-in", "Blacklisted"].map(c => (
                      <option key={c}>{c}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={S.label}>Amount Paid Now (XAF) <span style={{ color: T.textDim, fontWeight: 400 }}>— leave blank = fully paid</span></label>
                  <input
                    type="number"
                    style={S.input}
                    placeholder="Leave blank if fully paid"
                    value={ns.partialPaid}
                    onChange={(e) => setNs({ ...ns, partialPaid: e.target.value })}
                  />
                </div>
                {/* Order total summary */}
                {ns.items && ns.items.length > 0 && (
                  <div style={{ gridColumn: "1 / -1" }}>
                    {(() => {
                      const total = ns.items.reduce((s, it) => s + Number(it.plates) * Number(it.pricePerPlate), 0) + Number(ns.deliveryFee || 0);
                      const paid = ns.partialPaid !== "" ? Number(ns.partialPaid) : total;
                      const balance = total - paid;
                      return (
                        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 14px", display: "flex", gap: 24, flexWrap: "wrap" }}>
                          <div>
                            <div style={{ fontSize: 9, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 2 }}>Order Total</div>
                            <div style={{ fontSize: 15, fontWeight: 700, color: T.text }}>{fmt(total)} XAF</div>
                          </div>
                          <div>
                            <div style={{ fontSize: 9, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 2 }}>Amount Paid</div>
                            <div style={{ fontSize: 15, fontWeight: 700, color: T.success }}>{fmt(paid)} XAF</div>
                          </div>
                          {balance > 0 && (
                            <div>
                              <div style={{ fontSize: 9, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 2 }}>Balance Due</div>
                              <div style={{ fontSize: 15, fontWeight: 700, color: T.danger }}>{fmt(balance)} XAF</div>
                            </div>
                          )}
                          {balance === 0 && (
                            <div style={{ display: "flex", alignItems: "center", gap: 5, color: T.success, fontSize: 12, fontWeight: 700 }}>✅ Fully Paid</div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                )}
                <div>
                  <label style={S.label}>Notes</label>
                  <input
                    style={S.input}
                    placeholder="e.g. No onions, window seat, allergies…"
                    value={ns.notes}
                    onChange={(e) => setNs({ ...ns, notes: e.target.value })}
                  />
                </div>
                {ns.type === "Delivery" && (
                  <>
                    <div>
                      <label style={S.label}>Delivery Address</label>
                      <input
                        style={S.input}
                        value={ns.deliveryAddress}
                        onChange={(e) =>
                          setNs({ ...ns, deliveryAddress: e.target.value })
                        }
                      />
                    </div>
                    <div>
                      <label style={S.label}>Delivery Fee (XAF)</label>
                      <input
                        type="number"
                        style={S.input}
                        value={ns.deliveryFee}
                        onChange={(e) =>
                          setNs({ ...ns, deliveryFee: e.target.value })
                        }
                      />
                    </div>
                  </>
                )}
              </div>
              <div
                style={{ ...S.row, marginTop: 8, justifyContent: "flex-end" }}
              >
                <button
                  style={S.btn("ghost")}
                  onClick={() => {
                    setAddSale(false);
                    setEditSaleId(null);
                    setNs(EMPTY);
                    setShowNewCustomer(false);
                    setNewCust({ name: "", phone: "", email: "", notes: "" });
                  }}
                >
                  Cancel
                </button>
                <button style={S.btn("primary")} onClick={saveSale}>
                  {editSaleId ? "Update Order" : "Save & Deduct Inventory"}
                </button>
              </div>
            </div>
          )}
          {isMobile ? (
            <div>
              {[...filtered].reverse().map((s) => (
                <div key={s.id} style={{ ...S.cardMobile, marginBottom: 8 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: 4,
                    }}
                  >
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 700 }}>
                        {s.items && s.items.length > 1
                          ? `${s.items.length} items`
                          : s.meal}
                      </div>
                      <div style={{ fontSize: 10, color: T.textMuted }}>
                        {s.date} · {s.items && s.items.length > 1
                          ? s.items.map(it => `${it.meal} ×${it.plates}`).join(", ")
                          : `${totalPlates(s)} plate${totalPlates(s) !== 1 ? 's' : ''}`}
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 800,
                          color: T.restaurant,
                        }}
                      >
                        {fmt(orderTotal(s))}
                      </div>
                      <Badge color={typeColor[s.type] || T.textMuted}>
                        {s.type}
                      </Badge>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 11,
                      color: T.textMuted,
                    }}
                  >
                    <span>
                      {s.method} · {Array.isArray(s.items) && s.items.length > 1 ? `${s.items.length} items` : `${fmt(s.pricePerPlate)}/plate`}
                    </span>
                    {s.deliveryFee > 0 && (
                      <span style={{ color: T.delivery }}>
                        +{fmt(s.deliveryFee)} del.
                      </span>
                    )}
                  </div>
                  {s.type === "Delivery" && s.clientName && (
                    <div
                      style={{ fontSize: 10, color: T.textMuted, marginTop: 2 }}
                    >
                      📍 {s.clientName} · {s.deliveryAddress}
                    </div>
                  )}
                  {s.type !== "Delivery" && s.clientName && (
                    <div style={{ fontSize: 10, color: T.textMuted, marginTop: 2 }}>
                      👤 {s.clientName}{s.clientPhone ? ` · ${s.clientPhone}` : ""}
                    </div>
                  )}
                  {s.notes && (
                    <div style={{ fontSize: 10, color: T.textDim, marginTop: 2, fontStyle: "italic" }}>📝 {s.notes}</div>
                  )}
                  {(() => { const tot = orderTotal(s); const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot; const bal = tot - paid; return bal > 0 ? <div style={{ fontSize: 11, color: T.danger, fontWeight: 700, marginTop: 3 }}>⚠️ Balance: {fmt(bal)}</div> : null; })()}
                  {/* Inline payment panel */}
                  {orderPmtPanel === s.id && (() => {
                    const tot = orderTotal(s);
                    const alreadyPaid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : 0;
                    const bal = tot - alreadyPaid;
                    const [pmtAmt, setPmtAmt] = [null, null]; // use a ref-free approach via input id
                    return (
                      <div style={{ background: T.surface, border: `1.5px solid ${T.accent}`, borderRadius: 8, padding: 10, marginTop: 6 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: T.text, marginBottom: 6 }}>
                          💳 Record Payment · Balance: <span style={{ color: T.danger }}>{fmt(bal)} XAF</span>
                        </div>
                        <div style={{ display: "flex", gap: 4, marginBottom: 6 }}>
                          {[Math.round(bal * 0.5), bal].map(amt => (
                            <button key={amt} style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 8px" }}
                              onClick={() => { document.getElementById(`pmt-amt-${s.id}`).value = amt; }}>
                              {fmt(amt)}
                            </button>
                          ))}
                        </div>
                        <div style={{ display: "flex", gap: 5 }}>
                          <input id={`pmt-amt-${s.id}`} type="number" style={{ ...S.input, marginBottom: 0, flex: 1 }} placeholder={`Amount (max ${fmt(bal)})`} defaultValue={bal} />
                          <button style={{ ...S.btn("primary"), fontSize: 11, whiteSpace: "nowrap" }}
                            onClick={() => {
                              const amt = Number(document.getElementById(`pmt-amt-${s.id}`).value || bal);
                              const newPaid = alreadyPaid + Math.min(amt, bal);
                              setSales(prev => prev.map(x => x.id === s.id ? { ...x, partialPaid: newPaid >= tot ? "" : String(newPaid) } : x));
                              setOrderPmtPanel(null);
                            }}>
                            ✓ Collect
                          </button>
                          <button style={{ ...S.btn("ghost"), fontSize: 11 }} onClick={() => setOrderPmtPanel(null)}>✕</button>
                        </div>
                      </div>
                    );
                  })()}
                  <div style={{ marginTop: 6, display: "flex", gap: 6, justifyContent: "flex-end", flexWrap: "wrap" }}>
                    {(() => {
                      const tot = orderTotal(s);
                      const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
                      const bal = tot - paid;
                      if (bal <= 0) return null;
                      return (
                        <button
                          style={{ ...S.btn("primary"), fontSize: 11, padding: "4px 12px", background: T.danger, borderColor: T.danger, fontWeight: 700 }}
                          onClick={() => setOrderPmtPanel(orderPmtPanel === s.id ? null : s.id)}
                        >
                          💳 Collect {fmt(bal)}
                        </button>
                      );
                    })()}
                    <button
                      style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 7px", color: T.accent, borderColor: T.accent + "50" }}
                      onClick={() =>
                        openDoc(
                          `Invoice – Order #${s.id}`,
                          buildOrderInvoiceHTML({...s, saleIndex: sales.indexOf(s) + 1}, biz, logo)
                        )
                      }
                    >
                      📄 Invoice
                    </button>
                    <button
                      style={{
                        ...S.btn("ghost"),
                        fontSize: 10,
                        padding: "2px 7px",
                      }}
                      onClick={() =>
                        openDoc(
                          `Receipt – Order #${s.id}`,
                          buildOrderReceiptHTML({...s, saleIndex: sales.indexOf(s) + 1}, biz, logo)
                        )
                      }
                    >
                      🧾 Receipt
                    </button>
                    <button
                      style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 7px" }}
                      onClick={() => startEditSale(s)}
                    >
                      ✏️ Edit
                    </button>
                    <button
                      style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 7px", color: T.danger, borderColor: T.danger + "40" }}
                      onClick={() => deleteSale(s.id)}
                    >
                      🗑 Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="tbl-wrap">
              <table style={S.table}>
                <thead>
                  <tr>
                    {[
                      "Date",
                      "Meal",
                      "Plates",
                      "Price/Plate",
                      "Del. Fee",
                      "Total",
                      "Paid",
                      "Balance",
                      "Method",
                      "Type",
                      "Client / Address",
                      "Notes",
                      "Actions",
                    ].map((h) => (
                      <th key={h} style={S.th}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[...filtered].reverse().map((s) => (
                    <Fragment key={s.id}>
                    <tr>
                      <td style={S.td}>{s.date}</td>
                      <td style={{ ...S.td, fontWeight: 700 }}>{s.meal}</td>
                      <td style={S.td}>{totalPlates(s)}</td>
                      <td style={S.td}>{Array.isArray(s.items) && s.items.length > 1 ? <span style={{ color: T.textDim, fontSize: 10 }}>—</span> : fmt(s.pricePerPlate)}</td>
                      <td
                        style={{
                          ...S.td,
                          color: s.deliveryFee > 0 ? T.delivery : T.textDim,
                        }}
                      >
                        {s.deliveryFee > 0 ? fmt(s.deliveryFee) : "—"}
                      </td>
                      <td
                        style={{
                          ...S.td,
                          fontWeight: 700,
                          color: T.restaurant,
                        }}
                      >
                        {fmt(orderTotal(s))}
                      </td>
                      <td style={{ ...S.td, color: T.success }}>
                        {(() => { const tot = orderTotal(s); const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot; return fmt(paid); })()}
                      </td>
                      <td style={{ ...S.td, fontWeight: 700 }}>
                        {(() => { const tot = orderTotal(s); const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot; const bal = tot - paid; return bal > 0 ? <span style={{ color: T.danger }}>{fmt(bal)}</span> : <span style={{ color: T.success }}>—</span>; })()}
                      </td>
                      <td style={S.td}>{s.method}</td>
                      <td style={S.td}>
                        <Badge color={typeColor[s.type] || T.textMuted}>
                          {s.type}
                        </Badge>
                      </td>
                      <td style={{ ...S.td, fontSize: 11, color: T.textMuted }}>
                        {s.clientName ? (
                          <span>
                            <strong style={{ color: T.text, display: "block" }}>{s.clientName}</strong>
                            {s.clientPhone && <span style={{ display: "block" }}>{s.clientPhone}</span>}
                            {s.type === "Delivery" && s.deliveryAddress && <span style={{ display: "block" }}>📍 {s.deliveryAddress}</span>}
                          </span>
                        ) : s.type === "Delivery" && s.deliveryAddress ? (
                          <span>📍 {s.deliveryAddress}</span>
                        ) : (
                          "—"
                        )}
                      </td>
                      <td style={{ ...S.td, fontSize: 11, color: T.textDim }}>{s.notes || "—"}</td>
                      <td style={S.td}>
                        <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                          {(() => {
                            const tot = orderTotal(s);
                            const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
                            const bal = tot - paid;
                            if (bal <= 0) return null;
                            return (
                              <button
                                style={{ ...S.btn("primary"), fontSize: 10, padding: "2px 8px", background: T.danger, borderColor: T.danger, fontWeight: 700, whiteSpace: "nowrap" }}
                                title={`Collect outstanding balance of ${fmt(bal)}`}
                                onClick={() => setOrderPmtPanel(orderPmtPanel === s.id ? null : s.id)}
                              >💳 {fmt(bal)}</button>
                            );
                          })()}
                          <button
                            style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px", color: T.accent, borderColor: T.accent + "50" }}
                            onClick={() =>
                              openDoc(
                                `Invoice – Order #${s.id}`,
                                buildOrderInvoiceHTML({...s, saleIndex: sales.indexOf(s) + 1}, biz, logo)
                              )
                            }
                          >
                            📄
                          </button>
                          <button
                            style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px" }}
                            onClick={() =>
                              openDoc(
                                `Receipt – Order #${s.id}`,
                                buildOrderReceiptHTML({...s, saleIndex: sales.indexOf(s) + 1}, biz, logo)
                              )
                            }
                          >
                            🧾
                          </button>
                          <button
                            style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px" }}
                            onClick={() => startEditSale(s)}
                            title="Edit order"
                          >
                            ✏️
                          </button>
                          <button
                            style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px", color: T.danger, borderColor: T.danger + "40" }}
                            onClick={() => deleteSale(s.id)}
                            title="Delete order"
                          >
                            🗑
                          </button>
                        </div>
                      </td>
                    </tr>
                    {orderPmtPanel === s.id ? <tr key={`pmt-${s.id}`}>
                      <td colSpan={13} style={{ ...S.td, padding: 0 }}>
                        <div style={{ background: T.surface, borderLeft: `3px solid ${T.danger}`, padding: "10px 14px", display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                          <span style={{ fontSize: 12, fontWeight: 700, color: T.text }}>💳 Record Payment</span>
                          <span style={{ fontSize: 11, color: T.textMuted }}>Balance: <strong style={{ color: T.danger }}>{fmt(Math.max(0, orderTotal(s) - (s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : 0)))} XAF</strong></span>
                          <input id={`tbl-pmt-${s.id}`} type="number" style={{ ...S.input, marginBottom: 0, width: 130 }} defaultValue={Math.max(0, orderTotal(s) - (s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : 0))} />
                          <button style={{ ...S.btn("primary"), fontSize: 11, background: T.danger, borderColor: T.danger }}
                            onClick={() => {
                              const tot = orderTotal(s);
                              const alreadyPaid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : 0;
                              const bal = tot - alreadyPaid;
                              const amt = Number(document.getElementById(`tbl-pmt-${s.id}`).value || bal);
                              const newPaid = alreadyPaid + Math.min(amt, bal);
                              setSales(prev => prev.map(x => x.id === s.id ? { ...x, partialPaid: newPaid >= tot ? "" : String(newPaid) } : x));
                              setOrderPmtPanel(null);
                            }}>✓ Collect</button>
                          <button style={{ ...S.btn("ghost"), fontSize: 11 }} onClick={() => setOrderPmtPanel(null)}>✕</button>
                        </div>
                      </td>
                    </tr> : null}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* ── MEALS TAB ── */}
      {tab === "meals" && (
        <>
          <div style={{ ...S.row, marginBottom: 12, flexWrap: "wrap", gap: 6 }}>
            <div style={{ ...S.card, flex: 1, padding: 10, minWidth: 160 }}>
              <div style={S.cardTitle}>Active Meals</div>
              <div style={{ ...S.kpi, fontSize: 18 }}>
                {meals.filter((m) => m.active).length}
              </div>
            </div>
            <div style={{ ...S.card, flex: 1, padding: 10, minWidth: 160 }}>
              <div style={S.cardTitle}>Avg. Price</div>
              <div style={{ ...S.kpi, fontSize: 18 }}>
                {meals.length
                  ? fmt(meals.reduce((s, m) => s + Number(m.price || 0), 0) / meals.length)
                  : "—"}
              </div>
            </div>
            <div style={{ ...S.card, flex: 1, padding: 10, minWidth: 160 }}>
              <div style={S.cardTitle}>With Costing</div>
              <div style={{ ...S.kpi, fontSize: 18, color: T.success }}>
                {
                  meals.filter(
                    (m) =>
                      (m.ingredientLinks || []).length > 0 ||
                      Number(m.laborCost || 0) > 0 ||
                      (m.otherCosts || []).length > 0
                  ).length
                }
              </div>
            </div>
            <div style={{ display: "flex", gap: 6 }}>
              <button
                style={S.btn("primary")}
                onClick={() => {
                  setAddingMeal(!addingMeal);
                  setEditMealId(null);
                  setNm(EMPTY_MEAL);
                }}
              >
                {addingMeal && !editMealId ? "Cancel" : "+ New Meal"}
              </button>
            </div>
          </div>

          {/* Add / edit meal form */}
          {addingMeal && (
            <div style={{ ...S.card, marginBottom: 12, borderColor: T.accent }}>
              <div style={S.sectionTitle}>
                {editMealId ? "✏️ Edit Meal" : "➕ New Meal"}
              </div>

              {/* Basic Info */}
              <div style={{ fontSize: 10, fontWeight: 700, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 6 }}>
                Basic Info
              </div>
              <div style={S.grid(3)}>
                <div>
                  <label style={S.label}>Meal Name</label>
                  <input
                    style={S.input}
                    value={nm.name}
                    onChange={(e) => setNm({ ...nm, name: e.target.value })}
                  />
                </div>
                <div>
                  <label style={S.label}>Category</label>
                  {nm._addingCat ? (
                    <div style={{ display: "flex", gap: 5 }}>
                      <input
                        autoFocus
                        style={{ ...S.input, marginBottom: 0, flex: 1 }}
                        placeholder="New category name…"
                        value={nm._newCatName || ""}
                        onChange={e => setNm({ ...nm, _newCatName: e.target.value })}
                        onKeyDown={e => {
                          if (e.key === "Enter") {
                            const name = (nm._newCatName || "").trim();
                            if (name) {
                              setCatalogCategories(prev => {
                                const maxId = prev.reduce((m, c) => Math.max(m, c.id), 0);
                                return [...prev, { id: maxId + 1, name }];
                              });
                              setNm({ ...nm, category: name, _addingCat: false, _newCatName: "" });
                            }
                          }
                          if (e.key === "Escape") setNm({ ...nm, _addingCat: false, _newCatName: "" });
                        }}
                      />
                      <button style={{ ...S.btn("primary"), fontSize: 11, padding: "4px 9px" }} onClick={() => {
                        const name = (nm._newCatName || "").trim();
                        if (name) {
                          setCatalogCategories(prev => {
                            const maxId = prev.reduce((m, c) => Math.max(m, c.id), 0);
                            return [...prev, { id: maxId + 1, name }];
                          });
                          setNm({ ...nm, category: name, _addingCat: false, _newCatName: "" });
                        }
                      }}>Save</button>
                      <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 9px" }} onClick={() => setNm({ ...nm, _addingCat: false, _newCatName: "" })}>✕</button>
                    </div>
                  ) : (
                    <div style={{ display: "flex", gap: 5 }}>
                      <select
                        style={{ ...S.select, flex: 1 }}
                        value={nm.category}
                        onChange={(e) => setNm({ ...nm, category: e.target.value })}
                      >
                        {(catalogCategories || []).map((c) => (
                          <option key={c.id} value={c.name}>{c.name}</option>
                        ))}
                      </select>
                      <button
                        title="Add new category"
                        style={{ ...S.btn("ghost"), fontSize: 12, padding: "4px 8px", whiteSpace: "nowrap" }}
                        onClick={() => setNm({ ...nm, _addingCat: true, _newCatName: "" })}
                      >＋</button>
                    </div>
                  )}
                </div>
                <div>
                  <label style={S.label}>Photo</label>
                  <div
                    style={{ display: "flex", gap: 6, alignItems: "center" }}
                  >
                    {nm.photo && (
                      <img
                        src={nm.photo}
                        alt="m"
                        style={{
                          width: 32,
                          height: 32,
                          objectFit: "cover",
                          borderRadius: 4,
                        }}
                      />
                    )}
                    <button
                      style={{
                        ...S.btn("ghost"),
                        fontSize: 11,
                        padding: "4px 8px",
                      }}
                      onClick={() => mealPhotoRef.current.click()}
                    >
                      {nm.photo ? "Change" : "Upload"}
                    </button>
                    {nm.photo && (
                      <button
                        style={{
                          background: "none",
                          border: "none",
                          color: T.danger,
                          cursor: "pointer",
                        }}
                        onClick={() => setNm({ ...nm, photo: null })}
                      >
                        ✕
                      </button>
                    )}
                    <input
                      ref={mealPhotoRef}
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={async (e) => {
                        const f = e.target.files[0];
                        if (!f) return;
                        const src = await uploadFile(f, "meals");
                        if (!src) { alert("❌ Photo upload failed. Please check your internet connection and try again."); return; }
                        setNm((n) => ({ ...n, photo: src }));
                      }}
                    />
                  </div>
                </div>
                <div style={{ gridColumn: "span 2" }}>
                  <label style={S.label}>Description</label>
                  <input
                    style={S.input}
                    value={nm.description}
                    onChange={(e) =>
                      setNm({ ...nm, description: e.target.value })
                    }
                  />
                </div>
                <div>
                  <label style={S.label}>Active</label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      marginTop: 6,
                    }}
                  >
                    <input
                      type="checkbox"
                      id="meal-active"
                      checked={nm.active}
                      onChange={(e) =>
                        setNm({ ...nm, active: e.target.checked })
                      }
                    />
                    <label
                      htmlFor="meal-active"
                      style={{ fontSize: 11, color: T.textMuted }}
                    >
                      Available for orders
                    </label>
                  </div>
                </div>
              </div>

              <Divider />

              {/* Costing Section */}
              <div
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: T.textMuted,
                  textTransform: "uppercase",
                  letterSpacing: 0.6,
                  marginBottom: 8,
                }}
              >
                💰 Costing (per portion)
              </div>

              {/* Ingredient Links */}
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  color: T.text,
                  marginBottom: 6,
                }}
              >
                🧂 Ingredients / Inventory
              </div>
              <div
                style={{
                  background: T.surface,
                  borderRadius: 7,
                  padding: 10,
                  marginBottom: 10,
                }}
              >
                {/* Search bar */}
                <div style={{ display: "flex", gap: 6, marginBottom: 8, alignItems: "center" }}>
                  <input
                    style={{ ...S.input, flex: 1, padding: "4px 8px", fontSize: 11 }}
                    placeholder="🔍 Search ingredients…"
                    value={ingSearch}
                    onChange={e => setIngSearch(e.target.value)}
                    onClick={e => e.stopPropagation()}
                  />
                  {ingSearch && (
                    <button style={{ ...S.btn("ghost"), fontSize: 10, padding: "3px 8px", flexShrink: 0 }}
                      onClick={() => setIngSearch("")}>✕ Clear</button>
                  )}
                  {(nm.ingredientLinks || []).length > 0 && (
                    <span style={{ fontSize: 10, color: T.accent, fontWeight: 700, whiteSpace: "nowrap", flexShrink: 0 }}>
                      {(nm.ingredientLinks || []).length} linked
                    </span>
                  )}
                </div>

                {/* Linked ingredients — always shown at top, highlighted */}
                {(nm.ingredientLinks || []).filter(link => {
                  const inv = inventory.find(i => i.id === link.inventoryId);
                  return inv && (!ingSearch || inv.name.toLowerCase().includes(ingSearch.toLowerCase()));
                }).length > 0 && (
                  <div style={{ marginBottom: 6 }}>
                    <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", color: T.accent, marginBottom: 4 }}>✅ Linked</div>
                    {(nm.ingredientLinks || []).map(link => {
                      const inv = inventory.find(i => i.id === link.inventoryId);
                      if (!inv) return null;
                      if (ingSearch && !inv.name.toLowerCase().includes(ingSearch.toLowerCase())) return null;
                      return (
                        <div key={inv.id} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 5, fontSize: 11, background: T.accent + "08", borderRadius: 5, padding: "3px 6px" }}>
                          <input type="checkbox" checked={true}
                            onChange={() => setNm({ ...nm, ingredientLinks: (nm.ingredientLinks || []).filter(l => l.inventoryId !== inv.id) })} />
                          <span style={{ flex: 1, color: T.text, fontWeight: 600 }}>{inv.name}</span>
                          <span style={{ fontSize: 10, color: T.textDim, minWidth: 55 }}>{fmt(inv.costPerUnit)}/{inv.unit}</span>
                          <input type="number" step="0.01" min="0"
                            style={{ ...S.input, width: 65, padding: "3px 5px", fontSize: 11 }}
                            value={link.qty}
                            onChange={e => setNm({ ...nm, ingredientLinks: nm.ingredientLinks.map(l => l.inventoryId === inv.id ? { ...l, qty: Number(e.target.value) } : l) })}
                          />
                          <span style={{ fontSize: 10, color: T.textDim, minWidth: 28 }}>{inv.unit}</span>
                          <span style={{ fontSize: 11, color: T.danger, fontWeight: 700, minWidth: 68, textAlign: "right" }}>
                            {fmt((inv.costPerUnit || 0) * (link.qty || 0))}
                          </span>
                        </div>
                      );
                    })}
                    <div style={{ height: 1, background: T.border + "60", margin: "6px 0" }} />
                  </div>
                )}

                {/* Unlinked ingredients */}
                {(() => {
                  const linkedIds = new Set((nm.ingredientLinks || []).map(l => l.inventoryId));
                  const unlinked = inventory.filter(inv => {
                    if (linkedIds.has(inv.id)) return false;
                    if (ingSearch) return inv.name.toLowerCase().includes(ingSearch.toLowerCase()) || (inv.category || "").toLowerCase().includes(ingSearch.toLowerCase());
                    return true;
                  });
                  if (unlinked.length === 0 && ingSearch) return (
                    <div style={{ fontSize: 11, color: T.textDim, padding: "4px 0", textAlign: "center" }}>No ingredients match "{ingSearch}"</div>
                  );
                  return (
                    <>
                      {(nm.ingredientLinks || []).length > 0 && unlinked.length > 0 && !ingSearch && (
                        <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", color: T.textMuted, marginBottom: 4 }}>Available</div>
                      )}
                      {unlinked.map(inv => (
                        <div key={inv.id} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 5, fontSize: 11 }}>
                          <input type="checkbox" checked={false}
                            onChange={() => setNm({ ...nm, ingredientLinks: [...(nm.ingredientLinks || []), { inventoryId: inv.id, qty: inv.usedPerPlate || 0.1 }] })} />
                          <span style={{ flex: 1, color: T.textMuted }}>{inv.name}</span>
                          <span style={{ fontSize: 10, color: T.textDim, minWidth: 55 }}>{fmt(inv.costPerUnit)}/{inv.unit}</span>
                          <span style={{ fontSize: 10, color: T.textDim, minWidth: 55, textAlign: "right" }}>stock: {inv.stock}</span>
                        </div>
                      ))}
                    </>
                  );
                })()}

                {/* Ingredient subtotal */}
                {(nm.ingredientLinks || []).length > 0 && (
                  <div style={{ borderTop: `1px solid ${T.border}`, marginTop: 6, paddingTop: 6, display: "flex", justifyContent: "space-between", fontSize: 11, fontWeight: 700 }}>
                    <span style={{ color: T.textMuted }}>Ingredient subtotal:</span>
                    <span style={{ color: T.danger }}>
                      {fmt((nm.ingredientLinks || []).reduce((s, l) => {
                        const inv = inventory.find(i => i.id === l.inventoryId);
                        return s + (inv ? inv.costPerUnit * l.qty : 0);
                      }, 0))}
                    </span>
                  </div>
                )}
              </div>

              {/* Labor Cost */}
              <div style={S.grid(2)}>
                <div>
                  <label style={S.label}>👨‍🍳 Labor Cost per Portion (XAF)</label>
                  <input
                    type="number"
                    min="0"
                    style={S.input}
                    value={nm.laborCost}
                    onChange={(e) =>
                      setNm({ ...nm, laborCost: e.target.value })
                    }
                    placeholder="e.g. 200"
                  />
                </div>
              </div>

              {/* Other Costs */}
              <div style={{ marginTop: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 6,
                  }}
                >
                  <div style={{ fontSize: 11, fontWeight: 600, color: T.text }}>
                    📋 Other Costs per Portion
                  </div>
                  <button
                    style={{
                      ...S.btn("ghost"),
                      fontSize: 10,
                      padding: "2px 8px",
                    }}
                    onClick={() =>
                      setNm({
                        ...nm,
                        otherCosts: [
                          ...(nm.otherCosts || []),
                          { label: "", amount: "" },
                        ],
                      })
                    }
                  >
                    + Add
                  </button>
                </div>
                {(nm.otherCosts || []).map((oc, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      gap: 6,
                      alignItems: "center",
                      marginBottom: 5,
                    }}
                  >
                    <input
                      style={{ ...S.input, flex: 2 }}
                      placeholder="Label (e.g. Packaging)"
                      value={oc.label}
                      onChange={(e) =>
                        setNm({
                          ...nm,
                          otherCosts: nm.otherCosts.map((c, i) =>
                            i === idx ? { ...c, label: e.target.value } : c
                          ),
                        })
                      }
                    />
                    <input
                      type="number"
                      min="0"
                      style={{ ...S.input, flex: 1 }}
                      placeholder="Amount (XAF)"
                      value={oc.amount}
                      onChange={(e) =>
                        setNm({
                          ...nm,
                          otherCosts: nm.otherCosts.map((c, i) =>
                            i === idx ? { ...c, amount: e.target.value } : c
                          ),
                        })
                      }
                    />
                    <button
                      style={{
                        background: "none",
                        border: "none",
                        color: T.danger,
                        cursor: "pointer",
                        fontSize: 14,
                        padding: "0 4px",
                      }}
                      onClick={() =>
                        setNm({
                          ...nm,
                          otherCosts: nm.otherCosts.filter((_, i) => i !== idx),
                        })
                      }
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>

              <Divider />

              {/* Pricing */}
              <div
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: T.textMuted,
                  textTransform: "uppercase",
                  letterSpacing: 0.6,
                  marginBottom: 8,
                }}
              >
                🏷️ Pricing & Availability
              </div>
              <div style={S.grid(2)}>
                <div>
                  <label style={S.label}>Selling Price per Portion (XAF)</label>
                  <input
                    type="number"
                    style={{ ...S.input, color: T.accent, fontWeight: 700 }}
                    value={nm.price}
                    onChange={(e) => setNm({ ...nm, price: e.target.value })}
                    placeholder="e.g. 4500"
                  />
                </div>
                <div>
                  <label style={S.label}>Available Portions (batch qty)</label>
                  <input
                    type="number"
                    min="0"
                    style={S.input}
                    value={nm.availablePortions}
                    onChange={(e) =>
                      setNm({ ...nm, availablePortions: e.target.value })
                    }
                    placeholder="e.g. 30"
                  />
                </div>
              </div>

              {/* Live cost summary */}
              {(Number(nm.price) > 0 ||
                Number(nm.laborCost) > 0 ||
                (nm.ingredientLinks || []).length > 0) &&
                (() => {
                  const ingC = (nm.ingredientLinks || []).reduce((s, l) => {
                    const inv = inventory.find((i) => i.id === l.inventoryId);
                    return s + (inv ? inv.costPerUnit * l.qty : 0);
                  }, 0);
                  const labC = Number(nm.laborCost || 0);
                  const othC = (nm.otherCosts || []).reduce(
                    (s, c) => s + Number(c.amount || 0),
                    0
                  );
                  const totalC = ingC + labC + othC;
                  const price = Number(nm.price || 0);
                  const portions = Number(nm.availablePortions || 0);
                  const profit = price - totalC;
                  const margin =
                    price > 0 ? ((profit / price) * 100).toFixed(0) : null;
                  const totalValue = price * portions;
                  const totalProfit = profit * portions;
                  return (
                    <div
                      style={{
                        marginTop: 12,
                        background: T.surface,
                        borderRadius: 8,
                        padding: 12,
                        display: "grid",
                        gridTemplateColumns: "repeat(4,1fr)",
                        gap: 10,
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontSize: 10,
                            color: T.textMuted,
                            marginBottom: 2,
                          }}
                        >
                          Total Cost/Portion
                        </div>
                        <div
                          style={{
                            fontSize: 14,
                            fontWeight: 800,
                            color: T.danger,
                          }}
                        >
                          {fmt(totalC)}
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: 10,
                            color: T.textMuted,
                            marginBottom: 2,
                          }}
                        >
                          Profit/Portion
                        </div>
                        <div
                          style={{
                            fontSize: 14,
                            fontWeight: 800,
                            color: profit >= 0 ? T.success : T.danger,
                          }}
                        >
                          {fmt(profit)}
                        </div>
                        {margin && (
                          <div style={{ fontSize: 9, color: T.textMuted }}>
                            {margin}% margin
                          </div>
                        )}
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: 10,
                            color: T.textMuted,
                            marginBottom: 2,
                          }}
                        >
                          Total Meal Value
                        </div>
                        <div
                          style={{
                            fontSize: 14,
                            fontWeight: 800,
                            color: T.accent,
                          }}
                        >
                          {portions > 0 ? fmt(totalValue) : "—"}
                        </div>
                        {portions > 0 && (
                          <div style={{ fontSize: 9, color: T.textMuted }}>
                            {portions} portions × {fmt(price)}
                          </div>
                        )}
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: 10,
                            color: T.textMuted,
                            marginBottom: 2,
                          }}
                        >
                          Total Profit
                        </div>
                        <div
                          style={{
                            fontSize: 14,
                            fontWeight: 800,
                            color: totalProfit >= 0 ? T.success : T.danger,
                          }}
                        >
                          {portions > 0 ? fmt(totalProfit) : "—"}
                        </div>
                      </div>
                    </div>
                  );
                })()}

              <div
                style={{ ...S.row, marginTop: 12, justifyContent: "flex-end" }}
              >
                <button
                  style={S.btn("ghost")}
                  onClick={() => {
                    setAddingMeal(false);
                    setEditMealId(null);
                    setNm(EMPTY_MEAL);
                  }}
                >
                  Cancel
                </button>
                <button style={S.btn("primary")} onClick={saveMeal}>
                  {editMealId ? "Update Meal" : "Save Meal"}
                </button>
              </div>
            </div>
          )}

          {/* Search & filter bar */}
          <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap", alignItems: "center" }}>
            <input
              style={{ ...S.input, flex: 1, minWidth: 180 }}
              placeholder="🔍 Search meals…"
              value={mealSearch}
              onChange={e => setMealSearch(e.target.value)}
            />
            <select
              style={{ ...S.select, minWidth: 130 }}
              value={mealCatFilter}
              onChange={e => setMealCatFilter(e.target.value)}
            >
              <option value="All">All Categories</option>
              {(catalogCategories || []).map(c => (
                <option key={c.id} value={c.name}>{c.name}</option>
              ))}
            </select>
            <select
              style={{ ...S.select, minWidth: 120 }}
              value={mealCatFilter === "active" ? "active" : mealCatFilter === "inactive" ? "inactive" : ""}
              onChange={e => { if (e.target.value) setMealCatFilter(e.target.value); }}
            >
              <option value="">All Status</option>
              <option value="active">Active only</option>
              <option value="inactive">Inactive only</option>
            </select>
            {(mealSearch || mealCatFilter !== "All") && (
              <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 10px", whiteSpace: "nowrap" }}
                onClick={() => { setMealSearch(""); setMealCatFilter("All"); }}>
                ✕ Clear
              </button>
            )}
            <span style={{ fontSize: 11, color: T.textDim, whiteSpace: "nowrap" }}>
              {meals.filter(m => {
                const matchSearch = !mealSearch || m.name.toLowerCase().includes(mealSearch.toLowerCase()) || (m.description || "").toLowerCase().includes(mealSearch.toLowerCase());
                const matchCat = mealCatFilter === "All" ? true : mealCatFilter === "active" ? m.active : mealCatFilter === "inactive" ? !m.active : m.category === mealCatFilter;
                return matchSearch && matchCat;
              }).length} of {meals.length}
            </span>
          </div>

          {/* Meals list */}
          <div style={isMobile ? S.gridMobile : S.grid(3)}>
            {meals.filter(meal => {
              const matchSearch = !mealSearch || meal.name.toLowerCase().includes(mealSearch.toLowerCase()) || (meal.description || "").toLowerCase().includes(mealSearch.toLowerCase());
              const matchCat = mealCatFilter === "All" ? true : mealCatFilter === "active" ? meal.active : mealCatFilter === "inactive" ? !meal.active : meal.category === mealCatFilter;
              return matchSearch && matchCat;
            }).map((meal) => {
              const ingCost = getMealIngCost(meal);
              const totalCost = getMealTotalCost(meal);
              const portions = Number(meal.availablePortions || 0);
              const profit = meal.price - totalCost;
              const margin =
                meal.price > 0 && totalCost > 0

                  ? (((meal.price - totalCost) / meal.price) * 100).toFixed(0)
                  : null;
              const totalValue = meal.price * portions;
              const totalProfit = profit * portions;
              const isExpanded = expandedMeal === meal.id;
              const marginColor = margin
                ? Number(margin) > 40
                  ? T.success
                  : Number(margin) > 20
                  ? T.warning
                  : T.danger
                : T.textMuted;
              return (
                <div
                  key={meal.id}
                  style={{
                    ...S.card,
                    padding: 0,
                    overflow: "hidden",
                    opacity: meal.active ? 1 : 0.6,
                  }}
                >
                  {/* Photo */}
                  <div
                    style={{
                      height: 90,
                      background: T.surface,
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={async () => {
                      const inp = document.createElement("input");
                      inp.type = "file";
                      inp.accept = "image/*";
                      inp.onchange = async (e) => {
                        const f = e.target.files[0];
                        if (!f) return;
                        const src = await uploadFile(f, "meals");
                        if (!src) { alert("❌ Photo upload failed. Please check your internet connection and try again."); return; }
                        setMeals((prev) =>
                          prev.map((m) =>
                            m.id === meal.id ? { ...m, photo: src } : m
                          )
                        );
                        // Sync photo to matching catalog item
                        syncPhotoToCatalog(meal.name, src);
                      };
                      inp.click();
                    }}
                  >
                    {meal.photo ? (
                      <img
                        src={meal.photo}
                        alt={meal.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          color: T.textDim,
                          gap: 2,
                        }}
                      >
                        <div style={{ fontSize: 24 }}>🍽️</div>
                        <div style={{ fontSize: 9 }}>Click to upload</div>
                      </div>
                    )}
                    {!meal.active && (
                      <div
                        style={{
                          position: "absolute",
                          top: 4,
                          left: 4,
                          background: T.danger,
                          color: "#fff",
                          fontSize: 9,
                          padding: "2px 5px",
                          borderRadius: 3,
                        }}
                      >
                        INACTIVE
                      </div>
                    )}
                    <div
                      style={{
                        position: "absolute",
                        bottom: 4,
                        right: 4,
                        background: "rgba(0,0,0,0.55)",
                        color: "#fff",
                        fontSize: 8,
                        padding: "2px 4px",
                        borderRadius: 3,
                      }}
                    >
                      📷
                    </div>
                  </div>

                  <div style={{ padding: 10 }}>
                    {/* Name & category */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginBottom: 2,
                      }}
                    >
                      <div style={{ fontSize: 12, fontWeight: 700 }}>
                        {meal.name}
                      </div>
                      <div style={{ display: "flex", gap: 4, alignItems: "center", flexShrink: 0 }}>
                        {catalogItems && catalogItems.some(c => c.name.toLowerCase() === meal.name.toLowerCase()) && (
                          <span title="Linked to catalog — photos sync automatically" style={{ fontSize: 8, color: T.accent, background: T.accent + "18", padding: "1px 5px", borderRadius: 8, fontWeight: 700 }}>🔗 Catalog</span>
                        )}
                        <Badge color={T.textMuted}>{meal.category}</Badge>
                      </div>
                    </div>
                    {meal.description && (
                      <div
                        style={{
                          fontSize: 10,
                          color: T.textDim,
                          marginBottom: 6,
                          lineHeight: 1.4,
                        }}
                      >
                        {meal.description}
                      </div>
                    )}

                    {/* Price row */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        marginBottom: 4,
                      }}
                    >
                      <input
                        type="number"
                        value={meal.price}
                        onChange={(e) =>
                          setMeals((prev) =>
                            prev.map((m) =>
                              m.id === meal.id
                                ? { ...m, price: Number(e.target.value) }
                                : m
                            )
                          )
                        }
                        style={{
                          ...S.input,
                          width: 90,
                          padding: "3px 5px",
                          fontSize: 13,
                          fontWeight: 800,
                          color: T.accent,
                        }}
                      />
                      <span style={{ fontSize: 10, color: T.textMuted }}>
                        XAF/portion
                      </span>
                    </div>

                    {/* Quick cost summary bar */}
                    <div
                      style={{
                        background: T.surface,
                        borderRadius: 6,
                        padding: "6px 8px",
                        marginBottom: 6,
                        fontSize: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 2,
                        }}
                      >
                        <span style={{ color: T.textMuted }}>
                          Cost/portion:
                        </span>
                        <span style={{ color: T.danger, fontWeight: 700 }}>
                          {totalCost > 0 ? fmt(totalCost) : "—"}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 2,
                        }}
                      >
                        <span style={{ color: T.textMuted }}>
                          Profit/portion:
                        </span>
                        <span
                          style={{
                            color: profit >= 0 ? T.success : T.danger,
                            fontWeight: 700,
                          }}
                        >
                          {totalCost > 0 ? fmt(profit) : "—"}
                        </span>
                      </div>
                      {margin && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 2,
                          }}
                        >
                          <span style={{ color: T.textMuted }}>Margin:</span>
                          <span style={{ color: marginColor, fontWeight: 700 }}>
                            {margin}%
                          </span>
                        </div>
                      )}
                      <div
                        style={{
                          borderTop: `1px solid ${T.border}30`,
                          marginTop: 4,
                          paddingTop: 4,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ color: T.textMuted }}>
                          {portions > 0
                            ? `${portions} portions available`
                            : "Portions not set"}
                        </span>
                      </div>
                      {portions > 0 && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: 2,
                            }}
                          >
                            <span style={{ color: T.textMuted }}>
                              Total value:
                            </span>
                            <span style={{ color: T.accent, fontWeight: 700 }}>
                              {fmt(totalValue)}
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: 2,
                            }}
                          >
                            <span style={{ color: T.textMuted }}>
                              Total profit:
                            </span>
                            <span
                              style={{
                                color: totalProfit >= 0 ? T.success : T.danger,
                                fontWeight: 700,
                              }}
                            >
                              {fmt(totalProfit)}
                            </span>
                          </div>
                        </>
                      )}
                    </div>

                    {/* Expanded costing detail */}
                    {isExpanded && (
                      <div
                        style={{
                          background: `${T.surface}88`,
                          borderRadius: 6,
                          padding: 8,
                          marginBottom: 6,
                          fontSize: 10,
                        }}
                      >
                        {(meal.ingredientLinks || []).length > 0 && (
                          <>
                            <div
                              style={{
                                fontWeight: 700,
                                color: T.textMuted,
                                marginBottom: 4,
                              }}
                            >
                              🧂 Ingredients
                            </div>
                            {meal.ingredientLinks.map((l) => {
                              const inv = inventory.find(
                                (i) => i.id === l.inventoryId
                              );
                              if (!inv) return null;
                              return (
                                <div
                                  key={l.inventoryId}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: 2,
                                  }}
                                >
                                  <span style={{ color: T.textDim }}>
                                    {inv.name} × {l.qty}
                                    {inv.unit}
                                  </span>
                                  <span style={{ color: T.danger }}>
                                    {fmt(inv.costPerUnit * l.qty)}
                                  </span>
                                </div>
                              );
                            })}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                borderTop: `1px solid ${T.border}30`,
                                marginTop: 3,
                                paddingTop: 3,
                                fontWeight: 700,
                              }}
                            >
                              <span style={{ color: T.textMuted }}>
                                Ingredients subtotal
                              </span>
                              <span style={{ color: T.danger }}>
                                {fmt(ingCost)}
                              </span>
                            </div>
                          </>
                        )}
                        {Number(meal.laborCost || 0) > 0 && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: 4,
                            }}
                          >
                            <span style={{ color: T.textMuted }}>👨‍🍳 Labor</span>
                            <span style={{ color: T.danger }}>
                              {fmt(meal.laborCost)}
                            </span>
                          </div>
                        )}
                        {(meal.otherCosts || [])
                          .filter((c) => Number(c.amount) > 0)
                          .map((c, i) => (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: 2,
                              }}
                            >
                              <span style={{ color: T.textMuted }}>
                                📋 {c.label || "Other"}
                              </span>
                              <span style={{ color: T.danger }}>
                                {fmt(c.amount)}
                              </span>
                            </div>
                          ))}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderTop: `1px solid ${T.border}`,
                            marginTop: 5,
                            paddingTop: 5,
                            fontWeight: 800,
                          }}
                        >
                          <span style={{ color: T.text }}>Total Cost</span>
                          <span style={{ color: T.danger }}>
                            {fmt(totalCost)}
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Action buttons */}
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <button
                        style={{ ...S.btn("ghost"), fontSize: 9, padding: "2px 6px" }}
                        onClick={() => startEditMeal(meal)}
                      >✏️ Edit</button>
                      <button
                        style={{ ...S.btn("ghost"), fontSize: 9, padding: "2px 6px" }}
                        onClick={() => {
                          const copy = { ...meal, id: Date.now(), name: meal.name + " (copy)", active: false };
                          setMeals(prev => [...prev, copy]);
                          startEditMeal(copy);
                        }}
                      >⧉ Duplicate</button>
                      {!catalogItems.some(c => c.name.toLowerCase() === meal.name.toLowerCase()) && (
                        <button
                          title="Add to Catalog for use in Proposals"
                          style={{ ...S.btn("ghost"), fontSize: 9, padding: "2px 6px", color: T.accent, borderColor: T.accent + "40" }}
                          onClick={() => copyToCatalog(meal)}
                        >→ Catalog</button>
                      )}
                      {catalogItems.some(c => c.name.toLowerCase() === meal.name.toLowerCase()) && (
                        <span style={{ fontSize: 8, color: T.success, background: T.success + "18", padding: "2px 6px", borderRadius: 8, fontWeight: 700 }}>🔗 Catalog</span>
                      )}
                      <button
                        style={{ ...S.btn("ghost"), fontSize: 9, padding: "2px 6px", borderColor: isExpanded ? T.accent : T.border, color: isExpanded ? T.accent : T.text }}
                        onClick={() => setExpandedMeal(isExpanded ? null : meal.id)}
                      >💰 {isExpanded ? "Hide Cost" : "View Cost"}</button>
                      <button
                        style={{ ...S.btn("ghost"), fontSize: 9, padding: "2px 6px", color: meal.active ? T.danger : T.success }}
                        onClick={() => setMeals((prev) => prev.map((m) => m.id === meal.id ? { ...m, active: !m.active } : m))}
                      >{meal.active ? "Deactivate" : "Activate"}</button>
                      <button
                        style={{ ...S.btn("ghost"), fontSize: 9, padding: "2px 6px", color: T.danger, borderColor: T.danger + "40" }}
                        onClick={() => { if (window.confirm(`Delete "${meal.name}"?\n\nThis cannot be undone.`)) setMeals((prev) => prev.filter((m) => m.id !== meal.id)); }}
                      >🗑 Delete</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {meals.length === 0 && (
            <div
              style={{ color: T.textMuted, padding: 30, textAlign: "center" }}
            >
              No meals yet. Add a new meal or import from the catalog.
            </div>
          )}
        </>
      )}

      {/* ── INVENTORY TAB ── */}
      {tab === "inventory" && (
        <>
          <div style={{ ...S.row, marginBottom: 12, flexWrap: "wrap", gap: 6 }}>
            <div style={{ ...S.card, flex: 1, padding: 10, minWidth: 180 }}>
              <div style={S.cardTitle}>Total Stock Value</div>
              <div style={{ ...S.kpi, fontSize: 18 }}>
                {fmt(totalStockValue)}
              </div>
            </div>
            <div style={{ ...S.card, flex: 1, padding: 10, minWidth: 180 }}>
              <div style={S.cardTitle}>Low Stock Items</div>
              <div
                style={{
                  ...S.kpi,
                  fontSize: 18,
                  color: lowStock.length > 0 ? T.danger : T.success,
                }}
              >
                {lowStock.length}
              </div>
            </div>
            <div style={{ ...S.card, flex: 1, padding: 10, minWidth: 180 }}>
              <div style={S.cardTitle}>Total SKUs</div>
              <div style={{ ...S.kpi, fontSize: 18 }}>{inventory.length}</div>
            </div>
            <button
              style={{ ...S.btn("primary"), alignSelf: "center" }}
              onClick={() => {
                setAddingInv(!addingInv);
                setEditInvId(null);
                setShowNewCatInput(false);
                setNewCatValue("");
                setNi({
                  name: "",
                  category: "Ingredient",
                  itemType: "ingredient",
                  unit: "kg",
                  stock: "",
                  reorderAt: "",
                  costPerUnit: "",
                  sellingPrice: "",
                  linkedMeals: "",
                });
              }}
            >
              + Add Item
            </button>
          </div>
          {addingInv && (
            <div style={{ ...S.card, marginBottom: 12, borderColor: T.accent }}>
              <div style={S.sectionTitle}>
                {editInvId != null
                  ? "Edit Inventory Item"
                  : "New Inventory Item"}
              </div>
              <div style={S.grid(4)}>
                <div>
                  <label style={S.label}>Item Name</label>
                  <input
                    style={S.input}
                    value={ni.name}
                    onChange={(e) => setNi({ ...ni, name: e.target.value })}
                  />
                </div>
                <div>
                  <label style={S.label}>Category</label>
                  {showNewCatInput ? (
                    <div style={{ display: "flex", gap: 4 }}>
                      <input
                        style={{ ...S.input, flex: 1 }}
                        autoFocus
                        placeholder="New category name…"
                        value={newCatValue}
                        onChange={(e) => setNewCatValue(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            const trimmed = newCatValue.trim();
                            if (trimmed && !invCategories.includes(trimmed)) {
                              setInvCategories((prev) => [...prev, trimmed]);
                              setNi({ ...ni, category: trimmed });
                            } else if (trimmed) {
                              setNi({ ...ni, category: trimmed });
                            }
                            setNewCatValue("");
                            setShowNewCatInput(false);
                          }
                          if (e.key === "Escape") {
                            setNewCatValue("");
                            setShowNewCatInput(false);
                          }
                        }}
                      />
                      <button
                        style={{ ...S.btn("primary"), padding: "4px 8px", fontSize: 11 }}
                        onClick={() => {
                          const trimmed = newCatValue.trim();
                          if (trimmed && !invCategories.includes(trimmed)) {
                            setInvCategories((prev) => [...prev, trimmed]);
                            setNi({ ...ni, category: trimmed });
                          } else if (trimmed) {
                            setNi({ ...ni, category: trimmed });
                          }
                          setNewCatValue("");
                          setShowNewCatInput(false);
                        }}
                      >
                        ✓
                      </button>
                      <button
                        style={{ ...S.btn("ghost"), padding: "4px 8px", fontSize: 11 }}
                        onClick={() => { setNewCatValue(""); setShowNewCatInput(false); }}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <div style={{ display: "flex", gap: 4 }}>
                      <select
                        style={{ ...S.select, flex: 1 }}
                        value={ni.category}
                        onChange={(e) => setNi({ ...ni, category: e.target.value })}
                      >
                        {invCategories.map((c) => (
                          <option key={c}>{c}</option>
                        ))}
                      </select>
                      <button
                        title="Add new category"
                        style={{
                          ...S.btn("ghost"),
                          padding: "4px 8px",
                          fontSize: 13,
                          flexShrink: 0,
                          borderColor: T.accent,
                          color: T.accent,
                        }}
                        onClick={() => setShowNewCatInput(true)}
                      >
                        +
                      </button>
                    </div>
                  )}
                </div>
                <div>
                  <label style={S.label}>Item Type</label>
                  <select style={S.select} value={ni.itemType || "ingredient"} onChange={e => setNi({ ...ni, itemType: e.target.value })}>
                    <option value="ingredient">Ingredient / Internal Use</option>
                    <option value="resale">Resale Item (e.g. drinks, wine)</option>
                  </select>
                </div>
                <div>
                  <label style={S.label}>Unit</label>
                  <input
                    style={S.input}
                    value={ni.unit}
                    placeholder="kg, L, pack…"
                    onChange={(e) => setNi({ ...ni, unit: e.target.value })}
                  />
                </div>
                <div>
                  <label style={S.label}>Current Stock</label>
                  <input
                    type="number"
                    style={S.input}
                    value={ni.stock}
                    onChange={(e) => setNi({ ...ni, stock: e.target.value })}
                  />
                </div>
                <div>
                  <label style={S.label}>Reorder At (min)</label>
                  <input
                    type="number"
                    style={S.input}
                    value={ni.reorderAt}
                    onChange={(e) =>
                      setNi({ ...ni, reorderAt: e.target.value })
                    }
                  />
                </div>
                <div>
                  <label style={S.label}>Cost per Unit (XAF)</label>
                  <input
                    type="number"
                    style={S.input}
                    value={ni.costPerUnit}
                    onChange={(e) =>
                      setNi({ ...ni, costPerUnit: e.target.value })
                    }
                  />
                </div>
                {(ni.itemType || "ingredient") === "resale" && (
                  <div>
                    <label style={S.label}>Selling Price / Unit (XAF)</label>
                    <input
                      type="number"
                      style={S.input}
                      placeholder="Price charged to customers"
                      value={ni.sellingPrice || ""}
                      onChange={(e) => setNi({ ...ni, sellingPrice: e.target.value })}
                    />
                  </div>
                )}

                <div>
                  <label style={S.label}>Linked Meals (comma-sep.)</label>
                  <input
                    style={S.input}
                    value={ni.linkedMeals}
                    placeholder="e.g. Rice & Chicken, Stew…"
                    onChange={(e) =>
                      setNi({ ...ni, linkedMeals: e.target.value })
                    }
                  />
                </div>
              </div>
              <div
                style={{ ...S.row, marginTop: 10, justifyContent: "flex-end" }}
              >
                <button
                  style={S.btn("ghost")}
                  onClick={() => {
                    setAddingInv(false);
                    setEditInvId(null);
                    setShowNewCatInput(false);
                    setNewCatValue("");
                  }}
                >
                  Cancel
                </button>
                <button style={S.btn("primary")} onClick={saveInv}>
                  {editInvId != null ? "Update" : "Add to Inventory"}
                </button>
              </div>
            </div>
          )}
          {lowStock.length > 0 && (
            <div style={{ marginBottom: 10 }}>
              <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: T.danger, marginBottom: 6 }}>
                ⚠️ {lowStock.length} item{lowStock.length > 1 ? "s" : ""} need restocking
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: 6 }}>
                {lowStock.map(item => {
                  const pct = Number(item.reorderAt) > 0 ? Math.round((item.stock / item.reorderAt) * 100) : 0;
                  const critical = item.stock === 0;
                  return (
                    <div key={item.id} style={{
                      background: critical ? T.danger + "12" : T.warning + "10",
                      border: `1px solid ${critical ? T.danger : T.warning}40`,
                      borderLeft: `3px solid ${critical ? T.danger : T.warning}`,
                      borderRadius: 6, padding: "8px 10px",
                    }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: T.text }}>{item.name}</div>
                        {critical && <span style={{ fontSize: 9, fontWeight: 800, color: T.danger, background: T.danger + "15", padding: "1px 5px", borderRadius: 8 }}>OUT</span>}
                      </div>
                      <div style={{ fontSize: 10, color: T.textMuted, marginTop: 2 }}>
                        {item.stock} {item.unit} left · min {item.reorderAt}
                      </div>
                      <div style={{ height: 3, background: T.surface, borderRadius: 2, marginTop: 5 }}>
                        <div style={{ height: 3, borderRadius: 2, background: critical ? T.danger : T.warning, width: `${Math.min(pct, 100)}%` }} />
                      </div>
                      {item.costPerUnit > 0 && (
                        <div style={{ fontSize: 9, color: T.textDim, marginTop: 3 }}>
                          Cost: {fmt(item.costPerUnit)} / {item.unit}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div style={{ display: "flex", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
            <input
              style={{ ...S.input, flex: 1, minWidth: 180, marginBottom: 0 }}
              placeholder="🔍 Search items…"
              value={invSearch}
              onChange={e => setInvSearch(e.target.value)}
            />
            <select
              style={{ ...S.select, minWidth: 150 }}
              value={invCatFilter}
              onChange={e => setInvCatFilter(e.target.value)}
            >
              <option value="All">All Categories</option>
              {[...new Set(inventory.map(i => i.category).filter(Boolean))].sort().map(c => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
            {(invSearch || invCatFilter !== "All") && (
              <button style={{ ...S.btn("ghost"), fontSize: 11 }} onClick={() => { setInvSearch(""); setInvCatFilter("All"); }}>✕ Clear</button>
            )}
          </div>
          <div className="tbl-wrap">
            <table style={S.table}>
              <thead>
                <tr>
                  {[
                    "Item",
                    "Category",
                    "Unit",
                    "Stock",
                    "Reorder At",
                    "Cost/Unit",
                    "Stock Value",
                    "Linked Meals",
                    "Status",
                    "",
                  ].map((h) => (
                    <th key={h} style={S.th}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {inventory.filter(item => {
                  const q = invSearch.toLowerCase();
                  const matchSearch = !invSearch || item.name.toLowerCase().includes(q) || (item.category || "").toLowerCase().includes(q) || (item.unit || "").toLowerCase().includes(q);
                  const matchCat = invCatFilter === "All" || item.category === invCatFilter;
                  return matchSearch && matchCat;
                }).map((item) => {
                  const low = item.stock <= item.reorderAt;

                  return (
                    <tr key={item.id}>
                      <td style={{ ...S.td, fontWeight: 700 }}>{item.name}</td>
                      <td style={S.td}>{item.category}</td>
                      <td style={S.td}>{item.unit}</td>
                      <td
                        style={{
                          ...S.td,
                          fontWeight: 700,
                          color: low ? T.danger : T.success,
                        }}
                      >
                        {Math.round(item.stock * 100) / 100}
                      </td>
                      <td style={S.td}>{item.reorderAt}</td>
                      <td style={S.td}>{fmt(item.costPerUnit)}</td>

                      <td style={{ ...S.td, color: T.accent, fontWeight: 700 }}>
                        {fmt(item.stock * item.costPerUnit)}
                      </td>
                      <td style={{ ...S.td, fontSize: 11, color: T.textMuted }}>
                        {(item.linkedMeals || []).join(", ") || "—"}
                      </td>
                      <td style={S.td}>
                        {low ? (
                          <Badge color={T.danger}>Low</Badge>
                        ) : (
                          <Badge color={T.success}>OK</Badge>
                        )}
                      </td>
                      <td style={S.td}>
                        <div style={{ display: "flex", gap: 3 }}>
                          <button
                            style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px" }}
                            onClick={() => startEditInv(item)}
                          >Edit</button>
                          <button
                            style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px" }}
                            onClick={() => {
                              const copy = { ...item, id: Date.now(), name: item.name + " (copy)", stock: 0 };
                              setInventory(prev => [...prev, copy]);
                              startEditInv(copy);
                            }}
                          >⧉ Dupe</button>
                          <button
                            style={{ ...S.btn("primary"), fontSize: 10, padding: "2px 6px" }}
                            onClick={() => {
                              setRestockItem(item);
                              setRestockForm({ ...EMPTY_RESTOCK, costPerUnit: item.costPerUnit || "" });
                            }}
                          >+ Restock</button>
                          <button
                            style={{ background: "none", border: "none", color: T.danger, cursor: "pointer", fontSize: 11 }}
                            onClick={() => { if (window.confirm(`Delete ${item.name}?`)) deleteInv(item.id); }}
                          >✕</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

        </>
      )}

      {/* ── RECEIPT LIGHTBOX ── */}
      {viewReceiptUrl && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
          onClick={() => setViewReceiptUrl(null)}>
          <div style={{ position: "relative", maxWidth: "90vw", maxHeight: "90vh" }} onClick={e => e.stopPropagation()}>
            <img src={viewReceiptUrl} alt="Receipt" style={{ maxWidth: "80vw", maxHeight: "80vh", borderRadius: 8, objectFit: "contain", background: "#fff" }} />
            <button style={{ position: "absolute", top: -12, right: -12, background: T.danger, border: "none", borderRadius: "50%", width: 28, height: 28, color: "#fff", fontWeight: 800, cursor: "pointer", fontSize: 14 }}
              onClick={() => setViewReceiptUrl(null)}>✕</button>
            <a href={viewReceiptUrl} target="_blank" rel="noopener noreferrer"
              style={{ display: "block", marginTop: 8, textAlign: "center", fontSize: 11, color: T.accent }}>Open full size ↗</a>
          </div>
        </div>
      )}

      {/* ── PURCHASE DETAIL MODAL ── */}
      {viewPurchase && (() => {
        const p = viewPurchase;
        const totalCost = (Number(p.qty) || 0) * (Number(p.costPerUnit) || 0);
        const Field = ({ label, value }) => (
          <div style={{ marginBottom: 10 }}>
            <div style={{ fontSize: 10, color: T.textMuted, textTransform: "uppercase", letterSpacing: 1, marginBottom: 2 }}>{label}</div>
            <div style={{ fontSize: 14, color: T.text, fontWeight: 500 }}>{value || <span style={{ color: T.textDim }}>—</span>}</div>
          </div>
        );
        return (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 1500, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
            onClick={() => setViewPurchase(null)}>
            <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 14, padding: 20, width: "100%", maxWidth: 420, maxHeight: "90vh", overflowY: "auto" }}
              onClick={e => e.stopPropagation()}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                <div style={{ fontWeight: 700, fontSize: 16, color: T.text }}>🛍️ Purchase Detail</div>
                <button style={{ background: "none", border: "none", color: T.textMuted, cursor: "pointer", fontSize: 18 }} onClick={() => setViewPurchase(null)}>✕</button>
              </div>
              <div style={{ fontSize: 18, fontWeight: 700, color: T.accent, marginBottom: 14 }}>{p.itemName}</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 16px" }}>
                <Field label="Date" value={p.date} />
                <Field label="Supplier" value={p.supplier} />
                <Field label="Quantity" value={p.qty ? `${p.qty} ${p.unit || ""}`.trim() : null} />
                <Field label="Cost / Unit" value={p.costPerUnit ? fmt(p.costPerUnit) : null} />
                <Field label="Total Cost" value={totalCost > 0 ? fmt(totalCost) : null} />
                <Field label="Category" value={p.category} />
              </div>
              {p.note && <Field label="Note" value={p.note} />}
              {p.receiptUrl && (
                <div style={{ marginTop: 8 }}>
                  <div style={{ fontSize: 10, color: T.textMuted, textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>Receipt</div>
                  {p.receiptUrl.startsWith("data:application/pdf") || p.receiptUrl.endsWith(".pdf") ? (
                    <a href={p.receiptUrl} target="_blank" rel="noopener noreferrer"
                      style={{ fontSize: 13, color: T.accent }}>🧾 View PDF Receipt ↗</a>
                  ) : (
                    <img src={p.receiptUrl} alt="Receipt"
                      style={{ maxWidth: "100%", maxHeight: 200, objectFit: "contain", borderRadius: 8, border: `1px solid ${T.border}`, cursor: "pointer" }}
                      onClick={() => { setViewPurchase(null); setViewReceiptUrl(p.receiptUrl); }} title="Click to enlarge" />
                  )}
                </div>
              )}
              <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
                <button style={{ ...S.btn, background: T.accent, color: "#fff", fontSize: 13 }} onClick={() => setViewPurchase(null)}>Close</button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── RESTOCK MODAL ── */}
      {restockItem && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div style={{ ...S.card, width: "100%", maxWidth: 460, padding: 20 }}>
            <div style={{ ...S.sectionTitle, marginBottom: 6 }}>🛒 Restock: {restockItem.name}</div>
            <div style={{ fontSize: 11, color: T.textMuted, marginBottom: 14 }}>Current stock: {restockItem.stock} {restockItem.unit}</div>
            <div style={S.grid(2)}>
              <div>
                <label style={S.label}>Date *</label>
                <input type="date" style={S.input} value={restockForm.date} onChange={e => setRestockForm(f => ({ ...f, date: e.target.value }))} />
              </div>
              <div>
                <label style={S.label}>Qty Added ({restockItem.unit}) *</label>
                <input type="number" style={S.input} placeholder="e.g. 5" value={restockForm.qty} onChange={e => setRestockForm(f => ({ ...f, qty: e.target.value }))} />
              </div>
              <div>
                <label style={S.label}>Cost per {restockItem.unit} (XAF) *</label>
                <input type="number" style={S.input} placeholder="Unit cost paid" value={restockForm.costPerUnit} onChange={e => setRestockForm(f => ({ ...f, costPerUnit: e.target.value }))} />
              </div>
              <div>
                <label style={S.label}>Supplier</label>
                <input style={S.input} placeholder="e.g. Marché Mokolo" value={restockForm.supplier} onChange={e => setRestockForm(f => ({ ...f, supplier: e.target.value }))} />
              </div>
            </div>
            <div>
              <label style={S.label}>Note</label>
              <input style={S.input} placeholder="Optional note…" value={restockForm.note} onChange={e => setRestockForm(f => ({ ...f, note: e.target.value }))} />
            </div>
            {/* Receipt upload */}
            <div style={{ marginTop: 10 }}>
              <label style={S.label}>Receipt / Invoice (photo or PDF)</label>
              <input ref={restockFileRef} type="file" accept="image/*,application/pdf" style={{ display: "none" }}
                onChange={async e => {
                  const file = e.target.files[0];
                  if (!file) return;
                  setRestockForm(f => ({ ...f, receiptUploading: true }));
                  try {
                    let url;
                    if (isSupabaseConfigured()) {
                      url = await uploadFile(file, "receipts");
                    } else {
                      url = await readAsDataURL(file);
                    }
                    setRestockForm(f => ({ ...f, receiptUrl: url || "", receiptUploading: false }));
                  } catch {
                    setRestockForm(f => ({ ...f, receiptUploading: false }));
                  }
                  e.target.value = "";
                }}
              />
              {restockForm.receiptUploading ? (
                <div style={{ fontSize: 11, color: T.textMuted, padding: "6px 0" }}>Uploading…</div>
              ) : restockForm.receiptUrl ? (
                <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 4 }}>
                  <img src={restockForm.receiptUrl} alt="Receipt preview" style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 4, border: `1px solid ${T.border}`, cursor: "pointer" }}
                    onClick={() => setViewReceiptUrl(restockForm.receiptUrl)} />
                  <span style={{ fontSize: 11, color: T.success }}>✓ Receipt attached</span>
                  <button style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px" }} onClick={() => setRestockForm(f => ({ ...f, receiptUrl: "" }))}>Remove</button>
                </div>
              ) : (
                <button style={{ ...S.btn("ghost"), fontSize: 11, marginTop: 4 }} onClick={() => restockFileRef.current && restockFileRef.current.click()}>
                  📎 Attach Receipt
                </button>
              )}
            </div>
            {/* Total cost summary bar */}
            <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 14px", marginTop: 14, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: 10, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.8 }}>Total Cost</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: restockForm.qty && restockForm.costPerUnit ? T.accent : T.textDim }}>
                  {restockForm.qty && restockForm.costPerUnit
                    ? fmt(Number(restockForm.qty) * Number(restockForm.costPerUnit))
                    : "—"}
                </div>
              </div>
              {restockForm.qty && restockForm.costPerUnit && (
                <div style={{ fontSize: 11, color: T.textMuted, textAlign: "right" }}>
                  {restockForm.qty} {restockItem.unit} × {fmt(Number(restockForm.costPerUnit))}
                </div>
              )}
            </div>
            <div style={{ ...S.row, marginTop: 14, justifyContent: "flex-end" }}>
              <button style={S.btn("ghost")} onClick={() => { setRestockItem(null); setRestockForm(EMPTY_RESTOCK); }}>Cancel</button>
              <button style={S.btn("primary")} disabled={restockForm.receiptUploading} onClick={() => {
                const qty = Number(restockForm.qty);
                const cpu = Number(restockForm.costPerUnit);
                if (!qty || qty <= 0 || !restockForm.date) return;
                setInventory(prev => prev.map(it => it.id === restockItem.id
                  ? { ...it, stock: it.stock + qty, costPerUnit: cpu > 0 ? cpu : it.costPerUnit }
                  : it));
                const purchase = {
                  id: Date.now(),
                  date: restockForm.date,
                  itemId: restockItem.id,
                  itemName: restockItem.name,
                  unit: restockItem.unit,
                  qty,
                  costPerUnit: cpu,
                  totalCost: qty * cpu,
                  supplier: restockForm.supplier.trim(),
                  note: restockForm.note.trim(),
                  receiptUrl: restockForm.receiptUrl || "",
                };
                setInvPurchases(prev => [purchase, ...prev]);
                setRestockItem(null);
                setRestockForm(EMPTY_RESTOCK);
              }}>Confirm Restock</button>
            </div>
          </div>
        </div>
      )}

      {/* ── PURCHASES TAB ── */}
      {tab === "purchases" && (
        <div>
          <div style={{ ...S.row, marginBottom: 12, flexWrap: "wrap", gap: 6 }}>
            {/* Period filter chips */}
            {[["day","Today"],["week","This Week"],["month","This Month"],["all","All Time"]].map(([v,label]) => (
              <button key={v} style={{ ...S.btn(purchaseFilter === v ? "primary" : "ghost"), fontSize: 11 }} onClick={() => setPurchaseFilter(v)}>{label}</button>
            ))}
            {purchaseFilter === "all" && (
              <Fragment>
                <input type="date" style={{ ...S.input, width: 130, marginBottom: 0 }} value={purchaseFrom} onChange={e => setPurchaseFrom(e.target.value)} />
                <span style={{ alignSelf: "center", fontSize: 11, color: T.textMuted }}>–</span>
                <input type="date" style={{ ...S.input, width: 130, marginBottom: 0 }} value={purchaseTo} onChange={e => setPurchaseTo(e.target.value)} />
              </Fragment>
            )}
          </div>
          {(() => {
            const today = TODAY_ISO;
            const weekAgo = new Date(); weekAgo.setDate(weekAgo.getDate() - 6);
            const weekAgoStr = weekAgo.toISOString().slice(0, 10);
            const monthStart = today.slice(0, 7) + "-01";
            const filtered = (invPurchases || []).filter(p => {
              if (purchaseFilter === "day") return p.date === today;
              if (purchaseFilter === "week") return p.date >= weekAgoStr && p.date <= today;
              if (purchaseFilter === "month") return p.date >= monthStart && p.date <= today;
              return p.date >= purchaseFrom && p.date <= purchaseTo;
            });
            const totalSpent = filtered.reduce((s, p) => s + Number(p.totalCost || 0), 0);
            const csvRows = [
              ["Date","Item","Qty","Unit","Cost/Unit (XAF)","Total (XAF)","Supplier","Note"],
              ...filtered.map(p => [p.date, p.itemName, p.qty, p.unit, p.costPerUnit, p.totalCost, p.supplier || "", p.note || ""])
            ];
            const csvContent = csvRows.map(r => r.map(v => `"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
            const downloadCSV = () => {
              const blob = new Blob([csvContent], { type: "text/csv" });
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a"); a.href = url;
              a.download = `ingredient-purchases-${today}.csv`; a.click();
              URL.revokeObjectURL(url);
            };
            return (
              <div>
                <div style={{ ...S.row, marginBottom: 10, justifyContent: "space-between", flexWrap: "wrap", gap: 6 }}>
                  <div>
                    <span style={{ fontSize: 12, color: T.textMuted }}>{filtered.length} purchase{filtered.length !== 1 ? "s" : ""} · Total: </span>
                    <span style={{ fontSize: 14, fontWeight: 800, color: T.accent }}>{fmt(totalSpent)}</span>
                  </div>
                  {filtered.length > 0 && (
                    <button style={{ ...S.btn("ghost"), fontSize: 11 }} onClick={downloadCSV}>⬇ Download CSV</button>
                  )}
                </div>
                {filtered.length === 0 ? (
                  <div style={{ textAlign: "center", padding: 40, color: T.textMuted, fontSize: 13 }}>No purchases in this period.<br />Use the + Restock button on any inventory item.</div>
                ) : (
                  <div style={{ overflowX: "auto" }}>
                    <table style={S.table}>
                      <thead>
                        <tr>
                          {["Date","Item","Qty","Cost/Unit","Total","Supplier","Note","Receipt",""].map(h => (
                            <th key={h} style={S.th}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {filtered.map(p => (
                          <tr key={p.id} style={{ cursor: "pointer" }} onClick={() => setViewPurchase(p)}>
                            <td style={S.td}>{p.date}</td>
                            <td style={{ ...S.td, fontWeight: 600, color: T.accent }}>{p.itemName}</td>
                            <td style={S.td}>{p.qty} {p.unit}</td>
                            <td style={S.td}>{fmt(p.costPerUnit)}</td>
                            <td style={{ ...S.td, fontWeight: 700, color: T.accent }}>{fmt(p.totalCost)}</td>
                            <td style={{ ...S.td, color: T.textMuted }}>{p.supplier || "—"}</td>
                            <td style={{ ...S.td, color: T.textMuted, fontSize: 11 }}>{p.note || "—"}</td>
                            <td style={{ ...S.td, textAlign: "center" }} onClick={e => e.stopPropagation()}>
                              {p.receiptUrl ? (
                                p.receiptUrl.startsWith("data:application/pdf") || p.receiptUrl.endsWith(".pdf") ? (
                                  <a href={p.receiptUrl} target="_blank" rel="noopener noreferrer"
                                    style={{ fontSize: 18, textDecoration: "none", cursor: "pointer" }}
                                    title="View PDF receipt">🧾</a>
                                ) : (
                                  <img
                                    src={p.receiptUrl}
                                    alt="Receipt"
                                    style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 4, border: `1px solid ${T.border}`, cursor: "pointer" }}
                                    onClick={() => setViewReceiptUrl(p.receiptUrl)}
                                    title="Click to enlarge"
                                  />
                                )
                              ) : (
                                <span style={{ fontSize: 11, color: T.textDim }}>—</span>
                              )}
                            </td>
                            <td style={S.td} onClick={e => e.stopPropagation()}>
                              <button style={{ background: "none", border: "none", color: T.textMuted, cursor: "pointer", fontSize: 13, marginRight: 4 }} title="View details"
                                onClick={() => setViewPurchase(p)}>👁</button>
                              <button style={{ background: "none", border: "none", color: T.danger, cursor: "pointer", fontSize: 11 }}
                                onClick={() => { if (window.confirm("Delete this purchase record?")) setInvPurchases(prev => prev.filter(x => x.id !== p.id)); }}
                              >✕</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      )}

      {tab === "batches" && (
        <BatchesTab
          batches={batches}
          setBatches={setBatches}
          meals={meals}
          setMeals={setMeals}
          inventory={inventory}
          setInventory={setInventory}
          getMealTotalCost={getMealTotalCost}
          sales={sales}
        />
      )}
    </div>
  );
}

// ─── INVOICES ─────────────────────────────────────────────────────
function InvoicesPage({ invoices, setInvoices, events, logo, biz }) {
  const [doc, setDoc] = useState(null);
  const [pmtPanel, setPmtPanel] = useState(null); // { idx, amount, method }
  const openDoc = (title, html) =>
    setDoc({ title, html, onPrint: () => printDoc(title, html) });
  const totalAR = invoices.reduce((s, i) => s + (i.total - i.paid), 0);
  const totalPaid = invoices.reduce((s, i) => s + i.paid, 0);
  const recordPmt = (idx, amount) => {
    const u = [...invoices];
    const inv = { ...u[idx] };
    inv.paid = Math.min(inv.paid + Number(amount), inv.total);
    inv.status =
      inv.paid >= inv.total
        ? "Paid"
        : inv.paid > 0
        ? "Partially Paid"
        : "Unpaid";
    u[idx] = inv;
    setInvoices(u);
  };
  const stColor = {
    Paid: T.success,
    "Partially Paid": T.warning,
    Unpaid: T.danger,
    Cancelled: T.textDim,
  };
  return (
    <div>
      <DocModal doc={doc} onClose={() => setDoc(null)} />

      {/* ── Inline Payment Panel ─────────────────────────────────── */}
      {pmtPanel !== null && (() => {
        const inv = invoices[pmtPanel.idx];
        const bal = inv.total - inv.paid;
        return (
          <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.7)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
            onClick={() => setPmtPanel(null)}>
            <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, width:"100%", maxWidth:420, padding:24 }}
              onClick={e => e.stopPropagation()}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
                <div>
                  <div style={{ fontSize:14, fontWeight:700, color:T.text }}>💳 Record Payment</div>
                  <div style={{ fontSize:11, color:T.textMuted, marginTop:2 }}>{inv.num} · {inv.client}</div>
                </div>
                <button style={{ background:"none", border:"none", color:T.textDim, cursor:"pointer", fontSize:18 }} onClick={() => setPmtPanel(null)}>✕</button>
              </div>

              {/* Balance summary */}
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:16 }}>
                {[["Invoice Total", fmt(inv.total), T.text], ["Already Paid", fmt(inv.paid), T.success], ["Balance Due", fmt(bal), T.danger]]
                  .map(([l, v, c]) => (
                    <div key={l} style={{ background:T.surface, borderRadius:8, padding:"8px 10px" }}>
                      <div style={{ fontSize:9, color:T.textMuted, textTransform:"uppercase", letterSpacing:0.5, marginBottom:2 }}>{l}</div>
                      <div style={{ fontSize:13, fontWeight:800, color:c }}>{v}</div>
                    </div>
                  ))}
              </div>

              {/* Amount input */}
              <div style={{ marginBottom:12 }}>
                <label style={S.label}>Amount Received (XAF)</label>
                <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                  <input
                    type="number"
                    style={{ ...S.input, flex:1, fontSize:16, fontWeight:700 }}
                    value={pmtPanel.amount}
                    onChange={e => setPmtPanel(p => ({ ...p, amount: e.target.value }))}
                    autoFocus
                  />
                  <button style={{ ...S.btn("ghost"), fontSize:11, padding:"5px 10px", whiteSpace:"nowrap" }}
                    onClick={() => setPmtPanel(p => ({ ...p, amount: String(bal) }))}>
                    Full Balance
                  </button>
                </div>
              </div>

              {/* Payment method */}
              <div style={{ marginBottom:16 }}>
                <label style={S.label}>Payment Method</label>
                <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                  {["Mobile Money", "Orange Money", "Cash", "Bank Transfer", "Cheque"].map(m => (
                    <button key={m}
                      style={{ ...S.btn(pmtPanel.method === m ? "primary" : "ghost"), fontSize:11, padding:"4px 12px" }}
                      onClick={() => setPmtPanel(p => ({ ...p, method: m }))}>
                      {m}
                    </button>
                  ))}
                </div>
              </div>

              {/* Quick shortcuts */}
              <div style={{ display:"flex", gap:6, marginBottom:16, flexWrap:"wrap" }}>
                {[50, 100].map(pct => (
                  <button key={pct}
                    style={{ ...S.btn("ghost"), fontSize:10, padding:"3px 10px" }}
                    onClick={() => setPmtPanel(p => ({ ...p, amount: String(Math.round(bal * pct / 100)) }))}>
                    {pct}% ({fmt(Math.round(bal * pct / 100))})
                  </button>
                ))}
              </div>

              {/* Actions */}
              <div style={{ display:"flex", gap:8 }}>
                <button
                  style={{ ...S.btn("primary"), flex:1 }}
                  onClick={() => {
                    const amt = Number(pmtPanel.amount);
                    if (!amt || isNaN(amt) || amt <= 0) return;
                    recordPmt(pmtPanel.idx, amt);
                    // also note the payment method on the invoice
                    setInvoices(prev => prev.map((inv, j) => j === pmtPanel.idx
                      ? { ...inv, lastPaymentMethod: pmtPanel.method, lastPaymentDate: new Date().toISOString().slice(0,10) }
                      : inv
                    ));
                    setPmtPanel(null);
                  }}
                >
                  ✅ Record {pmtPanel.amount ? fmt(Number(pmtPanel.amount)) : ""} via {pmtPanel.method}
                </button>
                <button style={{ ...S.btn("ghost"), padding:"6px 14px" }} onClick={() => setPmtPanel(null)}>Cancel</button>
              </div>
            </div>
          </div>
        );
      })()}

      <div style={S.pageTitle}>🧾 Invoices & Payments</div>
      <div style={S.grid(4)}>
        <KpiCard
          label="AR Outstanding"
          value={fmt(totalAR)}
          color={T.danger}
          icon="⚠️"
        />
        <KpiCard
          label="Total Collected"
          value={fmt(totalPaid)}
          color={T.success}
          icon="✅"
        />
        <KpiCard
          label="Unpaid Invoices"
          value={invoices.filter((i) => i.status === "Unpaid").length}
          color={T.warning}
          icon="📬"
        />
        <KpiCard
          label="Total Invoiced"
          value={fmt(invoices.reduce((s, i) => s + i.total, 0))}
          icon="📄"
        />
      </div>
      <div style={{ marginTop: 14 }}>
        <div className="tbl-wrap">
          <table style={S.table}>
            <thead>
              <tr>
                {[
                  "Invoice #",
                  "Client",
                  "Issued",
                  "Due",
                  "Total",
                  "Paid",
                  "Balance",
                  "OD",
                  "Status",
                  "Documents",
                  "Action",
                ].map((h) => (
                  <th key={h} style={S.th}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {invoices.map((inv, i) => {
                const bal = inv.total - inv.paid;
                const od = daysOD(inv.due);
                const evt = events.find((e) => e.id === inv.eventId);
                return (
                  <tr key={inv.id}>
                    <td
                      style={{
                        ...S.td,
                        fontWeight: 700,
                        color: T.accent,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {inv.num}
                    </td>
                    <td style={{ ...S.td, fontWeight: 700 }}>{inv.client}</td>
                    <td style={{ ...S.td, whiteSpace: "nowrap" }}>
                      {inv.issued}
                    </td>
                    <td style={{ ...S.td, whiteSpace: "nowrap" }}>{inv.due}</td>
                    <td style={{ ...S.td, fontWeight: 600 }}>
                      {fmt(inv.total)}
                    </td>
                    <td style={{ ...S.td, color: T.success }}>
                      {fmt(inv.paid)}
                    </td>
                    <td
                      style={{
                        ...S.td,
                        fontWeight: 700,
                        color: bal > 0 ? T.danger : T.success,
                      }}
                    >
                      {fmt(bal)}
                    </td>
                    <td
                      style={{
                        ...S.td,
                        color: od > 0 ? T.danger : T.success,
                        fontSize: 11,
                      }}
                    >
                      {od > 0 ? `${od}d` : "—"}
                    </td>
                    <td style={S.td}>
                      <Badge color={stColor[inv.status] || T.textMuted}>
                        {inv.status}
                      </Badge>
                    </td>
                    <td style={S.td}>
                      <div style={{ display: "flex", gap: 3 }}>
                        <button
                          style={{
                            ...S.btn("ghost"),
                            fontSize: 10,
                            padding: "3px 7px",
                          }}
                          onClick={() =>
                            openDoc(
                              `Invoice ${inv.num}`,
                              buildInvoiceHTML(inv, evt, biz, logo)
                            )
                          }
                        >
                          📄 Invoice
                        </button>
                        {inv.paid > 0 && (
                          <button
                            style={{
                              ...S.btn("ghost"),
                              fontSize: 10,
                              padding: "3px 7px",
                            }}
                            onClick={() =>
                              openDoc(
                                `Receipt ${inv.num.replace("INV", "RCT")}`,
                                buildReceiptHTML(inv, biz, logo)
                              )
                            }
                          >
                            🧾 Receipt
                          </button>
                        )}
                      </div>
                    </td>
                    <td style={S.td}>
                      {bal > 0 && (
                        <button
                          style={{ ...S.btn("primary"), padding: "3px 8px", fontSize: 11 }}
                          onClick={() => setPmtPanel({ idx: i, amount: String(bal), method: "Mobile Money" })}
                        >
                          + Payment
                        </button>
                      )}
                      {bal <= 0 && inv.status === "Paid" && (
                        <span style={{ fontSize: 10, color: T.success, fontWeight: 700 }}>✅ Paid</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ ...S.card, marginTop: 10 }}>
          <div style={S.cardTitle}>AR Aging Detail</div>
          {invoices
            .filter((i) => i.total - i.paid > 0)
            .map((inv, i) => {
              const bal = inv.total - inv.paid;
              const days = daysOD(inv.due);
              const b = ageBucket(days);
              const bc = {
                Current: T.success,
                "1–7 days": T.warning,
                "8–30 days": T.warning,
                "31–60 days": T.danger,
                "61+ days": T.danger,
              }[b];
              return (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "7px 0",
                    borderBottom: `1px solid ${T.border}15`,
                  }}
                >
                  <div>
                    <span
                      style={{ fontWeight: 700, fontSize: 12, marginRight: 6 }}
                    >
                      {inv.client}
                    </span>
                    <span style={{ fontSize: 11, color: T.textMuted }}>
                      {inv.num}
                    </span>
                  </div>
                  <div
                    style={{ display: "flex", gap: 10, alignItems: "center" }}
                  >
                    <Badge color={bc}>{b}</Badge>
                    <span
                      style={{ fontWeight: 800, color: T.danger, fontSize: 12 }}
                    >
                      {fmt(bal)}
                    </span>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

// ─── CUSTOMERS PAGE ───────────────────────────────────────────────
const CUSTOMER_CLASSES = ["Regular", "VIP", "Wholesale", "Corporate", "Walk-in", "Blacklisted"];

function CustomersPage({ customers, setCustomers, invoices, setInvoices, events, sales, logo, biz }) {
  const [subTab, setSubTab] = useState("list");
  const [selCust, setSelCust] = useState(null);
  const [adding, setAdding] = useState(false);
  const [editId, setEditId] = useState(null);
  const [filterClass, setFilterClass] = useState("All");
  const [searchQ, setSearchQ] = useState("");
  const [doc, setDoc] = useState(null);
  const isMobile = useIsMobile();
  const openDoc = (title, html) => setDoc({ title, html, onPrint: () => printDoc(title, html) });

  const EMPTY_C = { name: "", phone: "", email: "", classification: "Regular", notes: "" };
  const [form, setForm] = useState(EMPTY_C);

  // Invoice state (moved from InvoicesPage)
  const totalAR = invoices.reduce((s, i) => s + (i.total - i.paid), 0);
  const totalPaid = invoices.reduce((s, i) => s + i.paid, 0);
  const recordPmt = (idx, amount) => {
    const u = [...invoices];
    const inv = { ...u[idx] };
    inv.paid = Math.min(inv.paid + Number(amount), inv.total);
    inv.status = inv.paid >= inv.total ? "Paid" : inv.paid > 0 ? "Partially Paid" : "Unpaid";
    u[idx] = inv;
    setInvoices(u);
  };
  const stColor = { Paid: T.success, "Partially Paid": T.warning, Unpaid: T.danger, Cancelled: T.textDim };
  const [arSort, setArSort] = useState("desc"); // "desc" = largest first, "asc" = smallest first

  const filtered = customers.filter(c => {
    if (filterClass !== "All" && c.classification !== filterClass) return false;
    if (searchQ && !c.name.toLowerCase().includes(searchQ.toLowerCase()) && !(c.phone || "").includes(searchQ)) return false;
    return true;
  });

  const saveCustomer = () => {
    if (!form.name.trim()) return;
    const item = { ...form, name: form.name.trim() };
    if (editId != null) {
      setCustomers(prev => prev.map(c => c.id === editId ? { ...item, id: editId } : c));
      setEditId(null);
    } else {
      setCustomers(prev => [...prev, { ...item, id: Date.now(), createdAt: TODAY_ISO }]);
    }
    setAdding(false);
    setForm(EMPTY_C);
  };

  const deleteCustomer = (id) => {
    if (!window.confirm("Delete this customer?")) return;
    setCustomers(prev => prev.filter(c => c.id !== id));
    if (selCust === id) setSelCust(null);
  };

  // Get activity for a customer
  const custSales = (name) => sales.filter(s => s.clientName && s.clientName.toLowerCase() === name.toLowerCase());
  const custEvents = (name) => events.filter(e => e.clientName && e.clientName.toLowerCase() === name.toLowerCase());
  const custInvoices = (name) => invoices.filter(i => i.client && i.client.toLowerCase() === name.toLowerCase());
  const custTotalSpend = (name) => {
    const sTotal = custSales(name).reduce((s, r) => s + orderTotal(r), 0);
    const eTotal = custEvents(name).reduce((s, e) => s + (e.revenue || 0), 0);
    const iTotal = custInvoices(name).reduce((s, i) => s + i.total, 0);
    return sTotal + eTotal + iTotal;
  };

  const classColor = { Regular: T.info, VIP: "#FFD700", Wholesale: T.catering, Corporate: T.accent, "Walk-in": T.textDim, Blacklisted: T.danger };
  const selCustomer = selCust != null ? customers.find(c => c.id === selCust) : null;

  return (
    <div>
      <DocModal doc={doc} onClose={() => setDoc(null)} />
      <div style={S.pageTitle}>👥 Customer Management</div>

      {/* Sub-tabs */}
      <div style={{ ...S.row, marginBottom: 14, flexWrap: "wrap", gap: 6 }}>
        {[["list", "👤 Customers"], ["invoices", "🧾 Invoices & AR"], ["ar", "💳 AR Overview"]].map(([v, l]) => (
          <button key={v} style={{ ...S.btn(subTab === v ? "primary" : "ghost"), fontSize: 13 }} onClick={() => setSubTab(v)}>{l}</button>
        ))}
      </div>

      {/* ── CUSTOMERS LIST ── */}
      {subTab === "list" && (
        <div>
          <div style={{ ...S.row, marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
            <input style={{ ...S.input, width: 200 }} placeholder="Search name or phone…" value={searchQ} onChange={e => setSearchQ(e.target.value)} />
            <select style={S.select} value={filterClass} onChange={e => setFilterClass(e.target.value)}>
              <option value="All">All Types</option>
              {CUSTOMER_CLASSES.map(c => <option key={c}>{c}</option>)}
            </select>
            <button style={S.btn("primary")} onClick={() => { setAdding(true); setEditId(null); setForm(EMPTY_C); }}>+ Add Customer</button>
          </div>

          <div style={S.grid(4)}>
            <KpiCard label="Total Customers" value={customers.length} icon="👥" />
            <KpiCard label="VIP Clients" value={customers.filter(c => c.classification === "VIP").length} color="#FFD700" icon="⭐" />
            <KpiCard label="Corporate" value={customers.filter(c => c.classification === "Corporate").length} color={T.accent} icon="🏢" />
            <KpiCard label="AR Outstanding" value={fmt(totalAR)} color={T.danger} icon="⚠️" />
          </div>

          {adding && (
            <div style={{ ...S.card, marginTop: 12, borderColor: T.accent }}>
              <div style={S.sectionTitle}>{editId ? "Edit Customer" : "New Customer"}</div>
              <div style={S.grid(3)}>
                <div>
                  <label style={S.label}>Name *</label>
                  <input style={S.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Full name" />
                </div>
                <div>
                  <label style={S.label}>Phone</label>
                  <input style={S.input} value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="+237 6XX XXX XXX" />
                </div>
                <div>
                  <label style={S.label}>Email</label>
                  <input style={S.input} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="optional" />
                </div>
                <div>
                  <label style={S.label}>Classification</label>
                  <select style={S.select} value={form.classification} onChange={e => setForm({ ...form, classification: e.target.value })}>
                    {CUSTOMER_CLASSES.map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div style={{ gridColumn: "span 2" }}>
                  <label style={S.label}>Notes</label>
                  <input style={S.input} value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} placeholder="Allergies, preferences, etc." />
                </div>
              </div>
              <div style={{ ...S.row, marginTop: 10, justifyContent: "flex-end", gap: 8 }}>
                <button style={S.btn("ghost")} onClick={() => { setAdding(false); setEditId(null); setForm(EMPTY_C); }}>Cancel</button>
                <button style={S.btn("primary")} onClick={saveCustomer}>Save</button>
              </div>
            </div>
          )}

          {/* Customer detail panel */}
          {selCustomer && (
            <div style={{ ...S.card, marginTop: 12, borderColor: classColor[selCustomer.classification] || T.accent }}>
              <div style={{ ...S.row, justifyContent: "space-between", marginBottom: 8 }}>
                <div>
                  <span style={{ fontWeight: 700, fontSize: 16 }}>{selCustomer.name}</span>
                  {" "}<span style={{ background: classColor[selCustomer.classification] || T.info, color: "#fff", borderRadius: 10, padding: "2px 10px", fontSize: 11, marginLeft: 6 }}>{selCustomer.classification}</span>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <button style={{ ...S.btn("ghost"), fontSize: 11 }} onClick={() => {
                    const allSales = custSales(selCustomer.name);
                    const allInvs = custInvoices(selCustomer.name);
                    // Filter to unpaid only
                    const cSales = allSales.filter(sale => {
                      const tot = orderTotal(sale);
                      const paid = sale.partialPaid !== "" && sale.partialPaid != null ? Number(sale.partialPaid) : tot;
                      return tot - paid > 0;
                    });
                    const cInvs = allInvs.filter(i => i.total - i.paid > 0);
                    const salesAR = cSales.reduce((s, sale) => {
                      const tot = orderTotal(sale); const paid = sale.partialPaid !== "" && sale.partialPaid != null ? Number(sale.partialPaid) : tot; return s + Math.max(0, tot - paid);
                    }, 0);
                    const invoiceAR = cInvs.reduce((s, i) => s + Math.max(0, i.total - i.paid), 0);
                    const totalAR = salesAR + invoiceAR;
                    const { detail: bizDetail } = getBizHTML(biz, logo);
                    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Outstanding Balance — ${selCustomer.name}</title>
<style>body{font-family:sans-serif;color:#111;padding:40px;max-width:800px;margin:0 auto}h1{font-size:22px;margin:0}h2{font-size:14px;font-weight:700;margin:24px 0 8px;border-bottom:2px solid #111;padding-bottom:4px}table{width:100%;border-collapse:collapse;margin-bottom:16px}th{background:#111;color:#fff;padding:7px 10px;font-size:11px;text-align:left}td{padding:7px 10px;border-bottom:1px solid #eee;font-size:12px}.ar{color:#dc2626;font-weight:700}.paid{color:#16a34a;font-weight:600}.total-row{display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #eee;font-size:13px}.grand{font-weight:800;font-size:15px;border-top:2px solid #111;margin-top:4px;padding-top:8px}.badge{display:inline-block;background:#ddd;border-radius:12px;padding:2px 10px;font-size:11px;color:#333;font-weight:600}</style></head><body>
<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px;border-bottom:2px solid #111;padding-bottom:20px">
  <div><div style="font-size:14px;font-weight:700;color:#111">${biz.name || "Cookie's Bites"}</div><div style="font-size:11px;color:#444;margin-top:3px;line-height:1.5">${bizDetail}</div></div>
  <div style="text-align:center"><img src="${(logo?.src || LOGO_SRC)}" alt="logo" style="width:225px;height:225px;object-fit:contain;display:block;margin:0 auto"/></div>
  <div style="text-align:right"><h1 style="color:#dc2626;font-size:18px;margin:0 0 6px">Outstanding Balance Statement</h1><p style="margin:2px 0;color:#444;font-size:12px">${new Date().toLocaleDateString("fr-CM",{day:"2-digit",month:"long",year:"numeric"})}</p><div style="margin-top:8px;border-top:1px solid #eee;padding-top:8px"><strong style="font-size:15px;color:#111">${selCustomer.name}</strong><br/><span class="badge">${selCustomer.classification}</span><br/>${selCustomer.phone ? `<span style="font-size:11px;color:#666">${selCustomer.phone}</span><br/>` : ""}${selCustomer.email ? `<span style="font-size:11px;color:#666">${selCustomer.email}</span>` : ""}</div></div>
</div>
${totalAR > 0 ? `<div style="background:#fff5f5;border:2px solid #dc2626;border-radius:8px;padding:14px 20px;margin-bottom:24px;display:flex;gap:40px;align-items:center">
  <div><div style="font-size:11px;color:#dc2626;font-weight:700;text-transform:uppercase;letter-spacing:1px">Total Amount Owed</div><div style="font-size:28px;font-weight:800;color:#dc2626">${fmt(totalAR)}</div></div>
  ${salesAR > 0 ? `<div><div style="font-size:11px;color:#444;font-weight:700;text-transform:uppercase;letter-spacing:1px">Restaurant Orders</div><div style="font-size:18px;font-weight:700;color:#dc2626">${fmt(salesAR)}</div></div>` : ""}
  ${invoiceAR > 0 ? `<div><div style="font-size:11px;color:#444;font-weight:700;text-transform:uppercase;letter-spacing:1px">Catering Invoices</div><div style="font-size:18px;font-weight:700;color:#dc2626">${fmt(invoiceAR)}</div></div>` : ""}
</div>` : `<div style="background:#f0fff4;border:2px solid #16a34a;border-radius:8px;padding:14px 20px;margin-bottom:24px"><strong style="color:#16a34a;font-size:16px">✅ No outstanding balance — all orders are fully paid.</strong></div>`}
${cSales.length > 0 ? `<h2>Unpaid Restaurant Orders</h2><table><thead><tr><th>Date</th><th>Items</th><th>Plates</th><th>Order Total</th><th>Paid to Date</th><th>Amount Owed</th></tr></thead><tbody>${cSales.map(s => {
  const tot = orderTotal(s); const paid2 = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : 0; const bal2 = tot - paid2;
  const items = Array.isArray(s.items) && s.items.length > 0 ? s.items.map(it => it.meal).join(", ") : s.meal;
  return `<tr><td>${s.date}</td><td>${items}</td><td>${totalPlates(s)}</td><td>${fmt(tot)}</td><td class="paid">${fmt(paid2)}</td><td class="ar">${fmt(bal2)}</td></tr>`;
}).join("")}</tbody></table>` : ""}
${cInvs.length > 0 ? `<h2>Unpaid Catering Invoices</h2><table><thead><tr><th>Invoice #</th><th>Date</th><th>Invoice Total</th><th>Paid to Date</th><th>Amount Owed</th><th>Status</th></tr></thead><tbody>${cInvs.map(inv => {
  const bal3 = inv.total - inv.paid;
  return `<tr><td>${inv.num}</td><td>${inv.issued||""}</td><td>${fmt(inv.total)}</td><td class="paid">${fmt(inv.paid)}</td><td class="ar">${fmt(bal3)}</td><td>${inv.status}</td></tr>`;
}).join("")}</tbody></table>` : ""}
${totalAR > 0 ? `<div style="margin-top:24px;padding:16px;border:2px solid #dc2626;border-radius:8px;background:#fff5f5"><strong style="color:#dc2626;font-size:15px">Total Amount Outstanding: ${fmt(totalAR)}</strong><br/><span style="font-size:12px;color:#666;margin-top:4px;display:block">Please arrange payment at your earliest convenience.</span>${biz.paymentTerms ? `<div style="margin-top:8px">${fmtPaymentTerms(biz.paymentTerms)}</div>` : ""}</div>` : ""}
</body></html>`;
                    openDoc(`Outstanding Balance — ${selCustomer.name}`, html);
                  }}>📄 Statement</button>
                  <button style={S.btn("ghost")} onClick={() => setSelCust(null)}>✕ Close</button>
                </div>
              </div>

              {/* AR Summary */}
              {(() => {
                const cSales = custSales(selCustomer.name);
                const cInvs = custInvoices(selCustomer.name);
                const salesAR = cSales.reduce((s, sale) => { const tot = orderTotal(sale); const paid = sale.partialPaid !== "" && sale.partialPaid != null ? Number(sale.partialPaid) : tot; return s + Math.max(0, tot - paid); }, 0);
                const invoiceAR = cInvs.reduce((s, i) => s + Math.max(0, i.total - i.paid), 0);
                const totalAR = salesAR + invoiceAR;
                const totalSpend = custTotalSpend(selCustomer.name);
                if (totalAR <= 0 && totalSpend <= 0) return null;
                return (
                  <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
                    <div style={{ ...S.card, flex: 1, padding: "10px 14px", minWidth: 130 }}>
                      <div style={S.cardTitle}>Total Spend</div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: T.success }}>{fmt(totalSpend)}</div>
                    </div>
                    <div style={{ ...S.card, flex: 1, padding: "10px 14px", minWidth: 130, borderColor: totalAR > 0 ? T.danger : T.success }}>
                      <div style={S.cardTitle}>Outstanding AR</div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: totalAR > 0 ? T.danger : T.success }}>{totalAR > 0 ? fmt(totalAR) : "✅ Nil"}</div>
                      {totalAR > 0 && salesAR > 0 && invoiceAR > 0 && (
                        <div style={{ fontSize: 10, color: T.textDim, marginTop: 2 }}>Orders: {fmt(salesAR)} · Invoices: {fmt(invoiceAR)}</div>
                      )}
                    </div>
                  </div>
                );
              })()}

              <div style={S.grid(3)}>
                <div><span style={{ color: T.textDim, fontSize: 12 }}>Phone</span><br />{selCustomer.phone || "—"}</div>
                <div><span style={{ color: T.textDim, fontSize: 12 }}>Email</span><br />{selCustomer.email || "—"}</div>
                <div><span style={{ color: T.textDim, fontSize: 12 }}>Since</span><br />{selCustomer.createdAt || "—"}</div>
                <div><span style={{ color: T.textDim, fontSize: 12 }}>Notes</span><br />{selCustomer.notes || "—"}</div>
              </div>
              <div style={S.sectionTitle}>Restaurant Orders ({custSales(selCustomer.name).length})</div>
              {custSales(selCustomer.name).length === 0 ? <div style={{ color: T.textDim, fontSize: 13, marginBottom: 8 }}>No restaurant orders.</div> : (
                <table style={{ ...S.table, marginBottom: 10 }}>
                  <thead><tr>{["Date","Meal","Plates","Total","Paid","Balance","Notes"].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                  <tbody>{custSales(selCustomer.name).map(s => {
                    const tot = orderTotal(s);
                    const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
                    const bal = tot - paid;
                    return <tr key={s.id}>
                      <td style={S.td}>{s.date}</td>
                      <td style={S.td}>{Array.isArray(s.items) && s.items.length > 1 ? s.items.map(it => it.meal).join(", ") : s.meal}</td>
                      <td style={S.td}>{totalPlates(s)}</td>
                      <td style={S.td}>{fmt(tot)}</td>
                      <td style={{ ...S.td, color: T.success }}>{fmt(paid)}</td>
                      <td style={{ ...S.td, color: bal > 0 ? T.danger : T.success, fontWeight: bal > 0 ? 700 : 400 }}>{fmt(bal)}</td>
                      <td style={{ ...S.td, color: T.textDim, fontSize: 12 }}>{s.notes || "—"}</td>
                    </tr>;
                  })}</tbody>
                </table>
              )}
              <div style={S.sectionTitle}>Catering Events ({custEvents(selCustomer.name).length})</div>
              {custEvents(selCustomer.name).length === 0 ? <div style={{ color: T.textDim, fontSize: 13, marginBottom: 8 }}>No catering events.</div> : (
                <table style={{ ...S.table, marginBottom: 10 }}>
                  <thead><tr>{["Date","Event","Guests","Revenue","Phase"].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                  <tbody>{custEvents(selCustomer.name).map(e => (
                    <tr key={e.id}>
                      <td style={S.td}>{e.eventDate}</td>
                      <td style={S.td}>{e.name}</td>
                      <td style={S.td}>{e.guests}</td>
                      <td style={{ ...S.td, color: T.success, fontWeight: 600 }}>{fmt(e.revenue || 0)}</td>
                      <td style={S.td}>{e.phase}</td>
                    </tr>
                  ))}</tbody>
                </table>
              )}
              <div style={S.sectionTitle}>Invoices ({custInvoices(selCustomer.name).length})</div>
              {custInvoices(selCustomer.name).length === 0 ? <div style={{ color: T.textDim, fontSize: 13 }}>No invoices.</div> : (
                <table style={S.table}>
                  <thead><tr>{["Invoice #","Total","Paid","Balance","Status",""].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                  <tbody>{custInvoices(selCustomer.name).map((inv, idx) => {
                    const bal = inv.total - inv.paid;
                    const evt = events.find(e => e.id === inv.eventId);
                    return <tr key={inv.id}>
                      <td style={{ ...S.td, color: T.accent, fontWeight: 700 }}>{inv.num}</td>
                      <td style={S.td}>{fmt(inv.total)}</td>
                      <td style={{ ...S.td, color: T.success }}>{fmt(inv.paid)}</td>
                      <td style={{ ...S.td, color: bal > 0 ? T.danger : T.success, fontWeight: 700 }}>{fmt(bal)}</td>
                      <td style={{ ...S.td, color: stColor[inv.status] }}>{inv.status}</td>
                      <td style={S.td}>
                        <button style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 7px" }}
                          onClick={() => openDoc(`Invoice ${inv.num}`, buildInvoiceHTML(inv, evt, biz, logo))}>
                          🖨 Print
                        </button>
                      </td>
                    </tr>;
                  })}</tbody>
                </table>
              )}
            </div>
          )}

          <div className="tbl-wrap" style={{ marginTop: 12 }}>
            <table style={S.table}>
              <thead>
                <tr>{["Name","Phone","Email","Type","Total Spend","AR Owed","Notes","Actions"].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {filtered.length === 0 && (
                  <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: T.textDim }}>No customers yet — they auto-populate when you record orders.</td></tr>
                )}
                {filtered.map(c => {
                  const arOwed = custInvoices(c.name).reduce((s, i) => s + (i.total - i.paid), 0)
                    + custSales(c.name).reduce((s, sale) => {
                      const tot = orderTotal(sale);
                      const paid = sale.partialPaid !== "" && sale.partialPaid != null ? Number(sale.partialPaid) : tot;
                      return s + (tot - paid);
                    }, 0);
                  return (
                    <tr key={c.id} style={{ cursor: "pointer", background: selCust === c.id ? T.cardHover : "transparent" }}
                      onClick={() => setSelCust(selCust === c.id ? null : c.id)}>
                      <td style={{ ...S.td, fontWeight: 700, color: T.accent }}>{c.name}</td>
                      <td style={S.td}>{c.phone || "—"}</td>
                      <td style={S.td}>{c.email || "—"}</td>
                      <td style={S.td}>
                        <span style={{ background: classColor[c.classification] || T.info, color: c.classification === "VIP" ? "#000" : "#fff", borderRadius: 10, padding: "2px 10px", fontSize: 11 }}>{c.classification}</span>
                      </td>
                      <td style={{ ...S.td, color: T.success, fontWeight: 600 }}>{fmt(custTotalSpend(c.name))}</td>
                      <td style={{ ...S.td, color: arOwed > 0 ? T.danger : T.success, fontWeight: arOwed > 0 ? 700 : 400 }}>{arOwed > 0 ? fmt(arOwed) : "—"}</td>
                      <td style={{ ...S.td, fontSize: 12, color: T.textDim }}>{c.notes || "—"}</td>
                      <td style={S.td} onClick={e => e.stopPropagation()}>
                        <div style={{ display: "flex", gap: 4 }}>
                          <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "2px 8px" }} onClick={() => { setForm({ name: c.name, phone: c.phone || "", email: c.email || "", classification: c.classification, notes: c.notes || "" }); setEditId(c.id); setAdding(true); }}>Edit</button>
                          <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "2px 8px", color: T.danger }} onClick={() => deleteCustomer(c.id)}>Del</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── INVOICES & AR ── */}
      {subTab === "invoices" && (
        <div>
          <div style={S.grid(4)}>
            <KpiCard label="AR Outstanding" value={fmt(totalAR)} color={T.danger} icon="⚠️" />
            <KpiCard label="Total Collected" value={fmt(totalPaid)} color={T.success} icon="✅" />
            <KpiCard label="Unpaid Invoices" value={invoices.filter(i => i.status === "Unpaid").length} color={T.warning} icon="📬" />
            <KpiCard label="Total Invoiced" value={fmt(invoices.reduce((s, i) => s + i.total, 0))} icon="📄" />
          </div>
          <div style={{ marginTop: 14 }}>
            <div className="tbl-wrap">
              <table style={S.table}>
                <thead>
                  <tr>{["Invoice #","Client","Issued","Due","Total","Paid","Balance","OD","Status","Documents","Action"].map(h => (
                    <th key={h} style={S.th}>{h}</th>
                  ))}</tr>
                </thead>
                <tbody>
                  {invoices.map((inv, i) => {
                    const bal = inv.total - inv.paid;
                    const od = daysOD(inv.due);
                    const evt = events.find(e => e.id === inv.eventId);
                    return (
                      <tr key={inv.id}>
                        <td style={{ ...S.td, fontWeight: 700, color: T.accent, whiteSpace: "nowrap" }}>{inv.num}</td>
                        <td style={{ ...S.td, fontWeight: 700 }}>{inv.client}</td>
                        <td style={{ ...S.td, whiteSpace: "nowrap" }}>{inv.issued}</td>
                        <td style={{ ...S.td, whiteSpace: "nowrap" }}>{inv.due}</td>
                        <td style={{ ...S.td, fontWeight: 600 }}>{fmt(inv.total)}</td>
                        <td style={{ ...S.td, color: T.success }}>{fmt(inv.paid)}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: bal > 0 ? T.danger : T.success }}>{fmt(bal)}</td>
                        <td style={{ ...S.td, color: od > 0 ? T.danger : T.success, fontSize: 11 }}>{od > 0 ? `${od}d` : "—"}</td>
                        <td style={S.td}><span style={{ color: stColor[inv.status], fontWeight: 600 }}>{inv.status}</span></td>
                        <td style={S.td}>
                          {evt && (
                            <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "2px 8px" }}
                              onClick={() => openDoc(`Invoice ${inv.num}`, buildInvoiceHTML(inv, evt, biz, logo))}>
                              Invoice
                            </button>
                          )}
                        </td>
                        <td style={S.td}>
                          {bal > 0 && (
                            <button style={{ ...S.btn("primary"), fontSize: 11, padding: "2px 8px" }}
                              onClick={() => {
                                const a = window.prompt(`Record payment for ${inv.client}\nBalance: ${fmt(bal)}\n\nEnter amount (XAF):`);
                                if (a && !isNaN(Number(a))) recordPmt(i, a);
                              }}>
                              + Pmt
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* ── AR OVERVIEW (Restaurant partial payments) ── */}
      {subTab === "ar" && (() => {
        const arSales = sales.filter(s => {
          if (!s.clientName) return false;
          const tot = orderTotal(s);
          const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
          return tot - paid > 0;
        });
        const totalRestAR = arSales.reduce((s, sale) => {
          const tot = orderTotal(sale);
          const paid = sale.partialPaid !== "" && sale.partialPaid != null ? Number(sale.partialPaid) : tot;
          return s + (tot - paid);
        }, 0);
        const sortMult = arSort === "desc" ? -1 : 1;
        const sortedArSales = [...arSales].sort((a, b) => {
          const balA = orderTotal(a) - (a.partialPaid !== "" && a.partialPaid != null ? Number(a.partialPaid) : orderTotal(a));
          const balB = orderTotal(b) - (b.partialPaid !== "" && b.partialPaid != null ? Number(b.partialPaid) : orderTotal(b));
          return sortMult * (balB - balA);
        });
        const sortedInvoices = [...invoices.filter(i => i.status !== "Paid" && i.status !== "Cancelled")]
          .sort((a, b) => sortMult * ((b.total - b.paid) - (a.total - a.paid)));
        const sortIcon = arSort === "desc" ? " ↓" : " ↑";
        const balThStyle = { ...S.th, cursor: "pointer", userSelect: "none", color: T.accent };
        return (
          <div>
            <div style={S.grid(3)}>
              <KpiCard label="Restaurant AR" value={fmt(totalRestAR)} color={T.danger} icon="🍽️" />
              <KpiCard label="Catering AR" value={fmt(totalAR)} color={T.warning} icon="🎉" />
              <KpiCard label="Total Outstanding" value={fmt(totalRestAR + totalAR)} color={T.danger} icon="⚠️" />
            </div>
            <div style={S.sectionTitle}>Restaurant — Partial Payments Outstanding</div>
            {sortedArSales.length === 0 ? (
              <div style={{ color: T.textDim, padding: 16 }}>No outstanding restaurant balances.</div>
            ) : (
              <div className="tbl-wrap">
                <table style={S.table}>
                  <thead><tr>
                    {["Date","Client","Meal","Plates","Order Total","Paid"].map(h => <th key={h} style={S.th}>{h}</th>)}
                    <th style={balThStyle} onClick={() => setArSort(s => s === "desc" ? "asc" : "desc")}>Balance{sortIcon}</th>
                    <th style={S.th}>Notes</th>
                  </tr></thead>
                  <tbody>
                    {sortedArSales.map(s => {
                      const tot = orderTotal(s);
                      const paid = s.partialPaid !== "" && s.partialPaid != null ? Number(s.partialPaid) : tot;
                      const bal = tot - paid;
                      return (
                        <tr key={s.id}>
                          <td style={S.td}>{s.date}</td>
                          <td style={{ ...S.td, fontWeight: 700 }}>{s.clientName}</td>
                          <td style={S.td}>{s.meal}</td>
                          <td style={S.td}>{totalPlates(s)}</td>
                          <td style={S.td}>{fmt(tot)}</td>
                          <td style={{ ...S.td, color: T.success }}>{fmt(paid)}</td>
                          <td style={{ ...S.td, color: T.danger, fontWeight: 700 }}>{fmt(bal)}</td>
                          <td style={{ ...S.td, fontSize: 12, color: T.textDim }}>{s.notes || "—"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
            <div style={{ ...S.sectionTitle, marginTop: 18 }}>Catering — Unpaid / Partial Invoices</div>
            {sortedInvoices.length === 0 ? (
              <div style={{ color: T.textDim, padding: 16 }}>No outstanding catering invoices.</div>
            ) : (
              <div className="tbl-wrap">
                <table style={S.table}>
                  <thead><tr>
                    {["Invoice #","Client","Due","Total","Paid"].map(h => <th key={h} style={S.th}>{h}</th>)}
                    <th style={balThStyle} onClick={() => setArSort(s => s === "desc" ? "asc" : "desc")}>Balance{sortIcon}</th>
                    <th style={S.th}>Status</th>
                  </tr></thead>
                  <tbody>
                    {sortedInvoices.map(inv => {
                      const bal = inv.total - inv.paid;
                      return (
                        <tr key={inv.id}>
                          <td style={{ ...S.td, color: T.accent, fontWeight: 700 }}>{inv.num}</td>
                          <td style={{ ...S.td, fontWeight: 700 }}>{inv.client}</td>
                          <td style={S.td}>{inv.due}</td>
                          <td style={S.td}>{fmt(inv.total)}</td>
                          <td style={{ ...S.td, color: T.success }}>{fmt(inv.paid)}</td>
                          <td style={{ ...S.td, color: T.danger, fontWeight: 700 }}>{fmt(bal)}</td>
                          <td style={{ ...S.td, color: stColor[inv.status] }}>{inv.status}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })()}
    </div>
  );
}

// ─── VENDORS PAGE ─────────────────────────────────────────────────
function VendorsPage({ overheads, setOverheads, vendors, setVendors }) {
  const [subTab, setSubTab] = useState("directory");
  const [adding, setAdding] = useState(false);
  const [editId, setEditId] = useState(null);
  const [searchQ, setSearchQ] = useState("");
  const EMPTY_V = { name: "", phone: "", email: "", category: "Other", notes: "" };
  const [form, setForm] = useState(EMPTY_V);

  const VENDOR_CATS = ["Other", "Produce & Ingredients", "Meat & Seafood", "Beverages",
    "Packaging", "Equipment", "Utilities", "Transport & Logistics",
    "Cleaning & Supplies", "Staffing", "Marketing", "Professional Services"];

  const filteredVendors = vendors.filter(v =>
    !searchQ ||
    v.name.toLowerCase().includes(searchQ.toLowerCase()) ||
    (v.phone || "").includes(searchQ) ||
    (v.category || "").toLowerCase().includes(searchQ.toLowerCase())
  );

  const saveVendor = () => {
    if (!form.name.trim()) return;
    const item = { ...form, name: form.name.trim() };
    if (editId != null) {
      setVendors(prev => prev.map(v => v.id === editId ? { ...item, id: editId } : v));
      setEditId(null);
    } else {
      setVendors(prev => [...prev, { ...item, id: Date.now(), createdAt: TODAY_ISO }]);
    }
    setAdding(false);
    setForm(EMPTY_V);
  };

  const deleteVendor = (id) => {
    if (!window.confirm("Delete this vendor?")) return;
    setVendors(prev => prev.filter(v => v.id !== id));
  };

  // Spending per vendor derived from overheads
  const vendorSpend = (name) =>
    overheads
      .filter(o => (o.vendor || "").toLowerCase() === name.toLowerCase())
      .reduce((s, o) => s + Number(o.amount || 0), 0);

  const vendorPurchases = (name) =>
    overheads.filter(o => (o.vendor || "").toLowerCase() === name.toLowerCase());

  return (
    <div>
      <div style={S.pageTitle}>🏪 Vendors & Expenses</div>

      <div style={{ display: "flex", gap: 3, marginBottom: 14, flexWrap: "wrap" }}>
        {[["directory", "🏪 Vendor Directory"], ["expenses", "📋 Expense Ledger"]].map(([t, l]) => (
          <button key={t} style={S.navBtn(subTab === t)} onClick={() => setSubTab(t)}>{l}</button>
        ))}
      </div>

      {subTab === "directory" && (
        <div>
          <div style={S.grid(3)}>
            <div style={S.card}>
              <div style={S.cardTitle}>Total Vendors</div>
              <div style={{ ...S.kpi }}>{vendors.length}</div>
              <div style={S.kpiSub}>suppliers & payees</div>
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>Total Purchases (YTD)</div>
              <div style={{ ...S.kpi, color: T.danger }}>
                {fmt(overheads.filter(o => o.date && o.date.startsWith(String(THIS_YEAR))).reduce((s, o) => s + Number(o.amount || 0), 0))}
              </div>
              <div style={S.kpiSub}>all expense types</div>
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>Active Vendors (YTD)</div>
              <div style={{ ...S.kpi, color: T.accent }}>
                {new Set(overheads.filter(o => o.date && o.date.startsWith(String(THIS_YEAR)) && o.vendor).map(o => (o.vendor || "").toLowerCase())).size}
              </div>
              <div style={S.kpiSub}>with purchases this year</div>
            </div>
          </div>

          <div style={{ display: "flex", gap: 8, margin: "12px 0", flexWrap: "wrap", alignItems: "center" }}>
            <input
              style={{ ...S.input, flex: 1, minWidth: 180, maxWidth: 300 }}
              placeholder="Search vendors…"
              value={searchQ}
              onChange={e => setSearchQ(e.target.value)}
            />
            <button style={S.btn("primary")} onClick={() => { setAdding(true); setEditId(null); setForm(EMPTY_V); }}>
              + Add Vendor
            </button>
          </div>

          {adding && (
            <div style={{ ...S.card, marginBottom: 12 }}>
              <div style={S.sectionTitle}>{editId ? "Edit Vendor" : "New Vendor"}</div>
              <div style={S.grid(2)}>
                <div>
                  <label style={S.label}>Vendor / Supplier Name *</label>
                  <input style={S.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Marché Central Douala" />
                </div>
                <div>
                  <label style={S.label}>Category</label>
                  <select style={S.input} value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}>
                    {VENDOR_CATS.map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div>
                  <label style={S.label}>Phone</label>
                  <input style={S.input} value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="+237 6XX XXX XXX" />
                </div>
                <div>
                  <label style={S.label}>Email</label>
                  <input style={S.input} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="vendor@email.com" />
                </div>
              </div>
              <div style={{ marginTop: 8 }}>
                <label style={S.label}>Notes</label>
                <input style={S.input} value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} placeholder="Payment terms, delivery days, contact person…" />
              </div>
              <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
                <button style={S.btn("primary")} onClick={saveVendor}>Save Vendor</button>
                <button style={S.btn("ghost")} onClick={() => { setAdding(false); setEditId(null); setForm(EMPTY_V); }}>Cancel</button>
              </div>
            </div>
          )}

          <div className="tbl-wrap">
            <table style={S.table}>
              <thead>
                <tr>
                  {["Vendor Name", "Category", "Phone", "Email", "Total Purchases", "# Transactions", "Notes", "Actions"].map(h => (
                    <th key={h} style={S.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredVendors.length === 0 ? (
                  <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: T.textDim }}>
                    No vendors yet — they auto-populate when you record purchases.
                  </td></tr>
                ) : filteredVendors.map(v => (
                  <tr key={v.id}>
                    <td style={{ ...S.td, fontWeight: 700, color: T.accent }}>{v.name}</td>
                    <td style={S.td}>{v.category || "—"}</td>
                    <td style={S.td}>{v.phone || "—"}</td>
                    <td style={S.td}>{v.email || "—"}</td>
                    <td style={{ ...S.td, fontWeight: 700, color: T.danger }}>{fmt(vendorSpend(v.name))}</td>
                    <td style={{ ...S.td, textAlign: "center" }}>{vendorPurchases(v.name).length}</td>
                    <td style={{ ...S.td, color: T.textMuted, fontSize: 12 }}>{v.notes || "—"}</td>
                    <td style={S.td}>
                      <div style={{ display: "flex", gap: 4 }}>
                        <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "2px 8px" }}
                          onClick={() => { setForm({ ...v }); setEditId(v.id); setAdding(true); }}>Edit</button>
                        <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "2px 8px", color: T.danger }}
                          onClick={() => deleteVendor(v.id)}>Del</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {subTab === "expenses" && (
        <OverheadsPage overheads={overheads} setOverheads={setOverheads} vendors={vendors} setVendors={setVendors} />
      )}
    </div>
  );
}

// ─── OVERHEAD EXPENSES PAGE ───────────────────────────────────────
function OverheadsPage({ overheads, setOverheads, vendors, setVendors }) {
  const [subTab, setSubTab] = useState("list");
  const [adding, setAdding] = useState(false);
  const [editId, setEditId] = useState(null);
  const EMPTY_OH = {
    date: TODAY_ISO,
    category: "Rent & Premises",
    description: "",
    amount: "",
    frequency: "Monthly",
    vendor: "",
    entryType: "opex",
    paymentStatus: "paid",
    assetName: "",
  };
  const [form, setForm] = useState(EMPTY_OH);
  const [filterCat, setFilterCat] = useState("All");
  const [filterYear, setFilterYear] = useState(String(THIS_YEAR));
  const [filterMonth, setFilterMonth] = useState("All");
  const [filterDesc, setFilterDesc] = useState("");
  const [filterExpDate, setFilterExpDate] = useState("");
  const isMobile = useIsMobile();

  const years = [...new Set(overheads.map((o) => o.date.slice(0, 4)))]
    .sort()
    .reverse();
  const months = [
    "All",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const monthNames = {
    "01": "Jan",
    "02": "Feb",
    "03": "Mar",
    "04": "Apr",
    "05": "May",
    "06": "Jun",
    "07": "Jul",
    "08": "Aug",
    "09": "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
    All: "All",
  };

  const filtered = overheads.filter((o) => {
    if (filterCat !== "All" && o.category !== filterCat) return false;
    if (filterYear !== "All" && !o.date.startsWith(filterYear)) return false;
    if (filterMonth !== "All" && o.date.slice(5, 7) !== filterMonth) return false;
    if (filterDesc.trim()) {
      const q = filterDesc.trim().toLowerCase();
      const descMatch = (o.description || "").toLowerCase().includes(q);
      const vendorMatch = (o.vendor || "").toLowerCase().includes(q);
      if (!descMatch && !vendorMatch) return false;
    }
    if (filterExpDate && o.date !== filterExpDate) return false;
    return true;
  });

  const totalFiltered = filtered.reduce((s, o) => s + Number(o.amount), 0);

  // Summary stats — only opex counts as "overhead expenses" for P&L
  const opexYTD = overheads.filter(
    (o) => o.date.startsWith("2026") && (o.entryType || "opex") === "opex"
  );
  const capexYTD = overheads.filter(
    (o) => o.date.startsWith("2026") && o.entryType === "capex"
  );
  const liabYTD = overheads.filter(
    (o) => o.date.startsWith("2026") && o.entryType === "liability_payment"
  );
  const totalYTD = opexYTD.reduce((s, o) => s + Number(o.amount), 0);
  const totalCapexYTD = capexYTD.reduce((s, o) => s + Number(o.amount), 0);
  const totalLiabYTD = liabYTD.reduce((s, o) => s + Number(o.amount), 0);
  const apTotal = overheads
    .filter((o) => o.paymentStatus === "unpaid")
    .reduce((s, o) => s + Number(o.amount), 0);
  const byCategory = {};
  opexYTD.forEach((o) => {
    byCategory[o.category] = (byCategory[o.category] || 0) + Number(o.amount);
  });
  const sortedCats = Object.entries(byCategory).sort((a, b) => b[1] - a[1]);

  const saveOverhead = () => {
    if (!form.description || !form.amount) return;
    const item = { ...form, amount: Number(form.amount) };
    if (editId != null) {
      setOverheads((prev) =>
        prev.map((o) => (o.id === editId ? { ...item, id: editId } : o))
      );
      setEditId(null);
    } else {
      setOverheads((prev) => [...prev, { ...item, id: Date.now() }]);
    }
    setAdding(false);
    setForm(EMPTY_OH);
    // Auto-upsert vendor from purchase entry
    if (form.vendor && form.vendor.trim() && setVendors) {
      const vname = form.vendor.trim();
      setVendors(prev => {
        const idx = prev.findIndex(v => v.name.toLowerCase() === vname.toLowerCase());
        if (idx >= 0) return prev;
        return [...prev, { id: Date.now() + 1, name: vname, phone: "", email: "", category: form.category || "Other", notes: "", createdAt: form.date || TODAY_ISO }];
      });
    }
  };
  const startEdit = (o) => {
    setForm({ ...o, amount: String(o.amount) });
    setEditId(o.id);
    setAdding(true);
    setSubTab("list");
  };
  const deleteItem = (id) =>
    setOverheads((prev) => prev.filter((o) => o.id !== id));

  const catColors = {
    "Rent & Premises": T.catering,
    Utilities: T.delivery,
    Personnel: T.accent,
    Transportation: T.restaurant,
    Marketing: T.info,
    Equipment: T.warning,
    Insurance: "#9A7AD4",
    "Professional Fees": "#4AD4C0",
    Subscriptions: "#D4A44A",
    Maintenance: "#7AD44A",
    Other: T.textMuted,
  };

  return (
    <div>
      <div style={S.pageTitle}>🏢 Expenses, Assets & Liabilities</div>
      <div style={S.subtitle}>
        Track operating expenses, asset purchases, and liability payments — each
        flows correctly to P&L, Balance Sheet & Cash Flows
      </div>

      <div style={{ display: "flex", gap: 3, marginBottom: 14 }}>
        {[
          ["list", "📋 Expense Ledger"],
          ["summary", "📊 Expenses Summary"],
        ].map(([t, label]) => (
          <button
            key={t}
            style={S.navBtn(subTab === t)}
            onClick={() => setSubTab(t)}
          >
            {label}
          </button>
        ))}
      </div>

      {/* ── SUMMARY SUB-TAB ── */}
      {subTab === "summary" && (
        <div>
          <div style={S.grid(3)}>
            <div style={S.card}>
              <div style={S.cardTitle}>Operating Expenses (YTD)</div>
              <div style={{ ...S.kpi, color: T.danger }}>{fmt(totalYTD)}</div>
              <div style={S.kpiSub}>Jan – Feb 2026 · hits P&L</div>
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>Asset Purchases (YTD)</div>
              <div style={{ ...S.kpi, color: T.warning }}>
                {fmt(totalCapexYTD)}
              </div>
              <div style={S.kpiSub}>
                {capexYTD.length} items · on Balance Sheet
              </div>
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>Accounts Payable (unpaid)</div>
              <div
                style={{ ...S.kpi, color: apTotal > 0 ? T.danger : T.success }}
              >
                {fmt(apTotal)}
              </div>
              <div style={S.kpiSub}>Across all entry types</div>
            </div>
          </div>

          <div style={{ ...S.grid(2), marginTop: 10 }}>
            <div style={S.card}>
              <div style={S.cardTitle}>By Category (YTD 2026)</div>
              {sortedCats.map(([cat, amt]) => (
                <div key={cat} style={{ marginBottom: 10 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 3,
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 6 }}
                    >
                      <div
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: 2,
                          background: catColors[cat] || T.textMuted,
                          flexShrink: 0,
                        }}
                      />
                      <span style={{ fontSize: 11, fontWeight: 600 }}>
                        {cat}
                      </span>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: catColors[cat] || T.text,
                        }}
                      >
                        {fmt(amt)}
                      </span>
                      <span
                        style={{
                          fontSize: 10,
                          color: T.textMuted,
                          marginLeft: 6,
                        }}
                      >
                        {totalYTD ? ((amt / totalYTD) * 100).toFixed(0) : 0}%
                      </span>
                    </div>
                  </div>
                  <PBar
                    pct={totalYTD ? (amt / totalYTD) * 100 : 0}
                    color={catColors[cat] || T.textMuted}
                  />
                </div>
              ))}
            </div>

            <div style={S.card}>
              <div style={S.cardTitle}>Monthly Breakdown (2026)</div>
              {["01", "02"].map((mo) => {
                const moTotal = overheads
                  .filter(
                    (o) =>
                      o.date.startsWith(`2026-${mo}`) &&
                      (o.entryType || "opex") === "opex"
                  )
                  .reduce((s, o) => s + Number(o.amount), 0);
                const moCats = {};
                overheads
                  .filter(
                    (o) =>
                      o.date.startsWith(`2026-${mo}`) &&
                      (o.entryType || "opex") === "opex"
                  )
                  .forEach((o) => {
                    moCats[o.category] =
                      (moCats[o.category] || 0) + Number(o.amount);
                  });
                return (
                  <div
                    key={mo}
                    style={{
                      marginBottom: 14,
                      paddingBottom: 14,
                      borderBottom: `1px solid ${T.border}`,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 6,
                      }}
                    >
                      <div style={{ fontSize: 12, fontWeight: 700 }}>
                        {monthNames[mo]} 2026
                      </div>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 800,
                          color: T.danger,
                        }}
                      >
                        {fmt(moTotal)}
                      </div>
                    </div>
                    {Object.entries(moCats)
                      .sort((a, b) => b[1] - a[1])
                      .map(([cat, amt]) => (
                        <div
                          key={cat}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: 10,
                            padding: "2px 0",
                          }}
                        >
                          <span style={{ color: T.textMuted }}>{cat}</span>
                          <span style={{ color: T.text, fontWeight: 600 }}>
                            {fmt(amt)}
                          </span>
                        </div>
                      ))}
                  </div>
                );
              })}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: 800,
                  fontSize: 12,
                }}
              >
                <span>TOTAL YTD</span>
                <span style={{ color: T.danger }}>{fmt(totalYTD)}</span>
              </div>
            </div>
          </div>

          {/* Frequency breakdown */}
          <div style={{ ...S.card, marginTop: 10 }}>
            <div style={S.cardTitle}>By Frequency Type (YTD)</div>
            <div style={S.grid(4)}>
              {OVERHEAD_FREQ.map((freq) => {
                const amt = overheads
                  .filter(
                    (o) =>
                      o.frequency === freq &&
                      o.date.startsWith("2026") &&
                      (o.entryType || "opex") === "opex"
                  )
                  .reduce((s, o) => s + Number(o.amount), 0);
                return amt > 0 ? (
                  <div
                    key={freq}
                    style={{
                      background: T.surface,
                      borderRadius: 7,
                      padding: 10,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 10,
                        color: T.textMuted,
                        marginBottom: 3,
                      }}
                    >
                      {freq}
                    </div>
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 800,
                        color: T.warning,
                      }}
                    >
                      {fmt(amt)}
                    </div>
                  </div>
                ) : null;
              })}
            </div>
          </div>
        </div>
      )}

      {/* ── LIST SUB-TAB ── */}
      {subTab === "list" && (
        <>
          {/* Filters & add */}
          <div style={{ ...S.row, marginBottom: 10, flexWrap: "wrap", gap: 6 }}>
            <select
              style={{ ...S.select, width: 150 }}
              value={filterCat}
              onChange={(e) => setFilterCat(e.target.value)}
            >
              <option value="All">All Categories</option>
              {OVERHEAD_CATS.map((c) => (
                <option key={c}>{c}</option>
              ))}
              {OVERHEAD_ASSET_CATS.map((c) => (
                <option key={c}>{c}</option>
              ))}
            </select>
            <select
              style={{ ...S.select, width: 90 }}
              value={filterYear}
              onChange={(e) => setFilterYear(e.target.value)}
            >
              <option value="All">All Years</option>
              {years.map((y) => (
                <option key={y}>{y}</option>
              ))}
            </select>
            <select
              style={{ ...S.select, width: 90 }}
              value={filterMonth}
              onChange={(e) => setFilterMonth(e.target.value)}
            >
              {months.map((m) => (
                <option key={m} value={m}>
                  {monthNames[m]}
                </option>
              ))}
            </select>
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <input
                type="text"
                placeholder="🔍 Search description / vendor…"
                style={{ ...S.input, marginBottom: 0, width: 210, fontSize: 12, paddingRight: filterDesc ? 24 : 8 }}
                value={filterDesc}
                onChange={e => setFilterDesc(e.target.value)}
              />
              {filterDesc && (
                <button
                  onClick={() => setFilterDesc("")}
                  style={{ position: "absolute", right: 4, background: "none", border: "none", cursor: "pointer", color: T.textDim, fontSize: 13, padding: "0 2px", lineHeight: 1 }}
                >✕</button>
              )}
            </div>
            <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
              <input
                type="date"
                style={{ ...S.input, marginBottom: 0, fontSize: 11, padding: "3px 7px", width: 140 }}
                value={filterExpDate}
                onChange={e => setFilterExpDate(e.target.value)}
              />
              {filterExpDate && (
                <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "3px 7px" }} onClick={() => setFilterExpDate("")}>✕</button>
              )}
            </div>
            <div style={{ flex: 1 }} />
            <div
              style={{ fontSize: 11, color: T.textMuted, alignSelf: "center" }}
            >
              {filtered.length} items ·{" "}
              <strong style={{ color: T.danger }}>{fmt(totalFiltered)}</strong>
            </div>
            <button
              style={S.btn("primary")}
              onClick={() => {
                setAdding(!adding);
                setEditId(null);
                setForm(EMPTY_OH);
              }}
            >
              {adding && !editId ? "Cancel" : "+ Add Entry"}
            </button>
          </div>

          {adding && (
            <div style={{ ...S.card, marginBottom: 12, borderColor: T.accent }}>
              <div style={S.sectionTitle}>
                {editId ? "✏️ Edit Entry" : "➕ New Entry"}
              </div>

              {/* Entry Type Selector */}
              <div style={{ marginBottom: 14 }}>
                <label style={S.label}>Entry Type</label>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                  {ENTRY_TYPES.map((et) => (
                    <button
                      key={et.value}
                      onClick={() =>
                        setForm({
                          ...form,
                          entryType: et.value,
                          category:
                            et.value === "capex" ? "Equipment" : form.category,
                        })
                      }
                      style={{
                        ...S.btn(
                          form.entryType === et.value ? "primary" : "ghost"
                        ),
                        fontSize: 11,
                        padding: "6px 12px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        minHeight: "auto",
                        height: "auto",
                      }}
                    >
                      <span style={{ fontWeight: 700 }}>
                        {et.icon} {et.label}
                      </span>
                      <span
                        style={{
                          fontSize: 10,
                          fontWeight: 400,
                          opacity: 0.75,
                          marginTop: 2,
                          textAlign: "left",
                        }}
                      >
                        {et.desc}
                      </span>
                    </button>
                  ))}
                </div>
              </div>

              <div style={S.grid(3)}>
                <div>
                  <label style={S.label}>Date</label>
                  <input
                    type="date"
                    style={S.input}
                    value={form.date}
                    onChange={(e) => setForm({ ...form, date: e.target.value })}
                  />
                </div>
                <div>
                  <label style={S.label}>
                    {form.entryType === "capex" ? "Asset Category" : "Category"}
                  </label>
                  <select
                    style={S.select}
                    value={form.category}
                    onChange={(e) =>
                      setForm({ ...form, category: e.target.value })
                    }
                  >
                    {(form.entryType === "capex"
                      ? OVERHEAD_ASSET_CATS
                      : OVERHEAD_CATS
                    ).map((c) => (
                      <option key={c}>{c}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={S.label}>Frequency</label>
                  <select
                    style={S.select}
                    value={form.frequency}
                    onChange={(e) =>
                      setForm({ ...form, frequency: e.target.value })
                    }
                  >
                    {OVERHEAD_FREQ.map((f) => (
                      <option key={f}>{f}</option>
                    ))}
                  </select>
                </div>
                <div
                  style={{
                    gridColumn: form.entryType === "capex" ? "1" : "span 2",
                  }}
                >
                  <label style={S.label}>Description</label>
                  <input
                    style={S.input}
                    value={form.description}
                    onChange={(e) =>
                      setForm({ ...form, description: e.target.value })
                    }
                    placeholder={
                      form.entryType === "capex"
                        ? "e.g. Industrial blender purchase"
                        : form.entryType === "liability_payment"
                        ? "e.g. Payment – supplier balance / loan instalment"
                        : "e.g. Monthly rent – Office/Premises"
                    }
                  />
                </div>
                {form.entryType === "capex" && (
                  <div>
                    <label style={S.label}>Asset Name (for register)</label>
                    <input
                      style={S.input}
                      value={form.assetName}
                      onChange={(e) =>
                        setForm({ ...form, assetName: e.target.value })
                      }
                      placeholder="e.g. Gas Cooker, Chest Freezer"
                    />
                  </div>
                )}
                <div>
                  <label style={S.label}>Amount (XAF)</label>
                  <input
                    type="number"
                    min="0"
                    style={{ ...S.input, color: T.danger, fontWeight: 700 }}
                    value={form.amount}
                    onChange={(e) =>
                      setForm({ ...form, amount: e.target.value })
                    }
                    placeholder="0"
                  />
                </div>
                <div style={{ gridColumn: "span 2" }}>
                  <label style={S.label}>Vendor / Payee</label>
                  <input
                    style={S.input}
                    value={form.vendor}
                    onChange={(e) =>
                      setForm({ ...form, vendor: e.target.value })
                    }
                    placeholder="e.g. ENEO, Propriétaire, Fournisseur Bassa..."
                  />
                </div>
                <div>
                  <label style={S.label}>Payment Status</label>
                  <div style={{ display: "flex", gap: 6, marginTop: 4 }}>
                    {[
                      ["paid", "✅ Paid"],
                      ["unpaid", "⏳ Unpaid / AP"],
                    ].map(([v, l]) => (
                      <button
                        key={v}
                        onClick={() => setForm({ ...form, paymentStatus: v })}
                        style={{
                          ...S.btn(
                            form.paymentStatus === v
                              ? v === "paid"
                                ? "success"
                                : "danger"
                              : "ghost"
                          ),
                          fontSize: 11,
                          flex: 1,
                        }}
                      >
                        {l}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
              <div
                style={{ ...S.row, marginTop: 10, justifyContent: "flex-end" }}
              >
                <button
                  style={S.btn("ghost")}
                  onClick={() => {
                    setAdding(false);
                    setEditId(null);
                    setForm(EMPTY_OH);
                  }}
                >
                  Cancel
                </button>
                <button style={S.btn("primary")} onClick={saveOverhead}>
                  {editId ? "Update" : "Save"}
                </button>
              </div>
            </div>
          )}

          {/* Table / Cards */}
          {isMobile ? (
            <div>
              {[...filtered]
                .sort((a, b) => b.date.localeCompare(a.date))
                .map((o) => {
                  const et = ENTRY_TYPES.find(
                    (e) => e.value === (o.entryType || "opex")
                  );
                  return (
                    <div
                      key={o.id}
                      style={{ ...S.cardMobile, marginBottom: 8 }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          marginBottom: 4,
                        }}
                      >
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              fontSize: 12,
                              fontWeight: 700,
                              marginBottom: 2,
                            }}
                          >
                            {o.description}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: 4,
                              flexWrap: "wrap",
                            }}
                          >
                            <span
                              style={{
                                ...S.badge(
                                  et?.value === "capex"
                                    ? T.warning
                                    : et?.value === "liability_payment"
                                    ? T.info
                                    : T.textMuted
                                ),
                                fontSize: 9,
                              }}
                            >
                              {et?.icon}{" "}
                              {et?.value === "opex"
                                ? "Expense"
                                : et?.value === "capex"
                                ? "Asset"
                                : "Liab.Pay"}
                            </span>
                            <span
                              style={{
                                ...S.badge(
                                  catColors[o.category] || T.textMuted
                                ),
                                fontSize: 9,
                              }}
                            >
                              {o.category}
                            </span>
                          </div>
                        </div>
                        <div
                          style={{
                            textAlign: "right",
                            flexShrink: 0,
                            marginLeft: 8,
                          }}
                        >
                          <div
                            style={{
                              fontSize: 14,
                              fontWeight: 800,
                              color:
                                o.entryType === "capex"
                                  ? T.warning
                                  : o.entryType === "liability_payment"
                                  ? T.info
                                  : T.danger,
                            }}
                          >
                            {fmt(o.amount)}
                          </div>
                          <Badge
                            color={
                              o.paymentStatus === "unpaid"
                                ? T.danger
                                : T.success
                            }
                          >
                            {o.paymentStatus === "unpaid" ? "Unpaid" : "Paid"}
                          </Badge>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: 10,
                          color: T.textMuted,
                        }}
                      >
                        <span>
                          {o.date}
                          {o.vendor ? ` · ${o.vendor}` : ""}
                        </span>
                        <Badge color={T.textMuted}>{o.frequency}</Badge>
                      </div>
                      <div style={{ display: "flex", gap: 5, marginTop: 6 }}>
                        <button
                          style={{ ...S.btn("ghost"), fontSize: 10, padding: "3px 8px" }}
                          onClick={() => startEdit(o)}
                        >✏️ Edit</button>
                        <button
                          style={{ ...S.btn("ghost"), fontSize: 10, padding: "3px 8px" }}
                          onClick={() => {
                            const copy = { ...o, id: Date.now(), date: TODAY_ISO };
                            setOverheads(prev => [...prev, copy]);
                            startEdit(copy);
                          }}
                        >⧉ Duplicate</button>
                        <button
                          style={{ ...S.btn("ghost"), fontSize: 10, padding: "3px 8px", color: T.danger }}
                          onClick={() => deleteItem(o.id)}
                        >✕</button>
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <div className="tbl-wrap">
                <table style={S.table}>
                  <thead>
                    <tr>
                      {[
                        "Date",
                        "Type",
                        "Category",
                        "Description",
                        "Vendor",
                        "Freq",
                        "Amount (XAF)",
                        "Status",
                        "",
                      ].map((h) => (
                        <th key={h} style={S.th}>
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {[...filtered]
                      .sort((a, b) => b.date.localeCompare(a.date))
                      .map((o) => {
                        const et = ENTRY_TYPES.find(
                          (e) => e.value === (o.entryType || "opex")
                        );
                        return (
                          <tr key={o.id}>
                            <td
                              style={{
                                ...S.td,
                                whiteSpace: "nowrap",
                                color: T.textMuted,
                              }}
                            >
                              {o.date}
                            </td>
                            <td style={S.td}>
                              <span
                                style={{
                                  ...S.badge(
                                    et?.value === "capex"
                                      ? T.warning
                                      : et?.value === "liability_payment"
                                      ? T.info
                                      : T.textMuted
                                  ),
                                  fontSize: 10,
                                }}
                              >
                                {et?.icon}{" "}
                                {et?.value === "opex"
                                  ? "Expense"
                                  : et?.value === "capex"
                                  ? "Asset"
                                  : "Liab.Pay"}
                              </span>
                            </td>
                            <td style={S.td}>
                              <span
                                style={{
                                  ...S.badge(
                                    catColors[o.category] || T.textMuted
                                  ),
                                  fontSize: 10,
                                }}
                              >
                                {o.category}
                              </span>
                            </td>
                            <td style={{ ...S.td, fontWeight: 600 }}>
                              {o.description}
                              {o.assetName ? (
                                <span
                                  style={{ fontSize: 10, color: T.textMuted }}
                                >
                                  {" "}
                                  · {o.assetName}
                                </span>
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              style={{
                                ...S.td,
                                color: T.textMuted,
                                fontSize: 11,
                              }}
                            >
                              {o.vendor || "—"}
                            </td>
                            <td style={S.td}>
                              <Badge color={T.textMuted}>{o.frequency}</Badge>
                            </td>
                            <td
                              style={{
                                ...S.td,
                                fontWeight: 700,
                                color:
                                  o.entryType === "capex"
                                    ? T.warning
                                    : o.entryType === "liability_payment"
                                    ? T.info
                                    : T.danger,
                              }}
                            >
                              {fmt(o.amount)}
                            </td>
                            <td style={S.td}>
                              <Badge
                                color={
                                  o.paymentStatus === "unpaid"
                                    ? T.danger
                                    : T.success
                                }
                              >
                                {o.paymentStatus === "unpaid"
                                  ? "Unpaid"
                                  : "Paid"}
                              </Badge>
                            </td>
                            <td style={S.td}>
                              <div style={{ display: "flex", gap: 4 }}>
                                <button
                                  style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px" }}
                                  onClick={() => startEdit(o)}
                                >Edit</button>
                                <button
                                  style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px" }}
                                  onClick={() => {
                                    const copy = { ...o, id: Date.now(), date: TODAY_ISO };
                                    setOverheads(prev => [...prev, copy]);
                                    startEdit(copy);
                                  }}
                                >⧉ Dupe</button>
                                <button
                                  style={{ ...S.btn("ghost"), fontSize: 10, padding: "2px 6px", color: T.danger }}
                                  onClick={() => deleteItem(o.id)}
                                >✕</button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {filtered.length === 0 && (
            <div
              style={{ color: T.textMuted, textAlign: "center", padding: 30 }}
            >
              No expenses found for the selected filters.
            </div>
          )}
          <div
            style={{
              marginTop: 8,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <div
              style={{
                background: T.surface,
                borderRadius: 7,
                padding: "8px 14px",
                fontSize: 12,
              }}
            >
              <span style={{ color: T.textMuted }}>Filtered Total: </span>
              <strong style={{ color: T.danger }}>{fmt(totalFiltered)}</strong>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

// ─── REPORTS PAGE ─────────────────────────────────────────────────
// Build report periods dynamically based on current year
function buildReportPeriods() {
  const now = new Date();
  const y = now.getFullYear();
  const py = y - 1; // previous year
  const monthNames = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
  const monthLabels = ["January","February","March","April","May","June",
    "July","August","September","October","November","December"];
  const monthEnds = [31,28,31,30,31,30,31,31,30,31,30,31];
  // adjust Feb for leap year
  if ((y % 4 === 0 && y % 100 !== 0) || y % 400 === 0) monthEnds[1] = 29;
  const pyFebEnd = ((py % 4 === 0 && py % 100 !== 0) || py % 400 === 0) ? 29 : 28;

  const todayStr = now.toISOString().slice(0, 10);
  const periods = [
    { id: "ytd_current", label: `Year to Date ${y}`, from: `${y}-01-01`, to: todayStr },
    { id: `annual_${y}`, label: `Full Year ${y}`, from: `${y}-01-01`, to: `${y}-12-31` },
    { id: `annual_${py}`, label: `Full Year ${py}`, from: `${py}-01-01`, to: `${py}-12-31` },
    { id: `q1_${y}`, label: `Q1 ${y} (Jan–Mar)`, from: `${y}-01-01`, to: `${y}-03-31` },
    { id: `q2_${y}`, label: `Q2 ${y} (Apr–Jun)`, from: `${y}-04-01`, to: `${y}-06-30` },
    { id: `q3_${y}`, label: `Q3 ${y} (Jul–Sep)`, from: `${y}-07-01`, to: `${y}-09-30` },
    { id: `q4_${y}`, label: `Q4 ${y} (Oct–Dec)`, from: `${y}-10-01`, to: `${y}-12-31` },
    { id: `q4_${py}`, label: `Q4 ${py} (Oct–Dec)`, from: `${py}-10-01`, to: `${py}-12-31` },
  ];
  // Add all months of current year up to current month
  for (let i = 0; i <= now.getMonth(); i++) {
    const mm = String(i + 1).padStart(2, "0");
    const end = String(monthEnds[i]).padStart(2, "0");
    periods.push({ id: `${monthNames[i]}_${y}`, label: `${monthLabels[i]} ${y}`, from: `${y}-${mm}-01`, to: `${y}-${mm}-${end}` });
  }
  // Add last 3 months of previous year
  for (let i = 9; i <= 11; i++) {
    const mm = String(i + 1).padStart(2, "0");
    const end = i === 1 ? String(pyFebEnd).padStart(2, "0") : String(monthEnds[i]).padStart(2, "0");
    periods.push({ id: `${monthNames[i]}_${py}`, label: `${monthLabels[i]} ${py}`, from: `${py}-${mm}-01`, to: `${py}-${mm}-${end}` });
  }
  return periods;
}
const REPORT_PERIODS = buildReportPeriods();

function buildReportData({
  periodId,
  customFrom: customFromOverride,
  customTo: customToOverride,
  events,
  sales,
  invoices,
  overheads,
  catalogItems,
  inventory,
  meals,
  invPurchases,
  prepaidItems,
}) {
  let from, to, p;
  if (periodId === "custom" && customFromOverride && customToOverride) {
    from = new Date(customFromOverride);
    to = new Date(customToOverride);
    p = { id: "custom", label: "Custom Range", from: customFromOverride, to: customToOverride };
  } else {
    p = REPORT_PERIODS.find((r) => r.id === periodId) || REPORT_PERIODS[0];
    from = new Date(p.from);
    to = new Date(p.to);
  }

  const pSales = sales.filter((s) => inRange(s.date, from, to));
  const pEvents = events.filter((e) => inRange(e.eventDate, from, to));
  const pOverheads = overheads.filter((o) => inRange(o.date, from, to));
  const pInvoices = invoices.filter((inv) => {
    const evt = events.find((e) => e.id === inv.eventId);
    return evt ? inRange(evt.eventDate, from, to) : false;
  });
  const pIngPurchases = (invPurchases || []).filter(p => inRange(p.date, from, to));

  // Revenue
  const rdRevenue = pSales.reduce((s, r) => s + orderTotal(r), 0);
  const catRevenue = pEvents.reduce((s, e) => s + e.revenue, 0);
  // Resale revenue: from sales that include resale items
  const resaleRevenue = pSales.reduce((s, sale) => {
    const resaleItems = (sale.items || []).filter(it => it._itemType === "resale");
    return s + resaleItems.reduce((a, it) => a + (Number(it.qty) || 0) * (Number(it.pricePerUnit) || 0), 0);
  }, 0);
  const totalRevenue = rdRevenue + catRevenue;

  // COGS — use meal-level costing for restaurant, event costs for catering
  const rdCOGS = pSales.reduce(
    (s, r) => s + orderCOGS(r, catalogItems, meals),
    0
  );
  const catCOGS = pEvents.reduce((s, e) => s + evtCOGS(e), 0);
  // Only ingredient purchases are immediate COGS; resale purchases are inventory assets (COGS recognized on sale)
  const ingPurchasesCOGS = pIngPurchases.reduce((s, p) => {
    const invItem = (inventory || []).find(i => i.id === p.itemId);
    const isResale = invItem ? invItem.itemType === "resale" : false;
    return isResale ? s : s + Number(p.totalCost || 0);
  }, 0);
  // Resale COGS: cost of resale items actually sold this period (qty × costPerUnit at time of sale)
  const resaleCOGS = pSales.reduce((s, sale) => {
    const resaleItems = (sale.items || []).filter(it => it._itemType === "resale");
    return s + resaleItems.reduce((a, it) => a + (Number(it.qty) || 0) * (Number(it._costPerUnit) || 0), 0);
  }, 0);
  const totalCOGS = rdCOGS + catCOGS + ingPurchasesCOGS + resaleCOGS;
  const grossProfit = totalRevenue - (isNaN(totalCOGS) ? 0 : totalCOGS);
  const _safeTotalCOGS = isNaN(totalCOGS) ? 0 : totalCOGS;

  // Overhead split — only opex hits P&L
  const oh = splitOverheads(pOverheads);
  const ohByCategory = {};
  pOverheads
    .filter((o) => (o.entryType || "opex") === "opex")
    .forEach((o) => {
      ohByCategory[o.category] =
        (ohByCategory[o.category] || 0) + Number(o.amount);
    });
  const prepaidRecognized = calcPrepaidRecognized(prepaidItems || [], from, to);
  const totalOverheads = oh.totalOpex + prepaidRecognized; // opex entries + prepaid amortization
  const operatingProfit = (isNaN(grossProfit) ? totalRevenue : grossProfit) - totalOverheads;

  // AR / Cash
  const cashReceived = invoices
    .filter((i) => inRange(i.issued || i.due, from, to))
    .reduce((s, i) => s + i.paid, 0);
  const arOutstanding = invoices.reduce((s, i) => s + (i.total - i.paid), 0); // all-time open balance
  const pCashReceived = pInvoices.reduce((s, i) => s + i.paid, 0);
  const restaurantCash = pSales.reduce((s, r) => s + orderTotal(r), 0); // assumed collected at sale

  // Balance sheet components (all-time cumulative for BS)
  const allOh = splitOverheads(overheads);
  const invValue = inventoryValue(inventory || []);

  // Accounts Payable = unpaid opex + unpaid capex (owed to suppliers/landlords)
  const totalAP = allOh.ap + allOh.capexAP;
  // Fixed assets = all capex purchases (gross, no depreciation for simplicity)
  const fixedAssetValue = allOh.fixedAssets;
  // Cumulative all-time net profit (retained earnings proxy)
  const allTimeSalesRevenue =
    sales.reduce((s, r) => s + orderTotal(r), 0) +
    events.reduce((s, e) => s + e.revenue, 0);
  const allTimeCOGS =
    sales.reduce((s, r) => s + orderCOGS(r, catalogItems, meals), 0) +
    events.reduce((s, e) => s + evtCOGS(e), 0);
  const allTimeOpex = overheads
    .filter((o) => (o.entryType || "opex") === "opex")
    .reduce((s, o) => s + Number(o.amount), 0);
  const retainedEarnings = allTimeSalesRevenue - allTimeCOGS - allTimeOpex;
  const totalCashReceived =
    invoices.reduce((s, i) => s + i.paid, 0) +
    sales.reduce((s, r) => s + orderTotal(r), 0);

  return {
    period: p,
    from,
    to,
    rdRevenue,
    catRevenue,
    totalRevenue,
    rdCOGS,
    catCOGS,
    resaleCOGS: isNaN(resaleCOGS) ? 0 : resaleCOGS,
    totalCOGS: _safeTotalCOGS,
    rdCOGS: isNaN(rdCOGS) ? 0 : rdCOGS,
    catCOGS: isNaN(catCOGS) ? 0 : catCOGS,
    grossProfit: isNaN(grossProfit) ? totalRevenue : grossProfit,
    ohByCategory,
    totalOverheads,
    prepaidRecognized,
    operatingProfit,
    cashReceived,
    arOutstanding,
    pCashReceived,
    restaurantCash,
    // Balance sheet
    invValue,
    fixedAssetValue,
    totalAP,
    retainedEarnings,
    allOh,
    allTimeCOGS,
    allTimeSalesRevenue,
    allTimeOpex,
    totalCashReceived,
    // cash flows
    paidOpexInPeriod: oh.paidOpex,
    liabPayInPeriod: pOverheads
      .filter((o) => o.entryType === "liability_payment")
      .reduce((s, o) => s + Number(o.amount), 0),
    capexInPeriod: oh.fixedAssets,
    pSales,
    pEvents,
    pInvoices,
    pOverheads,
    gm: totalRevenue > 0 ? (isNaN(grossProfit) ? '0.0' : ((grossProfit / totalRevenue) * 100).toFixed(1)) : '0.0',
    om:
      totalRevenue > 0
        ? (isNaN(operatingProfit) ? '0.0' : ((operatingProfit / totalRevenue) * 100).toFixed(1))
        : '0.0',
  };
}

function ReportsPage({
  events,
  sales,
  invoices,
  overheads,
  catalogItems,
  biz,
  inventory,
  meals,
  customers,
  batches,
  invPurchases,
  prepaidItems,
  setPrepaidItems,
  deposits,
  setDeposits,
}) {
  const [reportType, setReportType] = useState("pl");
  const [periodId, setPeriodId] = useState(() => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const monthNames = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
    const candidateId = `${monthNames[now.getMonth()]}_${y}`;
    // fall back to ytd period if no matching preset
    const found = REPORT_PERIODS.find(p => p.id === candidateId);
    return found ? candidateId : "ytd_current";
  });
  const [customReportFrom, setCustomReportFrom] = useState(TODAY_ISO);
  const [customReportTo, setCustomReportTo] = useState(TODAY_ISO);

  const d = useMemo(
    () =>
      buildReportData({
        periodId,
        customFrom: customReportFrom,
        customTo: customReportTo,
        events,
        sales,
        invoices,
        overheads,
        catalogItems,
        inventory: inventory || [],
        meals: meals || [],
        invPurchases: invPurchases || [],
        prepaidItems: prepaidItems || [],
      }),
    [
      periodId,
      customReportFrom,
      customReportTo,
      events,
      sales,
      invoices,
      overheads,
      catalogItems,
      inventory,
      meals,
      invPurchases,
      prepaidItems,
    ]
  );

  const printReport = () => {
    const title =
      reportType === "pl" ? "Profit & Loss Statement"
      : reportType === "bs" ? "Balance Sheet"
      : reportType === "cf" ? "Statement of Cash Flows"
      : reportType === "sales" ? "Sales Analysis Report"
      : reportType === "catering" ? "Catering Performance Report"
      : reportType === "customers" ? "Customer Report"
      : "Expense Ledger";
    const html = buildReportHTML(reportType, title, d, biz);
    printDoc(title, html);
  };

  const Row = ({ label, value, bold, color, indent, borderTop, large }) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: `${large ? 8 : 5}px ${indent ? 16 : 0}px`,
        borderTop: borderTop ? `1px solid ${T.border}` : "none",
      }}
    >
      <span
        style={{
          fontSize: indent ? 11 : 12,
          color: indent ? T.textMuted : T.text,
          fontWeight: bold ? 700 : 400,
        }}
      >
        {label}
      </span>
      <span
        style={{
          fontSize: large ? 14 : 12,
          fontWeight: bold ? 800 : 600,
          color: color || T.text,
        }}
      >
        {value}
      </span>
    </div>
  );

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 4,
        }}
      >
        <div>
          <div style={S.pageTitle}>📑 Financial Reports</div>
          <div style={S.subtitle}>
            Profit & Loss · Balance Sheet · Cash Flows — includes overhead
            expenses
          </div>
        </div>
      </div>

      {/* Report Controls */}
      <div
        style={{
          display: "flex",
          gap: 8,
          marginBottom: 16,
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", gap: 3 }}>
          {[
            ["pl", "📊 P&L"],
            ["bs", "🏦 Balance Sheet"],
            ["cf", "💸 Cash Flows"],
            ["sales", "🍽️ Sales"],
            ["catering", "🎉 Catering"],
            ["customers", "👥 Customers"],
            ["expenses", "📋 Expenses"],
            ["prepaid", "🏠 Prepaid & Deposits"],
          ].map(([t, label]) => (
            <button
              key={t}
              style={S.navBtn(reportType === t)}
              onClick={() => setReportType(t)}
            >
              {label}
            </button>
          ))}
        </div>
        <select
          style={{ ...S.select, width: 200 }}
          value={periodId}
          onChange={(e) => setPeriodId(e.target.value)}
        >
          <optgroup label="Custom">
            <option value="custom">📅 Custom Date Range</option>
          </optgroup>
          <optgroup label="Annual">
            {REPORT_PERIODS.filter((p) => p.id.startsWith("annual")).map(
              (p) => (
                <option key={p.id} value={p.id}>
                  {p.label}
                </option>
              )
            )}
          </optgroup>
          <optgroup label="Quarterly">
            {REPORT_PERIODS.filter((p) => p.id.startsWith("q")).map((p) => (
              <option key={p.id} value={p.id}>
                {p.label}
              </option>
            ))}
          </optgroup>
          <optgroup label="Monthly">
            {REPORT_PERIODS.filter(
              (p) => !p.id.startsWith("annual") && !p.id.startsWith("q")
            ).map((p) => (
              <option key={p.id} value={p.id}>
                {p.label}
              </option>
            ))}
          </optgroup>
        </select>
        {periodId === "custom" && (
          <div style={{ display: "flex", gap: 4, alignItems: "center", flexWrap: "wrap" }}>
            <input
              type="date"
              style={{ ...S.input, marginBottom: 0, fontSize: 11, padding: "3px 7px", width: 140 }}
              value={customReportFrom}
              onChange={e => setCustomReportFrom(e.target.value)}
            />
            <span style={{ fontSize: 11, color: T.textDim }}>→</span>
            <input
              type="date"
              style={{ ...S.input, marginBottom: 0, fontSize: 11, padding: "3px 7px", width: 140 }}
              value={customReportTo}
              onChange={e => setCustomReportTo(e.target.value)}
            />
          </div>
        )}
        <button
          style={S.btn("primary")}
          onClick={() => printReport()}
        >
          🖨️ Print / Export
        </button>
        <div style={{ fontSize: 10, color: T.textDim }}>
          {fmtDate(d.from)} – {fmtDate(d.to)}
        </div>
      </div>

      {/* ── P&L REPORT ── */}
      {reportType === "pl" && (
        <div style={{ ...S.grid(2), gap: 12 }}>
          <div>
            {/* Revenue */}
            <div style={S.card}>
              <div style={{ ...S.cardTitle, marginBottom: 12 }}>
                PROFIT & LOSS STATEMENT
              </div>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: T.accent,
                  marginBottom: 6,
                  letterSpacing: 0.5,
                  textTransform: "uppercase",
                }}
              >
                Revenue
              </div>
              <Row
                label="Restaurant & Delivery Sales"
                value={fmt(d.rdRevenue)}
                indent
              />
              <Row
                label="Catering Events Revenue"
                value={fmt(d.catRevenue)}
                indent
              />
              <Row
                label="Total Revenue"
                value={fmt(d.totalRevenue)}
                bold
                borderTop
                large
              />

              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: T.danger,
                  margin: "14px 0 6px",
                  letterSpacing: 0.5,
                  textTransform: "uppercase",
                }}
              >
                Cost of Goods Sold (Direct)
              </div>
              <Row
                label="Restaurant & Delivery COGS"
                value={fmt(d.rdCOGS)}
                indent
              />
              <Row label="Catering Events COGS" value={fmt(d.catCOGS)} indent />
              {d.resaleCOGS > 0 && <Row label="Resale Items COGS (drinks/wine)" value={fmt(d.resaleCOGS)} indent />}
              <Row label="Total COGS" value={fmt(d.totalCOGS)} bold borderTop />
              <Row
                label="Gross Profit"
                value={fmt(d.grossProfit)}
                bold
                borderTop
                large
                color={d.grossProfit >= 0 ? T.success : T.danger}
              />
              <Row
                label="Gross Margin"
                value={`${d.gm}%`}
                bold
                color={
                  Number(d.gm) >= 40
                    ? T.success
                    : Number(d.gm) >= 25
                    ? T.warning
                    : T.danger
                }
              />

              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: T.warning,
                  margin: "14px 0 6px",
                  letterSpacing: 0.5,
                  textTransform: "uppercase",
                }}
              >
                Operating Expenses (Overhead)
              </div>
              {Object.entries(d.ohByCategory)
                .sort((a, b) => b[1] - a[1])
                .map(([cat, amt]) => (
                  <Row key={cat} label={cat} value={fmt(amt)} indent />
                ))}
              {d.prepaidRecognized > 0 && (
                <Row label="Rent / Prepaid Amortization" value={fmt(d.prepaidRecognized)} indent />
              )}
              {Object.keys(d.ohByCategory).length === 0 && d.prepaidRecognized === 0 && (
                <div
                  style={{
                    fontSize: 11,
                    color: T.textDim,
                    padding: "4px 16px",
                  }}
                >
                  No overhead expenses recorded for this period.
                </div>
              )}
              <Row
                label="Total Operating Expenses"
                value={fmt(d.totalOverheads)}
                bold
                borderTop
              />
              <Row
                label="Operating Profit (EBIT)"
                value={fmt(d.operatingProfit)}
                bold
                borderTop
                large
                color={d.operatingProfit >= 0 ? T.success : T.danger}
              />
              <Row
                label="Operating Margin"
                value={`${d.om}%`}
                bold
                color={
                  Number(d.om) >= 20
                    ? T.success
                    : Number(d.om) >= 5
                    ? T.warning
                    : T.danger
                }
              />

              <div
                style={{
                  margin: "12px 0 6px",
                  padding: "10px 12px",
                  background:
                    d.operatingProfit >= 0 ? `${T.success}15` : `${T.danger}15`,
                  borderRadius: 8,
                  border: `1px solid ${
                    d.operatingProfit >= 0 ? T.success : T.danger
                  }30`,
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    color: T.textMuted,
                    marginBottom: 2,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                  }}
                >
                  Net Profit / (Loss)
                </div>
                <div
                  style={{
                    fontSize: 20,
                    fontWeight: 900,
                    color: d.operatingProfit >= 0 ? T.success : T.danger,
                  }}
                >
                  {fmt(d.operatingProfit)}
                </div>
                <div style={{ fontSize: 10, color: T.textMuted, marginTop: 2 }}>
                  {d.period.label} · Operating Margin: {d.om}%
                </div>
              </div>
            </div>
          </div>

          <div>
            {/* KPI summary */}
            <div style={S.card}>
              <div style={S.cardTitle}>Period KPIs</div>
              {[
                {
                  label: "Total Revenue",
                  value: fmt(d.totalRevenue),
                  color: T.accent,
                },
                {
                  label: "Gross Profit",
                  value: fmt(d.grossProfit),
                  color: T.success,
                },
                {
                  label: "Gross Margin",
                  value: `${d.gm}%`,
                  color: Number(d.gm) >= 40 ? T.success : T.warning,
                },
                {
                  label: "Total Overheads",
                  value: fmt(d.totalOverheads),
                  color: T.danger,
                },
                {
                  label: "Operating Profit",
                  value: fmt(d.operatingProfit),
                  color: d.operatingProfit >= 0 ? T.success : T.danger,
                },
                {
                  label: "Operating Margin",
                  value: `${d.om}%`,
                  color: Number(d.om) >= 20 ? T.success : T.warning,
                },
              ].map((item) => (
                <div
                  key={item.label}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px 0",
                    borderBottom: `1px solid ${T.border}15`,
                  }}
                >
                  <span style={{ fontSize: 11, color: T.textMuted }}>
                    {item.label}
                  </span>
                  <span
                    style={{ fontSize: 13, fontWeight: 800, color: item.color }}
                  >
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
            <div style={{ ...S.card, marginTop: 10 }}>
              <div style={S.cardTitle}>
                Overhead Breakdown ({d.period.label})
              </div>
              {Object.entries(d.ohByCategory)
                .sort((a, b) => b[1] - a[1])
                .map(([cat, amt]) => (
                  <div key={cat} style={{ marginBottom: 8 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 2,
                      }}
                    >
                      <span style={{ fontSize: 11 }}>{cat}</span>
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: T.warning,
                        }}
                      >
                        {fmt(amt)}
                      </span>
                    </div>
                    <PBar
                      pct={
                        d.totalOverheads ? (amt / d.totalOverheads) * 100 : 0
                      }
                      color={T.warning}
                    />
                  </div>
                ))}
              {Object.keys(d.ohByCategory).length === 0 && (
                <div style={{ color: T.textDim, fontSize: 11 }}>
                  No overhead expenses in this period.
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── BALANCE SHEET ── */}
      {reportType === "bs" && (
        <div style={S.grid(2)}>
          <div style={S.card}>
            <div style={{ ...S.cardTitle, marginBottom: 4 }}>BALANCE SHEET</div>
            <div style={{ fontSize: 10, color: T.textDim, marginBottom: 14 }}>
              As at {fmtDate(d.to)} · Based on recorded transactions
            </div>

            {/* ── ASSETS ── */}
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: T.success,
                marginBottom: 6,
                letterSpacing: 0.5,
                textTransform: "uppercase",
              }}
            >
              Assets
            </div>

            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: T.textMuted,
                margin: "0 0 4px 8px",
                textTransform: "uppercase",
                letterSpacing: 0.4,
              }}
            >
              Current Assets
            </div>
            <Row
              label="Cash & Cash Equivalents (est.)"
              value={fmt(Math.max(0, d.totalCashReceived - d.allTimeOpex - d.allTimeCOGS))}
              indent
            />
            <Row
              label="Accounts Receivable (open invoices)"
              value={fmt(d.arOutstanding)}
              indent
            />
            <Row label="Inventory at Cost" value={fmt(d.invValue)} indent />
            {(() => {
              const totalCurrent =
                Math.max(0, d.totalCashReceived - d.allTimeOpex - d.allTimeCOGS) +
                d.arOutstanding +
                d.invValue;
              return (
                <Row
                  label="Total Current Assets"
                  value={fmt(totalCurrent)}
                  bold
                  borderTop
                />
              );
            })()}

            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: T.textMuted,
                margin: "10px 0 4px 8px",
                textTransform: "uppercase",
                letterSpacing: 0.4,
              }}
            >
              Non-Current Assets
            </div>
            {d.allOh.capex.length === 0 ? (
              <Row
                label="Fixed Assets (no capex recorded)"
                value={fmt(0)}
                indent
              />
            ) : (
              d.allOh.capex.map((a) => (
                <Row
                  key={a.id}
                  label={`${a.assetName || a.description}`}
                  value={fmt(a.amount)}
                  indent
                />
              ))
            )}
            <Row
              label="Total Fixed Assets (gross)"
              value={fmt(d.fixedAssetValue)}
              bold
              borderTop
            />

            {(() => {
              const totalCurrent =
                Math.max(0, d.totalCashReceived - d.allTimeOpex - d.allTimeCOGS) +
                d.arOutstanding +
                d.invValue;
              return (
                <Row
                  label="TOTAL ASSETS"
                  value={fmt(totalCurrent + d.fixedAssetValue)}
                  bold
                  borderTop
                  large
                  color={T.success}
                />
              );
            })()}

            {/* ── LIABILITIES ── */}
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: T.danger,
                margin: "18px 0 6px",
                letterSpacing: 0.5,
                textTransform: "uppercase",
              }}
            >
              Liabilities
            </div>

            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: T.textMuted,
                margin: "0 0 4px 8px",
                textTransform: "uppercase",
                letterSpacing: 0.4,
              }}
            >
              Current Liabilities
            </div>
            <Row
              label="Accounts Payable (unpaid opex)"
              value={fmt(d.allOh.ap)}
              indent
            />
            <Row
              label="Payable on Asset Purchases"
              value={fmt(d.allOh.capexAP)}
              indent
            />
            {(() => {
              const totalCurrLiab = d.allOh.ap + d.allOh.capexAP;
              return (
                <Row
                  label="Total Current Liabilities"
                  value={fmt(totalCurrLiab)}
                  bold
                  borderTop
                />
              );
            })()}

            {/* Liability payments made reduce any outstanding loan balance */}
            {d.allOh.liabPay.length > 0 && (
              <>
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: 700,
                    color: T.textMuted,
                    margin: "10px 0 4px 8px",
                    textTransform: "uppercase",
                    letterSpacing: 0.4,
                  }}
                >
                  Long-term Liabilities
                </div>
                <Row
                  label="Loans / Financing (payments made)"
                  value={`(${fmt(d.allOh.totalLiabPaid)} paid)`}
                  indent
                />
              </>
            )}
            {(() => {
              const totalLiab = d.allOh.ap + d.allOh.capexAP;
              return (
                <Row
                  label="TOTAL LIABILITIES"
                  value={fmt(totalLiab)}
                  bold
                  borderTop
                  large
                  color={T.danger}
                />
              );
            })()}

            {/* ── EQUITY ── */}
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: T.accent,
                margin: "18px 0 6px",
                letterSpacing: 0.5,
                textTransform: "uppercase",
              }}
            >
              Equity
            </div>
            <Row
              label="Retained Earnings (cumulative net profit)"
              value={fmt(d.retainedEarnings)}
              indent
              color={d.retainedEarnings >= 0 ? T.success : T.danger}
            />
            <Row
              label="Owner's Capital (est.)"
              value={fmt(d.fixedAssetValue > 0 ? 0 : 450000)}
              indent
            />
            {(() => {
              const equity =
                d.retainedEarnings + (d.fixedAssetValue > 0 ? 0 : 450000);
              return (
                <Row
                  label="TOTAL EQUITY"
                  value={fmt(equity)}
                  bold
                  borderTop
                  large
                  color={T.accent}
                />
              );
            })()}

            {/* Balance check */}
            {(() => {
              const totalCurrent =
                Math.max(0, d.totalCashReceived - d.allTimeOpex - d.allTimeCOGS) +
                d.arOutstanding +
                d.invValue;
              const totalAssets = totalCurrent + d.fixedAssetValue;
              const totalLiab = d.allOh.ap + d.allOh.capexAP;
              const equity =
                d.retainedEarnings + (d.fixedAssetValue > 0 ? 0 : 450000);
              const diff = Math.abs(totalAssets - (totalLiab + equity));
              return (
                <div
                  style={{
                    marginTop: 14,
                    padding: "8px 12px",
                    background:
                      diff < 50000 ? `${T.success}15` : `${T.warning}15`,
                    borderRadius: 8,
                    border: `1px solid ${
                      diff < 50000 ? T.success : T.warning
                    }30`,
                  }}
                >
                  <div
                    style={{
                      fontSize: 10,
                      color: T.textMuted,
                      marginBottom: 2,
                    }}
                  >
                    Balance Check (Assets vs Liabilities + Equity)
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: diff < 50000 ? T.success : T.warning,
                    }}
                  >
                    {diff < 50000
                      ? "✅ Reasonably balanced"
                      : `⚠️ Difference: ${fmt(
                          diff
                        )} — cash balance is estimated`}
                  </div>
                  <div style={{ fontSize: 10, color: T.textDim, marginTop: 2 }}>
                    Cash is estimated at 60% of retained earnings. Record full
                    bookkeeping for exact balance.
                  </div>
                </div>
              );
            })()}
          </div>

          <div>
            <div style={S.card}>
              <div style={S.cardTitle}>Key Ratios & Notes</div>
              {(() => {
                const totalCurrent =
                  Math.max(0, d.totalCashReceived - d.allTimeOpex - d.allTimeCOGS) +
                  d.arOutstanding +
                  d.invValue;
                const totalCurrLiab = d.allOh.ap + d.allOh.capexAP;
                const currentRatio =
                  totalCurrLiab > 0
                    ? (totalCurrent / totalCurrLiab).toFixed(2)
                    : "∞";
                const quickAssets =
                  Math.max(0, d.totalCashReceived - d.allTimeOpex - d.allTimeCOGS) + d.arOutstanding;
                const quickRatio =
                  totalCurrLiab > 0
                    ? (quickAssets / totalCurrLiab).toFixed(2)
                    : "∞";
                return [
                  {
                    label: "Current Ratio",
                    value: currentRatio,
                    note: "Current Assets / Current Liabilities · >1.5 healthy",
                  },
                  {
                    label: "Quick Ratio",
                    value: quickRatio,
                    note: "Liquid Assets / Current Liabilities · >1.0 good",
                  },
                  {
                    label: "Accounts Receivable",
                    value: fmt(d.arOutstanding),
                    note: "Total unpaid client invoices",
                  },
                  {
                    label: "Accounts Payable",
                    value: fmt(d.allOh.ap + d.allOh.capexAP),
                    note: "Total unpaid expenses & asset purchases",
                  },
                  {
                    label: "Inventory at Cost",
                    value: fmt(d.invValue),
                    note: "Current stock value",
                  },
                  {
                    label: "Fixed Assets (gross)",
                    value: fmt(d.fixedAssetValue),
                    note: `${d.allOh.capex.length} asset purchase(s) recorded`,
                  },
                  {
                    label: "Gross Margin",
                    value: `${d.gm}%`,
                    note: `${
                      Number(d.gm) >= 40
                        ? "✅ Healthy"
                        : Number(d.gm) >= 25
                        ? "⚠️ Watch"
                        : "❌ Low"
                    }`,
                  },
                  {
                    label: "Operating Margin",
                    value: `${d.om}%`,
                    note: `After overheads of ${fmt(d.totalOverheads)}`,
                  },
                ].map((item) => (
                  <div
                    key={item.label}
                    style={{
                      padding: "7px 0",
                      borderBottom: `1px solid ${T.border}15`,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ fontSize: 12, fontWeight: 600 }}>
                        {item.label}
                      </span>
                      <span
                        style={{
                          fontSize: 13,
                          fontWeight: 800,
                          color: T.accent,
                        }}
                      >
                        {item.value}
                      </span>
                    </div>
                    <div
                      style={{ fontSize: 10, color: T.textMuted, marginTop: 2 }}
                    >
                      {item.note}
                    </div>
                  </div>
                ));
              })()}
            </div>
            <div style={{ ...S.card, marginTop: 10 }}>
              <div style={S.cardTitle}>Accounts Payable Detail</div>
              {(overheads || []).filter((o) => o.paymentStatus === "unpaid")
                .length === 0 ? (
                <div style={{ fontSize: 11, color: T.textDim }}>
                  No unpaid expenses recorded.
                </div>
              ) : (
                (overheads || [])
                  .filter((o) => o.paymentStatus === "unpaid")
                  .map((o) => (
                    <div
                      key={o.id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "6px 0",
                        borderBottom: `1px solid ${T.border}15`,
                      }}
                    >
                      <div>
                        <div style={{ fontSize: 11, fontWeight: 600 }}>
                          {o.description}
                        </div>
                        <div style={{ fontSize: 10, color: T.textMuted }}>
                          {o.vendor || "—"} · {o.date} ·{" "}
                          <Badge
                            color={
                              (o.entryType || "opex") === "capex"
                                ? T.warning
                                : T.danger
                            }
                          >
                            {(o.entryType || "opex") === "capex"
                              ? "Asset"
                              : "Expense"}
                          </Badge>
                        </div>
                      </div>
                      <span
                        style={{
                          fontSize: 13,
                          fontWeight: 800,
                          color: T.danger,
                        }}
                      >
                        {fmt(o.amount)}
                      </span>
                    </div>
                  ))
              )}
              {(overheads || []).filter((o) => o.paymentStatus === "unpaid")
                .length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 8,
                    paddingTop: 8,
                    borderTop: `1px solid ${T.border}`,
                    fontWeight: 800,
                    fontSize: 12,
                  }}
                >
                  <span>Total AP</span>
                  <span style={{ color: T.danger }}>
                    {fmt(
                      (overheads || [])
                        .filter((o) => o.paymentStatus === "unpaid")
                        .reduce((s, o) => s + Number(o.amount), 0)
                    )}
                  </span>
                </div>
              )}
            </div>
            {d.allOh.capex.length > 0 && (
              <div style={{ ...S.card, marginTop: 10 }}>
                <div style={S.cardTitle}>Fixed Assets Register</div>
                {d.allOh.capex.map((a) => (
                  <div
                    key={a.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "6px 0",
                      borderBottom: `1px solid ${T.border}15`,
                    }}
                  >
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 600 }}>
                        {a.assetName || a.description}
                      </div>
                      <div style={{ fontSize: 10, color: T.textMuted }}>
                        {a.vendor} · {a.date} ·{" "}
                        <Badge
                          color={
                            a.paymentStatus === "paid" ? T.success : T.danger
                          }
                        >
                          {a.paymentStatus === "paid" ? "Paid" : "Unpaid"}
                        </Badge>
                      </div>
                    </div>
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 800,
                        color: T.warning,
                      }}
                    >
                      {fmt(a.amount)}
                    </span>
                  </div>
                ))}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 8,
                    paddingTop: 8,
                    borderTop: `1px solid ${T.border}`,
                    fontWeight: 800,
                    fontSize: 12,
                  }}
                >
                  <span>Total Fixed Assets</span>
                  <span style={{ color: T.warning }}>
                    {fmt(d.fixedAssetValue)}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── CASH FLOWS ── */}
      {reportType === "cf" && (
        <div style={S.grid(2)}>
          <div style={S.card}>
            <div style={{ ...S.cardTitle, marginBottom: 4 }}>
              STATEMENT OF CASH FLOWS
            </div>
            <div style={{ fontSize: 10, color: T.textDim, marginBottom: 14 }}>
              Period: {fmtDate(d.from)} – {fmtDate(d.to)}
            </div>

            {/* Operating */}
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: T.success,
                marginBottom: 6,
                letterSpacing: 0.5,
                textTransform: "uppercase",
              }}
            >
              Operating Activities
            </div>
            <Row
              label="Cash from Restaurant Sales (collected)"
              value={fmt(d.rdRevenue)}
              indent
            />
            <Row
              label="Cash from Catering Invoices (collected)"
              value={fmt(d.pCashReceived)}
              indent
            />
            <Row
              label="Total Cash Inflows"
              value={fmt(d.rdRevenue + d.pCashReceived)}
              bold
              borderTop
              color={T.success}
            />
            <Row
              label="Restaurant COGS (direct costs)"
              value={`(${fmt(d.rdCOGS)})`}
              indent
              color={T.danger}
            />
            <Row
              label="Catering Event Costs"
              value={`(${fmt(d.catCOGS)})`}
              indent
              color={T.danger}
            />
            <Row
              label="Overhead Expense Payments (paid)"
              value={`(${fmt(d.paidOpexInPeriod)})`}
              indent
              color={T.danger}
            />
            <Row
              label="Liability / AP Payments"
              value={`(${fmt(d.liabPayInPeriod)})`}
              indent
              color={T.danger}
            />
            <Row
              label="Total Cash Outflows (operating)"
              value={`(${fmt(
                d.rdCOGS + d.catCOGS + d.paidOpexInPeriod + d.liabPayInPeriod
              )})`}
              bold
              borderTop
              color={T.danger}
            />
            {(() => {
              const netOps =
                d.rdRevenue +
                d.pCashReceived -
                d.rdCOGS -
                d.catCOGS -
                d.paidOpexInPeriod -
                d.liabPayInPeriod;
              return (
                <Row
                  label="Net Cash from Operations"
                  value={fmt(netOps)}
                  bold
                  borderTop
                  large
                  color={netOps >= 0 ? T.success : T.danger}
                />
              );
            })()}

            {/* Investing */}
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: T.warning,
                margin: "16px 0 6px",
                letterSpacing: 0.5,
                textTransform: "uppercase",
              }}
            >
              Investing Activities
            </div>
            {d.pOverheads.filter(
              (o) => o.entryType === "capex" && o.paymentStatus === "paid"
            ).length === 0 ? (
              <Row
                label="No asset purchases paid this period"
                value={fmt(0)}
                indent
              />
            ) : (
              d.pOverheads
                .filter(
                  (o) => o.entryType === "capex" && o.paymentStatus === "paid"
                )
                .map((a) => (
                  <Row
                    key={a.id}
                    label={`Asset: ${a.assetName || a.description}`}
                    value={`(${fmt(a.amount)})`}
                    indent
                    color={T.warning}
                  />
                ))
            )}
            {(() => {
              const paidCapex = d.pOverheads
                .filter(
                  (o) => o.entryType === "capex" && o.paymentStatus === "paid"
                )
                .reduce((s, o) => s + Number(o.amount), 0);
              return (
                <Row
                  label="Net Cash from Investing"
                  value={fmt(-paidCapex)}
                  bold
                  borderTop
                  color={paidCapex > 0 ? T.warning : T.text}
                />
              );
            })()}

            {/* Financing */}
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: T.info,
                margin: "16px 0 6px",
                letterSpacing: 0.5,
                textTransform: "uppercase",
              }}
            >
              Financing Activities
            </div>
            <Row label="Owner Capital Contributions" value="—" indent />
            <Row
              label="Loan Repayments made"
              value={
                d.liabPayInPeriod > 0 ? `(${fmt(d.liabPayInPeriod)})` : fmt(0)
              }
              indent
              color={T.info}
            />
            <Row
              label="Net Cash from Financing"
              value={fmt(0)}
              bold
              borderTop
            />

            {(() => {
              const paidCapex = d.pOverheads
                .filter(
                  (o) => o.entryType === "capex" && o.paymentStatus === "paid"
                )
                .reduce((s, o) => s + Number(o.amount), 0);
              const netOps =
                d.rdRevenue +
                d.pCashReceived -
                d.totalCOGS -
                d.paidOpexInPeriod -
                d.liabPayInPeriod;
              const netCash = netOps - paidCapex;
              return (
                <div
                  style={{
                    marginTop: 14,
                    background: T.surface,
                    borderRadius: 8,
                    padding: 12,
                  }}
                >
                  <Row
                    label="Net Change in Cash"
                    value={fmt(netCash)}
                    bold
                    large
                    color={netCash >= 0 ? T.success : T.danger}
                  />
                  {d.arOutstanding > 0 && (
                    <div
                      style={{ fontSize: 10, color: T.textMuted, marginTop: 6 }}
                    >
                      ⚠️ Collecting {fmt(d.arOutstanding)} in outstanding AR
                      would further improve cash.
                    </div>
                  )}
                </div>
              );
            })()}
          </div>

          <div>
            <div style={S.card}>
              <div style={S.cardTitle}>Cash Flow Summary</div>
              {(() => {
                const paidCapex = d.pOverheads
                  .filter(
                    (o) => o.entryType === "capex" && o.paymentStatus === "paid"
                  )
                  .reduce((s, o) => s + Number(o.amount), 0);
                const netOps =
                  d.rdRevenue +
                  d.pCashReceived -
                  d.totalCOGS -
                  d.paidOpexInPeriod -
                  d.liabPayInPeriod;
                const netCash = netOps - paidCapex;
                return [
                  {
                    label: "💰 Total Cash Inflows",
                    value: d.rdRevenue + d.pCashReceived,
                    color: T.success,
                  },
                  {
                    label: "🛒 COGS Outflows",
                    value: d.totalCOGS,
                    color: T.danger,
                  },
                  {
                    label: "🏢 Overhead Paid",
                    value: d.paidOpexInPeriod,
                    color: T.warning,
                  },
                  {
                    label: "💳 Liability Payments",
                    value: d.liabPayInPeriod,
                    color: T.info,
                  },
                  {
                    label: "🏗️ Asset Purchases (paid)",
                    value: paidCapex,
                    color: T.warning,
                  },
                  {
                    label: "📊 Net Cash Flow",
                    value: netCash,
                    color: netCash >= 0 ? T.success : T.danger,
                  },
                ].map((item) => (
                  <div
                    key={item.label}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "8px 0",
                      borderBottom: `1px solid ${T.border}15`,
                    }}
                  >
                    <span style={{ fontSize: 11, color: T.textMuted }}>
                      {item.label}
                    </span>
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 800,
                        color: item.color,
                      }}
                    >
                      {fmt(Math.abs(item.value))}
                    </span>
                  </div>
                ));
              })()}
            </div>
            <div style={{ ...S.card, marginTop: 10 }}>
              <div style={S.cardTitle}>
                Accruals (Earned but not yet Collected)
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "6px 0",
                  borderBottom: `1px solid ${T.border}15`,
                }}
              >
                <span style={{ fontSize: 11, color: T.textMuted }}>
                  AR Outstanding (client owes)
                </span>
                <span
                  style={{ fontSize: 13, fontWeight: 800, color: T.danger }}
                >
                  {fmt(d.arOutstanding)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "6px 0",
                }}
              >
                <span style={{ fontSize: 11, color: T.textMuted }}>
                  AP Outstanding (we owe)
                </span>
                <span
                  style={{ fontSize: 13, fontWeight: 800, color: T.warning }}
                >
                  {fmt(d.allOh.ap + d.allOh.capexAP)}
                </span>
              </div>
              <div style={{ fontSize: 10, color: T.textDim, marginTop: 4 }}>
                Net position:{" "}
                {fmt(d.arOutstanding - d.allOh.ap - d.allOh.capexAP)}
              </div>
            </div>
            <div style={{ ...S.card, marginTop: 10 }}>
              <div style={S.cardTitle}>Overhead Paid vs Unpaid</div>
              {d.pOverheads.filter((o) => (o.entryType || "opex") === "opex")
                .length === 0 ? (
                <div style={{ fontSize: 11, color: T.textDim }}>
                  No opex in this period.
                </div>
              ) : (
                [
                  ["Paid", d.paidOpexInPeriod, T.success],
                  ["Unpaid (AP)", d.allOh.ap, T.danger],
                ].map(([label, val, color]) => (
                  <div
                    key={label}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "5px 0",
                      borderBottom: `1px solid ${T.border}12`,
                    }}
                  >
                    <span style={{ fontSize: 11, color: T.textMuted }}>
                      {label}
                    </span>
                    <span style={{ fontSize: 11, fontWeight: 700, color }}>
                      {fmt(val)}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── SALES ANALYSIS ── */}
      {reportType === "sales" && (() => {
        const pSales = d.pSales;
        const totalSalesRev = pSales.reduce((s, r) => s + orderTotal(r), 0);
        const totalOrders = pSales.length;
        const avgOrderVal = totalOrders > 0 ? totalSalesRev / totalOrders : 0;

        // Meals ranked by revenue
        const byMeal = {};
        pSales.forEach(s => {
          const items = Array.isArray(s.items) && s.items.length > 0
            ? s.items
            : [{ meal: s.meal, plates: s.plates, pricePerPlate: s.pricePerPlate }];
          items.forEach(it => {
            const key = it.meal || "Unknown";
            if (!byMeal[key]) byMeal[key] = { revenue: 0, orders: 0, plates: 0 };
            byMeal[key].revenue += (Number(it.plates) || 0) * (Number(it.pricePerPlate) || 0);
            byMeal[key].orders += 1;
            byMeal[key].plates += Number(it.plates) || 0;
          });
        });
        const mealRanked = Object.entries(byMeal).sort((a,b) => b[1].revenue - a[1].revenue);

        // By order type
        const byType = {};
        pSales.forEach(s => {
          byType[s.type] = (byType[s.type] || 0) + orderTotal(s);
        });

        // By payment method
        const byMethod = {};
        pSales.forEach(s => {
          byMethod[s.method] = (byMethod[s.method] || 0) + orderTotal(s);
        });

        // By day of week
        const byDay = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"].map(d => ({ day: d, rev: 0, orders: 0 }));
        pSales.forEach(s => {
          const dow = (new Date(s.date).getDay() + 6) % 7; // 0=Mon
          byDay[dow].rev += orderTotal(s);
          byDay[dow].orders += 1;
        });
        const maxDayRev = Math.max(...byDay.map(d => d.rev), 1);

        // Delivery stats
        const deliveries = pSales.filter(s => s.type === "Delivery");
        const deliveryFees = deliveries.reduce((s,r) => s + (r.deliveryFee||0), 0);

        const statCard = (label, value, sub, color) => (
          <div key={label} style={{ background: T.surface, borderRadius: 8, padding: "10px 13px" }}>
            <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 2, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</div>
            <div style={{ fontSize: 18, fontWeight: 900, color: color || T.text }}>{value}</div>
            {sub && <div style={{ fontSize: 10, color: T.textDim, marginTop: 2 }}>{sub}</div>}
          </div>
        );

        return (
          <div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8, marginBottom: 14 }}>
              {statCard("Total Orders", totalOrders, `${fmtDate(d.from)} – ${fmtDate(d.to)}`, T.accent)}
              {statCard("Sales Revenue", fmtShort(totalSalesRev), "Restaurant & Delivery", T.success)}
              {statCard("Avg Order Value", fmt(Math.round(avgOrderVal)), "per transaction", T.info)}
              {statCard("Delivery Fees", fmt(deliveryFees), `${deliveries.length} deliveries`, T.warning)}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 10 }}>
              <div style={S.card}>
                <div style={S.cardTitle}>🏆 Top Selling Meals</div>
                <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
                    <thead>
                      <tr style={{ background: T.surface }}>
                        {["#","Meal","Orders","Plates","Revenue","% of Sales"].map(h => (
                          <th key={h} style={{ padding: "6px 8px", textAlign: h==="Revenue"||h==="% of Sales"?"right":"left", color: T.textMuted, fontSize: 9, letterSpacing: 0.5, textTransform: "uppercase", fontWeight: 700 }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {mealRanked.map(([meal, m], i) => (
                        <tr key={meal} style={{ borderBottom: `1px solid ${T.border}20` }}>
                          <td style={{ padding: "7px 8px", color: T.textDim, fontSize: 10 }}>{i+1}</td>
                          <td style={{ padding: "7px 8px", fontWeight: 600, color: T.text }}>{meal}</td>
                          <td style={{ padding: "7px 8px", color: T.textMuted }}>{m.orders}</td>
                          <td style={{ padding: "7px 8px", color: T.textMuted }}>{m.plates}</td>
                          <td style={{ padding: "7px 8px", textAlign: "right", fontWeight: 700, color: T.accent }}>{fmt(m.revenue)}</td>
                          <td style={{ padding: "7px 8px", textAlign: "right", color: T.textMuted }}>
                            {totalSalesRev > 0 ? ((m.revenue/totalSalesRev)*100).toFixed(1) : 0}%
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {mealRanked.length === 0 && <div style={{ padding: 16, color: T.textDim, fontSize: 11 }}>No sales in this period.</div>}
                </div>
              </div>
              <div>
                <div style={S.card}>
                  <div style={S.cardTitle}>📊 Revenue by Order Type</div>
                  {Object.entries(byType).sort((a,b) => b[1]-a[1]).map(([type, rev]) => (
                    <div key={type} style={{ marginBottom: 10 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                        <span style={{ fontSize: 11, color: T.text }}>{type}</span>
                        <span style={{ fontSize: 11, fontWeight: 700 }}>{fmt(rev)}</span>
                      </div>
                      <div style={{ height: 5, background: T.surface, borderRadius: 3 }}>
                        <div style={{ height: 5, borderRadius: 3, background: T.accent, width: `${totalSalesRev > 0 ? (rev/totalSalesRev)*100 : 0}%` }} />
                      </div>
                    </div>
                  ))}
                  {Object.keys(byType).length === 0 && <div style={{ color: T.textDim, fontSize: 11 }}>No data.</div>}
                </div>
                <div style={{ ...S.card, marginTop: 10 }}>
                  <div style={S.cardTitle}>💳 Payment Methods</div>
                  {Object.entries(byMethod).sort((a,b) => b[1]-a[1]).map(([method, rev]) => (
                    <div key={method} style={{ display: "flex", justifyContent: "space-between", padding: "5px 0", borderBottom: `1px solid ${T.border}20` }}>
                      <span style={{ fontSize: 11, color: T.textMuted }}>{method}</span>
                      <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: 11, fontWeight: 700 }}>{fmt(rev)}</div>
                        <div style={{ fontSize: 9, color: T.textDim }}>{totalSalesRev > 0 ? ((rev/totalSalesRev)*100).toFixed(0) : 0}%</div>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ ...S.card, marginTop: 10 }}>
                  <div style={S.cardTitle}>📅 Sales by Day of Week</div>
                  {byDay.map(({ day, rev, orders }) => (
                    <div key={day} style={{ marginBottom: 6 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
                        <span style={{ fontSize: 10, color: T.textMuted, width: 28 }}>{day}</span>
                        <div style={{ flex: 1, margin: "0 6px", height: 8, background: T.surface, borderRadius: 3, alignSelf: "center" }}>
                          <div style={{ height: 8, borderRadius: 3, background: rev > 0 ? T.accent : "transparent", width: `${(rev/maxDayRev)*100}%`, opacity: 0.8 }} />
                        </div>
                        <span style={{ fontSize: 10, color: T.text, fontWeight: rev > 0 ? 700 : 400, width: 70, textAlign: "right" }}>{rev > 0 ? fmt(rev) : "—"}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── CATERING PERFORMANCE ── */}
      {reportType === "catering" && (() => {
        const allEvents = events;
        const pEvents = d.pEvents;
        const completedEvents = allEvents.filter(e => e.phase === "Event Completed");
        const confirmedEvents = allEvents.filter(e => e.phase === "Confirmed");
        const leads = allEvents.filter(e => e.phase === "Lead / Inquiry");
        const totalCateringRev = allEvents.filter(e => e.revenue > 0).reduce((s,e) => s + e.revenue, 0);
        const avgEventRev = completedEvents.length > 0
          ? completedEvents.reduce((s,e) => s + e.revenue, 0) / completedEvents.length : 0;

        // By event type
        const byType = {};
        allEvents.forEach(e => {
          if (!byType[e.eventType]) byType[e.eventType] = { count: 0, rev: 0 };
          byType[e.eventType].count++;
          byType[e.eventType].rev += e.revenue || 0;
        });

        // Pipeline value (confirmed + leads)
        const pipelineVal = [...confirmedEvents, ...leads].reduce((s,e) => s + (e.guests * e.pricePerHead || 0), 0);

        // Proposal stats from period
        const proposalStats = {
          total: 0, approved: 0, sent: 0, draft: 0, declined: 0
        };

        const statCard = (label, value, sub, color) => (
          <div key={label} style={{ background: T.surface, borderRadius: 8, padding: "10px 13px" }}>
            <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 2, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</div>
            <div style={{ fontSize: 18, fontWeight: 900, color: color || T.text }}>{value}</div>
            {sub && <div style={{ fontSize: 10, color: T.textDim, marginTop: 2 }}>{sub}</div>}
          </div>
        );

        return (
          <div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8, marginBottom: 14 }}>
              {statCard("Completed Events", completedEvents.length, "all time", T.success)}
              {statCard("Total Revenue", fmtShort(totalCateringRev), "from completed events", T.accent)}
              {statCard("Avg Event Value", fmtShort(Math.round(avgEventRev)), "per completed event", T.info)}
              {statCard("Pipeline Value", fmtShort(pipelineVal), `${confirmedEvents.length} confirmed · ${leads.length} leads`, T.catering)}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              <div style={S.card}>
                <div style={S.cardTitle}>📋 All Events — Status Overview</div>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
                  <thead>
                    <tr style={{ background: T.surface }}>
                      {["Event","Type","Date","Guests","Revenue","Phase"].map(h => (
                        <th key={h} style={{ padding: "5px 7px", textAlign: "left", color: T.textMuted, fontSize: 9, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700 }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {[...allEvents].sort((a,b) => new Date(b.eventDate) - new Date(a.eventDate)).map(e => {
                      const phaseColor = {
                        "Event Completed": T.success,
                        "Confirmed": T.info,
                        "Planning": T.accent,
                        "Lead / Inquiry": T.textMuted,
                        "Quotation Sent": T.warning,
                        "Cancelled": T.danger,
                      }[e.phase] || T.textMuted;
                      return (
                        <tr key={e.id} style={{ borderBottom: `1px solid ${T.border}20` }}>
                          <td style={{ padding: "6px 7px", fontWeight: 600, fontSize: 11, maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{e.name}</td>
                          <td style={{ padding: "6px 7px", color: T.textMuted, fontSize: 10 }}>{e.eventType}</td>
                          <td style={{ padding: "6px 7px", color: T.textMuted, fontSize: 10 }}>{e.eventDate}</td>
                          <td style={{ padding: "6px 7px", color: T.textMuted, fontSize: 10 }}>{e.guests}</td>
                          <td style={{ padding: "6px 7px", fontWeight: 700, color: e.revenue > 0 ? T.accent : T.textDim, fontSize: 11 }}>{e.revenue > 0 ? fmtShort(e.revenue) : "—"}</td>
                          <td style={{ padding: "6px 7px" }}>
                            <span style={{ fontSize: 9, fontWeight: 700, color: phaseColor, background: phaseColor + "18", padding: "2px 6px", borderRadius: 10 }}>{e.phase}</span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {allEvents.length === 0 && <div style={{ padding: 16, color: T.textDim, fontSize: 11 }}>No events recorded.</div>}
              </div>
              <div>
                <div style={S.card}>
                  <div style={S.cardTitle}>🎊 Revenue by Event Type</div>
                  {Object.entries(byType).sort((a,b) => b[1].rev - a[1].rev).map(([type, data]) => (
                    <div key={type} style={{ marginBottom: 10 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                        <span style={{ fontSize: 11, color: T.text, fontWeight: 600 }}>{type}</span>
                        <span style={{ fontSize: 11 }}>{data.count} event{data.count !== 1 ? "s" : ""} · <strong>{fmtShort(data.rev)}</strong></span>
                      </div>
                      <div style={{ height: 6, background: T.surface, borderRadius: 3 }}>
                        <div style={{ height: 6, borderRadius: 3, background: T.catering, width: `${totalCateringRev > 0 ? (data.rev/totalCateringRev)*100 : 0}%` }} />
                      </div>
                    </div>
                  ))}
                  {Object.keys(byType).length === 0 && <div style={{ color: T.textDim, fontSize: 11 }}>No data.</div>}
                </div>
                <div style={{ ...S.card, marginTop: 10 }}>
                  <div style={S.cardTitle}>📊 Phase Breakdown</div>
                  {[
                    ["✅ Completed", completedEvents.length, T.success],
                    ["📆 Confirmed", confirmedEvents.length, T.info],
                    ["🔍 Lead / Inquiry", leads.length, T.textMuted],
                    ["❌ Cancelled", allEvents.filter(e=>e.phase==="Cancelled").length, T.danger],
                  ].map(([label, count, color]) => (
                    <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: `1px solid ${T.border}20` }}>
                      <span style={{ fontSize: 11, color: T.textMuted }}>{label}</span>
                      <span style={{ fontSize: 13, fontWeight: 800, color }}>{count}</span>
                    </div>
                  ))}
                  <div style={{ marginTop: 10, padding: "8px 10px", background: T.surface, borderRadius: 6 }}>
                    <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 2 }}>Pipeline Value (Confirmed + Leads)</div>
                    <div style={{ fontSize: 16, fontWeight: 900, color: T.catering }}>{fmt(pipelineVal)} XAF</div>
                  </div>
                </div>
                <div style={{ ...S.card, marginTop: 10 }}>
                  <div style={S.cardTitle}>💰 Invoice Collection Status</div>
                  {invoices.length === 0
                    ? <div style={{ color: T.textDim, fontSize: 11 }}>No invoices recorded.</div>
                    : invoices.map(inv => {
                        const bal = inv.total - inv.paid;
                        const statusColor = bal <= 0 ? T.success : inv.paid > 0 ? T.warning : T.danger;
                        return (
                          <div key={inv.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: `1px solid ${T.border}20`, alignItems: "center" }}>
                            <div>
                              <div style={{ fontSize: 11, fontWeight: 600 }}>{inv.client}</div>
                              <div style={{ fontSize: 9, color: T.textDim }}>{inv.num} · Due {inv.due}</div>
                            </div>
                            <div style={{ textAlign: "right" }}>
                              <div style={{ fontSize: 11, fontWeight: 700, color: statusColor }}>
                                {bal <= 0 ? "✅ Paid" : bal === inv.total ? `❌ ${fmt(bal)}` : `⏳ ${fmt(bal)}`}
                              </div>
                              <div style={{ fontSize: 9, color: T.textDim }}>{fmt(inv.total)} total</div>
                            </div>
                          </div>
                        );
                      })
                  }
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── CUSTOMER REPORT ── */}
      {reportType === "customers" && (() => {
        const allCustomers = customers || [];
        // Enrich each customer with their sales and event data
        const enriched = allCustomers.map(c => {
          const cSales = sales.filter(s => s.clientName && s.clientName.toLowerCase() === c.name.toLowerCase());
          const cEvents = events.filter(e => e.clientName && e.clientName.toLowerCase() === c.name.toLowerCase());
          const totalSpend = cSales.reduce((s,r) => s + orderTotal(r), 0) + cEvents.reduce((s,e) => s + (e.revenue||0), 0);
          const lastActivity = [...cSales.map(s=>s.date), ...cEvents.map(e=>e.eventDate)].sort().pop() || c.createdAt;
          return { ...c, totalSpend, orderCount: cSales.length, eventCount: cEvents.length, lastActivity };
        }).sort((a,b) => b.totalSpend - a.totalSpend);

        const totalCustomers = allCustomers.length;
        const vipCount = allCustomers.filter(c => c.classification === "VIP").length;
        const totalSpendAll = enriched.reduce((s,c) => s + c.totalSpend, 0);
        const avgSpend = totalCustomers > 0 ? totalSpendAll / totalCustomers : 0;

        return (
          <div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8, marginBottom: 14 }}>
              {[
                ["Total Customers", totalCustomers, "all time", T.accent],
                ["VIP Clients", vipCount, "high-value accounts", T.warning],
                ["Total Client Spend", fmtShort(totalSpendAll), "across all clients", T.success],
                ["Avg Spend / Client", fmt(Math.round(avgSpend)), "lifetime value", T.info],
              ].map(([label, val, sub, color]) => (
                <div key={label} style={{ background: T.surface, borderRadius: 8, padding: "10px 13px" }}>
                  <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 2, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</div>
                  <div style={{ fontSize: 18, fontWeight: 900, color }}>{val}</div>
                  <div style={{ fontSize: 10, color: T.textDim, marginTop: 2 }}>{sub}</div>
                </div>
              ))}
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>👥 Customer Ranking — by Lifetime Value</div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
                <thead>
                  <tr style={{ background: T.surface }}>
                    {["#","Name","Classification","Orders","Events","Total Spend","Last Activity","Notes"].map(h => (
                      <th key={h} style={{ padding: "6px 8px", textAlign: h==="Total Spend"?"right":"left", color: T.textMuted, fontSize: 9, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700 }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {enriched.map((c, i) => {
                    const classColor = c.classification === "VIP" ? T.warning : c.classification === "New" ? T.info : T.textMuted;
                    return (
                      <tr key={c.id} style={{ borderBottom: `1px solid ${T.border}20`, background: c.classification === "VIP" ? T.warning + "08" : "transparent" }}>
                        <td style={{ padding: "7px 8px", color: T.textDim, fontSize: 10 }}>{i+1}</td>
                        <td style={{ padding: "7px 8px", fontWeight: 700, color: T.text }}>{c.name}</td>
                        <td style={{ padding: "7px 8px" }}>
                          <span style={{ fontSize: 9, fontWeight: 700, color: classColor, background: classColor + "18", padding: "2px 7px", borderRadius: 10 }}>{c.classification}</span>
                        </td>
                        <td style={{ padding: "7px 8px", color: T.textMuted, textAlign: "center" }}>{c.orderCount}</td>
                        <td style={{ padding: "7px 8px", color: T.textMuted, textAlign: "center" }}>{c.eventCount}</td>
                        <td style={{ padding: "7px 8px", textAlign: "right", fontWeight: 800, color: c.totalSpend > 0 ? T.accent : T.textDim }}>
                          {c.totalSpend > 0 ? fmt(c.totalSpend) : "—"}
                        </td>
                        <td style={{ padding: "7px 8px", color: T.textDim, fontSize: 10 }}>{c.lastActivity || "—"}</td>
                        <td style={{ padding: "7px 8px", color: T.textDim, fontSize: 10, maxWidth: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.notes || "—"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {allCustomers.length === 0 && <div style={{ padding: 16, color: T.textDim, fontSize: 11 }}>No customers recorded yet.</div>}
            </div>
          </div>
        );
      })()}

      {/* ── EXPENSE LEDGER ── */}
      {reportType === "expenses" && (() => {
        const pOH = d.pOverheads;
        const opex = pOH.filter(o => (o.entryType||"opex") === "opex");
        const capexList = pOH.filter(o => (o.entryType||"opex") === "capex");
        const liabList = pOH.filter(o => o.entryType === "liability_payment");

        const totalOpex = opex.reduce((s,o) => s + Number(o.amount), 0);
        const totalCapex = capexList.reduce((s,o) => s + Number(o.amount), 0);
        const totalLiab = liabList.reduce((s,o) => s + Number(o.amount), 0);
        const unpaidOpex = opex.filter(o => o.paymentStatus === "unpaid");
        const totalUnpaid = unpaidOpex.reduce((s,o) => s + Number(o.amount), 0);

        // By vendor
        const byVendor = {};
        pOH.forEach(o => {
          const v = o.vendor || "Unspecified";
          byVendor[v] = (byVendor[v] || 0) + Number(o.amount);
        });
        const topVendors = Object.entries(byVendor).sort((a,b)=>b[1]-a[1]).slice(0,5);

        const entryTypeLabel = { opex: "Operating", capex: "Asset Purchase", liability_payment: "Liability Payment" };
        const entryTypeColor = { opex: T.danger, capex: T.warning, liability_payment: T.info };

        return (
          <div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8, marginBottom: 14 }}>
              {[
                ["Operating Expenses", fmt(totalOpex), `${opex.length} entries`, T.danger],
                ["Asset Purchases", fmt(totalCapex), `${capexList.length} items`, T.warning],
                ["Liability Payments", fmt(totalLiab), `${liabList.length} entries`, T.info],
                ["Accounts Payable", fmt(totalUnpaid), `${unpaidOpex.length} unpaid`, T.danger],
              ].map(([label, val, sub, color]) => (
                <div key={label} style={{ background: T.surface, borderRadius: 8, padding: "10px 13px" }}>
                  <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 2, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</div>
                  <div style={{ fontSize: 16, fontWeight: 900, color }}>{val}</div>
                  <div style={{ fontSize: 10, color: T.textDim, marginTop: 2 }}>{sub}</div>
                </div>
              ))}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 10 }}>
              <div style={S.card}>
                <div style={S.cardTitle}>📋 Full Expense Ledger — {d.period.label}</div>
                {unpaidOpex.length > 0 && (
                  <div style={{ background: T.danger + "12", border: `1px solid ${T.danger}30`, borderRadius: 6, padding: "7px 10px", marginBottom: 10, fontSize: 11 }}>
                    ⚠️ <strong>{unpaidOpex.length} unpaid expense{unpaidOpex.length > 1 ? "s" : ""}</strong> totalling <strong>{fmt(totalUnpaid)} XAF</strong> outstanding.
                  </div>
                )}
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
                  <thead>
                    <tr style={{ background: T.surface }}>
                      {["Date","Category","Description","Vendor","Type","Amount","Status"].map(h => (
                        <th key={h} style={{ padding: "5px 7px", textAlign: h==="Amount"?"right":"left", color: T.textMuted, fontSize: 9, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700 }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {[...pOH].sort((a,b) => new Date(b.date)-new Date(a.date)).map((o,i) => {
                      const isPaid = o.paymentStatus !== "unpaid";
                      return (
                        <tr key={i} style={{ borderBottom: `1px solid ${T.border}20`, background: !isPaid ? T.danger + "06" : "transparent" }}>
                          <td style={{ padding: "6px 7px", color: T.textMuted, fontSize: 10, whiteSpace: "nowrap" }}>{o.date}</td>
                          <td style={{ padding: "6px 7px", fontSize: 10, color: T.text }}>{o.category}</td>
                          <td style={{ padding: "6px 7px", fontSize: 10, color: T.textMuted, maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={o.description}>{o.description}</td>
                          <td style={{ padding: "6px 7px", fontSize: 10, color: T.textDim }}>{o.vendor || "—"}</td>
                          <td style={{ padding: "6px 7px" }}>
                            <span style={{ fontSize: 9, fontWeight: 700, color: entryTypeColor[o.entryType||"opex"], background: (entryTypeColor[o.entryType||"opex"]) + "15", padding: "2px 5px", borderRadius: 8 }}>
                              {entryTypeLabel[o.entryType||"opex"]}
                            </span>
                          </td>
                          <td style={{ padding: "6px 7px", textAlign: "right", fontWeight: 700, color: T.text }}>{fmt(Number(o.amount))}</td>
                          <td style={{ padding: "6px 7px" }}>
                            <span style={{ fontSize: 9, fontWeight: 700, color: isPaid ? T.success : T.danger }}>
                              {isPaid ? "✅ Paid" : "⏳ Unpaid"}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {pOH.length === 0 && <div style={{ padding: 16, color: T.textDim, fontSize: 11 }}>No expenses recorded for this period.</div>}
              </div>
              <div>
                <div style={S.card}>
                  <div style={S.cardTitle}>🏢 Top Vendors / Suppliers</div>
                  {topVendors.map(([vendor, amt]) => (
                    <div key={vendor} style={{ marginBottom: 9 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                        <span style={{ fontSize: 11, color: T.text }}>{vendor}</span>
                        <span style={{ fontSize: 11, fontWeight: 700 }}>{fmt(amt)}</span>
                      </div>
                      <div style={{ height: 5, background: T.surface, borderRadius: 3 }}>
                        <div style={{ height: 5, borderRadius: 3, background: T.danger, width: `${(totalOpex+totalCapex) > 0 ? (amt/(totalOpex+totalCapex))*100 : 0}%`, opacity: 0.7 }} />
                      </div>
                    </div>
                  ))}
                  {topVendors.length === 0 && <div style={{ color: T.textDim, fontSize: 11 }}>No vendor data.</div>}
                </div>
                <div style={{ ...S.card, marginTop: 10 }}>
                  <div style={S.cardTitle}>📊 Expense Breakdown</div>
                  {[
                    ["Operating (P&L)", totalOpex, T.danger],
                    ["Asset Purchases", totalCapex, T.warning],
                    ["Liability Payments", totalLiab, T.info],
                  ].map(([label, val, color]) => (
                    <div key={label} style={{ marginBottom: 9 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                        <span style={{ fontSize: 11, color: T.textMuted }}>{label}</span>
                        <span style={{ fontSize: 11, fontWeight: 700, color }}>{fmt(val)}</span>
                      </div>
                      <div style={{ height: 5, background: T.surface, borderRadius: 3 }}>
                        <div style={{ height: 5, borderRadius: 3, background: color, width: `${(totalOpex+totalCapex+totalLiab)>0?(val/(totalOpex+totalCapex+totalLiab))*100:0}%` }} />
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ ...S.card, marginTop: 10 }}>
                  <div style={S.cardTitle}>⚠️ Unpaid Expenses (AP)</div>
                  {unpaidOpex.length === 0
                    ? <div style={{ color: T.success, fontSize: 11, fontWeight: 700 }}>✅ All expenses paid</div>
                    : unpaidOpex.map((o,i) => (
                        <div key={i} style={{ padding: "6px 0", borderBottom: `1px solid ${T.border}20` }}>
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ fontSize: 11, color: T.text, fontWeight: 600 }}>{o.description}</span>
                            <span style={{ fontSize: 11, fontWeight: 800, color: T.danger }}>{fmt(Number(o.amount))}</span>
                          </div>
                          <div style={{ fontSize: 9, color: T.textDim }}>{o.vendor} · {o.date}</div>
                        </div>
                      ))
                  }
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {reportType === "prepaid" && (() => {
        const TODAY = TODAY_ISO;
        const EMPTY_PREPAID = { name: "", category: "Rent", startDate: TODAY.slice(0,7), months: "12", totalPaid: "", paymentDate: TODAY, notes: "" };
        const EMPTY_DEPOSIT = { name: "", amount: "", paidDate: TODAY, landlord: "", notes: "", status: "held" };
        // Local state inside IIFE won't persist — need component. Wrap in a sub-component.
        return <PrepaidDepositsPanel prepaidItems={prepaidItems} setPrepaidItems={setPrepaidItems} deposits={deposits} setDeposits={setDeposits} />;
      })()}

    </div>
  );
}

function PrepaidDepositsPanel({ prepaidItems, setPrepaidItems, deposits, setDeposits }) {
  const TODAY = TODAY_ISO;
  const EMPTY_PREPAID = { name: "", category: "Rent", startDate: TODAY.slice(0,7), months: "12", totalPaid: "", paymentDate: TODAY, notes: "" };
  const EMPTY_DEPOSIT = { name: "", amount: "", paidDate: TODAY, party: "", notes: "", status: "held" };
  const [showPrepaidForm, setShowPrepaidForm] = useState(false);
  const [prepaidForm, setPrepaidForm] = useState(EMPTY_PREPAID);
  const [editPrepaidId, setEditPrepaidId] = useState(null);
  const [showDepositForm, setShowDepositForm] = useState(false);
  const [depositForm, setDepositForm] = useState(EMPTY_DEPOSIT);
  const [editDepositId, setEditDepositId] = useState(null);
  const [viewItem, setViewItem] = useState(null); // { type: "prepaid"|"deposit", data: enrichedItem }

  // Compute recognition status for each prepaid
  const NOW_YEAR = new Date().getFullYear();
  const NOW_MONTH = new Date().getMonth() + 1;

  const enriched = (prepaidItems || []).map(item => {
    const monthly = Number(item.totalPaid) / Number(item.months);
    const startY = Number(item.startDate.slice(0,4));
    const startM = Number(item.startDate.slice(5,7));
    // How many months have elapsed (including current)?
    const elapsed = (NOW_YEAR - startY) * 12 + (NOW_MONTH - startM) + 1;
    const recognized = Math.min(Math.max(elapsed, 0), Number(item.months)) * monthly;
    const remaining = Number(item.totalPaid) - recognized;
    const endYear = startY + Math.floor((startM - 1 + Number(item.months)) / 12);
    const endMonth = ((startM - 1 + Number(item.months)) % 12) + 1;
    const endDate = `${endYear}-${String(endMonth).padStart(2,"0")}`;
    return { ...item, monthly, recognized, remaining, endDate };
  });

  const totalPrepaidAsset = enriched.reduce((s, i) => s + i.remaining, 0);
  const totalDeposits = (deposits || []).filter(d => d.status === "held").reduce((s, d) => s + Number(d.amount || 0), 0);

  const savePrepaid = () => {
    if (!prepaidForm.name || !prepaidForm.totalPaid || !prepaidForm.months || !prepaidForm.startDate) return;
    if (editPrepaidId) {
      setPrepaidItems(prev => prev.map(x => x.id === editPrepaidId ? { ...prepaidForm, id: editPrepaidId } : x));
    } else {
      setPrepaidItems(prev => [{ ...prepaidForm, id: Date.now() }, ...prev]);
    }
    setPrepaidForm(EMPTY_PREPAID); setEditPrepaidId(null); setShowPrepaidForm(false);
  };

  const saveDeposit = () => {
    if (!depositForm.name || !depositForm.amount) return;
    if (editDepositId) {
      setDeposits(prev => prev.map(x => x.id === editDepositId ? { ...depositForm, id: editDepositId } : x));
    } else {
      setDeposits(prev => [{ ...depositForm, id: Date.now() }, ...prev]);
    }
    setDepositForm(EMPTY_DEPOSIT); setEditDepositId(null); setShowDepositForm(false);
  };

  return (
    <div>
      {/* Summary bar */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8, marginBottom: 16 }}>
        {[
          ["Prepaid Asset Balance", fmt(totalPrepaidAsset), "Total unrecognized prepaid costs", T.accent],
          ["Security Deposits Held", fmt(totalDeposits), "Refundable — not an expense", T.info],
          ["Active Schedules", String(enriched.length), `${(deposits||[]).length} deposit(s)`, T.text],
        ].map(([label, val, sub, color]) => (
          <div key={label} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, padding: 12 }}>
            <div style={{ fontSize: 10, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.7, marginBottom: 4 }}>{label}</div>
            <div style={{ fontSize: 18, fontWeight: 800, color }}>{val}</div>
            <div style={{ fontSize: 10, color: T.textDim, marginTop: 2 }}>{sub}</div>
          </div>
        ))}
      </div>

      {/* ── PREPAID EXPENSES ── */}
      <div style={{ ...S.sectionTitle, marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>🗓️ Prepaid Expenses</span>
        <button style={{ ...S.btn("primary"), fontSize: 11 }} onClick={() => { setPrepaidForm(EMPTY_PREPAID); setEditPrepaidId(null); setShowPrepaidForm(true); }}>+ Add</button>
      </div>
      <div style={{ fontSize: 11, color: T.textMuted, marginBottom: 10 }}>
        The lump-sum you paid is spread monthly across the P&amp;L. Each month's slice reduces recognized balance automatically.
      </div>

      {showPrepaidForm && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, padding: 14, marginBottom: 14 }}>
          <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 10 }}>{editPrepaidId ? "Edit Prepaid" : "New Prepaid Expense"}</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <label style={S.label}>Description *</label>
              <input style={S.input} placeholder="e.g. Annual Rent 2026" value={prepaidForm.name} onChange={e => setPrepaidForm(f => ({ ...f, name: e.target.value }))} />
            </div>
            <div>
              <label style={S.label}>Category</label>
              <select style={S.select} value={prepaidForm.category} onChange={e => setPrepaidForm(f => ({ ...f, category: e.target.value }))}>
                {["Rent","Insurance","License / Permit","Software / Subscription","Other"].map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <label style={S.label}>Total Amount Paid (XAF) *</label>
              <input type="number" style={S.input} placeholder="e.g. 1200000" value={prepaidForm.totalPaid} onChange={e => setPrepaidForm(f => ({ ...f, totalPaid: e.target.value }))} />
            </div>
            <div>
              <label style={S.label}>Amortization Months *</label>
              <input type="number" style={S.input} placeholder="12" min="1" max="60" value={prepaidForm.months} onChange={e => setPrepaidForm(f => ({ ...f, months: e.target.value }))} />
            </div>
            <div>
              <label style={S.label}>First Recognition Month *</label>
              <input type="month" style={S.input} value={prepaidForm.startDate} onChange={e => setPrepaidForm(f => ({ ...f, startDate: e.target.value }))} />
            </div>
            <div>
              <label style={S.label}>Payment Date</label>
              <input type="date" style={S.input} value={prepaidForm.paymentDate} onChange={e => setPrepaidForm(f => ({ ...f, paymentDate: e.target.value }))} />
            </div>
            <div style={{ gridColumn: "1/-1" }}>
              <label style={S.label}>Notes</label>
              <input style={S.input} placeholder="Optional" value={prepaidForm.notes} onChange={e => setPrepaidForm(f => ({ ...f, notes: e.target.value }))} />
            </div>
          </div>
          {prepaidForm.totalPaid && prepaidForm.months && (
            <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 14px", marginTop: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: 10, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.7 }}>Monthly Recognition</div>
                <div style={{ fontSize: 18, fontWeight: 800, color: T.accent }}>{fmt(Number(prepaidForm.totalPaid) / Number(prepaidForm.months))}</div>
              </div>
              <div style={{ fontSize: 11, color: T.textMuted, textAlign: "right" }}>
                {fmt(Number(prepaidForm.totalPaid))} ÷ {prepaidForm.months} months
              </div>
            </div>
          )}
          <div style={{ ...S.row, marginTop: 12, gap: 8 }}>
            <button style={S.btn("primary")} onClick={savePrepaid}>Save</button>
            <button style={S.btn("ghost")} onClick={() => { setShowPrepaidForm(false); setEditPrepaidId(null); }}>Cancel</button>
          </div>
        </div>
      )}

      {enriched.length === 0 && !showPrepaidForm ? (
        <div style={{ textAlign: "center", padding: 30, color: T.textMuted, fontSize: 13 }}>No prepaid schedules yet.</div>
      ) : (
        <div style={{ overflowX: "auto", marginBottom: 20 }}>
          <table style={S.table}>
            <thead>
              <tr>{["Description","Category","Paid","Monthly","Start","End","Recognized","Remaining",""].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {enriched.map(item => {
                const pct = Number(item.totalPaid) > 0 ? (item.recognized / Number(item.totalPaid)) * 100 : 0;
                return (
                  <tr key={item.id} style={{ cursor: "pointer" }} onClick={() => setViewItem({ type: "prepaid", data: item })}>
                    <td style={{ ...S.td, fontWeight: 600, color: T.accent }}>{item.name}</td>
                    <td style={S.td}>{item.category}</td>
                    <td style={S.td}>{fmt(Number(item.totalPaid))}</td>
                    <td style={{ ...S.td, color: T.accent, fontWeight: 700 }}>{fmt(item.monthly)}</td>
                    <td style={S.td}>{item.startDate}</td>
                    <td style={S.td}>{item.endDate}</td>
                    <td style={S.td}>
                      <div>{fmt(item.recognized)}</div>
                      <div style={{ marginTop: 3, background: T.border, borderRadius: 3, height: 4, width: 80 }}>
                        <div style={{ background: T.accent, borderRadius: 3, height: 4, width: `${Math.min(pct,100).toFixed(0)}%` }} />
                      </div>
                    </td>
                    <td style={{ ...S.td, fontWeight: 700, color: item.remaining > 0 ? T.warning : T.textDim }}>{fmt(item.remaining)}</td>
                    <td style={S.td} onClick={e => e.stopPropagation()}>
                      <button style={{ background: "none", border: "none", color: T.textMuted, cursor: "pointer", fontSize: 13, marginRight: 4 }} title="View details"
                        onClick={() => setViewItem({ type: "prepaid", data: item })}>👁</button>
                      <button style={{ background: "none", border: "none", color: T.accent, cursor: "pointer", fontSize: 11, marginRight: 6 }}
                        onClick={() => { setPrepaidForm({ name: item.name, category: item.category, startDate: item.startDate, months: String(item.months), totalPaid: String(item.totalPaid), paymentDate: item.paymentDate || TODAY, notes: item.notes || "" }); setEditPrepaidId(item.id); setShowPrepaidForm(true); }}>✏️</button>
                      <button style={{ background: "none", border: "none", color: T.danger, cursor: "pointer", fontSize: 11 }}
                        onClick={() => { if (window.confirm("Delete this prepaid schedule?")) setPrepaidItems(prev => prev.filter(x => x.id !== item.id)); }}>✕</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* ── SECURITY DEPOSITS ── */}
      <div style={{ ...S.sectionTitle, marginBottom: 8, marginTop: 4, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>🔐 Security Deposits (Caution)</span>
        <button style={{ ...S.btn("primary"), fontSize: 11 }} onClick={() => { setDepositForm(EMPTY_DEPOSIT); setEditDepositId(null); setShowDepositForm(true); }}>+ Add</button>
      </div>
      <div style={{ fontSize: 11, color: T.textMuted, marginBottom: 10 }}>
        Refundable deposits — tracked as an asset, never charged to P&amp;L unless forfeited.
      </div>

      {showDepositForm && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, padding: 14, marginBottom: 14 }}>
          <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 10 }}>{editDepositId ? "Edit Deposit" : "New Security Deposit"}</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <label style={S.label}>Description *</label>
              <input style={S.input} placeholder="e.g. Shop caution — Marché Central" value={depositForm.name} onChange={e => setDepositForm(f => ({ ...f, name: e.target.value }))} />
            </div>
            <div>
              <label style={S.label}>Amount (XAF) *</label>
              <input type="number" style={S.input} placeholder="e.g. 500000" value={depositForm.amount} onChange={e => setDepositForm(f => ({ ...f, amount: e.target.value }))} />
            </div>
            <div>
              <label style={S.label}>Paid To (Landlord / Party)</label>
              <input style={S.input} placeholder="e.g. M. Nkeng Joseph" value={depositForm.party} onChange={e => setDepositForm(f => ({ ...f, party: e.target.value }))} />
            </div>
            <div>
              <label style={S.label}>Date Paid</label>
              <input type="date" style={S.input} value={depositForm.paidDate} onChange={e => setDepositForm(f => ({ ...f, paidDate: e.target.value }))} />
            </div>
            <div>
              <label style={S.label}>Status</label>
              <select style={S.select} value={depositForm.status} onChange={e => setDepositForm(f => ({ ...f, status: e.target.value }))}>
                <option value="held">Held (refundable)</option>
                <option value="returned">Returned</option>
                <option value="forfeited">Forfeited (write off to expenses)</option>
              </select>
            </div>
            <div>
              <label style={S.label}>Notes</label>
              <input style={S.input} placeholder="Optional" value={depositForm.notes} onChange={e => setDepositForm(f => ({ ...f, notes: e.target.value }))} />
            </div>
          </div>
          <div style={{ ...S.row, marginTop: 12, gap: 8 }}>
            <button style={S.btn("primary")} onClick={saveDeposit}>Save</button>
            <button style={S.btn("ghost")} onClick={() => { setShowDepositForm(false); setEditDepositId(null); }}>Cancel</button>
          </div>
        </div>
      )}

      {(!deposits || deposits.length === 0) && !showDepositForm ? (
        <div style={{ textAlign: "center", padding: 30, color: T.textMuted, fontSize: 13 }}>No deposits recorded yet.</div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={S.table}>
            <thead>
              <tr>{["Description","Amount","Paid To","Date Paid","Status","Notes",""].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {(deposits || []).map(dep => (
                <tr key={dep.id} style={{ cursor: "pointer" }} onClick={() => setViewItem({ type: "deposit", data: dep })}>
                  <td style={{ ...S.td, fontWeight: 600, color: T.accent }}>{dep.name}</td>
                  <td style={{ ...S.td, fontWeight: 700, color: T.accent }}>{fmt(Number(dep.amount || 0))}</td>
                  <td style={S.td}>{dep.party || "—"}</td>
                  <td style={S.td}>{dep.paidDate || "—"}</td>
                  <td style={S.td}>
                    <span style={{ padding: "2px 8px", borderRadius: 10, fontSize: 10, fontWeight: 700, background: dep.status === "held" ? T.info + "22" : dep.status === "returned" ? T.success + "22" : T.danger + "22", color: dep.status === "held" ? T.info : dep.status === "returned" ? T.success : T.danger }}>
                      {dep.status === "held" ? "Held" : dep.status === "returned" ? "Returned" : "Forfeited"}
                    </span>
                  </td>
                  <td style={{ ...S.td, color: T.textMuted, fontSize: 11 }}>{dep.notes || "—"}</td>
                  <td style={S.td} onClick={e => e.stopPropagation()}>
                    <button style={{ background: "none", border: "none", color: T.textMuted, cursor: "pointer", fontSize: 13, marginRight: 4 }} title="View details"
                      onClick={() => setViewItem({ type: "deposit", data: dep })}>👁</button>
                    <button style={{ background: "none", border: "none", color: T.accent, cursor: "pointer", fontSize: 11, marginRight: 6 }}
                      onClick={() => { setDepositForm({ name: dep.name, amount: String(dep.amount), party: dep.party || "", paidDate: dep.paidDate || TODAY, status: dep.status || "held", notes: dep.notes || "" }); setEditDepositId(dep.id); setShowDepositForm(true); }}>✏️</button>
                    <button style={{ background: "none", border: "none", color: T.danger, cursor: "pointer", fontSize: 11 }}
                      onClick={() => { if (window.confirm("Delete this deposit record?")) setDeposits(prev => prev.filter(x => x.id !== dep.id)); }}>✕</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ── VIEW DETAIL MODAL ── */}
      {viewItem && (() => {
        const { type, data } = viewItem;
        const isPrepaid = type === "prepaid";
        const Field = ({ label, value, accent, large }) => (
          <div style={{ marginBottom: 10 }}>
            <div style={{ fontSize: 10, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.7, marginBottom: 2 }}>{label}</div>
            <div style={{ fontSize: large ? 18 : 13, fontWeight: large ? 800 : 500, color: accent ? T.accent : T.text }}>{value || "—"}</div>
          </div>
        );
        return (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 1500, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
            onClick={() => setViewItem(null)}>
            <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 14, padding: 20, width: "100%", maxWidth: 420, maxHeight: "90vh", overflowY: "auto" }}
              onClick={e => e.stopPropagation()}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
                <div style={{ fontSize: 15, fontWeight: 800, color: T.text }}>
                  {isPrepaid ? "🗓️ Prepaid Expense" : "🔐 Security Deposit"}
                </div>
                <button style={{ background: "none", border: "none", color: T.textMuted, cursor: "pointer", fontSize: 18, lineHeight: 1 }} onClick={() => setViewItem(null)}>✕</button>
              </div>

              {isPrepaid ? (
                <Fragment>
                  <Field label="Description" value={data.name} large />
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 4 }}>
                    <Field label="Category" value={data.category} />
                    <Field label="Payment Date" value={data.paymentDate} />
                    <Field label="Total Paid" value={fmt(Number(data.totalPaid))} accent />
                    <Field label="Monthly Recognition" value={fmt(data.monthly)} accent />
                    <Field label="Start Month" value={data.startDate} />
                    <Field label="End Month" value={data.endDate} />
                    <Field label="Months" value={`${data.months} months`} />
                    <Field label="Status" value={data.remaining > 0 ? `Active — ${Number(data.months) - Math.round(data.recognized / data.monthly)} mo. left` : "Fully recognized"} />
                  </div>
                  <div style={{ background: T.surface, borderRadius: 8, padding: "10px 12px", marginBottom: 10 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                      <span style={{ fontSize: 11, color: T.textMuted }}>Recognized so far</span>
                      <span style={{ fontSize: 12, fontWeight: 700 }}>{fmt(data.recognized)}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                      <span style={{ fontSize: 11, color: T.textMuted }}>Prepaid asset remaining</span>
                      <span style={{ fontSize: 12, fontWeight: 700, color: data.remaining > 0 ? T.warning : T.textDim }}>{fmt(data.remaining)}</span>
                    </div>
                    <div style={{ background: T.border, borderRadius: 4, height: 6 }}>
                      <div style={{ background: T.accent, borderRadius: 4, height: 6, width: `${Math.min((data.recognized / Number(data.totalPaid)) * 100, 100).toFixed(0)}%`, transition: "width 0.3s" }} />
                    </div>
                    <div style={{ fontSize: 10, color: T.textDim, marginTop: 4, textAlign: "right" }}>
                      {((data.recognized / Number(data.totalPaid)) * 100).toFixed(0)}% recognized
                    </div>
                  </div>
                  {data.notes && <Field label="Notes" value={data.notes} />}
                </Fragment>
              ) : (
                <Fragment>
                  <Field label="Description" value={data.name} large />
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 4 }}>
                    <Field label="Amount" value={fmt(Number(data.amount || 0))} accent />
                    <Field label="Date Paid" value={data.paidDate} />
                    <Field label="Paid To" value={data.party} />
                    <div>
                      <div style={{ fontSize: 10, color: T.textMuted, textTransform: "uppercase", letterSpacing: 0.7, marginBottom: 4 }}>Status</div>
                      <span style={{ padding: "3px 10px", borderRadius: 10, fontSize: 11, fontWeight: 700, background: data.status === "held" ? T.info + "22" : data.status === "returned" ? T.success + "22" : T.danger + "22", color: data.status === "held" ? T.info : data.status === "returned" ? T.success : T.danger }}>
                        {data.status === "held" ? "Held (refundable)" : data.status === "returned" ? "Returned" : "Forfeited"}
                      </span>
                    </div>
                  </div>
                  {data.notes && <Field label="Notes" value={data.notes} />}
                </Fragment>
              )}

              <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
                <button style={{ ...S.btn("primary"), flex: 1 }} onClick={() => {
                  setViewItem(null);
                  if (isPrepaid) {
                    setPrepaidForm({ name: data.name, category: data.category, startDate: data.startDate, months: String(data.months), totalPaid: String(data.totalPaid), paymentDate: data.paymentDate || TODAY, notes: data.notes || "" });
                    setEditPrepaidId(data.id); setShowPrepaidForm(true);
                  } else {
                    setDepositForm({ name: data.name, amount: String(data.amount), party: data.party || "", paidDate: data.paidDate || TODAY, status: data.status || "held", notes: data.notes || "" });
                    setEditDepositId(data.id); setShowDepositForm(true);
                  }
                }}>✏️ Edit</button>
                <button style={{ ...S.btn("ghost"), flex: 1 }} onClick={() => setViewItem(null)}>Close</button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

function buildReportHTML(reportType, title, d, biz) {
  const fmtN = (n) => Math.round(n || 0).toLocaleString("en-US") + " XAF";
  const dateRange = `${d.from.toLocaleDateString("fr-CM", { day: "2-digit", month: "short", year: "numeric" })} – ${d.to.toLocaleDateString("fr-CM", { day: "2-digit", month: "short", year: "numeric" })}`;
  const rows = (items) =>
    items.map(([label, value, bold, color]) =>
      `<tr style="${bold ? "font-weight:700;" : ""}"><td style="padding:7px 12px;font-size:12px;color:${color || "#333"}">${label}</td><td style="padding:7px 12px;font-size:12px;text-align:right;font-weight:${bold ? 700 : 500};color:${color || "#111"}">${value}</td></tr>`
    ).join("");

  const css = `<style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:'Helvetica Neue',Arial,sans-serif;color:#1a1a1a;background:#fff;padding:40px;font-size:13px}
  .section{margin-bottom:22px}.section-title{font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#888;margin-bottom:8px;padding-bottom:4px;border-bottom:2px solid #1a1a1a}
  table{width:100%;border-collapse:collapse;margin-bottom:12px}tr:nth-child(even) td{background:#fafafa}
  td{padding:7px 12px;font-size:12px;border-bottom:1px solid #ebebeb}
  .total-row td{font-weight:800;font-size:13px;background:#1a1a1a;color:#fff;padding:10px 12px}
  .highlight td{background:#f0fdf4!important}.danger td{background:#fff5f5!important}
  .kpi-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:20px}
  .kpi{background:#f8f8f8;border-radius:8px;padding:12px 14px}
  .kpi .label{font-size:10px;color:#888;margin-bottom:4px;text-transform:uppercase;letter-spacing:0.5px}
  .kpi .value{font-size:18px;font-weight:900;color:#1a1a1a}
  .indent td:first-child{padding-left:24px;color:#555}
  @media print{body{padding:20px}}</style>`;

  const header = `<div style="display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #1a1a1a;padding-bottom:16px;margin-bottom:20px">
    <div><div style="font-size:24px;font-weight:900">${biz.name}</div><div style="font-size:11px;color:#888">${biz.tagline} · ${biz.city}</div></div>
    <div style="text-align:right"><div style="font-size:11px;font-weight:700;color:#888;text-transform:uppercase;letter-spacing:1px">${title}</div>
    <div style="font-size:18px;font-weight:900">${d.period.label}</div>
    <div style="font-size:11px;color:#888">${dateRange}</div></div>
  </div>`;

  const footer = `<div style="margin-top:30px;padding-top:16px;border-top:1px solid #ddd;text-align:center;font-size:11px;color:#aaa">Generated by ${biz.name} · ${new Date().toLocaleDateString()} · ${title}</div>`;

  // ── P&L ──────────────────────────────────────────────────────────
  if (reportType === "pl") {
    const body = `
    <div class="kpi-grid">
      <div class="kpi"><div class="label">Total Revenue</div><div class="value">${fmtN(d.totalRevenue)}</div></div>
      <div class="kpi"><div class="label">Gross Profit</div><div class="value">${fmtN(d.grossProfit)}</div></div>
      <div class="kpi"><div class="label">Net Profit</div><div class="value" style="color:${d.operatingProfit >= 0 ? "#16a34a" : "#dc2626"}">${fmtN(d.operatingProfit)}</div></div>
    </div>
    <div class="section"><div class="section-title">Revenue</div><table>
      ${rows([["Restaurant & Delivery Sales", fmtN(d.rdRevenue), false, "#333"],["Catering Events Revenue", fmtN(d.catRevenue), false, "#333"]])}
      <tr class="total-row"><td>Total Revenue</td><td style="text-align:right">${fmtN(d.totalRevenue)}</td></tr>
    </table></div>
    <div class="section"><div class="section-title">Cost of Goods Sold</div><table>
      ${rows([["Restaurant & Delivery COGS", fmtN(d.rdCOGS), false, "#333"],["Catering Events COGS", fmtN(d.catCOGS), false, "#333"]])}
      <tr class="total-row"><td>Total COGS</td><td style="text-align:right">${fmtN(d.totalCOGS)}</td></tr>
      <tr class="highlight"><td style="font-weight:700;padding:8px 12px">Gross Profit</td><td style="text-align:right;font-weight:800;color:#16a34a;padding:8px 12px">${fmtN(d.grossProfit)}</td></tr>
    </table></div>
    <div class="section"><div class="section-title">Operating Expenses (Overhead)</div><table>
      ${Object.entries(d.ohByCategory).map(([cat, amt]) => `<tr class="indent"><td>${cat}</td><td style="text-align:right;color:#333;font-weight:500">${fmtN(amt)}</td></tr>`).join("")}
      ${Object.keys(d.ohByCategory).length === 0 ? '<tr><td colspan="2" style="padding:10px 12px;color:#aaa">No overhead expenses recorded for this period.</td></tr>' : ""}
      <tr class="total-row"><td>Total Operating Expenses</td><td style="text-align:right">${fmtN(d.totalOverheads)}</td></tr>
      <tr style="${d.operatingProfit >= 0 ? "background:#f0fdf4" : "background:#fff5f5"}"><td style="font-weight:800;padding:10px 12px;font-size:14px">NET PROFIT / (LOSS)</td><td style="text-align:right;font-weight:900;font-size:16px;padding:10px 12px;color:${d.operatingProfit >= 0 ? "#16a34a" : "#dc2626"}">${fmtN(d.operatingProfit)}</td></tr>
    </table></div>`;
    return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title>${css}</head><body>${header}${body}${footer}</body></html>`;
  }

  // ── BALANCE SHEET ────────────────────────────────────────────────
  if (reportType === "bs") {
    const totalCurrent = Math.max(0, d.totalCashReceived - d.allTimeOpex - d.allTimeCOGS) + d.arOutstanding + d.invValue;
    const totalAssets = totalCurrent + d.fixedAssetValue;
    const totalCurrLiab = d.allOh.ap + d.allOh.capexAP;
    const totalLiab = totalCurrLiab;
    const ownersCapital = d.fixedAssetValue > 0 ? 0 : 450000;
    const equity = d.retainedEarnings + ownersCapital;
    const currentRatio = totalCurrLiab > 0 ? (totalCurrent / totalCurrLiab).toFixed(2) : "∞";
    const capexRows = d.allOh.capex.length === 0
      ? rows([["Fixed Assets (no capex recorded)", fmtN(0), false, "#999"]])
      : d.allOh.capex.map(a => `<tr class="indent"><td>${a.assetName || a.description}</td><td style="text-align:right">${fmtN(a.amount)}</td></tr>`).join("");
    const apRows = d.allOh.opex.filter(o => o.paymentStatus === "unpaid").length === 0
      ? '<tr><td colspan="2" style="padding:10px 12px;color:#aaa">No unpaid expenses.</td></tr>'
      : d.allOh.opex.filter(o => o.paymentStatus === "unpaid").map(o => `<tr class="indent"><td>${o.description}${o.vendor ? " · " + o.vendor : ""}</td><td style="text-align:right;color:#dc2626">${fmtN(o.amount)}</td></tr>`).join("");
    const body = `
    <div class="kpi-grid">
      <div class="kpi"><div class="label">Total Assets</div><div class="value">${fmtN(totalAssets)}</div></div>
      <div class="kpi"><div class="label">Total Liabilities</div><div class="value" style="color:#dc2626">${fmtN(totalLiab)}</div></div>
      <div class="kpi"><div class="label">Equity</div><div class="value" style="color:${equity >= 0 ? "#16a34a" : "#dc2626"}">${fmtN(equity)}</div></div>
    </div>
    <p style="font-size:10px;color:#888;margin-bottom:16px">As at ${d.to.toLocaleDateString("fr-CM", { day: "2-digit", month: "short", year: "numeric" })} · Based on recorded transactions</p>
    <div class="section"><div class="section-title">Current Assets</div><table>
      ${rows([["Cash & Cash Equivalents (est.)", fmtN(Math.max(0, d.totalCashReceived - d.allTimeOpex - d.allTimeCOGS)), false, "#333"],["Accounts Receivable (open invoices)", fmtN(d.arOutstanding), false, "#333"],["Inventory at Cost", fmtN(d.invValue), false, "#333"]])}
      <tr class="total-row"><td>Total Current Assets</td><td style="text-align:right">${fmtN(totalCurrent)}</td></tr>
    </table></div>
    <div class="section"><div class="section-title">Non-Current Assets (Fixed Assets)</div><table>
      ${capexRows}
      <tr class="total-row"><td>Total Fixed Assets (gross)</td><td style="text-align:right">${fmtN(d.fixedAssetValue)}</td></tr>
      <tr style="background:#f0f7ff"><td style="font-weight:800;padding:10px 12px">TOTAL ASSETS</td><td style="text-align:right;font-weight:900;font-size:14px;padding:10px 12px;color:#1d4ed8">${fmtN(totalAssets)}</td></tr>
    </table></div>
    <div class="section"><div class="section-title">Current Liabilities</div><table>
      ${rows([["Accounts Payable (unpaid opex)", fmtN(d.allOh.ap), false, "#dc2626"],["Payable on Asset Purchases", fmtN(d.allOh.capexAP), false, "#dc2626"]])}
      <tr class="total-row"><td>Total Current Liabilities</td><td style="text-align:right">${fmtN(totalCurrLiab)}</td></tr>
    </table></div>
    <div class="section"><div class="section-title">Equity</div><table>
      ${rows([["Retained Earnings (cumulative net profit)", fmtN(d.retainedEarnings), false, d.retainedEarnings >= 0 ? "#16a34a" : "#dc2626"],["Owner's Capital (est.)", fmtN(ownersCapital), false, "#333"]])}
      <tr class="total-row"><td>TOTAL EQUITY</td><td style="text-align:right">${fmtN(equity)}</td></tr>
    </table></div>
    <div class="section"><div class="section-title">Accounts Payable Detail</div><table>${apRows}</table></div>
    <div style="background:#f8f8f8;border-radius:8px;padding:12px 14px;margin-top:8px;font-size:11px;color:#555">
      Current Ratio: <strong>${currentRatio}</strong> &nbsp;|&nbsp; AR Outstanding: <strong>${fmtN(d.arOutstanding)}</strong> &nbsp;|&nbsp; Gross Margin: <strong>${d.gm}%</strong>
    </div>`;
    return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title>${css}</head><body>${header}${body}${footer}</body></html>`;
  }

  // ── CASH FLOWS ───────────────────────────────────────────────────
  const paidCapex = d.pOverheads.filter(o => o.entryType === "capex" && o.paymentStatus === "paid").reduce((s, o) => s + Number(o.amount), 0);
  const netOps = d.rdRevenue + d.pCashReceived - d.rdCOGS - d.catCOGS - d.paidOpexInPeriod - d.liabPayInPeriod;
  const netCash = netOps - paidCapex;
  const capexItems = d.pOverheads.filter(o => o.entryType === "capex" && o.paymentStatus === "paid");
  const capexRowsCF = capexItems.length === 0
    ? rows([["No asset purchases paid this period", fmtN(0), false, "#999"]])
    : capexItems.map(a => `<tr class="indent"><td>Asset: ${a.assetName || a.description}</td><td style="text-align:right;color:#d97706">(${fmtN(a.amount)})</td></tr>`).join("");
  const body = `
  <div class="kpi-grid">
    <div class="kpi"><div class="label">Total Cash In</div><div class="value" style="color:#16a34a">${fmtN(d.rdRevenue + d.pCashReceived)}</div></div>
    <div class="kpi"><div class="label">Total Cash Out</div><div class="value" style="color:#dc2626">${fmtN(d.rdCOGS + d.catCOGS + d.paidOpexInPeriod + d.liabPayInPeriod + paidCapex)}</div></div>
    <div class="kpi"><div class="label">Net Cash Flow</div><div class="value" style="color:${netCash >= 0 ? "#16a34a" : "#dc2626"}">${fmtN(netCash)}</div></div>
  </div>
  <p style="font-size:10px;color:#888;margin-bottom:16px">Period: ${dateRange}</p>
  <div class="section"><div class="section-title">Operating Activities — Inflows</div><table>
    ${rows([["Cash from Restaurant Sales", fmtN(d.rdRevenue), false, "#16a34a"],["Cash from Catering (collected)", fmtN(d.pCashReceived), false, "#16a34a"]])}
    <tr class="total-row"><td>Total Cash Inflows</td><td style="text-align:right">${fmtN(d.rdRevenue + d.pCashReceived)}</td></tr>
  </table></div>
  <div class="section"><div class="section-title">Operating Activities — Outflows</div><table>
    ${rows([["Restaurant COGS (direct costs)", `(${fmtN(d.rdCOGS)})`, false, "#dc2626"],["Catering Event Costs", `(${fmtN(d.catCOGS)})`, false, "#dc2626"],["Overhead Expense Payments (paid)", `(${fmtN(d.paidOpexInPeriod)})`, false, "#dc2626"],["Liability / AP Payments", `(${fmtN(d.liabPayInPeriod)})`, false, "#dc2626"]])}
    <tr class="total-row"><td>Total Cash Outflows (operating)</td><td style="text-align:right">(${fmtN(d.totalCOGS + d.paidOpexInPeriod + d.liabPayInPeriod)})</td></tr>
    <tr style="${netOps >= 0 ? "background:#f0fdf4" : "background:#fff5f5"}"><td style="font-weight:800;padding:10px 12px">Net Cash from Operations</td><td style="text-align:right;font-weight:900;padding:10px 12px;color:${netOps >= 0 ? "#16a34a" : "#dc2626"}">${fmtN(netOps)}</td></tr>
  </table></div>
  <div class="section"><div class="section-title">Investing Activities</div><table>
    ${capexRowsCF}
    <tr class="total-row"><td>Net Cash from Investing</td><td style="text-align:right">${paidCapex > 0 ? `(${fmtN(paidCapex)})` : fmtN(0)}</td></tr>
  </table></div>
  <div class="section"><div class="section-title">Financing Activities</div><table>
    ${rows([["Owner Capital Contributions", "—", false, "#999"],["Loan Repayments Made", d.liabPayInPeriod > 0 ? `(${fmtN(d.liabPayInPeriod)})` : fmtN(0), false, "#2563eb"]])}
    <tr class="total-row"><td>Net Cash from Financing</td><td style="text-align:right">${fmtN(0)}</td></tr>
  </table></div>
  <div style="${netCash >= 0 ? "background:#f0fdf4;border:1px solid #bbf7d0" : "background:#fff5f5;border:1px solid #fecaca"};border-radius:8px;padding:14px 16px;margin-top:8px">
    <div style="font-size:12px;font-weight:700;margin-bottom:4px">Net Change in Cash</div>
    <div style="font-size:22px;font-weight:900;color:${netCash >= 0 ? "#16a34a" : "#dc2626"}">${fmtN(netCash)}</div>
    ${d.arOutstanding > 0 ? `<div style="font-size:11px;color:#555;margin-top:6px">⚠️ Collecting ${fmtN(d.arOutstanding)} in outstanding AR would further improve cash.</div>` : ""}
  </div>
  <div style="margin-top:14px;background:#f8f8f8;border-radius:8px;padding:12px 14px;font-size:11px;color:#555">
    AR Outstanding: <strong>${fmtN(d.arOutstanding)}</strong> &nbsp;|&nbsp; AP Outstanding: <strong>${fmtN(d.allOh.ap + d.allOh.capexAP)}</strong>
  </div>`;
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title>${css}</head><body>${header}${body}${footer}</body></html>`;
}

// ─── AUTH HELPERS ─────────────────────────────────────────────────
// Roles: "owner" = full access | "staff" = restaurant + invoices only
const AUTH_KEY   = "cb_auth_v2";   // { owner: {email,hash}, staff: {email,hash} | null }
const SESSION_KEY = "cb_session_v2"; // { role: "owner"|"staff", expires }
const SESSION_DURATION = 8 * 60 * 60 * 1000; // 8 hours

const STAFF_TABS = ["restaurant", "customers"]; // tabs staff can access

function hashPassword(pw) {
  let h = 0x811c9dc5;
  for (let i = 0; i < pw.length; i++) {
    h ^= pw.charCodeAt(i);
    h = (h * 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, "0");
}

function loadAuth() {
  try { return JSON.parse(localStorage.getItem(AUTH_KEY)) || null; } catch { return null; }
}
function saveOwnerAuth(email, pw) {
  const existing = loadAuth() || {};
  const updated = { ...existing, owner: { email: email.trim().toLowerCase(), hash: hashPassword(pw) } };
  localStorage.setItem(AUTH_KEY, JSON.stringify(updated));
  if (isSupabaseConfigured()) cloudSet("cb_auth", updated);
}
function saveStaffAuth(email, pw) {
  const existing = loadAuth() || {};
  const updated = { ...existing, staff: pw ? { email: email.trim().toLowerCase(), hash: hashPassword(pw) } : null };
  localStorage.setItem(AUTH_KEY, JSON.stringify(updated));
  if (isSupabaseConfigured()) cloudSet("cb_auth", updated);
}
function loadSession() {
  try {
    const s = JSON.parse(localStorage.getItem(SESSION_KEY));
    if (s && Date.now() < s.expires) return s;
    localStorage.removeItem(SESSION_KEY);
    return null;
  } catch { return null; }
}
function saveSession(role) {
  localStorage.setItem(SESSION_KEY, JSON.stringify({ role, expires: Date.now() + SESSION_DURATION }));
}
function clearSession() {
  localStorage.removeItem(SESSION_KEY);
}

// ─── LOGIN SCREEN ─────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const localAuth = loadAuth();
  const [auth, setAuth] = useState(localAuth);
  const [syncing, setSyncing] = useState(!localAuth?.owner);
  const isFirstTime = !auth?.owner;
  const [email, setEmail] = useState(isFirstTime ? "cookiesbites@email.cm" : "");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // If no local credentials, try fetching from Supabase (handles new devices / cleared cache)
  useEffect(() => {
    if (localAuth?.owner) { setSyncing(false); return; }
    if (!isSupabaseConfigured()) { setSyncing(false); return; }
    cloudGet("cb_auth").then(data => {
      if (data?.owner) {
        localStorage.setItem(AUTH_KEY, JSON.stringify(data));
        setAuth(data);
      }
      setSyncing(false);
    }).catch(() => setSyncing(false));
  }, []); // eslint-disable-line

  const persistAuth = (authObj) => {
    localStorage.setItem(AUTH_KEY, JSON.stringify(authObj));
    if (isSupabaseConfigured()) cloudSet("cb_auth", authObj);
  };

  const handleSubmit = () => {
    setError("");
    if (!email.trim()) { setError("Email is required."); return; }
    if (!pw) { setError("Password is required."); return; }

    if (!auth?.owner) {
      // First-time owner setup
      if (pw.length < 6) { setError("Password must be at least 6 characters."); return; }
      if (pw !== pw2) { setError("Passwords do not match."); return; }
      const newAuth = { owner: { email: email.trim().toLowerCase(), hash: hashPassword(pw) } };
      persistAuth(newAuth);
      saveSession("owner");
      setLoading(true);
      setTimeout(() => onLogin("owner"), 400);
      return;
    }

    const emailLower = email.trim().toLowerCase();

    // Check owner
    if (auth.owner && emailLower === auth.owner.email && hashPassword(pw) === auth.owner.hash) {
      saveSession("owner");
      setLoading(true);
      setTimeout(() => onLogin("owner"), 400);
      return;
    }
    // Check staff
    if (auth.staff && emailLower === auth.staff.email && hashPassword(pw) === auth.staff.hash) {
      saveSession("staff");
      setLoading(true);
      setTimeout(() => onLogin("staff"), 400);
      return;
    }

    setError("Incorrect email or password.");
  };

  if (syncing) {
    return (
      <div style={{ background: T.bg, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
        <img src={LOGO_SRC} alt="Cookie's Bites" style={{ width: 120, objectFit: "contain" }} />
        <div style={{ color: T.textMuted, fontSize: 13 }}>Checking credentials…</div>
      </div>
    );
  }

  return (
    <div style={{
      fontFamily: "'DM Sans','Helvetica Neue',Arial,sans-serif",
      background: T.bg,
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 16,
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700;9..40,800&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        input:focus{border-color:#E8C547!important;box-shadow:0 0 0 2px rgba(232,197,71,0.07)!important;outline:none}
        button:hover{opacity:0.85}
        @keyframes fadeIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
        @keyframes spin{to{transform:rotate(360deg)}}
      `}</style>
      <div style={{ width: "100%", maxWidth: 380, animation: "fadeIn 0.35s ease" }}>
        {/* Brand */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img
            src={LOGO_SRC}
            alt="Cookie's Bites"
            style={{ width: 160, height: 160, objectFit: "contain", margin: "0 auto 8px", display: "block" }}
          />
          <div style={{ fontSize: 11, color: T.textMuted, marginTop: 3 }}>
            Business Tracker · cookiesbites.app
          </div>
        </div>

        {/* Card */}
        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: "28px 28px 24px" }}>
          <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 4 }}>
            {isFirstTime ? "👋 Welcome! Set up your account" : "Sign in"}
          </div>
          <div style={{ fontSize: 11, color: T.textMuted, marginBottom: 22 }}>
            {isFirstTime
              ? "Create the owner credentials to get started."
              : "Enter your credentials to continue."}
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={S.label}>Email address</label>
            <input style={{ ...S.input, fontSize: 14 }} type="email" autoComplete="email"
              value={email} onChange={e => { setEmail(e.target.value); setError(""); }}
              onKeyDown={e => e.key === "Enter" && handleSubmit()}
              placeholder="your@email.com" />
          </div>

          <div style={{ marginBottom: isFirstTime ? 14 : 20 }}>
            <label style={S.label}>Password</label>
            <div style={{ position: "relative" }}>
              <input style={{ ...S.input, fontSize: 14, paddingRight: 40 }}
                type={showPw ? "text" : "password"}
                autoComplete={isFirstTime ? "new-password" : "current-password"}
                value={pw} onChange={e => { setPw(e.target.value); setError(""); }}
                onKeyDown={e => e.key === "Enter" && handleSubmit()}
                placeholder={isFirstTime ? "Choose a password (min. 6 chars)" : ""} />
              <button style={{
                position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)",
                background: "none", border: "none", color: T.textMuted,
                cursor: "pointer", fontSize: 14, padding: "0 2px",
              }} onClick={() => setShowPw(!showPw)} tabIndex={-1}>
                {showPw ? "🙈" : "👁"}
              </button>
            </div>
          </div>

          {isFirstTime && (
            <div style={{ marginBottom: 20 }}>
              <label style={S.label}>Confirm password</label>
              <input style={{ ...S.input, fontSize: 14 }}
                type={showPw ? "text" : "password"} autoComplete="new-password"
                value={pw2} onChange={e => { setPw2(e.target.value); setError(""); }}
                onKeyDown={e => e.key === "Enter" && handleSubmit()}
                placeholder="Re-enter your password" />
            </div>
          )}

          {error && (
            <div style={{
              background: `${T.danger}15`, border: `1px solid ${T.danger}40`,
              borderRadius: 7, padding: "8px 12px", fontSize: 12, color: T.danger, marginBottom: 16,
            }}>⚠️ {error}</div>
          )}

          <button style={{
            ...S.btn("primary"), width: "100%", padding: "10px 16px", fontSize: 14,
            fontWeight: 700, borderRadius: 8, display: "flex", alignItems: "center",
            justifyContent: "center", gap: 8, opacity: loading ? 0.7 : 1,
          }} onClick={handleSubmit} disabled={loading}>
            {loading
              ? <span style={{ display: "inline-block", width: 16, height: 16, border: `2px solid ${T.bg}`, borderTopColor: "transparent", borderRadius: "50%", animation: "spin 0.6s linear infinite" }} />
              : (isFirstTime ? "Create Account & Sign In" : "Sign In →")}
          </button>
        </div>

        <div style={{ textAlign: "center", marginTop: 16, fontSize: 10, color: T.textDim }}>
          Session expires after 8 hours · Owner &amp; Staff accounts supported
        </div>
      </div>
    </div>
  );
}

// ─── IMPORT MODAL ─────────────────────────────────────────────────
// Uses SheetJS loaded dynamically from CDN — no npm install needed
function useSheetJS() {
  const [ready, setReady] = useState(!!window.XLSX);
  useEffect(() => {
    if (window.XLSX) { setReady(true); return; }
    const s = document.createElement("script");
    s.src = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
    s.onload = () => setReady(true);
    document.head.appendChild(s);
  }, []);
  return ready;
}

function parseXLDate(v) {
  if (!v && v !== 0) return "";
  if (typeof v === "number") {
    const d = new Date(Math.round((v - 25569) * 86400000));
    return d.toISOString().slice(0, 10);
  }
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const d = new Date(s);
  return isNaN(d) ? s : d.toISOString().slice(0, 10);
}

function getSheet(wb, keyword) {
  const key = wb.SheetNames.find(n => n.toLowerCase().includes(keyword.toLowerCase()));
  if (!key) return [];
  // range:2 skips the two instruction rows so row 3 (0-indexed: 2) becomes the header row
  return window.XLSX.utils.sheet_to_json(wb.Sheets[key], { defval: "", range: 2 });
}

function parseWorkbook(wb) {
  const ts = Date.now();

  // Catalog
  const catalog = getSheet(wb, "Catalog").map((r, i) => ({
    id: ts + i,
    name: String(r["Item Name *"] || r["Item Name"] || "").trim(),
    catId: null,
    _catName: String(r["Category *"] || r["Category"] || "").trim(),
    unitType: String(r["Unit Type *"] || r["Unit Type"] || "Per item").trim(),
    price: Number(r["Price\n(XAF) *"] || r["Price (XAF) *"] || r["Price (XAF)"] || r["Price"] || 0),
    costPerUnit: Number(r["Cost / Unit\n(XAF)"] || r["Cost / Unit (XAF)"] || r["Cost/Unit"] || 0),
    description: String(r["Description"] || "").trim(),
    tags: String(r["Tags\n(comma-sep)"] || r["Tags"] || "").split(",").map(t => t.trim()).filter(Boolean),
    photo: null,
  })).filter(r => r.name);

  // Meals
  const meals = getSheet(wb, "Meal").map((r, i) => ({
    id: ts + 10000 + i,
    name: String(r["Meal Name *"] || r["Meal Name"] || "").trim(),
    description: String(r["Description"] || "").trim(),
    price: Number(r["Price\n(XAF) *"] || r["Price (XAF) *"] || r["Price (XAF)"] || r["Price"] || 0),
    category: String(r["Category"] || "Main").trim(),
    active: String(r["Active"] || "Yes").trim().toLowerCase() !== "no",
    laborCost: Number(r["Labour Cost\n(XAF/plate)"] || r["Labour Cost (XAF/plate)"] || r["Labour Cost"] || 0),
    availablePortions: Number(r["Available\nPortions"] || r["Available Portions"] || 0),
    ingredientLinks: [],
    otherCosts: [],
    photo: null,
  })).filter(r => r.name);

  // Inventory
  const inventory = getSheet(wb, "Inventory").map((r, i) => ({
    id: ts + 20000 + i,
    name: String(r["Item Name *"] || r["Item Name"] || "").trim(),
    category: String(r["Category *"] || r["Category"] || "Ingredient").trim(),
    unit: String(r["Unit\n(kg/L/pack…) *"] || r["Unit"] || "kg").trim(),
    stock: Number(r["Current Stock *"] || r["Current Stock"] || 0),
    reorderAt: Number(r["Reorder Level\n(min alert)"] || r["Reorder Level"] || r["Reorder At"] || 0),
    costPerUnit: Number(r["Cost / Unit\n(XAF)"] || r["Cost / Unit (XAF)"] || r["Cost/Unit"] || 0),
    usedPerPlate: Number(r["Used / Plate\n(optional)"] || r["Used / Plate"] || 0),
    linkedMeals: [],
  })).filter(r => r.name);

  // Events
  const events = getSheet(wb, "Event").map((r, i) => {
    const guests = Number(r["Guests *"] || r["Guests"] || 0);
    const pph = Number(r["Price/Head\n(XAF)"] || r["Price/Head (XAF)"] || r["Price/Head"] || 0);
    const addOns = Number(r["Add-Ons\n(XAF)"] || r["Add-Ons (XAF)"] || r["Add-Ons"] || 0);
    const discount = Number(r["Discount\n(XAF)"] || r["Discount (XAF)"] || r["Discount"] || 0);
    return {
      id: ts + 30000 + i,
      name: String(r["Event Name *"] || r["Event Name"] || "").trim(),
      clientName: String(r["Client Name *"] || r["Client Name"] || "").trim(),
      clientPhone: String(r["Client Phone"] || "").trim(),
      eventDate: parseXLDate(r["Event Date *\n(YYYY-MM-DD)"] || r["Event Date *"] || r["Event Date"] || ""),
      location: String(r["Location"] || "").trim(),
      eventType: String(r["Event Type *"] || r["Event Type"] || "Other").trim(),
      serviceStyle: String(r["Service Style *"] || r["Service Style"] || "Buffet").trim(),
      guests, pricePerHead: pph, addOns, discount,
      phase: String(r["Phase *"] || r["Phase"] || "Lead / Inquiry").trim(),
      notes: String(r["Notes"] || "").trim(),
      revenue: guests * pph + addOns - discount,
      costs: { inventory: 0, labor: 0, transport: 0, overhead: 0 },
      media: [],
    };
  }).filter(r => r.name);

  // Sales
  const sales = getSheet(wb, "Sales").map((r, i) => ({
    id: ts + 40000 + i,
    date: parseXLDate(r["Date *\n(YYYY-MM-DD)"] || r["Date *"] || r["Date"] || ""),
    meal: String(r["Meal Name *"] || r["Meal Name"] || "").trim(),
    plates: Number(r["Plates /\nUnits *"] || r["Plates / Units *"] || r["Plates"] || 1),
    pricePerPlate: Number(r["Price / Plate\n(XAF) *"] || r["Price / Plate (XAF)"] || r["Price/Plate"] || 0),
    method: String(r["Payment\nMethod * \u25bc"] || r["Payment Method *"] || r["Payment Method"] || "Cash").trim(),
    type: String(r["Order Type *\n\u25bc"] || r["Order Type *"] || r["Order Type"] || "Dine-in").trim(),
    deliveryFee: Number(r["Delivery Fee\n(XAF)"] || r["Delivery Fee (XAF)"] || r["Delivery Fee"] || 0),
    clientName: String(r["Client Name"] || r["Client Name\n(delivery only)"] || "").trim(),
    deliveryAddress: "",
  })).filter(r => r.meal);

  // Invoices
  const invoices = getSheet(wb, "Invoice").map((r, i) => {
    const total = Number(r["Total Amount\n(XAF) *"] || r["Total Amount (XAF)"] || r["Total Amount"] || 0);
    const paid = Number(r["Amount Paid\n(XAF)"] || r["Amount Paid (XAF)"] || r["Amount Paid"] || 0);
    const status = paid >= total && total > 0 ? "Paid" : paid > 0 ? "Partially Paid" : "Unpaid";
    return {
      id: ts + 50000 + i,
      num: String(r["Invoice # *"] || r["Invoice #"] || `INV-${THIS_YEAR}-${String(i+1).padStart(4,"0")}`).trim(),
      client: String(r["Client Name *"] || r["Client Name"] || "").trim(),
      clientPhone: String(r["Client Phone"] || "").trim(),
      issued: parseXLDate(r["Issue Date *\n(YYYY-MM-DD)"] || r["Issue Date *"] || r["Issue Date"] || ""),
      due: parseXLDate(r["Due Date *\n(YYYY-MM-DD)"] || r["Due Date *"] || r["Due Date"] || ""),
      total, paid, status,
      notes: String(r["Notes"] || "").trim(),
    };
  }).filter(r => r.client);

  // Overheads
  const overheads = getSheet(wb, "Overhead").map((r, i) => ({
    id: ts + 60000 + i,
    date: parseXLDate(r["Date *\n(YYYY-MM-DD)"] || r["Date *"] || r["Date"] || ""),
    entryType: String(r["Entry Type *\n\u25bc"] || r["Entry Type *"] || r["Entry Type"] || "opex").trim(),
    category: String(r["Category *\n\u25bc"] || r["Category *"] || r["Category"] || "Other").trim(),
    description: String(r["Description *"] || r["Description"] || "").trim(),
    amount: Number(r["Amount\n(XAF) *"] || r["Amount (XAF) *"] || r["Amount (XAF)"] || r["Amount"] || 0),
    frequency: String(r["Frequency *\n\u25bc"] || r["Frequency *"] || r["Frequency"] || "One-time").trim(),
    vendor: String(r["Vendor / Supplier"] || r["Vendor"] || "").trim(),
    paymentStatus: String(r["Payment Status *\n\u25bc"] || r["Payment Status *"] || r["Payment Status"] || "paid").trim(),
    assetName: String(r["Asset Name\n(capex only)"] || r["Asset Name"] || "").trim(),
  })).filter(r => r.description);

  return { catalog, meals, inventory, events, sales, invoices, overheads };
}

function ImportModal({ onClose, onImport }) {
  const xlsxReady = useSheetJS();
  const fileRef = useRef();
  const [stage, setStage] = useState("idle");
  const [preview, setPreview] = useState(null);
  const [err, setErr] = useState("");
  const [counts, setCounts] = useState(null);

  const parse = (file) => {
    if (!file) return;
    if (!xlsxReady || !window.XLSX) { setErr("Parser still loading — please wait a moment and try again."); return; }
    setStage("parsing"); setErr("");
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const wb = window.XLSX.read(e.target.result, { type: "array", cellDates: false });
        const data = parseWorkbook(wb);
        setPreview(data);
        setCounts({
          "Catalog Items": data.catalog.length,
          "Meals": data.meals.length,
          "Inventory": data.inventory.length,
          "Catering Events": data.events.length,
          "Restaurant Sales": data.sales.length,
          "Overheads": data.overheads.length,
        });
        setStage("preview");
      } catch(e2) {
        setErr("Could not parse file: " + e2.message);
        setStage("error");
      }
    };
    reader.onerror = () => { setErr("Could not read file."); setStage("error"); };
    reader.readAsArrayBuffer(file);
  };

  const doImport = () => {
    if (!preview) return;
    setStage("importing");
    setTimeout(() => { onImport(preview); setStage("done"); }, 500);
  };

  const total = counts ? Object.values(counts).reduce((a, b) => a + b, 0) : 0;
  const populated = counts ? Object.entries(counts).filter(([, v]) => v > 0) : [];

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.85)", zIndex:3000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:14, width:"100%", maxWidth:540, maxHeight:"92vh", display:"flex", flexDirection:"column", overflow:"hidden" }}>
        {/* Header */}
        <div style={{ padding:"14px 18px", borderBottom:`1px solid ${T.border}`, background:T.surface, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div>
            <div style={{ fontWeight:800, fontSize:15 }}>⬆ Import Data from Excel</div>
            <div style={{ fontSize:11, color:T.textMuted, marginTop:2 }}>Upload the Cookies Bites Import Template (.xlsx)</div>
          </div>
          <button style={{ background:"none", border:"none", color:T.textMuted, cursor:"pointer", fontSize:20, lineHeight:1 }} onClick={onClose}>×</button>
        </div>

        <div style={{ padding:18, overflowY:"auto", flex:1 }}>
          {/* Idle / Error */}
          {(stage === "idle" || stage === "error") && (
            <>
              {!xlsxReady && <div style={{ textAlign:"center", fontSize:11, color:T.textMuted, marginBottom:10 }}>⏳ Loading file parser…</div>}
              <div
                style={{ border:`2px dashed ${T.accent}`, borderRadius:10, padding:"32px 20px", textAlign:"center", cursor:xlsxReady?"pointer":"default", background:T.accentSoft, marginBottom:12 }}
                onClick={() => xlsxReady && fileRef.current.click()}
                onDragOver={e => e.preventDefault()}
                onDrop={e => { e.preventDefault(); const f = e.dataTransfer.files[0]; if(f) parse(f); }}
              >
                <div style={{ fontSize:40, marginBottom:10 }}>📊</div>
                <div style={{ fontWeight:700, fontSize:14, marginBottom:5 }}>Click to browse or drag & drop</div>
                <div style={{ fontSize:11, color:T.textMuted }}>CookiesBites_Import_Template.xlsx</div>
                <input ref={fileRef} type="file" accept=".xlsx,.xls" style={{ display:"none" }} onChange={e => e.target.files[0] && parse(e.target.files[0])} />
              </div>
              {err && <div style={{ background:`${T.danger}15`, border:`1px solid ${T.danger}40`, borderRadius:7, padding:"9px 12px", fontSize:12, color:T.danger, marginBottom:10 }}>⚠️ {err}</div>}
              <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, padding:"10px 13px", fontSize:11, color:T.textMuted, lineHeight:1.75 }}>
                <div style={{ fontWeight:700, color:T.text, marginBottom:3 }}>⚠️ Before importing</div>
                <strong style={{ color:T.success }}>Safe:</strong> Catalog, Meals and Proposals are <strong>never overwritten</strong>.<br />
                <strong style={{ color:T.warning }}>Replaced:</strong> Sales and Expenses will be replaced by sheets that have rows. Inventory and Events will also be replaced if present. Sheets with 0 rows are left unchanged.
              </div>
            </>
          )}

          {/* Parsing spinner */}
          {stage === "parsing" && (
            <div style={{ textAlign:"center", padding:"50px 0" }}>
              <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
              <div style={{ width:38, height:38, border:`3px solid ${T.accent}`, borderTopColor:"transparent", borderRadius:"50%", animation:"spin 0.7s linear infinite", margin:"0 auto 14px" }} />
              <div style={{ fontWeight:700 }}>Reading file…</div>
              <div style={{ fontSize:11, color:T.textMuted, marginTop:4 }}>Parsing all sheets</div>
            </div>
          )}

          {/* Preview */}
          {stage === "preview" && counts && (
            <>
              <div style={{ background:`${T.success}12`, border:`1px solid ${T.success}40`, borderRadius:8, padding:"10px 13px", fontSize:12, color:T.success, fontWeight:700, marginBottom:13 }}>
                ✅ File parsed — {total} record{total !== 1 ? "s" : ""} found across {populated.length} sheet{populated.length !== 1 ? "s" : ""}
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginBottom:13 }}>
                {Object.entries(counts).map(([label, count]) => (
                  <div key={label} style={{ background:count > 0 ? T.accentSoft : T.surface, border:`1px solid ${count > 0 ? T.accent : T.border}`, borderRadius:8, padding:"9px 12px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <span style={{ fontSize:11, color:count > 0 ? T.text : T.textMuted }}>{label}</span>
                    <span style={{ fontSize:14, fontWeight:800, color:count > 0 ? T.accent : T.textDim }}>{count}</span>
                  </div>
                ))}
              </div>
              <div style={{ background:`${T.warning}12`, border:`1px solid ${T.warning}40`, borderRadius:8, padding:"9px 13px", fontSize:11, color:T.textMuted, lineHeight:1.7 }}>
                ⚠️ Clicking <strong style={{ color:T.text }}>Import Now</strong> will replace Sales and Expenses (and Inventory/Events if present). <strong style={{ color:T.success }}>Catalog, Meals and Proposals will NOT be changed.</strong>
              </div>
            </>
          )}

          {/* Importing */}
          {stage === "importing" && (
            <div style={{ textAlign:"center", padding:"50px 0" }}>
              <div style={{ width:38, height:38, border:`3px solid ${T.accent}`, borderTopColor:"transparent", borderRadius:"50%", animation:"spin 0.7s linear infinite", margin:"0 auto 14px" }} />
              <div style={{ fontWeight:700 }}>Importing…</div>
            </div>
          )}

          {/* Done */}
          {stage === "done" && (
            <div style={{ textAlign:"center", padding:"36px 0" }}>
              <div style={{ fontSize:52, marginBottom:12 }}>✅</div>
              <div style={{ fontWeight:800, fontSize:16, marginBottom:6 }}>Import Complete!</div>
              <div style={{ fontSize:12, color:T.textMuted, marginBottom:20 }}>{total} records loaded into the platform.</div>
              <button style={{ ...S.btn("primary"), fontSize:13, padding:"9px 22px" }} onClick={onClose}>Close & View Data</button>
            </div>
          )}
        </div>

        {/* Footer */}
        {(stage === "idle" || stage === "error" || stage === "preview") && (
          <div style={{ padding:"11px 18px", borderTop:`1px solid ${T.border}`, display:"flex", justifyContent:"flex-end", gap:8 }}>
            <button style={S.btn("ghost")} onClick={onClose}>Cancel</button>
            {stage === "preview" && <button style={S.btn("primary")} onClick={doImport}>⬆ Import Now</button>}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── MAIN APP ─────────────────────────────────────────────────────
const TABS = [
  { id: "dashboard", label: "📊 Dashboard" },
  { id: "catering", label: "🎉 Catering" },
  { id: "restaurant", label: "🍽️ Restaurant & Delivery" },
  { id: "customers", label: "👥 Customers" },
  { id: "vendors", label: "🧾 Expenses" },
  { id: "reports", label: "📑 Reports" },
  { id: "studio", label: "🤖 AI Studio", ownerOnly: true },
];

export default function App() {
  const [authed, setAuthed] = useState(() => !!loadSession());
  const [role, setRole] = useState(() => loadSession()?.role || "owner");
  const isOwner = role === "owner";
  const [tab, setTab] = useState(() => {
    const sess = loadSession();
    if (sess?.role === "staff") return "restaurant";
    return "dashboard";
  });
  // ── localStorage helpers (offline cache + fallback) ──────────────
  function ls_get(key, fallback) {
    try {
      const raw = localStorage.getItem(key);
      return raw !== null ? JSON.parse(raw) : fallback;
    } catch { return fallback; }
  }
  function ls_set(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
  }

  // ── Cloud sync state ──────────────────────────────────────────────
  const [cloudLoaded, setCloudLoaded] = useState(false);
  const [syncStatus, setSyncStatus] = useState("idle"); // "idle"|"saving"|"saved"|"offline"
  const syncTimers = useRef({});

  // ── All app state — initialised from localStorage cache first ─────
  const [events, setEvents] = useState(() => ls_get("cb_events", []));
  const [sales, setSales] = useState(() => ls_get("cb_sales", []));
  const [invoices, setInvoices] = useState(() => ls_get("cb_invoices", []));
  const [proposals, setProposals] = useState(() => ls_get("cb_proposals", []));
  const [proposalPrefillLines, setProposalPrefillLines] = useState(null);
  const [catalogItems, setCatalogItems] = useState(() => {
    const raw = ls_get("cb_catalog", CAT_ITEMS);
    return Array.isArray(raw) ? raw.map(i => i?.photo?.startsWith("data:") ? { ...i, photo: null } : i) : raw;
  });
  const [catalogCategories, setCatalogCategories] = useState(() => ls_get("cb_catalog_cats", CAT_CATS));
  // catalogMeta: { [nameLower]: { unitType, tags, notes } } — persists user edits independently of sync
  const [catalogMeta, setCatalogMeta] = useState(() => ls_get("cb_catalog_meta", {}));
  const [inventory, setInventory] = useState(() => ls_get("cb_inventory", INIT_INVENTORY));
  const [invPurchases, setInvPurchases] = useState(() => ls_get("cb_inv_purchases", []));
  const [prepaidItems, setPrepaidItems] = useState(() => ls_get("cb_prepaid_items", []));
  const [deposits, setDeposits] = useState(() => ls_get("cb_deposits", []));
  const [meals, setMeals] = useState(() => {
    const raw = ls_get("cb_meals", INIT_MEALS);
    return Array.isArray(raw) ? raw.map(m => m?.photo?.startsWith("data:") ? { ...m, photo: null } : m) : raw;
  });
  const [batches, setBatches] = useState(() => ls_get("cb_batches", []));
  const [overheads, setOverheads] = useState(() => ls_get("cb_overheads", []));
  const [logo, setLogo] = useState(() => ls_get("cb_logo", { src: LOGO_SRC }));
  const [biz, setBiz] = useState(() => ls_get("cb_biz", INIT_BIZ));
  const staffTabs = biz.staffTabs || ["restaurant", "customers"];
  const visibleTabs = isOwner ? TABS : TABS.filter(t => staffTabs.includes(t.id) && !t.ownerOnly);
  const [customers, setCustomers] = useState(() => ls_get("cb_customers", []));
  const [vendors, setVendors] = useState(() => ls_get("cb_vendors", []));
  const [socialLinks, setSocialLinks] = useState(() => ls_get("cb_social", { instagram: "", facebook: "", tiktok: "", whatsapp: "", google: "" }));
  const [showSettings, setShowSettings] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const isMobile = useIsMobile();

  // ── On mount: pull latest data from Supabase (cloud-first load) ───
  const CLOUD_KEYS = [
    "cb_events","cb_sales","cb_invoices","cb_proposals",
    "cb_catalog","cb_catalog_cats","cb_catalog_meta","cb_inventory","cb_meals",
    "cb_batches","cb_overheads","cb_logo","cb_biz",
    "cb_customers","cb_vendors","cb_social","cb_inv_purchases",
    "cb_prepaid_items","cb_deposits",
  ];

  // Strip base64 photo blobs from items — replace with null so they
  // don't bloat JSONB rows and cause silent write failures.
  // Legitimate photos are Supabase Storage public URLs (https://...).
  const stripBase64Photos = (items) => {
    if (!Array.isArray(items)) return items;
    return items.map(item => {
      if (item && item.photo && item.photo.startsWith("data:")) {
        return { ...item, photo: null };
      }
      return item;
    });
  };

  // Map old hardcoded category strings to the closest catalog category name.
  // If the meal's category already matches a catalog category exactly, leave it.
  // Otherwise assign the first catalog category as fallback.
  const migrateMealCategories = (meals, catCats) => {
    if (!Array.isArray(meals) || !Array.isArray(catCats) || catCats.length === 0) return meals;
    const validNames = new Set(catCats.map(c => c.name));
    const fallback = catCats[0].name;
    // Best-effort fuzzy map for old strings
    const legacyMap = {
      "Main":     catCats.find(c => /rice|main|chicken|beef|fish|stew/i.test(c.name))?.name || fallback,
      "Starter":  catCats.find(c => /start|snack|small|chop/i.test(c.name))?.name || fallback,
      "Side":     catCats.find(c => /side|veg|salad|fruit|platter/i.test(c.name))?.name || fallback,
      "Dessert":  catCats.find(c => /dessert|pastry|pastries/i.test(c.name))?.name || fallback,
      "Drink":    catCats.find(c => /drink|beverage|smoothie/i.test(c.name))?.name || fallback,
      "Imported": catCats.find(c => /import|corp|seasonal/i.test(c.name))?.name || fallback,
      "Other":    fallback,
    };
    return meals.map(m => {
      if (!m.category || validNames.has(m.category)) return m;
      return { ...m, category: legacyMap[m.category] || fallback };
    });
  };

  useEffect(() => {
    if (!isSupabaseConfigured()) { setCloudLoaded(true); return; }
    cloudGetAll(CLOUD_KEYS).then(cloud => {
      try {
      // For each key, cloud value wins over local cache
      const apply = (key, setter) => {
        if (cloud[key] !== undefined && cloud[key] !== null) {
          setter(cloud[key]);
          ls_set(key, cloud[key]); // refresh local cache
        }
      };
      if (cloud["cb_events"] !== undefined && cloud["cb_events"] !== null) {
        const _v = cloud["cb_events"];
        const local_v = ls_get("cb_events", []);
        if (_v.length > 0 || local_v.length === 0) { setEvents(_v); ls_set("cb_events", _v); }
      }
      if (cloud["cb_sales"] !== undefined && cloud["cb_sales"] !== null) {
        const _v = cloud["cb_sales"];
        const local_v = ls_get("cb_sales", []);
        if (_v.length > 0 || local_v.length === 0) { setSales(_v); ls_set("cb_sales", _v); }
      }
      if (cloud["cb_invoices"] !== undefined && cloud["cb_invoices"] !== null) {
        const _v = cloud["cb_invoices"];
        const local_v = ls_get("cb_invoices", []);
        if (_v.length > 0 || local_v.length === 0) { setInvoices(_v); ls_set("cb_invoices", _v); }
      }
      if (cloud["cb_proposals"] !== undefined && cloud["cb_proposals"] !== null) {
        const _v = cloud["cb_proposals"];
        const local_v = ls_get("cb_proposals", []);
        if (_v.length > 0 || local_v.length === 0) { setProposals(_v); ls_set("cb_proposals", _v); }
      }
      // Catalog is derived from Meals — clear items/cats so sync rebuilds them fresh
      setCatalogItems([]);
      ls_set("cb_catalog", []);
      setCatalogCategories([]);
      ls_set("cb_catalog_cats", []);
      // Load catalogMeta (user-edited unitType/tags/notes) — this persists across syncs
      if (cloud["cb_catalog_meta"] !== undefined && cloud["cb_catalog_meta"] !== null) {
        setCatalogMeta(cloud["cb_catalog_meta"]);
        ls_set("cb_catalog_meta", cloud["cb_catalog_meta"]);
      }
      // Inventory: only apply if cloud has actual items — never overwrite with empty array
      if (cloud["cb_inventory"] !== undefined && cloud["cb_inventory"] !== null
          && Array.isArray(cloud["cb_inventory"]) && cloud["cb_inventory"].length > 0) {
        setInventory(cloud["cb_inventory"]);
        ls_set("cb_inventory", cloud["cb_inventory"]);
      }
      if (cloud["cb_inv_purchases"] !== undefined && cloud["cb_inv_purchases"] !== null) {
        const _v = cloud["cb_inv_purchases"];
        const local_v = ls_get("cb_inv_purchases", []);
        if (_v.length > 0 || local_v.length === 0) { setInvPurchases(_v); ls_set("cb_inv_purchases", _v); }
      }
      if (cloud["cb_prepaid_items"] !== undefined && cloud["cb_prepaid_items"] !== null) {
        const _v = cloud["cb_prepaid_items"];
        const local_v = ls_get("cb_prepaid_items", []);
        if (_v.length > 0 || local_v.length === 0) { setPrepaidItems(_v); ls_set("cb_prepaid_items", _v); }
      }
      if (cloud["cb_deposits"] !== undefined && cloud["cb_deposits"] !== null) {
        const _v = cloud["cb_deposits"];
        const local_v = ls_get("cb_deposits", []);
        if (_v.length > 0 || local_v.length === 0) { setDeposits(_v); ls_set("cb_deposits", _v); }
      }
      if (cloud["cb_meals"] !== undefined && cloud["cb_meals"] !== null) {
        const catCats = cloud["cb_catalog_cats"] || catalogCategories;
        const clean = migrateMealCategories(stripBase64Photos(cloud["cb_meals"]), catCats);
        const local_meals = ls_get("cb_meals", []);
        if (clean.length > 0 || local_meals.length === 0) { setMeals(clean); ls_set("cb_meals", clean); }
      }
      if (cloud["cb_batches"] !== undefined && cloud["cb_batches"] !== null) {
        const _v = cloud["cb_batches"];
        const local_v = ls_get("cb_batches", []);
        if (_v.length > 0 || local_v.length === 0) { setBatches(_v); ls_set("cb_batches", _v); }
      }
      if (cloud["cb_overheads"] !== undefined && cloud["cb_overheads"] !== null) {
        const _v = cloud["cb_overheads"];
        const local_v = ls_get("cb_overheads", []);
        if (_v.length > 0 || local_v.length === 0) { setOverheads(_v); ls_set("cb_overheads", _v); }
      }
      apply("cb_logo",         setLogo);
      apply("cb_biz",          setBiz);
      if (cloud["cb_customers"] !== undefined && cloud["cb_customers"] !== null) {
        const _v = cloud["cb_customers"];
        const local_v = ls_get("cb_customers", []);
        if (_v.length > 0 || local_v.length === 0) { setCustomers(_v); ls_set("cb_customers", _v); }
      }
      apply("cb_vendors",      setVendors);
      apply("cb_social",       setSocialLinks);
      } catch(e) { console.error("Cloud load error:", e); }
      setCloudLoaded(true);
    }).catch(() => setCloudLoaded(true)); // offline — use local cache
  // eslint-disable-next-line
  }, []);

  // ── Debounced cloud + local sync ──────────────────────────────────
  const syncKey = useCallback((key, value, delay = 800) => {
    // Always write to localStorage immediately
    ls_set(key, value);
    // Debounce the cloud write
    if (!isSupabaseConfigured()) return;
    clearTimeout(syncTimers.current[key]);
    setSyncStatus("saving");
    syncTimers.current[key] = setTimeout(async () => {
      const ok = await cloudSet(key, value);
      setSyncStatus(ok ? "saved" : "offline");
      setTimeout(() => setSyncStatus(s => s === "saved" ? "idle" : s), 2000);
    }, delay);
  }, []);

  // ── Wire every state to cloud sync ────────────────────────────────
  useEffect(() => { if (cloudLoaded) syncKey("cb_events",       events);       }, [events,       cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_sales",        sales);        }, [sales,        cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_invoices",     invoices);     }, [invoices,     cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_proposals",    proposals);    }, [proposals,    cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_catalog",      catalogItems); }, [catalogItems, cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_catalog_cats", catalogCategories); }, [catalogCategories, cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_catalog_meta", catalogMeta); }, [catalogMeta, cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_inventory",    inventory);    }, [inventory,    cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_meals",        meals);        }, [meals,        cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_batches",      batches);      }, [batches,      cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_overheads",    overheads);    }, [overheads,    cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_inv_purchases", invPurchases); }, [invPurchases, cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_prepaid_items", prepaidItems); }, [prepaidItems, cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_deposits",      deposits);     }, [deposits,      cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_logo",         logo,    2000);}, [logo,         cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_biz",          biz);          }, [biz,          cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_customers",    customers);    }, [customers,    cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_vendors",      vendors);      }, [vendors,      cloudLoaded, syncKey]);
  useEffect(() => { if (cloudLoaded) syncKey("cb_social",       socialLinks);  }, [socialLinks,  cloudLoaded, syncKey]);

  // ── Auto-sync Meals → Catalog ──────────────────────────────────────
  useEffect(() => {
    if (!cloudLoaded) return;

    const mealCatNames = [...new Set(meals.map(m => m.category).filter(Boolean))];
    const sortedNames = [...mealCatNames].sort();
    const newCats = sortedNames.map((name, i) => ({ id: i + 1, name }));
    const catByName = {};
    newCats.forEach(c => { catByName[c.name.toLowerCase()] = c.id; });

    setCatalogCategories(newCats);

    setCatalogItems(prev => {
      const existingMap = {};
      prev.forEach(c => { existingMap[c.name.toLowerCase()] = c; });

      return meals.map((meal, idx) => {
        const key = meal.name.toLowerCase();
        const existing = existingMap[key];
        const meta = catalogMeta[key] || {};
        const catId = catByName[key] || catByName[(meal.category || "").toLowerCase()] || 1;
        return {
          id: existing?.id || (Date.now() + idx),
          catId,
          name: meal.name,
          description: meal.description || existing?.description || "",
          // meta takes priority — preserves user edits to unitType/tags/notes
          unitType: meta.unitType || existing?.unitType || "Per head",
          price: existing?.price || 0,
          costPerUnit: existing?.costPerUnit || 0,
          photo: meal.photo || existing?.photo || null,
          tags: meta.tags !== undefined ? meta.tags : (existing?.tags || []),
          notes: meta.notes !== undefined ? meta.notes : (existing?.notes || ""),
        };
      });
    });
  }, [meals, cloudLoaded, catalogMeta]); // eslint-disable-line

  // Backfill/merge customers from all sources: sales, catering events & invoices
  useEffect(() => {
    const allSources = new Map();
    [...sales, ...events].forEach((r) => {
      const name = (r.clientName || "").trim();
      if (!name) return;
      const key = name.toLowerCase();
      if (!allSources.has(key)) {
        allSources.set(key, { name, phone: (r.clientPhone || "").trim(), date: r.date || r.eventDate || TODAY_ISO });
      } else if (!allSources.get(key).phone && r.clientPhone) {
        allSources.get(key).phone = r.clientPhone.trim();
      }
    });
    invoices.forEach((inv) => {
      const name = (inv.client || "").trim();
      if (!name) return;
      const key = name.toLowerCase();
      if (!allSources.has(key)) {
        allSources.set(key, { name, phone: (inv.clientPhone || "").trim(), date: inv.issued || inv.date || TODAY_ISO });
      }
    });
    if (allSources.size === 0) return;
    setCustomers(prev => {
      const existingKeys = new Set(prev.map(c => c.name.toLowerCase()));
      const toAdd = [];
      allSources.forEach((src, key) => {
        if (!existingKeys.has(key)) {
          toAdd.push({ id: Date.now() + toAdd.length, name: src.name, phone: src.phone || "", email: "", classification: "Regular", notes: "", createdAt: src.date });
        } else {
          // Merge phone if missing
          const idx = prev.findIndex(c => c.name.toLowerCase() === key);
          if (idx >= 0 && !prev[idx].phone && src.phone) {
            prev = prev.map((c, i) => i === idx ? { ...c, phone: src.phone } : c);
          }
        }
      });
      return toAdd.length > 0 ? [...prev, ...toAdd] : prev;
    });
  }, [sales, events, invoices]);

  // Backfill/merge vendors from all overhead/purchase entries
  useEffect(() => {
    if (overheads.length === 0) return;
    const allVendors = new Map();
    overheads.forEach((o) => {
      const name = (o.vendor || "").trim();
      if (!name) return;
      const key = name.toLowerCase();
      if (!allVendors.has(key)) {
        allVendors.set(key, { name, category: o.category || "Other", date: o.date || TODAY_ISO });
      }
    });
    if (allVendors.size === 0) return;
    setVendors(prev => {
      const existingKeys = new Set(prev.map(v => v.name.toLowerCase()));
      const toAdd = [];
      allVendors.forEach((src, key) => {
        if (!existingKeys.has(key)) {
          toAdd.push({ id: Date.now() + toAdd.length + 9000, name: src.name, phone: "", email: "", category: src.category, notes: "", createdAt: src.date });
        }
      });
      return toAdd.length > 0 ? [...prev, ...toAdd] : prev;
    });
  }, [overheads]);

  const handleLogout = () => {
    clearSession();
    setAuthed(false);
  };

  const handleImport = (data) => {
    // Catalog, Meals, Proposals are NEVER overridden — import only adds/replaces transactional data
    // Invoices are not imported — restaurant sales generate their own invoices/receipts on the sale card
    if (data.inventory.length)  setInventory(data.inventory);
    if (data.events.length)     setEvents(data.events);
    if (data.sales.length)      setSales(data.sales);
    if (data.overheads.length)  setOverheads(data.overheads);
  };

  if (!authed) {
    return <LoginScreen onLogin={(r) => {
      setRole(r);
      // Redirect staff to their first allowed tab
      if (r === "staff") setTab("restaurant");
      setAuthed(true);
    }} />;
  }

  // Show loading screen while pulling latest data from Supabase
  if (!cloudLoaded) {
    return (
      <div style={{ background: "#0f0f0f", minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 18 }}>
        <img src={LOGO_SRC} alt="Cookie's Bites" style={{ width: 90, height: 90, objectFit: "contain", borderRadius: "50%", border: "2px solid #2a2a2a" }} />
        <div style={{ color: "#E8C547", fontSize: 13, fontWeight: 600, letterSpacing: 1 }}>Loading your data…</div>
        <div style={{ width: 180, height: 3, background: "#1e1e1e", borderRadius: 4, overflow: "hidden" }}>
          <div style={{ height: "100%", background: "linear-gradient(90deg,#E8C547,#b8952a)", borderRadius: 4, animation: "loadbar 1.2s ease-in-out infinite" }} />
        </div>
        <style>{`@keyframes loadbar{0%{width:0%}60%{width:85%}100%{width:100%}}`}</style>
      </div>
    );
  }

  return (
    <div style={S.app}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700;9..40,800&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        ::-webkit-scrollbar{width:4px;height:4px}
        ::-webkit-scrollbar-track{background:#141414}
        ::-webkit-scrollbar-thumb{background:#2a2a2a;border-radius:3px}
        input:focus,select:focus,textarea:focus{border-color:#E8C547!important;box-shadow:0 0 0 2px rgba(232,197,71,0.07)!important;outline:none}
        button:hover{opacity:0.80}
        tr:hover td{background:rgba(255,255,255,0.015)}
        textarea{background:#141414;border:1px solid #252525;border-radius:6px;padding:6px 9px;color:#EDEBE4;font-size:12px;width:100%;box-sizing:border-box;font-family:inherit}
        input[type=number]::-webkit-inner-spin-button{opacity:0.5}
        /* ── MOBILE RESPONSIVE ── */
        @media(max-width:767px){
          /* Prevent iOS zoom on inputs */
          input,select,textarea{font-size:16px!important}
          /* All fixed-column grids collapse on mobile */
          [style*="repeat(3"],[style*="repeat(4"],[style*="repeat(5"]{
            grid-template-columns:1fr!important;
          }
          /* 2-col grids stay 2-col unless very narrow */
          [style*="repeat(2"]{
            grid-template-columns:1fr 1fr!important;
          }
          /* Tables scroll horizontally */
          table{min-width:480px}
          /* Cards get less padding */
          [style*="padding: 14"]{padding:10px!important}
          /* Sticky sidebar panels go full-width */
          [style*="360px"]{grid-template-columns:1fr!important}
          [style*="position: sticky"]{position:static!important;max-height:none!important}
          /* Ensure buttons are tappable */
          button{min-height:34px}
        }
        /* Wrap all table containers */
        .tbl-wrap{overflow-x:auto;-webkit-overflow-scrolling:touch}
      `}</style>

      {showSettings && isOwner && (
        <SettingsModal
          biz={biz}
          setBiz={setBiz}
          logo={logo}
          socialLinks={socialLinks}
          setSocialLinks={setSocialLinks}
          onClose={() => setShowSettings(false)}
          setEvents={setEvents}
          setSales={setSales}
          setInvoices={setInvoices}
          setProposals={setProposals}
          setBatches={setBatches}
          setOverheads={setOverheads}
          setCustomers={setCustomers}
          cloudSet={cloudSet}
        />
      )}
      {showImport && isOwner && (
        <ImportModal
          onClose={() => setShowImport(false)}
          onImport={handleImport}
        />
      )}

      {/* ── TOPBAR ── */}
      {isMobile ? (
        <div
          style={{
            background: T.surface,
            borderBottom: `1px solid ${T.border}`,
            padding: "0 12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: 48,
            flexShrink: 0,
          }}
        >
          <div
            style={{
              fontSize: 15,
              fontWeight: 800,
              color: T.accent,
              letterSpacing: -0.3,
            }}
          >
            <img
              src={logo?.src || LOGO_SRC}
              alt="Cookie's Bites"
              style={{ height: 36, maxWidth: 120, objectFit: "contain" }}
            />
          </div>
          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
            <span style={{
              fontSize: 9, fontWeight: 700, letterSpacing: 0.5,
              color: isOwner ? T.accent : T.info,
              background: isOwner ? T.accentSoft : `${T.info}18`,
              border: `1px solid ${isOwner ? T.accent : T.info}40`,
              borderRadius: 20, padding: "1px 7px",
            }}>{isOwner ? "OWNER" : "STAFF"}</span>
            {isOwner && (
              <button
                style={{ ...S.btn("ghost"), fontSize: 10, padding: "3px 7px", color: T.accent, border: `1px solid ${T.accent}50` }}
                onClick={() => setShowImport(true)}
              >
                ⬆
              </button>
            )}
            {isOwner && (
              <button
                style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 8px" }}
                onClick={() => setShowSettings(true)}
              >
                ⚙️
              </button>
            )}
            <button
              title="Sign out"
              style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 8px", color: T.textMuted }}
              onClick={handleLogout}
            >
              ⏻
            </button>
          </div>
        </div>
      ) : (
        <div style={S.topbar}>
          <LogoArea
            logo={logo}
            setLogo={setLogo}
            biz={biz}
            onSettings={isOwner ? () => setShowSettings(true) : null}
          />
          <div
            style={{
              width: 1,
              height: 18,
              background: T.border,
              flexShrink: 0,
            }}
          />
          <div style={S.nav}>
            {visibleTabs.map((t) => (
              <button
                key={t.id}
                style={S.navBtn(tab === t.id)}
                onClick={() => setTab(t.id)}
              >
                {t.label}
              </button>
            ))}
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
            <span style={{
              fontSize: 9, fontWeight: 700, letterSpacing: 0.5,
              color: isOwner ? T.accent : T.info,
              background: isOwner ? T.accentSoft : `${T.info}18`,
              border: `1px solid ${isOwner ? T.accent : T.info}40`,
              borderRadius: 20, padding: "2px 8px", whiteSpace: "nowrap",
            }}>{isOwner ? "👑 Owner" : "👤 Staff"}</span>
            <div style={{ fontSize: 10, color: T.textMuted, whiteSpace: "nowrap" }}>
              📍{biz.city} · {TODAY_LABEL}
            </div>
            {isOwner && (
              <button
                title="Import data from Excel"
                style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 10px", color: T.accent, border: `1px solid ${T.accent}50` }}
                onClick={() => setShowImport(true)}
              >
                ⬆ Import
              </button>
            )}
            {/* Cloud sync indicator */}
            {isSupabaseConfigured() && syncStatus !== "idle" && (
              <span style={{
                fontSize: 9, fontWeight: 700, letterSpacing: 0.3,
                color: syncStatus === "saving" ? T.textMuted : syncStatus === "saved" ? T.success : T.danger,
                display: "flex", alignItems: "center", gap: 3, whiteSpace: "nowrap",
              }}>
                {syncStatus === "saving" && "☁ saving…"}
                {syncStatus === "saved"  && "✓ saved"}
                {syncStatus === "offline" && "⚠ offline"}
              </span>
            )}
            {!isSupabaseConfigured() && (
              <span title="Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to enable cloud sync" style={{ fontSize: 9, color: T.danger, fontWeight: 700, cursor: "help" }}>⚠ local only</span>
            )}
            <button
              title="Sign out"
              style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 10px" }}
              onClick={handleLogout}
            >
              ⏻ Sign Out
            </button>
          </div>
        </div>
      )}

      {/* ── MAIN CONTENT ── */}
      <div style={isMobile ? S.mainMobile : S.main}>
        {tab === "dashboard" && (
          <Dashboard
            events={events}
            sales={sales}
            invoices={invoices}
            catalogItems={catalogItems}
            overheads={overheads}
            inventory={inventory}
            meals={meals}
            invPurchases={invPurchases}
            prepaidItems={prepaidItems}
          />
        )}
        {tab === "catering" && (
          <CateringPage
            events={events}
            setEvents={setEvents}
            proposals={proposals}
            setProposals={setProposals}
            inventory={inventory}
            logo={logo}
            biz={biz}
            customers={customers}
            setCustomers={setCustomers}
            invoices={invoices}
            setInvoices={setInvoices}
            catalogItems={catalogItems}
            setCatalogItems={setCatalogItems}
            catalogCategories={catalogCategories}
            setCatalogCategories={setCatalogCategories}
            catalogMeta={catalogMeta}
            setCatalogMeta={setCatalogMeta}
            meals={meals}
            setMeals={setMeals}
            proposalPrefillLines={proposalPrefillLines}
            clearProposalPrefill={() => setProposalPrefillLines(null)}
          />
        )}
        {tab === "restaurant" && (
          <RestaurantPage
            sales={sales}
            setSales={setSales}
            inventory={inventory}
            setInventory={setInventory}
            catalogItems={catalogItems}
            setCatalogItems={setCatalogItems}
            catalogCategories={catalogCategories}
            setCatalogCategories={setCatalogCategories}
            meals={meals}
            setMeals={setMeals}
            batches={batches}
            setBatches={setBatches}
            logo={logo}
            biz={biz}
            customers={customers}
            setCustomers={setCustomers}
            invPurchases={invPurchases}
            setInvPurchases={setInvPurchases}
          />
        )}
        {tab === "customers" && (
          <CustomersPage
            customers={customers}
            setCustomers={setCustomers}
            invoices={invoices}
            setInvoices={setInvoices}
            events={events}
            sales={sales}
            logo={logo}
            biz={biz}
          />
        )}
        {tab === "vendors" && (
          <VendorsPage overheads={overheads} setOverheads={setOverheads} vendors={vendors} setVendors={setVendors} />
        )}
        {tab === "reports" && (
          <ReportsPage
            events={events}
            sales={sales}
            invoices={invoices}
            overheads={overheads}
            catalogItems={catalogItems}
            biz={biz}
            inventory={inventory}
            meals={meals}
            customers={customers}
            batches={batches}
            invPurchases={invPurchases}
            prepaidItems={prepaidItems}
            setPrepaidItems={setPrepaidItems}
            deposits={deposits}
            setDeposits={setDeposits}
          />
        )}
        {tab === "studio" && isOwner && (
          <AIStudioPage
            biz={biz}
            events={events}
            meals={meals}
            catalogItems={catalogItems}
            logo={logo}
            socialLinks={socialLinks}
            setSocialLinks={setSocialLinks}
          />
        )}
      </div>

      {/* ── MOBILE BOTTOM NAV ── */}
      {isMobile && <MobileNav tab={tab} setTab={setTab} tabs={visibleTabs} />}
    </div>
  );
}

// ─── AI STUDIO ────────────────────────────────────────────────────
// Content creation hub powered by Claude API
// Uses live app data (events, meals, catalog) as context

const STUDIO_TOOLS = [
  {
    id: "caption",
    icon: "✍️",
    label: "Social Caption",
    desc: "Write captions for Instagram, Facebook or WhatsApp",
    platforms: ["Instagram", "Facebook", "WhatsApp Status", "TikTok"],
    color: "#E4405F",
    prompt: (ctx, opts) =>
      `You are a social media copywriter for ${ctx.biz}, a catering and restaurant business in Douala, Cameroon.
Write a ${opts.platform} caption that is engaging, authentic and uses a warm West/Central African tone.
Tone: ${opts.tone}. Language: ${opts.lang === "fr" ? "French" : "English"}.
${opts.topic ? `Topic / context: ${opts.topic}` : ""}
${opts.mediaDesc ? `The post includes this image/video: ${opts.mediaDesc}` : ""}
${ctx.menuSnippet ? `Current menu highlights: ${ctx.menuSnippet}` : ""}
${ctx.upcomingEvent ? `Upcoming event context: ${ctx.upcomingEvent}` : ""}
Include relevant hashtags at the end. Keep it natural, not corporate.
Do NOT use emojis excessively — 2–4 max. Output only the caption text, ready to copy-paste.`,
  },
  {
    id: "menu",
    icon: "🍽️",
    label: "Menu Description",
    desc: "Write mouthwatering descriptions for menu items",
    color: "#FF6B35",
    prompt: (ctx, opts) =>
      `You are a food copywriter for ${ctx.biz}, a catering and restaurant in Douala, Cameroon.
Write a short, appetizing description (2–3 sentences) for: ${opts.topic || "our signature dish"}.
Tone: ${opts.tone}. Language: ${opts.lang === "fr" ? "French" : "English"}.
${opts.mediaDesc ? `The dish looks like this: ${opts.mediaDesc}` : ""}
${ctx.menuSnippet ? `Other menu items for context: ${ctx.menuSnippet}` : ""}
Focus on taste, texture, and local ingredients. Make it feel premium and inviting.
Output only the description, no titles or labels.`,
  },
  {
    id: "promo",
    icon: "📣",
    label: "Promotional Flyer Text",
    desc: "Generate text for digital flyers and event promotions",
    color: "#F4C430",
    prompt: (ctx, opts) =>
      `You are a marketing copywriter for ${ctx.biz}, catering & restaurant, Douala, Cameroon.
Write promotional flyer text for: ${opts.topic || "a special offer or event"}.
Tone: ${opts.tone}. Language: ${opts.lang === "fr" ? "French" : "English"}.
${ctx.upcomingEvent ? `Event details: ${ctx.upcomingEvent}` : ""}
${opts.mediaDesc ? `Visual context: ${opts.mediaDesc}` : ""}
Structure: catchy headline → 2 short body lines → clear call-to-action → contact/booking info placeholder.
Keep it punchy and direct. Output only the flyer text, formatted with line breaks.`,
  },
  {
    id: "email",
    icon: "📧",
    label: "Client Email / Message",
    desc: "Draft professional emails for catering proposals and follow-ups",
    color: "#4A90D9",
    prompt: (ctx, opts) =>
      `You are writing on behalf of ${ctx.biz}, a catering and restaurant business in Douala, Cameroon.
Draft a professional ${opts.emailType || "follow-up"} email to a catering client.
Tone: ${opts.tone}. Language: ${opts.lang === "fr" ? "French" : "English"}.
Context: ${opts.topic || "following up after a proposal or event inquiry"}.
${ctx.upcomingEvent ? `Event reference: ${ctx.upcomingEvent}` : ""}
Keep it warm but professional. Include a clear subject line first, then the email body.
Use [CLIENT NAME] as placeholder. Sign off as the ${ctx.biz} team.`,
  },
  {
    id: "review",
    icon: "⭐",
    label: "Review Response",
    desc: "Craft thoughtful responses to customer reviews",
    color: "#3DB86A",
    prompt: (ctx, opts) =>
      `You manage customer relations for ${ctx.biz}, catering & restaurant, Douala, Cameroon.
Write a ${opts.sentiment === "negative" ? "gracious, empathetic response to a negative" : "warm response to a positive"} customer review.
Language: ${opts.lang === "fr" ? "French" : "English"}.
Review content: "${opts.topic || "sample customer feedback"}"
Be human, specific, and professional. Under 5 sentences. Do not be defensive.
Output only the response text.`,
  },
  {
    id: "story",
    icon: "📖",
    label: "Brand Story / About",
    desc: "Write compelling brand copy for your website or profile",
    color: "#9B59B6",
    prompt: (ctx, opts) =>
      `Write brand story / about section copy for ${ctx.biz}, a catering and restaurant business based in ${ctx.city}.
Tone: ${opts.tone}. Language: ${opts.lang === "fr" ? "French" : "English"}.
${opts.topic ? `Key points to include: ${opts.topic}` : ""}
${ctx.menuSnippet ? `Menu highlights to weave in: ${ctx.menuSnippet}` : ""}
Emphasise authenticity, quality, and local roots. 3–4 short paragraphs.
Output only the brand copy, no commentary.`,
  },
  {
    id: "analyze",
    icon: "📊",
    label: "Analyze Uploaded Image",
    desc: "Get AI insights and content suggestions from a photo",
    color: "#E8C547",
    mediaRequired: true,
    prompt: (ctx, opts) =>
      `You are a food and hospitality marketing expert reviewing content for ${ctx.biz}, Douala, Cameroon.
Analyze this image and provide:
1. A brief description of what you see
2. What's working well visually (lighting, composition, appeal)
3. 3 specific content ideas this image could be used for (social post, flyer, menu item)
4. A ready-to-use Instagram caption for this image
Language: ${opts.lang === "fr" ? "French" : "English"}.`,
  },
  {
    id: "review_request",
    icon: "🌟",
    label: "Request a Review",
    desc: "Generate polite, personalised messages asking customers to leave a Google or social media review",
    color: "#FBBC04",
    prompt: (ctx, opts) =>
      `You are writing on behalf of ${ctx.biz}, a catering and restaurant business in Douala, Cameroon.
Write a warm, genuine, and polite message asking a satisfied customer to leave a review.
Channel: ${opts.reviewChannel}. Language: ${opts.lang === "fr" ? "French" : "English"}.
Tone: ${opts.tone}.
${opts.customerName ? `Address the customer by name: ${opts.customerName}` : "Use a friendly generic greeting."}
${opts.occasion ? `The occasion / service they experienced: ${opts.occasion}` : ""}
${ctx.menuSnippet ? `Menu context: ${ctx.menuSnippet}` : ""}
${opts.reviewChannel === "Google" && opts.googleReviewLink ? `Include this Google review link prominently: ${opts.googleReviewLink}` : ""}
${opts.reviewChannel === "Facebook" && opts.facebookLink ? `Include this Facebook page link: ${opts.facebookLink}` : ""}
${opts.reviewChannel === "WhatsApp" ? "This is a WhatsApp message — keep it conversational, warm and short (max 4 sentences before the link)." : ""}
${opts.reviewChannel === "General / Multi-platform" ? `Include all available review links. Google: ${opts.googleReviewLink || "[Google Review Link]"}. Facebook: ${opts.facebookLink || "[Facebook Link]"}.` : ""}
Guidelines:
- Do NOT be pushy or transactional — make it feel like a heartfelt personal request
- Mention how much reviews help a small local business
- Make leaving the review sound effortless (one click)
- End with genuine thanks and an invitation to return
- If WhatsApp: do NOT include a formal subject line, make it feel like a personal text
- If Email/General: include a warm subject line at the top
Output only the ready-to-send message. No commentary.`,
  },
];

const TONES = ["Professional", "Casual & Friendly", "Exciting & Bold", "Warm & Personal", "Luxurious"];
const EMAIL_TYPES = ["Follow-up", "Proposal introduction", "Thank you after event", "Booking confirmation", "Payment reminder"];

function AIStudioPage({ biz, events, meals, catalogItems, logo, socialLinks, setSocialLinks }) {
  const isMobile = useIsMobile();

  // Context derived from app data
  const menuSnippet = meals.slice(0, 5).map(m => `${m.name} (${fmt(m.price)})`).join(", ");
  const catSnippet = catalogItems.slice(0, 6).map(c => c.name).join(", ");
  const nextEvent = events
    .filter(e => e.eventDate >= TODAY_ISO && e.phase !== "Cancelled")
    .sort((a, b) => a.eventDate.localeCompare(b.eventDate))[0];
  const upcomingEvent = nextEvent
    ? `${nextEvent.name} — ${nextEvent.eventType} for ${nextEvent.guests} guests on ${nextEvent.eventDate} at ${nextEvent.location || "TBD"}`
    : "";

  const appCtx = {
    biz: biz.name,
    city: biz.city,
    menuSnippet: menuSnippet || catSnippet,
    upcomingEvent,
  };

  // UI state
  const [tool, setTool] = useState(null);
  const [opts, setOpts] = useState({
    platform: "Instagram", tone: "Warm & Personal", lang: "en",
    topic: "", emailType: "Follow-up", sentiment: "positive", mediaDesc: "",
    reviewChannel: "WhatsApp", customerName: "", occasion: "",
    googleReviewLink: "", facebookLink: "",
  });
  const [uploadedImage, setUploadedImage] = useState(null); // { src, base64, mime }
  const [output, setOutput] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);
  const [history, setHistory] = useState([]); // [{tool, output, ts}]
  const [showHistory, setShowHistory] = useState(false);
  const [showSocial, setShowSocial] = useState(false);
  const [apiKey, setApiKey] = useState(() => localStorage.getItem("cb_api_key") || "");
  const [showApiKey, setShowApiKey] = useState(false);
  const imgRef = useRef();

  const activeTool = STUDIO_TOOLS.find(t => t.id === tool);

  const handleImageUpload = (file) => {
    if (!file || !file.type.startsWith("image/")) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64 = e.target.result.split(",")[1];
      setUploadedImage({ src: e.target.result, base64, mime: file.type });
      setOpts(o => ({ ...o, mediaDesc: "" }));
    };
    reader.readAsDataURL(file);
  };

  const generate = async () => {
    if (!activeTool) return;
    if (!apiKey.trim()) {
      setError("Please enter your Anthropic API key above to use AI Studio.");
      return;
    }
    setLoading(true); setError(""); setOutput("");

    // Merge saved platform links so prompts always have them even if not typed per-session
    const mergedOpts = {
      ...opts,
      googleReviewLink: opts.googleReviewLink || socialLinks.google,
      facebookLink: opts.facebookLink || socialLinks.facebook,
    };
    const systemPrompt = activeTool.prompt(appCtx, mergedOpts);

    try {
      const messages = [];

      if (uploadedImage && activeTool.id === "analyze") {
        messages.push({
          role: "user",
          content: [
            { type: "image", source: { type: "base64", media_type: uploadedImage.mime, data: uploadedImage.base64 } },
            { type: "text", text: systemPrompt },
          ],
        });
      } else {
        messages.push({ role: "user", content: systemPrompt });
      }

      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey.trim(),
          "anthropic-version": "2023-06-01",
          "anthropic-dangerous-direct-browser-access": "true",
        },
        body: JSON.stringify({
          model: "claude-sonnet-4-20250514",
          max_tokens: 1000,
          messages,
        }),
      });

      const data = await res.json();
      if (data.error) throw new Error(data.error.message);
      const text = (data.content || []).filter(b => b.type === "text").map(b => b.text).join("\n");
      setOutput(text);
      setHistory(h => [{ tool: activeTool.label, output: text, ts: new Date().toLocaleTimeString() }, ...h.slice(0, 9)]);
    } catch (e) {
      setError(e.message || "Failed to fetch. Check your API key and internet connection.");
    } finally {
      setLoading(false);
    }
  };

  const copy = () => {
    navigator.clipboard.writeText(output).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    });
  };

  // ── Social links panel ────────────────────────────────────────────
  const SocialPanel = () => (
    <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, padding: 14, marginBottom: 14 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <div style={{ fontWeight: 700, fontSize: 13 }}>🔗 Platform Links</div>
        <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "3px 8px" }} onClick={() => setShowSocial(false)}>✕</button>
      </div>
      <div style={{ fontSize: 11, color: T.textMuted, marginBottom: 14, lineHeight: 1.6 }}>
        Add your links once — they'll be used across all tools for quick-open buttons and auto-inserted into review request messages.
      </div>

      {/* Review links section */}
      <div style={{ fontSize: 10, fontWeight: 700, color: T.accent, letterSpacing: 0.6, textTransform: "uppercase", marginBottom: 8 }}>⭐ Review Links</div>
      {[
        { key: "google", icon: "🔍", label: "Google Business Review Link", ph: "https://g.page/r/YOUR_PLACE_ID/review", help: "Find it in Google Business Profile → Get more reviews" },
        { key: "facebook", icon: "👤", label: "Facebook Page URL", ph: "https://facebook.com/cookiesbites" },
      ].map(s => (
        <div key={s.key} style={{ marginBottom: 10 }}>
          <label style={S.label}>{s.icon} {s.label}</label>
          <input style={S.input} value={socialLinks[s.key]} onChange={e => setSocialLinks(l => ({ ...l, [s.key]: e.target.value }))} placeholder={s.ph} />
          {s.help && <div style={{ fontSize: 10, color: T.textDim, marginTop: 3 }}>ℹ️ {s.help}</div>}
        </div>
      ))}

      {/* Social links section */}
      <div style={{ fontSize: 10, fontWeight: 700, color: T.textMuted, letterSpacing: 0.6, textTransform: "uppercase", margin: "14px 0 8px" }}>📱 Social Media</div>
      {[
        { key: "instagram", icon: "📷", label: "Instagram URL", ph: "https://instagram.com/cookiesbites" },
        { key: "tiktok", icon: "🎵", label: "TikTok URL", ph: "https://tiktok.com/@cookiesbites" },
        { key: "whatsapp", icon: "💬", label: "WhatsApp Business Number", ph: "+237 6XX XXX XXX", help: "Numbers only used for WhatsApp links" },
      ].map(s => (
        <div key={s.key} style={{ marginBottom: 10 }}>
          <label style={S.label}>{s.icon} {s.label}</label>
          <input style={S.input} value={socialLinks[s.key]} onChange={e => setSocialLinks(l => ({ ...l, [s.key]: e.target.value }))} placeholder={s.ph} />
          {s.help && <div style={{ fontSize: 10, color: T.textDim, marginTop: 3 }}>ℹ️ {s.help}</div>}
        </div>
      ))}
      <div style={{ fontSize: 10, color: T.textDim, marginTop: 10, padding: "8px 10px", background: T.card, borderRadius: 6 }}>
        🔒 Saved in your browser only. Never sent to any server.
      </div>
    </div>
  );

  // ── Tool card grid ────────────────────────────────────────────────
  if (!tool) {
    return (
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
          <div>
            <div style={S.pageTitle}>🤖 AI Studio</div>
            <div style={S.subtitle}>Generate content powered by Claude — captions, menus, emails, promotions and more</div>
          </div>
          <button
            style={{ ...S.btn("ghost"), fontSize: 11, padding: "5px 11px", flexShrink: 0 }}
            onClick={() => setShowSocial(s => !s)}
          >
            🔗 Social Links
          </button>
        </div>

        {showSocial && <SocialPanel />}

        {/* API Key input */}
        <div style={{ background: T.surface, border: `1px solid ${apiKey ? T.success + "60" : T.accent + "60"}`, borderRadius: 8, padding: "10px 13px", marginBottom: 14 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: apiKey ? T.success : T.accent }}>
              {apiKey ? "🔑 API Key Connected" : "🔑 Anthropic API Key Required"}
            </div>
            <button style={{ fontSize: 10, color: T.textMuted, background: "none", border: "none", cursor: "pointer" }}
              onClick={() => setShowApiKey(k => !k)}>
              {showApiKey ? "Hide" : "Show"}
            </button>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <input
              type={showApiKey ? "text" : "password"}
              value={apiKey}
              onChange={e => { setApiKey(e.target.value); localStorage.setItem("cb_api_key", e.target.value); }}
              placeholder="sk-ant-..."
              style={{ ...S.input, flex: 1, fontFamily: "monospace", fontSize: 11, marginBottom: 0 }}
            />
            {apiKey && (
              <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 10px", color: T.danger, borderColor: T.danger + "50" }}
                onClick={() => { setApiKey(""); localStorage.removeItem("cb_api_key"); }}>
                Clear
              </button>
            )}
          </div>
          <div style={{ fontSize: 10, color: T.textDim, marginTop: 5 }}>
            🔒 Saved securely in your browser — stays across sessions. Get your key at <span style={{ color: T.accent }}>console.anthropic.com</span>
          </div>
        </div>

        {/* Context banner */}
        {(menuSnippet || upcomingEvent) && (
          <div style={{ background: T.accentSoft, border: `1px solid ${T.accent}30`, borderRadius: 8, padding: "9px 13px", marginBottom: 16, fontSize: 11, color: T.textMuted, lineHeight: 1.7 }}>
            <span style={{ fontWeight: 700, color: T.accent }}>✓ App data loaded — </span>
            {menuSnippet && <span>menu items, </span>}
            {upcomingEvent && <span>upcoming event ({nextEvent?.name}), </span>}
            <span>business profile ready as AI context.</span>
          </div>
        )}

        {/* Tool grid */}
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: 12 }}>
          {STUDIO_TOOLS.map(t => (
            <button
              key={t.id}
              onClick={() => { setTool(t.id); setOutput(""); setError(""); }}
              style={{
                background: T.card, border: `1px solid ${T.border}`,
                borderRadius: 12, padding: "16px 16px 14px",
                textAlign: "left", cursor: "pointer",
                transition: "all 0.15s",
                display: "flex", flexDirection: "column", gap: 6,
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = t.color; e.currentTarget.style.background = `${t.color}10`; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.background = T.card; }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 22 }}>{t.icon}</span>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, color: T.text }}>{t.label}</div>
                  {t.mediaRequired && <span style={{ fontSize: 9, color: t.color, fontWeight: 700, letterSpacing: 0.5 }}>MEDIA REQUIRED</span>}
                </div>
              </div>
              <div style={{ fontSize: 11, color: T.textMuted, lineHeight: 1.5 }}>{t.desc}</div>
              <div style={{ marginTop: 4, fontSize: 10, color: t.color, fontWeight: 700 }}>
                {history.filter(h => h.tool === t.label).length > 0 && `${history.filter(h => h.tool === t.label).length} generated this session`}
              </div>
            </button>
          ))}
        </div>

        {/* History */}
        {history.length > 0 && (
          <div style={{ marginTop: 20 }}>
            <button
              style={{ ...S.btn("ghost"), fontSize: 11, marginBottom: 10 }}
              onClick={() => setShowHistory(h => !h)}
            >
              {showHistory ? "▲" : "▼"} Session History ({history.length})
            </button>
            {showHistory && history.map((h, i) => (
              <div key={i} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 13px", marginBottom: 8 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                  <span style={{ fontSize: 11, fontWeight: 700 }}>{h.tool}</span>
                  <span style={{ fontSize: 10, color: T.textMuted }}>{h.ts}</span>
                </div>
                <div style={{ fontSize: 11, color: T.textMuted, whiteSpace: "pre-wrap", lineHeight: 1.6, maxHeight: 80, overflow: "hidden" }}>{h.output}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ── Active tool workspace ─────────────────────────────────────────
  return (
    <div>
      {/* Back + header */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
        <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "4px 10px" }} onClick={() => { setTool(null); setOutput(""); setUploadedImage(null); }}>
          ← Back
        </button>
        <div>
          <div style={{ fontWeight: 800, fontSize: 15 }}>{activeTool.icon} {activeTool.label}</div>
          <div style={{ fontSize: 11, color: T.textMuted }}>{activeTool.desc}</div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 14 }}>
        {/* LEFT: Options */}
        <div>
          {/* API Key warning if missing */}
          {!apiKey && (
            <div style={{ background: `${T.warning}15`, border: `1px solid ${T.warning}50`, borderRadius: 8, padding: "9px 12px", marginBottom: 12, fontSize: 11, color: T.warning }}>
              ⚠️ No API key set. <button style={{ background: "none", border: "none", color: T.accent, cursor: "pointer", fontSize: 11, padding: 0, fontWeight: 700 }}
                onClick={() => { setTool(null); }}>← Go back</button> to enter your Anthropic API key before generating.
            </div>
          )}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, padding: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: T.textMuted, letterSpacing: 0.5, marginBottom: 12, textTransform: "uppercase" }}>Options</div>

            {/* Language */}
            <div style={{ marginBottom: 10 }}>
              <label style={S.label}>Language</label>
              <div style={{ display: "flex", gap: 6 }}>
                {["en", "fr"].map(l => (
                  <button key={l} style={{
                    ...S.btn(opts.lang === l ? "primary" : "ghost"),
                    flex: 1, fontSize: 12,
                  }} onClick={() => setOpts(o => ({ ...o, lang: l }))}>
                    {l === "en" ? "🇬🇧 English" : "🇫🇷 Français"}
                  </button>
                ))}
              </div>
            </div>

            {/* Tone (not for analyze) */}
            {activeTool.id !== "analyze" && (
              <div style={{ marginBottom: 10 }}>
                <label style={S.label}>Tone</label>
                <select style={S.select} value={opts.tone} onChange={e => setOpts(o => ({ ...o, tone: e.target.value }))}>
                  {TONES.map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
            )}

            {/* Platform (caption only) */}
            {activeTool.id === "caption" && (
              <div style={{ marginBottom: 10 }}>
                <label style={S.label}>Platform</label>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                  {activeTool.platforms.map(p => (
                    <button key={p} style={{
                      ...S.btn(opts.platform === p ? "primary" : "ghost"),
                      fontSize: 11, padding: "4px 9px",
                    }} onClick={() => setOpts(o => ({ ...o, platform: p }))}>
                      {p}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Email type */}
            {activeTool.id === "email" && (
              <div style={{ marginBottom: 10 }}>
                <label style={S.label}>Email type</label>
                <select style={S.select} value={opts.emailType} onChange={e => setOpts(o => ({ ...o, emailType: e.target.value }))}>
                  {EMAIL_TYPES.map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
            )}

            {/* Sentiment (review) */}
            {activeTool.id === "review" && (
              <div style={{ marginBottom: 10 }}>
                <label style={S.label}>Review sentiment</label>
                <div style={{ display: "flex", gap: 6 }}>
                  {["positive", "negative"].map(s => (
                    <button key={s} style={{
                      ...S.btn(opts.sentiment === s ? (s === "negative" ? "danger" : "success") : "ghost"),
                      flex: 1, fontSize: 12,
                    }} onClick={() => setOpts(o => ({ ...o, sentiment: s }))}>
                      {s === "positive" ? "⭐ Positive" : "⚠️ Negative"}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Review Request — dedicated options */}
            {activeTool.id === "review_request" && (
              <>
                {/* Channel selector */}
                <div style={{ marginBottom: 10 }}>
                  <label style={S.label}>Send via / Platform</label>
                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                    {[
                      { id: "WhatsApp", icon: "💬", color: "#25D366" },
                      { id: "Google", icon: "🔍", color: "#FBBC04" },
                      { id: "Facebook", icon: "👤", color: "#1877F2" },
                      { id: "SMS / Text", icon: "📱", color: "#4A90D9" },
                      { id: "General / Multi-platform", icon: "🌐", color: T.accent },
                    ].map(ch => (
                      <button key={ch.id} style={{
                        ...S.btn(opts.reviewChannel === ch.id ? "ghost" : "ghost"),
                        fontSize: 11, padding: "4px 9px",
                        border: `1px solid ${opts.reviewChannel === ch.id ? ch.color : T.border}`,
                        color: opts.reviewChannel === ch.id ? ch.color : T.textMuted,
                        background: opts.reviewChannel === ch.id ? `${ch.color}15` : "transparent",
                        fontWeight: opts.reviewChannel === ch.id ? 700 : 400,
                      }} onClick={() => setOpts(o => ({ ...o, reviewChannel: ch.id }))}>
                        {ch.icon} {ch.id}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Customer name */}
                <div style={{ marginBottom: 10 }}>
                  <label style={S.label}>Customer name <span style={{ color: T.textDim }}>(optional — personalises the message)</span></label>
                  <input style={S.input} value={opts.customerName}
                    onChange={e => setOpts(o => ({ ...o, customerName: e.target.value }))}
                    placeholder="e.g. Marie, Mr. Ngando…" />
                </div>

                {/* Occasion */}
                <div style={{ marginBottom: 10 }}>
                  <label style={S.label}>What did they experience? <span style={{ color: T.textDim }}>(optional)</span></label>
                  <input style={S.input} value={opts.occasion}
                    onChange={e => setOpts(o => ({ ...o, occasion: e.target.value }))}
                    placeholder="e.g. Wedding catering for 120 guests, Delivery order last Sunday…" />
                </div>

                {/* Google review link (contextual) */}
                {(opts.reviewChannel === "Google" || opts.reviewChannel === "General / Multi-platform") && (
                  <div style={{ marginBottom: 10 }}>
                    <label style={S.label}>🔍 Google Review Link</label>
                    <input style={{
                      ...S.input,
                      border: `1px solid ${socialLinks.google ? T.accent : "#FBBC0460"}`,
                    }}
                      value={opts.googleReviewLink || socialLinks.google}
                      onChange={e => setOpts(o => ({ ...o, googleReviewLink: e.target.value }))}
                      placeholder="https://g.page/r/YOUR_PLACE_ID/review" />
                    {!socialLinks.google && !opts.googleReviewLink && (
                      <div style={{ fontSize: 10, color: "#FBBC04", marginTop: 3 }}>
                        ⚠️ No Google link saved yet — add it in 🔗 Platform Links or paste it above
                      </div>
                    )}
                    {(socialLinks.google && !opts.googleReviewLink) && (
                      <div style={{ fontSize: 10, color: T.success, marginTop: 3 }}>
                        ✓ Using saved Google link
                      </div>
                    )}
                  </div>
                )}

                {/* Facebook link (contextual) */}
                {(opts.reviewChannel === "Facebook" || opts.reviewChannel === "General / Multi-platform") && (
                  <div style={{ marginBottom: 10 }}>
                    <label style={S.label}>👤 Facebook Page Link</label>
                    <input style={{
                      ...S.input,
                      border: `1px solid ${socialLinks.facebook ? T.accent : "#1877F260"}`,
                    }}
                      value={opts.facebookLink || socialLinks.facebook}
                      onChange={e => setOpts(o => ({ ...o, facebookLink: e.target.value }))}
                      placeholder="https://facebook.com/cookiesbites" />
                  </div>
                )}

                {/* WhatsApp tip */}
                {opts.reviewChannel === "WhatsApp" && (
                  <div style={{ background: "#25D36615", border: "1px solid #25D36640", borderRadius: 7, padding: "8px 11px", marginBottom: 10, fontSize: 11, color: T.textMuted }}>
                    💬 After generating, use the <strong style={{ color: T.text }}>Send on WhatsApp</strong> button to pre-fill the message directly into a WhatsApp chat.
                    {!socialLinks.whatsapp && <span style={{ color: "#25D366" }}> Add your WhatsApp number in 🔗 Platform Links first.</span>}
                  </div>
                )}
              </>
            )}

            {/* Topic / context */}
            {activeTool.id !== "analyze" && activeTool.id !== "review_request" && (
              <div style={{ marginBottom: 10 }}>
                <label style={S.label}>
                  {activeTool.id === "review" ? "Paste review text" : activeTool.id === "email" ? "Context / key points" : "Topic / additional context"}
                  {" "}<span style={{ color: T.textDim }}>(optional)</span>
                </label>
                <textarea
                  rows={3}
                  style={{ ...S.input, resize: "vertical", fontFamily: "inherit" }}
                  value={opts.topic}
                  onChange={e => setOpts(o => ({ ...o, topic: e.target.value }))}
                  placeholder={
                    activeTool.id === "menu" ? "Dish name, key ingredients, style…" :
                    activeTool.id === "promo" ? "Event name, date, offer details…" :
                    activeTool.id === "email" ? "Client name, event details, key asks…" :
                    activeTool.id === "review" ? "Paste the customer review here…" :
                    activeTool.id === "story" ? "Founding story, values, key differentiators…" :
                    "What is this post about?"
                  }
                />
              </div>
            )}

            {/* Image upload (hidden for review_request) + App data context */}
            <>
              {activeTool.id !== "review_request" && (
                <div style={{ marginBottom: 14 }}>
                  <label style={S.label}>
                    {activeTool.mediaRequired ? "Upload image * (required)" : "Upload image (optional — for visual context)"}
                  </label>
                  <div
                    style={{
                      border: `2px dashed ${uploadedImage ? T.accent : T.border}`,
                      borderRadius: 8, padding: uploadedImage ? 0 : "16px 12px",
                      textAlign: "center", cursor: "pointer",
                      background: uploadedImage ? "transparent" : T.surface,
                      overflow: "hidden",
                    }}
                    onClick={() => imgRef.current.click()}
                    onDragOver={e => e.preventDefault()}
                    onDrop={e => { e.preventDefault(); handleImageUpload(e.dataTransfer.files[0]); }}
                  >
                    {uploadedImage ? (
                      <div style={{ position: "relative" }}>
                        <img src={uploadedImage.src} alt="upload" style={{ width: "100%", maxHeight: 160, objectFit: "cover", display: "block" }} />
                        <button
                          style={{ position: "absolute", top: 6, right: 6, background: "rgba(0,0,0,0.7)", border: "none", color: "#fff", borderRadius: "50%", width: 22, height: 22, cursor: "pointer", fontSize: 12 }}
                          onClick={e => { e.stopPropagation(); setUploadedImage(null); }}
                        >×</button>
                      </div>
                    ) : (
                      <>
                        <div style={{ fontSize: 24, marginBottom: 4 }}>🖼️</div>
                        <div style={{ fontSize: 11, color: T.textMuted }}>Click or drag image here</div>
                        <div style={{ fontSize: 10, color: T.textDim, marginTop: 2 }}>JPG, PNG, WebP</div>
                      </>
                    )}
                    <input ref={imgRef} type="file" accept="image/*" style={{ display: "none" }}
                      onChange={e => handleImageUpload(e.target.files[0])} />
                  </div>
                  {uploadedImage && activeTool.id !== "analyze" && (
                    <div style={{ marginTop: 8 }}>
                      <label style={S.label}>Describe the image (helps AI write better)</label>
                      <input style={S.input} value={opts.mediaDesc}
                        onChange={e => setOpts(o => ({ ...o, mediaDesc: e.target.value }))}
                        placeholder="e.g. Steaming jollof rice plated elegantly on white plate" />
                    </div>
                  )}
                </div>
              )}

              <div style={{ background: T.surface, borderRadius: 8, padding: "9px 11px", marginBottom: 12, fontSize: 10, color: T.textMuted, lineHeight: 1.7 }}>
              <div style={{ fontWeight: 700, color: T.accent, marginBottom: 3 }}>📡 Live context from your app</div>
              {menuSnippet && <div>Menu: {menuSnippet.slice(0, 80)}{menuSnippet.length > 80 ? "…" : ""}</div>}
              {upcomingEvent && <div>Next event: {upcomingEvent.slice(0, 70)}…</div>}
              {!menuSnippet && !upcomingEvent && <div style={{ color: T.textDim }}>Add meals and events to enrich AI context</div>}
              </div>
            </>

            <button
              style={{
                ...S.btn("primary"), width: "100%", fontSize: 13, padding: "9px",
                opacity: (loading || (activeTool.mediaRequired && !uploadedImage)) ? 0.5 : 1,
                cursor: (loading || (activeTool.mediaRequired && !uploadedImage)) ? "not-allowed" : "pointer",
              }}
              onClick={generate}
              disabled={loading || (activeTool.mediaRequired && !uploadedImage)}
            >
              {loading ? "✨ Generating…" : `✨ Generate ${activeTool.label}`}
            </button>
          </div>
        </div>

        {/* RIGHT: Output */}
        <div>
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, padding: 14, minHeight: 300, display: "flex", flexDirection: "column" }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: T.textMuted, letterSpacing: 0.5, marginBottom: 10, textTransform: "uppercase" }}>Generated Content</div>

            {/* Loading spinner */}
            {loading && (
              <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 10 }}>
                <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
                <div style={{ width: 32, height: 32, border: `3px solid ${T.accent}`, borderTopColor: "transparent", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />
                <div style={{ fontSize: 12, color: T.textMuted }}>Writing for you…</div>
              </div>
            )}

            {/* Error */}
            {error && !loading && (
              <div style={{ background: `${T.danger}15`, border: `1px solid ${T.danger}40`, borderRadius: 8, padding: "10px 13px", fontSize: 12, color: T.danger }}>
                ⚠️ {error}
              </div>
            )}

            {/* Output */}
            {output && !loading && (
              <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 10 }}>
                <div style={{
                  flex: 1, whiteSpace: "pre-wrap", fontSize: 13, lineHeight: 1.75,
                  color: T.text, background: T.surface, borderRadius: 8, padding: "12px 13px",
                  minHeight: 200,
                }}>
                  {output}
                </div>

                {/* Action buttons */}
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <button style={{ ...S.btn("primary"), fontSize: 11, padding: "5px 12px" }} onClick={copy}>
                    {copied ? "✓ Copied!" : "📋 Copy"}
                  </button>
                  <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "5px 12px" }} onClick={generate}>
                    🔄 Regenerate
                  </button>

                  {/* Review Request — dedicated action buttons */}
                  {activeTool.id === "review_request" && (
                    <>
                      {/* WhatsApp send */}
                      {socialLinks.whatsapp && (
                        <a
                          href={`https://wa.me/${socialLinks.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(output.slice(0, 1000))}`}
                          target="_blank" rel="noopener noreferrer"
                          style={{ ...S.btn("ghost"), fontSize: 11, padding: "5px 12px", color: "#25D366", border: `1px solid #25D36650`, textDecoration: "none", display: "inline-block", fontWeight: 700 }}
                        >
                          💬 Send on WhatsApp
                        </a>
                      )}
                      {/* Copy Google link */}
                      {(opts.googleReviewLink || socialLinks.google) && (
                        <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "5px 12px", color: "#FBBC04", border: "1px solid #FBBC0450" }}
                          onClick={() => { navigator.clipboard.writeText(opts.googleReviewLink || socialLinks.google); }}>
                          🔍 Copy Google Link
                        </button>
                      )}
                      {/* Open Facebook review tab */}
                      {(opts.facebookLink || socialLinks.facebook) && (
                        <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "5px 12px", color: "#1877F2", border: "1px solid #1877F250" }}
                          onClick={() => window.open((opts.facebookLink || socialLinks.facebook) + "/reviews", "_blank")}>
                          👤 Open Facebook Reviews
                        </button>
                      )}
                    </>
                  )}

                  {/* Social quick-open buttons for all other tools */}
                  {activeTool.id !== "review_request" && (
                    <>
                      {socialLinks.instagram && (
                        <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "5px 12px", color: "#E4405F", border: `1px solid #E4405F50` }}
                          onClick={() => window.open(socialLinks.instagram, "_blank")}>
                          📷 Open Instagram
                        </button>
                      )}
                      {socialLinks.facebook && (
                        <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "5px 12px", color: "#1877F2", border: `1px solid #1877F250` }}
                          onClick={() => window.open(socialLinks.facebook, "_blank")}>
                          👤 Open Facebook
                        </button>
                      )}
                      {socialLinks.whatsapp && (
                        <a
                          href={`https://wa.me/${socialLinks.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(output.slice(0, 1000))}`}
                          target="_blank" rel="noopener noreferrer"
                          style={{ ...S.btn("ghost"), fontSize: 11, padding: "5px 12px", color: "#25D366", border: `1px solid #25D36650`, textDecoration: "none", display: "inline-block" }}
                        >
                          💬 Share on WhatsApp
                        </a>
                      )}
                      {socialLinks.tiktok && (
                        <button style={{ ...S.btn("ghost"), fontSize: 11, padding: "5px 12px" }}
                          onClick={() => window.open(socialLinks.tiktok, "_blank")}>
                          🎵 Open TikTok
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}

            {/* Empty state */}
            {!output && !loading && !error && (
              <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, color: T.textDim }}>
                <div style={{ fontSize: 36 }}>{activeTool.icon}</div>
                <div style={{ fontSize: 12 }}>Set your options and click Generate</div>
              </div>
            )}
          </div>

          {/* Clipboard hint */}
          {output && (
            <div style={{ marginTop: 8, fontSize: 10, color: T.textDim, textAlign: "center", lineHeight: 1.6 }}>
              Copy the content above, then paste into your social media app or email client.
              {Object.values(socialLinks).some(Boolean) ? " Use the quick-open buttons to jump straight there." : " Add your social links via 🔗 Social Links to get quick-open buttons."}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
